<script setup>
/* eslint-disable no-unused-vars -- Legacy POS handlers remain for historical transaction screens. */
import { ref, reactive, computed, onMounted, watch, nextTick } from 'vue'
import Chart from 'chart.js/auto';
import 'chartjs-adapter-date-fns';
import * as XLSX from 'xlsx'; // Import untuk fitur Export Excel
import MarketplaceShipmentImport from './components/MarketplaceShipmentImport.vue';
import MarketplaceIncomeImport from './components/MarketplaceIncomeImport.vue';
import MarketplaceTransactionHistory from './components/MarketplaceTransactionHistory.vue';

// Impor dari file konfigurasi Firebase Anda

import { db, auth, functions } from './firebase.js'; 
import { httpsCallable } from 'firebase/functions';
import {
    clearReadCacheContext,
    invalidateModuleCache,
    isReadCacheReady,
    readModuleCache,
    setReadCacheContext,
    writeModuleCache,
} from './app-read-cache.js';
import {
    finalizeFullReloadV4,
    syncIncrementalModuleV4,
} from './incremental-read-v4.js';
import {
    filterRowsByRangeV4,
    mergeFinanceChangesV4,
    mergeProductChangesV4,
    mergeSalesChangesV4,
    validateFinancePayloadV4,
    validateProductsPayloadV4,
    validateSalesPayloadV4,
} from './incremental-adapters-v4.js';

// Impor fungsi-fungsi untuk Database (Firestore)
import {
    collection,
    doc,
    setDoc as firestoreSetDoc,
    updateDoc as firestoreUpdateDoc,
    deleteDoc as firestoreDeleteDoc,
    writeBatch as firestoreWriteBatch,
    runTransaction as firestoreRunTransaction,
    addDoc as firestoreAddDoc,
    onSnapshot,
    query,
    where,
    getDocs,
    getDocsFromServer,
    getDoc,
    getDocFromServer,
    orderBy,
    limit,
    startAfter,
    documentId,
    increment,
} from 'firebase/firestore';
let bulkSearchDebounceTimer = null;
let bulkScanTimer = null;
let posScanTimer = null;
// Impor fungsi-fungsi BARU untuk Autentikasii
import { 
    onAuthStateChanged, 
    signOut,
    GoogleAuthProvider, // <-- Impor Google Provider
    
    signInWithPopup, // <-- Impor signInWithPopup
    
    createUserWithEmailAndPassword, 
    signInWithEmailAndPassword 
} from "firebase/auth";

// --- STATE MANAGEMENT ---
const storedActivePage = localStorage.getItem('lastActivePage') || 'dashboard';
const removedPageRoutes = ['promosi', 'audit-data', 'bulk_process_legacy', 'rekonsiliasi'];
const activePage = ref(
    storedActivePage === 'bulk_process_legacy'
        ? 'bulk_process'
        : (removedPageRoutes.includes(storedActivePage) ? 'dashboard' : storedActivePage)
);
if (removedPageRoutes.includes(storedActivePage)) {
    localStorage.setItem('lastActivePage', activePage.value);
}
const isLoading = ref(true);
const isSaving = ref(false); // Untuk tombol simpan umum
const isSavingSettings = ref(false); // Untuk tombol simpan di halaman Pengaturan
// Hapus baris 'const isSubscribing = ref(false);' yang lama
const isSubscribingMonthly = ref(false); // <-- TAMBAHKAN INI
const isSubscribingYearly = ref(false);  // <-- TAMBAHKAN INI
const currentUser = ref(null);

// ============================================================
// PRIVASI DANA GANTUNG
// ============================================================
// Nilai sensitif selalu tersensor saat aplikasi baru dibuka atau direfresh.
// Ikon mata pada kartu Dana Gantung mengatur tampil/sembunyi selama sesi aktif.
const isPendingPrivacyMode =
    ref(true);


// ============================================================
// MODE GELAP FASHION OS
// ============================================================
const DARK_MODE_STORAGE_KEY =
    'fashion_os_dark_mode_v1';

const isDarkMode =
    ref(
        localStorage.getItem(
            DARK_MODE_STORAGE_KEY
        ) === 'dark'
    );

const applyDarkModeAppearance =
    enabled => {
        const rootElement =
            document.documentElement;

        rootElement.classList.toggle(
            'fashion-os-dark-page',
            enabled
        );

        rootElement.style.colorScheme =
            enabled
                ? 'dark'
                : 'light';

        // Chart.js berada di canvas sehingga warna teks dan garisnya
        // tidak dapat diubah hanya dengan CSS.
        Chart.defaults.color =
            enabled
                ? '#cbd5e1'
                : '#475569';

        Chart.defaults.borderColor =
            enabled
                ? 'rgba(148, 163, 184, 0.20)'
                : 'rgba(148, 163, 184, 0.28)';
    };

watch(
    isDarkMode,
    async (
        enabled,
        previousValue
    ) => {
        localStorage.setItem(
            DARK_MODE_STORAGE_KEY,
            enabled
                ? 'dark'
                : 'light'
        );

        applyDarkModeAppearance(
            enabled
        );

        // Saat tombol ditekan di Dashboard, buat ulang grafik
        // supaya label dan garis langsung mengikuti tema baru.
        if (
            previousValue !== undefined &&
            activePage.value ===
                'dashboard'
        ) {
            await nextTick();
            renderCharts();
        }
    },
    {
        immediate: true
    }
);

const userProfile = reactive({ data: null }); // <-- TAMBAHKAN INI
const currentTime = ref(new Date());        // <-- TAMBAHKAN INI
const nomorWhatsAppAdmin = ref('6285691803476');
const activationCodeInput = ref('');
const activationCodeMessage = ref('');
const commissionPayouts = ref([]);
const commissions = ref([]);
const editedProducts = ref(new Set());
const markProductAsEdited = (productId) => {
  editedProducts.value.add(productId);
};
const activationCodes = ref([]);
const newActivationCode = ref('');
const state = reactive({
    settings: { 
        brandName: 'FASHION OS', 
        minStok: 10,
        marketplaces: [],
        modelProduk: [],
        categories: [],
        inflowCategories: [ // <-- TAMBAHKAN INI
          { id: 'INFLOW-1', name: 'Modal Masuk', description: 'Tambahan modal dari pemilik atau investor.' },
          { id: 'INFLOW-2', name: 'Pendapatan Lain', description: 'Pendapatan di luar penjualan produk.' },
        ],
    },
    produk: [],
inventoryPaginated: [],
transaksi: [],

// Data retur
retur: [],

// Data khusus halaman Cek Pencairan Dana
pendingSettlements: [],

keuangan: [],
    
    carts: {},
    promotions: { perChannel: {}, perModel: {} },
    commissions: { perModel: {} },
    specialPrices: {},
    produksi: [],    // --- START: KODE BARU UNTUK STOK KAIN ---
    gudangKain: [],
    suppliers: [],
    purchaseOrders: [],
    voucherNotes: [],
    investor: [],
    bankAccounts: [],
    
    // --- END: KODE BARU UNTUKK STOK KAIN ---
    transactionCounter: 0,
    pinProtection: {
            dashboard: true,
            profitDetails: true,
            incomeHistory: true,
            investmentPage: true,
            statistikPenjualan: false,
            exportData: false,
            transactionDetail: false,
        }
});


const uiState = reactive({
    onboardingVisible: false,
    onboardingStep: 0,
    activeAccordion: null,
    sidebarGroups: {
    produk: true,
    produksi: false,
    penjualan: false,
    keuangan: false,
    sistem: false,
    bantuan: false
},
    activeCartChannel: null,

    massUpdateVariants: [],
    isMassUpdateLoading: false,
massUpdateFilterSize: '', // <-- BARUU: Untuk menyimpan input ukuran
    massUpdateFilterColor: '',

    analisisModelLimit: 10,
    dashboardDateFilter: 'this_year',
    dashboardSalesModelFilter: 'all',
    dashboardSalesChannelFilter: 'all',
    salesStatsDateFilter: 'all_time',
    salesStatsModelFilter: 'all',
    salesStatsChannelFilter: 'all',
    dashboardStartDate: '',
    dashboardEndDate: '',
    dashboardStartMonth: new Date().getMonth() + 1,
    dashboardEndMonth: new Date().getMonth() + 1,
    dashboardStartYear: new Date().getFullYear(),
    dashboardEndYear: new Date().getFullYear(),
    gudangKainSearch: '',
    gudangKainSort: 'tanggal-desc',
    editProduksiBatch: {
        produksiType: '',
        namastatus: '',
        kainBahan: []
    },
    hargaHppSelectedProduct: '',
    inventoryFilterStock: 'all',
    inventorySearch: '',
    inventorySort: 'nama-asc',
    isModalVisible: false,
    keuanganPemasukanBulan: new Date().getMonth() + 1,
    keuanganPemasukanEndDate: '',
    keuanganPemasukanFilter: 'today',
    keuanganPemasukanStartDate: '',
    keuanganPemasukanTahun: new Date().getFullYear(),
    keuanganPengeluaranBulan: new Date().getMonth() + 1,
    keuanganPengeluaranEndDate: '',
    keuanganPengeluaranFilter: 'today',
    keuanganPengeluaranStartDate: '',
    keuanganPengeluaranTahun: new Date().getFullYear(),
    laporanData: { ringkasan: [], laporanPerStatus: [], statusTerpilih: '' },
    laporanStatusSelected: 'all',
    laporanSemuaFilter: 'this_month',
    laporanSemuaStartDate: '',
    laporanSemuaEndDate: '',
    laporanSemuaBulan: new Date().getMonth() + 1,
    laporanSemuaTahun: new Date().getFullYear(),
    laporanSemuaStartMonth: new Date().getMonth() + 1,
    laporanSemuaEndMonth: new Date().getMonth() + 1,
    laporanSemuaStartYear: new Date().getFullYear(),
    laporanSemuaEndYear: new Date().getFullYear(),
    laporanSemuaCurrentPage: 1,
    laporanSemuaItemsPerPage: 5,
    analisisModelFilter: 'none',
    analisisModelSelectedModel: '',
    analisisModelSelectedType: 'aktualJadi',
    produksiFilterType: 'all',
    modalData: {},
    modalType: '',
    produksiWarnaRecommendations: [],
    produksiUkuranRecommendations: [],
    newProduksiBatch: {
        tanggal: new Date().toISOString().split('T')[0],
        produksiType: 'pemaklun', // Menambah properti ini
        namastatus: '', // Menambah properti ini
        statusProses: 'Dalam Proses',
        kainBahan: [{
            idUnik: '',
            modelProdukId: '',
            namaKain: '',
            tokoKain: '',
            warnaKain: '',
            ukuran: '',
            totalYard: null,
            hargaKainPerYard: null,
            yardPermodel: null,
            aktualJadi: null,
            aktualJadiLabelType: 'Aktual Jadi',
            hargaMaklunPerPcs: null,
            biayaAlat: null,
            aktualJadiKombinasi: null,
        }],
        statusPembayaran: 'Belum Dibayar',
        jumlahPembayaran: null,
        tanggalPembayaran: '',
        catatan: '',
        orangMemproses: '',
        
    },

    
    notesData: {},
    notesSearch: '',
    notesFilterType: 'all', // 'all', 'model', 'channel'
    notesFilterModel: '',
    notesFilterChannel: '',
    notesSortBy: 'endDate-asc',

    newPaymentData: {},

    supplierModalData: {},
    activeSupplierView: 'list', // 'list' atau 'form' <-- TAMBAHKAN BARIS INI
    penerimaanBarangForm: { // <-- TAMBAHKAN OBJEK INI
        supplierId: null,
        supplierName: '',
        tanggal: new Date().toISOString().split('T')[0],
        produk: [],
        statusProses: 'Dalam Proses',
        statusPembayaran: 'Belum Dibayar',
        catatan: '',
    },

    exportFilter: 'all_time',
    exportStartDate: '',
    exportEndDate: '',
    exportStartMonth: new Date().getMonth() + 1,
    exportEndMonth: new Date().getMonth() + 1,
    exportStartYear: new Date().getFullYear(),
    exportEndYear: new Date().getFullYear(),
    
    pengaturanMarketplaceSearch: '',
    pengaturanModelProdukSearch: '',
    pos_scan_input: '', // Untuk input scan di halaman POS
    pos_order_id: '',   // Untuk menyimpan ID pesanan yang di-scan   
    posDateFilter: 'today',
    posStartDate: '',
    posEndDate: '',
    posBulan: new Date().getMonth() + 1,
    posTahun: new Date().getFullYear(),
    posStartMonth: new Date().getMonth() + 1,
    posEndMonth: new Date().getMonth() + 1,
    posStartYear: new Date().getFullYear(),
    posEndYear: new Date().getFullYear(),
    posSearchQuery: '',
    posSearchRecommendations: [],
    specialPriceChannel: null,
    specialPriceSearch: '',
    specialPriceRecommendations: [],
    selectedProductForSpecialPrice: null,
    specialPriceInput: null,
    produksiFilterStatus: 'all',
    produksiSearch: '',
    promosiSelectedModel: '',
    returPageBulan: new Date().getMonth() + 1,
    returPageDateFilter: 'today',
    returPageEndDate: '',
    returPageSearchQuery: '',
    returPageSearchRecommendations: [],
    returPageStartDate: '',
    returPageStartMonth: new Date().getMonth() + 1,
    returPageEndMonth: new Date().getMonth() + 1,
    returPageStartYear: new Date().getFullYear(),
    returPageEndYear: new Date().getFullYear(),
    returPageTahun: new Date().getFullYear(),
    returSearchQuery: '',
    returSearchRecommendations: [],
    ringkasanStatusSelected: 'Selesai',
    selectedPlan: null,
    oldPin: '',
    newPin: '',
    confirmNewPin: '',
    pinError: '',

    isPemasukanLocked: false,       // Status terkunci untuk tabel pemasukan
    pemasukanPinInput: '',         // Untuk input PIN di halaman keuangan
    pemasukanPinError: '',         // Pesan error jika PIN salah

    isInvestasiLocked: false,     // Status terkunci untuk halaman investasi
    investasiPinInput: '',       // Untuk input PIN di halaman investasi
    investasiPinError: '',       // Pesan error jika PIN salah

    laporanKeuanganPinInput: '',
laporanKeuanganPinError: '',
laporanTransaksiPinInput: '',
laporanTransaksiPinError: '',
hargaHppPinInput: '',
hargaHppPinError: '',
statistikPenjualanPinInput: '',
statistikPenjualanPinError: '',

    referralCodeInput: '',
    referralCodeApplied: false,
    referralCodeMessage: '',

adminVerificationIdInput: '',
adminVerificationResult: null,
isVerifying: false,
adminVerificationError: '',

selectedProductForPurchase: null,

produksiLastVisible: null, // Untuk menyimpan dokumen produksi terakhir
produksiHasMore: true,     // Flag untuk menandakan apakah masih ada data produksi

transaksiLastVisible: null, // Untuk menyimpan dokumen transaksi terakhir
transaksiHasMore: true,     // Flag untuk menandakan apakah masih ada data transaksi

returLastVisible: null, // Untuk menyimpan dokumen retur terakhir
returHasMore: true,     // Flag untuk menandakan apakah masih ada data retur

productsLastVisible: null, // Untuk menyimpan dokumen produk terakhir
productsHasMore: true,     // Flag untuk menandakan apakah masih ada data produk


summaryData: {},
laporanKeuanganTahun: new Date().getFullYear(),
laporanTransaksiTahun: new Date().getFullYear(),
hargaHppSelectedModelName: '',

roasDashboard: {
    dateFilter: 'today',
    startDate: '',
    endDate: '',
    startMonth: new Date().getMonth() + 1,
    endMonth: new Date().getMonth() + 1,
    startYear: new Date().getFullYear(),
    endYear: new Date().getFullYear(),
    channelId: 'all',
    selectedModelId: 'all',
    adSpend: null,
    operationalBudget: null,
    taxPercent: null,
    discount: 0,
},

roasCalculator: {
        hargaJual: 150000,
        modalProduk: 65000,
        biayaPacking: 3000,
        biayaAdminMarketplace: 10000,
        targetMargin: 20, // dalam persen
        estimasiBiayaIklan: 500000, // dalam Rupiah
        customRoasTarget: 5,
    },

purchaseOrderSearch: '',
purchaseOrdersLastVisible: null, // Untuk menyimpan dokumen terakhir yang terlihat
purchaseOrdersHasMore: true,     // Flag untuk menandakan apakah masih ada data untuk dimuat

    purchaseOrderStatusProsesFilter: 'all', // 'all', 'Dalam Proses', 'Selesai'
    purchaseOrderStatusBayarFilter: 'all', // 'all', 'Belum Dibayar', 'Proses Pembayaran', 'Sudah Dibayar'
    purchaseOrderSort: 'tanggal-desc', // 'total-desc', 'total-asc'
    purchaseOrderItemStatusFilter: 'all',
    purchaseOrderDateFilter: 'all_time',
    purchaseOrderStartDate: '',
    purchaseOrderEndDate: '',
    purchaseOrderStartMonth: new Date().getMonth() + 1,
    purchaseOrderEndMonth: new Date().getMonth() + 1,
    purchaseOrderStartYear: new Date().getFullYear(),
    purchaseOrderEndYear: new Date().getFullYear(),

    pengaturanTab: 'umum',
    isKeuanganInfoVisible: false,
    priceCalculator: {
    hpp: null,
    targetMargin: 0,
    selectedMarketplace: null,
    selectedModelName: null,
    result: null,
    paymentMethod: 'cash', 
      selectedBankAccountId: null,
      adminFee: 0
},
    allUsers: [],
    selectedUserForExport: null,
    isExportingUserData: false,
    newActivationCode: '',
    
    stockInSearchRecommendations: [],
    bulk_manual_input: '',       // Untuk kolom input manual
    bulk_scan_input: '',         // Untuk kolom scanner lama
    bulk_paste_input: '',        // Untuk salin-tempel massal ID pesanan dan SKU
    bulkPasteInfoVisible: false,
    bulkPasteValidation: null,
    bulk_recommendations: [],    // Rekomendasi untuk input manual
    last_processed_orders: [],
    bulk_order_queue: [],
    is_processing_scan: false,   // Mencegah scan ganda
    investorStatusFilter: 'aktif',
    investorPaymentFilter: 'all_time',
    investorPaymentStartMonth: new Date().getMonth() + 1,
    investorPaymentEndMonth: new Date().getMonth() + 1,
    investorPaymentStartYear: new Date().getFullYear(),
    investorPaymentEndYear: new Date().getFullYear(),
    investorPaymentSearch: '',
    

    isPinConfirmModalVisible: false,
    pinConfirmInput: '',
    pinConfirmError: '',
    pinActionToConfirm: null,
    pinConfirmationMode: 'toggle',
    pinActionLabel: '',
    posChannelFilter: 'all',

     laporanBagiHasil: {
        selectedInvestorId: null,
        month: new Date().getMonth() + 1, // Default bulan ini
        year: new Date().getFullYear(),   // Default tahun ini
        result: null // Untuk menyimpan hasil kalkulasi
    }, // <-- PENTING: Tambahkan koma di sini

    // --- TAMBAHKAN 3 BARIS BARU DI SINI ---
    massPriceFilterUkuran: '',
    massPriceFilterWarna: '',
    massPriceInputs: {},
    massPriceHppInput: null

});

const onboardingSteps = [
    {
        title: 'Isi Pengaturan Dasar',
        subtitle: 'Mulai dari fondasi aplikasi terlebih dahulu.',
        description: 'Tambahkan channel penjualan, model produk, kategori biaya, kategori pemasukan, rekening, dan PIN keamanan. Data ini menjadi dasar untuk stok, harga, transaksi, laporan, dan ROAS.',
        pageName: 'pengaturan',
        pageLabel: 'Buka Pengaturan'
    },
    {
        title: 'Tambah Produk dan SKU',
        subtitle: 'Masukkan produk lengkap per warna dan ukuran.',
        description: 'Buat produk dengan SKU yang rapi agar stok, barcode, proses pesanan, retur, dan laporan bisa terbaca dengan benar.',
        pageName: 'inventaris',
        pageLabel: 'Buka Inventaris'
    },
    {
        title: 'Isi Harga Jual dan HPP',
        subtitle: 'Lengkapi modal dan harga jual produk.',
        description: 'Harga jual dan HPP wajib diisi agar aplikasi bisa menghitung margin, laba, laporan profit, dan target ROAS dengan akurat.',
        pageName: 'harga-hpp',
        pageLabel: 'Buka Harga & HPP'
    },
    {
        title: 'Atur Stok Awal',
        subtitle: 'Pastikan stok fisik dan alokasi stok sudah sesuai.',
        description: 'Setelah produk dibuat, masukkan stok awal setiap varian. Ini penting agar penjualan, retur, dan laporan stok tidak berantakan.',
        pageName: 'inventaris',
        pageLabel: 'Buka Inventaris'
    },
    {
        title: 'Kelola Produksi dan Supplier',
        subtitle: 'Gunakan jika bisnis Anda mencatat produksi, kain, atau pembelian supplier.',
        description: 'Di halaman produksi, supplier, dan gudang kain, Anda bisa mencatat proses produksi, kebutuhan bahan, aktual jadi, pembayaran maklun, dan penerimaan barang.',
        pageName: 'produksi',
        pageLabel: 'Buka Produksi'
    },
    {
        title: 'Mulai Input Penjualan',
        subtitle: 'Gunakan Kasir POS untuk penjualan langsung dan impor pesanan marketplace yang sudah terkirim.',
        description: 'Untuk transaksi marketplace, pindahkan hasil scan dan ekspor pengiriman melalui Google Sheets, lalu impor hanya paket yang sudah terkonfirmasi terkirim. Pantau penghasilan aktual setelah data keuangan marketplace tersedia.',
        pageName: 'bulk_process',
        pageLabel: 'Buka Impor Pesanan Terkirim'
    },
    {
        title: 'Pantau Keuangan dan Laporan',
        subtitle: 'Cek arus uang, laporan transaksi, dan laporan keuangan.',
        description: 'Gunakan halaman keuangan dan laporan untuk memantau pemasukan, pengeluaran, transaksi, profit, dan kondisi bisnis secara lebih terukur.',
        pageName: 'laporan-keuangan',
        pageLabel: 'Buka Laporan Keuangan'
    },
    {
        title: 'Analisis ROAS dan Profit Iklan',
        subtitle: 'Gunakan Dashboard ROAS dan Kalkulator ROAS.',
        description: 'Setelah data penjualan dan biaya lengkap, Anda bisa membaca performa iklan, target ROAS, BEP, profit, dan evaluasi per model produk.',
        pageName: 'roas-dashboard',
        pageLabel: 'Buka Dashboard ROAS'
    }
];

function nextOnboardingStep() {
    if (uiState.onboardingStep < onboardingSteps.length - 1) {
        uiState.onboardingStep++;
    } else {
        finishOnboarding(false);
    }
}

function prevOnboardingStep() {
    if (uiState.onboardingStep > 0) {
        uiState.onboardingStep--;
    }
}

async function finishOnboarding(isSkipped = false) {
    if (!currentUser.value) {
        uiState.onboardingVisible = false;
        return;
    }

    try {
        await setDoc(doc(db, 'users', currentUser.value.uid), {
            onboardingDone: true,
            onboardingSkipped: isSkipped,
            onboardingFinishedAt: new Date()
        }, { merge: true });

        userProfile.data = {
            ...(userProfile.data || {}),
            onboardingDone: true,
            onboardingSkipped: isSkipped
        };

        uiState.onboardingVisible = false;
        uiState.onboardingStep = 0;
    } catch (error) {
        console.error('Gagal menyimpan status onboarding:', error);
        alert('Gagal menyimpan status panduan. Silakan coba lagi.');
    }
}

function openOnboardingRelatedPage(pageName) {
    uiState.onboardingVisible = false;
    changePage(pageName);
}

function toggleSidebarGroup(group) {
    const isCurrentlyOpen = uiState.sidebarGroups[group];

    Object.keys(uiState.sidebarGroups).forEach(key => {
        uiState.sidebarGroups[key] = false;
    });

    uiState.sidebarGroups[group] = !isCurrentlyOpen;
}


function togglePendingPrivacyMode() {
    isPendingPrivacyMode.value =
        !isPendingPrivacyMode.value;
}



function toggleDarkMode() {
    isDarkMode.value =
        !isDarkMode.value;
}


const dataFetched = reactive({
    // Produk
    products: false,
    allProductsLoaded: false,
    pricesAndAllocations: false,

    // Transaksi dan retur
    transactions: false,
    allTransactionsLoaded: false,

    returns: false,
    allReturnsLoaded: false,

    // Halaman lainnya
        pendingSettlements: false,
    production: false,
    finance: false,

    suppliers: false,
    purchaseOrders: false,

    notes: false,
    fabric: false,
    investorsAndBanks: false,

    settings: false
});

// ============================================================
// INVALIDASI CACHE SESUDAH FIRESTORE WRITE
// ============================================================
// Seluruh write tetap memakai SDK Firestore asli. Pembungkus ini
// hanya menandai modul cache sebagai kotor setelah write berhasil,
// sehingga refresh cepat tidak pernah menampilkan cache lama.
const READ_CACHE_MODULE_BY_COLLECTION =
    Object.freeze({
        settings: 'settings',
        promotions: 'settings',
        product_commissions: 'settings',
        categories: 'settings',

        products: 'products',
        product_prices: 'products',
        stock_allocations: 'products',

        transactions: 'sales',
        returns: 'sales',

        keuangan: 'finance',

        production_batches: 'production',
        fabric_stock: 'production',

        suppliers: 'suppliers',
        purchase_orders: 'suppliers',

        voucher_notes: 'notes',

        investors: 'investment',
        investor_payments: 'investment',
        bank_accounts: 'investment'
    });

const getReadCacheModuleFromReference =
    reference => {
        const path =
            String(reference?.path || '');

        const collectionName =
            path.split('/')[0] || '';

        return (
            READ_CACHE_MODULE_BY_COLLECTION[
                collectionName
            ] || null
        );
    };

const invalidateWrittenReferences =
    references => {
        const modules = new Set();

        (references || []).forEach(
            reference => {
                const moduleName =
                    getReadCacheModuleFromReference(
                        reference
                    );

                if (moduleName) {
                    modules.add(moduleName);
                }
            }
        );

        modules.forEach(moduleName => {
            invalidateModuleCache(moduleName);
        });
    };

async function setDoc(
    reference,
    data,
    options
) {
    const result =
        options === undefined
            ? await firestoreSetDoc(
                reference,
                data
            )
            : await firestoreSetDoc(
                reference,
                data,
                options
            );

    invalidateWrittenReferences([
        reference
    ]);

    return result;
}

async function updateDoc(
    reference,
    ...args
) {
    const result =
        await firestoreUpdateDoc(
            reference,
            ...args
        );

    invalidateWrittenReferences([
        reference
    ]);

    return result;
}

async function deleteDoc(reference) {
    const result =
        await firestoreDeleteDoc(
            reference
        );

    invalidateWrittenReferences([
        reference
    ]);

    return result;
}

async function addDoc(
    collectionReference,
    data
) {
    const result =
        await firestoreAddDoc(
            collectionReference,
            data
        );

    invalidateWrittenReferences([
        result
    ]);

    return result;
}

function writeBatch(database) {
    const nativeBatch =
        firestoreWriteBatch(database);

    const writtenReferences = [];

    const wrappedBatch = {
        set(reference, ...args) {
            writtenReferences.push(
                reference
            );

            nativeBatch.set(
                reference,
                ...args
            );

            return wrappedBatch;
        },

        update(reference, ...args) {
            writtenReferences.push(
                reference
            );

            nativeBatch.update(
                reference,
                ...args
            );

            return wrappedBatch;
        },

        delete(reference) {
            writtenReferences.push(
                reference
            );

            nativeBatch.delete(
                reference
            );

            return wrappedBatch;
        },

        async commit() {
            const result =
                await nativeBatch.commit();

            invalidateWrittenReferences(
                writtenReferences
            );

            return result;
        }
    };

    return wrappedBatch;
}

async function runTransaction(
    database,
    updateFunction,
    options
) {
    const writtenReferences = [];

    const result =
        await firestoreRunTransaction(
            database,
            async nativeTransaction => {
                const wrappedTransaction = {
                    get(reference) {
                        return nativeTransaction.get(
                            reference
                        );
                    },

                    set(reference, ...args) {
                        writtenReferences.push(
                            reference
                        );

                        nativeTransaction.set(
                            reference,
                            ...args
                        );

                        return wrappedTransaction;
                    },

                    update(reference, ...args) {
                        writtenReferences.push(
                            reference
                        );

                        nativeTransaction.update(
                            reference,
                            ...args
                        );

                        return wrappedTransaction;
                    },

                    delete(reference) {
                        writtenReferences.push(
                            reference
                        );

                        nativeTransaction.delete(
                            reference
                        );

                        return wrappedTransaction;
                    }
                };

                return updateFunction(
                    wrappedTransaction
                );
            },
            options
        );

    invalidateWrittenReferences(
        writtenReferences
    );

    return result;
}

// Mencegah halaman yang sama menjalankan query
// dua kali secara bersamaan.
const pagesCurrentlyLoading = new Set();
// ============================================================
// INDEXEDDB + PEMERIKSAAN VERSI DATA SERVER
// ============================================================

// Urutan settings harus paling awal.
// Produk memerlukan data marketplace dan model dari settings.
const SYNC_MODULE_FIELDS = Object.freeze({
    settings: 'module_settings_version',
    products: 'module_products_version',
    sales: 'module_sales_version',
    finance: 'module_finance_version',
    production: 'module_production_version',
    suppliers: 'module_suppliers_version',
    notes: 'module_notes_version',
    investment: 'module_investment_version'
});


const cacheStartupState = reactive({
    userId: null,
    running: false,
    finished: false
});


// ============================================================
// INDEXEDDB KHUSUS METADATA VERSI
// BUKAN DATABASE INTERNAL FIRESTORE
// ============================================================

const SYNC_META_DB_NAME =
    'fashion_os_cache_metadata';

const SYNC_META_DB_VERSION = 1;

const SYNC_META_STORE_NAME =
    'user_versions';

let syncMetadataDbPromise = null;


// Key localStorage lama.
// Hanya dipakai untuk migrasi dan cadangan darurat.
const getLegacySyncStorageKey = (userId) => {
    return `fashion_os_sync_versions_v1_${userId}`;
};


const normalizeSyncVersions = (versions = {}) => {
    const normalized = {
        schemaVersion: 2
    };

    Object.keys(SYNC_MODULE_FIELDS)
        .forEach(moduleName => {
            normalized[moduleName] =
                Number(versions[moduleName]) || 0;
        });

    return normalized;
};


const openSyncMetadataDb = () => {
    if (syncMetadataDbPromise) {
        return syncMetadataDbPromise;
    }

    syncMetadataDbPromise =
        new Promise((resolve, reject) => {
            if (
                typeof window === 'undefined' ||
                !window.indexedDB
            ) {
                reject(
                    new Error(
                        'IndexedDB tidak tersedia di browser ini.'
                    )
                );

                return;
            }

            const request =
                window.indexedDB.open(
                    SYNC_META_DB_NAME,
                    SYNC_META_DB_VERSION
                );

            request.onupgradeneeded = () => {
                const database = request.result;

                if (
                    !database.objectStoreNames.contains(
                        SYNC_META_STORE_NAME
                    )
                ) {
                    database.createObjectStore(
                        SYNC_META_STORE_NAME,
                        {
                            keyPath: 'userId'
                        }
                    );
                }
            };

            request.onsuccess = () => {
                const database = request.result;

                database.onversionchange = () => {
                    database.close();
                    syncMetadataDbPromise = null;
                };

                resolve(database);
            };

            request.onerror = () => {
                syncMetadataDbPromise = null;

                reject(
                    request.error ||
                    new Error(
                        'Gagal membuka IndexedDB metadata.'
                    )
                );
            };

            request.onblocked = () => {
                console.warn(
                    '[SYNC METADATA] Pembaruan IndexedDB tertahan oleh tab lain.'
                );
            };
        });

    return syncMetadataDbPromise;
};



const writeSyncMetadataRecord =
    async (record) => {
        const database =
            await openSyncMetadataDb();

        return new Promise((resolve, reject) => {
            const transaction =
                database.transaction(
                    SYNC_META_STORE_NAME,
                    'readwrite'
                );

            transaction
                .objectStore(
                    SYNC_META_STORE_NAME
                )
                .put(record);

            transaction.oncomplete = () => {
                resolve();
            };

            transaction.onerror = () => {
                reject(
                    transaction.error ||
                    new Error(
                        'Gagal menyimpan metadata versi.'
                    )
                );
            };

            transaction.onabort = () => {
                reject(
                    transaction.error ||
                    new Error(
                        'Penyimpanan metadata dibatalkan.'
                    )
                );
            };
        });
    };


const saveLocalSyncVersions = async (
    userId,
    versions
) => {
    const normalized =
        normalizeSyncVersions(versions);

    const record = {
        userId,
        ...normalized,
        savedAt: Date.now()
    };

    try {
        await writeSyncMetadataRecord(record);

        // Hapus versi lama setelah berhasil masuk IndexedDB.
        localStorage.removeItem(
            getLegacySyncStorageKey(userId)
        );
    } catch (error) {
        // Cadangan agar aplikasi tetap bekerja
        // pada browser yang bermasalah dengan IndexedDB.
        console.warn(
            '[SYNC METADATA] IndexedDB gagal. Memakai localStorage sebagai cadangan.',
            error
        );

        localStorage.setItem(
            getLegacySyncStorageKey(userId),
            JSON.stringify(normalized)
        );
    }
};




// Mengambil seluruh versi modul dari user_sync.
const extractServerSyncVersions =
    (syncData = {}) => {
        const versions = {};

        Object.entries(SYNC_MODULE_FIELDS)
            .forEach(
                ([moduleName, fieldName]) => {
                    versions[moduleName] =
                        Number(
                            syncData[fieldName]
                        ) || 0;
                }
            );

        return normalizeSyncVersions(versions);
    };

const preparePersistentReadCache =
    async userId => {
        if (!userId) {
            clearReadCacheContext();
            return false;
        }

        try {
            const syncSnapshot =
                await getDocFromServer(
                    doc(
                        db,
                        'user_sync',
                        userId
                    )
                );

            const serverVersions =
                extractServerSyncVersions(
                    syncSnapshot.exists()
                        ? syncSnapshot.data()
                        : {}
                );

            setReadCacheContext(
                userId,
                serverVersions
            );

            await saveLocalSyncVersions(
                userId,
                serverVersions
            );

            console.log(
                '[APP CACHE] Versi server siap. Cache halaman akan dipakai hanya bila versinya sama.'
            );

            return true;
        } catch (error) {
            // Gagal membaca versi berarti cache persisten
            // tidak boleh dipakai. Loader normal tetap berjalan.
            clearReadCacheContext();

            console.warn(
                '[APP CACHE] Pemeriksaan versi gagal. Memakai pembacaan server biasa.',
                error
            );

            return false;
        }
    };





const loadCachedModuleSafely = async (
    moduleName,
    loader
) => {
    try {
        await loader();
    } catch (error) {
        console.warn(
            `[INDEXEDDB] Cache modul "${moduleName}" belum tersedia.`,
            error
        );
    }
};


// ============================================================
// MEMUAT MODUL DARI CACHE FIRESTORE
// ============================================================

const loadBigModulesFromIndexedDb =
    async (userId) => {
        console.log(
            '[STARTUP CEPAT] Memuat pengaturan inti saja.'
        );

        // Startup tidak boleh membaca seluruh produk,
        // transaksi, retur, keuangan, produksi, dan supplier.
        // Modul besar akan dimuat ketika halamannya dibuka.
        await loadCachedModuleSafely(
            'settings',
            () => fetchCoreData(userId)
        );
    };



// ============================================================
// STARTUP CACHE
// ============================================================

const beginIndexedDbStartup =
    async (userId) => {
        if (
            cacheStartupState.userId !== userId
        ) {
            cacheStartupState.userId = userId;
            cacheStartupState.running = false;
            cacheStartupState.finished = false;
        }

        if (
            cacheStartupState.running ||
            cacheStartupState.finished
        ) {
            return false;
        }

        cacheStartupState.running = true;

        try {
            // Jangan matikan jaringan Firestore.
            // Mematikan jaringan membuat pembacaan server
            // menghasilkan pesan client is offline.
            await loadBigModulesFromIndexedDb(
                userId
            );

            return true;
        } catch (error) {
            console.warn(
                '[STARTUP CEPAT] Data inti belum berhasil dimuat.',
                error
            );

            cacheStartupState.running = false;
            cacheStartupState.finished = true;

            return false;
        }
    };

const finishIndexedDbStartup =
    async () => {
        try {
            console.log(
                isReadCacheReady()
                    ? '[APP CACHE] Cache halaman aktif dan tervalidasi oleh versi server.'
                    : '[APP CACHE] Cache persisten tidak aktif. Aplikasi memakai loader server biasa.'
            );
        } catch (error) {
            console.warn(
                '[APP CACHE] Penyelesaian startup cache gagal. Aplikasi tetap dapat digunakan.',
                error
            );
        } finally {
            cacheStartupState.running = false;
            cacheStartupState.finished = true;
        }
    };

const loadDataForPage = async (pageName) => {
    if (!currentUser.value) return;

    // Permintaan pertama tetap berjalan.
    // Permintaan kedua untuk halaman yang sama dilewati
    // sampai permintaan pertama selesai.
    if (pagesCurrentlyLoading.has(pageName)) {
        console.log(
            `[SKIP LOAD] Halaman "${pageName}" masih dimuat.`
        );
        return;
    }

    pagesCurrentlyLoading.add(pageName);

const userId = currentUser.value.uid;

// Hanya pemanggilan halaman pertama yang bertugas
// menyelesaikan proses cache startup.
let shouldFinishIndexedDbStartup = false;

try {
    shouldFinishIndexedDbStartup =
        await beginIndexedDbStartup(userId);
        const dataPromises = [];

        // FASHION_OS_DASHBOARD_SUMMARY_V2
        // Di luar Dashboard/Rekonsiliasi cukup baca satu dokumen global.
        // Bila ringkasan belum siap, daftar Dana Gantung lama tetap dipakai.
        if (
            pageName !== 'dashboard' &&
            pageName !== 'rekonsiliasi'
        ) {
            dataPromises.push(
                loadDashboardGlobalSummaryV2(
                    userId
                ).then(summaryReady => {
                    if (
                        !summaryReady &&
                        !dataFetched
                            .pendingSettlements
                    ) {
                        return fetchPendingSettlementData(
                            userId
                        );
                    }

                    return true;
                })
            );
        }

        switch(pageName) {
            case 'dashboard': {
                dataPromises.push(
                    loadDashboardDataByCurrentFilter(
                        userId
                    )
                );

                dataPromises.push(
                    fetchSummaryData(
                        userId
                    )
                );

                // Muat semua pesanan marketplace yang belum selesai secara terpisah
                // dari rentang tanggal KPI. Daftar tertunda adalah saldo berjalan.
                dataPromises.push(
                    fetchPendingSettlementData(
                        userId
                    )
                );

                break;
            }
            case 'audit-data':
    dataPromises.push(fetchAllProductData(userId));
    dataPromises.push(fetchTransactionAndReturnData(userId, false, null, null, true));
    dataPromises.push(fetchKeuanganData());
    break;
            case 'statistik-penjualan':
    dataPromises.push(fetchAllProductData(userId));
    dataPromises.push(fetchTransactionAndReturnData(userId, false, null, null, true));
    break;
            case 'transaksi':
                dataPromises.push(
                    fetchAllProductData(
                        userId
                    )
                );

                dataPromises.push(
                    loadTransactionHistoryByCurrentFilter(
                        userId
                    )
                );

                dataPromises.push(
                    fetchNotesData(
                        userId
                    )
                );

                break;

            case 'bulk_process':
                dataPromises.push(
                    fetchAllProductData(
                        userId
                    )
                );
                break;

            case 'inventaris':
                dataPromises.push(fetchProductData(userId));
                break;

            case 'harga-hpp':
            case 'promosi':
            case 'produksi':
            case 'supplier':
            case 'retur':
                dataPromises.push(fetchAllProductData(userId));
                
                if (pageName === 'promosi') dataPromises.push(fetchNotesData(userId));
                if (pageName === 'produksi') dataPromises.push(fetchProductionData(userId));
                if (pageName === 'supplier') dataPromises.push(fetchSupplierData(userId));
                if (pageName === 'retur') {
                    dataPromises.push(
                        loadReturnHistoryByCurrentFilter(
                            userId
                        )
                    );
                }
                break;
            
            case 'gudang-kain':
                dataPromises.push(fetchProductionData(userId));
                break;
            case 'laporan-transaksi':
case 'laporan-keuangan': {
    // Laporan harus pakai data mentah terbaru, bukan summary lama.
    // Summary lama bisa masih menyimpan transaksi yang sudah dihapus.
    dataPromises.push(fetchTransactionAndReturnData(userId, false, null, null, true));
    dataPromises.push(fetchKeuanganData());
    break;
}
            case 'keuangan':
                dataPromises.push(fetchKeuanganData());
                break;
            case 'investasi':
      await fetchInvestorsAndBanksData(userId);
      break;
    
    case 'pengaturan':
      // Kita panggil fungsi ini karena data Bank ada di dalamnya
      await fetchInvestorsAndBanksData(userId); 
      break;
            
            // --- PENAMBAHAN CASE BARU DI SINI ---
            case 'panduan-baru':
case 'roas-calculator':
    break;

case 'roas-dashboard':
    dataPromises.push(fetchAllProductData(userId));
    dataPromises.push(fetchTransactionAndReturnData(userId));
    dataPromises.push(fetchKeuanganData());
    break;
}
        if (dataPromises.length > 0) {
            await Promise.all(dataPromises);
        }

        if (pageName === 'dashboard') {
            nextTick(renderCharts);
        }

        } catch (error) {
        console.error(
            `Failed to load data for page ${pageName}:`,
            error
        );
    } finally {
    pagesCurrentlyLoading.delete(pageName);

    // Sesudah halaman menampilkan data IndexedDB,
    // hidupkan network dan periksa satu dokumen versi.
    if (shouldFinishIndexedDbStartup) {
        await finishIndexedDbStartup(userId);
    }
}
};

const lastEditedModel = ref(null);
const groupRefs = ref({});

const inventoryModelLoading = reactive({});
const inventoryModelLoaded = reactive({});
const inventoryModelErrors = reactive({});



const riwayatPengeluaran = computed(() => {
    // 1. Filter Awal: Hanya Pengeluaran (pengeluaran atau biaya)
    const pengeluaranData = state.keuangan.filter(k => k.jenis === 'pengeluaran' || k.jenis === 'biaya');

    // 2. Filter Waktu: Menerapkan filter tanggal yang dipilih
    const filteredByDate = filterDataByDate(
        pengeluaranData,
        uiState.keuanganPengeluaranFilter,
        uiState.keuanganPengeluaranStartDate,
        uiState.keuanganPengeluaranEndDate,
        uiState.keuanganPengeluaranStartMonth,
        uiState.keuanganPengeluaranStartYear,
        uiState.keuanganPengeluaranEndMonth,
        uiState.keuanganPengeluaranEndYear
    );

    // 3. Sort Stabil: Tanggal ASC (Terbaru di Bawah)
    return filteredByDate.sort((a, b) => {
        const dateA = new Date(a.tanggal).getTime();
        const dateB = new Date(b.tanggal).getTime();
        if (dateA !== dateB) {
            return dateA - dateB; // ASCENDING
        }
        return a.id.localeCompare(b.id);
    });
});
// --- AKHIR PENGGANTIAN riwayatPengeluaran ---


// --- GANTI SELURUH COMPUTED PROPERTY riwayatPemasukan DENGAN KODE INI ---
const riwayatPemasukan = computed(() => {
    // 1. Filter Awal: Hanya Pemasukan
    const pemasukanData = state.keuangan.filter(k => k.jenis === 'pemasukan_lain');

    // 2. Filter Waktu: Menerapkan filter tanggal yang dipilih
    const filteredByDate = filterDataByDate(
        pemasukanData,
        uiState.keuanganPemasukanFilter,
        uiState.keuanganPemasukanStartDate,
        uiState.keuanganPemasukanEndDate,
        uiState.keuanganPemasukanStartMonth,
        uiState.keuanganPemasukanStartYear,
        uiState.keuanganPemasukanEndMonth,
        uiState.keuanganPemasukanEndYear
    );

    // 3. Sort Stabil: Tanggal ASC (Terbaru di Bawah)
    return filteredByDate.sort((a, b) => {
        const dateA = new Date(a.tanggal).getTime();
        const dateB = new Date(b.tanggal).getTime();
        if (dateA !== dateB) {
            return dateA - dateB; // ASCENDING
        }
        return a.id.localeCompare(b.id);
    });
});

const unpaidCommissions = computed(() =>
    commissions.value.filter(c => c.status === 'unpaid')
        .sort((a, b) => new Date(b.createdAt.seconds * 1000) - new Date(a.createdAt.seconds * 1000))
);

const processingCommissions = computed(() =>
    commissions.value.filter(c => c.status === 'processing')
        .sort((a, b) => new Date(b.createdAt.seconds * 1000) - new Date(a.createdAt.seconds * 1000))
);

const paidCommissions = computed(() =>
    commissions.value.filter(c => c.status === 'paid')
);

const totalUnpaidCommission = computed(() =>
    unpaidCommissions.value.reduce((sum, c) => sum + c.commissionAmount, 0)
);

const totalProcessingCommission = computed(() =>
    processingCommissions.value.reduce((sum, c) => sum + c.commissionAmount, 0)
);

const totalPaidCommission = computed(() =>
    paidCommissions.value.reduce((sum, c) => sum + c.commissionAmount, 0)
);

const totalRevenue = computed(() =>
    totalPaidCommission.value + totalProcessingCommission.value + totalUnpaidCommission.value
);

const availableForWithdrawal = computed(() => totalUnpaidCommission.value);
const totalWithdrawn = computed(() => totalPaidCommission.value);

const isLaporanKeuanganLocked = ref(false);
const isLaporanTransaksiLocked = ref(false);
const isHargaHppLocked = ref(false);
const isStatistikPenjualanLocked = ref(false);
const isDashboardLocked = ref(false);
const dashboardPinInput = ref('');
const dashboardPinError = ref('');
const ADMIN_UID = '6m4bgRlZMDhL8niVyD4lZmGuarF3'; 
const hasLoadedInitialData = ref(false);
// Properti ini akan otomatis bernilai 'true' jika yang login adalah Anda (Admin)
const isAdmin = computed(() => {
  return currentUser.value && currentUser.value.uid === ADMIN_UID;
});

const parsePercentageInput = (value) => {
    if (typeof value !== 'string') return value;
    const cleaned = value.replace(',', '.').replace(/[^0-9.]/g, '');
    return parseFloat(cleaned) || 0;
};

function toExportDate(value) {
    if (!value) return null;

    if (value instanceof Date) {
        return isNaN(value.getTime()) ? null : value;
    }

    if (value?.toDate && typeof value.toDate === 'function') {
        const date = value.toDate();
        return isNaN(date.getTime()) ? null : date;
    }

    if (value?.seconds) {
        const date = new Date(value.seconds * 1000);
        return isNaN(date.getTime()) ? null : date;
    }

    const date = new Date(value);
    return isNaN(date.getTime()) ? null : date;
}

function formatExportDate(value, withTime = true) {
    const date = toExportDate(value);
    if (!date) return '';

    const pad = (num) => String(num).padStart(2, '0');

    const year = date.getFullYear();
    const month = pad(date.getMonth() + 1);
    const day = pad(date.getDate());
    const hour = pad(date.getHours());
    const minute = pad(date.getMinutes());

    if (!withTime) {
        return `${year}-${month}-${day}`;
    }

    return `${year}-${month}-${day} ${hour}:${minute}`;
}

function getAdminExportDateRange(
    exportFilter = 'all_time',
    exportStartDate = '',
    exportEndDate = '',
    exportStartMonth = new Date().getMonth() + 1,
    exportEndMonth = new Date().getMonth() + 1,
    exportStartYear = new Date().getFullYear(),
    exportEndYear = new Date().getFullYear()
) {
    const now = new Date();

    let start = null;
    let end = null;
    let label = 'Semua Data';

    const startOfDay = (date) => new Date(date.getFullYear(), date.getMonth(), date.getDate(), 0, 0, 0, 0);
    const endOfDay = (date) => new Date(date.getFullYear(), date.getMonth(), date.getDate(), 23, 59, 59, 999);

    if (exportFilter === 'today') {
        start = startOfDay(now);
        end = endOfDay(now);
        label = 'Hari Ini';
    }

    if (exportFilter === 'last_7_days') {
        start = startOfDay(new Date(now.getFullYear(), now.getMonth(), now.getDate() - 6));
        end = endOfDay(now);
        label = '7 Hari Terakhir';
    }

    if (exportFilter === 'last_30_days') {
        start = startOfDay(new Date(now.getFullYear(), now.getMonth(), now.getDate() - 29));
        end = endOfDay(now);
        label = '30 Hari Terakhir';
    }

    if (exportFilter === 'this_year') {
        start = new Date(now.getFullYear(), 0, 1, 0, 0, 0, 0);
        end = new Date(now.getFullYear(), 11, 31, 23, 59, 59, 999);
        label = `Tahun Ini ${now.getFullYear()}`;
    }

    if (exportFilter === 'by_date_range') {
        if (!exportStartDate || !exportEndDate) {
            throw new Error('Tanggal awal dan tanggal akhir export wajib diisi.');
        }

        start = startOfDay(new Date(exportStartDate));
        end = endOfDay(new Date(exportEndDate));
        label = `${formatExportDate(start, false)} s/d ${formatExportDate(end, false)}`;
    }

    if (exportFilter === 'by_month_range') {
        start = new Date(Number(exportStartYear), Number(exportStartMonth) - 1, 1, 0, 0, 0, 0);
        end = new Date(Number(exportEndYear), Number(exportEndMonth), 0, 23, 59, 59, 999);
        label = `${String(exportStartMonth).padStart(2, '0')}-${exportStartYear} s/d ${String(exportEndMonth).padStart(2, '0')}-${exportEndYear}`;
    }

    if (exportFilter === 'by_year_range') {
        start = new Date(Number(exportStartYear), 0, 1, 0, 0, 0, 0);
        end = new Date(Number(exportEndYear), 11, 31, 23, 59, 59, 999);
        label = `${exportStartYear} s/d ${exportEndYear}`;
    }

    return {
        filter: exportFilter,
        start,
        end,
        label,
        isAllTime: exportFilter === 'all_time'
    };
}

function isInsideAdminExportRange(value, range) {
    if (range.isAllTime) return true;

    const date = toExportDate(value);
    if (!date) return false;

    return date >= range.start && date <= range.end;
}


function safeSheetName(name) {
    let cleanName = String(name || 'Sheet');

    const forbiddenChars = [':', '\\', '/', '?', '*', '[', ']'];

    forbiddenChars.forEach(char => {
        cleanName = cleanName.split(char).join(' ');
    });

    cleanName = cleanName.trim().substring(0, 31);

    return cleanName || 'Sheet';
}

function appendExportSheet(workbook, sheetName, rows, columnWidths = []) {
    const safeRows = rows && rows.length > 0
        ? rows
        : [{ Keterangan: 'Tidak ada data pada periode export ini.' }];

    const worksheet = XLSX.utils.json_to_sheet(safeRows, { cellDates: true });

    if (worksheet['!ref']) {
        worksheet['!autofilter'] = { ref: worksheet['!ref'] };
    }

    worksheet['!cols'] = columnWidths.length > 0
        ? columnWidths.map(width => ({ wch: width }))
        : Object.keys(safeRows[0] || {}).map(key => ({ wch: Math.min(Math.max(key.length + 6, 16), 40) }));

    XLSX.utils.book_append_sheet(workbook, worksheet, safeSheetName(sheetName));
}

function snapshotToRows(snapshot) {
    return snapshot.docs.map(docSnap => ({
        docId: docSnap.id,
        id: docSnap.id,
        ...docSnap.data()
    }));
}

function isActiveExportRecord(item) {
    if (!item) return false;

    const status = String(item.status || item.statusData || item.statusProses || '').toLowerCase();

    if (item.isDeleted === true) return false;
    if (item.deleted === true) return false;
    if (item.archived === true) return false;
    if (item.deletedAt) return false;
    if (status === 'deleted') return false;
    if (status === 'dihapus') return false;
    if (status === 'arsip') return false;
    if (status === 'archived') return false;

    return true;
}



function isValidNumberForExport(value) {
    return value !== null && value !== undefined && value !== '' && !isNaN(Number(value));
}

function exportNumber(value) {
    return isValidNumberForExport(value) ? Number(value) : 0;
}

function getActiveArray(items) {
    return (items || []).filter(isActiveExportRecord);
}

async function getDocsByProductIds(
    collectionName,
    productIds,
    ownerUserId = null,
    readFromServer = false
) {
    const cleanProductIds =
        new Set(
            (productIds || [])
                .filter(Boolean)
        );

    if (cleanProductIds.size === 0) {
        return [];
    }

    if (!ownerUserId) {
        console.warn(
            `[QUERY DIBATALKAN] ${collectionName} tidak dibaca tanpa ownerUserId.`
        );

        return [];
    }

    const ownerQuery =
        query(
            collection(
                db,
                collectionName
            ),
            where(
                'userId',
                '==',
                ownerUserId
            )
        );

    const snapshot =
        readFromServer
            ? await getDocsFromServer(
                ownerQuery
            )
            : await getDocs(
                ownerQuery
            );

    return snapshotToRows(
        snapshot
    ).filter(row =>
        cleanProductIds.has(
            row.product_id
        )
    );
}

function dedupeRowsByDocId(rows) {
    const map = new Map();

    (rows || []).forEach(row => {
        const key = row.docId || row.id;
        if (!key) return;
        map.set(key, row);
    });

    return [...map.values()];
}



function buildMarketplaceRowsForExport(marketplaces = [], sourceLabel = 'Data aplikasi yang sedang tampil') {
    return JSON.parse(JSON.stringify(marketplaces || [])).map((mp, index) => {
        const programs = Array.isArray(mp.programs)
            ? mp.programs
            : (Array.isArray(mp.program) ? mp.program : []);

        const programText = programs.length > 0
            ? programs.map(program => {
                const name = program.name || program.nama || program.programName || 'Program';
                const type = program.type || program.jenis || program.satuan || program.unit || '%';
                const value = program.rate ?? program.value ?? program.amount ?? program.nominal ?? program.biaya ?? '';

                if (String(type).toLowerCase().includes('rp')) {
                    return `${name} (Rp ${new Intl.NumberFormat('id-ID').format(Number(value) || 0)})`;
                }

                return `${name} (${value}%)`;
            }).join('; ')
            : '';

        return {
            'No': index + 1,
            'Sumber Data': sourceLabel,
            'ID Channel': mp.id || '',
            'Nama Channel': mp.name || mp.nama || '',
            'Biaya Admin (%)': mp.adm ?? mp.admin ?? 0,
            'Biaya Layanan G Xtra (%)': mp.layanan ?? mp.serviceFee ?? 0,
            'Biaya Per Pesanan': mp.perPesanan ?? mp.biayaPerPesanan ?? 0,
            'Jumlah Program': programs.length,
            'Program Tambahan': programText
        };
    });
}

function exportMarketplaceYangTampil() {
    const marketplaces = state.settings.marketplaces || [];

    if (marketplaces.length === 0) {
        alert('Tidak ada data marketplace untuk diexport.');
        return;
    }

    const dataToExport = buildMarketplaceRowsForExport(
        marketplaces,
        'state.settings.marketplaces - data yang tampil di aplikasi'
    );

    const worksheet = XLSX.utils.json_to_sheet(dataToExport);

    worksheet['!cols'] = [
        { wch: 8 },
        { wch: 45 },
        { wch: 30 },
        { wch: 34 },
        { wch: 18 },
        { wch: 24 },
        { wch: 20 },
        { wch: 18 },
        { wch: 60 }
    ];

    if (worksheet['!ref']) {
        worksheet['!autofilter'] = { ref: worksheet['!ref'] };
    }

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Marketplace');

    const safeEmail = String(currentUser.value?.email || 'user')
        .replace(/[^a-zA-Z0-9@._-]/g, '_');

    XLSX.writeFile(
        workbook,
        `Marketplace_Yang_Tampil_${safeEmail}_${new Date().toISOString().split('T')[0]}.xlsx`
    );
}

const getExpenseTypeByCategory = (kategori) => {
    const category = (state.settings.categories || []).find(cat => cat.name === kategori);

    if (category?.type) {
        return category.type;
    }

    const nama = (kategori || '').toLowerCase();

    const productionKeywords = [
        'kain',
        'jahit',
        'maklun',
        'supplier',
        'produksi',
        'bahan',
        'aksesoris',
        'resleting',
        'kancing',
        'label',
        'hangtag',
        'bordir',
        'payet',
        'obras',
        'kerugian stok'
    ];

    return productionKeywords.some(keyword => nama.includes(keyword))
        ? 'produksi'
        : 'operasional';
};

// --- LOGIKA FILTER YANG SUDAH DIPERBAIKI ---
const filteredMassPriceVariants = computed(() => {
    // 1. Ambil data source
    let variants = uiState.massUpdateVariants || [];

    // 2. Filter berdasarkan Ukuran (DIGANTI JADI EXACT MATCH)
    if (uiState.massPriceFilterUkuran) {
        const keyword = uiState.massPriceFilterUkuran.toString().toLowerCase().trim();
        
        variants = variants.filter(v => {
            const val = String(v.varian || '').toLowerCase();
            // PERUBAHAN PENTING DI SINI:
            // Gunakan '===' (Sama Persis). 
            // Jadi kalau ketik "l", hanya "l" yang muncul. "xl" tidak akan muncul.
            return val === keyword; 
        });
    }

    // 3. Filter berdasarkan Warna (TETAP PAKAI INCLUDES AGAR FLEKSIBEL)
    if (uiState.massPriceFilterWarna) {
        const keyword = uiState.massPriceFilterWarna.toString().toLowerCase().trim();
        
        variants = variants.filter(v => {
            const val = String(v.warna || '').toLowerCase();
            // Warna tetap pakai 'includes' supaya ketik "merah" bisa ketemu "merah maroon"
            return val.includes(keyword);
        });
    }

    return variants;
});

const isSubscriptionActive = computed(() => {
    const now = currentTime.value; // Gunakan waktu reaktif kita

    if (!userProfile.data) {
        return false;
    }

    const status = userProfile.data.subscriptionStatus;

    // Cek jika masa trial aktif
    if (status === 'trial' && userProfile.data.trialEndDate) {
        const trialEndDate = new Date(userProfile.data.trialEndDate.seconds * 1000);
        if (trialEndDate > now) return true;
    }

    // Cek jika masa langganan berbayar aktif
    if (status === 'active' && userProfile.data.subscriptionEndDate) {
        // Cek jika subscriptionEndDate adalah Firestore Timestamp atau JS Date
        const endDateValue = userProfile.data.subscriptionEndDate.seconds 
            ? userProfile.data.subscriptionEndDate.seconds * 1000 
            : new Date(userProfile.data.subscriptionEndDate).getTime();

        if (endDateValue > now) return true;
    }

    return false;
});

let unsubscribeSummary = null; // Variabel untuk menyimpan listener

const fetchSummaryData = (userId) => {
    if (unsubscribeSummary) {
        unsubscribeSummary(); // Hentikan listener lama jika ada
    }

    if (!userId) {
        state.summaryData = {};
        return;
    }

    const summaryRef = doc(db, "user_summaries", userId);
    // Gunakan onSnapshot untuk 'mendengarkan' perubahan secara real-time
    unsubscribeSummary = onSnapshot(summaryRef, (docSnap) => {
        if (docSnap.exists()) {
            state.summaryData = docSnap.data();
        } else {
            console.log("Dokumen ringkasan belum ada, akan dibuat otomatis oleh Cloud Function.");
            state.summaryData = {};
        }
    }, (error) => {
        console.error("Gagal mendengarkan summary data:", error);
    });
};
// Fungsi untuk mengambil daftar semua pengguna (hanya untuk Admin)
async function fetchAllUsers() {
    if (!isAdmin.value) return;

    try {
        const usersCollection = collection(db, 'users');
        const userSnapshots = await getDocsFromServer(usersCollection);

        uiState.allUsers = userSnapshots.docs.map(docSnap => {
            const data = docSnap.data() || {};

            return {
                ...data,

                // INI YANG PALING PENTING:
                // UID export admin harus pakai ID dokumen users/{docId},
                // bukan field uid di dalam data karena field itu bisa lama/salah.
                id: docSnap.id,
                uid: docSnap.id,
                firestoreDocId: docSnap.id,

                // Simpan uid lama hanya untuk cek/debug, jangan dipakai export.
                oldUidField: data.uid || '',

                email: data.email || data.userEmail || data.ownerEmail || ''
            };
        }).sort((a, b) => {
            return String(a.email || '').localeCompare(String(b.email || ''));
        });

        // Reset pilihan supaya user wajib pilih ulang dari data terbaru.
        uiState.selectedUserForExport = null;

    } catch (error) {
        console.error("Gagal mengambil daftar pengguna:", error);
        alert("Gagal mengambil daftar pengguna.");
    }
}

function getAdminExportUserId(user) {
    if (!user) return '';

    // Prioritas utama harus ID dokumen Firestore users/{docId}
    return user.firestoreDocId || user.id || user.docId || user.uid || '';
}

function getAdminExportUserEmail(user) {
    if (!user) return '';

    return user.email || user.userEmail || user.ownerEmail || '';
}

async function fetchCommissionPayouts() {
    if (!isAdmin.value) return;
    try {
        const payoutsQuery = query(
            collection(db, "keuangan"), 
            where("kategori", "==", "Pembayaran Komisi Mitra")
        );
        const snapshot = await getDocs(payoutsQuery);
        commissionPayouts.value = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }))
            .sort((a, b) => b.tanggal.toDate() - a.tanggal.toDate()); // Urutkan dari terbaru
    } catch (error) {
        console.error("Gagal mengambil riwayat pencairan komisi:", error);
        alert("Gagal mengambil riwayat pencairan komisi.");
    }
}

// Fungsi baru untuk membuat kode rujukan yang lebih profesional
function generatePartnerCode() {
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
    let result = 'PARTNER-';
    for (let i = 0; i < 5; i++) {
        result += characters.charAt(Math.floor(Math.random() * characters.length));
    }
    return result;
}

function openMassUpdateModal(group) {
    // 1. Reset Input Filter & Data
    uiState.massPriceFilterUkuran = '';
    uiState.massPriceFilterWarna = '';
    uiState.massUpdateVariants = []; // Kosongkan dulu

    // 2. Tampilkan Modal
    showModal('aturHargaMassal', { 
        groupName: group.namaModel 
    });

    // 3. MASUKKAN DATA LANGSUNG DARI GRUP (Solusi Masalah Anda)
    // Alih-alih request ke database berdasarkan ID, kita pakai data yang sudah ada di grup
    // Ini menjamin jumlah varian SAMA PERSIS dengan yang terlihat di halaman inventaris
    uiState.massUpdateVariants = group.variants.map(v => ({
        ...v,
        // Pastikan properti warna dan varian aman
        warna: v.warna || '', 
        varian: v.varian || ''
    }));

    // (Opsional) Kita tidak perlu memanggil fetchAllVariantsForModel lagi
    // karena datanya sudah kita ambil dari tampilan inventaris
}

// Fungsi baru untuk menjadikan pengguna sebagai mitra
async function makeUserPartner(userId) {
    if (!confirm("Anda yakin ingin menjadikan pengguna ini sebagai mitra? Kode rujukan unik akan dibuat.")) {
        return;
    }

    try {
        const userRef = doc(db, "users", userId);
        const referralCode = generatePartnerCode();

        await updateDoc(userRef, {
            isPartner: true,
            referralCode: referralCode
        });

        // Perbarui state lokal
        const userInState = uiState.allUsers.find(u => u.uid === userId);
        if (userInState) {
            userInState.isPartner = true;
            userInState.referralCode = referralCode;
        }

        alert(`Pengguna berhasil menjadi mitra! Kode rujukan: ${referralCode}`);
    } catch (error) {
        console.error("Gagal menjadikan pengguna mitra:", error);
        alert("Gagal menjadikan pengguna mitra. Silakan coba lagi.");
    }
}

async function fetchActivationCodes() {
    if (!isAdmin.value) return;
    try {
        const codesCollection = collection(db, 'activation_codes');
        const snapshot = await getDocs(codesCollection);
        activationCodes.value = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }))
            .sort((a, b) => (a.status === 'unused' ? -1 : 1) - (b.status === 'unused' ? -1 : 1)); // Urutkan yang 'unused' di atas
    } catch (error) {
        console.error("Gagal mengambil kode aktivasi:", error);
    }
}

async function deleteActivationCode(codeId) {
    if (!confirm('Anda yakin ingin menghapus kode aktivasi ini? Aksi ini tidak dapat dibatalkan.')) {
        return;
    }

    if (!isAdmin.value) {
        alert("Anda tidak memiliki izin untuk melakukan tindakan ini.");
        return;
    }

    try {
        await deleteDoc(doc(db, "activation_codes", codeId));

        // Perbarui state lokal untuk memperbarui UI
        activationCodes.value = activationCodes.value.filter(code => code.id !== codeId);

        alert(`Kode aktivasi "${codeId}" berhasil dihapus.`);
    } catch (error) {
        console.error("Gagal menghapus kode aktivasi:", error);
        alert("Gagal menghapus kode aktivasi. Silakan coba lagi.");
    }
}

// Fungsii untuk membuat kode aktivasi baru
async function createActivationCode() {
    if (!isAdmin.value) return;
    
    let codeToCreate = newActivationCode.value.trim();
    if (!codeToCreate) {
        // Jika input kosong, buat kode acak
        codeToCreate = `FOS-${Date.now().toString().slice(-6)}`;
    }

    try {
        isSaving.value = true;
        const codeRef = doc(db, "activation_codes", codeToCreate);
        const codeDoc = await getDoc(codeRef);

        if (codeDoc.exists()) {
            throw new Error("Kode ini sudah ada. Silakan gunakan kode lain.");
        }

        await setDoc(codeRef, {
            status: 'unused',
            createdAt: new Date()
        });
        
        // Tambahkan ke daftar lokal untuk update UI instan
        activationCodes.value.unshift({ id: codeToCreate, status: 'unused', createdAt: new Date() });
        newActivationCode.value = ''; // Kosongkan input
        alert(`Kode aktivasi "${codeToCreate}" berhasil dibuat!`);

    } catch (error) {
        console.error("Gagal membuat kode aktivasi:", error);
        alert(`Gagal: ${error.message}`);
    } finally {
        isSaving.value = false;
    }
}

async function updateReferralCode() {
    const user = uiState.modalData.user;
    const newCode = uiState.modalData.newReferralCode.trim();

    if (!user || !newCode) {
        return alert("Kode rujukan tidak boleh kosong.");
    }
    if (newCode.length < 5) {
        return alert("Kode rujukan harus memiliki minimal 5 karakter.");
    }

    try {
        isSaving.value = true;
        const userRef = doc(db, "users", user.uid);
        await updateDoc(userRef, {
            referralCode: newCode
        });

        // Update data di state lokal agar tampilan langsung berubah
        const userInState = uiState.allUsers.find(u => u.uid === user.uid);
        if (userInState) {
            userInState.referralCode = newCode;
        }

        hideModal();
        alert(`Kode rujukan untuk ${user.email} berhasil diubah menjadi ${newCode}`);
    } catch (error) {
        console.error("Gagal mengubah kode rujukan:", error);
        alert("Terjadi kesalahan saat mengubah kode rujukan.");
    } finally {
        isSaving.value = false;
    }
}

let userListener = null; // Listener untuk data pengguna

function setupUserListener(userId) {
    // Hentikan listener lama jika ada
    if (userListener) userListener();

    const userDocRef = doc(db, 'users', userId);
    userListener = onSnapshot(userDocRef, (docSnap) => {
        if (docSnap.exists()) {
            console.log("Data profil pengguna diperbarui secara real-time.");
            // Perbarui state reaktif `userProfile` dengan data terbaru
            userProfile.data = { ...userProfile.data, ...docSnap.data() };
        }
    });
}

// --- FUNGSI MENYIMPAN PERUBAHAN MASSAL (VERSI LANGSUNG KE DB) ---
async function applyAndSaveChanges() {
    // 1. Ambil inputan user
    const newHpp = uiState.massPriceHppInput;
    // Cek apakah ada harga jual yang diisi
    const hasPriceUpdate = Object.values(uiState.massPriceInputs).some(val => val !== null && val !== '' && val !== undefined);

    // 2. Validasi
    if (filteredMassPriceVariants.value.length === 0) {
        return alert("Tidak ada produk yang cocok dengan filter.");
    }
    
    if ((newHpp === null || newHpp === '') && !hasPriceUpdate) {
        return alert("Masukkan HPP atau setidaknya satu Harga Jual baru.");
    }

    if (!confirm(`Anda akan mengubah data untuk ${filteredMassPriceVariants.value.length} varian produk secara PERMANEN. Lanjutkan?`)) {
        return;
    }

    isSaving.value = true;
    const batch = writeBatch(db); // Kita pakai Batch agar semua tersimpan sekaligus
    const userId = currentUser.value.uid;

    try {
        // 3. Loop semua varian hasil filter (Data Lengkap dari Database)
        for (const variant of filteredMassPriceVariants.value) {
            
            // --- A. UPDATE HPP (ke koleksi products) ---
            if (newHpp !== null && newHpp !== '' && newHpp >= 0) {
                const productRef = doc(db, "products", variant.docId);
                batch.update(productRef, { hpp: parseFloat(newHpp) });
                
                // Update tampilan lokal (hanya jika produknya sedang terlihat di layar)
                // Agar user melihat perubahannya tanpa refresh
                const localProd = state.produk.find(p => p.docId === variant.docId);
                if(localProd) localProd.hpp = parseFloat(newHpp);
            }

            // --- B. UPDATE HARGA JUAL (ke koleksi product_prices) ---
            for (const marketplaceId in uiState.massPriceInputs) {
                const newPrice = uiState.massPriceInputs[marketplaceId];
                
                if (newPrice !== null && newPrice !== '' && newPrice !== undefined) {
                    // ID dokumen harga formatnya: IDPRODUK-IDMARKETPLACE
                    const priceDocId = `${variant.docId}-${marketplaceId}`;
                    const priceRef = doc(db, "product_prices", priceDocId);
                    
                    // Gunakan set dengan merge:true agar membuat baru jika belum ada
                    batch.set(priceRef, {
                        product_id: variant.docId,
                        product_sku: variant.sku,
                        marketplace_id: marketplaceId,
                        price: parseFloat(newPrice),
                        userId: userId
                    }, { merge: true });

                    // Update tampilan lokal (hanya jika terlihat)
                    const localProd = state.produk.find(p => p.docId === variant.docId);
                    if(localProd) {
                        if(!localProd.hargaJual) localProd.hargaJual = {};
                        localProd.hargaJual[marketplaceId] = parseFloat(newPrice);
                    }
                }
            }
        }

        // 4. Eksekusi ke Database
        await batch.commit();
        
        alert("Berhasil memperbarui harga massal!");
        
        // Reset form
        uiState.massPriceHppInput = null;
        uiState.massPriceInputs = {};
        
        hideModal();

    } catch (error) {
        console.error("Gagal update massal:", error);
        alert(`Terjadi kesalahan: ${error.message}`);
    } finally {
        isSaving.value = false;
    }
}

async function deleteInvestor(investorId) {
    if (!confirm("Anda yakin ingin menghapus data investor ini secara permanen? Aksi ini tidak dapat dibatalkan.")) {
        return;
    }
    try {
        await deleteDoc(doc(db, "investors", investorId));
        state.investor = state.investor.filter(inv => inv.id !== investorId);
        alert("Data investor berhasil dihapus.");
    } catch (error) {
        console.error("Error menghapus investor:", error);
        alert("Gagal menghapus data investor.");
    }
}

async function verifyCashoutRequest() {
    const withdrawalId = uiState.adminVerificationIdInput.trim();
    if (!withdrawalId) {
        uiState.adminVerificationError = 'ID Pencairan tidak boleh kosong.';
        return;
    }

    uiState.isVerifying = true;
    uiState.adminVerificationResult = null;
    uiState.adminVerificationError = '';

    try {
        // PERBAIKAN: Mencari di koleksi 'commissions' dengan status 'processing'
        const q = query(
            collection(db, "commissions"), 
            where("withdrawalId", "==", withdrawalId),
            where("status", "==", "processing") // Pastikan hanya yang sedang diproses
        );

        const querySnapshot = await getDocs(q);

        if (querySnapshot.empty) {
            throw new Error(`Tidak ditemukan pengajuan yang sedang diproses dengan ID: ${withdrawalId}`);
        }

        // Hitung total dari semua komisi yang terkait dengan ID ini
        let totalAmount = 0;
        let transactionDetails = '';
        let requestDate = null;

        querySnapshot.forEach(doc => {
            const data = doc.data();
            totalAmount += data.commissionAmount;
            if (!requestDate) {
                requestDate = new Date(data.createdAt.seconds * 1000).toLocaleString('id-ID');
                transactionDetails = `Pengajuan dari: ${data.partnerEmail || data.referralCode}`;
            }
        });

        uiState.adminVerificationResult = {
            jumlah: totalAmount,
            tanggal: requestDate,
            catatan: transactionDetails
        };

    } catch (error) {
        uiState.adminVerificationError = error.message;
    } finally {
        uiState.isVerifying = false;
    }
}

async function saveMasterHargaSupplier() {
    if (isSaving.value) return;
    isSaving.value = true;

    try {
        const batch = writeBatch(db);
        
        state.produk.forEach(p => {
            const productRef = doc(db, "products", p.docId);
            // Simpan hargaBeli ke database
            batch.update(productRef, { hargaBeli: p.hargaBeli || 0 });
        });

        await batch.commit();
        alert("Katalog harga supplier berhasil diperbarui!");
        hideModal();
    } catch (error) {
        console.error("Gagal simpan harga supplier:", error);
        alert("Gagal menyimpan harga.");
    } finally {
        isSaving.value = false;
    }
}

function addProductFromSelection() {
    const selectedProduct = uiState.selectedProductForPurchase;
    if (!selectedProduct) return;

    // Cek apakah produk sudah ada di daftar
    const existingItem = uiState.penerimaanBarangForm.produk.find(
        (item) => item.sku === selectedProduct.sku
    );

    if (existingItem) {
        // Jika sudah ada, tambahkan kuantitasnya
        existingItem.qty = (existingItem.qty || 0) + 1;
    } else {
        // Jika belum ada, tambahkan produk baru ke daftar
        uiState.penerimaanBarangForm.produk.push({
            id: selectedProduct.id,
            sku: selectedProduct.sku,
            modelName: selectedProduct.nama,
            color: selectedProduct.warna,
            size: selectedProduct.varian,
            hargaJual: 0, // <-- BARIS INI YANG DIUBAH
            qty: 1,
            statusProses: 'Dalam Proses',
            statusPembayaran: 'Belum Dibayar',
            returReason: null,
        });
    }

    // Kosongkan pilihan setelah produk ditambahkan
    uiState.selectedProductForPurchase = null;
}

function showInvestorPaymentDetail(p) {
    // 'p' adalah objek data dari `filteredInvestorPayments` yang berisi semua detail
    const reportResult = {
        // Data utama
        investorName: p.investorName,
        period: p.period,
        profitSharePercentage: p.profitSharePercentage,
        investorShare: p.investorShare,
        companyShare: p.companyShare,
        paymentMethod: p.paymentMethod,
        bankDetails: p.bankDetails,
        adminFee: p.adminFee,
        totalPayment: p.totalPayment,
        
        // --- PERUBAHAN UTAMA: Meneruskan semua data detail ---
        omsetBersihPenjualan: p.omsetBersihPenjualan,
        omsetBersihDariRetur: p.omsetBersihDariRetur,
        omsetBersihFinal: p.omsetBersihFinal,
        totalHppTerjual: p.totalHppTerjual,
        totalHppRetur: p.totalHppRetur,
        hppTerjualFinal: p.hppTerjualFinal,
        labaKotor: p.labaKotor,
        biayaMarketplacePenjualan: p.biayaMarketplacePenjualan,
        biayaMarketplaceBatal: p.biayaMarketplaceBatal,
        totalBiayaTransaksi: p.totalBiayaTransaksi,
        totalBiayaOperasional: p.totalBiayaOperasional,
        labaBersih: p.labaBersihPeriode, // Menggunakan labaBersihPeriode sebagai laba bersih

        showPrintButton: true,
        showRecordButton: false 
    };
    showModal('laporanBagiHasilDetail', reportResult);
}

// FUNGSI BARU UNTUK MENGHAPUS RIWAYAT PEMBAYARAN
async function deleteInvestorPayment(paymentId) {
    if (!confirm("Anda yakin ingin menghapus riwayat pembayaran ini? Aksi ini tidak dapat dibatalkan.")) {
        return;
    }
    try {
        await deleteDoc(doc(db, "investor_payments", paymentId));
        state.investorPayments = state.investorPayments.filter(p => p.id !== paymentId);
        alert("Riwayat pembayaran berhasil dihapus.");
    } catch (error) {
        console.error("Error menghapus pembayaran investor:", error);
        alert("Gagal menghapus riwayat pembayaran.");
    }
}

function exportInvestorPayments() {
    if (state.investorPayments.length === 0) return alert("Tidak ada data untuk diekspor.");
    
    const dataToExport = state.investorPayments.map(p => ({
        "Tanggal Bayar": new Date(p.paymentDate),
        "Nama Investor": p.investorName,
        "Periode Laporan": p.period,
        "Laba Bersih Periode": p.labaBersihPeriode,
        "Persentase (%)": p.profitSharePercentage,
        "Bagian Investor (Rp)": p.investorShare,
        "Metode Bayar": p.paymentMethod,
        "Biaya Admin (Rp)": p.adminFee,
        "Total Dibayar (Rp)": p.totalPayment,
        "Bank Tujuan": p.bankDetails ? `${p.bankDetails.bankName} - ${p.bankDetails.accountNumber}` : 'N/A',
        "Atas Nama": p.bankDetails ? p.bankDetails.accountName : 'N/A'
    }));

    const worksheet = XLSX.utils.json_to_sheet(dataToExport);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Riwayat Pembayaran Investor");
    worksheet["!cols"] = Array(11).fill({ wch: 25 });
    XLSX.writeFile(workbook, `Riwayat_Pembayaran_Investor_${new Date().toISOString().split('T')[0]}.xlsx`);
}

async function submitInvestorForm(isEditing) {
    if (!currentUser.value) return alert("Anda harus login.");
    const form = uiState.modalData;

    if (!form.name || !form.amount || !form.profitShare || !form.startDate) {
        return alert("Semua kolom wajib diisi.");
    }

    const dataToSave = {
        userId: currentUser.value.uid,
        name: form.name,
        amount: form.amount,
        profitShare: form.profitShare,
        startDate: new Date(form.startDate),
        status: form.status || 'aktif', // <-- BARIS BARU
    };

    try {
        if (isEditing) {
            const investorRef = doc(db, "investors", form.id);
            await updateDoc(investorRef, dataToSave);
            const index = state.investor.findIndex(inv => inv.id === form.id);
            if (index !== -1) {
                state.investor[index] = { id: form.id, ...dataToSave };
            }
            alert('Data investor berhasil diperbarui!');
        } else {
            const investorRef = await addDoc(collection(db, "investors"), dataToSave);
            state.investor.unshift({ id: investorRef.id, ...dataToSave });
            alert('Investor baru berhasil ditambahkan!');
        }
        hideModal();
    } catch (error) {
        console.error("Error menyimpan data investor:", error);
        alert("Gagal menyimpan data investor.");
    }
}

async function toggleInvestorStatus(investor) {
    const newStatus = investor.status === 'aktif' ? 'selesai' : 'aktif';
    if (!confirm(`Anda yakin ingin mengubah status investor "${investor.name}" menjadi "${newStatus}"?`)) return;

    try {
        const investorRef = doc(db, "investors", investor.id);
        await updateDoc(investorRef, { status: newStatus });
        
        // Update state lokal
        const invInState = state.investor.find(i => i.id === investor.id);
        if (invInState) {
            invInState.status = newStatus;
        }
        alert("Status investor berhasil diperbarui!");
    } catch (error) {
        console.error("Gagal mengubah status investor:", error);
        alert("Gagal mengubah status investor.");
    }
}

async function exportAllDataForUser(
    userId,
    userEmail,
    exportFilter = uiState.exportFilter,
    exportStartDate = uiState.exportStartDate,
    exportEndDate = uiState.exportEndDate,
    exportStartMonth = uiState.exportStartMonth,
    exportEndMonth = uiState.exportEndMonth,
    exportStartYear = uiState.exportStartYear,
    exportEndYear = uiState.exportEndYear
) {
    const selectedExportUser = uiState.selectedUserForExport;

const fixedUserId = getAdminExportUserId(selectedExportUser) || userId;
const fixedUserEmail = getAdminExportUserEmail(selectedExportUser) || userEmail;

userId = fixedUserId;
userEmail = fixedUserEmail;

if (!isAdmin.value || !userId) {
    return alert("Aksi tidak diizinkan atau pelanggan belum dipilih.");
}

    let exportRange;

    try {
        exportRange = getAdminExportDateRange(
            exportFilter,
            exportStartDate,
            exportEndDate,
            exportStartMonth,
            exportEndMonth,
            exportStartYear,
            exportEndYear
        );
    } catch (error) {
        return alert(error.message);
    }

    if (!confirm(`Anda akan mengunduh data untuk ${userEmail}.\n\nPeriode: ${exportRange.label}\n\nLanjutkan?`)) {
        return;
    }

    uiState.isExportingUserData = true;

    try {
        const workbook = XLSX.utils.book_new();

        const [
            userSettingsSnap,
            productsSnap,
            productPricesSnap,
            bankAccountsSnap,
            keuanganSnap,
            transactionsSnap,
            returnsSnap,
            productionSnap,
            suppliersSnap,
            purchaseOrdersSnap,
            investorsSnap,
            investorPaymentsSnap,
            categoriesSnap
        ] = await Promise.all([
    getDocFromServer(doc(db, "settings", userId)),
    getDocsFromServer(query(collection(db, "products"), where("userId", "==", userId))),
    getDocsFromServer(query(collection(db, "product_prices"), where("userId", "==", userId))),
    getDocsFromServer(query(collection(db, "bank_accounts"), where("userId", "==", userId))),
    getDocsFromServer(query(collection(db, "keuangan"), where("userId", "==", userId))),
    getDocsFromServer(query(collection(db, "transactions"), where("userId", "==", userId))),
    getDocsFromServer(query(collection(db, "returns"), where("userId", "==", userId))),
    getDocsFromServer(query(collection(db, "production_batches"), where("userId", "==", userId))),
    getDocsFromServer(query(collection(db, "suppliers"), where("userId", "==", userId))),
    getDocsFromServer(query(collection(db, "purchase_orders"), where("userId", "==", userId))),
    getDocsFromServer(query(collection(db, "investors"), where("userId", "==", userId))),
    getDocsFromServer(query(collection(db, "investor_payments"), where("userId", "==", userId))),
    getDocsFromServer(query(collection(db, "categories"), where("userId", "==", userId)))
]);

        const userSettings = userSettingsSnap.exists()
            ? userSettingsSnap.data()
            : { marketplaces: [], modelProduk: [], categories: [], inflowCategories: [] };

        const productsRawAll = getActiveArray(snapshotToRows(productsSnap));
const bankAccountsRaw = getActiveArray(snapshotToRows(bankAccountsSnap));
const keuanganRaw = getActiveArray(snapshotToRows(keuanganSnap));
const transactionsRaw = getActiveArray(snapshotToRows(transactionsSnap));
const returnsRaw = getActiveArray(snapshotToRows(returnsSnap));
const productionRaw = getActiveArray(snapshotToRows(productionSnap));
const suppliersRaw = getActiveArray(snapshotToRows(suppliersSnap));
const purchaseOrdersRaw = getActiveArray(snapshotToRows(purchaseOrdersSnap));
const investorsRaw = getActiveArray(snapshotToRows(investorsSnap));
const investorPaymentsRaw = getActiveArray(snapshotToRows(investorPaymentsSnap));
const categoriesRaw = getActiveArray(snapshotToRows(categoriesSnap));

const activeMarketplaces = getActiveArray(userSettings.marketplaces || []);
const activeModels = getActiveArray(userSettings.modelProduk || []);
const activeCategories = getActiveArray(userSettings.categories || []);
const activeInflowCategories = getActiveArray(userSettings.inflowCategories || []);

const activeMarketplaceIds = new Set(activeMarketplaces.map(channel => channel.id).filter(Boolean));
const activeModelIds = new Set(activeModels.map(model => model.id).filter(Boolean));

const productsRaw = productsRawAll.filter(product => {
    if (!isActiveExportRecord(product)) return false;

    // Kalau produk punya model_id, pastikan modelnya masih aktif.
    // Kalau model_id kosong, tetap export karena bisa jadi data lama.
    if (product.model_id && activeModelIds.size > 0 && !activeModelIds.has(product.model_id)) {
        return false;
    }

    return true;
});

const activeProductIds = new Set();
const activeProductSkus = new Set();

productsRaw.forEach(product => {
    if (product.docId) activeProductIds.add(product.docId);
    if (product.id) activeProductIds.add(product.id);
    if (product.sku) activeProductSkus.add(product.sku);
});

// Ambil harga dari 2 jalur:
// 1. by userId
// 2. by product_id, untuk data lama yang mungkin belum punya userId
const productPricesByUser = getActiveArray(snapshotToRows(productPricesSnap));
const productPricesByProduct = await getDocsByProductIds("product_prices", [...activeProductIds], userId);
const productPricesRaw = dedupeRowsByDocId([
    ...productPricesByUser,
    ...productPricesByProduct
]).filter(price => {
    if (!isActiveExportRecord(price)) return false;

    const productId = price.product_id || '';
    const sku = price.product_sku || '';
    const marketplaceId = price.marketplace_id || '';

    const productStillExists =
        activeProductIds.has(productId) ||
        activeProductSkus.has(sku);

    const marketplaceStillExists =
    !marketplaceId ||
    activeMarketplaceIds.size === 0 ||
    activeMarketplaceIds.has(marketplaceId);

    return productStillExists && marketplaceStillExists;
});

        const marketplaceMap = {};
activeMarketplaces.forEach(channel => {
    marketplaceMap[channel.id] = channel.name;
});

const modelMap = {};
activeModels.forEach(model => {
    modelMap[model.id] = model.namaModel;
});

        const productBySku = {};
        const productById = {};

        productsRaw.forEach(product => {
            if (product.sku) productBySku[product.sku] = product;
            productById[product.docId] = product;
            if (product.id) productById[product.id] = product;
        });

        const getProductName = (sku) => {
            const product = productBySku[sku];
            return product?.product_name || product?.nama || '';
        };

        const getChannelName = (channelId, fallback = '') => {
            return marketplaceMap[channelId] || fallback || channelId || '';
        };

        // =========================
        // 00. INFO EXPORT
        // =========================
        appendExportSheet(workbook, '00 Info Export', [
            { Info: 'Nama Aplikasi', Nilai: 'Fashion OS' },
            { Info: 'Jenis Export', Nilai: 'Export Admin Developer' },
            { Info: 'Email User', Nilai: userEmail || '' },
            { Info: 'User ID', Nilai: userId },
            { Info: 'Filter Export', Nilai: exportRange.label },
            { Info: 'Tanggal Mulai Filter', Nilai: exportRange.start ? formatExportDate(exportRange.start) : 'Semua Data' },
            { Info: 'Tanggal Akhir Filter', Nilai: exportRange.end ? formatExportDate(exportRange.end) : 'Semua Data' },
            { Info: 'Dibuat Pada', Nilai: formatExportDate(new Date()) },
            { Info: 'Catatan', Nilai: 'Data transaksi, retur, keuangan, produksi, purchase order, dan pembayaran investor mengikuti filter waktu. Data master tetap lengkap agar referensi SKU, produk, channel, model, dan supplier tidak hilang.' }
        ], [24, 80]);

const marketplaceSource = currentUser.value?.uid === userId
    ? JSON.parse(JSON.stringify(state.settings.marketplaces || []))
    : JSON.parse(JSON.stringify(userSettings.marketplaces || []));

const marketplaceSourceLabel = currentUser.value?.uid === userId
    ? 'state.settings.marketplaces - data yang tampil di aplikasi'
    : `settings/${userId} - data Firestore`;

const marketplaceRows = buildMarketplaceRowsForExport(
    marketplaceSource,
    marketplaceSourceLabel
);

appendExportSheet(workbook, '01 Marketplace', marketplaceRows, [8, 45, 30, 34, 18, 24, 20, 18, 60]);
        // =========================
        // 02. MODEL PRODUK
        // =========================
        const modelRows = activeModels.map(model => ({
    'ID Model': model.id || '',
    'Nama Model': model.namaModel || '',
    'Warna Default': model.warna || '',
    'Ukuran Default': model.ukuran || '',
    'Yard Per Model': exportNumber(model.yardPerModel),
    'Harga Maklun': exportNumber(model.hargaMaklun),
    'Harga Jahit': exportNumber(model.hargaJahit)
}));

        appendExportSheet(workbook, '02 Model Produk', modelRows, [24, 30, 22, 18, 18, 18, 18]);

        // =========================
        // 03. KATEGORI BIAYA
        // =========================
        const settingCategoryRows = [
    ...activeCategories.map(category => ({
        'Sumber': 'settings.categories',
        'ID Kategori': category.id || '',
        'Nama Kategori': category.name || '',
        'Tipe': category.type || '',
        'Deskripsi': category.description || ''
    })),
    ...activeInflowCategories.map(category => ({
        'Sumber': 'settings.inflowCategories',
        'ID Kategori': category.id || '',
        'Nama Kategori': category.name || '',
        'Tipe': 'pemasukan',
        'Deskripsi': category.description || ''
    })),
    ...categoriesRaw.map(category => ({
        'Sumber': 'collection.categories',
        'ID Kategori': category.docId || '',
        'Nama Kategori': category.name || category.nama || '',
        'Tipe': category.type || '',
        'Deskripsi': category.description || ''
    }))
];

        appendExportSheet(workbook, '03 Kategori', settingCategoryRows, [28, 24, 32, 18, 50]);

        // =========================
        // 04. PRODUK MASTER
        // =========================
        const productRows = productsRaw.map(product => ({
            'ID Produk': product.docId || '',
            'SKU': product.sku || '',
            'Nama Produk': product.product_name || product.nama || '',
            'ID Model': product.model_id || '',
            'Nama Model': modelMap[product.model_id] || '',
            'Warna': product.color || product.warna || '',
            'Ukuran': product.variant || product.varian || '',
            'Stok Fisik': exportNumber(product.physical_stock ?? product.stokFisik),
            'HPP': exportNumber(product.hpp),
            'Harga Beli Supplier': exportNumber(product.hargaBeli),
            'Tanggal Dibuat': formatExportDate(product.createdAt),
            'Tanggal Update': formatExportDate(product.updatedAt)
        }));

        appendExportSheet(workbook, '04 Produk Master', productRows, [28, 24, 36, 24, 28, 18, 14, 14, 16, 18, 22, 22]);

        // =========================
        // 05. HARGA JUAL
        // =========================
        const priceRows = productPricesRaw.map(price => {
            const product = productById[price.product_id] || productBySku[price.product_sku] || {};

            return {
                'ID Harga': price.docId || '',
                'ID Produk': price.product_id || '',
                'SKU': price.product_sku || product.sku || '',
                'Nama Produk': product.product_name || product.nama || '',
                'ID Channel': price.marketplace_id || '',
                'Nama Channel': getChannelName(price.marketplace_id),
                'Harga Jual': exportNumber(price.price),
                'Tanggal Dibuat': formatExportDate(price.createdAt),
                'Tanggal Update': formatExportDate(price.updatedAt)
            };
        });

        appendExportSheet(workbook, '05 Harga Jual', priceRows, [28, 28, 22, 36, 24, 28, 18, 22, 22]);

        // =========================
        // 06. REKENING BANK
        // =========================
        const bankRows = bankAccountsRaw.map(bank => ({
            'ID Rekening': bank.docId || '',
            'Nama Bank': bank.bankName || '',
            'Nomor Rekening': bank.accountNumber || '',
            'Atas Nama': bank.accountName || '',
            'Tanggal Dibuat': formatExportDate(bank.createdAt)
        }));

        appendExportSheet(workbook, '06 Rekening Bank', bankRows, [28, 24, 28, 30, 22]);

        // =========================
        // FILTERED DATA
        // =========================
        const filteredTransactions = transactionsRaw
            .filter(trx => isInsideAdminExportRange(trx.tanggal || trx.createdAt, exportRange))
            .sort((a, b) => {
                const dateA = toExportDate(a.tanggal || a.createdAt)?.getTime() || 0;
                const dateB = toExportDate(b.tanggal || b.createdAt)?.getTime() || 0;
                return dateA - dateB;
            });

        const filteredReturns = returnsRaw
    .filter(retur => (retur.items || []).length > 0)
    .filter(retur => isInsideAdminExportRange(retur.tanggal || retur.createdAt, exportRange))
            .sort((a, b) => {
                const dateA = toExportDate(a.tanggal || a.createdAt)?.getTime() || 0;
                const dateB = toExportDate(b.tanggal || b.createdAt)?.getTime() || 0;
                return dateA - dateB;
            });

        const filteredKeuangan = keuanganRaw
            .filter(item => isInsideAdminExportRange(item.tanggal || item.createdAt, exportRange))
            .sort((a, b) => {
                const dateA = toExportDate(a.tanggal || a.createdAt)?.getTime() || 0;
                const dateB = toExportDate(b.tanggal || b.createdAt)?.getTime() || 0;
                return dateA - dateB;
            });

        const filteredProduction = productionRaw
            .filter(batch => isInsideAdminExportRange(batch.tanggal || batch.createdAt, exportRange))
            .sort((a, b) => {
                const dateA = toExportDate(a.tanggal || a.createdAt)?.getTime() || 0;
                const dateB = toExportDate(b.tanggal || b.createdAt)?.getTime() || 0;
                return dateA - dateB;
            });

        const filteredPurchaseOrders = purchaseOrdersRaw
            .filter(order => isInsideAdminExportRange(order.tanggal || order.createdAt, exportRange))
            .sort((a, b) => {
                const dateA = toExportDate(a.tanggal || a.createdAt)?.getTime() || 0;
                const dateB = toExportDate(b.tanggal || b.createdAt)?.getTime() || 0;
                return dateA - dateB;
            });

        const filteredInvestorPayments = investorPaymentsRaw
            .filter(payment => isInsideAdminExportRange(payment.paymentDate || payment.tanggal || payment.createdAt, exportRange))
            .sort((a, b) => {
                const dateA = toExportDate(a.paymentDate || a.tanggal || a.createdAt)?.getTime() || 0;
                const dateB = toExportDate(b.paymentDate || b.tanggal || b.createdAt)?.getTime() || 0;
                return dateA - dateB;
            });

        // =========================
        // 07. TRANSAKSI RINGKAS
        // =========================
        const transactionSummaryRows = filteredTransactions.map(trx => {
            const totalHpp = (trx.items || []).reduce((sum, item) => {
                return sum + (exportNumber(item.hpp) * exportNumber(item.qty));
            }, 0);

            const totalQty = (trx.items || []).reduce((sum, item) => {
                return sum + exportNumber(item.qty);
            }, 0);

            const biayaMarketplace = exportNumber(trx.biaya?.total);
            const totalAkhir = exportNumber(trx.total);
            const estimasiLaba = totalAkhir - totalHpp - biayaMarketplace;

            return {
                'ID Transaksi': trx.docId || trx.id || '',
                'ID Pesanan Marketplace': trx.marketplaceOrderId || trx.orderId || '',
                'Tanggal Transaksi': formatExportDate(trx.tanggal || trx.createdAt),
                'Tanggal Pencairan': formatExportDate(trx.tanggalPencairan),
                'Channel': trx.channel || getChannelName(trx.channelId),
                'Status Pencairan': trx.statusPencairan || '',
                'Jumlah SKU': (trx.items || []).length,
                'Total Qty': totalQty,
                'Subtotal': exportNumber(trx.subtotal),
                'Total Diskon': exportNumber(trx.diskon?.totalDiscount),
                'Total Akhir': totalAkhir,
                'Total HPP': totalHpp,
                'Biaya Marketplace': biayaMarketplace,
                'Estimasi Laba': estimasiLaba
            };
        });

        appendExportSheet(workbook, '07 Transaksi Ringkas', transactionSummaryRows, [30, 28, 22, 22, 22, 20, 14, 14, 18, 18, 18, 18, 20, 18]);

        // =========================
        // 08. TRANSAKSI DETAIL
        // =========================
        const transactionDetailRows = filteredTransactions.flatMap(trx => {
            return (trx.items || []).map((item, index) => {
                const product = productBySku[item.sku] || {};
                const qty = exportNumber(item.qty);
                const hargaJual = exportNumber(item.hargaJual);
                const hpp = exportNumber(item.hpp);

                return {
                    'ID Transaksi': trx.docId || trx.id || '',
                    'No Item': index + 1,
                    'ID Pesanan Marketplace': trx.marketplaceOrderId || trx.orderId || '',
                    'Tanggal Transaksi': formatExportDate(trx.tanggal || trx.createdAt),
                    'Channel': trx.channel || getChannelName(trx.channelId),
                    'SKU': item.sku || '',
                    'Nama Produk': product.product_name || product.nama || getProductName(item.sku),
                    'Warna': product.color || product.warna || '',
                    'Ukuran': product.variant || product.varian || '',
                    'Qty': qty,
                    'Harga Jual / Pcs': hargaJual,
                    'HPP / Pcs': hpp,
                    'Subtotal Item': hargaJual * qty,
                    'HPP Item': hpp * qty,
                    'Status Pencairan': trx.statusPencairan || ''
                };
            });
        });

        appendExportSheet(workbook, '08 Transaksi Detail', transactionDetailRows, [30, 12, 28, 22, 22, 22, 36, 18, 14, 12, 18, 18, 18, 18, 20]);

        // =========================
        // 09. RETUR DETAIL
        // =========================
        const returnRows = filteredReturns.flatMap(retur => {
            return (retur.items || []).map((item, index) => {
                const product = productBySku[item.sku] || {};

                return {
                    'ID Retur': retur.docId || retur.id || '',
                    'No Item': index + 1,
                    'Tanggal Retur': formatExportDate(retur.tanggal || retur.createdAt),
                    'ID Transaksi Asal': retur.originalTransactionId || '',
                    'Channel': getChannelName(retur.channelId),
                    'SKU': item.sku || '',
                    'Nama Produk': product.product_name || product.nama || getProductName(item.sku),
                    'Warna': product.color || product.warna || '',
                    'Ukuran': product.variant || product.varian || '',
                    'Qty Retur': exportNumber(item.qty),
                    'Nilai Retur': exportNumber(item.nilaiRetur),
                    'Nilai Diskon Retur': exportNumber(item.nilaiDiskon),
                    'Biaya Marketplace Batal': exportNumber(item.biayaMarketplace),
                    'Alasan': item.alasan || ''
                };
            });
        });

        appendExportSheet(workbook, '09 Retur Detail', returnRows, [30, 12, 22, 30, 22, 22, 36, 18, 14, 14, 18, 20, 22, 40]);

        // =========================
        // 10. KEUANGAN
        // =========================
        const financeRows = filteredKeuangan.map(item => ({
            'ID Keuangan': item.docId || item.id || '',
            'Tanggal': formatExportDate(item.tanggal || item.createdAt),
            'Jenis': item.jenis || '',
            'Kategori': item.kategori || '',
            'Jumlah': exportNumber(item.jumlah),
            'Metode Bayar': item.paymentMethod || item.metodeBayar || '',
            'Bank / Rekening': item.bankName || item.bankAccountName || '',
            'Catatan': item.catatan || ''
        }));

        appendExportSheet(workbook, '10 Keuangan', financeRows, [30, 22, 20, 30, 18, 22, 28, 50]);

        // =========================
        // 11. PRODUKSI DETAIL
        // =========================
        const productionRows = filteredProduction.flatMap(batch => {
            return (batch.kainBahan || []).map((item, index) => {
                const modelInfo = (userSettings.modelProduk || []).find(model => model.id === item.modelProdukId) || {};
                const yardPerModel = exportNumber(item.yardPermodel || item.yardPerModel || modelInfo.yardPerModel || 1);
                const totalYard = exportNumber(item.totalYard);
                const targetQty = yardPerModel > 0 ? Math.floor(totalYard / yardPerModel) : 0;
                const aktualJadi = exportNumber(item.aktualJadi);
                const aktualJadiKombinasi = exportNumber(item.aktualJadiKombinasi);
                const aktualFinal = aktualJadi + aktualJadiKombinasi;
                const selisih = aktualFinal - targetQty;
                const hargaKainPerYard = exportNumber(item.hargaKainPerYard);
                const totalBiayaKain = totalYard * hargaKainPerYard;
                const hargaJasa = batch.produksiType === 'penjahit'
                    ? exportNumber(item.hargaJahitPerPcs)
                    : exportNumber(item.hargaMaklunPerPcs);
                const totalBiayaJasa = aktualJadi * hargaJasa;
                const totalBiayaAlat = aktualFinal > 0 ? exportNumber(item.biayaAlat) : 0;
                const totalBiayaProduksi = totalBiayaKain + totalBiayaJasa + totalBiayaAlat;
                const hppFinal = aktualFinal > 0 ? totalBiayaProduksi / aktualFinal : 0;
                const hppIdeal = targetQty > 0 ? totalBiayaProduksi / targetQty : hppFinal;

                return {
                    'ID Batch': batch.docId || batch.id || '',
                    'No Item': index + 1,
                    'Tanggal Produksi': formatExportDate(batch.tanggal || batch.createdAt),
                    'Tipe Produksi': batch.produksiType || '',
                    'Nama Pekerja / Status': batch.namaStatus || batch.namastatus || batch.orangMemproses || '',
                    'Status Proses': batch.statusProses || '',
                    'Status Pembayaran': batch.statusPembayaran || '',
                    'Tanggal Pembayaran': formatExportDate(batch.tanggalPembayaran),
                    'Model Produk': modelInfo.namaModel || modelMap[item.modelProdukId] || '',
                    'SKU Hasil': item.sku || '',
                    'Nama Kain': item.namaKain || '',
                    'Toko Kain': item.tokoKain || '',
                    'Warna Kain': item.warnaKain || '',
                    'Ukuran': item.ukuran || '',
                    'Total Yard': totalYard,
                    'Yard Per Model': yardPerModel,
                    'Target Qty': targetQty,
                    'Aktual Jadi': aktualJadi,
                    'Aktual Jadi Kombinasi': aktualJadiKombinasi,
                    'Aktual Final': aktualFinal,
                    'Selisih': selisih,
                    'Harga Kain / Yard': hargaKainPerYard,
                    'Total Biaya Kain': totalBiayaKain,
                    'Harga Jasa / Pcs': hargaJasa,
                    'Total Biaya Jasa': totalBiayaJasa,
                    'Biaya Alat': totalBiayaAlat,
                    'Total Biaya Produksi': totalBiayaProduksi,
                    'HPP Ideal / Pcs': hppIdeal,
                    'HPP Final / Pcs': hppFinal,
                    'Sudah Masuk Stok': item.isInventoried ? 'Ya' : 'Belum'
                };
            });
        });

        appendExportSheet(workbook, '11 Produksi Detail', productionRows, [30, 12, 22, 18, 28, 20, 20, 22, 28, 22, 24, 24, 20, 14, 14, 16, 14, 14, 22, 14, 14, 18, 20, 18, 20, 18, 22, 18, 18, 18]);

        // =========================
        // 12. SUPPLIER
        // =========================
        const supplierRows = suppliersRaw.map(supplier => ({
            'ID Supplier': supplier.docId || supplier.id || '',
            'Nama Supplier': supplier.name || supplier.nama || '',
            'Kontak': supplier.contact || supplier.kontak || '',
            'Alamat': supplier.address || supplier.alamat || '',
            'Catatan': supplier.notes || supplier.catatan || '',
            'Tanggal Dibuat': formatExportDate(supplier.createdAt)
        }));

        appendExportSheet(workbook, '12 Supplier', supplierRows, [30, 30, 24, 45, 45, 22]);

        // =========================
        // 13. PURCHASE ORDER DETAIL
        // =========================
        const purchaseOrderRows = filteredPurchaseOrders.flatMap(order => {
            return (order.produk || order.items || []).map((item, index) => {
                const qty = exportNumber(item.qty);
                const hargaBeli = exportNumber(item.hargaBeli || item.price || item.harga);

                return {
                    'ID Purchase Order': order.docId || order.id || '',
                    'No Item': index + 1,
                    'Tanggal': formatExportDate(order.tanggal || order.createdAt),
                    'ID Supplier': order.supplierId || '',
                    'Nama Supplier': order.supplierName || '',
                    'SKU': item.sku || '',
                    'Nama Produk': item.modelName || item.productName || item.nama || '',
                    'Warna': item.color || item.warna || '',
                    'Ukuran': item.size || item.ukuran || '',
                    'Qty': qty,
                    'Harga Beli / Pcs': hargaBeli,
                    'Subtotal': qty * hargaBeli,
                    'Status Proses Item': item.statusProses || order.statusProses || '',
                    'Status Pembayaran Item': item.statusPembayaran || '',
                    'Status Pembayaran PO': order.statusPembayaran || '',
                    'Dibayarkan': exportNumber(order.dibayarkan),
                    'Total Qty PO': exportNumber(order.totalQtyValue),
                    'Catatan': order.catatan || ''
                };
            });
        });

        appendExportSheet(workbook, '13 Purchase Order', purchaseOrderRows, [30, 12, 22, 26, 30, 22, 36, 18, 14, 12, 18, 18, 22, 24, 24, 18, 16, 45]);

        // =========================
        // 14. INVESTOR
        // =========================
        const investorRows = investorsRaw.map(investor => ({
            'ID Investor': investor.docId || investor.id || '',
            'Nama Investor': investor.name || '',
            'Nominal Investasi': exportNumber(investor.amount),
            'Bagi Hasil (%)': exportNumber(investor.profitShare),
            'Tanggal Mulai': formatExportDate(investor.startDate, false),
            'Status': investor.status || '',
            'Tanggal Dibuat': formatExportDate(investor.createdAt)
        }));

        appendExportSheet(workbook, '14 Investor', investorRows, [30, 30, 20, 18, 18, 16, 22]);

        // =========================
        // 15. PEMBAYARAN INVESTOR
        // =========================
        const investorPaymentRows = filteredInvestorPayments.map(payment => ({
            'ID Pembayaran': payment.docId || payment.id || '',
            'Tanggal Bayar': formatExportDate(payment.paymentDate || payment.tanggal || payment.createdAt),
            'Nama Investor': payment.investorName || '',
            'Periode Laporan': payment.period || '',
            'Laba Bersih Periode': exportNumber(payment.labaBersihPeriode),
            'Persentase Bagi Hasil (%)': exportNumber(payment.profitSharePercentage),
            'Bagian Investor': exportNumber(payment.investorShare),
            'Bagian Perusahaan': exportNumber(payment.companyShare),
            'Metode Bayar': payment.paymentMethod || '',
            'Biaya Admin': exportNumber(payment.adminFee),
            'Total Dibayar': exportNumber(payment.totalPayment),
            'Bank Tujuan': payment.bankDetails?.bankName || '',
            'Nomor Rekening': payment.bankDetails?.accountNumber || '',
            'Atas Nama': payment.bankDetails?.accountName || ''
        }));

        appendExportSheet(workbook, '15 Bayar Investor', investorPaymentRows, [30, 22, 30, 22, 22, 24, 20, 20, 18, 18, 18, 24, 28, 30]);

        // =========================
        // 16. RINGKASAN PERIODE
        // =========================
        const totalOmset = transactionSummaryRows.reduce((sum, row) => sum + exportNumber(row['Total Akhir']), 0);
        const totalSubtotal = transactionSummaryRows.reduce((sum, row) => sum + exportNumber(row['Subtotal']), 0);
        const totalDiskon = transactionSummaryRows.reduce((sum, row) => sum + exportNumber(row['Total Diskon']), 0);
        const totalHpp = transactionSummaryRows.reduce((sum, row) => sum + exportNumber(row['Total HPP']), 0);
        const totalBiayaMarketplace = transactionSummaryRows.reduce((sum, row) => sum + exportNumber(row['Biaya Marketplace']), 0);
        const totalNilaiRetur = returnRows.reduce((sum, row) => sum + exportNumber(row['Nilai Retur']), 0);
        const totalKeuanganMasuk = financeRows
            .filter(row => String(row['Jenis']).includes('pemasukan'))
            .reduce((sum, row) => sum + exportNumber(row['Jumlah']), 0);
        const totalKeuanganKeluar = financeRows
            .filter(row => String(row['Jenis']).includes('pengeluaran') || String(row['Jenis']).includes('biaya'))
            .reduce((sum, row) => sum + exportNumber(row['Jumlah']), 0);

        appendExportSheet(workbook, '16 Ringkasan Periode', [
            { Metrik: 'Periode Export', Nilai: exportRange.label },
            { Metrik: 'Jumlah Transaksi', Nilai: transactionSummaryRows.length },
            { Metrik: 'Jumlah Item Transaksi', Nilai: transactionDetailRows.length },
            { Metrik: 'Jumlah Retur Item', Nilai: returnRows.length },
            { Metrik: 'Jumlah Data Keuangan', Nilai: financeRows.length },
            { Metrik: 'Jumlah Batch Produksi', Nilai: filteredProduction.length },
            { Metrik: 'Jumlah Item Produksi', Nilai: productionRows.length },
            { Metrik: 'Jumlah Purchase Order Item', Nilai: purchaseOrderRows.length },
            { Metrik: 'Total Subtotal Transaksi', Nilai: totalSubtotal },
            { Metrik: 'Total Diskon', Nilai: totalDiskon },
            { Metrik: 'Total Omset Bersih Transaksi', Nilai: totalOmset },
            { Metrik: 'Total HPP Transaksi', Nilai: totalHpp },
            { Metrik: 'Total Biaya Marketplace', Nilai: totalBiayaMarketplace },
            { Metrik: 'Total Nilai Retur', Nilai: totalNilaiRetur },
            { Metrik: 'Total Pemasukan Lain', Nilai: totalKeuanganMasuk },
            { Metrik: 'Total Pengeluaran / Biaya', Nilai: totalKeuanganKeluar },
            { Metrik: 'Estimasi Laba Sebelum Pengeluaran Operasional', Nilai: totalOmset - totalHpp - totalBiayaMarketplace - totalNilaiRetur }
        ], [42, 28]);

const rejectedRows = [];

productsRawAll.forEach(product => {
    if (!productsRaw.find(activeProduct => activeProduct.docId === product.docId)) {
        rejectedRows.push({
            'Tipe Data': 'Produk',
            'ID': product.docId || product.id || '',
            'Alasan Tidak Diexport': 'Produk tidak aktif / model produk sudah tidak aktif / terhapus',
            'Nama / SKU': product.product_name || product.nama || product.sku || ''
        });
    }
});

productPricesByUser.forEach(price => {
    const productId = price.product_id || '';
    const sku = price.product_sku || '';
    const marketplaceId = price.marketplace_id || '';

    const productStillExists = activeProductIds.has(productId) || activeProductSkus.has(sku);
    const marketplaceStillExists = !marketplaceId || activeMarketplaceIds.has(marketplaceId);

    if (!productStillExists || !marketplaceStillExists || !isActiveExportRecord(price)) {
        rejectedRows.push({
            'Tipe Data': 'Harga Jual',
            'ID': price.docId || price.id || '',
            'Alasan Tidak Diexport': !productStillExists
                ? 'Produk sudah tidak ada / orphan price'
                : (!marketplaceStillExists ? 'Channel marketplace sudah tidak ada' : 'Data harga tidak aktif / terhapus'),
            'Nama / SKU': sku || productId || ''
        });
    }
});

returnsRaw.forEach(retur => {
    if (!retur.items || retur.items.length === 0) {
        rejectedRows.push({
            'Tipe Data': 'Retur',
            'ID': retur.docId || retur.id || '',
            'Alasan Tidak Diexport': 'Retur tidak punya item',
            'Nama / SKU': retur.originalTransactionId || ''
        });
    }
});

appendExportSheet(workbook, '99 Data Dibuang', rejectedRows, [22, 32, 60, 36]);

        const safeEmail = String(userEmail || 'user')
            .replace(/[^a-zA-Z0-9@._-]/g, '_')
            .substring(0, 80);

        const safePeriod = String(exportRange.label)
            .replace(/[^a-zA-Z0-9_-]/g, '_')
            .substring(0, 40);

        const fileName = `Fashion_OS_Admin_Export_${safeEmail}_${safePeriod}_${new Date().toISOString().split('T')[0]}.xlsx`;

        XLSX.writeFile(workbook, fileName, { cellDates: true });

        alert('Data berhasil diekspor dengan format rapi.');

    } catch (error) {
        console.error("Gagal mengekspor data pelanggan:", error);
        alert("Terjadi kesalahan saat mengekspor data: " + error.message);
    } finally {
        uiState.isExportingUserData = false;
    }
}

const filteredVoucherNotes = computed(() => {
    let filtered = state.voucherNotes;
    
    // Filter berdasarkan tipe (model/channel)
    if (uiState.notesFilterType !== 'all') {
        filtered = filtered.filter(note => note.type === uiState.notesFilterType);
    }

    // Filter berdasarkan model produk
    if (uiState.notesFilterModel) {
        filtered = filtered.filter(note => note.modelName === uiState.notesFilterModel);
    }

    // Filter berdasarkan channel
    if (uiState.notesFilterChannel) {
        filtered = filtered.filter(note => note.channelId === uiState.notesFilterChannel);
    }

    // Filter berdasarkan pencarian
    const searchQuery = uiState.notesSearch.toLowerCase();
    if (searchQuery) {
        filtered = filtered.filter(note =>
            note.title.toLowerCase().includes(searchQuery) ||
            note.modelName?.toLowerCase().includes(searchQuery) ||
            note.channelName?.toLowerCase().includes(searchQuery) ||
            note.voucherType.toLowerCase().includes(searchQuery) // BARIS BARU UNTUK PENCARIAN
        );
    }
    
    // Filter berdasarkan jenis voucher yang dipilih di form Tambah Catatan
    if (uiState.notesData.voucherType) {
        filtered = filtered.filter(note => note.voucherType === uiState.notesData.voucherType);
    }

    // Mengurutkan berdasarkan tanggal berakhir (semakin dekat, semakin di atas)
    return filtered.sort((a, b) => {
        if (uiState.notesSortBy === 'endDate-asc') {
            return a.endDate.getTime() - b.endDate.getTime();
        }
        // Tambahkan logika pengurutan lain jika diperlukan
        return 0;
    });
});



const monthlyPrice = ref(350000);
const yearlyPrice = ref(4200000);
const discountedMonthlyPrice = ref(250000);
const discountedYearlyPrice = ref(2500000);

async function submitAddProduct() {
    const form = uiState.modalData;
    const hppValue = Number(form.hpp);
    if (!form.sku || !form.nama || !form.modelId || !form.warna || !form.varian) {
        alert('SKU, Nama, Model produk, Warna, dan Varian wajib diisi.');
        return;
    }
    if (!Number.isFinite(hppValue) || hppValue <= 0) {
        alert('Masukkan HPP/modal per pcs lebih dari Rp0.');
        return;
    }

    const skuFormatted = form.sku.toUpperCase().replace(/\s+/g, '-');
    const userId = currentUser.value.uid;

    try {
        const productsCollection = collection(db, "products");
        const q = query(productsCollection, where("sku", "==", skuFormatted), where("userId", "==", userId));
        const querySnapshot = await getDocs(q);

        if (!querySnapshot.empty) {
            throw new Error(`Produk dengan SKU "${skuFormatted}" sudah terdaftar untuk akun Anda.`);
        }

        const newProductRef = doc(collection(db, "products"));

        const productData = {
            id: newProductRef.id,
            product_name: form.nama,
            model_id: form.modelId,
            color: form.warna || '',
            variant: form.varian || '',
            physical_stock: 0,
            hpp: hppValue,
            userId: userId,
            sku: skuFormatted
        };

        const batch = writeBatch(db);
        batch.set(newProductRef, productData);

        state.settings.marketplaces.forEach(channel => {
            const priceDocId = `${newProductRef.id}-${channel.id}`;
            const priceRef = doc(db, "product_prices", priceDocId);
            batch.set(priceRef, {
                product_id: newProductRef.id,
                product_sku: skuFormatted,
                marketplace_id: channel.id,
                price: 0,
                userId: userId
            });
        });

        await batch.commit();

        // --- PERBAIKAN DIMULAI DI SINI ---

        // Buat objek produk baru untuk ditambahkan ke state lokal
        const newProductObject = {
            docId: newProductRef.id,
            sku: productData.sku,
            nama: productData.product_name,
            model_id: productData.model_id,
            warna: productData.color,
            varian: productData.variant,
            stokFisik: productData.physical_stock,
            hpp: productData.hpp,
            hargaJual: {},
            stokAlokasi: {},
            userId: productData.userId
        };

        // 1. Tambahkan ke state utama (untuk halaman HPP, Promosi, dll)
        state.produk.push(newProductObject);
        
        // 2. Tambahkan juga ke state tampilan inventaris agar UI langsung update
        state.inventoryPaginated.push(newProductObject);

        // --- AKHIR PERBAIKAN ---

        alert(`Produk "${form.nama}" berhasil ditambahkan!`);
        hideModal();

    } catch (error) {
        console.error('Error menyimpan produk:', error);
        alert(`Gagal menyimpan produk: ${error.message}`);
    }
}


const laporanKeuanganData = computed(() => {
    const year = Number(uiState.laporanKeuanganTahun);
    const transactions = state.transaksi || [];
    const records = state.keuangan || [];
    const asDate = value => value?.toDate ? value.toDate() : value instanceof Date ? value : value?.seconds ? new Date(value.seconds * 1000) : value ? new Date(value) : null;
    const channelKey = item => String(item.channelId || item.channel || '').trim().toLowerCase();
    const statusOf = tx => String(tx.statusPencairan || '').trim().toLowerCase().replace(/\s+/g, '');
    const hppOf = tx => Number(tx.totalHpp) || (tx.items || []).reduce((sum, item) => sum + (Number(item.hpp) || 0) * (Number(item.qty) || 0), 0);
    const months = [];
    for (let month = 1; month <= 12; month++) {
        const monthName = new Date(year, month - 1, 1).toLocaleString('id-ID', { month: 'long' });
        const inMonth = date => date && date.getFullYear() === year && date.getMonth() + 1 === month;
        const payoutRecords = records.filter(record => record.isMarketplaceIncomeReport === true && inMonth(asDate(record.periodeSelesai || record.tanggal)));
        const payoutChannels = new Set(payoutRecords.map(channelKey));
        const periodTransactions = transactions.filter(tx => inMonth(asDate(tx.tanggalPencairan || tx.tanggalTerkirim || tx.tanggal || tx.createdAt)));
        const confirmed = periodTransactions.filter(tx => statusOf(tx) === 'sudahcair' || tx.konfirmasiSuksesCairManual || String(tx.statusDataMarketplace || '').trim().toLowerCase() === 'cocok');
        const aggregatePayout = payoutRecords.reduce((sum, record) => sum + (Number(record.jumlah ?? record.amount ?? record.nominal) || 0), 0);
        const perOrderIncome = confirmed.reduce((sum, tx) => {
            if (tx.konfirmasiSuksesCairManual || payoutChannels.has(channelKey(tx))) return sum;
            return sum + (Number(tx.penghasilanBersihMarketplace) || (Object.prototype.hasOwnProperty.call(tx, 'statusDataMarketplace') ? 0 : Math.max(0, (Number(tx.total) || 0) - (Number(tx.biaya?.total ?? tx.totalBiaya) || 0))));
        }, 0);
        const payoutAmount = aggregatePayout + perOrderIncome;
        const soldHpp = confirmed.reduce((sum, tx) => sum + hppOf(tx), 0);
        const transactionFees = confirmed.reduce((sum, tx) => sum + (Number(tx.biaya?.total ?? tx.totalBiaya) || 0), 0);
        const expenses = records.filter(record => inMonth(asDate(record.tanggal)) && (record.jenis === 'pengeluaran' || record.jenis === 'biaya'));
        const profitDistributions = records.filter(record =>
            record.isProfitDistribution === true &&
            Number(record.periodeLabaTahun || asDate(record.tanggal)?.getFullYear()) === year &&
            Number(record.periodeLabaBulan || (asDate(record.tanggal)?.getMonth() + 1)) === month
        );
        const distributedProfit = profitDistributions.reduce((sum, record) => sum + (Number(record.jumlah) || 0), 0);
        const productionCosts = expenses.filter(record => (record.tipeBiaya || getExpenseTypeByCategory(record.kategori)) === 'produksi').reduce((sum, record) => sum + (Number(record.jumlah) || 0), 0);
        const operatingCosts = expenses.filter(record => (record.tipeBiaya || getExpenseTypeByCategory(record.kategori)) !== 'produksi').reduce((sum, record) => sum + (Number(record.jumlah) || 0), 0);
        const isCoveredByPayout = (tx, record) => {
            if (channelKey(record) !== channelKey(tx)) return false;
            const date = asDate(tx.tanggalPencairan || tx.tanggalTerkirim || tx.tanggal || tx.createdAt);
            const dateKey = date ? date.getFullYear() + '-' + String(date.getMonth() + 1).padStart(2, '0') + '-' + String(date.getDate()).padStart(2, '0') : '';
            const start = String(record.periodeMulai || '').slice(0, 10);
            const end = String(record.periodeSelesai || '').slice(0, 10);
            return !!dateKey && !!start && !!end && dateKey >= start && dateKey <= end;
        };
        const missingSummary = periodTransactions.some(tx =>
            tx.konfirmasiSuksesCairManual && !payoutRecords.some(record => isCoveredByPayout(tx, record))
        );
        const netProfit = missingSummary ? null : payoutAmount - soldHpp - transactionFees - operatingCosts;
        months.push({monthName,payoutAmount,soldHpp,transactionFees,productionCosts,operatingCosts,distributedProfit,netProfit,undistributedProfit:netProfit===null?null:netProfit-distributedProfit,missingSummary});
    }
    const yearlyTotals = {
        payoutAmount: months.reduce((sum,item)=>sum+item.payoutAmount,0),
        soldHpp: months.reduce((sum,item)=>sum+item.soldHpp,0),
        transactionFees: months.reduce((sum,item)=>sum+item.transactionFees,0),
        productionCosts: months.reduce((sum,item)=>sum+item.productionCosts,0),
        operatingCosts: months.reduce((sum,item)=>sum+item.operatingCosts,0),
        netProfit: months.some(item=>item.missingSummary)?null:months.reduce((sum,item)=>sum+item.netProfit,0),
        missingSummary: months.some(item=>item.missingSummary),
        distributedProfit: months.reduce((sum,item)=>sum+item.distributedProfit,0),
        undistributedProfit: months.some(item=>item.missingSummary)?null:months.reduce((sum,item)=>sum+item.undistributedProfit,0)
    };
    return {months,yearlyTotals};
});

const profitDistributionForm = reactive({
    month: new Date().getMonth() + 1,
    recipient: '',
    amount: null,
    message: '',
    error: ''
});
const isSavingProfitDistribution = ref(false);

async function saveProfitDistribution() {
    if (isSavingProfitDistribution.value) return;
    profitDistributionForm.error = '';
    profitDistributionForm.message = '';
    const amount = Math.round(Number(profitDistributionForm.amount) || 0);
    const selectedMonth = Number(profitDistributionForm.month) - 1;
    const available = laporanKeuanganData.value.months[selectedMonth]?.undistributedProfit;
    if (!currentUser.value?.uid) {
        profitDistributionForm.error = 'Silakan masuk kembali sebelum mencatat pembagian laba.';
        return;
    }
    if (!profitDistributionForm.recipient || amount <= 0) {
        profitDistributionForm.error = 'Isi nama penerima dan jumlah yang benar-benar dibayarkan.';
        return;
    }
    if (available === null || available <= 0) {
        profitDistributionForm.error = 'Laba belum bisa dibagikan karena laporan belum lengkap atau periode masih rugi.';
        return;
    }
    if (amount > available) {
        profitDistributionForm.error = 'Jumlah melebihi laba yang belum dibagikan pada bulan tersebut.';
        return;
    }
    isSavingProfitDistribution.value = true;
    try {
        const record = {
            userId: currentUser.value.uid,
            jenis: 'pembagian_laba',
            kategori: 'Pembagian Laba',
            jumlah: amount,
            tanggal: new Date(),
            penerima: profitDistributionForm.recipient.trim(),
            periodeLabaTahun: Number(uiState.laporanKeuanganTahun),
            periodeLabaBulan: Number(profitDistributionForm.month),
            isProfitDistribution: true,
            status: 'aktif',
            catatan: 'Pembagian laba yang benar-benar dibayarkan sesuai kesepakatan pemilik usaha dan pemodal.'
        };
        const docRef = await firestoreAddDoc(collection(db, 'keuangan'), record);
        state.keuangan.unshift({ id: docRef.id, ...record });
        invalidateModuleCache('finance');
        profitDistributionForm.message = 'Pembagian laba tersimpan. Laba usaha tetap sama; saldo laba belum dibagikan sudah dikurangi.';
        profitDistributionForm.recipient = '';
        profitDistributionForm.amount = null;
    } catch (error) {
        profitDistributionForm.error = error?.message || 'Pembagian laba gagal disimpan.';
    } finally {
        isSavingProfitDistribution.value = false;
    }
}

const laporanTransaksiData = computed(() => {
    const year = Number(uiState.laporanTransaksiTahun);
    const all = state.transaksi || [];
    const asDate = value => value?.toDate ? value.toDate() : value instanceof Date ? value : value?.seconds ? new Date(value.seconds * 1000) : value ? new Date(value) : null;
    const qtyOf = tx => (tx.items || []).reduce((sum, item) => sum + (Number(item.qty) || 0), 0);
    const hppOf = tx => Number(tx.totalHpp) || (tx.items || []).reduce((sum, item) => sum + (Number(item.hpp) || 0) * (Number(item.qty) || 0), 0);
    const statusOf = tx => String(tx.statusPencairan || '').trim().toLowerCase().replace(/\s+/g, '');
    const months = [];
    for (let month=1; month<=12; month++) {
        const monthName = new Date(year,month-1,1).toLocaleString('id-ID',{month:'long'});
        const rows = all.filter(tx => { const date=asDate(tx.tanggalTerkirim||tx.tanggal||tx.createdAt); return date&&date.getFullYear()===year&&date.getMonth()+1===month; });
        const successful = rows.filter(tx => statusOf(tx)==='sudahcair' || ['cocok','id_sukses_terkonfirmasi'].includes(String(tx.statusDataMarketplace||'').toLowerCase()));
        const pending = rows.filter(tx => !['sudahcair','retur/pengembalian','retur','baranghilang'].includes(statusOf(tx)));
        months.push({monthName,totalOrders:rows.length,totalQty:rows.reduce((sum,tx)=>sum+qtyOf(tx),0),totalHpp:rows.reduce((sum,tx)=>sum+hppOf(tx),0),successfulOrders:successful.length,pendingOrders:pending.length});
    }
    const yearlyTotals={totalOrders:months.reduce((sum,item)=>sum+item.totalOrders,0),totalQty:months.reduce((sum,item)=>sum+item.totalQty,0),totalHpp:months.reduce((sum,item)=>sum+item.totalHpp,0),successfulOrders:months.reduce((sum,item)=>sum+item.successfulOrders,0),pendingOrders:months.reduce((sum,item)=>sum+item.pendingOrders,0)};
    return {months,yearlyTotals};
});

const roasResults = computed(() => {
    const { hargaJual, modalProduk, biayaPacking, biayaAdminMarketplace } = uiState.roasCalculator;

    if (!hargaJual || hargaJual <= 0) {
        return { error: "Harga Jual harus diisi." };
    }

    // --- PERBAIKAN RUMUS DI SINI ---
    // Biaya Admin sekarang ditambahkan langsung sebagai angka Rupiah
    const totalBiayaProduk = (modalProduk || 0) + (biayaPacking || 0) + (biayaAdminMarketplace || 0);
    const profitKotor = hargaJual - totalBiayaProduk;

    if (profitKotor <= 0) {
        return {
            totalBiayaProduk,
            profitKotor,
            error: "Harga Jual lebih rendah dari total biaya, tidak mungkin profit."
        };
    }

    const breakEvenROAS = hargaJual / profitKotor;

    const targets = [10, 15, 20, 25, 30].map(marginPercent => {
        const targetProfit = hargaJual * (marginPercent / 100);
        const maxBiayaIklanPerOrder = profitKotor - targetProfit;
        if (maxBiayaIklanPerOrder <= 0) {
            return { margin: marginPercent, roas: Infinity };
        }
        return {
            margin: marginPercent,
            roas: hargaJual / maxBiayaIklanPerOrder
        };
    });

    return {
        totalBiayaProduk,
        profitKotor,
        profitMargin: (profitKotor / hargaJual) * 100,
        breakEvenROAS,
        targets,
    };
});

const roasSimulationResults = computed(() => {
    const results = roasResults.value;
    const { estimasiBiayaIklan, hargaJual, customRoasTarget } = uiState.roasCalculator;

    if (!hargaJual || hargaJual <= 0 || !estimasiBiayaIklan || estimasiBiayaIklan <= 0 || results.error) {
        // Jika input belum lengkap, kembalikan array kosong
        return [
            { scenario: 'Skenario Impas (BEP)', targetRoas: 'N/A', estimasiOrder: 0, estimasiOmset: 0, estimasiLabaBersih: 0 },
            { scenario: 'Skenario Target Profit 20%', targetRoas: 'N/A', estimasiOrder: 0, estimasiOmset: 0, estimasiLabaBersih: 0 },
            { scenario: 'Skenario Kustom', targetRoas: customRoasTarget || 0, estimasiOrder: 0, estimasiOmset: 0, estimasiLabaBersih: 0 },
        ];
    }

    const calculateScenario = (scenarioName, roasTarget) => {
        if (!isFinite(roasTarget) || roasTarget <= 0) {
            return { scenario: scenarioName, targetRoas: 'N/A', estimasiOrder: 0, estimasiOmset: 0, estimasiLabaBersih: 0 };
        }
        
        // Rumus inti yang sudah benar
        const estimasiOmset = estimasiBiayaIklan * roasTarget;
        const estimasiOrder = hargaJual > 0 ? estimasiOmset / hargaJual : 0;
        const estimasiProfitKotor = estimasiOrder * results.profitKotor;
        const estimasiLabaBersih = estimasiProfitKotor - estimasiBiayaIklan;

        return {
            scenario: scenarioName,
            targetRoas: roasTarget,
            estimasiOrder,
            estimasiOmset,
            estimasiLabaBersih,
        };
    };

    // Cari target ROAS untuk 20% dari hasil perhitungan yang sudah benar
    const targetRoas20Percent = results.targets.find(t => t.margin === 20)?.roas || 0;

    return [
        calculateScenario('Skenario Impas (BEP)', results.breakEvenROAS),
        calculateScenario('Skenario Target Profit 20%', targetRoas20Percent),
        calculateScenario('Skenario Kustom', customRoasTarget || 0),
    ];
});

async function addSupplier() {
    if (!currentUser.value) return alert("Anda harus login.");
    const form = uiState.modalData;
    if (!form.name) return alert("Nama supplier tidak boleh kosong.");
    
    const dataToSave = { ...form, userId: currentUser.value.uid, products: [] };
    
    try {
        const docRef = await addDoc(collection(db, "suppliers"), dataToSave);
        state.suppliers.push({ id: docRef.id, ...dataToSave });
        hideModal();
        alert('Supplier baru berhasil ditambahkan!');
    } catch (error) {
        console.error("Gagal menambah supplier:", error);
        alert("Gagal menambah supplier. Silakan coba lagi.");
    }
}

async function updateSupplier() {
    if (!currentUser.value) return alert("Anda harus login.");
    const form = uiState.modalData;
    
    try {
        const supplierRef = doc(db, "suppliers", form.id);
        await updateDoc(supplierRef, { name: form.name, contact: form.contact });
        
        const index = state.suppliers.findIndex(s => s.id === form.id);
        if (index !== -1) {
            state.suppliers[index].name = form.name;
            state.suppliers[index].contact = form.contact;
        }
        
        hideModal();
        alert('Data supplier berhasil diperbarui!');
    } catch (error) {
        console.error("Gagal memperbarui supplier:", error);
        alert("Gagal memperbarui supplier. Silakan coba lagi.");
    }
}

async function deleteSupplier(supplierId) {
    if (!confirm("Anda yakin ingin menghapus supplier ini? Semua data produknya juga akan terhapus.")) {
        return;
    }
    
    try {
        await deleteDoc(doc(db, "suppliers", supplierId));
        state.suppliers = state.suppliers.filter(s => s.id !== supplierId);
        alert("Supplier berhasil dihapus.");
    } catch (error) {
        console.error("Gagal menghapus supplier:", error);
        alert("Gagal menghapus supplier. Silakan coba lagi.");
    }
}

async function addSupplierPayment() {
    if (!currentUser.value) return alert("Anda harus login.");
    
    const form = uiState.newPaymentData;
    const order = uiState.modalData;

    if (!form.amount || form.amount <= 0 || !form.date || !form.method) {
        return alert("Jumlah, tanggal, dan metode pembayaran wajib diisi.");
    }

    isSaving.value = true;
    try {
        const batch = writeBatch(db);
        const orderRef = doc(db, "purchase_orders", order.id);

        // Siapkan data pembayaran baru
        const newPayment = {
            amount: form.amount,
            date: new Date(form.date),
            method: form.method,
            notes: form.notes || ''
        };

        // Update data di pesanan
        const newPaymentHistory = [...(order.paymentHistory || []), newPayment];
        const newTotalPaid = newPaymentHistory.reduce((sum, p) => sum + p.amount, 0);
        
        let newStatus = 'Cicilan';
        if (newTotalPaid >= order.totalQtyValue) {
            newStatus = 'Lunas';
        }

        batch.update(orderRef, {
            paymentHistory: newPaymentHistory,
            dibayarkan: newTotalPaid,
            statusPembayaran: newStatus
        });

        // Buat catatan pengeluaran baru di 'keuangan'
        const expenseRef = doc(collection(db, "keuangan"));
        const expenseData = {
            tanggal: new Date(form.date),
            jenis: 'pengeluaran',
            kategori: 'Pembayaran Supplier',
            jumlah: form.amount,
            catatan: `Pembayaran untuk PO #${order.id.slice(-6)} ke ${order.supplierName}. Metode: ${form.method}.`,
            userId: currentUser.value.uid
        };
        batch.set(expenseRef, expenseData);

        await batch.commit();

        // Update state lokal
        const orderInState = state.purchaseOrders.find(o => o.id === order.id);
        if (orderInState) {
            orderInState.paymentHistory = newPaymentHistory;
            orderInState.dibayarkan = newTotalPaid;
            orderInState.statusPembayaran = newStatus;
        }
        state.keuangan.push({ id: expenseRef.id, ...expenseData });

        alert('Pembayaran berhasil dicatat!');
        hideModal();

    } catch (error) {
        console.error("Gagal menambah pembayaran:", error);
        alert("Gagal menambah pembayaran. Silakan coba lagi.");
    } finally {
        isSaving.value = false;
    }
}

const searchCatalogQuery = ref(''); // Teks pencarian di modal

// Fungsi untuk memfilter produk berdasarkan SKU atau Nama Model
const filteredCatalog = computed(() => {
    if (!searchCatalogQuery.value) return state.produk;
    const query = searchCatalogQuery.value.toLowerCase();
    return state.produk.filter(p => 
        p.sku.toLowerCase().includes(query) || 
        (p.namaModel && p.namaModel.toLowerCase().includes(query))
    );
});

async function addPurchaseOrderItemToInventory(item) {
    // 1. CEK KUNCI (Cegah double click saat lag)
    if (isSaving.value) return;

    if (!currentUser.value) return alert("Anda harus login.");

    // 2. CEK STATUS ITEM
    if (item.isInventoried) {
        return; 
    }

    if (!confirm(`Masukan ${item.qty} pcs ke inventaris?`)) {
        return;
    }

    const productInState = state.produk.find(p => p.sku === item.sku);
    if (!productInState) {
        return alert(`Error: Produk SKU ${item.sku} tidak ditemukan.`);
    }

    const qtyToAdd = parseInt(item.qty, 10) || 0;
    if (qtyToAdd <= 0) return alert("Jumlah barang 0.");

    // KUNCI TOMBOL DETIK INI JUGA
    isSaving.value = true;

    try {
        const batch = writeBatch(db);
        
        // Gunakan INCREMENT (Server Google yang hitung)
        const productRef = doc(db, "products", productInState.docId);
        batch.update(productRef, { physical_stock: increment(qtyToAdd) });

        const orderRef = doc(db, "purchase_orders", item.orderId);
        const orderInState = state.purchaseOrders.find(o => o.id === item.orderId);
        
        // Siapkan update status item di dalam pesanan
        const updatedProdukItems = JSON.parse(JSON.stringify(orderInState.produk));
        const itemIndex = updatedProdukItems.findIndex(p => 
            p.sku === item.sku && 
            p.hargaJual === item.hargaJual && 
            p.qty === item.qty && 
            !p.isInventoried
        );
        
        if (itemIndex !== -1) {
            updatedProdukItems[itemIndex].isInventoried = true;
            batch.update(orderRef, { produk: updatedProdukItems });
            
            // EKSEKUSI KE DATABASE
            await batch.commit();

            // --- UPDATE TAMPILAN (Agar terasa cepat) ---
            productInState.stokFisik = (productInState.stokFisik || 0) + qtyToAdd;
            
            const invItem = state.inventoryPaginated.find(p => p.docId === productInState.docId);
            if (invItem) invItem.stokFisik = (invItem.stokFisik || 0) + qtyToAdd;

            // Update item spesifik di tampilan agar tombol hilang
            const originalItemInOrder = orderInState.produk[itemIndex]; 
            if (originalItemInOrder) {
                originalItemInOrder.isInventoried = true;
            }
            // Update juga view item yang sedang dirender
            item.isInventoried = true;

            alert('Berhasil! Stok masuk.');
        } else {
             throw new Error("Item tidak ditemukan atau sudah diproses.");
        }

    } catch (error) {
        console.error("Gagal update stok:", error);
        alert(`Gagal: ${error.message}`);
    } finally {
        // BUKA KUNCI
        isSaving.value = false;
    }
}

async function deletePurchaseOrder(orderId) {
    if (!confirm("Anda yakin ingin menghapus riwayat penerimaan barang ini? Aksi ini tidak dapat dibatalkan.")) {
        return;
    }

    try {
        await deleteDoc(doc(db, "purchase_orders", orderId));
        state.purchaseOrders = state.purchaseOrders.filter(order => order.id !== orderId);
        alert("Riwayat penerimaan barang berhasil dihapus.");
    } catch (error) {
        console.error("Gagal menghapus riwayat penerimaan barang:", error);
        alert("Gagal menghapus riwayat penerimaan barang. Silakan coba lagi.");
    }
}

function showEditPenerimaanBarangForm(order) {
    // Salin data pesanan yang dipilih ke formulir untuk diedit
    uiState.penerimaanBarangForm = JSON.parse(JSON.stringify(order));
    uiState.activeSupplierView = 'form';
}

function showPenerimaanBarangForm(supplier) {
    uiState.penerimaanBarangForm = {
    supplierId: supplier.id,
    supplierName: supplier.name,
    tanggal: new Date().toISOString().split('T')[0],
    produk: [],
    statusProses: 'Dalam Proses',
    statusPembayaran: 'Belum Dibayar',
    dibayarkan: 0, // <-- TAMBAHKAN INI
    tanggalPembayaran: '', // <-- TAMBAHKAN INI
    catatan: '',
};
    uiState.selectedProductForPurchase = null; // <-- TAMBAHKAN BARIS INI
    uiState.activeSupplierView = 'form';
}



function removeProductFromPenerimaanBarang(index) {
    uiState.penerimaanBarangForm.produk.splice(index, 1);
}

function hidePenerimaanBarangForm() {
    if (confirm('Yakin ingin membatalkan? Semua data yang belum disimpan akan hilang.')) {
        uiState.activeSupplierView = 'list';
    }
}

async function submitPenerimaanBarang() {
    if (!currentUser.value) return alert("Anda harus login.");
    const form = uiState.penerimaanBarangForm;
    
    // Perbaikan: Validasi tambahan
    if (form.produk.length === 0) {
        return alert("Daftar produk tidak boleh kosong.");
    }
    for (const p of form.produk) {
        if (!p.sku || p.qty === null || p.qty === undefined || p.hargaJual === null || p.hargaJual === undefined) {
            return alert("Setiap produk harus memiliki SKU, Harga Jual, dan Kuantitas yang valid.");
        }
    }

    // Perbaikan: Tentukan status pembayaran order secara keseluruhan
    let totalTagihan = form.produk.reduce((sum, p) => sum + (p.hargaJual || 0) * (p.qty || 0), 0);
let sudahDibayar = form.dibayarkan || 0;
let orderPaymentStatus = 'Belum Dibayar';

if (sudahDibayar > 0 && sudahDibayar < totalTagihan) {
    orderPaymentStatus = 'Cicilan';
} else if (sudahDibayar >= totalTagihan && totalTagihan > 0) {
    orderPaymentStatus = 'Lunas';
}

    let totalQtyValue = form.produk.reduce((sum, p) => sum + (p.hargaJual || 0) * (p.qty || 0), 0);
    
    // Perbaikan: Buat objek data secara eksplisit
    const dataToSave = {
        userId: currentUser.value.uid,
        supplierId: form.supplierId || null,
        supplierName: form.supplierName || 'N/A',
        tanggal: new Date(form.tanggal),
        produk: form.produk.map(p => ({
            id: p.id || null, 
            sku: p.sku || '',
            modelName: p.modelName || '',
            color: p.color || '',
            size: p.size || '',
            hargaJual: p.hargaJual || 0,
            qty: p.qty || 0,
            statusProses: p.statusProses || 'Dalam Proses',
            statusPembayaran: p.statusPembayaran || 'Belum Dibayar', // Simpan status per produk
            returReason: p.returReason || null,
        })),
        dibayarkan: form.dibayarkan || 0, // Simpan total yang sudah dibayarkan
        statusPembayaran: orderPaymentStatus, // Simpan status keseluruhan
        catatan: form.catatan || '',
        totalQtyValue,
        createdAt: new Date(),
    };

    try {
        let docRef;
        if (form.id) {
            const docToUpdate = doc(db, "purchase_orders", form.id);
            await updateDoc(docToUpdate, dataToSave);
            const index = state.purchaseOrders.findIndex(order => order.id === form.id);
            if (index !== -1) {
                state.purchaseOrders[index] = { id: form.id, ...dataToSave, tanggal: dataToSave.tanggal };
            }
            alert(`Pesanan berhasil diperbarui.`);
        } else {
            docRef = await addDoc(collection(db, "purchase_orders"), dataToSave);
            state.purchaseOrders.unshift({ id: docRef.id, ...dataToSave, tanggal: dataToSave.tanggal });
            alert(`Penerimaan barang berhasil dicatat dengan ID: ${docRef.id}`);
        }
        uiState.activeSupplierView = 'list';
    } catch (error) {
        console.error("Gagal menyimpan penerimaan barang:", error);
        alert(`Gagal menyimpan penerimaan barang. Detail: ${error.message}`);
    }
}

async function handleCashoutRequest() {
    const amountToWithdraw = totalUnpaidCommission.value;
    if (amountToWithdraw <= 0) return;
    const withdrawalId = `WDRW-${Date.now()}`;
    if (!confirm(`Anda akan mengajukan pencairan sebesar ${formatCurrency(amountToWithdraw)}. Lanjutkan?`)) return;

    isSaving.value = true;
    try {
        const idToken = await auth.currentUser.getIdToken(true);
        const response = await fetch('/api/request-cashout', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${idToken}` },
            body: JSON.stringify({
                amountToWithdraw: amountToWithdraw,
                withdrawalId: withdrawalId,
                // --- PERBAIKAN DI SINI ---
                // Mengambil kode rujukan dari userProfile.data, bukan currentUser
                referralCode: userProfile.data.referralCode 
            })
        });
        const data = await response.json();
        if (!response.ok) throw new Error(data.message || 'Error server.');

        // UI akan update otomatis via onSnapshot, cukup beri notif
        alert('Permintaan pencairan Anda telah berhasil diajukan dan sedang diproses.');

    } catch (error) {
        console.error('Error saat mencairkan komisi:', error);
        alert(`Gagal mengajukan pencairan: ${error.message}`);
    } finally {
        isSaving.value = false;
    }
}

async function proceedToPartnerPayment() {
    if (!currentUser.value) {
        return alert("Anda harus login.");
    }

    try {
        const priceToPay = 50000;
        const itemName = 'Biaya Pendaftaran Mitra Fashion OS';

        const response = await fetch('/api/create-mayar-invoice', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                amount: priceToPay,
                item_name: itemName,
                customer_email: currentUser.value.email,
                callback_url: 'https://appfashion.id/api/mayar-webhook',
                redirect_url: `https://appfashion.id/langganan?status=success`,
                merchant_ref: `PARTNERREG-${currentUser.value.uid}-${Date.now()}-${Math.floor(Math.random() * 10000)}`,
            }),
        });

        const data = await response.json();
        if (data.invoice_url) {
            window.location.href = data.invoice_url;
        } else {
            throw new Error('Gagal mendapatkan URL pembayaran dari Mayar.');
        }
    } catch (error) {
        console.error("Gagal memproses pendaftaran mitra:", error);
        alert(`Gagal memproses pendaftaran. Silakan coba lagi.\n\nError: ${error.message}`);
    }
}

// eslint-disable-next-line no-unused-vars

function handlePosSubmit() {
    if (uiState.pos_order_id) {
        alert("Selesaikan transaksi saat ini terlebih dahulu!");
        uiState.pos_scan_input = '';
        return;
    }
    const scannedValue = uiState.pos_scan_input.trim();
    if (!scannedValue) return;

    const product = getProductBySku(scannedValue);

    if (product) {
        addProductToCart(product);
    } else if (activeCart.value.length > 0) {
        // Jika BUKAN produk DAN keranjang sudah terisi, anggap ini ID Pesanan
        uiState.pos_order_id = scannedValue;
    } else {
        alert(`SKU "${scannedValue}" tidak ditemukan.`);
    }
    
    uiState.posSearchRecommendations = [];
    uiState.pos_scan_input = '';
}


// PASTIKAN FUNGSI INI ADA (dari panduan sebelumnya)
function handlePosSearch() {
  const query = uiState.pos_scan_input.trim().toLowerCase();
  if (query.length < 2) {
    uiState.posSearchRecommendations = [];
    return;
  }
  // Menghapus .slice(0, 5) agar menampilkan semua hasil
  uiState.posSearchRecommendations = state.produk
    .filter(p => `${p.sku} ${p.nama}`.toLowerCase().includes(query));
}

// PASTIKAN FUNGSI INI ADA (dari panduan sebelumnya)
// eslint-disable-next-line no-unused-vars
function selectPosRecommendation(product) {
    if (uiState.pos_order_id) {
        alert("Selesaikan transaksi saat ini terlebih dahulu!");
        return;
    }
    addProductToCart(product);
    uiState.pos_scan_input = '';
    uiState.posSearchRecommendations = [];
}

function handleBulkManualSearch() {
  clearTimeout(bulkSearchDebounceTimer);
  const query = uiState.bulk_manual_input.trim().toLowerCase();
  if (query.length < 2) {
    uiState.bulk_recommendations = [];
    return;
  }
  bulkSearchDebounceTimer = setTimeout(() => {
    const filteredProducts = state.produk
      .filter(p => `${p.sku} ${p.nama}`.toLowerCase().includes(query));
    
    const recommendationsWithModel = filteredProducts.map(p => {
      const model = state.settings.modelProduk.find(m => m.id === p.model_id);
      return {
        ...p,
        modelNama: model ? model.namaModel : 'N/A'
      };
    });

    // Menghapus .slice(0, 5) agar menampilkan semua hasil
    uiState.bulk_recommendations = recommendationsWithModel;
  }, 200);
}

// FUNGSI INTI UNTUK MENAMBAHKAN PRODUK KE ANTRIAN SEMENTARA
function addProductToBulkQueue(product) {
    if (!uiState.activeCartChannel) return alert("Pilih Channel Penjualan dulu.");
    
    // Bagian ini penting untuk mendefinisikan 'currentOrder'
    let currentOrder = uiState.bulk_order_queue.find(o => o.id.startsWith('TEMP-'));
    if (!currentOrder) {
        currentOrder = {
            id: `TEMP-${Date.now()}`,
            marketplaceOrderId: 'MENUNGGU RESI...',
            items: [],
            status: 'Sedang Diisi'
        };
        uiState.bulk_order_queue.unshift(currentOrder);
    }

    const specialPrice = state.specialPrices[uiState.activeCartChannel]?.[product.sku];
    const regularPrice = product.hargaJual?.[uiState.activeCartChannel] ?? 0;
    const finalPrice = specialPrice !== undefined ? specialPrice : regularPrice;
    
    // Logika komisi baru yang sudah kita tambahkan sebelumnya
    const commissionRate = product.commissions?.[uiState.activeCartChannel] || 0;

    const existingItem = currentOrder.items.find(item => item.sku === product.sku);
    if (existingItem) {
        existingItem.qty++;
        // Pastikan komisi juga di-update jika produk yang sama di-scan lagi
        existingItem.commissionRate = commissionRate;
    } else {
        // Menambahkan item baru lengkap dengan harga dan komisinya
        currentOrder.items.push({ ...product, qty: 1, hargaJualAktual: finalPrice, commissionRate: commissionRate });
    }
}

// FUNGSI SAAT MENG-KLIK REKOMENDASI MANUAL
function selectBulkRecommendation(product) {
    addProductToBulkQueue(product);
    uiState.bulk_manual_input = '';
    uiState.bulk_recommendations = [];
}

function updateBulkQueueItemQty(sku, delta) {
    const tempOrder = uiState.bulk_order_queue.find(o => o.id.startsWith('TEMP-'));
    if (!tempOrder) return;

    const item = tempOrder.items.find(i => i.sku === sku);
    if (!item) return;

    item.qty += delta;

    if (item.qty <= 0) {
        // Jika kuantitas menjadi 0, hapus item dari antrian
        removeBulkQueueItem(sku);
    }
}

function removeBulkQueueItem(sku) {
    const tempOrder = uiState.bulk_order_queue.find(o => o.id.startsWith('TEMP-'));
    if (!tempOrder) return;

    const itemIndex = tempOrder.items.findIndex(i => i.sku === sku);
    if (itemIndex > -1) {
        tempOrder.items.splice(itemIndex, 1);
    }
}


// FUNGSI UNTUK TOMBOL MANUAL "JADIKAN ID PESANAN"
function finalizeManualOrder() {
    const marketplaceOrderId = uiState.bulk_manual_input.trim();
    if (!marketplaceOrderId) {
        return alert("Ketik ID Pesanan di kolom input terlebih dahulu.");
    }
    
    let orderToFinalize = uiState.bulk_order_queue.find(o => o.id.startsWith('TEMP-'));
    
    if (orderToFinalize) {
        orderToFinalize.id = marketplaceOrderId;
        orderToFinalize.marketplaceOrderId = marketplaceOrderId;
        orderToFinalize.status = 'Mengantri';
        uiState.bulk_manual_input = ''; // Kosongkan input
        // Baris alert sudah dihapus dari sini
    } else {
        alert("Tidak ada produk dalam daftar untuk difinalisasi. Tambahkan produk terlebih dahulu.");
    }
}

function deleteQueuedOrder(index) {
    if (confirm("Anda yakin ingin menghapus pesanan ini dari antrian?")) {
        uiState.bulk_order_queue.splice(index, 1);
    }
}


// FUNGSI FINAL UNTUK MEMPROSES SEMUA PESANAN DI ANTRIAN
async function processBatchOrders() {
    const ordersToProcess = [...uiState.bulk_order_queue];
    if (ordersToProcess.length === 0) {
        return alert("Tidak ada pesanan di antrian untuk diproses.");
    }
    if (!confirm(`Anda akan memproses ${ordersToProcess.length} pesanan... Lanjutkan?`)) return;

    uiState.is_processing_scan = true;
    const marketplace = getMarketplaceById(uiState.activeCartChannel);
    let successCount = 0;
    const batch = writeBatch(db);
    
    try {
    const newTransactions = [];

    // Satu identitas untuk satu kali proses massal
    const bulkBatchId = `BULK-${Date.now()}`;

    // Waktu dasar untuk menjaga urutan transaksi
    const bulkBaseTime = Date.now();

    for (
        let orderIndex = 0;
        orderIndex < ordersToProcess.length;
        orderIndex++
    ) {
        const order = ordersToProcess[orderIndex];
            const items = order.items.map(item => ({
    sku: item.sku || '',
    nama: item.nama || item.product_name || '',
    qty: Number(item.qty) || 0,
    hpp: Number(item.hpp) || 0,
    model_id: item.model_id || item.modelId || '',
    warna: item.warna || item.color || '',
    varian: item.varian || item.variant || ''
}));

const totalHpp = items.reduce(
    (sum, item) => sum + (item.hpp * item.qty),
    0
);

const newTransactionData = {
    marketplaceOrderId: order.marketplaceOrderId || '',
    tanggal: new Date(bulkBaseTime - orderIndex),
    bulkBatchId,
    bulkSequence: orderIndex + 1,
    inputSource: 'bulk_process',
    items,
    totalHpp,
    statusDataMarketplace: 'menunggu_data',
    penghasilanBersihMarketplace: null,
    channel: marketplace.name,
    channelId: uiState.activeCartChannel,
    statusPencairan: 'Belum Cair',
    userId: currentUser.value.uid
};

            const transactionRef = doc(collection(db, "transactions"));
            batch.set(transactionRef, newTransactionData);
            newTransactions.push({ ...newTransactionData, id: transactionRef.id });

            // --- PERBAIKANN STOK SUPAYA TIDAK NGACO (PAKAI INCREMENT) ---
            for (const item of order.items) {
                const productRef = doc(db, "products", item.docId);
                batch.update(productRef, { physical_stock: increment(-item.qty) });
            }
            // -----------------------------------------------------------
            
            successCount++;
        }
        
        await batch.commit();

        state.transaksi.unshift(...newTransactions);
        // Transaksi belum cair baru selalu langsung masuk ke Dana Gantung.
const pendingTransactionIds =
    new Set(
        (
            state.pendingSettlements ||
            []
        ).map(transaction =>
            transaction.id
        )
    );

state.pendingSettlements.unshift(
    ...newTransactions.filter(
        transaction =>
            !pendingTransactionIds.has(
                transaction.id
            )
    )
);

newTransactions.forEach(
    transaction =>
        applyDashboardSummaryV2TransactionDelta(
            null,
            transaction
        )
);
        // Update tampilan stok lokal
        ordersToProcess.forEach(order => {
            order.items.forEach(item => {
                const productInState = state.produk.find(p => p.docId === item.docId);
                if (productInState) {
                    productInState.stokFisik -= item.qty;
                }
                const invItem = state.inventoryPaginated.find(p => p.docId === item.docId);
                if (invItem) invItem.stokFisik -= item.qty;
            });
        });

        alert(`Proses Selesai! ${successCount} pesanan berhasil diproses.`);
        uiState.bulk_order_queue = [];
    } catch (error) {
        alert(`Terjadi kesalahan: ${error.message}. Tidak ada pesanan yang diproses.`);
    } finally {
        uiState.is_processing_scan = false;
    }
}

function handleMarketplaceImportCompleted(payload) {
    const upsertById = (list, item) => {
        const index = (list || []).findIndex(entry => entry.id === item.id);
        if (index >= 0) list[index] = { ...list[index], ...item };
        else list.unshift(item);
    };
    const financeRecords = [
        ...(payload?.keuanganRecord ? [payload.keuanganRecord] : []),
        ...(payload?.keuanganRecords || [])
    ];
    financeRecords.forEach(record => {
        if (!Array.isArray(state.keuangan)) state.keuangan = [];
        upsertById(state.keuangan, record);
        upsertById(dashboardPeriodData.finance, record);
        if (isDateToday(record.tanggal)) upsertById(dashboardTodayData.finance, record);
    });
    const importedTransactions = payload?.transactions || [];
    if (!importedTransactions.length) return;

    importedTransactions.forEach(transaction => {
        const transactionIndex = (state.transaksi || []).findIndex(item => item.id === transaction.id);
        const previousTransaction = transactionIndex >= 0 ? state.transaksi[transactionIndex] : null;
        if (previousTransaction) {
            state.transaksi[transactionIndex] = transaction;
        } else {
            state.transaksi.unshift(transaction);
        }
        upsertById(dashboardPeriodData.transactions, transaction);
        if (isDateToday(transaction.tanggal)) upsertById(dashboardTodayData.transactions, transaction);

        applyDashboardSummaryV2TransactionDelta(
            previousTransaction,
            transaction
        );

        const settlementStatus = String(transaction.statusPencairan || '').trim().toLowerCase();
        const isPendingSettlement = !settlementStatus ||
            settlementStatus === 'belum cair' ||
            settlementStatus === 'waiting';
        const pendingIndex = (state.pendingSettlements || []).findIndex(item => item.id === transaction.id);
        if (isPendingSettlement) {
            if (pendingIndex >= 0) state.pendingSettlements[pendingIndex] = transaction;
            else state.pendingSettlements.unshift(transaction);
        } else if (pendingIndex >= 0) {
            state.pendingSettlements.splice(pendingIndex, 1);
        }
    });

    if (!payload.financeUpdate && payload.stockDeltas) {
        Object.entries(payload.stockDeltas).forEach(([productId, quantity]) => {
            const product = (state.produk || []).find(item => (item.docId || item.id) === productId);
            const paginatedProduct = (state.inventoryPaginated || []).find(item => (item.docId || item.id) === productId);
            if (product) {
                product.stokFisik = (Number(product.stokFisik ?? product.physical_stock) || 0) - Number(quantity || 0);
                product.physical_stock = product.stokFisik;
            }
            if (paginatedProduct) {
                paginatedProduct.stokFisik = (Number(paginatedProduct.stokFisik ?? paginatedProduct.physical_stock) || 0) - Number(quantity || 0);
                paginatedProduct.physical_stock = paginatedProduct.stokFisik;
            }
        });
    }

    invalidateModuleCache('transactions');
}

function showNotesModal() {
    // Reset semua state terkait modal sebelum menampilkan yang baru
    uiState.modalData = {};
    uiState.isModalVisible = true;
    
    // Tunda eksekusi sampai DOM diperbarui
    nextTick(() => {
        uiState.modalType = 'notesModal';
        // Reset form data setiap kali modal dibuka
        uiState.notesData = {
            type: 'model', // default
            voucherType: '',
            title: '',
            endDate: new Date().toISOString().split('T')[0],
            endHour: '23',
            endMinute: '59',
            modelName: '',
            channelId: ''
        };
    });
}

function handleReturSearch() {
    const query = uiState.modalData.transactionIdSearch.trim().toLowerCase();
    if (query.length < 2) {
        uiState.returSearchRecommendations = [];
        return;
    }
    // Cari berdasarkan ID Pesanan Marketplace atau ID internal
    uiState.returSearchRecommendations = state.transaksi.filter(t =>
        (t.marketplaceOrderId && t.marketplaceOrderId.toLowerCase().includes(query)) ||
        (t.id && t.id.toLowerCase().includes(query))
    );
}

function selectReturRecommendation(trx) {
    uiState.modalData.transactionIdSearch = trx.marketplaceOrderId || trx.id;
    uiState.returSearchRecommendations = [];
    // Langsung jalankan fungsi pencarian transaksi setelah memilih
    findTransactionForReturn();
}

async function submitVoucherNote() {
    if (!currentUser.value) return alert("Anda harus login.");
    const form = uiState.notesData;

    if (!form.title || !form.endDate || !form.channelId || !form.voucherType) {
        return alert("Semua kolom wajib diisi.");
    }

    if (form.type === 'model' && !form.modelName) {
        return alert("Nama model produk wajib diisi.");
    }

    const endDateTime = new Date(`${form.endDate}T${form.endHour}:${form.endMinute}:00`);

    const dataToSave = {
        title: form.title,
        type: form.type,
        voucherType: form.voucherType,
        modelName: form.modelName || null,
        channelId: form.channelId,
        channelName: state.settings.marketplaces.find(c => c.id === form.channelId)?.name || 'N/A',
        endDate: endDateTime,
        createdAt: new Date(),
        userId: currentUser.value.uid,
    };

    try {
        const docRef = await addDoc(collection(db, "voucher_notes"), dataToSave);
        state.voucherNotes.push({ id: docRef.id, ...dataToSave, endDate: dataToSave.endDate });
        alert("Catatan voucher berhasil disimpan!");

        // --- PERUBAHAN UTAMA DI SINI ---
        // Baris hideModal() dihapus dan diganti dengan kode untuk mereset form
        uiState.notesData.title = '';
        uiState.notesData.endDate = new Date().toISOString().split('T')[0];
        uiState.notesData.endHour = '23';
        uiState.notesData.endMinute = '59';
        uiState.notesData.modelName = '';
        uiState.notesData.channelId = '';
        uiState.notesData.voucherType = '';
        uiState.notesData.type = 'model'; // Kembali ke default
        // --- AKHIR PERUBAHAN ---

    } catch (error) {
        console.error("Gagal menyimpan catatan:", error);
        alert("Gagal menyimpan catatan. Silakan coba lagi.");
    }
}

async function deleteVoucherNote(noteId) {
    if (!confirm("Anda yakin ingin menghapus catatan ini?")) return;
    try {
        await deleteDoc(doc(db, "voucher_notes", noteId));
        state.voucherNotes = state.voucherNotes.filter(note => note.id !== noteId);
        alert("Catatan berhasil dihapus.");
    } catch (error) {
        console.error("Gagal menghapus catatan:", error);
        alert("Gagal menghapus catatan.");
    }
}

async function findTransactionForReturn() {
    const orderId = uiState.modalData.transactionIdSearch.trim();
    
    if (!orderId) {
        return alert("Silakan scan resi atau masukkan ID Pesanan Marketplace.");
    }

    // 1. CARI DI DATA LOKAL (State) DULU
    let foundTrx = state.transaksi.find(t => 
        t.marketplaceOrderId && t.marketplaceOrderId.toLowerCase() === orderId.toLowerCase()
    );

    // 2. JIKA TIDAK KETEMU DI LOKAL, CARI LANGSUNG KE FIREBASE
    if (!foundTrx) {
        try {
            // Tampilkan indikator loading (opsional, tapi bagus untuk UX)
            // uiState.isLoading = true; 

            const q = query(
                collection(db, "transactions"),
                where("userId", "==", currentUser.value.uid),
                where("marketplaceOrderId", "==", orderId) // Pencarian persis (Case sensitive biasanya)
            );

            const querySnapshot = await getDocs(q);

            if (!querySnapshot.empty) {
                const docSnap = querySnapshot.docs[0];
                // Format datanya agar sama dengan format di state
                foundTrx = { 
                    id: docSnap.id, 
                    ...docSnap.data(), 
                    tanggal: docSnap.data().tanggal?.toDate ? docSnap.data().tanggal.toDate() : new Date(docSnap.data().tanggal)
                };
            }
        } catch (error) {
            console.error("Error mencari transaksi di database:", error);
        } finally {
            // uiState.isLoading = false;
        }
    }

    // 3. PROSES HASIL PENCARIAN
    if (foundTrx) {
        uiState.modalData.foundTransaction = foundTrx;
        
        // Reset items agar bersih
        uiState.modalData.items = foundTrx.items.map(item => ({
            ...item,
            returnQty: item.qty, // Default retur qty sama dengan qty beli
            selected: true,      // Default tercentang
            alasan: '',
            tindakLanjut: 'Ganti Baru'
        }));
        
        // Opsional: Beri notifikasi kecil bahwa data ditemukan
        // alert("Transaksi ditemukan!"); 
    } else {
        alert("Transaksi dengan ID Pesanan tersebut tidak ditemukan (baik di riwayat lokal maupun database).");
        uiState.modalData.foundTransaction = null;
        uiState.modalData.items = [];
    }
}

async function handleSubscriptionMayar(plan) {
    if (!currentUser.value) {
        alert("Silakan login terlebih dahulu.");
        return;
    }

    let isSubscribingPlan = plan === 'bulanan' ? isSubscribingMonthly : isSubscribingYearly;
    if (isSubscribingPlan.value) {
        return;
    }
    isSubscribingPlan.value = true;

    // Logika untuk memeriksa apakah ada kode rujukan yang aktif
    const referredByCode = uiState.referralCodeApplied ? uiState.referralCodeInput : (currentUser.value?.userData?.referredBy || null);

    // --- AWAL PERBAIKAN UTAMA ---
    // Tentukan harga yang akan dibayar berdasarkan status kode rujukan
    let priceToPay;
    if (referredByCode) {
        // Jika ada kode rujukan, gunakan harga diskon
        priceToPay = plan === 'bulanan' ? discountedMonthlyPrice.value : discountedYearlyPrice.value;
    } else {
        // Jika tidak ada, gunakan harga normal
        priceToPay = plan === 'bulanan' ? monthlyPrice.value : yearlyPrice.value;
    }
    // --- AKHIR PERBAIKAN UTAMA ---

    try {
        if (referredByCode) {
            const pendingCommissionRef = doc(db, 'pending_commissions', currentUser.value.email);
            await setDoc(pendingCommissionRef, {
                referredByCode: referredByCode,
                timestamp: new Date(),
            }, { merge: true });
            console.log(`INFO: Data referral untuk ${currentUser.value.email} disimpan di Firestore.`);
        }

        const response = await fetch('/api/create-mayar-invoice', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                amount: priceToPay, // <-- Menggunakan variabel harga yang sudah benar
                item_name: `Langganan Fashion OS - Paket ${plan === 'bulanan' ? 'Bulanan' : 'Tahunan'}`,
                customer_email: currentUser.value.email,
                callback_url: 'https://appfashion.id/api/mayar-webhook',
                redirect_url: `https://appfashion.id/langganan?status=success`,
                merchant_ref: `FASHIONOS-${currentUser.value.uid}-${Date.now()}-${plan}`,
            }),
        });

        const data = await response.json();
        if (!response.ok) {
            throw new Error(data.message || `Mayar API Error: ${response.status}`);
        }
        if (data.invoice_url) {
            window.location.href = data.invoice_url;
        } else {
            throw new Error('Gagal mendapatkan URL pembayaran dari Mayar.');
        }
    } catch (error) {
        console.error("Gagal memproses langganan Mayar:", error);
        alert(`Gagal memproses langganan. Silakan coba lagi.\n\nError: ${error.message}`);
    } finally {
        isSubscribingPlan.value = false;
    }
}

const voucherTokoMinBelanjaComputed = (channel) => computed({
    get() { 
        const promo = state.promotions.perChannel[channel.id]?.voucherToko;
        return promo?.minBelanja ? 'Rp ' + formatInputNumber(promo.minBelanja) : '';
    },
    set(newValue) {
        if (!state.promotions.perChannel[channel.id]) state.promotions.perChannel[channel.id] = {};
        if (!state.promotions.perChannel[channel.id].voucherToko || typeof state.promotions.perChannel[channel.id].voucherToko !== 'object') {
            state.promotions.perChannel[channel.id].voucherToko = {};
        }
        state.promotions.perChannel[channel.id].voucherToko.minBelanja = parseInputNumber(newValue);
    }
});

const voucherSemuaProdukMinBelanjaComputed = (channel) => computed({
    get() { 
        const promo = state.promotions.perChannel[channel.id]?.voucherSemuaProduk;
        return promo?.minBelanja ? 'Rp ' + formatInputNumber(promo.minBelanja) : '';
    },
    set(newValue) {
        if (!state.promotions.perChannel[channel.id]) state.promotions.perChannel[channel.id] = {};
        if (!state.promotions.perChannel[channel.id].voucherSemuaProduk || typeof state.promotions.perChannel[channel.id].voucherSemuaProduk !== 'object') {
            state.promotions.perChannel[channel.id].voucherSemuaProduk = {};
        }
        state.promotions.perChannel[channel.id].voucherSemuaProduk.minBelanja = parseInputNumber(newValue);
    }
});

const diskonMinBelanjaComputed = (modelName, channelId) => computed({
    get() { 
        return state.promotions.perModel[modelName]?.[channelId]?.minBelanja ? 'Rp ' + formatInputNumber(state.promotions.perModel[modelName][channelId].minBelanja) : '';
    },
    set(newValue) {
        if (!state.promotions.perModel[modelName]) {
            state.promotions.perModel[modelName] = {};
        }
        if (!state.promotions.perModel[modelName][channelId]) {
            state.promotions.perModel[modelName][channelId] = {};
        }
        state.promotions.perModel[modelName][channelId].minBelanja = parseInputNumber(newValue);
    }
});

const tieredMinComputed = (tier) => computed({
    get() { return tier.min ? 'Rp ' + formatInputNumber(tier.min) : ''; },
    set(newValue) { tier.min = parseInputNumber(newValue) || 0; }
});


async function saveChannelPromotions(channelId) {
    if (!currentUser.value) return alert("Anda harus login.");
    isSaving.value = true;
    try {
        const userId = currentUser.value.uid;
        const promotionsRef = doc(db, "promotions", userId);
        const channelPromoData = state.promotions.perChannel[channelId];

        // Hanya update data untuk channel yang spesifik ini
        await updateDoc(promotionsRef, {
            [`perChannel.${channelId}`]: JSON.parse(JSON.stringify(channelPromoData))
        });

        alert(`Pengaturan voucher untuk channel ini berhasil disimpan!`);
    } catch (error) {
        console.error("Gagal menyimpan promosi channel:", error);
        alert("Gagal menyimpan promosi channel.");
    } finally {
        isSaving.value = false;
    }
}

async function saveModelPromotions(modelName, channelId) {
    if (!currentUser.value) return alert("Anda harus login.");
    isSaving.value = true;
    try {
        const userId = currentUser.value.uid;
        const promotionsRef = doc(db, "promotions", userId);
        const modelPromoData = state.promotions.perModel[modelName]?.[channelId];

        if (modelPromoData) {
            // Hanya update data untuk model dan channel yang spesifik ini
            await updateDoc(promotionsRef, {
                [`perModel.${modelName}.${channelId}`]: JSON.parse(JSON.stringify(modelPromoData))
            });
            alert(`Promosi untuk model ${modelName} di channel ini berhasil disimpan!`);
        } else {
            alert('Tidak ada perubahan untuk disimpan.');
        }
    } catch (error) {
        console.error("Gagal menyimpan promosi model:", error);
        alert("Gagal menyimpan promosi model.");
    } finally {
        isSaving.value = false;
    }
}

async function applyReferralCode() {
    if (currentUser.value?.userData?.referredBy) {
        uiState.referralCodeMessage = "Anda sudah memiliki diskon rujukan.";
        return;
    }
    if (!uiState.referralCodeInput) {
        uiState.referralCodeMessage = "Kode rujukan tidak boleh kosong.";
        uiState.referralCodeApplied = false;
        return;
    }

    try {
        const usersCollection = collection(db, "users");
        const q = query(usersCollection, where("referralCode", "==", uiState.referralCodeInput));
        const querySnapshot = await getDocs(q);

        if (!querySnapshot.empty) {
            const partnerDoc = querySnapshot.docs[0];
            if (partnerDoc.data().isPartner) {
                uiState.referralCodeApplied = true;
                uiState.referralCodeMessage = "Kode rujukan berhasil diterapkan! Harga paket akan disesuaikan.";
            } else {
                uiState.referralCodeMessage = "Kode rujukan tidak valid atau bukan milik mitra.";
                uiState.referralCodeApplied = false;
            }
        } else {
            uiState.referralCodeMessage = "Kode rujukan tidak valid atau tidak ditemukan.";
            uiState.referralCodeApplied = false;
        }
    } catch (error) {
        console.error("Error applying referral code:", error);
        uiState.referralCodeMessage = "Terjadi kesalahan saat memvalidasi kode.";
        uiState.referralCodeApplied = false;
    }
}


async function addCategory() {
    if (!currentUser.value) return alert("Anda harus login.");
    const form = uiState.nestedModalData;
    if (!form.name) return alert("Nama kategori tidak boleh kosong.");

    const newCategory = {
    id: `CAT-${Date.now()}`,
    name: form.name,
    description: form.description || '',
    type: form.type || 'operasional',
    userId: currentUser.value.uid,
};
    try {
        const categoryRef = doc(db, "categories", newCategory.id);
        await setDoc(categoryRef, newCategory);

        // Langsung tambahkan kategori baru ke state lokal
        state.settings.categories.push(newCategory);

        alert('Kategori baru berhasil ditambahkan.');
        hideNestedModal();
    } catch (error) {
        console.error("Gagal menambahkan kategori:", error);
        alert("Gagal menambahkan kategori. Silakan coba lagi.");
    }
}

async function updateCategory() {
    if (!currentUser.value) return alert("Anda harus login.");
    const form = uiState.nestedModalData;
    if (!form.name) return alert("Nama kategori tidak boleh kosong.");

    try {
        const categoryRef = doc(db, "categories", form.id);
        await updateDoc(categoryRef, {
    name: form.name,
    description: form.description,
    type: form.type || 'operasional',
});

        // Cari dan perbarui kategori di state lokal
        const index = state.settings.categories.findIndex(cat => cat.id === form.id);
        if (index !== -1) {
            state.settings.categories[index] = { ...form };
        }

        alert('Kategori berhasil diperbarui.');
        hideNestedModal();
    } catch (error) {
        console.error("Gagal memperbarui kategori:", error);
        alert("Gagal memperbarui kategori. Silakan coba lagi.");
    }
}

async function deleteCategory(categoryId) {
    if (!currentUser.value) return alert("Anda harus login.");
    if (!confirm('Anda yakin ingin menghapus kategori ini?')) return;
    try {
        const categoryRef = doc(db, "categories", categoryId);
        await deleteDoc(categoryRef);
        
        // Hapus data dari state lokal
        state.settings.categories = state.settings.categories.filter(cat => cat.id !== categoryId);

        alert('Kategori berhasil dihapus.');
    } catch (error) {
        console.error("Gagal menghapus kategori:", error);
        alert("Gagal menghapus kategori. Silakan coba lagi.");
    }
}

// GANTII SELURUHH FUNGSI handleRegister INI
async function handleRegister() {
    try {
        const userCredential = await createUserWithEmailAndPassword(auth, authForm.email, authForm.password);
        const user = userCredential.user;
        const now = new Date();
        const userDocRef = doc(db, "users", user.uid);

        let newUserData = {
            email: user.email,
            subscriptionStatus: 'trial',
            subscriptionEndDate: null,
            trialEndDate: null,
            dashboardPin: authForm.dashboardPin || null,
            
            // --- BARISS BARU UNTUK PROGRAM KEMITRAAN ---
            isPartner: false, // Default: pengguna baru bukan mitra
            referralCode: null,
            referredBy: authForm.referredBy || null // <-- Ambil kode rujukan dari form jika ada
            // --- AKHIR BARIS BARU ---
        };
        
        if (authForm.activationCode) {
            const codeRef = doc(db, "activation_codes", authForm.activationCode);
            const codeDoc = await getDoc(codeRef);

            if (codeDoc.exists() && codeDoc.data().status === 'unused') {
                newUserData.subscriptionStatus = 'active';
                const nextMonth = new Date(now.setMonth(now.getMonth() + 1));
                newUserData.subscriptionEndDate = nextMonth;
                alert('Registrasi berhasil! Langganan Anda aktif selama 30 hari.');
                await updateDoc(codeRef, { status: 'used', usedBy: user.uid, usedAt: new Date() });
            } else {
                const threeDaysLater = new Date(now.setDate(now.getDate() + 3));
                newUserData.trialEndDate = threeDaysLater;
                alert('Kode aktivasi tidak valid atau sudah digunakan. Anda mendapatkan free trial selama 3 hari.');
            }
        } else {
            const threeDaysLater = new Date(now.setDate(now.getDate() + 3));
            newUserData.trialEndDate = threeDaysLater;
            alert('Registrasi berhasil! Anda mendapatkan free trial selama 3 hari.');
        }

        await setDoc(userDocRef, newUserData, { merge: true });
        authForm.error = '';
    } catch (error) {
        if (error.code === 'auth/email-already-in-use') {
            authForm.error = 'Alamat email ini sudah terdaftar. Silakan gunakan email lain atau login.';
        } else if (error.code === 'auth/invalid-email') {
            authForm.error = 'Format alamat email tidak valid.';
        } else if (error.code === 'auth/weak-password') {
            authForm.error = 'Kata sandi terlalu lemah. Minimal 6 karakter.';
        } else {
            authForm.error = 'Terjadi kesalahan saat mendaftar. Silakan coba lagi.';
        }
    }
}

async function handleLogin() {
    try {
        // [PERBAIKAN DI SINI]
        // Kita tidak perlu lagi menyimpan 'userCredential' karena
        // onAuthStateChanged akan menanganinya secara otomatis.
        await signInWithEmailAndPassword(auth, authForm.email, authForm.password);
        
        // Baris `const user = userCredential.user;` sudah dihapus.
        // Baris `await handleAuth(user);` sudah dihapus.
        
        authForm.error = '';
        alert('Selamat datang kembali!');

    } catch (error) {
        if (error.code === 'auth/invalid-credential' || error.code === 'auth/user-not-found' || error.code === 'auth/wrong-password') {
            authForm.error = 'Email atau kata sandi salah.';
        } else {
            authForm.error = 'Terjadi kesalahan saat login.';
        }
    }
}

async function handleLogout() {
    await signOut(auth);
}

async function handleActivation() {
    if (!activationCodeInput.value) {
        activationCodeMessage.value = 'Kode tidak boleh kosong.';
        return;
    }
    if (!currentUser.value) {
        activationCodeMessage.value = 'Anda harus login untuk mengaktifkan kode.';
        return;
    }

    try {
        isSaving.value = true;
        activationCodeMessage.value = 'Memvalidasi kode...';

        const codeRef = doc(db, "activation_codes", activationCodeInput.value);
        const userRef = doc(db, "users", currentUser.value.uid);
        let subscriptionEndDate;

        await runTransaction(db, async (transaction) => {
            const codeDoc = await transaction.get(codeRef);
            if (!codeDoc.exists() || codeDoc.data().status !== 'unused') {
                throw new Error('Kode aktivasi tidak valid atau sudah digunakan.');
            }
            const now = new Date();
            subscriptionEndDate = new Date(new Date(now).setMonth(now.getMonth() + 1));

            transaction.update(userRef, {
                subscriptionStatus: 'active',
                subscriptionEndDate: subscriptionEndDate,
                trialEndDate: null
            });
            transaction.update(codeRef, {
                status: 'used',
                usedBy: currentUser.value.uid,
                usedByEmail: userProfile.data.email, // <-- PERBAIKAN DI SINI
                usedAt: new Date()
            });
        });

        // Perbarui state lokal agar UI langsung berubah tanpa refresh
        if (userProfile.data) {
            userProfile.data.subscriptionStatus = 'active';
            userProfile.data.subscriptionEndDate = subscriptionEndDate;
            userProfile.data.trialEndDate = null;
        }

        activationCodeMessage.value = '';
        activationCodeInput.value = '';
        alert('Aktivasi berhasil! Langganan Anda sekarang aktif selama 1 bulan.');

    } catch (error) {
        activationCodeMessage.value = error.message;
    } finally {
        isSaving.value = false;
    }
}

// Metode untuk login dengan Google
async function signInWithGoogle() {
    const provider = new GoogleAuthProvider();

    // Selalu tampilkan pilihan akun Google
    provider.setCustomParameters({
        prompt: 'select_account'
    });

    try {
        const result = await signInWithPopup(auth, provider);
        const user = result.user;
        
        // Cek apakah ini pengguna baru atau lama
        const userDocRef = doc(db, "users", user.uid);
        const userDocSnap = await getDoc(userDocRef);

        if (!userDocSnap.exists()) {
            // Jika pengguna baru, inisialisasi data dan berikan trial
            const now = new Date();
            const threeDaysLater = new Date(
                now.setDate(now.getDate() + 3)
            );

            const newUserData = {
                email: user.email,
                subscriptionStatus: 'trial',
                subscriptionEndDate: null,
                trialEndDate: threeDaysLater,
            };

            await setDoc(userDocRef, newUserData);

            alert(
                'Selamat datang! Anda mendapatkan free trial selama 3 hari.'
            );
        } else {
            alert('Selamat datang kembali!');
        }
    } catch (error) {
        console.error("Error login dengan Google:", error);

        // Jangan tampilkan error apabila pengguna menutup popup sendiri
        if (error.code !== 'auth/popup-closed-by-user') {
            alert(error.message);
        }
    }
}

const authForm = reactive({
    email: '',
    password: '',
    error: '',
    dashboardPin: '',
    activationCode: '',
    referredBy: ''
});


function removeProgram(programId) {
    const marketplace = uiState.modalData;
    if (marketplace && marketplace.programs) {
        const index = marketplace.programs.findIndex(p => p.id === programId);
        if (index !== -1) {
            marketplace.programs.splice(index, 1);
        }
    }
}

async function submitStockAdjustment() {
    // --- 1. GEMBOK PENGAMAN: Cegah Double Click ---
    if (isSaving.value) return;

    const form = uiState.modalData;
    if (!form.sku || !form.qty || form.qty <= 0 || !form.alasan || !form.tipe) {
        alert('Semua kolom wajib diisi dan jumlah harus lebih dari 0.');
        return;
    }

    const skuToUpdate = form.sku.toUpperCase();
    const quantity = parseInt(form.qty, 10); // Pastikan jadi angka integer
    const adjustmentType = form.tipe; // 'penambahan' atau 'pengurangan'
    let hppLoss = 0;

    // KUNCI TOMBOL
    isSaving.value = true;

    try {
        const productsCollection = collection(db, "products");
        const q = query(productsCollection, where("sku", "==", skuToUpdate), where("userId", "==", currentUser.value.uid));
        const querySnapshot = await getDocs(q);

        if (querySnapshot.empty) {
            throw new Error(`Produk dengan SKU "${skuToUpdate}" tidak ditemukan.`);
        }

        const productDocSnapshot = querySnapshot.docs[0];
        const productId = productDocSnapshot.id;
        const productRef = doc(db, "products", productId);
        
        // Cari produk di state lokal untuk update tampilan
        const productInState = state.produk.find(p => p.docId === productId);
        const inventoryProductInState = state.inventoryPaginated.find(p => p.docId === productId);

        await runTransaction(db, async (transaction) => {
            const productDoc = await transaction.get(productRef);
            if (!productDoc.exists()) throw new Error("Dokumen produk hilang!");

            const currentData = productDoc.data();
            const currentStock = currentData.physical_stock || 0;

            // --- LOGIKA UTAMA: Gunakan INCREMENT ---
            let adjustmentValue = 0;

            if (adjustmentType === 'penambahan') {
                adjustmentValue = quantity;
            } else { // pengurangan
                // Cek stok cukup atau tidak (Opsional, jika ingin membolehkan minus, hapus if ini)
                if (currentStock < quantity) {
                    throw new Error(`Stok tidak cukup. Stok saat ini: ${currentStock}, akan dikurangi: ${quantity}.`);
                }
                adjustmentValue = -quantity; // Negatif
                
                // Hitung kerugian finansial
                hppLoss = (currentData.hpp || 0) * quantity;
            }

            // Update stok menggunakan increment (Server Side Calculation)
            transaction.update(productRef, { physical_stock: increment(adjustmentValue) });

            // Catat pengeluaran jika ada kerugian (pengurangan stok karena rusak/hilang)
            if (adjustmentType === 'pengurangan' && hppLoss > 0) {
                const expenseRef = doc(collection(db, "keuangan"));
                const expenseData = {
                    kategori: 'Kerugian Stok',
                    jumlah: hppLoss,
                    catatan: `${form.alasan}: ${quantity} pcs x ${skuToUpdate}`,
                    jenis: 'pengeluaran',
                    userId: currentUser.value.uid,
                    tanggal: new Date()
                };
                transaction.set(expenseRef, expenseData);
                // Kita push ke state lokal nanti setelah transaksi sukses
            }
        });

        // --- UPDATE TAMPILAN (State Lokal) ---
        // Update tanpa refresh halaman
        if (productInState) {
            if (adjustmentType === 'penambahan') productInState.stokFisik += quantity;
            else productInState.stokFisik -= quantity;
        }
        
        if (inventoryProductInState) {
             if (adjustmentType === 'penambahan') inventoryProductInState.stokFisik += quantity;
             else inventoryProductInState.stokFisik -= quantity;
        }

        // Jika ada kerugian, tambahkan ke tabel keuangan lokal (kosmetik)
        if (adjustmentType === 'pengurangan' && hppLoss > 0) {
            await fetchKeuanganData(true); // Reload data keuangan biar aman
        }

        alert(`Stok untuk SKU ${skuToUpdate} berhasil disesuaikan.`);
        hideModal();

    } catch (error) {
        console.error("Error dalam transaksi penyesuaian stok:", error);
        alert(`Gagal memperbarui stok: ${error.message}`);
    } finally {
        // BUKA KUNCI
        isSaving.value = false;
    }
}

let profitExpenseChart = null;
let salesChannelChart = null;


// --- UTILITY FUNCTIONS ---
const formatCurrency = (value) => {
    return new Intl.NumberFormat('id-ID', {
        style: 'currency',
        currency: 'IDR',
        minimumFractionDigits: 0, // Tidak ada angka di belakang koma
        maximumFractionDigits: 0, // Angka akan dibulatkan
    }).format(value || 0);
};

const targetMarginComputed = computed({
    get() {
        if (uiState.priceCalculator.targetMargin) {
            // Menampilkan kembali dengan koma jika ada
            return uiState.priceCalculator.targetMargin.toString().replace('.', ',') + '%';
        }
        return '';
    },
    set(newValue) {
        // Mengizinkan koma sebagai input desimal dan mengubahnya menjadi titik
        const jsNumberString = newValue.toString().replace(/,/g, '.');
        // Membersihkan karakter selain angka dan titik
        const cleanedValue = jsNumberString.replace(/[^0-9.]/g, '');
        // Menggunakan parseFloat untuk membaca angka desimal
        const parsedValue = parseFloat(cleanedValue) || 0;
        uiState.priceCalculator.targetMargin = parsedValue;
    }
});

const admComputed = computed({
    get() { return uiState.modalData.adm ? uiState.modalData.adm + '%' : ''; },
    set(newValue) { uiState.modalData.adm = parsePercentageInput(newValue); }
});

const layananComputed = computed({
    get() { return uiState.modalData.layanan ? uiState.modalData.layanan + '%' : ''; },
    set(newValue) { uiState.modalData.layanan = parsePercentageInput(newValue); }
});



const formatNumber = (value) => (value === null || value === undefined) ? '' : new Intl.NumberFormat('id-ID').format(value);
const getProductBySku = (sku) => {
    // Pertama, pastikan 'sku' yang dicari tidak kosong
    if (!sku) {
        return undefined;
    }
    // Cari produk, dan pastikan setiap produk 'p' dan 'p.sku' ada sebelum membandingkan
    return state.produk.find(p => p && p.sku && p.sku.toLowerCase() === sku.toLowerCase());
};
const getMarketplaceById = (id) => state.settings.marketplaces.find(mp => mp.id === id);

const getTransactionDisplayId = (trxId) => {
    if (!trxId) return '-';
    // Cari transaksi di state berdasarkan ID
    const trx = state.transaksi.find(t => t.id === trxId);
    // Jika ketemu, tampilkan marketplaceOrderId (Resi), jika tidak tampilkan ID internal
    return trx ? (trx.marketplaceOrderId || trx.id) : trxId;
};

function filterDataByDate(data, filterType, startDateStr, endDateStr, startMonth, startYear, endMonth, endYear) {
    if (!data) return [];
    
    const today = new Date();
    today.setHours(0, 0, 0, 0); 

    return data.filter(item => {
        if (!item.tanggal) return false;
        
        // KRITIS: Pastikan konversi ke Date dan waktu di-reset
        const itemDate = item.tanggal?.seconds 
    ? new Date(item.tanggal.seconds * 1000) 
    : new Date(item.tanggal);
        itemDate.setHours(0, 0, 0, 0); 

        switch (filterType) {
            case 'today': {
    const t = new Date(); // Ambil waktu detik ini
    return itemDate.getDate() === t.getDate() &&
           itemDate.getMonth() === t.getMonth() &&
           itemDate.getFullYear() === t.getFullYear();
}

            case 'last_7_days': {
                const sevenDaysAgo = new Date(today);
                sevenDaysAgo.setDate(today.getDate() - 7);
                return itemDate >= sevenDaysAgo;
            }
            case 'last_30_days': {
                const thirtyDaysAgo = new Date(today);
                thirtyDaysAgo.setDate(today.getDate() - 30);
                return itemDate >= thirtyDaysAgo;
            }
            case 'this_year':
                return itemDate.getFullYear() === today.getFullYear();

            case 'by_date_range': {
                if (!startDateStr || !endDateStr) return true;
                const start = new Date(startDateStr);
                const end = new Date(endDateStr);
                start.setHours(0, 0, 0, 0);
                end.setHours(23, 59, 59, 999);
                return itemDate >= start && itemDate <= end;
            }
            
            case 'by_month_range': {
                if (!startMonth || !startYear || !endMonth || !endYear) return true;
                const start = new Date(startYear, startMonth - 1, 1);
                const end = new Date(endYear, endMonth, 0); 
                end.setHours(23, 59, 59, 999);
                return itemDate >= start && itemDate <= end;
            }
            
            case 'by_year_range': {
                if (!startYear || !endYear) return true;
                const start = new Date(startYear, 0, 1);
                const end = new Date(endYear, 11, 31);
                end.setHours(23, 59, 59, 999);
                return itemDate >= start && itemDate <= end;
            }
            
            case 'all_time':
            default:
                return true;
        }
    });
}

const formatInputNumber = (value) => {
    if (value === null || value === undefined) return '';
    return new Intl.NumberFormat('id-ID').format(value);
};

const parseInputNumber = (value) => {
    if (value === null || value === undefined || value === '') return 0;
    const parsed = value.toString().replace(/[^0-9]/g, '');
    return parseInt(parsed, 10) || 0;
};


// --- COMPUTED PROPERTIES ---
const uniqueRoasModels = computed(() => {
    const modelMap = new Map();

    (state.settings.modelProduk || []).forEach(model => {
        const namaDasar = (model.namaModel || '').split(' ')[0];

        if (namaDasar && !modelMap.has(namaDasar)) {
            modelMap.set(namaDasar, {
                namaModel: namaDasar
            });
        }
    });

    return Array.from(modelMap.values()).sort((a, b) =>
        a.namaModel.localeCompare(b.namaModel)
    );
});

const roasDashboardData = computed(() => {
    let transaksi = state.transaksi || [];

    transaksi = filterDataByDate(
        transaksi,
        uiState.roasDashboard.dateFilter,
        uiState.roasDashboard.startDate,
        uiState.roasDashboard.endDate,
        uiState.roasDashboard.startMonth,
        uiState.roasDashboard.startYear,
        uiState.roasDashboard.endMonth,
        uiState.roasDashboard.endYear
    );

    if (uiState.roasDashboard.channelId !== 'all') {
        transaksi = transaksi.filter(t => 
            t.channelId === uiState.roasDashboard.channelId || 
            t.channel === uiState.roasDashboard.channelId
        );
    }
if (uiState.roasDashboard.selectedModelId !== 'all') {
    const selectedModelName = uiState.roasDashboard.selectedModelId;

    transaksi = transaksi
        .map(t => {
            const originalItems = t.items || [];

            const filteredItems = originalItems.filter(item => {
                const productData = state.produk.find(p => p.sku === item.sku);

                const modelId =
                    item.model_id ||
                    item.modelId ||
                    productData?.model_id ||
                    productData?.modelId ||
                    '';

                const modelData = state.settings.modelProduk.find(m => m.id === modelId);
                const namaDasar = (modelData?.namaModel || '').split(' ')[0];

                return namaDasar === selectedModelName;
            });

            if (filteredItems.length === 0) return null;

            const itemSubtotal = filteredItems.reduce((sum, item) => {
                return sum + ((item.hargaJual || item.price || 0) * (item.qty || 0));
            }, 0);

            const transaksiSubtotal = originalItems.reduce((sum, item) => {
                return sum + ((item.hargaJual || item.price || 0) * (item.qty || 0));
            }, 0);

            const ratio = transaksiSubtotal > 0 ? itemSubtotal / transaksiSubtotal : 1;

            return {
                ...t,
                items: filteredItems,
                total: itemSubtotal,
                subtotal: itemSubtotal,
                diskon: typeof t.diskon === 'object'
                    ? { ...t.diskon, totalDiscount: (t.diskon.totalDiscount || 0) * ratio }
                    : (t.diskon || 0) * ratio,
                biaya: {
                    ...(t.biaya || {}),
                    total: (t.biaya?.total || 0) * ratio
                }
            };
        })
        .filter(Boolean);
}
    const omset = transaksi.reduce((sum, t) => sum + (t.subtotal || t.total || 0), 0);
    const totalOrder = transaksi.length;

    const qtyTerjual = transaksi.reduce((sum, t) => {
        return sum + (t.items || []).reduce((s, item) => s + (item.qty || 0), 0);
    }, 0);

    const totalHpp = transaksi.reduce((sum, t) => {
        return sum + (t.items || []).reduce((s, item) => {
            return s + ((item.hpp || 0) * (item.qty || 0));
        }, 0);
    }, 0);


    const biayaMarketplace = transaksi.reduce((sum, t) => {
        return sum + (t.biaya?.total || 0);
    }, 0);

    const discount = transaksi.reduce((sum, t) => {
    const diskonValue = typeof t.diskon === 'object'
        ? (t.diskon.totalDiscount || 0)
        : (t.diskon || 0);

    return sum + diskonValue;
}, 0);


    const biayaIklan = parseInputNumber(uiState.roasDashboard.adSpend);
    const biayaOperasional = parseInputNumber(uiState.roasDashboard.operationalBudget);
    const pajakPersen = parseFloat(uiState.roasDashboard.taxPercent) || 0;
    const pajak = biayaIklan * (pajakPersen / 100);

    const labaKotor = omset - totalHpp;
    const labaBersih = omset - discount - totalHpp - biayaMarketplace - biayaIklan - biayaOperasional - pajak;

    const roas = biayaIklan > 0 ? omset / biayaIklan : 0;
    const marginBersih = omset > 0 ? (labaBersih / omset) * 100 : 0;


const grossProfit = omset - discount - totalHpp - biayaMarketplace;
const bepRoas = grossProfit > 0 ? omset / grossProfit : 0;

let status = 'Data belum cukup';
if (biayaIklan > 0 && labaBersih > 0) status = 'PROFIT';
if (biayaIklan > 0 && labaBersih <= 0) status = 'RUGI / PERLU OPTIMASI';

return {
    omset,
    totalOrder,
    qtyTerjual,
    totalHpp,
    biayaMarketplace,
    biayaIklan,
    biayaOperasional,
    pajak,
    labaKotor,
    grossProfit,
    labaBersih,
    roas,
    marginBersih,
    bepRoas,
    discount,
    status
};
});

const DASHBOARD_BATCH_SIZE = 200;

const dashboardPeriodData =
    reactive({
        transactions: [],
        returns: [],
        finance: []
    });

const dashboardTodayData =
    reactive({
        transactions: [],
        finance: []
    });

const dashboardDataLoading =
    ref(false);

const dashboardDataError =
    ref('');

const dashboardDataMessage =
    ref('');

const dashboardLoadedCounts =
    reactive({
        transactions: 0,
        returns: 0,
        finance: 0
    });

const dashboardPaidReturnOriginKeys =
    ref([]);

// FASHION_OS_CASH_RETURN_LIVE_V2
// Saldo kas seluruh waktu. Nilai ini tidak mengikuti filter Dashboard.
const dashboardCashBalance =
    reactive({
        value: 0,
        loading: false,
        error: '',
        loaded: false
    });

let dashboardCashBalanceRequestId = 0;

// FASHION_OS_DASHBOARD_SUMMARY_V2
// Ringkasan ini berada di koleksi baru dan tidak mengubah user_summaries
// lama. Bila Cloud Function belum siap, pemuatan lama tetap menjadi fallback.
const dashboardSummaryV2 =
    reactive({
        periodReady: false,
        globalReady: false,
        userId: '',
        loading: false,
        rebuilding: false,
        metrics: {},
        global: {},
        series: [],
        channels: {},
        today: {},
        version: 0,
        readDocuments: 0,
        error: ''
    });

const DASHBOARD_SUMMARY_V2_CACHE_PREFIX =
    'fashion_os_dashboard_v2_cache:';

const dashboardSummaryV2MemoryCache =
    new Map();

const dashboardSummaryV2RebuildAttempted =
    new Set();

let dashboardSummaryV2GlobalLoadedAt =
    0;

let dashboardSummaryV2RefreshTimer =
    null;

const getDashboardSummaryV2Callable =
    httpsCallable(
        functions,
        'getDashboardSummaryV2',
        {
            timeout: 120000
        }
    );

const rebuildDashboardSummaryV2Callable =
    httpsCallable(
        functions,
        'rebuildDashboardSummaryV2',
        {
            timeout: 540000
        }
    );

const prepareDashboardSummaryV2User =
    userId => {
        if (
            dashboardSummaryV2.userId ===
            userId
        ) {
            return;
        }

        dashboardSummaryV2.userId =
            userId || '';

        dashboardSummaryV2.periodReady =
            false;

        dashboardSummaryV2.globalReady =
            false;

        dashboardSummaryV2.metrics =
            {};

        dashboardSummaryV2.global =
            {};

        dashboardSummaryV2.series =
            [];

        dashboardSummaryV2.channels =
            {};

        dashboardSummaryV2.today =
            {};

        dashboardSummaryV2.version =
            0;

        dashboardSummaryV2GlobalLoadedAt =
            0;

        dashboardCashBalance.value =
            0;

        dashboardCashBalance.loaded =
            false;

        dashboardCashBalance.error =
            '';
    };

const dashboardSummaryV2DateKey =
    value => {
        const date =
            value instanceof Date
                ? value
                : new Date(value);

        if (
            Number.isNaN(
                date.getTime()
            )
        ) {
            return '';
        }

        const year =
            date.getFullYear();

        const month =
            String(
                date.getMonth() + 1
            ).padStart(2, '0');

        const day =
            String(
                date.getDate()
            ).padStart(2, '0');

        return `${year}-${month}-${day}`;
    };

const dashboardSummaryV2RequestPayload =
    range => ({
        allTime:
            range.allTime === true,
        startDateKey:
            range.startDate
                ? dashboardSummaryV2DateKey(
                    range.startDate
                )
                : '',
        endDateKey:
            range.endDate
                ? dashboardSummaryV2DateKey(
                    range.endDate
                )
                : '',
        todayDateKey:
            dashboardSummaryV2DateKey(
                new Date()
            )
    });

const dashboardSummaryV2CacheKey =
    (userId, requestPayload) =>
        `${DASHBOARD_SUMMARY_V2_CACHE_PREFIX}${userId}:${JSON.stringify(requestPayload)}`;

const readDashboardSummaryV2Cache =
    cacheKey => {
        if (
            dashboardSummaryV2MemoryCache.has(
                cacheKey
            )
        ) {
            return dashboardSummaryV2MemoryCache.get(
                cacheKey
            );
        }

        try {
            const cachedValue =
                sessionStorage.getItem(
                    cacheKey
                );

            if (!cachedValue) {
                return null;
            }

            const parsedValue =
                JSON.parse(
                    cachedValue
                );

            if (
                parsedValue?.ready !==
                true
            ) {
                return null;
            }

            dashboardSummaryV2MemoryCache.set(
                cacheKey,
                parsedValue
            );

            return parsedValue;
        } catch (error) {
            return null;
        }
    };

const writeDashboardSummaryV2Cache =
    (cacheKey, value) => {
        dashboardSummaryV2MemoryCache.set(
            cacheKey,
            value
        );

        try {
            sessionStorage.setItem(
                cacheKey,
                JSON.stringify(value)
            );
        } catch (error) {
            // Cache sesi hanya optimasi. Dashboard tetap berjalan tanpanya.
        }
    };

const invalidateDashboardSummaryV2Cache =
    () => {
        dashboardSummaryV2MemoryCache.clear();

        try {
            const keysToRemove =
                [];

            for (
                let index = 0;
                index < sessionStorage.length;
                index++
            ) {
                const key =
                    sessionStorage.key(
                        index
                    );

                if (
                    key?.startsWith(
                        DASHBOARD_SUMMARY_V2_CACHE_PREFIX
                    )
                ) {
                    keysToRemove.push(
                        key
                    );
                }
            }

            keysToRemove.forEach(
                key =>
                    sessionStorage.removeItem(
                        key
                    )
            );
        } catch (error) {
            // Tidak semua browser mengizinkan sessionStorage.
        }

        clearTimeout(
            dashboardSummaryV2RefreshTimer
        );

        dashboardSummaryV2RefreshTimer =
            setTimeout(
                () => {
                    if (
                        activePage.value ===
                            'dashboard' &&
                        currentUser.value?.uid
                    ) {
                        loadDashboardDataByCurrentFilter(
                            currentUser.value.uid
                        );
                    }
                },
                2500
            );
    };

const applyDashboardSummaryV2Global =
    (
        globalData,
        userId = ''
    ) => {
        if (userId) {
            dashboardSummaryV2.userId =
                userId;
        }

        dashboardSummaryV2.global = {
            ...(globalData || {})
        };

        dashboardSummaryV2.globalReady =
            true;

        dashboardSummaryV2GlobalLoadedAt =
            Date.now();

        dashboardCashBalance.value =
            Number(
                globalData?.cashBalance
            ) || 0;

        dashboardCashBalance.loaded =
            true;

        dashboardCashBalance.loading =
            false;

        dashboardCashBalance.error =
            '';
    };

const applyDashboardSummaryV2Period =
    (
        data,
        userId
    ) => {
        dashboardSummaryV2.metrics = {
            ...(data.metrics || {})
        };

        dashboardSummaryV2.series =
            Array.isArray(data.series)
                ? data.series
                : [];

        dashboardSummaryV2.channels = {
            ...(data.channels || {})
        };

        dashboardSummaryV2.today = {
            ...(data.today || {})
        };

        dashboardSummaryV2.version =
            Number(data.version) || 0;

        dashboardSummaryV2.readDocuments =
            Number(
                data.readDocuments
            ) || 0;

        dashboardSummaryV2.periodReady =
            true;

        applyDashboardSummaryV2Global(
            data.global,
            userId
        );
    };

const loadDashboardGlobalSummaryV2 =
    async userId => {
        if (!userId) {
            return false;
        }

        prepareDashboardSummaryV2User(
            userId
        );

        if (
            dashboardSummaryV2.globalReady &&
            dashboardSummaryV2.userId ===
                userId &&
            (
                Date.now() -
                dashboardSummaryV2GlobalLoadedAt
            ) < 60000
        ) {
            return true;
        }

        try {
            const response =
                await getDashboardSummaryV2Callable({
                    globalOnly: true
                });

            const data =
                response?.data || {};

            if (data.ready !== true) {
                return false;
            }

            dashboardSummaryV2.version =
                Number(data.version) || 0;

            applyDashboardSummaryV2Global(
                data.global,
                userId
            );

            return true;
        } catch (error) {
            console.warn(
                '[DASHBOARD V2] Ringkasan global belum tersedia. Fallback lama dipakai.',
                error
            );

            return false;
        }
    };

const loadDashboardPeriodSummaryV2 =
    async (
        userId,
        range
    ) => {
        if (!userId || !range?.ready) {
            return false;
        }

        prepareDashboardSummaryV2User(
            userId
        );

        dashboardSummaryV2.loading =
            true;

        dashboardSummaryV2.error =
            '';

        dashboardSummaryV2.periodReady =
            false;

        dashboardCashBalance.loading =
            true;

        const requestPayload =
            dashboardSummaryV2RequestPayload(
                range
            );

        const cacheKey =
            dashboardSummaryV2CacheKey(
                userId,
                requestPayload
            );

        const cachedData =
            readDashboardSummaryV2Cache(
                cacheKey
            );

        const requestWithCache = {
            ...requestPayload
        };

        if (
            Number.isFinite(
                Number(
                    cachedData?.version
                )
            )
        ) {
            requestWithCache.knownVersion =
                Number(
                    cachedData.version
                );
        }

        try {
            let response =
                await getDashboardSummaryV2Callable(
                    requestWithCache
                );

            let data =
                response?.data || {};

            if (
                data.ready !== true &&
                data.rebuilding !== true &&
                !dashboardSummaryV2RebuildAttempted.has(
                    userId
                )
            ) {
                dashboardSummaryV2RebuildAttempted.add(
                    userId
                );

                dashboardSummaryV2.rebuilding =
                    true;

                await rebuildDashboardSummaryV2Callable();

                dashboardSummaryV2.rebuilding =
                    false;

                response =
                    await getDashboardSummaryV2Callable(
                        requestPayload
                    );

                data =
                    response?.data || {};
            }

            if (
                data.unchanged ===
                    true &&
                cachedData
            ) {
                data = {
                    ...cachedData,
                    global:
                        data.global ||
                        cachedData.global,
                    version:
                        data.version ||
                        cachedData.version,
                    readDocuments:
                        data.readDocuments ||
                        1
                };
            }

            if (data.ready !== true) {
                return false;
            }

            writeDashboardSummaryV2Cache(
                cacheKey,
                data
            );

            applyDashboardSummaryV2Period(
                data,
                userId
            );

            return true;
        } catch (error) {
            dashboardSummaryV2.rebuilding =
                false;

            dashboardSummaryV2.error =
                error?.message || '';

            console.warn(
                '[DASHBOARD V2] Ringkasan belum dapat dipakai. Dashboard lama tetap dijalankan.',
                error
            );

            return false;
        } finally {
            dashboardSummaryV2.loading =
                false;
        }
    };

const dashboardSummaryV2TransactionGlobal =
    transaction => {
        const discount =
            Number(
                transaction?.diskon
                    ?.totalDiscount ??
                transaction?.totalDiscount ??
                transaction?.discount
            ) || 0;

        const gross =
            Number.isFinite(
                Number(
                    transaction?.subtotal
                )
            )
                ? Number(
                    transaction.subtotal
                )
                : (
                    Number(
                        transaction?.total ??
                        transaction?.grandTotal
                    ) || 0
                ) + discount;

        const isNewFormat =
            Object.prototype.hasOwnProperty.call(
                transaction || {},
                'statusDataMarketplace'
            );

        const isMatched =
            String(transaction?.statusDataMarketplace || '').toLowerCase() ===
            'cocok';

        const net = isNewFormat
            ? (
                isMatched
                    ? Number(transaction?.penghasilanBersihMarketplace) || 0
                    : 0
            )
            : (
                Number.isFinite(
                    Number(
                        transaction?.total ??
                        transaction?.grandTotal
                    )
                )
                    ? Number(
                        transaction?.total ??
                        transaction?.grandTotal
                    )
                    : gross - discount
            );

        const fees =
            Number(
                transaction?.biaya?.total ??
                transaction?.totalBiaya
            ) || 0;

        const qty =
            (
                transaction?.items ||
                []
            ).reduce(
                (total, item) =>
                    total +
                    (
                        Number(
                            item.qty
                        ) || 0
                    ),
                0
            );

        const status =
            String(
                transaction?.statusPencairan ||
                ''
            )
                .trim()
                .toLocaleLowerCase(
                    'id-ID'
                );

        const previousStatus =
            String(
                transaction
                    ?.statusPencairanSebelumRetur ||
                ''
            )
                .trim()
                .toLocaleLowerCase(
                    'id-ID'
                );

        const isSettled =
            status === 'sudah cair' ||
            (
                (
                    status ===
                        'retur/pengembalian' ||
                    status ===
                        'retur / pengembalian' ||
                    status ===
                        'retur'
                ) &&
                previousStatus ===
                    'sudah cair'
            );

        const isPending =
            !status ||
            status === 'belum cair' ||
            status === 'waiting';

        return {
            cashBalance:
                isSettled
                    ? net - fees
                    : 0,
            pendingFunds:
                isPending
                    ? net - fees
                    : 0,
            pendingQty:
                isPending
                    ? qty
                    : 0
        };
    };

const applyDashboardSummaryV2GlobalDelta =
    delta => {
        if (
            dashboardSummaryV2.globalReady !==
            true
        ) {
            return;
        }

        [
            'cashBalance',
            'pendingFunds',
            'pendingQty'
        ].forEach(field => {
            dashboardSummaryV2.global[field] =
                (
                    Number(
                        dashboardSummaryV2
                            .global[field]
                    ) || 0
                ) +
                (
                    Number(
                        delta[field]
                    ) || 0
                );
        });

        dashboardCashBalance.value =
            Number(
                dashboardSummaryV2
                    .global.cashBalance
            ) || 0;

        invalidateDashboardSummaryV2Cache();
    };

const applyDashboardSummaryV2TransactionDelta =
    (
        beforeTransaction,
        afterTransaction
    ) => {
        if (
            dashboardSummaryV2.globalReady !==
            true
        ) {
            return;
        }

        const before =
            dashboardSummaryV2TransactionGlobal(
                beforeTransaction
            );

        const after =
            dashboardSummaryV2TransactionGlobal(
                afterTransaction
            );

        applyDashboardSummaryV2GlobalDelta({
            cashBalance:
                after.cashBalance -
                before.cashBalance,
            pendingFunds:
                after.pendingFunds -
                before.pendingFunds,
            pendingQty:
                after.pendingQty -
                before.pendingQty
        });
    };

const applyDashboardSummaryV2ReturnDelta =
    (
        beforeReturn,
        afterReturn
    ) => {
        if (
            dashboardSummaryV2.globalReady !==
            true
        ) {
            return;
        }

        const returnCashContribution =
            returnRecord => {
                const previousStatus =
                    String(
                        returnRecord
                            ?.statusPencairanSebelumRetur ||
                        ''
                    )
                        .trim()
                        .toLocaleLowerCase(
                            'id-ID'
                        );

                if (
                    previousStatus !==
                    'sudah cair'
                ) {
                    return 0;
                }

                return (
                    returnRecord?.items ||
                    []
                ).reduce(
                    (total, item) =>
                        total -
                        (
                            Number(
                                item.nilaiRetur
                            ) || 0
                        ) +
                        (
                            Number(
                                item.biayaMarketplace
                            ) || 0
                        ),
                    0
                );
            };

        applyDashboardSummaryV2GlobalDelta({
            cashBalance:
                returnCashContribution(
                    afterReturn
                ) -
                returnCashContribution(
                    beforeReturn
                ),
            pendingFunds: 0,
            pendingQty: 0
        });
    };

// FASHION_OS_DASHBOARD_CASH_AND_SELLING_PRICES_V1
// FASHION_OS_DASHBOARD_CASH_BUILD_FIX_V3
const toDashboardCashNumber =
    value => {
        const parsed = Number(value);
        return Number.isFinite(parsed)
            ? parsed
            : 0;
    };

const getDashboardCashDiscount =
    transaction =>
        toDashboardCashNumber(
            transaction?.diskon?.totalDiscount ??
            transaction?.totalDiscount ??
            transaction?.discount
        );

const getDashboardCashGross =
    transaction => {
        const subtotal =
            Number(transaction?.subtotal);

        if (
            Number.isFinite(subtotal) &&
            subtotal !== 0
        ) {
            return subtotal;
        }

        // Dokumen lama dapat hanya memiliki total bersih.
        // Tambahkan kembali diskon agar rumus gross - diskon tetap konsisten.
        return (
            toDashboardCashNumber(
                transaction?.total ??
                transaction?.grandTotal
            ) +
            getDashboardCashDiscount(
                transaction
            )
        );
    };

const loadDashboardCashBalanceFromDocuments =
    async userId => {
        // Query sederhana per user tidak membutuhkan indeks gabungan.
        // Jalur ini hanya dipakai bila aggregate gagal atau tidak dapat
        // membaca subtotal dokumen lama.
        const [
            transactionSnapshot,
            financeSnapshot
        ] = await Promise.all([
            getDocsFromServer(
                query(
                    collection(db, 'transactions'),
                    where('userId', '==', userId)
                )
            ),
            getDocsFromServer(
                query(
                    collection(db, 'keuangan'),
                    where('userId', '==', userId)
                )
            )
        ]);

        let settledGross = 0;
        let settledDiscount = 0;
        let settledFees = 0;

        transactionSnapshot.docs.forEach(
            documentSnapshot => {
                const transaction = {
                    id: documentSnapshot.id,
                    ...documentSnapshot.data()
                };

                if (
                    !isActiveExportRecord(
                        transaction
                    ) ||
                    String(
                        transaction.statusPencairan ||
                        ''
                    )
                        .trim()
                        .toLocaleLowerCase('id-ID') !==
                        'sudah cair'
                ) {
                    return;
                }

                settledGross +=
                    getDashboardCashGross(
                        transaction
                    );

                settledDiscount +=
                    getDashboardCashDiscount(
                        transaction
                    );

                settledFees +=
                    toDashboardCashNumber(
                        transaction?.biaya?.total ??
                        transaction?.totalBiaya
                    );
            }
        );

        let otherIncome = 0;
        let expense = 0;
        let otherCost = 0;

        financeSnapshot.docs.forEach(
            documentSnapshot => {
                const finance = {
                    id: documentSnapshot.id,
                    ...documentSnapshot.data()
                };

                if (
                    !isActiveExportRecord(
                        finance
                    )
                ) {
                    return;
                }

                const amount =
                    toDashboardCashNumber(
                        finance.jumlah ??
                        finance.amount ??
                        finance.nominal
                    );

                if (
                    finance.jenis ===
                    'pemasukan_lain'
                ) {
                    otherIncome += amount;
                } else if (
                    finance.jenis ===
                    'pengeluaran'
                ) {
                    expense += amount;
                } else if (
                    finance.jenis ===
                    'biaya'
                ) {
                    otherCost += amount;
                } else if (
                    finance.jenis ===
                    'pembagian_laba'
                ) {
                    otherCost += amount;
                }
            }
        );

        return (
            (
                settledGross -
                settledDiscount -
                settledFees
            ) +
            otherIncome -
            expense -
            otherCost
        );
    };

// FASHION_OS_DASHBOARD_CASH_NO_INDEX_V2
const loadDashboardCashBalance =
    async userId => {
        if (!userId) {
            dashboardCashBalance.value = 0;
            dashboardCashBalance.loaded = false;
            dashboardCashBalance.error = '';
            return;
        }

        const requestId =
            ++dashboardCashBalanceRequestId;

        dashboardCashBalance.loading = true;
        dashboardCashBalance.error = '';

        try {
            // Langsung gunakan query sederhana per user. Jalur ini tidak
            // membutuhkan indeks agregasi Firestore tambahan.
            const cashValue =
                await loadDashboardCashBalanceFromDocuments(
                    userId
                );

            if (
                requestId !==
                dashboardCashBalanceRequestId
            ) {
                return;
            }

            dashboardCashBalance.value =
                toDashboardCashNumber(
                    cashValue
                );

            dashboardCashBalance.loaded = true;
            dashboardCashBalance.error = '';
        } catch (error) {
            if (
                requestId !==
                dashboardCashBalanceRequestId
            ) {
                return;
            }

            console.error(
                '[DASHBOARD] Saldo Kas Berjalan gagal dihitung:',
                error
            );

            dashboardCashBalance.error =
                error?.message ||
                'Saldo kas belum berhasil dimuat.';
        } finally {
            if (
                requestId ===
                dashboardCashBalanceRequestId
            ) {
                dashboardCashBalance.loading = false;
            }
        }
    };

// Satu perubahan transaksi diterapkan ke semua sumber data lokal
// yang mungkin sedang dipakai halaman lain atau Dashboard.
const applyTransactionUpdateToLocalStores =
    (transactionId, updatePayload) => {
        const localStores = [
            state.pendingSettlements,
            state.transaksi,
            dashboardPeriodData.transactions,
            dashboardTodayData.transactions
        ];

        let beforeTransaction =
            null;

        localStores.forEach(list => {
            const transaction =
                (list || []).find(
                    item =>
                        item.id ===
                        transactionId
                );

            if (transaction) {
                if (!beforeTransaction) {
                    beforeTransaction = {
                        ...transaction,
                        items:
                            (
                                transaction.items ||
                                []
                            ).map(
                                item => ({
                                    ...item
                                })
                            ),
                        biaya: {
                            ...(
                                transaction.biaya ||
                                {}
                            )
                        },
                        diskon: {
                            ...(
                                transaction.diskon ||
                                {}
                            )
                        }
                    };
                }

                Object.assign(
                    transaction,
                    updatePayload
                );
            }
        });

        if (beforeTransaction) {
            applyDashboardSummaryV2TransactionDelta(
                beforeTransaction,
                {
                    ...beforeTransaction,
                    ...updatePayload
                }
            );
        }
    };

const addReturnToLocalStores =
    returnRecord => {
        const returnAlreadyExists =
            (state.retur || []).some(
                item =>
                    item.id ===
                    returnRecord.id
            );

        if (!returnAlreadyExists) {
            state.retur.unshift(
                returnRecord
            );

            applyDashboardSummaryV2ReturnDelta(
                null,
                returnRecord
            );
        }

        if (
            !(dashboardPeriodData.returns || []).some(
                item =>
                    item.id ===
                    returnRecord.id
            )
        ) {
            dashboardPeriodData.returns = [
                returnRecord,
                ...dashboardPeriodData.returns
            ];

            dashboardLoadedCounts.returns =
                dashboardPeriodData.returns.length;
        }
    };

let dashboardRequestId = 0;

let dashboardReloadTimer =
    null;

const dashboardFilteredData = computed(() => {
    const toSafeDate = (value) => {
        if (!value) return null;

        const d = value?.toDate
            ? value.toDate()
            : (value?.seconds ? new Date(value.seconds * 1000) : new Date(value));

        return isNaN(d.getTime()) ? null : d;
    };

    const mapToDateObject = (dataArray, type = 'default') => {
        return (dataArray || [])
            .map(item => {
                const tanggalTransaksi = toSafeDate(item.tanggal);
                const tanggalPencairan = toSafeDate(item.tanggalPencairan);

                let tanggalUntukFilter = tanggalTransaksi;

                // Untuk Dashboard Dana Cair:
                // Kalau transaksi sudah cair, filter waktunya pakai tanggal dana cair.
                if (type === 'transaksi' && item.statusPencairan === 'Sudah Cair') {
                    tanggalUntukFilter = tanggalPencairan || tanggalTransaksi;
                }

                return {
                    ...item,
                    tanggal: tanggalUntukFilter,
                    tanggalTransaksi,
                    tanggalPencairan
                };
            })
            .filter(item => item.tanggal);
    };

    const keuanganData =
        mapToDateObject(
            dashboardPeriodData.finance
        );

    const transaksiData =
        mapToDateObject(
            dashboardPeriodData.transactions,
            'transaksi'
        );

    const returData =
        mapToDateObject(
            dashboardPeriodData.returns
        );

    const filterOptions = [
        uiState.dashboardDateFilter,
        uiState.dashboardStartDate,
        uiState.dashboardEndDate,
        uiState.dashboardStartMonth,
        uiState.dashboardStartYear,
        uiState.dashboardEndMonth,
        uiState.dashboardEndYear
    ];

    return {
        transaksi: filterDataByDate(transaksiData, ...filterOptions),
        keuangan: filterDataByDate(keuanganData, ...filterOptions),
        retur: filterDataByDate(returData, ...filterOptions)
    };
});

const filteredInvestorPayments = computed(() => {
    // Ambil data pembayaran dan pastikan array tidak null
    const payments = state.investorPayments || [];

    // Map data untuk membuat properti 'tanggal' yang aman sebelum filtering
    const paymentsForFilter = payments.map(p => {
        // Jika p.paymentDate null, gunakan Date(0) (tanggal awal) sebagai fallback yang aman
        const safeDate = p.paymentDate || new Date(0); 
        return { 
            ...p, 
            tanggal: safeDate 
        };
    });
    
    // 1. Terapkan filter tanggal (Filter Waktu)
    let filteredData = filterDataByDate(
        paymentsForFilter,
        uiState.investorPaymentFilter,
        uiState.investorPaymentStartDate,
        uiState.investorPaymentEndDate,
        uiState.investorPaymentStartMonth,
        uiState.investorPaymentStartYear,
        uiState.investorPaymentEndMonth,
        uiState.investorPaymentEndYear
    );

    // 2. Filter berdasarkan pencarian (diperkuat dengan guards)
    const searchQuery = uiState.investorPaymentSearch.toLowerCase();
    if (searchQuery) {
        filteredData = filteredData.filter(p => 
            // Pastikan kita tidak memanggil toLowerCase() pada null
            (p.investorName || '').toLowerCase().includes(searchQuery) ||
            (p.period || '').toLowerCase().includes(searchQuery) ||
            (p.paymentMethod || '').toLowerCase().includes(searchQuery) ||
            (p.bankDetails?.bankName || '').toLowerCase().includes(searchQuery)
        );
    }
    
    // 3. Sort: Terbaru lebih dulu (Desc)
    return filteredData.sort((a, b) => new Date(b.tanggal).getTime() - new Date(a.tanggal).getTime());
});

const investorLedger = computed(() => {
    // 1. Hitung total pembayaran per investor
    const paymentsByInvestor = (state.investorPayments || []).reduce((acc, p) => {
        const invId = p.investorId;
        if (!acc[invId]) {
            acc[invId] = { totalPayout: 0 };
        }
        // Pastikan totalPayment ada
        acc[invId].totalPayout += (p.totalPayment || 0); 
        return acc;
    }, {});

    // 2. Gabungkan dengan data investor dan hitung ROI
    return (state.investor || []).map(inv => {
        const totalPayout = paymentsByInvestor[inv.id]?.totalPayout || 0;
        const modal = inv.amount || 0;
        
        let roi = 0;
        if (modal > 0) {
            // ROI = (Total Dibayarkan / Modal) * 100
            roi = (totalPayout / modal) * 100;
        }

        return {
            ...inv,
            totalPayout: totalPayout,
            roi: roi,
            // Menggunakan Date.getTime() untuk memastikan nilai numerik yang dapat diurutkan
            startDate: inv.startDate instanceof Date ? inv.startDate.getTime() : new Date(inv.startDate).getTime()
        };
    }).filter(inv => {
        // Filter status
        if (uiState.investorStatusFilter === 'aktif') return inv.status === 'aktif';
        if (uiState.investorStatusFilter === 'selesai') return inv.status === 'selesai';
        return true; // 'semua'
    });
});

// GANTI SELURUH COMPUTED PROPERTY INI
const dashboardKpis = computed(() => {
    let kpis = {
        saldoKas: 0,
        omsetBersih: 0,
        labaKotor: 0,
        labaBersih: 0,
        omsetKotor: 0,
        totalDiskon: 0,
        totalHppTerjual: 0,
        totalBiayaTransaksi: 0,
        totalBiayaOperasional: 0,
        totalNilaiRetur: 0,
        pemasukanLain: 0,
        danaBelumCair: 0,
        qtyBelumCair: 0,
        totalUnitStok: 0,
        totalNilaiStokHPP: 0
    };

    if (
        dashboardSummaryV2.periodReady ===
        true
    ) {
        const metrics =
            dashboardSummaryV2.metrics ||
            {};

        const globalMetrics =
            dashboardSummaryV2.global ||
            {};

        kpis.saldoKas =
            Number(
                globalMetrics.cashBalance
            ) || 0;

        kpis.omsetKotor =
            Number(
                metrics.omsetKotor
            ) || 0;

        kpis.totalDiskon =
            Number(
                metrics.totalDiskon
            ) || 0;

        kpis.omsetBersih =
            Number(
                metrics.omsetBersih
            ) || 0;

        kpis.totalHppTerjual =
            Number(
                metrics.totalHppTerjual
            ) || 0;

        kpis.totalBiayaTransaksi =
            Number(
                metrics.totalBiayaTransaksi
            ) || 0;

        kpis.totalBiayaOperasional =
            Number(
                metrics.totalBiayaOperasional
            ) || 0;

        kpis.totalNilaiRetur =
            Number(
                metrics.totalNilaiRetur
            ) || 0;

        kpis.pemasukanLain =
            Number(
                metrics.pemasukanLain
            ) || 0;

        kpis.labaKotor =
            Number(
                metrics.labaKotor
            ) || 0;

        kpis.labaBersih =
            Number(
                metrics.labaBersih
            ) || 0;

        kpis.danaBelumCair =
            Number(
                globalMetrics.pendingFunds
            ) || 0;

        kpis.qtyBelumCair =
            Number(
                globalMetrics.pendingQty
            ) || 0;

        kpis.totalUnitStok =
            Number(
                globalMetrics.totalUnitStok
            ) || 0;

        kpis.totalNilaiStokHPP =
            Number(
                globalMetrics.totalNilaiStokHPP
            ) || 0;

        return kpis;
    }

    const { transaksi, keuangan, retur } = dashboardFilteredData.value;

    let omsetKotorAwal = 0;
    let totalDiskonAwal = 0;
    let totalHppTerjualAwal = 0;
    let totalBiayaTransaksiAwal = 0;
    let danaBelumCair = 0;
    let qtyBelumCair = 0;

const transaksiCairKeys = new Set();

(
    dashboardPaidReturnOriginKeys.value ||
    []
).forEach(
    key =>
        transaksiCairKeys.add(
            String(key).toLowerCase()
        )
);

(transaksi || []).forEach(trx => {
    if (trx.statusPencairan === 'Sudah Cair') {
        [
            trx.id,
            trx.marketplaceOrderId,
            trx.orderId,
            trx.idPesanan,
            trx.nomorPesanan
        ]
            .filter(Boolean)
            .forEach(key => transaksiCairKeys.add(String(key).toLowerCase()));
    }
});

    (transaksi || []).forEach(trx => {
        
        const totalHppTrx = (trx.items || []).reduce((sum, item) => {
            return sum + ((Number(item.hpp) || 0) * (Number(item.qty) || 0));
        }, 0);

        const totalBiayaTrx = Number(trx.biaya?.total) || 0;

        const trxQty = (trx.items || []).reduce((sum, item) => {
            return sum + (Number(item.qty) || 0);
        }, 0);

        const isCair = trx.statusPencairan === 'Sudah Cair';
        const isPending = !trx.statusPencairan || trx.statusPencairan === 'Belum Cair' || trx.statusPencairan === 'Waiting';

        if (isCair) {
            omsetKotorAwal += Number(trx.subtotal) || 0;
            totalDiskonAwal += Number(trx.diskon?.totalDiscount) || 0;
            totalHppTerjualAwal += totalHppTrx;
            totalBiayaTransaksiAwal += totalBiayaTrx;
        } else if (isPending) {
            const payout = (Number(trx.total) || 0) - totalBiayaTrx;
            danaBelumCair += payout;
            qtyBelumCair += trxQty;
        }
    });

    // Dana Gantung adalah saldo piutang seluruh waktu dan tidak mengikuti
    // filter periode Dashboard. Gunakan daftar khusus transaksi belum cair.
    if (
        dataFetched.pendingSettlements ||
        (
            state.pendingSettlements ||
            []
        ).length > 0
    ) {
        danaBelumCair = 0;
        qtyBelumCair = 0;

        (
            state.pendingSettlements ||
            []
        ).forEach(transaction => {
            if (
                !isActiveExportRecord(
                    transaction
                )
            ) {
                return;
            }

            const settlementStatus =
                String(
                    transaction.statusPencairan ||
                    'Belum Cair'
                )
                    .trim()
                    .toLocaleLowerCase(
                        'id-ID'
                    );

            if (
                settlementStatus !==
                    'belum cair' &&
                settlementStatus !==
                    'waiting'
            ) {
                return;
            }

            const transactionFees =
                Number(
                    transaction?.biaya?.total
                ) || 0;

            let transactionTotal =
                Number(transaction.total);

            if (
                !Number.isFinite(
                    transactionTotal
                )
            ) {
                const subtotal =
                    Number(
                        transaction.subtotal
                    ) || 0;

                const discount =
                    Number(
                        transaction?.diskon
                            ?.totalDiscount
                    ) || 0;

                transactionTotal =
                    subtotal -
                    discount;
            }

            danaBelumCair +=
                transactionTotal -
                transactionFees;

            qtyBelumCair +=
                (
                    transaction.items ||
                    []
                ).reduce(
                    (total, item) =>
                        total +
                        (
                            Number(
                                item.qty
                            ) || 0
                        ),
                    0
                );
        });
    }

    kpis.danaBelumCair =
        danaBelumCair;

    kpis.qtyBelumCair =
        qtyBelumCair;

    // Semua retur pada filter Dashboard.
// Dipakai khusus untuk kartu Total Nilai Retur.
let totalNilaiReturSemua = 0;

// Retur dari transaksi Sudah Cair.
// Dipakai untuk koreksi omzet, HPP, biaya, dan laba.
let totalNilaiReturGross = 0;

let totalDiskonBatal = 0;
let totalHppRetur = 0;
let biayaMarketplaceBatal = 0;

    (retur || []).forEach(r => {
    // Seluruh data retur masuk ke kartu Total Nilai Retur,
    // baik dari Manajemen Retur maupun Audit & Pencairan Dana.
    (r.items || []).forEach(item => {
        totalNilaiReturSemua +=
            (Number(item.nilaiRetur) || 0) +
            (Number(item.nilaiDiskon) || 0);
    });

    const returKeys = [
        r.originalTransactionId,
        r.transactionId,
        r.marketplaceOrderId,
        r.orderId,
        r.idPesanan,
        r.nomorPesanan
    ]
        .filter(Boolean)
        .map(key => String(key).toLowerCase());

    const returPunyaTransaksiAsal = returKeys.some(key => transaksiCairKeys.has(key));

    if (!returPunyaTransaksiAsal) {
        return;
    }

    (r.items || []).forEach(item => {
        totalNilaiReturGross += (Number(item.nilaiRetur) || 0) + (Number(item.nilaiDiskon) || 0);
        totalDiskonBatal += Number(item.nilaiDiskon) || 0;
        biayaMarketplaceBatal += Number(item.biayaMarketplace) || 0;

        const product = getProductBySku(item.sku);

        if (product) {
            totalHppRetur += (Number(product.hpp) || 0) * (Number(item.qty) || 0);
        }
    });
});

    const pemasukanLain = (keuangan || [])
        .filter(k => k.jenis === 'pemasukan_lain')
        .reduce((sum, k) => sum + (Number(k.jumlah) || 0), 0);

    

    kpis.totalBiayaOperasional = (keuangan || [])
        .filter(k => k.jenis === 'pengeluaran' || k.jenis === 'biaya')
        .filter(k => (k.tipeBiaya || getExpenseTypeByCategory(k.kategori)) !== 'produksi')
        .reduce((sum, k) => sum + (Number(k.jumlah) || 0), 0);

    kpis.omsetKotor = omsetKotorAwal - totalNilaiReturGross;
    kpis.totalDiskon = totalDiskonAwal - totalDiskonBatal;
    kpis.totalHppTerjual = totalHppTerjualAwal - totalHppRetur;
    kpis.totalBiayaTransaksi = totalBiayaTransaksiAwal - biayaMarketplaceBatal;
    kpis.totalNilaiRetur = totalNilaiReturSemua;
    kpis.pemasukanLain = pemasukanLain;

    kpis.omsetBersih = kpis.omsetKotor - kpis.totalDiskon;
    kpis.labaKotor = kpis.omsetBersih - kpis.totalHppTerjual;
    kpis.labaBersih = kpis.labaKotor - kpis.totalBiayaTransaksi - kpis.totalBiayaOperasional;
    // SALDO KAS BERJALAN
    // Jalur dokumen lama hanya menjadi fallback bila V2 belum siap.
    kpis.saldoKas =
        Number(
            dashboardCashBalance.value
        ) || 0;

    // Total inventaris diambil dari satu dokumen ringkasan
    // yang sudah dipelihara Cloud Function.
    const inventoryTotals =
        state.summaryData
            ?.inventoryTotals ||
        {};

    kpis.totalUnitStok =
        Number(
            inventoryTotals.totalUnitStok
        ) || 0;

    kpis.totalNilaiStokHPP =
        Number(
            inventoryTotals.totalNilaiStokHPP
        ) || 0;

    if (
        dashboardSummaryV2.globalReady ===
        true
    ) {
        const globalMetrics =
            dashboardSummaryV2.global ||
            {};

        kpis.saldoKas =
            Number(
                globalMetrics.cashBalance
            ) || 0;

        kpis.danaBelumCair =
            Number(
                globalMetrics.pendingFunds
            ) || 0;

        kpis.qtyBelumCair =
            Number(
                globalMetrics.pendingQty
            ) || 0;

        kpis.totalUnitStok =
            Number(
                globalMetrics.totalUnitStok
            ) || 0;

        kpis.totalNilaiStokHPP =
            Number(
                globalMetrics.totalNilaiStokHPP
            ) || 0;
    }

    return kpis;
});

const dataHealthAudit = computed(() => {
    const issues = [];

    const addIssue = (level, title, description, location) => {
        issues.push({
            id: `${level}-${title}-${issues.length}`,
            level,
            title,
            description,
            location
        });
    };

    (state.produk || []).forEach(product => {
        if (!product.sku) {
            addIssue(
                'danger',
                'Produk tanpa SKU',
                'Produk ini belum memiliki SKU. SKU dibutuhkan untuk stok, transaksi, retur, dan laporan.',
                product.nama || product.product_name || 'Produk'
            );
        }

        if (!product.hpp || Number(product.hpp) <= 0) {
            addIssue(
                'warning',
                'Produk belum punya HPP',
                'HPP kosong bisa membuat laba kotor dan laba bersih tidak akurat.',
                product.sku || product.nama || product.product_name || 'Produk'
            );
        }

        if ((Number(product.stokFisik) || 0) < 0) {
            addIssue(
                'danger',
                'Stok produk minus',
                'Stok minus menandakan ada transaksi, retur, atau penyesuaian stok yang perlu dicek.',
                product.sku || product.nama || product.product_name || 'Produk'
            );
        }
    });

    const skuMap = {};

    (state.produk || []).forEach(product => {
        if (!product.sku) return;

        const sku = String(product.sku).toLowerCase();
        skuMap[sku] = (skuMap[sku] || 0) + 1;
    });

    Object.keys(skuMap).forEach(sku => {
        if (skuMap[sku] > 1) {
            addIssue(
                'danger',
                'SKU duplikat',
                `SKU ini dipakai ${skuMap[sku]} kali. SKU duplikat bisa membuat transaksi dan stok salah baca.`,
                sku.toUpperCase()
            );
        }
    });

    (state.transaksi || []).forEach(trx => {
        if (!trx.statusPencairan) {
            addIssue(
                'warning',
                'Transaksi belum punya status pencairan',
                'Status pencairan kosong bisa membuat dashboard dana cair tidak akurat.',
                trx.id || trx.marketplaceOrderId || 'Transaksi'
            );
        }

        (trx.items || []).forEach(item => {
            if (!item.sku) {
                addIssue(
                    'danger',
                    'Item transaksi tanpa SKU',
                    'Ada item transaksi yang tidak memiliki SKU, sehingga stok dan laporan bisa salah.',
                    trx.id || trx.marketplaceOrderId || 'Transaksi'
                );
            }

            if (!item.hpp || Number(item.hpp) <= 0) {
                addIssue(
                    'warning',
                    'Item transaksi tanpa HPP',
                    'HPP pada item transaksi kosong. Laba transaksi bisa tidak akurat.',
                    item.sku || trx.id || 'Transaksi'
                );
            }
        });
    });

    const transaksiKeys = new Set();

    (state.transaksi || []).forEach(trx => {
        [
            trx.id,
            trx.marketplaceOrderId,
            trx.orderId,
            trx.idPesanan,
            trx.nomorPesanan
        ]
            .filter(Boolean)
            .forEach(key => transaksiKeys.add(String(key).toLowerCase()));
    });

    (state.retur || []).forEach(retur => {
        const returKeys = [
            retur.originalTransactionId,
            retur.transactionId,
            retur.marketplaceOrderId,
            retur.orderId,
            retur.idPesanan,
            retur.nomorPesanan
        ]
            .filter(Boolean)
            .map(key => String(key).toLowerCase());

        const punyaTransaksiAsal = returKeys.some(key => transaksiKeys.has(key));

        if (!punyaTransaksiAsal) {
            addIssue(
                'warning',
                'Retur tanpa transaksi asal',
                'Data retur ini tidak menemukan transaksi asal. Jika transaksi sudah dihapus, retur ini bisa membuat laporan terlihat minus.',
                retur.id || 'Retur'
            );
        }
    });

    (state.keuangan || []).forEach(item => {
        if (!item.kategori) {
            addIssue(
                'warning',
                'Data keuangan tanpa kategori',
                'Kategori kosong membuat laporan biaya operasional atau produksi sulit dibaca.',
                item.id || item.jenis || 'Keuangan'
            );
        }
    });

    return {
        issues,
        summary: {
            total: issues.length,
            danger: issues.filter(i => i.level === 'danger').length,
            warning: issues.filter(i => i.level === 'warning').length
        }
    };
});

const namaKainHistory = computed(() => {
    const uniqueNames = new Set(state.gudangKain.map(k => k.namaKain).filter(Boolean));
    return Array.from(uniqueNames).sort();
});

const tokoKainHistory = computed(() => {
    const uniqueToko = new Set(state.gudangKain.map(k => k.toko).filter(Boolean));
    return Array.from(uniqueToko).sort();
});

const totalYardHistory = computed(() => {
    const uniqueYards = new Set(state.gudangKain.map(k => k.sisaYard).filter(y => y !== null));
    return Array.from(uniqueYards).sort((a, b) => a - b);
});

const hargaKainPerYardHistory = computed(() => {
    const uniqueHargas = new Set(state.gudangKain.map(k => k.hargaBeliPerYard).filter(h => h !== null));
    return Array.from(uniqueHargas).sort((a, b) => a - b);
});
const filteredTransaksi = computed(() => {
    let filteredData = filterDataByDate(
        state.transaksi, 
        uiState.posDateFilter, 
        uiState.posStartDate, 
        uiState.posEndDate,
        uiState.posStartMonth,
        uiState.posStartYear,
        uiState.posEndMonth,
        uiState.posEndYear
    );
    
    // BARIS BARUuu: Menambahkan filter berdasarkan channel jika sudah dipilih
    if (uiState.posChannelFilter && uiState.posChannelFilter !== 'all') {
        filteredData = filteredData.filter(trx => trx.channelId === uiState.posChannelFilter);
    }

    return filteredData.sort((a, b) => new Date(b.tanggal) - new Date(a.tanggal));
});
const activeCart = computed(() => state.carts[uiState.activeCartChannel] || []);
const cartSummary = computed(() => {
    const summary = { subtotal: 0, itemCount: 0, discount: { totalDiscount: 0, description: '' }, finalTotal: 0 };
    if (!uiState.activeCartChannel || activeCart.value.length === 0) return summary;
    summary.subtotal = activeCart.value.reduce((sum, item) => sum + (item.hargaJualAktual * item.qty), 0);
    summary.itemCount = activeCart.value.reduce((sum, item) => sum + item.qty, 0);
    summary.discount = calculateBestDiscount(activeCart.value, uiState.activeCartChannel);
    summary.finalTotal = summary.subtotal - summary.discount.totalDiscount;
    return summary;
});
const filteredGudangKain = computed(() => {
    let kainData = [...state.gudangKain];
    const searchTerm = uiState.gudangKainSearch.toLowerCase();

    if (searchTerm) {
        kainData = kainData.filter(kain => 
            kain.namaKain.toLowerCase().includes(searchTerm) ||
            kain.warna.toLowerCase().includes(searchTerm) ||
            kain.toko.toLowerCase().includes(searchTerm)
        );
    }

    kainData.sort((a, b) => {
        switch (uiState.gudangKainSort) {
            case 'nama-asc': return a.namaKain.localeCompare(b.namaKain);
            case 'nama-desc': return b.namaKain.localeCompare(a.namaKain);
            case 'stok-desc': return b.sisaYard - a.sisaYard;
            case 'stok-asc': return a.sisaYard - b.sisaYard;
            case 'tanggal-asc': return new Date(a.tanggalBeli) - new Date(b.tanggalBeli);
            case 'tanggal-desc': default: return new Date(b.tanggalBeli) - new Date(a.tanggalBeli);
        }
    });

    return kainData;
});

// PATCH INVENTORY GROUPS V3
const INVENTORY_MODEL_QUERY_CHUNK_SIZE = 30;

const getInventoryBaseModelName = value => {
    const cleanName =
        String(value || 'Tanpa Nama')
            .trim()
            .replace(/\s+/g, ' ');

    return (
        cleanName.split(' ')[0] ||
        'Tanpa Nama'
    );
};

const getInventoryModelGroupKey = value =>
    `model:${getInventoryBaseModelName(value)
        .toLocaleLowerCase('id-ID')}`;

const inventoryProductGroups = computed(() => {
    const loadedProducts =
        state.inventoryPaginated || [];

    const searchTerm =
        String(uiState.inventorySearch || '')
            .trim()
            .toLocaleLowerCase('id-ID');

    const stockFilter =
        uiState.inventoryFilterStock;

    const minStock =
        Number(state.settings.minStok) || 0;

    // Beberapa entri Pengaturan dapat memiliki ID berbeda,
    // tetapi nama model dasar yang sama (contoh: AISHA).
    // Gabungkan semuanya sebelum membuat baris induk inventaris.
    const groupedModels = new Map();

    (
        state.settings.modelProduk ||
        []
    ).forEach(model => {
        const modelId = model?.id;

        if (
            modelId === undefined ||
            modelId === null ||
            modelId === ''
        ) {
            return;
        }

        const fullModelName =
            String(
                model.namaModel ||
                'Tanpa Nama'
            )
                .trim()
                .replace(/\s+/g, ' ');

        const displayModelName =
            getInventoryBaseModelName(
                fullModelName
            );

        const groupKey =
            getInventoryModelGroupKey(
                fullModelName
            );

        if (!groupedModels.has(groupKey)) {
            groupedModels.set(groupKey, {
                groupKey,
                namaModel:
                    displayModelName,
                modelIds: [],
                fullModelNames: []
            });
        }

        const targetGroup =
            groupedModels.get(groupKey);

        const alreadyHasModelId =
            targetGroup.modelIds.some(
                savedId =>
                    String(savedId) ===
                    String(modelId)
            );

        if (!alreadyHasModelId) {
            targetGroup.modelIds.push(
                modelId
            );
        }

        if (
            !targetGroup.fullModelNames
                .includes(fullModelName)
        ) {
            targetGroup.fullModelNames.push(
                fullModelName
            );
        }
    });

    let groups =
        Array.from(
            groupedModels.values()
        ).map(group => {
            const modelIdKeys =
                new Set(
                    group.modelIds.map(
                        modelId =>
                            String(modelId)
                    )
                );

            const variants =
                loadedProducts.filter(
                    product =>
                        modelIdKeys.has(
                            String(
                                product.model_id ||
                                ''
                            )
                        )
                );

            const totalStock =
                variants.reduce(
                    (sum, product) =>
                        sum +
                        (
                            Number(
                                product.stokFisik
                            ) || 0
                        ),
                    0
                );

            const totalNilaiStok =
                variants.reduce(
                    (sum, product) =>
                        sum +
                        (
                            (
                                Number(
                                    product.stokFisik
                                ) || 0
                            ) *
                            (
                                Number(
                                    product.hpp
                                ) || 0
                            )
                        ),
                    0
                );

            return {
                ...group,
                namaModelLengkap:
                    group.fullModelNames
                        .join(' '),
                variants,
                totalStock,
                totalNilaiStok,
                isLoaded:
                    inventoryModelLoaded[
                        group.groupKey
                    ] === true,
                isLoading:
                    inventoryModelLoading[
                        group.groupKey
                    ] === true,
                error:
                    inventoryModelErrors[
                        group.groupKey
                    ] || ''
            };
        });

    if (searchTerm) {
        groups = groups.filter(group => {
            const modelMatch =
                group.namaModel
                    .toLocaleLowerCase(
                        'id-ID'
                    )
                    .includes(searchTerm) ||
                group.namaModelLengkap
                    .toLocaleLowerCase(
                        'id-ID'
                    )
                    .includes(searchTerm);

            const loadedVariantMatch =
                group.variants.some(
                    variant =>
                        String(
                            variant.sku || ''
                        )
                            .toLocaleLowerCase(
                                'id-ID'
                            )
                            .includes(
                                searchTerm
                            ) ||
                        String(
                            variant.nama || ''
                        )
                            .toLocaleLowerCase(
                                'id-ID'
                            )
                            .includes(
                                searchTerm
                            )
                );

            return (
                modelMatch ||
                loadedVariantMatch
            );
        });
    }

    // Filter stok hanya diterapkan pada grup yang sudah dibuka,
    // karena stok grup yang belum dibuka belum dibaca dari Firestore.
    if (stockFilter !== 'all') {
        groups = groups.filter(group => {
            if (!group.isLoaded) {
                return false;
            }

            if (stockFilter === 'aman') {
                return (
                    group.totalStock >
                    minStock
                );
            }

            if (
                stockFilter ===
                'menipis'
            ) {
                return (
                    group.totalStock > 0 &&
                    group.totalStock <=
                        minStock
                );
            }

            if (stockFilter === 'habis') {
                return (
                    group.totalStock === 0
                );
            }

            return true;
        });
    }

    groups.sort((a, b) => {
        switch (
            uiState.inventorySort
        ) {
            case 'nama-desc':
                return b.namaModel
                    .localeCompare(
                        a.namaModel,
                        'id',
                        {
                            numeric: true
                        }
                    );

            case 'stok-desc':
                return (
                    b.totalStock -
                    a.totalStock
                );

            case 'stok-asc':
                return (
                    a.totalStock -
                    b.totalStock
                );

            case 'nama-asc':
            default:
                return a.namaModel
                    .localeCompare(
                        b.namaModel,
                        'id',
                        {
                            numeric: true
                        }
                    );
        }
    });

    const sizeOrder = {
        xxs: 1,
        xs: 2,
        s: 3,
        m: 4,
        l: 5,
        xl: 6,
        xxl: 7,
        xxxl: 8,
        xxxxl: 9,
        xxxxxl: 10,
        27: 20,
        28: 21,
        29: 22,
        30: 23,
        31: 24,
        32: 25,
        33: 26,
        34: 27,
        35: 28,
        36: 29,
        37: 30,
        38: 31,
        39: 32,
        40: 33,
        41: 34,
        42: 35,
        43: 36,
        44: 37,
        45: 38,
        46: 39,
        allsize: 90,
        satuukuran: 90
    };

    groups.forEach(group => {
        group.variants.sort(
            (a, b) => {
                const colorCompare =
                    String(
                        a.warna || ''
                    ).localeCompare(
                        String(
                            b.warna || ''
                        ),
                        'id',
                        {
                            numeric: true
                        }
                    );

                if (
                    colorCompare !== 0
                ) {
                    return colorCompare;
                }

                const sizeA =
                    sizeOrder[
                        String(
                            a.varian || ''
                        ).toLowerCase()
                    ] || 999;

                const sizeB =
                    sizeOrder[
                        String(
                            b.varian || ''
                        ).toLowerCase()
                    ] || 999;

                return sizeA - sizeB;
            }
        );
    });

    return groups;
});

const allProductGroups = computed(() => {
    // Fungsi ini sama persis seperti inventoryProductGroups, TAPI menggunakan state.produk
    const grouped = state.produk.reduce((acc, product) => { 
        const model = state.settings.modelProduk.find(m => m.id === product.model_id);
        const modelName = model ? model.namaModel.split(' ')[0] : 'N/A';

        if (!acc[modelName]) {
            acc[modelName] = {
                namaModel: modelName,
                variants: [],
                totalStock: 0,
                totalNilaiStok: 0,
            };
        }
        acc[modelName].variants.push(product);
        acc[modelName].totalStock += (product.stokFisik || 0);
        acc[modelName].totalNilaiStok += (product.stokFisik || 0) * (parseInputNumber(product.hpp) || 0);
        return acc;
    }, {});

    // ... (Salin semua sisa kode dari inventoryProductGroups ke sini, mulai dari 'let productGroups = ...' sampai selesai)
    // Ini bagian untuk filtering dan sorting
    let productGroups = Object.values(grouped);
    // ... dan seterusnya ...
    return productGroups;
});

const promosiProductModels = computed(() => {
  if (!sortedProduk.value) return [];
  // Mengambil nama model dasar dari setiap produk yang sudah terurut
  const modelNames = sortedProduk.value.map(product => {
    const model = state.settings.modelProduk.find(m => m.id === product.model_id);
    return model ? model.namaModel.split(' ')[0] : 'N/A';
  });
  // Mengembalikan daftar nama model yang unik dan terurut
  return Array.from(new Set(modelNames)).sort();
});

const filteredVoucherTypes = computed(() => {
    if (uiState.notesData.type === 'model') {
        return ['Voucher Produk Tertentu', 'Diskon Minimal Belanja Bertingkat'];
    }
    if (uiState.notesData.type === 'channel') {
        return ['Voucher Ikuti Toko', 'Voucher Semua Produk'];
    }
    return []; // Default, jika belum dipilih
});

const modalStockSummary = computed(() => {
    if (uiState.modalType !== 'kelolaStok' || !uiState.modalData.original) {
        return { teralokasi: 0, belumTeralokasi: 0 };
    }
    const { product } = uiState.modalData;
    const teralokasi = Object.values(product.stokAlokasi).reduce((sum, val) => sum + (val || 0), 0);
    const belumTeralokasi = (product.stokFisik || 0) - teralokasi;
    return { teralokasi, belumTeralokasi };
});

const laporanTotalBiayaJasa = computed(() => {
    // Pastikan data batches sudah tersedia
    if (!uiState.laporanData.laporanPerStatus || uiState.laporanData.laporanPerStatus.length === 0) {
        return 0;
    }

    // Filter ulang batches berdasarkan jenis pekerja yang dipilih
    const filteredBatches = uiState.laporanData.laporanPerStatus.filter(batch => {
        const matchesType = uiState.produksiFilterType === 'all' || batch.produksiType === uiState.produksiFilterType;
        const matchesStatus = uiState.laporanData.statusTerpilih === 'Semua' || batch.statusProses === uiState.laporanData.statusTerpilih;
        return matchesType && matchesStatus;
    });

    // Kalkulasi total biaya Jasa berdasarkan item yang sudah difilter
    return filteredBatches.reduce((total, batch) => {
        // Cek jenis pekerja dari batch dan gunakan harga yang sesuai
        const hargaJasa = batch.produksiType === 'penjahit' ? 'hargaJahitPerPcs' : 'hargaMaklunPerPcs';
        const totalHargaJasaBatch = (batch.kainBahan || []).reduce((subtotal, item) => {
            return subtotal + ((item.aktualJadi || 0) * (item[hargaJasa] || 0));
        }, 0);
        return total + totalHargaJasaBatch;
    }, 0);
});


const filteredRetur = computed(() => {
    // 1. "Bongkar" data retur menjadi daftar item yang rata (flattened list)
    const flatReturItems = (state.retur || []).flatMap(doc => 
        (doc.items || []).map(itemDetail => ({
            ...itemDetail, 
            returnDocId: doc.id, 
            tanggal: doc.tanggal,
            channelId: doc.channelId,
            originalTransactionId: doc.originalTransactionId // <--- PENTING: Tambahkan baris ini
        }))
    );

    // 2. Lakukan filter seperti biasa pada daftar yang sudah rata
    let returData = flatReturItems;
    const searchQuery = uiState.returPageSearchQuery.toLowerCase();
    if (searchQuery) {
        returData = returData.filter(item => {
            const product = getProductBySku(item.sku);
            const productName = product ? product.nama.toLowerCase() : '';
            return (
                item.sku.toLowerCase().includes(searchQuery) ||
                (item.alasan && item.alasan.toLowerCase().includes(searchQuery)) ||
                productName.includes(searchQuery)
            );
        });
    }

    returData = filterDataByDate(
        returData, 
        uiState.returPageDateFilter, 
        uiState.returPageStartDate, 
        uiState.returPageEndDate,
        uiState.returPageStartMonth,
        uiState.returPageStartYear,
        uiState.returPageEndMonth,
        uiState.returPageEndYear
    );

    return returData.sort((a, b) => new Date(b.tanggal) - new Date(a.tanggal));
});



const filteredMarketplaces = computed(() => {
    // Memberikan nilai default array kosong jika state.settings.marketplaces undefined
    const marketplacesData = state.settings.marketplaces || [];
    const query = uiState.pengaturanMarketplaceSearch.toLowerCase();
    if (!query) {
        return marketplacesData;
    }
    return marketplacesData.filter(mp => 
        (mp.name || '').toLowerCase().includes(query)
    );
});

// GANTI SELURUH COMPUTED PROPERTY INI
const filteredModelProduk = computed(() => {
    const modelProdukData = state.settings.modelProduk || [];
    const query = uiState.pengaturanModelProdukSearch.toLowerCase();

    const filteredModels = modelProdukData.filter(model =>
        (model.namaModel || '').toLowerCase().includes(query)
    );
    
    // Kita tidak lagi menggabungkan data produk, hanya menampilkan model itu sendiri
    return filteredModels;
});

const filteredProduksiBatches = computed(() => {
    if (!state.produksi) {
        return [];
    }

    let filteredData = state.produksi;

    // Filter berdasarkan jenis pekerja (Pemaklun/Penjahit)
    if (uiState.produksiFilterType && uiState.produksiFilterType !== 'all') {
        filteredData = filteredData.filter(batch => batch.produksiType === uiState.produksiFilterType);
    }
    
    // Filter berdasarkan status proses
    if (uiState.produksiFilterStatus !== 'all') {
        filteredData = filteredData.filter(batch => batch.statusProses === uiState.produksiFilterStatus);
    }

    // Filter berdasarkan pencarian
    const searchTerm = uiState.produksiSearch.toLowerCase();
    if (searchTerm) {
        filteredData = filteredData.filter(batch => 
            (batch.id || '').toLowerCase().includes(searchTerm) ||
            (batch.namaStatus && batch.namaStatus.toLowerCase().includes(searchTerm)) ||
            (batch.kainBahan || []).some(item =>
                (item.idUnik || '').toLowerCase().includes(searchTerm) ||
                (item.namaKain || '').toLowerCase().includes(searchTerm) ||
                (item.warnaKain || '').toLowerCase().includes(searchTerm) ||
                (item.ukuran || '').toLowerCase().includes(searchTerm)
            )
        );
    }

    return filteredData;
});

const sortedProduk = computed(() => {
    const products = [...state.produk];

    // Objek untuk menentukan urutan ukuran khusus (logis)
    const sizeOrder = {
        'xxs': 1, 'xs': 2, 's': 3, 'm': 4, 'l': 5, 'xl': 6, 'xxl': 7, 'xxxl': 8, 'xxxxl': 9, 'xxxxxl': 10,
        '27': 20, '28': 21, '29': 22, '30': 23, '31': 24, '32': 25, '33': 26, '34': 27, '35': 28, '36': 29,
        '37': 30, '38': 31, '39': 32, '40': 33, '41': 34, '42': 35, '43': 36, '44': 37, '45': 38, '46': 39,
        'allsize': 90, 'satuukuran': 90
    };

    // Fungsi perbandingan yang lebih cerdas
    function compareSizes(a, b) {
        const sizeA = (a || '').toLowerCase().trim();
        const sizeB = (b || '').toLowerCase().trim();
        
        // Menggunakan nilai numerik dari sizeOrder untuk urutan yang konsisten
        const orderA = sizeOrder[sizeA] || 999;
        const orderB = sizeOrder[sizeB] || 999;

        // Jika kedua ukuran ditemukan di sizeOrder, urutkan berdasarkan nilainya
        if (orderA !== 999 && orderB !== 999) {
            return orderA - orderB;
        }

        // Jika salah satu adalah angka murni (misal: "38"), urutkan secara numerik
        const numA = parseInt(sizeA, 10);
        const numB = parseInt(sizeB, 10);
        if (!isNaN(numA) && !isNaN(numB)) {
            return numA - numB;
        }
        
        // Jika tidak ada yang cocok, gunakan perbandingan string biasa
        return sizeA.localeCompare(sizeB);
    }

    // Lakukan pengurutan bertingkat
    return products.sort((a, b) => {
        // 1. Urutkan berdasarkan Nama Model
        const modelA = state.settings.modelProduk.find(m => m.id === a.model_id)?.namaModel || a.nama;
        const modelB = state.settings.modelProduk.find(m => m.id === b.model_id)?.namaModel || b.nama;
        const modelCompare = modelA.localeCompare(modelB);
        if (modelCompare !== 0) return modelCompare;

        // 2. Urutkan berdasarkan Warna
        const colorCompare = (a.warna || '').localeCompare(b.warna || '');
        if (colorCompare !== 0) return colorCompare;

        // 3. Urutkan berdasarkan Ukuran dengan fungsi perbandingan yang baru
        return compareSizes(a.varian, b.varian);
    });
});

const filteredPurchaseOrders = computed(() => {
    let orders = [...state.purchaseOrders];

    // --- Terapkan Filter Waktu ---
    orders = filterDataByDate(
        orders.map(o => ({ ...o, tanggal: o.tanggal })),
        uiState.purchaseOrderDateFilter,
        uiState.purchaseOrderStartDate,
        uiState.purchaseOrderEndDate,
        uiState.purchaseOrderStartMonth,
        uiState.purchaseOrderStartYear,
        uiState.purchaseOrderEndMonth,
        uiState.purchaseOrderEndYear
    );

    // --- Terapkan Filter Nama Supplier & SKU ---
    const searchTerm = uiState.purchaseOrderSearch.toLowerCase();
    if (searchTerm) {
        orders = orders.filter(order =>
            order.supplierName.toLowerCase().includes(searchTerm) ||
            order.produk.some(item => item.sku.toLowerCase().includes(searchTerm))
        );
    }

    // --- Terapkan Filter Status Proses ---
    if (uiState.purchaseOrderStatusProsesFilter !== 'all') {
        orders = orders.filter(order => 
        (order.produk || []).some(p => p.statusProses === uiState.purchaseOrderStatusProsesFilter)
    );
}
    
    // --- Terapkan Filter Status Bayar ---
    if (uiState.purchaseOrderStatusBayarFilter !== 'all') {
        orders = orders.filter(order => order.statusPembayaran === uiState.purchaseOrderStatusBayarFilter);
    }

    // --- Terapkan Logika Pengurutan ---
    return orders.sort((a, b) => {
        switch (uiState.purchaseOrderSort) {
            case 'total-desc':
                return b.totalQtyValue - a.totalQtyValue;
            case 'total-asc':
                return a.totalQtyValue - b.totalQtyValue;
            default: // 'tanggal-desc'
                return new Date(b.tanggal) - new Date(a.tanggal);
        }
    });
});

const itemizedPurchaseHistory = computed(() => {
    // Langkah 1: Dapatkan semua item produk seperti sebelumnya
    let allItems = filteredPurchaseOrders.value.flatMap(order => 
        (order.produk || []).map(item => ({
            ...item,
            orderId: order.id,
            tanggal: order.tanggal,
            supplierName: order.supplierName,
            orderStatusProses: order.statusProses,
            orderStatusPembayaran: order.statusPembayaran
        }))
    );

    // --- PERBAIKAN DI SINI ---
    // Langkah 2: Tambahkan logika filter berdasarkan status inventaris
    const filterStatus = uiState.purchaseOrderItemStatusFilter;
    if (filterStatus !== 'all') {
        allItems = allItems.filter(item => {
            if (filterStatus === 'sudahMasuk') {
                return item.isInventoried === true;
            }
            if (filterStatus === 'belumMasuk') {
                return !item.isInventoried;
            }
            return true;
        });
    }

    return allItems;
});

const ringkasanJadiData = computed(() => {
    const summary = {};
    
    // Pertama, filter batches berdasarkan status dan jenis pekerja
    const filteredBatches = state.produksi.filter(batch => {
        const matchesStatus = uiState.ringkasanStatusSelected === 'all' || batch.statusProses === uiState.ringkasanStatusSelected;
        const matchesType = uiState.produksiFilterType === 'all' || batch.produksiType === uiState.produksiFilterType;
        return matchesStatus && matchesType;
    });
    
    // Kemudian, proses data dari batches yang sudah difilter
    filteredBatches.forEach(batch => {
        (batch.kainBahan || []).forEach(kb => {
            if (kb.aktualJadi > 0) {
                const modelName = state.settings.modelProduk.find(m => m.id === kb.modelProdukId)?.namaModel || 'N/A';
                const key = `${batch.tanggal}|${batch.namaPemaklun}|${modelName}|${kb.namaKain}|${kb.warnaKain}|${kb.ukuran}`;
                if (!summary[key]) {
                    summary[key] = { tanggal: batch.tanggal, pemaklun: batch.namaPemaklun, model: modelName, kain: kb.namaKain, warna: kb.warnaKain, ukuran: kb.ukuran, total: 0 };
                }
                summary[key].total += kb.aktualJadi;
            }
        });
    });
    return Object.values(summary).sort((a, b) => new Date(b.tanggal) - new Date(a.tanggal));
});

const produksiDetailComputed = computed(() => {
    const batch = uiState.modalType === 'editProduksi' ? uiState.editProduksiBatch : uiState.modalData;

    if (!batch || !batch.kainBahan) {
        return { ...batch, totalAktualJadi: 0 };
    }

    const total = batch.kainBahan.reduce((sum, item) => {
        return sum + (parseInt(item.aktualJadi, 10) || 0);
    }, 0);

    return {
        ...batch,
        totalAktualJadi: total
    };
});


const voucherTokoDiskonNominalComputed = (channel) => computed({
    get() {
        const promo = state.promotions.perChannel[channel.id]?.voucherToko;
        return promo?.diskonNominal ? formatInputNumber(promo.diskonNominal) : '';
    },
    set(newValue) {
        if (!state.promotions.perChannel[channel.id]) state.promotions.perChannel[channel.id] = {};
        if (!state.promotions.perChannel[channel.id].voucherToko) state.promotions.perChannel[channel.id].voucherToko = {};
        
        const nominal = parseInputNumber(newValue);
        state.promotions.perChannel[channel.id].voucherToko.diskonNominal = nominal > 0 ? nominal : null;
        // Otomatis kosongkan diskon rate jika nominal diisi
        if (nominal > 0) {
            state.promotions.perChannel[channel.id].voucherToko.diskonRate = null;
        }
    }
});

const voucherSemuaProdukDiskonNominalComputed = (channel) => computed({
    get() {
        const promo = state.promotions.perChannel[channel.id]?.voucherSemuaProduk;
        return promo?.diskonNominal ? formatInputNumber(promo.diskonNominal) : '';
    },
    set(newValue) {
        if (!state.promotions.perChannel[channel.id]) state.promotions.perChannel[channel.id] = {};
        if (!state.promotions.perChannel[channel.id].voucherSemuaProduk) state.promotions.perChannel[channel.id].voucherSemuaProduk = {};
        
        const nominal = parseInputNumber(newValue);
        state.promotions.perChannel[channel.id].voucherSemuaProduk.diskonNominal = nominal > 0 ? nominal : null;
        if (nominal > 0) {
            state.promotions.perChannel[channel.id].voucherSemuaProduk.diskonRate = null;
        }
    }
});

const diskonNominalComputed = (modelName, channelId) => computed({
    get() {
        const promo = state.promotions.perModel[modelName]?.[channelId];
        return promo?.diskonNominal ? formatInputNumber(promo.diskonNominal) : '';
    },
    set(newValue) {
        if (!state.promotions.perModel[modelName]) state.promotions.perModel[modelName] = {};
        if (!state.promotions.perModel[modelName][channelId]) state.promotions.perModel[modelName][channelId] = {};

        const nominal = parseInputNumber(newValue);
        state.promotions.perModel[modelName][channelId].diskonNominal = nominal > 0 ? nominal : null;
        if (nominal > 0) {
            state.promotions.perModel[modelName][channelId].diskonRate = null;
        }
    }
});

const tieredDiskonNominalComputed = (tier) => computed({
    get() { 
        return tier.diskonNominal ? formatInputNumber(tier.diskonNominal) : ''; 
    },
    set(newValue) { 
        const nominal = parseInputNumber(newValue);
        tier.diskonNominal = nominal > 0 ? nominal : null;
        if (nominal > 0) {
            tier.diskon = null;
        }
    }
});

// Perbarui computed property yang lama agar bisa mengosongkan nilai nominal
const voucherTokoDiskonRateComputedUpdated = (channel) => computed({
    get() {
        const promo = state.promotions.perChannel[channel.id]?.voucherToko;
        return promo?.diskonRate ? promo.diskonRate + '%' : '';
    },
    set(newValue) {
        if (!state.promotions.perChannel[channel.id]) state.promotions.perChannel[channel.id] = {};
        if (!state.promotions.perChannel[channel.id].voucherToko) state.promotions.perChannel[channel.id].voucherToko = {};
        
        const rate = parsePercentageInput(newValue);
        state.promotions.perChannel[channel.id].voucherToko.diskonRate = rate > 0 ? rate : null;
        if (rate > 0) {
            state.promotions.perChannel[channel.id].voucherToko.diskonNominal = null;
        }
    }
});

const voucherSemuaProdukDiskonRateComputedUpdated = (channel) => computed({
    get() {
        const promo = state.promotions.perChannel[channel.id]?.voucherSemuaProduk;
        return promo?.diskonRate ? promo.diskonRate + '%' : '';
    },
    set(newValue) {
        if (!state.promotions.perChannel[channel.id]) state.promotions.perChannel[channel.id] = {};
        if (!state.promotions.perChannel[channel.id].voucherSemuaProduk) state.promotions.perChannel[channel.id].voucherSemuaProduk = {};
        
        const rate = parsePercentageInput(newValue);
        state.promotions.perChannel[channel.id].voucherSemuaProduk.diskonRate = rate > 0 ? rate : null;
        if (rate > 0) {
            state.promotions.perChannel[channel.id].voucherSemuaProduk.diskonNominal = null;
        }
    }
});

const diskonRateComputedUpdated = (modelName, channelId) => computed({
    get() {
        const promo = state.promotions.perModel[modelName]?.[channelId];
        return promo?.diskonRate ? promo.diskonRate + '%' : '';
    },
    set(newValue) {
        if (!state.promotions.perModel[modelName]) state.promotions.perModel[modelName] = {};
        if (!state.promotions.perModel[modelName][channelId]) state.promotions.perModel[modelName][channelId] = {};

        const rate = parsePercentageInput(newValue);
        state.promotions.perModel[modelName][channelId].diskonRate = rate > 0 ? rate : null;
        if (rate > 0) {
            state.promotions.perModel[modelName][channelId].diskonNominal = null;
        }
    }
});

const tieredDiskonComputedUpdated = (tier) => computed({
    get() { 
        return tier.diskon ? tier.diskon + '%' : ''; 
    },
    set(newValue) { 
        const rate = parsePercentageInput(newValue);
        tier.diskon = rate > 0 ? rate : null;
        if (rate > 0) {
            tier.diskonNominal = null;
        }
    }
});

const laporanSemuanyaData = computed(() => {
    // Awalnya, ambil semua item produksi dari setiap batch
    let semuaItemProduksi = state.produksi.flatMap(batch =>
        (batch.kainBahan || []).map(kain => ({
            ...kain,
            batchId: batch.id,
            tanggal: batch.tanggal,
            namaStatus: batch.namaStatus, // Memastikan nama pekerja ada
            produksiType: batch.produksiType, // Memastikan jenis pekerja ada
            statusProses: batch.statusProses,
        }))
    );

    // Filter berdasarkan jenis pekerja yang dipilih
    if (uiState.produksiFilterType !== 'all') {
        semuaItemProduksi = semuaItemProduksi.filter(item => item.produksiType === uiState.produksiFilterType);
    }
    
    // Terapkan filter tanggal setelah filter jenis pekerja
    const filteredData = filterDataByDate(
        semuaItemProduksi,
        uiState.laporanSemuaFilter,
        uiState.laporanSemuaStartDate,
        uiState.laporanSemuaEndDate,
        uiState.laporanSemuaStartMonth,
        uiState.laporanSemuaStartYear,
        uiState.laporanSemuaEndMonth,
        uiState.laporanSemuaEndYear
    );

    const tableData = filteredData.map(item => {
        const modelInfo = state.settings.modelProduk.find(m => m.id === item.modelProdukId) || {};
        const totalBiayaKain = (item.totalYard || 0) * (item.hargaKainPerYard || 0);
        const hargaJasaPerPcs = item.produksiType === 'penjahit' ? (item.hargaJahitPerPcs || 0) : (item.hargaMaklunPerPcs || 0);
        
        // [PERBAIKAN KUNCI DI SINI]
        // Biaya Jasa dan Biaya Alat sekarang HANYA dihitung berdasarkan 'aktualJadi'
        const totalBiayaJasa = (item.aktualJadi || 0) * hargaJasaPerPcs;
        const totalBiayaAlat = (item.aktualJadi || 0) > 0 ? (item.biayaAlat || 0) : 0;
        
        const totalBiayaProduksi = totalBiayaKain + totalBiayaJasa + totalBiayaAlat;
        
        return {
            ...item,
            modelNama: modelInfo.namaModel || 'N/A',
            totalBiayaKain,
            totalBiayaMaklun: totalBiayaJasa,
            totalBiayaAlat,
            totalBiayaProduksi,
            totalKuantitas: (item.aktualJadi || 0) + (item.aktualJadiKombinasi || 0),
        };
    }).sort((a, b) => new Date(b.tanggal) - new Date(a.tanggal));

    return { tableData };
});


const laporanSemuaKpis = computed(() => {
    const tableData = laporanSemuanyaData.value.tableData;
    if (!tableData || tableData.length === 0) {
        return { totalModelSelesai: 0, totalBiaya: 0, avgHpp: 0, totalBatch: 0 };
    }

    // [PERBAIKAN] Hanya menghitung dari 'aktualJadi' sesuai permintaan
    const totalModelSelesai = tableData.reduce((sum, item) => sum + (item.aktualJadi || 0), 0);

    const totalBiaya = tableData.reduce((sum, item) => sum + item.totalBiayaProduksi, 0);
    const avgHpp = totalModelSelesai > 0 ? totalBiaya / totalModelSelesai : 0;
    const totalBatch = new Set(tableData.map(item => item.batchId)).size;

    return { totalModelSelesai, totalBiaya, avgHpp, totalBatch };
});
const analisisModelData = computed(() => {
    console.log("--- MEMULAI ANALISIS ---");

    const dataPerKain = state.produksi.flatMap(batch =>
        (batch.kainBahan || []).map(kain => ({
            ...kain,
            batchId: batch.id,
            tanggal: batch.tanggal,
            namaStatus: batch.namaStatus,
            produksiType: batch.produksiType,
            statusProses: batch.statusProses,
        }))
    );
    console.log("1. Total item produksi yang ditemukan:", dataPerKain.length, dataPerKain);
    console.log("2. Filter yang sedang aktif:", { 
        filterMode: uiState.analisisModelFilter,
        selectedModelId: uiState.analisisModelSelectedModel, 
        workerType: uiState.produksiFilterType,
        actualType: uiState.analisisModelSelectedType
    });

    let filteredData = dataPerKain.filter(item => {
        const matchesType = uiState.produksiFilterType === 'all' || item.produksiType === uiState.produksiFilterType;
        const matchesModel = uiState.analisisModelFilter === 'all' || (uiState.analisisModelFilter === 'model' && item.modelProdukId === uiState.analisisModelSelectedModel);
        return matchesType && matchesModel;
    });
    console.log("3. Data setelah difilter berdasarkan Model & Jenis Status:", filteredData.length, filteredData);

    const processedData = filteredData.map(item => {
        const modelInfo = state.settings.modelProduk.find(m => m.id === item.modelProdukId) || {};
        const totalBiayaKain = (item.totalYard || 0) * (item.hargaKainPerYard || 0);
        const yardStandar = modelInfo.yardPerModel || 1;
        const hargaJasaPerPcs = item.produksiType === 'penjahit' ? (item.hargaJahitPerPcs || 0) : (item.hargaMaklunPerPcs || 0);
        const targetQty = Math.floor((item.totalYard || 0) / yardStandar);
        let aktualFinal = 0;
        let totalBiayaJasa = 0;
        let totalBiayaAlat = 0;
        if (uiState.analisisModelSelectedType === 'aktualJadi' && item.aktualJadi > 0) {
            aktualFinal = (item.aktualJadi || 0);
            totalBiayaJasa = aktualFinal * hargaJasaPerPcs;
            totalBiayaAlat = (item.biayaAlat || 0);
        } else if (uiState.analisisModelSelectedType === 'aktualJadiKombinasi' && item.aktualJadiKombinasi > 0) {
            aktualFinal = (item.aktualJadiKombinasi || 0);
            totalBiayaJasa = 0;
            totalBiayaAlat = 0;
        }
        const selisih = aktualFinal - targetQty;
        const totalBiayaProduksi = totalBiayaKain + totalBiayaJasa + totalBiayaAlat;
        const hpp = totalBiayaProduksi / (aktualFinal || 1);
        return {
            ...item,
            modelNama: modelInfo.namaModel || 'N/A',
            targetQty: targetQty,
            aktualFinal: aktualFinal,
            selisih: selisih,
            hpp: hpp,
        };
    });
    console.log("4. Data setelah diproses (sebelum filter aktual > 0):", processedData.length, processedData);
    
    const finalData = processedData.filter(item => item.aktualFinal > 0);
    console.log("5. Data FINAL yang akan ditampilkan di tabel:", finalData.length, finalData);

    const sortedData = finalData.sort((a, b) => a.selisih - b.selisih);
    const limit = parseInt(uiState.analisisModelLimit, 10);
    const finalResult = limit > 0 ? sortedData.slice(0, limit) : sortedData;
    console.log("--- ANALISIS SELESAI ---");
    return finalResult;
});

const dashboardWorkflowMetrics = computed(() => {
    // Gunakan tanggal hasil filter Dashboard; transaksi yang cair difilter berdasarkan tanggal pencairan.
    const periodTransactions = dashboardFilteredData.value.transaksi || [];
    // Legacy marketplace transactions may not have statusDataMarketplace yet.
    const transactions = periodTransactions.filter(transaction =>
        Boolean(String(transaction?.marketplaceOrderId || '').trim()) &&
        Boolean(String(transaction?.channelId || transaction?.channel || '').trim())
    );
    const matchedTransactions = transactions.filter(transaction =>
        String(transaction.statusDataMarketplace || '').trim().toLowerCase() === 'cocok'
    );
    const manuallyConfirmedTransactions = transactions.filter(transaction =>
        transaction.konfirmasiSuksesCairManual === true ||
        String(transaction.statusDataMarketplace || '').trim().toLowerCase() === 'id_sukses_terkonfirmasi'
    );
    const successfulTransactions = [...matchedTransactions, ...manuallyConfirmedTransactions];
    const hpp = transaction => Number(transaction.totalHpp) || (transaction.items || []).reduce(
        (sum, item) => sum + ((Number(item.hpp) || 0) * (Number(item.qty) || 0)), 0
    );
    const incomeRecords = (dashboardFilteredData.value.keuangan || []).filter(record => record.isMarketplaceIncomeReport === true);
    const txDate = transaction => {
        const value = transaction.tanggalPencairan || transaction.tanggalTerkirim || transaction.tanggal;
        return value?.toDate ? value.toDate() : value instanceof Date ? value : value?.seconds ? new Date(value.seconds * 1000) : value ? new Date(value) : null;
    };
    const coveredByPayoutSummary = transaction => incomeRecords.some(record => {
        if (String(record.channelId || '') !== String(transaction.channelId || '')) return false;
        const date = txDate(transaction);
        const start = String(record.periodeMulai || '').slice(0, 10);
        const end = String(record.periodeSelesai || '').slice(0, 10);
        if (!date || !start || !end || Number.isNaN(date.getTime())) return false;
        const key = date.getFullYear() + '-' + String(date.getMonth() + 1).padStart(2, '0') + '-' + String(date.getDate()).padStart(2, '0');
        return key >= start && key <= end;
    });
    const transactionIncome = matchedTransactions.filter(transaction => !coveredByPayoutSummary(transaction))
        .reduce((sum, transaction) => sum + (Number(transaction.penghasilanBersihMarketplace) || 0), 0);
    const payoutIncome = incomeRecords.reduce((sum, record) => sum + (Number(record.jumlah ?? record.amount ?? record.nominal) || 0), 0);
    const netIncome = transactionIncome + payoutIncome;
    const totalHpp = successfulTransactions.reduce((sum, transaction) => sum + hpp(transaction), 0);
    const operatingCosts = (dashboardFilteredData.value.keuangan || [])
        .filter(record => (record.jenis === 'pengeluaran' || record.jenis === 'biaya') &&
            (record.tipeBiaya || getExpenseTypeByCategory(record.kategori)) !== 'produksi')
        .reduce((sum, record) => sum + (Number(record.jumlah) || 0), 0);
    // Pesanan tertunda adalah backlog seluruh waktu, bukan hanya transaksi
    // yang tanggalnya masuk ke filter periode KPI.
    const finalStatuses = new Set([
    'sudahcair',
    'retur',
    'returpengembalian',
    'dikembalikan',
    'pengembalian',
    'baranghilang',
    'hilang',
    'dibatalkan',
    'batal',
    'cancelled',
    'canceled'
]);

const pendingTransactions = (state.pendingSettlements || []).filter(transaction => {
    if (!isActiveExportRecord(transaction)) return false;
    if (!String(transaction.marketplaceOrderId || '').trim()) return false;
    if (!String(transaction.channelId || transaction.channel || '').trim()) return false;

    const status = String(transaction.statusPencairan || '')
        .trim()
        .toLocaleLowerCase('id-ID')
        .replace(/[\s/_-]+/g, '');

    return !finalStatuses.has(status);
});
    const matchedPendingTransactions = pendingTransactions.filter(transaction =>
        String(transaction.statusDataMarketplace || '').trim().toLowerCase() === 'cocok'
    );
    const pendingFunds = matchedPendingTransactions.reduce(
        (sum, transaction) => sum + (Number(transaction.penghasilanBersihMarketplace) || 0), 0
    );
    const pendingQty = pendingTransactions.reduce((sum, transaction) => sum + (transaction.items || []).reduce(
        (itemSum, item) => itemSum + (Number(item.qty) || 0), 0
    ), 0);
    const pendingHpp = pendingTransactions.reduce((sum, transaction) => sum + hpp(transaction), 0);
    const incomeComplete = !manuallyConfirmedTransactions.some(transaction => !coveredByPayoutSummary(transaction));
    return {
        netIncome, totalHpp, operatingCosts,
        netProfit: incomeComplete ? netIncome - totalHpp - operatingCosts : null,
        incomeComplete, pendingFunds, pendingQty, pendingOrders: pendingTransactions.length,
        pendingHpp, pendingMatchedOrders: matchedPendingTransactions.length
    };
});

const dashboardPremiumData = computed(() => {
 const now = new Date(); const today = new Date(now.getFullYear(),now.getMonth(),now.getDate()); const tomorrow = new Date(today); tomorrow.setDate(tomorrow.getDate()+1);
 const newTransactionsToday=(dashboardTodayData.transactions||[]).filter(transaction=>{const date=transaction?.tanggal?.toDate?transaction.tanggal.toDate():new Date(transaction?.tanggal);return Object.prototype.hasOwnProperty.call(transaction||{},'statusDataMarketplace')&&date>=today&&date<tomorrow;});
 const isMatched=transaction=>String(transaction?.statusDataMarketplace||'').trim().toLowerCase()==='cocok';
 const matchedTransactions=newTransactionsToday.filter(isMatched); const pendingTransactions=newTransactionsToday.filter(transaction=>!isMatched(transaction));
 const produkHampirHabis=(state.produk||[]).filter(product=>{const stock=product.stokFisik??product.physical_stock??0;return stock>0&&stock<=(state.settings.minStok||10);}).sort((a,b)=>(a.stokFisik??a.physical_stock??0)-(b.stokFisik??b.physical_stock??0)).slice(0,5);
 const batchBelumSelesai=(state.produksi||[]).filter(batch=>(batch.statusProses||'').toLowerCase()!=='selesai');
 const maklunTerlambat=batchBelumSelesai.filter(batch=>{const date=new Date(batch.tanggal);return(batch.produksiType||'').toLowerCase()==='pemaklun'&&Math.floor((today-date)/(1000*60*60*24))>=14;});
 return {orderHariIni:newTransactionsToday.length,orderMenungguCocok:pendingTransactions.length,orderCocok:matchedTransactions.length,penghasilanCocok:matchedTransactions.reduce((sum,transaction)=>sum+(Number(transaction.penghasilanBersihMarketplace)||0),0),produkHampirHabis,batchBelumSelesai:batchBelumSelesai.length,maklunTerlambat:maklunTerlambat.length};
});



const dashboardSalesStats = computed(() => {
    const modelMap = {};
    const colorMap = {};
    const sizeMap = {};
    const channelMap = {};

    const selectedModel = uiState.dashboardSalesModelFilter;
    const selectedChannel = uiState.dashboardSalesChannelFilter;

    (state.transaksi || []).forEach(transaksi => {
        const channelName = transaksi.channel || transaksi.channelId || 'Tanpa Channel';

        if (selectedChannel !== 'all' && channelName !== selectedChannel) {
            return;
        }

        (transaksi.items || []).forEach(item => {
            const qty = item.qty || 0;

            const productData = (state.produk || []).find(p =>
                p.sku === item.sku ||
                p.docId === item.product_id ||
                p.id === item.product_id
            );

            const masterModel = (state.settings.modelProduk || []).find(m =>
                m.id === productData?.model_id ||
                m.id === productData?.modelId ||
                m.id === item.modelProdukId ||
                m.id === item.model_id
            );

            const modelName = masterModel?.namaModel || 'Tanpa Model';

            if (selectedModel !== 'all' && modelName !== selectedModel) {
                return;
            }

            const colorName =
                item.warna ||
                item.color ||
                productData?.warna ||
                productData?.color ||
                'Tanpa Warna';

            const sizeName =
                item.varian ||
                item.size ||
                item.ukuran ||
                productData?.varian ||
                productData?.variant ||
                productData?.ukuran ||
                'Tanpa Ukuran';

            const itemOmset = (item.hargaJual || item.price || item.harga || 0) * qty;

            if (!modelMap[modelName]) modelMap[modelName] = { name: modelName, qty: 0 };
            if (!colorMap[colorName]) colorMap[colorName] = { name: colorName, qty: 0 };
            if (!sizeMap[sizeName]) sizeMap[sizeName] = { name: sizeName, qty: 0 };
            if (!channelMap[channelName]) channelMap[channelName] = { name: channelName, qty: 0, omset: 0 };

            modelMap[modelName].qty += qty;
            colorMap[colorName].qty += qty;
            sizeMap[sizeName].qty += qty;
            channelMap[channelName].qty += qty;
            channelMap[channelName].omset += itemOmset;
        });
    });

    const sortByQty = data => Object.values(data).sort((a, b) => b.qty - a.qty).slice(0, 3);
    const sortByOmset = data => Object.values(data).sort((a, b) => b.omset - a.omset).slice(0, 3);

    return {
        topModels: sortByQty(modelMap),
        topColors: sortByQty(colorMap),
        topSizes: sortByQty(sizeMap),
        topChannels: sortByOmset(channelMap)
    };
});

const salesPerformanceStats = computed(() => {
    const selectedDate = uiState.salesStatsDateFilter;
    const selectedModel = uiState.salesStatsModelFilter;
    const selectedChannel = uiState.salesStatsChannelFilter;

    const modelMap = {};
    const colorMap = {};
    const sizeMap = {};
    const channelMap = {};
    const productMap = {};

    let totalOrder = 0;
    let totalQty = 0;
    let totalOmset = 0;
    let totalHpp = 0;

    const toDate = (value) => {
        if (!value) return null;
        const date = value?.toDate
            ? value.toDate()
            : value?.seconds
                ? new Date(value.seconds * 1000)
                : new Date(value);

        return isNaN(date.getTime()) ? null : date;
    };

    const isDateIncluded = (dateValue) => {
        if (selectedDate === 'all_time') return true;

        const date = toDate(dateValue);
        if (!date) return false;

        const now = new Date();

        const startToday = new Date();
        startToday.setHours(0, 0, 0, 0);

        const endToday = new Date();
        endToday.setHours(23, 59, 59, 999);

        if (selectedDate === 'today') {
            return date >= startToday && date <= endToday;
        }

        if (selectedDate === 'last_7_days') {
            const start = new Date();
            start.setDate(now.getDate() - 7);
            start.setHours(0, 0, 0, 0);
            return date >= start && date <= now;
        }

        if (selectedDate === 'last_30_days') {
            const start = new Date();
            start.setDate(now.getDate() - 30);
            start.setHours(0, 0, 0, 0);
            return date >= start && date <= now;
        }

        if (selectedDate === 'this_month') {
            return date.getMonth() === now.getMonth() && date.getFullYear() === now.getFullYear();
        }

        return true;
    };

    (state.transaksi || []).forEach(trx => {
        if (!isDateIncluded(trx.tanggal)) return;

        const channelName = trx.channel || trx.channelId || 'Tanpa Channel';

        if (selectedChannel !== 'all' && channelName !== selectedChannel) {
            return;
        }

        let trxIncluded = false;

        (trx.items || []).forEach(item => {
            const qty = Number(item.qty) || 0;
            if (qty <= 0) return;

            const productData = (state.produk || []).find(p =>
                p.sku === item.sku ||
                p.docId === item.product_id ||
                p.id === item.product_id
            );

            const masterModel = (state.settings.modelProduk || []).find(m =>
                m.id === productData?.model_id ||
                m.id === productData?.modelId ||
                m.id === item.modelProdukId ||
                m.id === item.model_id
            );

            const modelName =
                item.modelName ||
                masterModel?.namaModel ||
                productData?.nama ||
                productData?.product_name ||
                'Tanpa Model';

            if (selectedModel !== 'all' && modelName !== selectedModel) {
                return;
            }

            trxIncluded = true;

            const colorName =
                item.warna ||
                item.color ||
                productData?.warna ||
                productData?.color ||
                'Tanpa Warna';

            const sizeName =
                item.varian ||
                item.size ||
                item.ukuran ||
                productData?.varian ||
                productData?.variant ||
                productData?.ukuran ||
                'Tanpa Ukuran';

            const productName =
                productData?.nama ||
                productData?.product_name ||
                modelName;

            const sku = item.sku || productData?.sku || '-';

            const hargaJual = Number(item.hargaJual || item.price || item.harga || 0);
            const hpp = Number(item.hpp || productData?.hpp || 0);

            const itemOmset = hargaJual * qty;
            const itemHpp = hpp * qty;
            const itemProfit = itemOmset - itemHpp;

            totalQty += qty;
            totalOmset += itemOmset;
            totalHpp += itemHpp;

            if (!modelMap[modelName]) {
                modelMap[modelName] = { name: modelName, qty: 0, omset: 0, profit: 0 };
            }

            if (!colorMap[colorName]) {
                colorMap[colorName] = { name: colorName, qty: 0, omset: 0 };
            }

            if (!sizeMap[sizeName]) {
                sizeMap[sizeName] = { name: sizeName, qty: 0, omset: 0 };
            }

            if (!channelMap[channelName]) {
                channelMap[channelName] = { name: channelName, qty: 0, omset: 0, order: 0 };
            }

            if (!productMap[sku]) {
                productMap[sku] = {
                    sku,
                    name: productName,
                    model: modelName,
                    color: colorName,
                    size: sizeName,
                    qty: 0,
                    omset: 0,
                    hpp: 0,
                    profit: 0
                };
            }

            modelMap[modelName].qty += qty;
            modelMap[modelName].omset += itemOmset;
            modelMap[modelName].profit += itemProfit;

            colorMap[colorName].qty += qty;
            colorMap[colorName].omset += itemOmset;

            sizeMap[sizeName].qty += qty;
            sizeMap[sizeName].omset += itemOmset;

            channelMap[channelName].qty += qty;
            channelMap[channelName].omset += itemOmset;

            productMap[sku].qty += qty;
            productMap[sku].omset += itemOmset;
            productMap[sku].hpp += itemHpp;
            productMap[sku].profit += itemProfit;
        });

        if (trxIncluded) {
            totalOrder += 1;
            if (channelMap[channelName]) {
                channelMap[channelName].order += 1;
            }
        }
    });

    const sortByQty = (data) => Object.values(data).sort((a, b) => b.qty - a.qty);
    const sortByOmset = (data) => Object.values(data).sort((a, b) => b.omset - a.omset);

    const grossProfit = totalOmset - totalHpp;

    return {
        totalOrder,
        totalQty,
        totalOmset,
        totalHpp,
        grossProfit,
        averageOrderValue: totalOrder > 0 ? totalOmset / totalOrder : 0,

        topModels: sortByQty(modelMap).slice(0, 10),
        topColors: sortByQty(colorMap).slice(0, 10),
        topSizes: sortByQty(sizeMap).slice(0, 10),
        topChannels: sortByOmset(channelMap).slice(0, 10),
        topProducts: sortByOmset(productMap).slice(0, 20)
    };
});

const kpiExplanations = {
    'saldo-kas': {
    title: 'Saldo Kas Berjalan',
    description: `
Saldo Kas Berjalan menunjukkan total uang kas yang dimiliki bisnis saat ini berdasarkan seluruh transaksi yang telah tercatat.

Perhitungan Saldo Kas Berjalan meliputi:

• Omset Bersih
+ Pemasukan Lain
− Biaya Transaksi
− Seluruh Pengeluaran Kas

Saldo Kas Berjalan tidak mengikuti filter waktu pada Dashboard, sehingga meskipun tidak ada transaksi hari ini, nilai saldo tetap menampilkan posisi kas terbaru.

KPI ini membantu Anda mengetahui jumlah kas yang tersedia secara keseluruhan untuk operasional bisnis.
`
},

    'omset-kotor': {
        title: 'Omset Kotor',
        description: `Omset Kotor adalah total nilai penjualan sebelum dikurangi apa pun.

Contoh:
Jika produk terjual Rp120.000, maka Omset Kotor = Rp120.000.

Omset Kotor belum dikurangi:
- diskon,
- retur,
- biaya marketplace,
- HPP,
- biaya operasional.`
    },

    'omset-bersih': {
        title: 'Omset Bersih',
        description: `Omset Bersih adalah nilai penjualan setelah dikurangi diskon dan retur.

Rumus sederhananya:

Omset Kotor - Diskon - Total Nilai Retur

Angka ini membantu melihat nilai penjualan yang lebih bersih sebelum dikurangi HPP, biaya marketplace, dan biaya operasional.`
    },

    'diskon': {
        title: 'Diskon',
        description: `Diskon adalah total potongan harga yang diberikan ke pembeli.

Contohnya:
- voucher seller,
- diskon produk,
- potongan harga manual,
- promo yang mengurangi nilai penjualan.

Diskon akan mengurangi Omset Kotor.`
    },

    'laba-kotor': {
        title: 'Laba Kotor',
        description: `Laba Kotor adalah keuntungan awal dari penjualan produk.

Rumus sederhananya:

Omset Bersih - Total HPP Terjual

Catatan:
Laba Kotor belum dikurangi biaya marketplace, biaya transaksi, listrik, iklan, gaji, sewa, dan biaya operasional lain.`
    },

    'hpp-terjual': {
        title: 'Total HPP Terjual',
        description: `Total HPP Terjual adalah total modal produk yang sudah terjual.

Contoh:
Jika 1 produk HPP-nya Rp50.000 dan terjual 2 pcs, maka HPP Terjual = Rp100.000.

Catatan penting:
- HPP dihitung saat barang terjual.
- Beli kain atau bahan tidak langsung masuk ke HPP Terjual.
- Beli kain masuk ke stok/persediaan dulu, lalu baru menjadi HPP saat produknya terjual.`
    },

    'biaya-transaksi': {
        title: 'Biaya Transaksi',
        description: `Biaya Transaksi adalah biaya yang muncul dari proses penjualan.

Contohnya:
- biaya admin marketplace,
- komisi marketplace,
- biaya layanan,
- biaya program marketplace,
- potongan transaksi lain.

Biaya ini mengurangi Laba Bersih karena langsung terkait dengan transaksi penjualan.`
    },

    'biaya-operasional': {
        title: 'Biaya Operasional',
        description: `Biaya Operasional adalah pengeluaran harian bisnis yang bukan untuk membeli stok atau produksi barang.

Contoh yang masuk Biaya Operasional:
- listrik,
- internet,
- sewa,
- gaji admin,
- iklan,
- biaya packing operasional,
- kebutuhan toko.

Catatan penting:
Beli kain, bahan, maklun, supplier, atau produksi tidak dimasukkan ke Biaya Operasional.

Beli kain tetap mengurangi Saldo Kas, tapi tidak langsung mengurangi Laba Bersih, karena kain berubah menjadi stok/persediaan.`
    },

    'laba-bersih-operasional': {
        title: 'Laba Bersih',
        description: `Laba Bersih adalah estimasi keuntungan setelah penjualan dikurangi biaya utama.

Rumus sederhananya:

Laba Kotor - Biaya Transaksi - Biaya Operasional

Catatan penting:
- Beli kain, bahan, maklun, dan produksi tidak langsung memotong Laba Bersih.
- Biaya produksi baru terasa sebagai HPP saat barangnya terjual.
- Jadi Laba Bersih lebih fokus menunjukkan hasil penjualan, bukan sekadar uang kas yang keluar untuk tambah stok.`
    },

    'total-unit-stok': {
        title: 'Total Unit Stok',
        description: `Total Unit Stok adalah jumlah semua stok fisik produk yang masih tersedia.

Contoh:
Jika stok Aurelia 50 pcs dan Amara 30 pcs, maka Total Unit Stok = 80 pcs.

Angka ini membantu melihat jumlah barang yang masih bisa dijual.`
    },

    'nilai-stok': {
        title: 'Total Nilai Stok (HPP)',
        description: `Total Nilai Stok adalah nilai modal dari stok yang masih tersisa.

Rumus sederhananya:

Jumlah Stok × HPP per Produk

Catatan:
Ini bukan harga jual stok, tapi nilai modal/HPP stok yang masih ada di gudang.`
    },

    'nilai-retur': {
    title: 'Total Nilai Retur',
    description: `Total Nilai Retur adalah nilai produk yang dikembalikan oleh pembeli dan masih tercatat sebagai retur.

Angka ini diambil dari harga jual produk yang diretur, bukan dari HPP/modal produk.

Contoh:
Jika pembeli mengembalikan 1 produk dengan harga jual Rp120.000, maka Total Nilai Retur bertambah Rp120.000.

Retur akan mengurangi Omset Bersih.

Catatan:
Jika data retur dihapus dari Manajemen Retur, maka nilai retur juga seharusnya tidak lagi dihitung di dashboard.`
},
};


// --- METHODS ---
async function saveData() {
    if (!currentUser.value) return alert("Anda harus login untuk menyimpan data.");

    // Cek jika ada perubahan pada produk. Jika tidak, kita anggap ini adalah penyimpanan pengaturan global.
    const hasProductChanges = editedProducts.value.size > 0;

    isSaving.value = true;
    try {
        const userId = currentUser.value.uid;
        const batch = writeBatch(db);

        // Bagian 1: Simpan Pengaturan Global (Settings, Promotions, Commissions)
        // Ini akan selalu berjalan saat tombol simpan ditekan dari halaman pengaturan.
        const settingsRef = doc(db, "settings", userId);
        batch.set(settingsRef, {
            brandName: state.settings.brandName,
            minStok: state.settings.minStok,
            marketplaces: JSON.parse(JSON.stringify(state.settings.marketplaces)),
            modelProduk: JSON.parse(JSON.stringify(state.settings.modelProduk)),
            // ... (tambahkan field settings lain jika ada)
        }, { merge: true });

        const promotionsRef = doc(db, "promotions", userId);
        batch.set(promotionsRef, {
            perChannel: JSON.parse(JSON.stringify(state.promotions.perChannel)),
            perModel: JSON.parse(JSON.stringify(state.promotions.perModel)),
        }, { merge: true });

        // --- INI BAGIAN PENTING YANG HILANG ---
        // Selalu simpan data komisi jika yang login adalah admin
        if (isAdmin.value) {
            const commissionsRef = doc(db, "commissions", userId);
            batch.set(commissionsRef, {
                perModel: state.commissions.perModel || {},
                userId: userId
            }, { merge: true });
        }
        // --- AKHIR BAGIAN PENTING ---

        // Bagian 2: Simpan Perubahan Produk yang Spesifik (jika ada)
        if (hasProductChanges) {
            for (const productId of editedProducts.value) {
                const product = state.produk.find(p => p.docId === productId);
                if (!product) continue;

                const productRef = doc(db, "products", product.docId);
                batch.update(productRef, { hpp: product.hpp });

                for (const marketplaceId in product.hargaJual) {
                    const priceDocId = `${product.docId}-${marketplaceId}`;
                    const priceRef = doc(db, "product_prices", priceDocId);
                    batch.set(priceRef, {
                        product_id: product.docId,
                        product_sku: product.sku,
                        marketplace_id: marketplaceId,
                        price: product.hargaJual[marketplaceId] || 0,
                        userId: userId
                    }, { merge: true });
                }
            }
        }
        
        await batch.commit();
        
        // Kosongkan daftar produk yang diedit setelah berhasil disimpan
        editedProducts.value.clear();
        
        alert('Perubahan berhasil disimpan!');

    } catch (error) {
        console.error("Gagal menyimpan data ke Firebase:", error);
        alert("Gagal menyimpan data. Cek console untuk detail.");
    } finally {
        isSaving.value = false;
    }
}


function unlockPemasukan() {
    if (uiState.pemasukanPinInput === state.settings.dashboardPin) {
        uiState.isPemasukanLocked = false;
        uiState.pemasukanPinError = '';
    } else {
        uiState.pemasukanPinError = 'PIN salah. Silakan coba lagi.';
        uiState.pemasukanPinInput = '';
    }
}

const PIN_PROTECTION_DEFAULTS =
    Object.freeze({
        dashboard: false,
        incomeHistory: false,
        investmentPage: false,
        laporanTransaksi: false,
        laporanKeuangan: false,
        hargaHpp: false,
        statistikPenjualan: false,
        exportData: false,
        transactionDetail: false
    });

function ensurePinProtectionDefaults() {
    const currentProtection =
        state.settings.pinProtection &&
        typeof state.settings.pinProtection ===
            'object'
            ? state.settings.pinProtection
            : {};

    state.settings.pinProtection = {
        ...PIN_PROTECTION_DEFAULTS,
        ...currentProtection
    };

    return state.settings.pinProtection;
}

let pendingPinProtectedAction = null;

function resetPinConfirmationState() {
    uiState.isPinConfirmModalVisible = false;
    uiState.pinConfirmInput = '';
    uiState.pinConfirmError = '';
    uiState.pinActionToConfirm = null;
    uiState.pinConfirmationMode = 'toggle';
    uiState.pinActionLabel = '';
    pendingPinProtectedAction = null;
}

function cancelPinConfirmation() {
    resetPinConfirmationState();
}

function requestPinForToggle(feature) {
    if (!state.settings.dashboardPin) {
        alert('Anda harus mengatur PIN utama terlebih dahulu di bagian "Ubah PIN Dasbor".');
        return;
    }

    // Cache pengaturan lama mungkin belum memiliki key fitur PIN baru.
    // Normalisasi dilakukan sebelum modal dibuka agar tombol Konfirmasi
    // tidak berhenti diam saat statistik/export/detail diaktifkan.
    ensurePinProtectionDefaults();

    pendingPinProtectedAction = null;
    uiState.pinActionToConfirm = feature;
    uiState.pinConfirmationMode = 'toggle';
    uiState.pinActionLabel = 'mengubah pengaturan kunci';
    uiState.pinConfirmInput = '';
    uiState.pinConfirmError = '';
    uiState.isPinConfirmModalVisible = true;
}

function requestPinProtectedAction(feature, action, actionLabel = 'melanjutkan aksi ini') {
    const protectionEnabled = Boolean(
        state.settings.dashboardPin &&
        state.settings.pinProtection?.[feature]
    );

    if (!protectionEnabled) {
        return action();
    }

    pendingPinProtectedAction = action;
    uiState.pinActionToConfirm = feature;
    uiState.pinConfirmationMode = 'action';
    uiState.pinActionLabel = actionLabel;
    uiState.pinConfirmInput = '';
    uiState.pinConfirmError = '';
    uiState.isPinConfirmModalVisible = true;

    nextTick(() => {
        document.querySelector('[data-pin-confirm-input="true"]')?.focus();
    });

    return undefined;
}

function requestProtectedExport(action) {
    return requestPinProtectedAction('exportData', action, 'melakukan export data');
}

// eslint-disable-next-line no-unused-vars

function openProtectedTransactionDetail(transaction) {
    return requestPinProtectedAction(
        'transactionDetail',
        () => showModal('transactionDetail', transaction),
        'membuka detail transaksi'
    );
}

async function confirmPinAndToggle() {
    if (uiState.pinConfirmInput !== state.settings.dashboardPin) {
        uiState.pinConfirmError = 'PIN yang Anda masukkan salah.';
        return;
    }

    if (uiState.pinConfirmationMode === 'action') {
        const action = pendingPinProtectedAction;
        resetPinConfirmationState();

        if (typeof action === 'function') {
            try {
                await action();
            } catch (error) {
                console.error('[PIN PROTECTION] Aksi setelah verifikasi PIN gagal:', error);
                alert('Aksi belum berhasil dijalankan. Silakan coba kembali.');
            }
        }
        return;
    }

    const feature =
        uiState.pinActionToConfirm;

    const pinProtection =
        ensurePinProtectionDefaults();

    if (
        !feature ||
        !Object.prototype.hasOwnProperty.call(
            pinProtection,
            feature
        )
    ) {
        uiState.pinConfirmError =
            'Pengaturan kunci tidak ditemukan. Tutup lalu buka kembali Pengaturan Umum.';
        return;
    }

    pinProtection[feature] =
        !pinProtection[feature];

    await saveGeneralSettings();
    resetPinConfirmationState();
}

async function submitBankAccount() {
    const form = uiState.modalData;
    if (!form.bankName || !form.accountNumber || !form.accountName) {
        return alert("Semua kolom wajib diisi.");
    }
    const dataToSave = { ...form, userId: currentUser.value.uid };

    try {
        const docRef = doc(db, "bank_accounts", dataToSave.id || `BANK-${Date.now()}`);
        await setDoc(docRef, dataToSave, { merge: true });

        // Update state lokal
        const index = state.bankAccounts.findIndex(b => b.id === docRef.id);
        if (index > -1) {
            state.bankAccounts[index] = { ...dataToSave, id: docRef.id };
        } else {
            state.bankAccounts.unshift({ ...dataToSave, id: docRef.id });
        }
        hideModal();
        alert("Rekening bank berhasil disimpan!");
    } catch (error) {
        console.error("Error saving bank account:", error);
        alert("Gagal menyimpan rekening bank.");
    }
}

// FUNGSI UNTUK MENGHAPUS REKENING BANK
async function deleteBankAccount(accountId) {
    if (!confirm("Anda yakin ingin menghapus rekening ini?")) return;
    try {
        await deleteDoc(doc(db, "bank_accounts", accountId));
        state.bankAccounts = state.bankAccounts.filter(b => b.id !== accountId);
        alert("Rekening bank berhasil dihapus.");
    } catch (error) {
        console.error("Error deleting bank account:", error);
        alert("Gagal menghapus rekening bank.");
    }
}

async function saveGeneralSettings() {
    if (!currentUser.value) return alert("Anda harus login untuk menyimpan pengaturan.");
    
    isSavingSettings.value = true;
    uiState.pinError = '';

    let newPinToSave = state.settings.dashboardPin;

    if (uiState.newPin) { 
        if (state.settings.dashboardPin && uiState.oldPin !== state.settings.dashboardPin) {
            uiState.pinError = 'PIN lama salah.';
            isSavingSettings.value = false;
            return;
        }
        if (uiState.newPin !== uiState.confirmNewPin) {
            uiState.pinError = 'PIN baru dan konfirmasi tidak cocok.';
            isSavingSettings.value = false;
            return;
        }
        if (uiState.newPin.length < 4 || uiState.newPin.length > 6) {
            uiState.pinError = 'PIN harus 4-6 karakter.';
            isSavingSettings.value = false;
            return;
        }
        newPinToSave = uiState.newPin;
    }

    try {
        const userId = currentUser.value.uid;
        const settingsRef = doc(db, "settings", userId);
        
        // --- PERBAIKAN: Buat objek pinProtection yang bersih ---
        const cleanPinProtection = {
            dashboard: !!state.settings.pinProtection.dashboard,
            incomeHistory: !!state.settings.pinProtection.incomeHistory,
            investmentPage: !!state.settings.pinProtection.investmentPage,
            laporanTransaksi: !!state.settings.pinProtection.laporanTransaksi,
            laporanKeuangan: !!state.settings.pinProtection.laporanKeuangan,
            hargaHpp: !!state.settings.pinProtection.hargaHpp,
            statistikPenjualan: !!state.settings.pinProtection.statistikPenjualan,
            exportData: !!state.settings.pinProtection.exportData,
            transactionDetail: !!state.settings.pinProtection.transactionDetail,
        };

        const dataToUpdate = {
            brandName: state.settings.brandName,
            minStok: state.settings.minStok,
            pinProtection: cleanPinProtection, // <-- Gunakan objek yang bersih
            ...(newPinToSave !== undefined && { dashboardPin: newPinToSave }),
        };

        await setDoc(settingsRef, dataToUpdate, { merge: true });
        
        state.settings.dashboardPin = newPinToSave;
        uiState.oldPin = '';
        uiState.newPin = '';
        uiState.confirmNewPin = '';
        
        alert('Pengaturan umum berhasil disimpan ke database!');

    } catch (error) {
        console.error("Gagal menyimpan pengaturan umum:", error);
        alert("Gagal menyimpan pengaturan umum. Silakan coba lagi.");
    } finally {
        isSavingSettings.value = false;
    }
}

async function confirmCashoutPayment(withdrawalId) {
    if (!confirm(`Anda yakin ingin mengonfirmasi pembayaran untuk ID: ${withdrawalId}?`)) return;

    uiState.isVerifying = true;
    uiState.adminVerificationError = '';
    try {
        const idToken = await auth.currentUser.getIdToken(true);
        const response = await fetch('/api/confirm-payment', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${idToken}` },
            body: JSON.stringify({ withdrawalId: withdrawalId })
        });
        const data = await response.json();
        if (!response.ok) throw new Error(data.message);

        alert('Pembayaran berhasil dikonfirmasi! Status di halaman mitra akan terupdate.');
        uiState.adminVerificationResult = null;
        uiState.adminVerificationIdInput = '';

    } catch (error) {
        uiState.adminVerificationError = `Gagal konfirmasi: ${error.message}`;
    } finally {
        uiState.isVerifying = false;
    }
}

function generateBagiHasilReport() {
    const { selectedInvestorId, month, year } = uiState.laporanBagiHasil;
    
    if (!selectedInvestorId) {
        return alert("Silakan pilih investor terlebih dahulu.");
    }
    const investor = state.investor.find(inv => inv.id === selectedInvestorId);
    if (!investor) {
        return alert("Data investor tidak ditemukan.");
    }

    const filteredTransaksi = filterDataByDate(
        state.transaksi, 'by_month_range', null, null, month, year, month, year
    );
    const filteredKeuangan = filterDataByDate(
        state.keuangan, 'by_month_range', null, null, month, year, month, year
    );
    const filteredRetur = filterDataByDate(
        state.retur, 'by_month_range', null, null, month, year, month, year
    );

    const omsetKotorPenjualan = filteredTransaksi.reduce((sum, trx) => sum + (trx.subtotal || 0), 0);
    const diskonPenjualan = filteredTransaksi.reduce((sum, trx) => sum + (trx.diskon?.totalDiscount || 0), 0);
    const hppTerjualPenjualan = filteredTransaksi.reduce((sum, trx) => sum + (trx.items || []).reduce((itemSum, item) => itemSum + (item.hpp || 0) * (item.qty || 0), 0), 0);
    const biayaTransaksiPenjualan = filteredTransaksi.reduce((sum, trx) => sum + (trx.biaya?.total || 0), 0);

    let omsetBersihDariRetur = 0;
    let totalHppRetur = 0;
    let totalBiayaMarketplaceBatal = 0;

    filteredRetur.forEach(returDoc => {
        (returDoc.items || []).forEach(item => {
            omsetBersihDariRetur += (item.nilaiRetur || 0);
            totalBiayaMarketplaceBatal += (item.biayaMarketplace || 0);
            const product = getProductBySku(item.sku);
            if (product) {
                totalHppRetur += (product.hpp || 0) * item.qty;
            }
        });
    });

    const omsetBersihPenjualanFinal = omsetKotorPenjualan - diskonPenjualan;
    const omsetBersihFinal = omsetBersihPenjualanFinal - omsetBersihDariRetur;
    const hppTerjualFinal = hppTerjualPenjualan - totalHppRetur;
    const finalBiayaTransaksi = biayaTransaksiPenjualan - totalBiayaMarketplaceBatal;
    
    const labaKotor = omsetBersihFinal - hppTerjualFinal;

    // --- BARIS INI DIPERBARUI ---
    // Filter pengeluaran dan kecualikan catatan yang mengandung kata "Bagi hasil"
    const totalBiayaOperasional = filteredKeuangan
        .filter(i => 
            i.jenis === 'pengeluaran' && 
            !(i.catatan && i.catatan.toLowerCase().includes('bagi hasil'))
        )
        .reduce((sum, i) => sum + i.jumlah, 0);
    // --- AKHIR PERUBAIAN ---

    const labaBersih = labaKotor - totalBiayaOperasional - finalBiayaTransaksi;

    let investorShare = 0;
    let companyShare = 0;
    if (labaBersih > 0) {
        investorShare = labaBersih * (investor.profitShare / 100);
        companyShare = labaBersih - investorShare;
    }

    uiState.laporanBagiHasil.result = {
        investorName: investor.name,
        profitSharePercentage: investor.profitShare,
        period: `${new Date(0, month - 1).toLocaleString('id-ID', { month: 'long' })} ${year}`,
        omsetBersihPenjualan: omsetBersihPenjualanFinal,
        omsetBersihDariRetur,
        omsetBersihFinal,
        totalHppTerjual: hppTerjualPenjualan,
        totalHppRetur,
        hppTerjualFinal,
        labaKotor,
        biayaMarketplacePenjualan: biayaTransaksiPenjualan,
        biayaMarketplaceBatal: totalBiayaMarketplaceBatal,
        totalBiayaTransaksi: finalBiayaTransaksi,
        totalBiayaOperasional,
        labaBersih,
        investorShare,
        companyShare
    };
}

function changePage(pageName) {
    activePage.value = pageName;

    // Simpan halaman terakhir secara langsung
    localStorage.setItem('lastActivePage', pageName);

    const sidebarPageGroups = {
        inventaris: 'produk',
        'harga-hpp': 'produk',
        promosi: 'produk',

        produksi: 'produksi',
        supplier: 'produksi',
        'gudang-kain': 'produksi',

        transaksi: 'penjualan',
        bulk_process: 'penjualan',
        retur: 'penjualan',
        'statistik-penjualan': 'penjualan',

        keuangan: 'keuangan',
        'roas-dashboard': 'keuangan',
        'roas-calculator': 'keuangan',
        investasi: 'keuangan',
        'laporan-transaksi': 'keuangan',
        'laporan-keuangan': 'keuangan',

        mitra: 'sistem',
        pengaturan: 'sistem',

        langganan: 'bantuan',
        'panduan-baru': 'bantuan',
        'barcode-generator': 'bantuan',
        panduan: 'bantuan',
        tentang: 'bantuan'
    };

    const targetGroup = sidebarPageGroups[pageName];

    if (targetGroup) {
        Object.keys(uiState.sidebarGroups).forEach(key => {
            uiState.sidebarGroups[key] = false;
        });

        uiState.sidebarGroups[targetGroup] = true;
    }

    // Logika Kunci Halaman Dashboardd
    if (pageName === 'dashboard') {
        if (state.settings.dashboardPin && state.settings.pinProtection?.dashboard) {
            isDashboardLocked.value = true;
            dashboardPinInput.value = '';
            dashboardPinError.value = '';
        } else {
            isDashboardLocked.value = false;
        }
    }

    // Logika Kunci Halaman Keuangan
    if (pageName === 'keuangan') {
        if (state.settings.dashboardPin && state.settings.pinProtection?.incomeHistory) {
            uiState.isPemasukanLocked = true;
            uiState.pemasukanPinInput = '';
            uiState.pemasukanPinError = '';
        } else {
            uiState.isPemasukanLocked = false;
        }
    }

    // Logika Kunci Halaman Investasi
    if (pageName === 'investasi') {
        if (state.settings.dashboardPin && state.settings.pinProtection?.investmentPage) {
            uiState.isInvestasiLocked = true;
            uiState.investasiPinInput = '';
            uiState.investasiPinError = '';
        } else {
            uiState.isInvestasiLocked = false;
        }
    }

    // Logika Kunci Laporan Transaksi
    if (pageName === 'laporan-transaksi') {
        if (state.settings.dashboardPin && state.settings.pinProtection?.laporanTransaksi) {
            isLaporanTransaksiLocked.value = true;
            uiState.laporanTransaksiPinInput = '';
            uiState.laporanTransaksiPinError = '';
        } else {
            isLaporanTransaksiLocked.value = false;
        }
    }

    // Logika Kunci Laporan Keuangan
    if (pageName === 'laporan-keuangan') {
        if (state.settings.dashboardPin && state.settings.pinProtection?.laporanKeuangan) {
            isLaporanKeuanganLocked.value = true;
            uiState.laporanKeuanganPinInput = '';
            uiState.laporanKeuanganPinError = '';
        } else {
            isLaporanKeuanganLocked.value = false;
        }
    }

    // Logika Kunci Harga & HPP
    if (pageName === 'harga-hpp') {
        if (state.settings.dashboardPin && state.settings.pinProtection?.hargaHpp) {
            isHargaHppLocked.value = true;
            uiState.hargaHppPinInput = '';
            uiState.hargaHppPinError = '';
        } else {
            isHargaHppLocked.value = false;
        }
    }


    // Logika Kunci Statistik Penjualan
    if (pageName === 'statistik-penjualan') {
        if (state.settings.dashboardPin && state.settings.pinProtection?.statistikPenjualan) {
            isStatistikPenjualanLocked.value = true;
            uiState.statistikPenjualanPinInput = '';
            uiState.statistikPenjualanPinError = '';
        } else {
            isStatistikPenjualanLocked.value = false;
        }
    }
}

function unlockDashboard() {
  // Cek PIN yang dimasukkan dengan PIN yang sudah ada di state
  if (dashboardPinInput.value === state.settings.dashboardPin) {
    isDashboardLocked.value = false;
    dashboardPinError.value = '';
    // Simpan status terkunci ke localStorage (opsional, tapi disarankan)
    localStorage.setItem('isDashboardUnlocked', 'true');
  } else {
    dashboardPinError.value = 'PIN salah. Silakan coba lagi.';
  }
}

function unlockInvestasi() {
    if (uiState.investasiPinInput === state.settings.dashboardPin) {
        uiState.isInvestasiLocked = false;
        uiState.investasiPinError = '';
    } else {
        uiState.investasiPinError = 'PIN salah. Silakan coba lagi.';
        uiState.investasiPinInput = '';
    }
}

function unlockLaporanTransaksi() {
    if (uiState.laporanTransaksiPinInput === state.settings.dashboardPin) {
        isLaporanTransaksiLocked.value = false;
        uiState.laporanTransaksiPinError = '';
    } else {
        uiState.laporanTransaksiPinError = 'PIN salah.';
    }
}

function unlockLaporanKeuangan() {
    if (uiState.laporanKeuanganPinInput === state.settings.dashboardPin) {
        isLaporanKeuanganLocked.value = false;
        uiState.laporanKeuanganPinError = '';
    } else {
        uiState.laporanKeuanganPinError = 'PIN salah.';
    }
}

function unlockHargaHpp() {
    if (uiState.hargaHppPinInput === state.settings.dashboardPin) {
        isHargaHppLocked.value = false;
        uiState.hargaHppPinError = '';
    } else {
        uiState.hargaHppPinError = 'PIN salah.';
    }
}

function unlockStatistikPenjualan() {
    if (uiState.statistikPenjualanPinInput === state.settings.dashboardPin) {
        isStatistikPenjualanLocked.value = false;
        uiState.statistikPenjualanPinError = '';
    } else {
        uiState.statistikPenjualanPinError = 'PIN salah. Silakan coba lagi.';
        uiState.statistikPenjualanPinInput = '';
    }
}

function showModal(type, data = {}) {
    // --- PERBAIKAN DIMULAI DI SINI ---
    // Pastikan semua data produk sudah dimuat sebelum membuka modal yang memerlukannya
    if (type === 'addStockIn' || type === 'priceCalculator' || type === 'addProduksi') {
        fetchAllProductData(currentUser.value.uid);
    }
    // --- AKHIR PERBAIKAN ---

    uiState.modalData = {};
    uiState.modalType = type;
    uiState.isModalVisible = true;

    nextTick(() => {
        if (data) {
            uiState.modalData = JSON.parse(JSON.stringify(data));
        }

        if (type === 'editMarketplace' && data) {
            if (!uiState.modalData.programs) {
                uiState.modalData.programs = [];
            }
        } else if (type === 'supplierPayment') {
            uiState.newPaymentData = {
                amount: null,
                date: new Date().toISOString().split('T')[0],
                method: 'Transfer',
                notes: ''
            };
        } else if (type === 'addProduksi') {
            if (!state.settings.modelProduk || state.settings.modelProduk.length === 0) {
                alert("Data 'Model Produk' belum dibuat. silahkan kehalaman pengaturan untuk menambahkan model produk.");
                hideModal();
                return;
            }
            setupNewProduksiBatch();
        } else if (type === 'editProduksi' && data) {
            setupEditProduksiBatch(data);
        } else if (type === 'editRetur' && data) {
            uiState.modalData.tanggal = new Date(data.tanggal).toISOString().split('T')[0];
        }
    });
}

// Tambahkan fungsi baru ini di bawah showModal
function showNestedModal(type, data = {}) {
    // Fungsi ini khusus untuk modal yang muncul di atas modal lain
    uiState.nestedModalType = type;
    uiState.nestedModalData = data;
}

function hideNestedModal() {
    uiState.nestedModalType = null;
    uiState.nestedModalData = {};
}
async function submitKain(isEditing = false) {
    if (!currentUser.value) {
        return alert("Anda harus login untuk mengelola stok kain.");
    }

    const form = uiState.modalData;
    if (!form.namaKain || !form.warna || !form.sisaYard || !form.hargaBeliPerYard) {
        alert('Nama Kain, Warna, Sisa Yard, dan Harga Beli wajib diisi.');
        return;
    }

    const dataToSave = {
        ...form,
        tanggalBeli: new Date(form.tanggalBeli)
    };
    
    try {
        if (isEditing) {
            // Logika EDIT tidak perlu userId karena dokumen sudah ada
            const kainRef = doc(db, "fabric_stock", dataToSave.id);
            const updateData = { ...dataToSave };
            delete updateData.id;
            
            await updateDoc(kainRef, updateData);

            const index = state.gudangKain.findIndex(k => k.id === form.id);
            if (index !== -1) {
                state.gudangKain[index] = dataToSave;
            }
            alert('Data kain berhasil diperbarui!');
        } else {
            // Logika TAMBAH BARU
            dataToSave.userId = currentUser.value.uid; // <-- TAMBAHKAN userId DI SINI
            const collectionRef = collection(db, "fabric_stock");
            const newDocRef = await addDoc(collectionRef, dataToSave);

            state.gudangKain.unshift({ ...dataToSave, id: newDocRef.id });
            alert('Stok kain baru berhasil ditambahkan!');
        }
        hideModal();
    } catch (error) {
        console.error("Error menyimpan data kain:", error);
        alert("Gagal menyimpan data kain ke database.");
    }
}

async function deleteKain(kainId) {
    if (confirm(`Anda yakin ingin menghapus data kain dengan ID: ${kainId}? Stok akan hilang permanen.`)) {
        try {
            await deleteDoc(doc(db, "fabric_stock", kainId));
            
            // Update UI setelah berhasil dihapus dari Firebase
            state.gudangKain = state.gudangKain.filter(k => k.id !== kainId);
            alert('Data kain berhasil dihapus.');

        } catch (error) {
            console.error("Error menghapus data kain:", error);
            alert("Gagal menghapus data kain dari database.");
        }
    }
}
function exportLaporanSemuaToExcel() {
    const dataToExport = laporanSemuanyaData.value.tableData.map(item => ({
        "Tanggal": new Date(item.tanggal),
        "Pemaklun": item.namaPemaklun,
        "Model Produk": item.modelNama,
        "Status": item.statusProses,
        "Nama Kain": item.namaKain,
        "Warna": item.warnaKain,
        "Ukuran": item.ukuran,
        "Qty Jadi (Pcs)": item.aktualJadi,
        "Qty Kombinasi (Pcs)": item.aktualJadiKombinasi,
        "Biaya Kain (Rp)": item.totalBiayaKain,
        "Biaya Maklun (Rp)": item.totalBiayaMaklun,
        "Biaya Alat (Rp)": item.totalBiayaAlat,
        "Total Biaya (Rp)": item.totalBiayaProduksi,
    }));
    if (dataToExport.length === 0) { alert("Tidak ada data untuk diekspor."); return; }
    const worksheet = XLSX.utils.json_to_sheet(dataToExport);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Laporan Produksi");
    worksheet["!cols"] = Array(13).fill({ wch: 20 });
    XLSX.writeFile(workbook, `Laporan_Produksi_Menyeluruh_${new Date().toISOString().split('T')[0]}.xlsx`);
}

function hideModal() {
    const modelToScrollTo = lastEditedModel.value;

    uiState.isModalVisible = false;
    uiState.modalType = '';
    uiState.modalData = {};
    lastEditedModel.value = null; // Reset setelah digunakan

    // --- PERBAIKAN DI SINI: Tambahkan reset untuk state harga massal ---
    uiState.massPriceFilterUkuran = '';
    uiState.massPriceFilterWarna = '';
    uiState.massPriceInputs = {};
    uiState.massPriceHppInput = null;

    if (modelToScrollTo && groupRefs.value[modelToScrollTo]) {
        nextTick(() => {
            groupRefs.value[modelToScrollTo].scrollIntoView({
                behavior: 'smooth',
                block: 'center'
            });
        });
    }
}

// TAMBAHKAN FUNGSI BARU INI
function hideKeuanganInfoModal() {
    uiState.isKeuanganInfoVisible = false;
}

function exportPurchaseOrdersToExcel() {
    const dataToExport = filteredPurchaseOrders.value.map(order => ({
        "ID Pesanan": order.id,
        "Tanggal": new Date(order.tanggal),
        "Nama Supplier": order.supplierName,
        "Total Nilai": order.totalQtyValue,
        "Status Proses": order.statusProses,
        "Status Pembayaran": order.statusPembayaran,
        "Jumlah Dibayarkan": order.dibayarkan || 0,
        "Sisa Pembayaran": order.totalQtyValue - (order.dibayarkan || 0)
    }));

    if (dataToExport.length === 0) {
        alert("Tidak ada data untuk diekspor.");
        return;
    }

    const worksheet = XLSX.utils.json_to_sheet(dataToExport);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Riwayat Penerimaan Barang");
    worksheet["!cols"] = Array(8).fill({ wch: 20 });
    XLSX.writeFile(workbook, `Riwayat_Penerimaan_Barang_${new Date().toISOString().split('T')[0]}.xlsx`);
}

function addProductToCart(product, qty = 1) {
    if (!uiState.activeCartChannel) { alert("Pilih channel penjualan."); return; }
    const cart = state.carts[uiState.activeCartChannel];
    const existingItem = cart.find(item => item.sku === product.sku);

    const specialPrice = state.specialPrices[uiState.activeCartChannel]?.[product.sku];
    const regularPrice = product.hargaJual?.[uiState.activeCartChannel] ?? Object.values(product.hargaJual)[0] ?? 0;
    const finalPrice = specialPrice !== undefined ? specialPrice : regularPrice;

    // --- [PERBAIKAN KUNCI DI SINI] ---
    // Mengambil komisi berdasarkan NAMA MODEL produk dari state global, bukan dari produk itu sendiri.
    const commissionRate = state.commissions.perModel[product.nama]?.[uiState.activeCartChannel] || 0;

    if (existingItem) {
        existingItem.qty += qty;
        existingItem.hargaJualAktual = finalPrice;
        existingItem.commissionRate = commissionRate; // Update komisi juga
    } else {
        // Saat menambahkan produk baru, sertakan commissionRate yang benar
        cart.push({ ...product, qty, hargaJualAktual: finalPrice, commissionRate: commissionRate });
    }
}

// eslint-disable-next-line no-unused-vars

function updateCartItemQty(sku, delta) {
    const item = activeCart.value.find(i => i.sku === sku);
    if (item) {
        item.qty += delta;
        if (item.qty <= 0) removeFromCart(sku);
    }
}
function removeFromCart(sku) {
    const itemIndex = activeCart.value.findIndex(i => i.sku === sku);
    if (itemIndex > -1) activeCart.value.splice(itemIndex, 1);
}
// eslint-disable-next-line no-unused-vars
function confirmCompleteTransaction() {
    if (!uiState.pos_order_id) {
        return alert("Harap scan resi atau masukkan ID Pesanan Marketplace terlebih dahulu.");
    }
    const marketplace = getMarketplaceById(uiState.activeCartChannel);
    if (!marketplace) {
        alert("Silakan pilih channel penjualan terlebih dahulu.");
        return;
    }
    showModal('confirmTransaction', { 
        channelName: marketplace.name, 
        orderId: uiState.pos_order_id, // Kirim orderId ke modal
        ...cartSummary.value 
    });
}
async function executeCompleteTransaction() {
    if (!currentUser.value) {
        return alert("Anda harus login untuk menyelesaikan transaksi.");
    }
    const marketplace = getMarketplaceById(uiState.activeCartChannel);
    
    if (!marketplace || activeCart.value.length === 0) {
        alert("Keranjang kosong atau channel penjualan tidak valid.");
        return;
    }
    if (!uiState.pos_order_id) {
        hideModal();
        alert("Gagal: ID Pesanan Marketplace belum di-scan. Silakan scan resi terlebih dahulu.");
        return;
    }

    const items = activeCart.value.map(item => ({
        sku: item.sku || '',
        nama: item.nama || item.product_name || '',
        qty: Number(item.qty) || 0,
        hpp: Number(item.hpp) || 0,
        model_id: item.model_id || item.modelId || '',
        warna: item.warna || item.color || '',
        varian: item.varian || item.variant || ''
    }));

    const totalHpp = items.reduce(
        (sum, item) => sum + (item.hpp * item.qty),
        0
    );

    const newTransactionData = {
        marketplaceOrderId: uiState.pos_order_id,
        tanggal: new Date(),
        items,
        totalHpp,
        statusDataMarketplace: 'menunggu_data',
        penghasilanBersihMarketplace: null,
        channel: marketplace.name,
        channelId: marketplace.id,
        statusPencairan: 'Belum Cair',
        userId: currentUser.value.uid
    };

    try {
        const batch = writeBatch(db);
        const transactionRef = doc(collection(db, "transactions"));
        batch.set(transactionRef, newTransactionData);

        for (const item of activeCart.value) {
            const productRef = doc(db, "products", item.docId);
            batch.update(productRef, { physical_stock: increment(-item.qty) });
        }

        await batch.commit();

        activeCart.value.forEach(item => {
            const productInState = state.produk.find(p => p.docId === item.docId);
            if (productInState) {
                productInState.stokFisik -= item.qty;
            }
             const invItem = state.inventoryPaginated.find(p => p.docId === item.docId);
             if (invItem) invItem.stokFisik -= item.qty;
        });
        
        // Masukkan transaksi baru langsung ke data lokal.
// Tidak perlu membaca ulang seluruh transaksi Firebase.
const createdTransaction = {
    id: transactionRef.id,
    ...newTransactionData
};

state.transaksi.unshift(createdTransaction);

// Transaksi POS belum cair selalu langsung masuk ke Dana Gantung.
if (
    !state.pendingSettlements.some(
        transaction =>
            transaction.id ===
            createdTransaction.id
    )
) {
    state.pendingSettlements.unshift(
        createdTransaction
    );
}

applyDashboardSummaryV2TransactionDelta(
    null,
    createdTransaction
);

        state.carts[uiState.activeCartChannel] = [];
        uiState.pos_order_id = '';
        hideModal();
        alert("Transaksi berhasil disimpan! Semua biaya marketplace telah sinkron.");

    } catch (error) {
        console.error("Error saat menyimpan transaksi:", error);
        alert(`Gagal menyimpan transaksi: ${error.message}`);
    }
}

function calculateBestDiscount(cart, channelId) {
    if (!cart || cart.length === 0) {
        return { totalDiscount: 0, description: 'Tidak ada diskon yang berlaku', rate: 0 };
    }

    const eligiblePromotions = [];
    const totalCartSubtotal = cart.reduce((sum, item) => sum + (item.hargaJualAktual * item.qty), 0);

    // 1. Kumpulkan promosi per channel
    const channelPromos = state.promotions.perChannel[channelId] || {};
    const voucherToko = channelPromos.voucherToko;
    if (voucherToko && totalCartSubtotal >= (voucherToko.minBelanja || 0)) {
        let discountValue = 0;
        let discountDesc = '';
        if (voucherToko.diskonNominal > 0) {
            discountValue = voucherToko.diskonNominal;
            discountDesc = `Voucher Ikuti Toko (${formatCurrency(discountValue)})`;
        } else if (voucherToko.diskonRate > 0) {
            discountValue = (voucherToko.diskonRate / 100) * totalCartSubtotal;
            discountDesc = `Voucher Ikuti Toko (${voucherToko.diskonRate}%)`;
        }
        if (discountValue > 0) {
            eligiblePromotions.push({ totalDiscount: discountValue, description: discountDesc, rate: voucherToko.diskonRate || 0 });
        }
    }

    const voucherSemuaProduk = channelPromos.voucherSemuaProduk;
    if (voucherSemuaProduk && totalCartSubtotal >= (voucherSemuaProduk.minBelanja || 0)) {
        let discountValue = 0;
        let discountDesc = '';
        if (voucherSemuaProduk.diskonNominal > 0) {
            discountValue = voucherSemuaProduk.diskonNominal;
            discountDesc = `Voucher Semua Produk (${formatCurrency(discountValue)})`;
        } else if (voucherSemuaProduk.diskonRate > 0) {
            discountValue = (voucherSemuaProduk.diskonRate / 100) * totalCartSubtotal;
            discountDesc = `Voucher Semua Produk (${voucherSemuaProduk.diskonRate}%)`;
        }
        if (discountValue > 0) {
            eligiblePromotions.push({ totalDiscount: discountValue, description: discountDesc, rate: voucherSemuaProduk.diskonRate || 0 });
        }
    }

    // 2. Kumpulkan promosi per model produk
    const allModelPromos = state.promotions.perModel || {};
    const itemsByModel = cart.reduce((acc, item) => {
        const modelInfo = state.settings.modelProduk.find(m => m.id === item.model_id);
        const modelName = modelInfo ? modelInfo.namaModel.split(' ')[0] : (item.nama || '').split(' ')[0];
        if (!acc[modelName]) {
            acc[modelName] = { subtotal: 0, qty: 0 };
        }
        acc[modelName].subtotal += item.hargaJualAktual * item.qty;
        acc[modelName].qty += item.qty;
        return acc;
    }, {});

    for (const modelName in itemsByModel) {
        const modelData = itemsByModel[modelName];
        const modelPromosForChannel = (allModelPromos[modelName] || {})[channelId] || {};
        
        // Cek Voucher Produk Tertentu
        if (modelPromosForChannel.minBelanja > 0 && modelData.subtotal >= modelPromosForChannel.minBelanja) {
            let discountValue = 0;
            let discountDesc = '';
            if (modelPromosForChannel.diskonNominal > 0) {
                discountValue = modelPromosForChannel.diskonNominal;
                discountDesc = `Voucher ${modelName} (${formatCurrency(discountValue)})`;
            } else if (modelPromosForChannel.diskonRate > 0) {
                discountValue = (modelPromosForChannel.diskonRate / 100) * modelData.subtotal;
                discountDesc = `Voucher ${modelName} (${modelPromosForChannel.diskonRate}%)`;
            }
            if (discountValue > 0) {
                eligiblePromotions.push({ totalDiscount: discountValue, description: discountDesc, rate: modelPromosForChannel.diskonRate || 0 });
            }
        }
        
        // Cek Diskon Bertingkat
        if (modelPromosForChannel.diskonBertingkat && modelPromosForChannel.diskonBertingkat.length > 0) {
            const sortedTiers = [...modelPromosForChannel.diskonBertingkat].sort((a, b) => (b.diskon || b.diskonNominal) - (a.diskon || a.diskonNominal));
            for (const tier of sortedTiers) {
                if (modelData.subtotal >= tier.min) {
                    let discountValue = 0;
                    let discountDesc = '';
                     if (tier.diskonNominal > 0) {
                        discountValue = tier.diskonNominal;
                        discountDesc = `Diskon Bertingkat ${modelName} (${formatCurrency(discountValue)})`;
                    } else if (tier.diskon > 0) {
                        discountValue = (tier.diskon / 100) * modelData.subtotal;
                        discountDesc = `Diskon Bertingkat ${modelName} (${tier.diskon}%)`;
                    }
                    if (discountValue > 0) {
                       eligiblePromotions.push({ totalDiscount: discountValue, description: discountDesc, rate: tier.diskon || 0 });
                    }
                }
            }
        }
    }

    // 3. Cari promosi terbaik dari semua yang terkumpul
    if (eligiblePromotions.length === 0) {
        return { totalDiscount: 0, description: 'Tidak ada diskon yang berlaku', rate: 0 };
    }
    
    // Cari promo dengan nilai diskon rupiah paling besar
    return eligiblePromotions.reduce((best, current) => {
        return current.totalDiscount > best.totalDiscount ? current : best;
    });
}

function getMarketplaceFeeValue(fee, price) {
    const value = parseFloat(fee?.rate ?? fee?.value ?? fee ?? 0) || 0;
    const type = fee?.type || fee?.feeType || fee?.jenis || 'percent';

    if (type === 'rupiah' || type === 'nominal' || type === 'fixed') {
        return value;
    }

    return price * (value / 100);
}

function getMarketplaceFeeRate(fee) {
    const value = parseFloat(fee?.rate ?? fee?.value ?? fee ?? 0) || 0;
    const type = fee?.type || fee?.feeType || fee?.jenis || 'percent';

    return (type === 'rupiah' || type === 'nominal' || type === 'fixed') ? 0 : value / 100;
}

function calculateSellingPrice() {
    const { hpp, targetMargin, selectedMarketplace, selectedModelName } = uiState.priceCalculator;

    // TAMBAHKAN 1 BARIS INI untuk mengambil nama model dasar
    const baseModelName = selectedModelName ? selectedModelName.split(' ')[0] : null;

    // PERBARUI VALIDASI ini untuk menggunakan baseModelName
    if (!hpp || !selectedMarketplace || !baseModelName) {
        uiState.priceCalculator.result = null;
        return;
    }

    const mp = state.settings.marketplaces.find(m => m.id === selectedMarketplace);
    if (!mp) {
        uiState.priceCalculator.result = null;
        return;
    }

    // PERBARUI BARIS INI untuk menggunakan baseModelName
    const commissionRate = (state.commissions.perModel[baseModelName]?.[selectedMarketplace] || 0) / 100;

    const dummyProduct = {
        sku: 'calc-dummy',
        nama: baseModelName, // PERBARUI BARIS INI untuk menggunakan baseModelName
        hargaJualAktual: hpp * 2,
        qty: 1
    };
    const discountInfo = calculateBestDiscount([dummyProduct], selectedMarketplace);
    const bestDiscountRate = (discountInfo.rate || 0) / 100;

    const perOrderFee = parseFloat(mp.perPesanan || 0) || 0;
const targetProfitPercentage = (targetMargin || 0) / 100;

const adminRate = getMarketplaceFeeRate(mp.adm);
const layananRate = getMarketplaceFeeRate(mp.layanan);

const programRates = (mp.programs || []).map(p => getMarketplaceFeeRate(p));
const totalProgramPercentage = programRates.reduce((sum, rate) => sum + rate, 0);

const allPercentageFees =
    adminRate +
    layananRate +
    targetProfitPercentage +
    bestDiscountRate +
    totalProgramPercentage +
    commissionRate;

const calculatedPrice = (hpp + perOrderFee) / (1 - allPercentageFees);

const adminFee = getMarketplaceFeeValue(mp.adm, calculatedPrice);
const commission = calculatedPrice * commissionRate;
const serviceFee = getMarketplaceFeeValue(mp.layanan, calculatedPrice);
    const bestDiscount = calculatedPrice * bestDiscountRate;

    const itemizedProgramFees = (mp.programs || []).map(program => {
    const value = parseFloat(program.rate ?? program.value ?? 0) || 0;
    const type = program.type || program.feeType || program.jenis || 'percent';

    return {
        name: program.name,
        rate: type === 'rupiah' || type === 'nominal' || type === 'fixed' ? 0 : value,
        type,
        fee: getMarketplaceFeeValue(program, calculatedPrice)
    };
});
    const totalProgramFeeValue = itemizedProgramFees.reduce((sum, item) => sum + item.fee, 0);

    const totalFees = adminFee + commission + serviceFee + totalProgramFeeValue + perOrderFee;
    const netProfit = calculatedPrice - hpp - bestDiscount - totalFees;
    const totalSemuaBiaya = hpp + bestDiscount + totalFees;
    const labaKotor = calculatedPrice - bestDiscount - hpp;

    uiState.priceCalculator.result = {
        calculatedPrice,
        totalFees,
        netProfit,
        bestDiscount,
        totalSemuaBiaya,
        labaKotor,
        bestDiscountRatePercentage: discountInfo.rate || 0,
        breakdown: {
            hpp,
            adminFee,
            admRate: mp.adm || 0,
            commission,
            komisiRate: commissionRate * 100,
            serviceFee,
            layananRate: mp.layanan || 0,
            programFee: itemizedProgramFees,
            perOrderFee
        }
    };
}

async function recordBagiHasilPayment() {
    const report = uiState.laporanBagiHasil;
    const result = report.result;
    if (!result || result.investorShare <= 0) return alert("Tidak ada keuntungan.");

    // --- AWAL PERBAIKAN: Mengambilll data dari state yang benar ---
    const paymentMethod = report.paymentMethod; 
    const adminFee = paymentMethod === 'transfer' ? (report.adminFee || 0) : 0;
    const totalPengeluaran = result.investorShare + adminFee;
    let catatan = `Bagi hasil ${result.investorName} (${result.period}). Metode: ${paymentMethod}.`;
    
    if (paymentMethod === 'transfer') {
        if (!report.selectedBankAccountId) return alert("Pilih rekening tujuan transfer.");
        const bank = state.bankAccounts.find(b => b.id === report.selectedBankAccountId);
        catatan += ` Ke: ${bank.bankName} ${bank.accountNumber} a.n ${bank.accountName}.`;
        if (adminFee > 0) catatan += ` Biaya Admin: ${formatCurrency(adminFee)}.`;
    }
    // --- AKHIR PERBAIKAN ---

    if (!confirm(`Anda akan mencatat pengeluaran total sebesar ${formatCurrency(totalPengeluaran)}. Lanjutkan?`)) return;

    try {
        const batch = writeBatch(db);

        // 1. Catat di 'keuangan' (Pengeluaran umum)
        const keuanganData = {
            kategori: 'Bagi Hasil Investor',
            jumlah: totalPengeluaran,
            catatan: catatan,
            jenis: 'pengeluaran',
            userId: currentUser.value.uid,
            tanggal: new Date()
        };
        const keuanganRef = doc(collection(db, "keuangan"));
        batch.set(keuanganRef, keuanganData);

        // 2. Catat di 'investor_payments' (Riwayat khusus investor)
        const paymentData = {
            investorId: report.selectedInvestorId,
            investorName: result.investorName,
            period: result.period,
            labaBersihPeriode: result.labaBersih,
            profitSharePercentage: result.profitSharePercentage,
            investorShare: result.investorShare,
            companyShare: result.companyShare,
            paymentMethod: paymentMethod,
            adminFee: adminFee,
            totalPayment: totalPengeluaran,
            bankDetails: paymentMethod === 'transfer' ? state.bankAccounts.find(b => b.id === report.selectedBankAccountId) : null,
            paymentDate: new Date(),
            userId: currentUser.value.uid,
            omsetBersihPenjualan: result.omsetBersihPenjualan,
            omsetBersihDariRetur: result.omsetBersihDariRetur,
            omsetBersihFinal: result.omsetBersihFinal,
            totalHppTerjual: result.totalHppTerjual,
            totalHppRetur: result.totalHppRetur,
            hppTerjualFinal: result.hppTerjualFinal,
            labaKotor: result.labaKotor,
            biayaMarketplacePenjualan: result.biayaMarketplacePenjualan,
            biayaMarketplaceBatal: result.biayaMarketplaceBatal,
            totalBiayaTransaksi: result.totalBiayaTransaksi,
            totalBiayaOperasional: result.totalBiayaOperasional
        };
        const paymentRef = doc(collection(db, "investor_payments"));
        batch.set(paymentRef, paymentData);

        await batch.commit();

        // Update state lokal
        state.keuangan.push({ id: keuanganRef.id, ...keuanganData });
        state.investorPayments.push({ id: paymentRef.id, ...paymentData });

        alert('Pembayaran bagi hasil berhasil dicatat!');
        report.result = null; // Reset laporan
    } catch (error) {
        console.error("Gagal mencatat pembayaran:", error);
        alert("Gagal mencatat pembayaran.");
    }
}

function renderCharts() {
    if (profitExpenseChart) profitExpenseChart.destroy();
    if (salesChannelChart) salesChannelChart.destroy();
    
    // Gunakan nilai default array kosong untuk mencegah error
    const { transaksi = [], keuangan = [] } = dashboardFilteredData.value || {};
    const ctxProfit = document.getElementById('profitExpenseChart')?.getContext('2d');
    const ctxSales = document.getElementById('salesChannelChart')?.getContext('2d');
    
    if (!ctxProfit || !ctxSales) {
        return;
    }

    if (
        dashboardSummaryV2.periodReady ===
        true
    ) {
        const series =
            Array.isArray(
                dashboardSummaryV2.series
            )
                ? dashboardSummaryV2.series
                : [];

        profitExpenseChart =
            new Chart(
                ctxProfit,
                {
                    type: 'line',
                    data: {
                        labels:
                            series.map(
                                item =>
                                    item.key
                            ),
                        datasets: [
                            {
                                label:
                                    'Laba Kotor',
                                data:
                                    series.map(
                                        item =>
                                            Number(
                                                item
                                                    .labaKotor
                                            ) || 0
                                    ),
                                borderColor:
                                    '#10b981',
                                backgroundColor:
                                    'rgba(16, 185, 129, 0.2)',
                                fill: true
                            },
                            {
                                label:
                                    'Biaya Operasional',
                                data:
                                    series.map(
                                        item =>
                                            Number(
                                                item
                                                    .biayaOperasional
                                            ) || 0
                                    ),
                                borderColor:
                                    '#ef4444',
                                backgroundColor:
                                    'rgba(239, 68, 68, 0.2)',
                                fill: true
                            }
                        ]
                    },
                    options: {
                        responsive: true,
                        maintainAspectRatio:
                            false
                    }
                }
            );

        const channelData =
            dashboardSummaryV2.channels ||
            {};

        salesChannelChart =
            new Chart(
                ctxSales,
                {
                    type: 'doughnut',
                    data: {
                        labels:
                            Object.keys(
                                channelData
                            ),
                        datasets: [
                            {
                                data:
                                    Object.values(
                                        channelData
                                    ),
                                backgroundColor: [
                                    '#4f46e5',
                                    '#3b82f6',
                                    '#10b981',
                                    '#f97316',
                                    '#ef4444'
                                ]
                            }
                        ]
                    },
                    options: {
                        responsive: true,
                        maintainAspectRatio:
                            false
                    }
                }
            );

        return;
    }
    
    // --- GRAFIK 1: LABA KOTOR VS BIAYA OPERASIONAL ---
    const dates = [...new Set([
        ...transaksi.map(t => new Date(t.tanggal).toDateString()), 
        ...keuangan.map(b => new Date(b.tanggal).toDateString())
    ])].sort((a,b) => new Date(a) - new Date(b));

    const profitData = dates.map(d => transaksi.filter(t => new Date(t.tanggal).toDateString() === d).reduce((s, t) => s + (t.total - t.items.reduce((ts, i) => ts + (i.hpp || 0) * (i.qty || 0), 0)), 0));
    const expenseData = dates.map(d => keuangan.filter(b => new Date(b.tanggal).toDateString() === d && b.jenis === 'pengeluaran').reduce((s, b) => s + (b.jumlah || 0), 0));
    
    profitExpenseChart = new Chart(ctxProfit, {
        type: 'line',
        data: {
            labels: dates,
            datasets: [{ 
                label: 'Laba Kotor', 
                data: profitData, 
                borderColor: '#10b981', 
                backgroundColor: 'rgba(16, 185, 129, 0.2)',
                fill: true 
            }, { 
                label: 'Biaya Operasional', 
                data: expenseData, 
                borderColor: '#ef4444', 
                backgroundColor: 'rgba(239, 68, 68, 0.2)',
                fill: true 
            }] 
        }, 
        options: { responsive: true, maintainAspectRatio: false } 
    });
    
    // --- GRAFIK 2: PENJUALAN PER CHANNEL ---
    const salesByChannel = transaksi.reduce((acc, trx) => {
        acc[trx.channel] = (acc[trx.channel] || 0) + (trx.total || 0);
        return acc;
    }, {});
    
    salesChannelChart = new Chart(ctxSales, {
        type: 'doughnut',
        data: { 
            labels: Object.keys(salesByChannel), 
            datasets: [{ 
                data: Object.values(salesByChannel), 
                backgroundColor: ['#4f46e5', '#3b82f6', '#10b981', '#f97316', '#ef4444'] 
            }] 
        }, 
        options: { responsive: true, maintainAspectRatio: false } 
    });
}

// eslint-disable-next-line no-unused-vars

async function exportTransactionsToExcel() {
    // 1. Ambil data yang sudah difilter dari tabel (filteredTransaksi sudah ada di kode Anda)
    const dataToExport = filteredTransaksi.value;

    if (dataToExport.length === 0) {
        alert("Tidak ada data transaksi untuk diekspor pada periode yang dipilih.");
        return;
    }

    try {
        // 2. Proses data (map, BUKAN flatMap) untuk membuat 1 baris per transaksi
        const worksheetData = dataToExport.map(trx => {
            
            // 3. Lakukan semua kalkulasi yang sama seperti di modal "Detail Transaksi"
            const totalHPP = (trx.items || []).reduce((sum, item) => sum + (item.hpp || 0) * item.qty, 0);
            const totalBiayaMarketplace = trx.biaya?.total || 0;
            const labaKotor = trx.total - totalHPP; // (Omset Bersih - Total HPP)
            const labaBersih = trx.total - totalHPP - totalBiayaMarketplace;

            // 4. Ambil rincian biaya
            const rincianBiaya = trx.biaya?.rincian || [];
            const komisiProduk = rincianBiaya.find(b => b.name === 'Komisi Produk')?.value || 0;
            const administrasi = rincianBiaya.find(b => b.name === 'Administrasi')?.value || 0;
            const perPesanan = rincianBiaya.find(b => b.name === 'Per Pesanan')?.value || 0;
            const layananGxtra = rincianBiaya.find(b => b.name.includes('Layanan'))?.value || 0;
            const biayaIklan = rincianBiaya.find(b => b.name === 'BIAYA IKLAN')?.value || 0;
            const asuransi = rincianBiaya.find(b => b.name.includes('Asuransi'))?.value || 0;

            // 5. Buat objek data untuk baris Excel
            return {
                "ID Pesanan": trx.marketplaceOrderId || trx.id,
                "Tanggal": new Date(trx.tanggal),
                "Channel": trx.channel,
                "Item Terjual": (trx.items || []).map(item => `${item.qty}x ${item.sku}`).join('; '),
                "Omset Kotor": trx.subtotal,
                "Diskon": trx.diskon?.totalDiscount || 0,
                "Omset Bersih": trx.total,
                "Total HPP Terjual": totalHPP,
                "Laba Kotor": labaKotor,
                "Total Biaya Marketplace": totalBiayaMarketplace,
                "Estimasi Laba Bersih": labaBersih,
                "Biaya Komisi Produk": komisiProduk,
                "Biaya Administrasi": administrasi,
                "Biaya Per Pesanan": perPesanan,
                "Biaya Layanan": layananGxtra,
                "Biaya Iklan": biayaIklan,
                "Biaya Asuransi": asuransi
            };
        });
        
        const worksheet = XLSX.utils.json_to_sheet(worksheetData);
        
        // 6. Atur lebar kolom agar rapi
        worksheet['!cols'] = [
            { wch: 25 }, // ID Pesanan
            { wch: 20 }, // Tanggal
            { wch: 20 }, // Channel
            { wch: 30 }, // Item Terjual
            { wch: 15 }, // Omset Kotor
            { wch: 15 }, // Diskon
            { wch: 15 }, // Omset Bersih
            { wch: 15 }, // Total HPP
            { wch: 15 }, // Laba Kotor
            { wch: 20 }, // Total Biaya MP
            { wch: 20 }, // Laba Bersih
            { wch: 20 }, // Komisi Produk
            { wch: 20 }, // Administrasi
            { wch: 20 }, // Per Pesanan
            { wch: 20 }, // Layanan
            { wch: 20 }, // Iklan
            { wch: 20 }  // Asuransi
        ];

        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Transaksi");

        const fileName = `Export_Transaksi_Lengkap_${new Date().toISOString().split('T')[0]}.xlsx`;
        XLSX.writeFile(workbook, fileName);
    } catch (error) {
        console.error("Gagal mengekspor data transaksi:", error);
        alert("Terjadi kesalahan saat mengekspor data.");
    }
}

function addPromotionTier(modelName, channelId) {
    if (!state.promotions.perModel[modelName]) state.promotions.perModel[modelName] = {};
    if (!state.promotions.perModel[modelName][channelId]) state.promotions.perModel[modelName][channelId] = {};
    if (!state.promotions.perModel[modelName][channelId].diskonBertingkat) state.promotions.perModel[modelName][channelId].diskonBertingkat = [];
    state.promotions.perModel[modelName][channelId].diskonBertingkat.push({ min: 0, diskon: 0 });
}

// Logika untuk menghapus tingkatan diskon
function removePromotionTier(modelName, channelId, tierIndex) {
    if (state.promotions.perModel[modelName]?.[channelId]?.diskonBertingkat) {
        state.promotions.perModel[modelName][channelId].diskonBertingkat.splice(tierIndex, 1);
    }
}

function setupNewProduksiBatch() {
    uiState.newProduksiBatch = reactive({
        tanggal: new Date().toISOString().split('T')[0],
        produksiType: 'pemaklun',
        namaStatus: '',
        statusProses: 'Dalam Proses',
        kainBahan: [{
            idUnik: generateUniqueCode(),
            modelProdukId: '',
            sku: '', // Untuk produk terdaftar (aktual jadi)
            skuKombinasi: '', // <-- FIELD BARU DITAMBAHKAN
            namaKain: '',
            tokoKain: '',
            warnaKain: '',
            ukuran: '',
            totalYard: null,
            hargaKainPerYard: null,
            yardPerModel: null,
            aktualJadi: null,
            hargaMaklunPerPcs: null,
            hargaJahitPerPcs: null,
            biayaAlat: null,
            aktualJadiKombinasi: null,
            isInventoried: false,
        }],
        statusPembayaran: 'Belum Dibayar',
        jumlahPembayaran: null,
        tanggalPembayaran: '',
        catatan: '',
        orangMemproses: '',
    });
}

async function submitNewProduksiBatch() {
    if (!currentUser.value) {
        return alert("Anda harus login untuk membuat batch produksi.");
    }

    const newBatchData = JSON.parse(JSON.stringify(uiState.newProduksiBatch));
    
    if (!newBatchData.namaStatus) { // <-- Menggunakan namaStatus untuk validasi
        return alert("Nama Pemaklun/Penjahit wajib diisi.");
    }
    
    let totalQty = 0;
    let totalBiayaMaterial = 0;
    let totalHargaJasa = 0;

    (newBatchData.kainBahan || []).forEach(item => {
        totalBiayaMaterial += (item.totalYard || 0) * (item.hargaKainPerYard || 0);
        totalQty += (item.aktualJadi || 0);
        
        const hargaJasaPerPcs = newBatchData.produksiType === 'penjahit' 
            ? (item.hargaJahitPerPcs || 0) 
            : (item.hargaMaklunPerPcs || 0);
        totalHargaJasa += (item.aktualJadi || 0) * hargaJasaPerPcs;
    });

    const batchId = `PROD-${Date.now()}`;
    
    const dataToSave = {
        ...newBatchData,
        id: batchId,
        totalQty,
        totalBiayaMaterial,
        totalHargaJasaMaklun: totalHargaJasa,
        tanggal: new Date(newBatchData.tanggal),
        userId: currentUser.value.uid,
    };
    
    try {
        const batchRef = doc(db, "production_batches", batchId);
        await setDoc(batchRef, dataToSave);

        state.produksi.unshift(dataToSave); 
        
        hideModal();
        alert('Batch produksi baru berhasil disimpan ke Database!');

    } catch (error) {
        console.error("Error menyimpan batch produksi baru:", error);
        alert("Gagal menyimpan batch produksi baru. Cek console.");
    }
}

function setupEditProduksiBatch(batch) {
    // Buat salinan data batch agar data asli di state tidak ikut berubah sebelum disimpan
    const dataForModal = JSON.parse(JSON.stringify(batch));
    
    // Pastikan properti dinamis ada, meskipun tidak ada di data database
    dataForModal.produksiType = dataForModal.produksiType || 'pemaklun';
    dataForModal.namaStatus = dataForModal.namaStatus || '';
    dataForModal.totalBiayaMaterial = dataForModal.totalBiayaMaterial || 0;
    dataForModal.totalHargaJasaMaklun = dataForModal.totalHargaJasaMaklun || 0;

    if (dataForModal.kainBahan && Array.isArray(dataForModal.kainBahan)) {
        dataForModal.kainBahan = dataForModal.kainBahan.map(item => {
            if (!item.idUnik) {
                item.idUnik = generateUniqueCode();
            }
            return {
                ...item,
                hargaMaklunPerPcs: item.hargaMaklunPerPcs || 0,
                biayaAlat: item.biayaAlat || 0,
                isInventoried: item.isInventoried || false,
            };
        });
    }

    // Konversi objek Date ke format string YYYY-MM-DD
    if (dataForModal.tanggal) {
        dataForModal.tanggal = new Date(dataForModal.tanggal).toISOString().split('T')[0];
    }
    if (dataForModal.tanggalPembayaran) {
        dataForModal.tanggalPembayaran = new Date(dataForModal.tanggalPembayaran).toISOString().split('T')[0];
    }

    uiState.editProduksiBatch = reactive(dataForModal);
}



async function submitEditProduksiBatch() {
    const editedBatchData = JSON.parse(JSON.stringify(uiState.editProduksiBatch));
    let totalQty = 0;
    let totalBiayaMaterial = 0;
    let totalHargaJasaMaklun = 0;

    (editedBatchData.kainBahan || []).forEach(item => {
        totalBiayaMaterial += (item.totalYard || 0) * (item.hargaKainPerYard || 0);
        
        // =========================================================================
        // PERUBAHAN DI SINI: Hanya menjumlahkan 'aktualJadi'
        // =========================================================================
        totalQty += (parseInt(item.aktualJadi, 10) || 0);
        
        totalHargaJasaMaklun += (parseInt(item.aktualJadi, 10) || 0) * (item.hargaMaklunPerPcs || 0);
    });
    
    const finalBatch = { ...editedBatchData, totalQty, totalBiayaMaterial, totalHargaJasaMaklun };
    
    const dataToUpdate = { ...finalBatch };
    delete dataToUpdate.id;
    dataToUpdate.tanggal = new Date(dataToUpdate.tanggal);
    if (dataToUpdate.tanggalPembayaran) {
        dataToUpdate.tanggalPembayaran = new Date(dataToUpdate.tanggalPembayaran);
    }
    dataToUpdate.produksiType = editedBatchData.produksiType;
    dataToUpdate.namaStatus = editedBatchData.namaStatus;
    try {
        const batchRef = doc(db, "production_batches", finalBatch.id);
        await updateDoc(batchRef, dataToUpdate);

        const index = state.produksi.findIndex(b => b.id === finalBatch.id);
        if (index !== -1) {
            state.produksi.splice(index, 1, finalBatch);
        }
        
        hideModal();
        alert("Batch produksi berhasil diperbarui di Database.");

    } catch(error) {
        console.error("Error mengupdate batch produksi:", error);
        alert("Gagal memperbarui data di database.");
    }
}

// KODE BARU

async function updateProductionInventoryStatus(batchId, itemIndex) {
    // 1. CEK STATUS KUNCI (Agar tidak bisa diklik saat sedang loading)
    if (isSaving.value) return; 

    if (!currentUser.value) {
        alert("Anda harus login untuk mengelola inventaris.");
        return;
    }

    const originalBatch = state.produksi.find(b => b.id === batchId);
    if (!originalBatch) {
        alert("Batch tidak ditemukan.");
        return;
    }
    const itemToUpdate = originalBatch.kainBahan[itemIndex];

    // 2. CEK STATUS ITEM (Agar tidak diproses ulang jika data lokal sudah update)
    if (itemToUpdate.isInventoried) {
        return; // Diam saja, jangan muncul alert biar tidak mengganggu flow
    }
    
    // Konfirmasi
    if (!confirm("Masukan stok ke inventaris?")) {
        return;
    }
    
    const qtyToAdd = parseInt(itemToUpdate.aktualJadi, 10) || 0;
    if (qtyToAdd <= 0) {
        alert("Jumlah 0, stok tidak bertambah.");
        return;
    }

    // --- KUNCI UTAMA (INI YANG MEMBUAT AMAN) ---
    // Kita set loading TRUE detik ini juga. 
    // Jadi walaupun HP/Laptop lag, klik kedua tidak akan tembus ke bawah.
    isSaving.value = true; 

    try {
        const batch = writeBatch(db);
        const batchRef = doc(db, "production_batches", batchId);
        const matchingProduct = getProductBySku(itemToUpdate.sku);

        if (matchingProduct) {
            const productRef = doc(db, "products", matchingProduct.docId);
            const allocationRef = doc(db, "stock_allocations", matchingProduct.docId);

            // Gunakan INCREMENT agar hitungan dilakukan di server Google (Pasti Akurat)
            batch.update(productRef, { physical_stock: increment(qtyToAdd) });

            // Tandai item ini sudah masuk (Update Dokumen Produksi)
            const newKainBahan = JSON.parse(JSON.stringify(originalBatch.kainBahan));
            newKainBahan[itemIndex].isInventoried = true;
            batch.update(batchRef, { kainBahan: newKainBahan });

            // Update timestamp alokasi
            batch.set(allocationRef, { userId: currentUser.value.uid }, { merge: true });

            // EKSEKUSI KE DATABASE
            await batch.commit();

            // Firestore menjadi sumber kebenaran untuk angka stok.
            // state.produk dan state.inventoryPaginated dapat menunjuk objek
            // produk yang sama. Karena itu stok tidak boleh ditambah dengan
            // "+=" pada kedua array: angka layar bisa bertambah dua kali.
            let stokTerbaru =
                (Number(matchingProduct.stokFisik) || 0) +
                qtyToAdd;

            try {
                const freshProductSnapshot =
                    await getDocFromServer(productRef);

                if (freshProductSnapshot.exists()) {
                    stokTerbaru =
                        Number(
                            freshProductSnapshot
                                .data()
                                ?.physical_stock
                        ) || 0;
                }
            } catch (verificationError) {
                // Commit utama sudah berhasil. Bila pembacaan verifikasi
                // sesaat gagal, tampilkan hasil lokal satu kali. Cache produk
                // tetap kotor dan sinkronisasi berikutnya akan memakai server.
                console.warn(
                    '[STOK PRODUKSI] Stok server belum dapat diverifikasi. Memakai hasil lokal satu kali.',
                    verificationError
                );
            }

            // Tombol langsung berubah menjadi "Sudah Masuk Inventaris".
            itemToUpdate.isInventoried = true;

            const applyLatestProductionStock =
                productList => {
                    (productList || []).forEach(product => {
                        if (
                            product?.docId ===
                            matchingProduct.docId
                        ) {
                            // Assignment nilai final, bukan penambahan ulang.
                            // Aman walaupun dua array memegang objek yang sama.
                            product.stokFisik =
                                stokTerbaru;
                        }
                    });
                };

            applyLatestProductionStock(
                state.produk
            );

            applyLatestProductionStock(
                state.inventoryPaginated
            );

            console.log(
                `[STOK PRODUKSI] ${itemToUpdate.sku}: +${qtyToAdd} pcs, stok terbaru ${stokTerbaru}.`
            );

            // Pesan Sukses
            alert("Berhasil! Stok bertambah.");

        } else {
            throw new Error("Produk SKU ini belum terdaftar di Inventaris.");
        }
    } catch (error) {
        console.error("Error update stok:", error);
        alert(`Gagal: ${error.message}`);
    } finally {
        // BUKA KUNCI SETELAH SEMUA SELESAI
        isSaving.value = false;
    }
}

function calculateRowSummary(item, batchType) {
    let batch;
    if (batchType === 'new') {
        batch = uiState.newProduksiBatch;
    } else if (batchType === 'edit') {
        batch = uiState.editProduksiBatch;
    } else {
        return { totalBiayaJasa: 0, totalBiayaAlat: 0 };
    }
    
    const modelInfo = state.settings.modelProduk.find(m => m.id === item.modelProdukId) || {};
    const totalYard = parseFloat(item.totalYard) || 0;
    const hargaKainPerYard = parseFloat(item.hargaKainPerYard) || 0;
    const aktualJadi = parseFloat(item.aktualJadi) || 0;
    const aktualJadiKombinasi = parseFloat(item.aktualJadiKombinasi) || 0;
    const hargaJahitPerPcs = parseFloat(item.hargaJahitPerPcs) || 0;
    const hargaMaklunPerPcs = parseFloat(item.hargaMaklunPerPcs) || 0;
    const biayaAlatInput = parseFloat(item.biayaAlat) || 0;
    const yardPerModel = parseFloat(item.yardPerModel) || (modelInfo.yardPerModel || 1);

    const totalBiayaKain = totalYard * hargaKainPerYard;
    
    let hargaJasa = 0;
    if (batch.produksiType === 'penjahit') {
        hargaJasa = hargaJahitPerPcs;
    } else {
        hargaJasa = hargaMaklunPerPcs;
    }

    const targetQty = yardPerModel > 0 ? Math.floor(totalYard / yardPerModel) : 0;
    
    let aktualFinal = aktualJadi > 0 ? aktualJadi : aktualJadiKombinasi;

    const totalBiayaJasa = aktualJadi * hargaJasa;
    const totalBiayaAlat = aktualJadi > 0 ? biayaAlatInput : 0;
    const selisih = aktualFinal - targetQty;
    const totalBiayaProduksi = totalBiayaKain + totalBiayaJasa + totalBiayaAlat;
    
    const hpp = totalBiayaProduksi / (aktualFinal || 1);
    const hppIdeal = targetQty > 0 ? totalBiayaProduksi / targetQty : hpp;
    const kerugianPerPcs = selisih < 0 && aktualFinal > 0 ? hpp - hppIdeal : 0;

    return {
        targetQty,
        selisih,
        totalBiayaKain,
        totalBiayaJasa,
        totalBiayaAlat,
        totalBiayaProduksi, // <-- DATA BARU UNTUK DITAMPILKAN
        hpp,
        hppIdeal,
        kerugianPerPcs
    };
}

async function deleteProduksiBatch(batchId) {
    if (confirm(`Anda yakin ingin menghapus batch produksi ID: ${batchId}?`)) {
        try {
            // Membuat referensi ke dokumen yang akan dihapus
            const batchRef = doc(db, "production_batches", batchId);
            
            // Menghapus dokumen dari Firestore
            await deleteDoc(batchRef);

            // Menghapus data dari state lokal untuk update UI instan
            state.produksi = state.produksi.filter(b => b.id !== batchId);
            
            alert(`Batch produksi ID: ${batchId} berhasil dihapus.`);
            
        } catch (error) {
            console.error("Error menghapus batch produksi:", error);
            alert("Gagal menghapus data dari database.");
        }
    }
}
function handleStockInSearch() {
    const query = uiState.modalData.sku.trim().toLowerCase();
    if (query.length < 2) {
        uiState.stockInSearchRecommendations = [];
        return;
    }
    uiState.stockInSearchRecommendations = state.produk.filter(p => 
        p.sku.toLowerCase().includes(query) ||
        p.nama.toLowerCase().includes(query)
    ).slice(0, 5); // Batasi hanya 5 rekomendasi
}

function selectStockInRecommendation(product) {
    uiState.modalData.sku = product.sku; // Isi input dengan SKU yang dipilih
    uiState.stockInSearchRecommendations = []; // Sembunyikan rekomendasi
}


function generateLaporanByStatus(status) {
    uiState.laporanData.statusTerpilih = status === 'all' ? 'Semua' : status;
    
    // KOMENTAR: Logika baru untuk menangani pilihan "Semua Status"
    if (status === 'all') {
        uiState.laporanData.laporanPerStatus = state.produksi;
    } else {
        uiState.laporanData.laporanPerStatus = state.produksi.filter(b => b.statusProses === status);
    }
    
    showModal('laporanStatusDetail');
}

function printProduksiDetail(batch) {
    // [PERBAIKAN 1] Logika untuk menentukan label dan nama yang benar
    const jenisPekerjaLabel = batch.produksiType === 'penjahit' ? 'Penjahit' : 'Pemaklun';
    const namaPekerja = batch.namaStatus || 'N/A';
    
    const printContent = `
        <style>
            @media print {
                @page { 
                    size: A4; 
                    margin: 20mm; 
                }
                body { 
                    -webkit-print-color-adjust: exact; 
                    print-color-adjust: exact;
                }
                /* Sembunyikan header dan footer default browser */
                @page {
                    @top-left { content: none; }
                    @top-right { content: none; }
                    @bottom-left { content: none; }
                    @bottom-right { content: none; }
                }
                header, footer { display: none; }
            }
            body { 
                font-family: Arial, sans-serif; 
                font-size: 11pt; 
            }
            h3, h4 { 
                margin: 0; 
                padding: 0; 
                color: #333;
            }
            .header { text-align: center; border-bottom: 1px solid #ccc; padding-bottom: 10px; margin-bottom: 20px; }
            .info-section { margin-bottom: 20px; }
            .info-section p { margin: 4px 0; }
            table { width: 100%; border-collapse: collapse; margin-top: 15px; }
            th, td { border: 1px solid #ddd; padding: 8px; text-align: left; }
            th { background-color: #f2f2f2; font-weight: bold; }
            .total { font-weight: bold; }
            .text-right { text-align: right; }
        </style>
        <title>Detail Batch Produksi - ${batch.id}</title> <!-- [PERBAIKAN 2] Menghilangkan 'about:blank' -->
        <div class="header">
            <h3>Detail Batch Produksi: ${batch.id}</h3>
        </div>
        <div class="info-section">
            <p><strong>Tanggal:</strong> ${new Date(batch.tanggal).toLocaleDateString('id-ID')}</p>
            <!-- [PERBAIKAN 3] Menampilkan label dan nama yang sudah benar -->
            <p><strong>${jenisPekerjaLabel}:</strong> ${namaPekerja}</p>
            <p><strong>Status:</strong> ${batch.statusProses}</p>
        </div>
        <h4>Detail Produksi</h4>
        <table>
            <thead>
                <tr>
                    <th>Nama Produk</th> <!-- [PERBAIKAN 4] Kolom baru untuk nama produk -->
                    <th>Nama Kain</th>
                    <th>Warna</th>
                    <th>Ukuran</th>
                    <th class="text-right">Aktual Jadi</th>
                </tr>
            </thead>
            <tbody>
                ${(batch.kainBahan || []).map(kb => `
                    <tr>
                        <td>${state.settings.modelProduk.find(m => m.id === kb.modelProdukId)?.namaModel || 'N/A'}</td>
                        <td>${kb.namaKain || '-'}</td>
                        <td>${kb.warnaKain || '-'}</td>
                        <td>${kb.ukuran || '-'}</td>
                        <td class="text-right">${kb.aktualJadi || 0} pcs</td>
                    </tr>
                `).join('')}
            </tbody>
        </table>
        
        <div style="margin-top: 25px;">
             <h4>Ringkasan Biaya</h4>
             <table>
                <tbody>
                    <tr><td>Total Kuantitas Jadi</td><td class="total text-right">${batch.totalQty} pcs</td></tr>
                    <tr><td>Total Biaya Material</td><td class="total text-right">${formatCurrency(batch.totalBiayaMaterial)}</td></tr>
                    <!-- [PERBAIKAN 5] Label biaya jasa dinamis -->
                    <tr><td>Total Biaya ${jenisPekerjaLabel}</td><td class="total text-right">${formatCurrency(batch.totalHargaJasaMaklun)}</td></tr>
                </tbody>
            </table>
        </div>
    `;
    const printWindow = window.open('', '_blank');
    printWindow.document.write(printContent);
    printWindow.document.close();
    printWindow.print();
}

function printPurchaseInvoice(order) {
    if (!order) return;
    
    // Mengambil Nama Brand dari Pengaturan
    const brandName = state.settings.brandName || 'FASHION OS';
    const totalTagihan = order.totalQtyValue || 0;
    const sudahDibayar = order.dibayarkan || 0;
    const sisa = totalTagihan - sudahDibayar;
    
    // Penentuan Status yang lebih pas untuk Reseller
    let statusBayar = 'BELUM BAYAR';
    if (sisa <= 0) statusBayar = 'LUNAS';
    else if (sudahDibayar > 0) statusBayar = 'DICICIL';

    const openingScript = '<' + 'script>';
const closingScript = '<' + '/script>';

    const printContent = `
        <html>
        <head>
            <title>Nota #${order.id.slice(-6)}</title>
            <style>
                /* Pengaturan Kertas HVS / A4 */
                @page {
                    size: A4 portrait;
                    margin: 15mm;
                }

                * {
                    box-sizing: border-box;
                    -webkit-print-color-adjust: exact;
                }

                body { 
                    font-family: 'Arial', sans-serif; 
                    color: #1e293b; 
                    margin: 0; 
                    padding: 0; 
                    font-size: 12px;
                    background: white;
                }

                .container { 
                    width: 100%;
                    max-width: 190mm;
                    margin: auto;
                }

                /* Header: Nama Toko Anda */
                .header { 
                    display: flex; 
                    justify-content: space-between; 
                    align-items: center;
                    border-bottom: 4px solid #1e293b; 
                    padding-bottom: 15px; 
                    margin-bottom: 25px; 
                }

                .brand-section h1 { 
                    font-size: 28px; 
                    font-weight: 900; 
                    color: #1e293b; 
                    text-transform: uppercase;
                    margin: 0;
                    letter-spacing: -1px;
                }

                .document-title {
                    text-align: right;
                }

                .document-title h2 {
                    margin: 0;
                    font-size: 18px;
                    color: #475569;
                    letter-spacing: 2px;
                }

                /* Detail Transaksi */
                .info-grid { 
                    display: flex; 
                    justify-content: space-between; 
                    margin-bottom: 30px; 
                }

                .info-box p { margin: 2px 0; }
                .label-small { font-size: 10px; color: #64748b; font-weight: bold; text-transform: uppercase; }

                .status-badge { 
                    border: 3px double #ef4444; 
                    color: #ef4444; 
                    font-size: 20px; 
                    font-weight: 900; 
                    padding: 5px 20px; 
                    transform: rotate(-10deg); 
                    display: inline-block;
                    text-transform: uppercase;
                    border-radius: 4px;
                }

                .status-lunas { border-color: #10b981; color: #10b981; }

                /* Tabel Barang */
                table { 
                    width: 100%; 
                    border-collapse: collapse; 
                    margin-bottom: 30px; 
                }

                th { 
                    background: #f1f5f9; 
                    padding: 12px 10px; 
                    border-bottom: 2px solid #cbd5e1; 
                    text-align: left; 
                    font-size: 11px;
                    color: #475569;
                }

                td { 
                    padding: 12px 10px; 
                    border-bottom: 1px solid #e2e8f0; 
                }

                /* Perhitungan Total */
                .summary-section {
                    display: flex;
                    justify-content: flex-end;
                }

                .totals-table { 
                    width: 280px;
                }

                .total-row { 
                    display: flex; 
                    justify-content: space-between; 
                    padding: 6px 0; 
                    font-size: 13px;
                }

                .grand-total { 
                    border-top: 2px solid #1e293b; 
                    margin-top: 10px; 
                    padding-top: 10px; 
                    font-weight: bold; 
                    font-size: 16px; 
                }

                .footer { 
                    margin-top: 60px; 
                    font-size: 10px; 
                    color: #94a3b8; 
                    border-top: 1px solid #e2e8f0; 
                    padding-top: 20px;
                    text-align: center;
                }

                @media print {
                    body { margin: 0; }
                    .no-print { display: none; }
                }
            </style>
        </head>
        <body>
            <div class="container">
                <div class="header">
                    <div class="brand-section">
                        <h1>${brandName}</h1>
                        <p style="margin:0; font-weight: bold; color: #64748b;">LAPORAN PEMBELIAN BARANG</p>
                    </div>
                    <div class="document-title">
                        <h2>NOTA RESMI</h2>
                        <p style="margin:0; font-family:monospace; font-weight: bold;">Ref: #${order.id.slice(-6).toUpperCase()}</p>
                    </div>
                </div>

                <div class="info-grid">
                    <div class="info-box">
                        <p class="label-small">Asal Gudang / Supplier:</p>
                        <p style="font-size: 16px; font-weight: bold;">${order.supplierName}</p>
                        <p class="label-small" style="margin-top:10px;">Waktu Pengambilan:</p>
                        <p style="font-weight: bold;">${new Date(order.tanggal).toLocaleDateString('id-ID', { weekday: 'long', day: 'numeric', month: 'long', year: 'numeric' })}</p>
                    </div>
                    <div class="info-box" style="text-align: right;">
                        <div class="status-badge ${sisa <= 0 ? 'status-lunas' : ''}">${statusBayar}</div>
                    </div>
                </div>

                <table>
                    <thead>
                        <tr>
                            <th style="width: 55%">Deskripsi Produk & SKU</th>
                            <th style="text-align: right">Harga Satuan</th>
                            <th style="text-align: center">Qty</th>
                            <th style="text-align: right">Subtotal</th>
                        </tr>
                    </thead>
                    <tbody>
                        ${order.produk.map(p => `
                            <tr>
                                <td>
                                    <div style="font-weight:bold; font-size: 13px;">${p.modelName}</div>
                                    <div style="font-size:10px; color:#64748b; font-family: monospace;">SKU: ${p.sku} | Varian: ${p.color} - ${p.size}</div>
                                </td>
                                <td style="text-align: right">${formatCurrency(p.hargaJual)}</td>
                                <td style="text-align: center; font-weight: bold;">${p.qty}</td>
                                <td style="text-align: right; font-weight:bold">${formatCurrency(p.hargaJual * p.qty)}</td>
                            </tr>
                        `).join('')}
                    </tbody>
                </table>

                <div class="summary-section">
                    <div class="totals-table">
                        <div class="total-row">
                            <span>Total Belanja</span>
                            <span>${formatCurrency(totalTagihan)}</span>
                        </div>
                        <div class="total-row" style="color: #10b981; font-weight: bold;">
                            <span>Total Sudah Dibayar</span>
                            <span>${formatCurrency(sudahDibayar)}</span>
                        </div>
                        <div class="total-row grand-total">
                            <span>Sisa Hutang / Tagihan</span>
                            <span style="color: ${sisa > 0 ? '#ef4444' : '#1e293b'}">${formatCurrency(sisa)}</span>
                        </div>
                    </div>
                </div>

                <div class="footer">
                    <p><strong>Catatan Tambahan:</strong> ${order.catatan || 'Tidak ada catatan.'}</p>
                    <p>Nota ini diterbitkan secara otomatis oleh sistem manajemen internal <strong>${brandName}</strong>.</p>
                    <p>Waktu Cetak: ${new Date().toLocaleString('id-ID')}</p>
                </div>
            </div>
            ${openingScript}
                window.onload = function() { 
                    window.print(); 
                    setTimeout(function() { window.close(); }, 1000); 
                }
            ${closingScript}
        </body>
        </html>
    `;
    const printWindow = window.open('', '_blank');
    printWindow.document.write(printContent);
    printWindow.document.close();
}

function exportInvoiceToExcel(order) {
    const brandName = state.settings.brandName || 'FASHION OS';
    
    // Header Nota
    const header = [
        [brandName.toUpperCase()],
        ["INVOICE PENERIMAAN BARANG"],
        ["ID Pesanan:", order.id.slice(-6).toUpperCase()],
        ["Supplier:", order.supplierName],
        ["Tanggal:", new Date(order.tanggal).toLocaleDateString('id-ID')],
        [], // Baris kosong
        ["PRODUK", "SKU", "HARGA", "QTY", "SUBTOTAL"]
    ];

    // Data Produk
    const body = order.produk.map(p => [
        p.modelName,
        p.sku,
        p.hargaJual,
        p.qty,
        p.hargaJual * p.qty
    ]);

    // Footer Keuangan
    const footer = [
        [],
        ["", "", "", "TOTAL TAGIHAN:", order.totalQtyValue],
        ["", "", "", "SUDAH DIBAYAR:", order.dibayarkan],
        ["", "", "", "SISA TAGIHAN:", order.totalQtyValue - order.dibayarkan]
    ];

    const worksheet = XLSX.utils.aoa_to_sheet([...header, ...body, ...footer]);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Invoice");
    
    XLSX.writeFile(workbook, `Invoice_${order.supplierName}_${order.id.slice(-6)}.xlsx`);
}

function exportProduksiDetailToExcel(batch) {
    const dataForExcel = (batch.kainBahan || []).map(kb => {
        const modelName = state.settings.modelProduk.find(m => m.id === kb.modelProdukId)?.namaModel || 'N/A';
        return {
            "ID Batch": batch.id, "Tanggal Produksi": new Date(batch.tanggal), "Nama Pemaklun": batch.namaPemaklun,
            "Status Proses": batch.statusProses, "Nama Model Produk": modelName, "Nama Kain": kb.namaKain || '',
            "Aktual Jadi (Pcs)": kb.aktualJadi || 0, "Harga Maklun/Pcs": kb.hargaMaklunPerPcs || 0,
        };
    });
    if (dataForExcel.length === 0) { alert('Tidak ada detail kain untuk diexport.'); return; }
    const worksheet = XLSX.utils.json_to_sheet(dataForExcel);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, `Detail ${batch.id}`);
    worksheet["!cols"] = [ { wch: 20 }, { wch: 15 }, { wch: 25 }, { wch: 15 }, { wch: 25 }, { wch: 25 }, { wch: 15 }, { wch: 20 } ];
    XLSX.writeFile(workbook, `Detail_Produksi_${batch.id}.xlsx`);
}

function exportGroupedProduksiToExcel() {
    const status = uiState.laporanData.statusTerpilih;
    const data = uiState.laporanData.laporanPerStatus;
    if (data.length === 0) { alert(`Tidak ada data dengan status "${status}" untuk diekspor.`); return; }
    const dataForExcel = data.flatMap(batch => (batch.kainBahan || []).map(kb => {
        const modelName = state.settings.modelProduk.find(m => m.id === kb.modelProdukId)?.namaModel || 'N/A';
        return {
            "ID Batch": batch.id, "Tanggal Produksi": new Date(batch.tanggal), "Nama Pemaklun": batch.namaPemaklun,
            "Status Proses": batch.statusProses, "Nama Model Produk": modelName, "Nama Kain": kb.namaKain || '',
            "Aktual Jadi (Pcs)": kb.aktualJadi || 0, "Harga Maklun/Pcs": kb.hargaMaklunPerPcs || 0,
        };
    }));
    const worksheet = XLSX.utils.json_to_sheet(dataForExcel);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, `Laporan Produksi ${status}`);
    worksheet["!cols"] = [ { wch: 20 }, { wch: 15 }, { wch: 25 }, { wch: 15 }, { wch: 25 }, { wch: 25 }, { wch: 15 }, { wch: 20 } ];
    XLSX.writeFile(workbook, `Laporan_Produksi_${status}_${new Date().toISOString().split('T')[0]}.xlsx`);
}

async function submitBiaya() {
    if (!currentUser.value) return alert("Anda harus login.");
    const form = uiState.modalData;

    // Validasi dasar
    if (!form.kategori || !form.jumlah) {
        return alert("Tanggal, Kategori, dan Jumlah Pokok wajib diisi.");
    }

    const paymentMethod = form.paymentMethod;
    const adminFee = paymentMethod === 'transfer' ? (form.adminFee || 0) : 0;
    const totalPengeluaran = form.jumlah + adminFee;
    let catatanLengkap = form.catatan || '';

    // Buat catatan otomatis berdasarkan metode pembayaran
    if (paymentMethod === 'transfer') {
        if (!form.selectedBankAccountId) return alert("Pilih rekening tujuan untuk transfer.");
        const bank = state.bankAccounts.find(b => b.id === form.selectedBankAccountId);
        let detailTransfer = `(Pembayaran via Transfer ke ${bank.bankName} - ${bank.accountNumber} a.n ${bank.accountName}`;
        if (adminFee > 0) {
            detailTransfer += `, Biaya Admin: ${formatCurrency(adminFee)}`;
        }
        detailTransfer += `)`;
        catatanLengkap = `${catatanLengkap} ${detailTransfer}`.trim();
    } else {
        catatanLengkap = `${catatanLengkap} (Pembayaran via Tunai)`.trim();
    }
    
    const selectedCategory = (state.settings.categories || []).find(cat => cat.name === form.kategori);
const tipeBiaya = selectedCategory?.type || getExpenseTypeByCategory(form.kategori);

isLoading.value = true;
try {
    await addDoc(collection(db, "keuangan"), { 
        kategori: form.kategori,
        kategoriId: selectedCategory?.id || '',
        tipeBiaya: tipeBiaya,
        jumlah: totalPengeluaran,
        catatan: catatanLengkap,
        jenis: 'pengeluaran',
        userId: currentUser.value.uid,
        tanggal: new Date(form.tanggal)
    });

        // KRITIS: Memuat ulang semua data dari DB untuk menyegarkan state
        await fetchKeuanganData(true); 
        
        hideModal();
        alert('Data pengeluaran berhasil disimpan!');
    } catch (e) {
        console.error("Error menyimpan biaya:", e);
        alert("Gagal menyimpan data pengeluaran.");
    } finally {
        isLoading.value = false;
    }
}

async function deleteBiaya(id) {
    if (!currentUser.value) return alert("Anda harus login untuk mengelola biaya.");
    if (!confirm('Anda yakin ingin menghapus data pengeluaran ini?')) return;
    try {
        // PERBAIKAN: Hapus dari koleksi 'keuangan'
        await deleteDoc(doc(db, "keuangan", id)); 
        
        // KRITIS: Memuat ulang semua data dari DB untuk menyegarkan state
        await fetchKeuanganData(true); 
        
        alert('Data pengeluaran berhasil dihapus.');
    } catch (error) {
        console.error("Error menghapus biaya:", error);
        alert("Gagal menghapus data pengeluaran.");
    }
}

async function submitPemasukan() {
    if (!currentUser.value) return alert("Anda harus login untuk mengelola pemasukan.");
    isLoading.value = true;
    try {
        await addDoc(collection(db, "keuangan"), {
            kategori: uiState.modalData.kategori,
            jumlah: uiState.modalData.jumlah,
            catatan: uiState.modalData.catatan,
            jenis: 'pemasukan_lain',
            userId: currentUser.value.uid,
            tanggal: new Date(uiState.modalData.tanggal)
        });

        // KRITIS: Memuat ulang semua data dari DB untuk menyegarkan state
        await fetchKeuanganData(true); 

        hideModal();
        alert('Data pemasukan berhasil disimpan!');
    } catch (e) {
        console.error("Error menyimpan pemasukan:", e);
        alert("Gagal menyimpan data pemasukan.");
    } finally {
        isLoading.value = false;
    }
}

async function deletePemasukan(id) {
    if (!currentUser.value) return alert("Anda harus login untuk mengelola pemasukan.");
    if (!confirm('Anda yakin ingin menghapus data pemasukan ini?')) return;
    try {
        // PERBAIKAN: Hapus dari koleksi 'keuangan'
        await deleteDoc(doc(db, "keuangan", id)); 
        
        // KRITIS: Memuat ulang semua data dari DB untuk menyegarkan state
        await fetchKeuanganData(true); 
        
        alert('Data pemasukan berhasil dihapus.');
    } catch (error) {
        console.error("Error menghapus pemasukan:", error);
        alert("Gagal menghapus data pemasukan.");
    }
}

async function addInflowCategory() {
    if (!currentUser.value) return alert("Anda harus login.");
    const form = uiState.nestedModalData;
    if (!form.name) return alert("Nama kategori tidak boleh kosong.");

    const newCategory = {
        id: `INFLOW-${Date.now()}`,
        name: form.name,
        description: form.description || '',
    };
    try {
        const userRef = doc(db, "users", currentUser.value.uid);
        const userDoc = await getDoc(userRef);
        const userData = userDoc.data();
        
        const updatedCategories = [...(userData.inflowCategories || []), newCategory];
        await updateDoc(userRef, { inflowCategories: updatedCategories });
        
        // Update state lokal
        state.settings.inflowCategories = updatedCategories;
        
        alert('Kategori pemasukan baru berhasil ditambahkan.');
        hideNestedModal();
    } catch (error) {
        console.error("Gagal menambahkan kategori pemasukan:", error);
        alert("Gagal menambahkan kategori pemasukan. Silakan coba lagi.");
    }
}

async function updateInflowCategory() {
    if (!currentUser.value) return alert("Anda harus login.");
    const form = uiState.nestedModalData;
    if (!form.name) return alert("Nama kategori tidak boleh kosong.");
    
    try {
        const userRef = doc(db, "users", currentUser.value.uid);
        const userDoc = await getDoc(userRef);
        const userData = userDoc.data();
        
        const updatedCategories = (userData.inflowCategories || []).map(cat => {
            if (cat.id === form.id) {
                return { ...cat, name: form.name, description: form.description };
            }
            return cat;
        });

        await updateDoc(userRef, { inflowCategories: updatedCategories });
        
        // Update state lokal
        const index = state.settings.inflowCategories.findIndex(cat => cat.id === form.id);
        if (index !== -1) {
            state.settings.inflowCategories[index] = { ...form, id: form.id };
        }

        alert('Kategori pemasukan berhasil diperbarui.');
        hideNestedModal();
    } catch (error) {
        console.error("Gagal memperbarui kategori pemasukan:", error);
        alert("Gagal memperbarui kategori pemasukan. Silakan coba lagi.");
    }
}

async function deleteInflowCategory(categoryId) {
    if (!currentUser.value) return alert("Anda harus login.");
    if (!confirm('Anda yakin ingin menghapus kategori ini?')) return;
    
    try {
        const userRef = doc(db, "users", currentUser.value.uid);
        const userDoc = await getDoc(userRef);
        const userData = userDoc.data();

        const updatedCategories = (userData.inflowCategories || []).filter(cat => cat.id !== categoryId);
        await updateDoc(userRef, { inflowCategories: updatedCategories });
        
        // Update state lokal
        state.settings.inflowCategories = updatedCategories;
        
        alert('Kategori pemasukan berhasil dihapus.');
    } catch (error) {
        console.error("Gagal menghapus kategori pemasukan:", error);
        alert("Gagal menghapus kategori pemasukan. Silakan coba lagi.");
    }
}

function exportKeuangan(type) {
    const dataToFilter = state.keuangan || [];
    let data;

    if (type === 'pengeluaran') {
        data = dataToFilter.filter(k => k.jenis === 'pengeluaran');
    } else {
        data = dataToFilter.filter(k => k.jenis === 'pemasukan_lain');
    }
    
    const sheetName = type === 'pengeluaran' ? 'Laporan Pengeluaran' : 'Laporan Pemasukan';
    if (data.length === 0) {
        alert(`Tidak ada data ${type} untuk diexport.`);
        return;
    }
    const dataForExcel = data.map(item => ({
        "Tanggal": new Date(item.tanggal),
        "Kategori/Tipe": item.kategori || item.tipe,
        "Jumlah": item.jumlah,
        "Catatan": item.catatan || ''
    }));
    const worksheet = XLSX.utils.json_to_sheet(dataForExcel);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, sheetName);
    worksheet["!cols"] = [ { wch: 15 }, { wch: 25 }, { wch: 20 }, { wch: 40 } ];
    XLSX.writeFile(workbook, `${sheetName.replace(/\s/g, '_')}_${new Date().toISOString().split('T')[0]}.xlsx`);
}
// FUNGSI HAPUS RETUR (SEKARANG LEBIH SEDERHANA)

async function deleteReturnItem(itemToDelete) {
    const yakin = confirm(
        "Yakin ingin menghapus data retur ini?\n\nCatatan: penghapusan ini hanya menghapus riwayat retur. Stok inventaris tidak akan berubah."
    );

    if (!yakin) return;

    try {
        const returnDocRef = doc(db, "returns", itemToDelete.returnDocId);
        const returnSnap = await getDoc(returnDocRef);

        if (!returnSnap.exists()) {
            throw new Error("Data retur tidak ditemukan.");
        }

        const returnData = returnSnap.data();
        const oldItems = returnData.items || [];

        const newItems = oldItems.filter(item => {
            return !(
                item.sku === itemToDelete.sku &&
                item.qty === itemToDelete.qty &&
                item.alasan === itemToDelete.alasan
            );
        });

        if (newItems.length === 0) {
            await deleteDoc(returnDocRef);

            state.retur = state.retur.filter(r => r.id !== itemToDelete.returnDocId);
        } else {
            await updateDoc(returnDocRef, {
                items: newItems
            });

            const returInState = state.retur.find(r => r.id === itemToDelete.returnDocId);

            if (returInState) {
                returInState.items = newItems;
            }
        }

        

        alert("Data retur berhasil dihapus. Stok inventaris tidak berubah.");

    } catch (error) {
        console.error("Gagal menghapus data retur:", error);
        alert("Gagal menghapus data retur: " + error.message);
    }
}

function buildReturnItemsFromTransaction(
    transaction,
    itemsToReturn = [],
    defaultReason = ''
) {
    const transactionItems = Array.isArray(transaction?.items)
        ? transaction.items
        : [];

    // Gunakan subtotal tersimpan.
    // Untuk data lama yang tidak mempunyai subtotal,
    // hitung ulang dari seluruh item transaksi.
    const fallbackSubtotal = transactionItems.reduce((sum, item) => {
        const qty = Number(item.qty) || 0;

        const hargaJual = Number(
            item.hargaJualAktual ??
            item.hargaJual ??
            item.price ??
            item.harga ??
            0
        ) || 0;

        return sum + (hargaJual * qty);
    }, 0);

    const subtotalTransaksi =
        Number(transaction?.subtotal) ||
        fallbackSubtotal ||
        1;

    const totalDiskon =
        Number(transaction?.diskon?.totalDiscount) || 0;

    const totalBiayaMarketplace =
        Number(transaction?.biaya?.total) || 0;

    return (itemsToReturn || [])
        .map(item => {
            const qty =
                Number(item.returnQty ?? item.qty) || 0;

            const hargaJual = Number(
                item.hargaJualAktual ??
                item.hargaJual ??
                item.price ??
                item.harga ??
                0
            ) || 0;

            const nilaiKotorItem = hargaJual * qty;

            const porsiItem =
                subtotalTransaksi > 0
                    ? nilaiKotorItem / subtotalTransaksi
                    : 0;

            const nilaiDiskon =
                totalDiskon * porsiItem;

            const biayaMarketplace =
                totalBiayaMarketplace * porsiItem;

            const nilaiReturBersih =
                nilaiKotorItem - nilaiDiskon;

            return {
                sku: item.sku || '',
                qty,
                // Simpan HPP saat retur dibuat agar laporan historis tidak
                // berubah ketika HPP produk diperbarui di masa depan.
                hpp:
                    Number(item.hpp) || 0,
                nilaiRetur: nilaiReturBersih,
                nilaiDiskon,
                biayaMarketplace,
                alasan:
                    item.alasan ||
                    defaultReason ||
                    ''
            };
        })
        .filter(item => item.sku && item.qty > 0);
}


// Mengumpulkan jumlah stok yang perlu dikembalikan.
// Map dipakai agar satu SKU hanya diperbarui sekali.
function addReturnedItemsToStockMap(stockMap, returnItems = []) {
    (returnItems || []).forEach(item => {
        const sku = String(item.sku || '').trim();
        const qty = Number(item.qty) || 0;

        if (!sku || qty <= 0) return;

        stockMap.set(
            sku,
            (stockMap.get(sku) || 0) + qty
        );
    });
}


// Memasukkan pengembalian stok fisik ke Firebase batch.
function queuePhysicalStockReturn(batch, stockMap) {
    stockMap.forEach((qty, sku) => {
        const product =
            getProductBySku(sku) ||
            state.inventoryPaginated.find(p =>
                String(p.sku || '').toLowerCase() ===
                sku.toLowerCase()
            );

        if (!product?.docId) {
            throw new Error(
                `Produk dengan SKU "${sku}" tidak ditemukan di Inventaris. Retur dibatalkan agar stok tidak salah.`
            );
        }

        const productRef = doc(
            db,
            "products",
            product.docId
        );

        // Increment menghitung langsung di server Firebase.
        batch.update(productRef, {
            physical_stock: increment(qty)
        });
    });
}


// Memperbarui tampilan stok setelah Firebase berhasil.
function applyPhysicalStockReturnToLocal(stockMap) {
    stockMap.forEach((qty, sku) => {
        const normalizedSku = sku.toLowerCase();

        const productInState = state.produk.find(p =>
            String(p.sku || '').toLowerCase() ===
            normalizedSku
        );

        if (productInState) {
            productInState.stokFisik =
                (Number(productInState.stokFisik) || 0) +
                qty;
        }

        const inventoryProduct =
            state.inventoryPaginated.find(p =>
                String(p.sku || '').toLowerCase() ===
                normalizedSku
            );

        if (inventoryProduct) {
            inventoryProduct.stokFisik =
                (Number(inventoryProduct.stokFisik) || 0) +
                qty;
        }
    });
}

async function submitReturForm() {
    if (!currentUser.value) return alert("Anda harus login.");
    const form = uiState.modalData;
    const selectedItems = form.items.filter(item => item.selected && item.returnQty > 0);

    if (!form.foundTransaction || selectedItems.length === 0) {
        alert('Harap cari transaksi dan pilih minimal satu item untuk diretur.');
        return;
    }

    try {
        const batch = writeBatch(db);
const trxAsli = form.foundTransaction;
const newKeuanganEntries = [];

// Menampung stok fisik yang akan dikembalikan
const returnedStockMap = new Map();

const previousSettlementStatus =
    trxAsli.statusPencairan ||
    'Belum Cair';

const transactionUpdatePayload = {
    statusPencairan:
        'Retur/Pengembalian',
    statusPencairanSebelumRetur:
        previousSettlementStatus,
    tanggalRetur: new Date()
};

// Retur dan perubahan status transaksi disimpan secara atomik.
// Bila salah satu gagal, keduanya batal sehingga Dana Gantung
// tidak bisa tertinggal karena status setengah tersimpan.
batch.update(
    doc(
        db,
        'transactions',
        trxAsli.id
    ),
    transactionUpdatePayload
);

        const dataToSave = {
    tanggal: new Date(),
    channelId: trxAsli.channelId,
    originalTransactionId: trxAsli.id,
    marketplaceOrderId:
        trxAsli.marketplaceOrderId ||
        '',
    sumber: 'Manajemen Retur',
    statusRetur:
        'Retur / Pengembalian',
    statusPencairanSebelumRetur:
        previousSettlementStatus,
    createdAt: new Date(),

    items: buildReturnItemsFromTransaction(
        trxAsli,
        selectedItems,
        'Retur dari Manajemen Retur'
    ),

    userId: currentUser.value.uid
};

        const returnRef = doc(collection(db, "returns"));
        batch.set(returnRef, dataToSave);

        // Kumpulkan jumlah stok dari seluruh item retur
addReturnedItemsToStockMap(
    returnedStockMap,
    dataToSave.items
);

// Kembalikan stok fisik dalam batch yang sama
queuePhysicalStockReturn(
    batch,
    returnedStockMap
);
        
        await batch.commit();

        const localReturnRecord = {
            id: returnRef.id,
            ...dataToSave
        };

        addReturnToLocalStores(
            localReturnRecord
        );

        applyTransactionUpdateToLocalStores(
            trxAsli.id,
            transactionUpdatePayload
        );

        if (
            previousSettlementStatus ===
                'Sudah Cair' &&
            dashboardSummaryV2.globalReady !==
                true
        ) {
            await loadDashboardCashBalance(
                currentUser.value.uid
            );
        }

        if (newKeuanganEntries.length > 0) {
            state.keuangan.push(...newKeuanganEntries);
        }

        // Firebase sudah berhasil.
// Sekarang perbarui angka stok yang tampil.
applyPhysicalStockReturnToLocal(
    returnedStockMap
);

        alert(`Data retur untuk pesanan ${trxAsli.marketplaceOrderId} berhasil disimpan!`);
        hideModal();

    } catch (error) {
        console.error("Error menyimpan data retur:", error);
        alert("Gagal menyimpan data retur. Cek console untuk detail.");
    }
}

function handleReturPageSearch() {
    const query = uiState.returPageSearchQuery;
    if (!query) {
        uiState.returPageSearchRecommendations = [];
        return;
    }
    const lowerQuery = query.toLowerCase();
    const recommendations = new Set();
    
    // Cari berdasarkan SKU, Nama, Alasan dari data retur yang sudah ada
    // Perbaikan untuk memastikan tidak error saat ada data kosong
    state.retur.forEach(item => {
        // Karena data retur sekarang bisa memiliki banyak item di dalam array 'items'
        // Kita perlu meloop di dalamnya juga
        (item.items || []).forEach(itemDetail => {
            const product = getProductBySku(itemDetail.sku);
            const productName = product ? product.nama : '';

            const matches = (item.id && item.id.toLowerCase().includes(lowerQuery)) ||
                            (itemDetail.sku && itemDetail.sku.toLowerCase().includes(lowerQuery)) ||
                            (productName && productName.toLowerCase().includes(lowerQuery)) ||
                            (itemDetail.alasan && itemDetail.alasan.toLowerCase().includes(lowerQuery));

            if (matches) {
                if (itemDetail.sku) recommendations.add(itemDetail.sku);
                if (productName) recommendations.add(productName);
                if (itemDetail.alasan) recommendations.add(itemDetail.alasan);
            }
        });
    });

    uiState.returPageSearchRecommendations = Array.from(recommendations).slice(0, 5);
}

function selectReturPageRecommendation(rec) {
    uiState.returPageSearchQuery = rec;
    uiState.returPageSearchRecommendations = [];
}
function exportReturToExcel() {
    const dataToExport = filteredRetur.value.map(item => {
        const product = getProductBySku(item.sku) || {};
        const marketplace = getMarketplaceById(item.channelId) || {};
        return {
            "ID Retur": item.id,
            "Tanggal": new Date(item.tanggal),
            "Asal Toko": marketplace.name || 'N/A',
            "SKU": item.sku,
            "Nama Produk": product.nama || 'N/A',
            "Qty": item.qty,
            "Alasan": item.alasan,
            "Tindak Lanjut": item.tindakLanjut,
        };
    });

    if (dataToExport.length === 0) {
        alert("Tidak ada data retur untuk diekspor.");
        return;
    }
    const worksheet = XLSX.utils.json_to_sheet(dataToExport);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Laporan Retur");
    worksheet["!cols"] = [ { wch: 20 }, { wch: 15 }, { wch: 20 }, { wch: 20 }, { wch: 30 }, { wch: 8 }, { wch: 30 }, { wch: 20 }];
    
    // Format tanggal
    dataToExport.forEach((_data, index) => {
        const cellRef = XLSX.utils.encode_cell({c: 1, r: index + 1});
        if (worksheet[cellRef]) {
            worksheet[cellRef].t = 'd';
            worksheet[cellRef].z = 'dd/mm/yyyy';
        }
    });

    XLSX.writeFile(workbook, `Laporan_Retur_${new Date().toISOString().split('T')[0]}.xlsx`);
}

function printInvestorPaymentDetailed(data) {
    const printContent = `
        <style>
            body { font-family: sans-serif; margin: 20px; font-size: 12px; }
            h3, h4 { margin: 0; padding: 0; }
            table { width: 100%; border-collapse: collapse; margin-top: 15px; }
            th, td { padding: 6px; text-align: left; }
            .header { text-align: center; border-bottom: 1px solid #ccc; padding-bottom: 10px; margin-bottom: 15px; }
            .section { margin-top: 20px; }
            .section-title { font-weight: bold; border-bottom: 1px solid #eee; padding-bottom: 5px; margin-bottom: 8px; font-size: 14px; }
            .summary-table td { border: 1px solid #eee; }
            .summary-table .label { font-weight: bold; }
            .total { font-weight: bold; font-size: 1.1em; }
        </style>
        <div class="header">
            <h3>Laporan Bagi Hasil Investor</h3>
            <p>${data.investorName} - Periode ${data.period}</p>
        </div>
        <div class="section">
            <h4 class="section-title">Perhitungan Laba Bersih</h4>
            <table class="summary-table">
                <tr><td>Omset Bersih Penjualan</td><td style="text-align:right;">${formatCurrency(data.omsetBersihPenjualan)}</td></tr>
                <tr><td>(-) Omset Bersih dari Retur</td><td style="text-align:right;">-${formatCurrency(data.omsetBersihDariRetur)}</td></tr>
                <tr class="total"><td>Total Omset Bersih</td><td style="text-align:right;">${formatCurrency(data.omsetBersihFinal)}</td></tr>
                <tr><td>(-) HPP Terjual</td><td style="text-align:right;">-${formatCurrency(data.hppTerjualFinal)}</td></tr>
                <tr class="total"><td>LABA KOTOR</td><td style="text-align:right;">${formatCurrency(data.labaKotor)}</td></tr>
                <tr><td>(-) Total Biaya Marketplace</td><td style="text-align:right;">-${formatCurrency(data.totalBiayaTransaksi)}</td></tr>
                <tr><td>(-) Biaya Operasional</td><td style="text-align:right;">-${formatCurrency(data.totalBiayaOperasional)}</td></tr>
                <tr class="total" style="background-color: #f0f0f0;"><td>LABA BERSIH PERIODE</td><td style="text-align:right;">${formatCurrency(data.labaBersih)}</td></tr>
            </table>
        </div>
        <div class="section">
            <h4 class="section-title">Pembagian Hasil</h4>
            <table class="summary-table">
                <tr class="total" style="background-color: #e6f7ff;">
                    <td>Bagian Investor (${data.profitSharePercentage}%)</td>
                    <td style="text-align:right;">${formatCurrency(data.investorShare)}</td>
                </tr>
                <tr><td>Bagian Perusahaan</td><td style="text-align:right;">${formatCurrency(data.companyShare)}</td></tr>
            </table>
        </div>
    `;
    const printWindow = window.open('', '_blank');
    printWindow.document.write(printContent);
    printWindow.document.close();
    printWindow.print();
}

async function addMarketplace() {
    if (!currentUser.value) return alert("Anda harus login.");

    const newMarketplace = {
        id: `marketplace-${Date.now()}`,
        name: 'Marketplace Baru'
    };

    state.settings.marketplaces.push(newMarketplace);

    if (!state.promotions.perChannel[newMarketplace.id]) {
        state.promotions.perChannel[newMarketplace.id] = { voucherToko: null, voucherSemuaProduk: null };
    }
    
    // Perbarui data marketplaces di database secara langsung
    try {
        const userId = currentUser.value.uid;
        const settingsRef = doc(db, "settings", userId);
        
        // Cukup perbarui satu field 'marketplaces', tidak seluruh dokumen
        await updateDoc(settingsRef, {
            marketplaces: state.settings.marketplaces,
        });

        alert('Marketplace baru berhasil ditambahkan dan disimpan!');
    } catch(error) {
        console.error("Gagal menyimpan perubahan marketplace:", error);
        alert(`Gagal menyimpan data: ${error.message}`);
    }
}

async function removeMarketplace(marketplaceId) {
    if (!currentUser.value) return alert("Anda harus login.");
    if (!confirm('Anda yakin ingin menghapus marketplace ini?')) return;

    const index = state.settings.marketplaces.findIndex(mp => mp.id === marketplaceId);
    if (index > -1) {
        // Hapus marketplace dari array lokal
        state.settings.marketplaces.splice(index, 1);
        
        try {
            const userId = currentUser.value.uid;
            const settingsRef = doc(db, "settings", userId);
            
            // Lakukan update dokumen yang sangat spesifik
            await setDoc(settingsRef, {
    marketplaces: JSON.parse(JSON.stringify(state.settings.marketplaces)),
    userId: userId
}, { merge: true });
            
            // Hapus juga data promosi yang mungkin ada di perChannel dan perModel
            // agar data tidak 'menggantung' di database.
            // ini opsional, tetapi merupakan praktik terbaik
            if (state.promotions.perChannel[marketplaceId]) {
                delete state.promotions.perChannel[marketplaceId];
                // Hapus data promosi dari Firestore juga jika ada
                const promotionsRef = doc(db, "promotions", userId);
                await updateDoc(promotionsRef, {
                    perChannel: state.promotions.perChannel,
                });
            }

            alert('Marketplace berhasil dihapus dan perubahan telah disimpan.');
        } catch(error) {
            alert(`Gagal menyimpan data: ${error.message}`);
        }
    }
}

async function saveMarketplaceEdit() {
    if (!currentUser.value) return alert("Anda harus login.");
    
    const editedMarketplace = uiState.modalData;
    const index = state.settings.marketplaces.findIndex(mp => mp.id === editedMarketplace.id);
    
    if (index !== -1) {
        state.settings.marketplaces[index] = editedMarketplace;
    }
    
    try {
        const userId = currentUser.value.uid;
        const settingsRef = doc(db, "settings", userId);
        
        // Cukup perbarui satu field 'marketplaces', tidak seluruh dokumen
        await setDoc(settingsRef, {
    marketplaces: JSON.parse(JSON.stringify(state.settings.marketplaces)),
    userId: userId
}, { merge: true });

        hideModal();
        alert('Perubahan marketplace berhasil disimpan.');
    } catch(error) {
        console.error("Gagal menyimpan perubahan marketplace:", error);
        alert(`Gagal menyimpan data: ${error.message}`);
    }
}

async function saveSettingsData() {
    if (!currentUser.value) return alert("Anda harus login.");

    isSaving.value = true;
    await nextTick();

    try {
        const userId = currentUser.value.uid;
        const settingsRef = doc(db, "settings", userId);

        const settingsData = {
            brandName: state.settings.brandName,
            minStok: state.settings.minStok,
            marketplaces: JSON.parse(JSON.stringify(state.settings.marketplaces || [])),
            modelProduk: JSON.parse(JSON.stringify(state.settings.modelProduk || [])),
            categories: JSON.parse(JSON.stringify(state.settings.categories || [])),
            inflowCategories: JSON.parse(JSON.stringify(state.settings.inflowCategories || [])),
            pinProtection: state.settings.pinProtection || {},
            dashboardPin: state.settings.dashboardPin || '',
            userId: userId
        };

        await setDoc(settingsRef, settingsData, { merge: true });

        alert("Pengaturan berhasil disimpan.");

    } catch (error) {
        console.error("Gagal menyimpan pengaturan:", error);
        alert("Gagal menyimpan pengaturan. Coba lagi.");
    } finally {
        isSaving.value = false;
    }
}

async function addModelProduk() {
    if (!currentUser.value) return alert("Anda harus login.");
    const newModel = {
        id: `MODEL-${Date.now()}`,
        namaModel: 'Model Baru',
        warna: '',
        ukuran: '',
        yardPerModel: 0,
        hargaMaklun: 0,
        hargaJahit: 0,
    };
    state.settings.modelProduk.push(newModel);
    await saveData();
    alert('Model Produk baru berhasil ditambahkan.');
}

async function removeModelProduk(modelId) {
    if (!currentUser.value) return alert("Anda harus login.");
    if (!confirm('Anda yakin ingin menghapus model Produk ini?')) return;

    const index = state.settings.modelProduk.findIndex(m => m.id === modelId);
    if (index > -1) {
        state.settings.modelProduk.splice(index, 1);
        await saveData(); // Panggil saveData untuk menyimpan
        alert('Model Produk berhasil dihapus.');
    }
}

async function saveModelProdukEdit() {
    if (!currentUser.value) return alert("Anda harus login.");
    const editedModel = uiState.modalData;
    const index = state.settings.modelProduk.findIndex(model => model.id === editedModel.id);
    if (index !== -1) {
        state.settings.modelProduk[index] = {
            ...editedModel,
            hargaJahit: editedModel.hargaJahit || 0,
            warna: editedModel.warna || '',
            ukuran: editedModel.ukuran || ''
        };
    }
    
    // Perbarui data modelProduk di database secara langsung
    try {
        const userId = currentUser.value.uid;
        const settingsRef = doc(db, "settings", userId);
        
        // Cukup perbarui satu field 'modelProduk', tidak seluruh dokumen
        await updateDoc(settingsRef, {
            modelProduk: state.settings.modelProduk,
        });

        alert('Perubahan model Produk berhasil disimpan.');
        hideModal();
    } catch (error) {
        console.error("Gagal menyimpan perubahan model produk:", error);
        alert(`Gagal menyimpan perubahan model produk: ${error.message}`);
    }
}

async function saveStockAllocation() {
    if (isSaving.value) return;
    if (!currentUser.value) {
        alert('Anda harus login untuk menyimpan perubahan.');
        return;
    }

    const modalData = uiState.modalData;
    if (!modalData?.product || !modalData?.original?.docId) {
        alert('Data produk tidak lengkap. Tutup modal, muat ulang Inventaris, lalu coba lagi.');
        return;
    }

    const { product, original } = modalData;
    const desiredStock = Number(product.stokFisik);
    const openingStock = Number(original.stokFisik ?? original.physical_stock) || 0;
    if (!Number.isSafeInteger(desiredStock) || desiredStock < 0) {
        alert('Stok fisik harus berupa bilangan bulat nol atau lebih.');
        return;
    }

    const marketplaceList = state.settings.marketplaces || [];
    const cleanAllocationData = {};
    for (const marketplace of marketplaceList) {
        const value = Number(product.stokAlokasi?.[marketplace.id]) || 0;
        if (!Number.isSafeInteger(value) || value < 0) {
            alert('Alokasi stok untuk ' + marketplace.name + ' harus berupa bilangan bulat nol atau lebih.');
            return;
        }
        cleanAllocationData[marketplace.id] = value;
    }
    const allocationTotal = Object.values(cleanAllocationData).reduce((sum, value) => sum + value, 0);
    if (allocationTotal > desiredStock) {
        alert('Total alokasi (' + allocationTotal + ') melebihi stok fisik (' + desiredStock + '). Kurangi alokasi atau tambah stok terlebih dahulu.');
        return;
    }

    const userId = currentUser.value.uid;
    const productRef = doc(db, 'products', original.docId);
    const allocationRef = doc(db, 'stock_allocations', original.docId);
    const allocationChanged = marketplaceList.some(marketplace =>
        (Number(cleanAllocationData[marketplace.id]) || 0) !==
        (Number(original.stokAlokasi?.[marketplace.id]) || 0)
    );
    isSaving.value = true;
    let stockCommitted = false;

    try {
        // Terapkan selisih terhadap stok saat modal dibuka ke stok terbaru di server.
        // Penjualan/penerimaan yang terjadi selama modal terbuka tidak tertimpa.
        const savedPhysicalStock = await firestoreRunTransaction(db, async transaction => {
            const productSnapshot = await transaction.get(productRef);
            if (!productSnapshot.exists()) {
                throw new Error('Data produk tidak ditemukan di database. Muat ulang Inventaris.');
            }
            const currentStock = Number(
                productSnapshot.data().physical_stock ??
                productSnapshot.data().stokFisik
            ) || 0;
            const nextStock = currentStock + (desiredStock - openingStock);
            if (!Number.isSafeInteger(nextStock) || nextStock < 0) {
                throw new Error('Stok terbaru berubah saat modal terbuka. Muat ulang lalu periksa jumlah stok kembali.');
            }
            transaction.update(productRef, { physical_stock: nextStock });
            return nextStock;
        });
        stockCommitted = true;

        // Simpan alokasi terpisah agar kegagalan izin alokasi tidak membatalkan
        // penambahan stok fisik yang sudah berhasil.
        state.produk = (state.produk || []).map(item =>
            item.docId === original.docId
                ? { ...item, stokFisik: savedPhysicalStock, physical_stock: savedPhysicalStock }
                : item
        );
        state.inventoryPaginated = (state.inventoryPaginated || []).map(item =>
            item.docId === original.docId
                ? { ...item, stokFisik: savedPhysicalStock, physical_stock: savedPhysicalStock }
                : item
        );
        uiState.modalData.product.stokFisik = savedPhysicalStock;
        uiState.modalData.product.physical_stock = savedPhysicalStock;
        uiState.modalData.original.stokFisik = savedPhysicalStock;
        uiState.modalData.original.physical_stock = savedPhysicalStock;

        if (allocationChanged) {
            await firestoreSetDoc(allocationRef, {
                ...cleanAllocationData,
                userId
            }, { merge: true });
        }

        state.produk = (state.produk || []).map(item =>
            item.docId === original.docId
                ? { ...item, stokAlokasi: { ...cleanAllocationData } }
                : item
        );
        state.inventoryPaginated = (state.inventoryPaginated || []).map(item =>
            item.docId === original.docId
                ? { ...item, stokAlokasi: { ...cleanAllocationData } }
                : item
        );

        const targetModel = state.settings.modelProduk.find(
            model => model.id === original.model_id
        );
        if (targetModel) lastEditedModel.value = targetModel.namaModel.split(' ')[0];

        hideModal();
        alert('Stok fisik berhasil diperbarui.' + (allocationChanged ? ' Alokasi channel juga berhasil disimpan.' : ''));
    } catch (error) {
        console.error('[INVENTARIS] Gagal menyimpan stok:', error);
        const detail = error?.message || 'Periksa koneksi internet dan izin database.';
        alert(
            stockCommitted
                ? 'Stok fisik sudah berhasil diperbarui, tetapi alokasi per channel gagal disimpan. Jangan tambahkan stok lagi. Perbaiki alokasi lalu simpan kembali.\n\n' + detail
                : 'Stok gagal disimpan. Periksa koneksi internet dan izin database.\n\n' + detail
        );
    } finally {
        isSaving.value = false;
    }
}

async function deleteGroup(variants) {
    if (!confirm(`Anda yakin ingin menghapus SEMUA ${variants.length} varian produk ini? Aksi ini tidak dapat dibatalkan.`)) {
        return;
    }
    if (!currentUser.value) {
        return alert("Anda harus login.");
    }

    const batch = writeBatch(db);
    const deletedDocIds = variants.map(v => v.docId);

    deletedDocIds.forEach(productId => {
        const productRef = doc(db, "products", productId);
        batch.delete(productRef);
        const allocationRef = doc(db, "stock_allocations", productId);
        batch.delete(allocationRef);

        state.settings.marketplaces.forEach(mp => {
            const priceDocId = `${productId}-${mp.id}`;
            const priceRef = doc(db, "product_prices", priceDocId);
            batch.delete(priceRef);
        });
    });

    try {
        await batch.commit();

        // --- PERBAIKAN DI SINI ---
        // Memperbarui kedua state array untuk konsistensi data dan UI
        state.produk = state.produk.filter(p => !deletedDocIds.includes(p.docId));
        state.inventoryPaginated = state.inventoryPaginated.filter(p => !deletedDocIds.includes(p.docId));
        
        alert(`Berhasil menghapus ${variants.length} varian produk.`);
    } catch (error) {
        console.error("Gagal menghapus grup produk:", error);
        alert(`Gagal menghapus produk: ${error.message}`);
    }
}

async function removeProductVariant(productId) {
    if (!confirm(`Anda yakin ingin menghapus varian produk ini? Aksi ini tidak dapat dibatalkan.`)) {
        return;
    }
    if (!currentUser.value) {
        return alert("Anda harus login.");
    }

    try {
        const batch = writeBatch(db);
        
        // DIHAPUS: Pengecekan di sisi klien yang menyebabkan error. Keamanan sudah diatur oleh Firebase Rules.
        // const productInState = state.produk.find(p => p.docId === productId);
        // if (!productInState || productInState.userId !== userId) {
        //     throw new Error("Anda tidak memiliki izin untuk menghapus produk ini.");
        // }

        const productRef = doc(db, "products", productId);
        batch.delete(productRef);
        const allocationRef = doc(db, "stock_allocations", productId);
        batch.delete(allocationRef);

        state.settings.marketplaces.forEach(mp => {
            const priceDocId = `${productId}-${mp.id}`;
            const priceRef = doc(db, "product_prices", priceDocId);
            batch.delete(priceRef);
        });

        await batch.commit();
        
        // --- PERBAIKAN DI SINI ---
        // Memperbarui kedua state array untuk konsistensi data dan UI
        state.produk = state.produk.filter(p => p.docId !== productId);
        state.inventoryPaginated = state.inventoryPaginated.filter(p => p.docId !== productId);

        alert(`Varian produk berhasil dihapus.`);
    } catch (error) {
        console.error(`Error menghapus produk ID: ${productId}:`, error);
        alert(`Gagal menghapus produk: ${error.message}`);
    }
}

function goToAturHarga(productName) {
    activePage.value = 'harga-hpp';
    uiState.hargaHppSelectedProduct = productName;
}

const transactionDetails = computed(() => {
    if (uiState.modalType !== 'transactionDetail' || !uiState.modalData.id) {
        return null;
    }

    const trx = uiState.modalData;
    const isNewFormat =
        Object.prototype.hasOwnProperty.call(
            trx || {},
            'statusDataMarketplace'
        );

    const isMatched =
        String(trx.statusDataMarketplace || '').toLowerCase() === 'cocok';

    const totalHPP = Number(trx.totalHpp) || (trx.items || []).reduce(
        (sum, item) =>
            sum +
            ((Number(item.hpp) || 0) * (Number(item.qty) || 0)),
        0
    );

    const totalBiayaMarketplace = isNewFormat
        ? 0
        : (Number(trx.biaya?.total) || 0);

    const totalPenghasilan = isNewFormat
        ? (
            isMatched
                ? (Number(trx.penghasilanBersihMarketplace) || 0)
                : 0
        )
        : (Number(trx.total) || 0);

    const labaBersih = isNewFormat && !isMatched
        ? null
        : totalPenghasilan - totalHPP - totalBiayaMarketplace;

    return {
        ...trx,
        totalHPP,
        totalBiayaMarketplace,
        totalPenghasilan,
        labaBersih,
        isNewFormat,
        isMatched
    };
});

const panduanData = [
    {
        id: 'pengaturan',
        icon: '⚙️',
        title: '1. Pengaturan',
        badge: 'Fondasi',
        subtitle: 'Tempat mengatur aturan utama sebelum aplikasi dipakai.',
        description: 'Halaman Pengaturan adalah pondasi Fashion OS. Bagian ini wajib dirapikan lebih dulu karena data marketplace, model produk, kategori, rekening, dan PIN akan dipakai oleh halaman lain.',
        steps: [
            'Isi Marketplace untuk Shopee, TikTok Shop, Offline, Website, atau channel lain.',
            'Isi Model Produk agar produk, produksi, stok, laporan, dan ROAS bisa terbaca per model.',
            'Isi kategori biaya dan kategori pemasukan supaya laporan keuangan rapi.',
            'Isi rekening bank jika memakai fitur investasi, pembayaran, atau pencatatan rekening.',
            'Atur PIN keamanan untuk halaman sensitif seperti dashboard, laporan, dan HPP.'
        ],
        tips: [
            'Marketplace dan Model Produk wajib diisi sebelum tambah produk.',
            'Jangan hapus model produk yang sudah dipakai transaksi.',
            'Pastikan biaya marketplace sesuai channel agar profit tidak salah.'
        ],
        links: [
            { label: 'Marketplace', page: 'pengaturan', tab: 'marketplace', primary: true },
            { label: 'Model Produk', page: 'pengaturan', tab: 'modelproduk', primary: true },
            { label: 'Rekening Bank', page: 'pengaturan', tab: 'rekening', primary: false }
        ]
    },
    {
        id: 'produk',
        icon: '📦',
        title: '2. Inventaris Produk',
        badge: 'Produk & Stok',
        subtitle: 'Tempat membuat produk, SKU, warna, ukuran, dan stok.',
        description: 'Inventaris dipakai untuk menyimpan semua data produk per varian. Data ini akan terhubung ke penjualan, retur, barcode, produksi, harga, HPP, dan laporan.',
        steps: [
            'Tambahkan produk berdasarkan model produk yang sudah dibuat.',
            'Isi SKU yang rapi dan singkat untuk setiap warna dan ukuran.',
            'Isi warna, ukuran, stok fisik, dan data varian lain.',
            'Gunakan fitur stok untuk memantau produk yang aman, menipis, atau habis.',
            'Gunakan barcode agar proses scan produk lebih cepat.'
        ],
        tips: [
            'Gunakan pola SKU yang konsisten, contoh ARL-HTM-M.',
            'Satu varian sebaiknya satu SKU.',
            'Jangan membuat SKU terlalu panjang agar mudah discan dan dicari.'
        ],
        links: [
            { label: 'Buka Inventaris', page: 'inventaris', primary: true },
            { label: 'Panduan Barcode', page: 'barcode-generator', primary: false }
        ]
    },
    {
        id: 'harga',
        icon: '🏷️',
        title: '3. Harga & HPP',
        badge: 'Profit',
        subtitle: 'Tempat mengisi modal produk dan harga jual per channel.',
        description: 'Halaman Harga & HPP sangat penting karena menjadi dasar perhitungan laba, margin, laporan keuangan, dashboard, dan ROAS.',
        steps: [
            'Isi HPP atau modal produk untuk setiap SKU.',
            'Isi harga jual per channel marketplace.',
            'Pastikan harga jual sesuai biaya tiap marketplace.',
            'Gunakan data ini untuk membaca laba dan harga aman.',
            'Update HPP jika ada perubahan biaya produksi atau pembelian.'
        ],
        tips: [
            'Jangan mulai iklan sebelum HPP dan harga jual lengkap.',
            'HPP kosong bisa membuat laporan profit tidak akurat.',
            'Harga per marketplace bisa berbeda karena potongan biaya berbeda.'
        ],
        links: [
            { label: 'Buka Harga & HPP', page: 'harga-hpp', primary: true },
            { label: 'Kalkulator ROAS', page: 'roas-calculator', primary: false }
        ]
    },
    {
        id: 'produksi',
        icon: '🏭',
        title: '4. Produksi, Gudang Kain, dan Supplier',
        badge: 'Produksi',
        subtitle: 'Untuk mencatat kain, maklun, supplier, aktual jadi, dan pembelian barang.',
        description: 'Modul produksi membantu bisnis fashion mencatat proses dari bahan sampai barang jadi. Cocok untuk brand yang produksi sendiri, maklun, atau mengambil barang dari supplier.',
        steps: [
            'Catat batch produksi berdasarkan model produk.',
            'Isi kain, warna kain, yard, aktual jadi, biaya maklun, dan status pembayaran.',
            'Pantau Gudang Kain untuk melihat penggunaan dan kebutuhan bahan.',
            'Gunakan Supplier untuk mencatat penerimaan barang atau pembelian produk.',
            'Pantau status proses dan status pembayaran supaya produksi tidak tercecer.'
        ],
        tips: [
            'Isi model produk dulu sebelum mencatat produksi.',
            'Aktual jadi harus dicatat agar stok produksi lebih jelas.',
            'Supplier cocok dipakai jika barang masuk bukan dari produksi sendiri.'
        ],
        links: [
            { label: 'Buka Produksi', page: 'produksi', primary: true },
            { label: 'Gudang Kain', page: 'gudang-kain', primary: false },
            { label: 'Supplier', page: 'supplier', primary: false }
        ]
    },
    {
        id: 'penjualan',
        icon: '🛒',
        title: '5. Pesanan dan Penjualan',
        badge: 'Marketplace',
        subtitle: 'Pesanan marketplace diproses setelah cocok dengan data pengiriman.',
        description: 'Untuk Shopee dan TikTok Shop, scan ID paket di Google Sheets, cocokkan dengan ekspor pesanan terkirim, lalu impor hanya paket yang benar-benar terkirim. Fashion OS mengambil SKU dan HPP dari master produk.',
        steps: [
            'Scan ID paket atau resi ke tab SCAN_SHOPEE atau SCAN_TIKTOK di Google Sheets.',
            'Tempel ekspor pesanan terkirim ke tab DATA_SHOPEE atau DATA_TIKTOK.',
            'Jalankan menu Fashion OS di Google Sheets dan periksa tab SIAP_IMPORT.',
            'Unduh file Google Sheets dan impor tab SIAP_IMPORT ke Fashion OS.',
            'Saat data keuangan tersedia, impor SIAP_PENGHASILAN untuk mencocokkan penghasilan bersih dan pencairan.'
        ],
        tips: [
            'Gunakan ID Paket atau No Resi agar kiriman yang terbagi dalam beberapa paket tidak tertukar.',
            'Pesanan belum terkirim atau batal tidak akan dibuat sebagai transaksi.',
            'Impor berulang akan melewati paket yang sudah tercatat.'
        ],
        links: [
            { label: 'Kasir POS untuk penjualan langsung', page: 'transaksi', primary: false },
            { label: 'Impor Pesanan Terkirim', page: 'bulk_process', primary: true }
        ]
    },
    {
        id: 'retur',
        icon: '↩️',
        title: '6. Retur',
        badge: 'Pengembalian',
        subtitle: 'Untuk mencatat produk yang kembali dan menjaga laporan tetap akurat.',
        description: 'Retur dipakai saat ada pesanan kembali, batal, gagal kirim, atau pengembalian produk. Data retur penting agar stok, omset, HPP, dan profit tidak salah.',
        steps: [
            'Cari transaksi atau produk yang mengalami retur.',
            'Isi alasan retur dan jumlah produk yang kembali.',
            'Pastikan stok kembali sesuai kondisi barang.',
            'Pantau dampak retur ke laporan dan profit.',
            'Gunakan catatan retur untuk evaluasi kualitas produk atau pengiriman.'
        ],
        tips: [
            'Retur jangan dicatat manual di luar sistem agar laporan tetap sinkron.',
            'Pisahkan retur karena pembeli, seller, gagal kirim, atau alasan lain.',
            'Cek kembali stok setelah retur disimpan.'
        ],
        links: [
            { label: 'Buka Retur', page: 'retur', primary: true },
            { label: 'Laporan Transaksi', page: 'laporan-transaksi', primary: false }
        ]
    },
    {
        id: 'keuangan',
        icon: '💰',
        title: '7. Keuangan dan Laporan',
        badge: 'Kontrol Profit',
        subtitle: 'Untuk mencatat pemasukan, pengeluaran, transaksi, dan profit.',
        description: 'Modul keuangan membantu membaca kondisi bisnis secara lebih jelas. Dari sini pengguna bisa melihat uang masuk, uang keluar, laba, dan laporan transaksi.',
        steps: [
            'Catat pemasukan lain di luar penjualan jika ada.',
            'Catat pengeluaran operasional dan produksi.',
            'Cek Laporan Transaksi untuk melihat data order.',
            'Cek Laporan Keuangan untuk melihat laba dan biaya.',
            'Gunakan Dashboard untuk ringkasan performa bisnis.'
        ],
        tips: [
            'Pisahkan biaya produksi dan biaya operasional.',
            'Catat pengeluaran rutin agar laba bersih tidak terlihat terlalu besar.',
            'Gunakan filter tanggal untuk membaca performa harian, bulanan, atau custom.'
        ],
        links: [
            { label: 'Keuangan', page: 'keuangan', primary: true },
            { label: 'Laporan Keuangan', page: 'laporan-keuangan', primary: true },
            { label: 'Laporan Transaksi', page: 'laporan-transaksi', primary: false },
            { label: 'Dashboard', page: 'dashboard', primary: false }
        ]
    },
    {
        id: 'roas',
        icon: '📊',
        title: '8. Dashboard ROAS dan Kalkulator ROAS',
        badge: 'Iklan',
        subtitle: 'Untuk membaca performa iklan, BEP, profit, dan target ROAS.',
        description: 'Modul ROAS dipakai untuk membantu mengambil keputusan iklan. Pengguna bisa membaca omset, HPP, diskon, biaya marketplace, biaya iklan, laba, dan target ROAS.',
        steps: [
            'Pilih periode tanggal yang ingin dianalisis.',
            'Pilih channel penjualan atau semua channel.',
            'Pilih model produk atau semua model.',
            'Isi biaya iklan, diskon, pajak, dan biaya operasional jika dibutuhkan.',
            'Baca ROAS, profit, dan target iklan sebelum scale budget.'
        ],
        tips: [
            'ROAS akan lebih akurat jika transaksi, HPP, dan biaya marketplace sudah lengkap.',
            'Analisis per model lebih aman daripada hanya melihat semua produk.',
            'Gunakan Kalkulator ROAS untuk simulasi sebelum menjalankan iklan.'
        ],
        links: [
            { label: 'Dashboard ROAS', page: 'roas-dashboard', primary: true },
            { label: 'Kalkulator ROAS', page: 'roas-calculator', primary: true },
            { label: 'Statistik Penjualan', page: 'statistik-penjualan', primary: false }
        ]
    },

];

const panduanAccordion = ref('pengaturan');

function openPanduanLink(link) {
    if (!link) return;

    if (link.tab) {
        uiState.pengaturanTab = link.tab;
    }

    if (link.page) {
        changePage(link.page);
    }
}

// eslint-disable-next-line no-unused-vars

async function deleteTransaction(transactionId) {
    if (!confirm(`Anda yakin ingin menghapus transaksi ID: ${transactionId}? Stok produk akan dikembalikan.`)) {
        return;
    }

    const trxToDelete = state.transaksi.find(trx => trx.id === transactionId);
    if (!trxToDelete) {
        alert("Transaksi tidak ditemukan.");
        return;
    }

    try {
        const batch = writeBatch(db);
        const transactionRef = doc(db, "transactions", transactionId);
        batch.delete(transactionRef);

        for (const item of trxToDelete.items) {
            const productInState = state.produk.find(p => p.sku === item.sku);
            if (productInState) {
                const newStock = (productInState.stokFisik || 0) + item.qty;
                const productRef = doc(db, "products", productInState.docId);
                batch.update(productRef, { physical_stock: newStock });
            }
        }

        await batch.commit();

// Firebase sudah berhasil.
// Sekarang perbarui stok yang tampil di browser.
for (const item of trxToDelete.items || []) {
    const qty = Number(item.qty) || 0;

    const productInState = state.produk.find(
        p => p.sku === item.sku
    );

    if (productInState) {
        productInState.stokFisik =
            (Number(productInState.stokFisik) || 0) +
            qty;
    }

    const inventoryProduct =
        state.inventoryPaginated.find(
            p => p.sku === item.sku
        );

    if (inventoryProduct) {
        inventoryProduct.stokFisik =
            (Number(inventoryProduct.stokFisik) || 0) +
            qty;
    }
}

// Hapus transaksi dari data lokal.
state.transaksi = state.transaksi.filter(
    trx => trx.id !== transactionId
);

// Hapus juga dari daftar pesanan belum cair.
state.pendingSettlements =
    state.pendingSettlements.filter(
        trx => trx.id !== transactionId
    );
// Data transaksi berubah.
// Batalkan status cache supaya halaman lain membaca ulang data terbaru.
dataFetched.transactions = false;
dataFetched.allTransactionsLoaded = false;
dataFetched.returns = false;
dataFetched.allReturnsLoaded = false;
dataFetched.pendingSettlements = false;

uiState.transaksiLastVisible = null;
uiState.transaksiHasMore = true;

uiState.returLastVisible = null;
uiState.returHasMore = true;
alert(
    "Transaksi berhasil dihapus dan stok telah dikembalikan."
);

    } catch (error) {
        console.error("Error saat menghapus transaksi:", error);
        alert("Gagal menghapus transaksi dari database.");
    }
}

function handleModelProdukChange() {
    const selectedModel = state.settings.modelProduk.find(
        model => model.id === uiState.modalData.modelId
    );
    if (selectedModel) {
        // Mengisi otomatis Nama, Warna, dan Ukuran
        uiState.modalData.nama = selectedModel.namaModel || '';
        uiState.modalData.warna = selectedModel.warna || '';
        uiState.modalData.varian = selectedModel.ukuran || '';
    } else {
        // Mengosongkan field jika pilihan dihapus
        uiState.modalData.nama = '';
        uiState.modalData.warna = '';
        uiState.modalData.varian = '';
    }
}

function handleProductSkuChange(item) {
    const selectedProduct = state.produk.find(p => p.sku === item.sku);
    if (selectedProduct) {
        // --- Logika yang sudah ada ---
        item.warnaKain = selectedProduct.warna;
        item.ukuran = selectedProduct.varian;
        item.modelProdukId = selectedProduct.model_id;

        // --- LOGIKA BARU UNTUK HARGA OTOMATIS ---
        const selectedModel = state.settings.modelProduk.find(m => m.id === selectedProduct.model_id);
        if (selectedModel) {
            // Cek jenis jasa yang dipilih di form utama
            const batchType = uiState.modalType === 'addProduksi' ? uiState.newProduksiBatch.produksiType : uiState.editProduksiBatch.produksiType;

            if (batchType === 'penjahit') {
                item.hargaJahitPerPcs = selectedModel.hargaJahit || 0;
                item.hargaMaklunPerPcs = null; // Kosongkan harga maklun
            } else { // 'pemaklun'
                item.hargaMaklunPerPcs = selectedModel.hargaMaklun || 0;
                item.hargaJahitPerPcs = null; // Kosongkan harga jahit
            }
        }
        // --- AKHIR DARI LOGIKA BARU ---
    }
}

function addKainBahanItem(batch) {
    if (!batch.kainBahan) {
        batch.kainBahan = [];
    }
    batch.kainBahan.push({
        idUnik: generateUniqueCode(), // <-- BARIS BARU: Tambahkan kode unik
        modelProdukId: '',
        namaKain: '',
        tokoKain: '',
        warnaKain: '',
        ukuran: '',
        totalYard: null,
        hargaKainPerYard: null,
        yardPerModel: null,
        targetQty: null,
        aktualJadi: null,
        aktualJadiLabelType: 'Aktual Jadi',
        hargaMaklunPerPcs: null,
        biayaAlat: null,
        aktualJadiKombinasi: null
    });
}

function removeKainBahanItem(batch, index) {
    if (batch.kainBahan && batch.kainBahan.length > index) {
        batch.kainBahan.splice(index, 1);
    }
}

let specialPriceDebounceTimer;
function handleSpecialPriceSearch() {
    clearTimeout(specialPriceDebounceTimer);
    uiState.selectedProductForSpecialPrice = null; // Reset pilihan setiap kali mencari
    uiState.specialPriceInput = null;

    const query = uiState.specialPriceSearch.trim().toLowerCase();
    if (query.length < 2) {
        uiState.specialPriceRecommendations = [];
        return;
    }
    specialPriceDebounceTimer = setTimeout(() => {
        uiState.specialPriceRecommendations = state.produk.filter(p => 
            p.sku.toLowerCase().includes(query) ||
            p.nama.toLowerCase().includes(query) ||
            p.warna.toLowerCase().includes(query) ||
            p.varian.toLowerCase().includes(query)
        ).slice(0, 5);
    }, 300);
}

function selectProductForSpecialPrice(product) {
    uiState.selectedProductForSpecialPrice = product;
    uiState.specialPriceSearch = `${product.nama} - ${product.varian} (${product.sku})`;
    uiState.specialPriceRecommendations = [];

    // Cek apakah sudah ada harga spesial untuk produk ini di channel yg dipilih
    const existingPrice = state.specialPrices[uiState.specialPriceChannel]?.[product.sku];
    if (existingPrice) {
        uiState.specialPriceInput = existingPrice;
    } else {
        uiState.specialPriceInput = null;
    }
}

function saveSpecialPrice() {
    if (!uiState.selectedProductForSpecialPrice || uiState.specialPriceInput === null || uiState.specialPriceInput <= 0) {
        alert("Harap pilih produk dan masukkan harga spesial yang valid.");
        return;
    }

    const channelId = uiState.specialPriceChannel;
    const sku = uiState.selectedProductForSpecialPrice.sku;
    const price = uiState.specialPriceInput;

    if (!state.specialPrices[channelId]) {
        state.specialPrices[channelId] = {};
    }
    state.specialPrices[channelId][sku] = price;

    alert(`Harga spesial untuk SKU ${sku} di channel terpilih berhasil disimpan!`);
    
    // Reset form di dalam modal
    uiState.selectedProductForSpecialPrice = null;
    uiState.specialPriceSearch = '';
    uiState.specialPriceInput = null;

    // OTOMATIS TUTUP MODAL SETELAH SIMPAN
    hideModal();
}

function deleteSpecialPrice(channelId, sku) {
    if (confirm(`Anda yakin ingin menghapus harga spesial untuk SKU ${sku}?`)) {
        if (state.specialPrices[channelId] && state.specialPrices[channelId][sku]) {
            delete state.specialPrices[channelId][sku];
            alert('Harga spesial berhasil dihapus.');
        }
    }
}



function showBulkPasteInfo() {
    uiState.bulkPasteInfoVisible = !uiState.bulkPasteInfoVisible;
}

function getBulkPasteRows() {
    return (uiState.bulk_paste_input || '')
        .split(/\r?\n|\t/)
        .map(row => row.trim())
        .filter(row => row.length > 0);
}

function findProductBySkuForBulkPaste(value) {
    const keyword = value.toString().trim().toLowerCase();

    return (state.produk || []).find(product => {
        return (product.sku || '').toString().trim().toLowerCase() === keyword;
    });
}

function looksLikeOrderId(value) {
    const code = value?.toString().trim();

    // Semua teks dianggap ID Pesanan selama tidak kosong.
    // Tidak ada syarat minimal karakter, strip, underscore, angka, atau huruf.
    return !!code;
}

function buildBulkPasteValidation() {
    const rows = getBulkPasteRows();
    const errors = [];
    const orders = [];
    let currentOrder = null;

    if (!uiState.activeCartChannel) {
        errors.push('Pilih Channel Penjualan terlebih dahulu.');
    }

    if (rows.length === 0) {
        errors.push('Data masih kosong.');
    }

    rows.forEach((value, index) => {
        const lineNumber = index + 1;
        const product = findProductBySkuForBulkPaste(value);

        if (product) {
            if (!currentOrder) {
                errors.push(`Baris ${lineNumber}: SKU "${value}" tidak punya ID Pesanan di atasnya.`);
                return;
            }

            const existingItem = currentOrder.items.find(item => item.sku === product.sku);

            if (existingItem) {
                existingItem.qty += 1;
            } else {
                currentOrder.items.push({
                    ...product,
                    qty: 1
                });
            }

            return;
        }

        if (looksLikeOrderId(value)) {
            currentOrder = {
                marketplaceOrderId: value,
                items: []
            };

            orders.push(currentOrder);
            return;
        }

        errors.push(`Baris ${lineNumber}: "${value}" tidak ditemukan sebagai SKU dan tidak terbaca sebagai ID Pesanan.`);
    });

    orders.forEach(order => {
        if (!order.items || order.items.length === 0) {
            errors.push(`ID Pesanan "${order.marketplaceOrderId}" belum punya produk.`);
        }
    });

    const totalProducts = orders.reduce((sum, order) => {
        return sum + order.items.reduce((itemSum, item) => itemSum + item.qty, 0);
    }, 0);

    return {
        orders,
        errors,
        totalOrders: orders.length,
        totalProducts,
        hasError: errors.length > 0
    };
}

function validateBulkPasteOrders() {
    uiState.bulkPasteValidation = buildBulkPasteValidation();
}

function addValidatedBulkOrderToQueue(orderData) {
    let existingOrder = uiState.bulk_order_queue.find(order => {
        return order.marketplaceOrderId === orderData.marketplaceOrderId;
    });

    if (!existingOrder) {
        existingOrder = {
            id: orderData.marketplaceOrderId,
            marketplaceOrderId: orderData.marketplaceOrderId,
            items: [],
            status: 'Mengantri'
        };

        uiState.bulk_order_queue.unshift(existingOrder);
    }

    orderData.items.forEach(product => {
        const specialPrice = state.specialPrices[uiState.activeCartChannel]?.[product.sku];
        const regularPrice = product.hargaJual?.[uiState.activeCartChannel] ?? 0;
        const finalPrice = specialPrice !== undefined ? specialPrice : regularPrice;
        const commissionRate = product.commissions?.[uiState.activeCartChannel] || 0;

        const existingItem = existingOrder.items.find(item => item.sku === product.sku);

        if (existingItem) {
            existingItem.qty += product.qty;
            existingItem.commissionRate = commissionRate;
        } else {
            existingOrder.items.push({
                ...product,
                hargaJualAktual: finalPrice,
                commissionRate: commissionRate
            });
        }
    });
}

function processBulkPasteOrders() {
    if (!uiState.bulkPasteValidation) {
        validateBulkPasteOrders();
    }

    if (!uiState.bulkPasteValidation || uiState.bulkPasteValidation.hasError) {
        return alert('Data belum aman. Klik Validasi Data dan perbaiki baris yang bermasalah dulu.');
    }

    uiState.bulkPasteValidation.orders.forEach(order => {
        addValidatedBulkOrderToQueue(order);
    });

    const totalOrders = uiState.bulkPasteValidation.totalOrders;
    const totalProducts = uiState.bulkPasteValidation.totalProducts;

    uiState.bulk_paste_input = '';
    uiState.bulkPasteValidation = null;

    alert(`Berhasil memasukkan ${totalOrders} ID pesanan dan ${totalProducts} produk ke antrian.`);
}

const prosesBulkScanFinal = (scannedValue) => {
    if (!uiState.activeCartChannel) {
        alert("Pilih Channel Penjualan terlebih dahulu!");
        uiState.bulk_scan_input = '';
        return;
    }

    const product = getProductBySku(scannedValue);

    if (product) {
        // Jika Produk Ditemukan
        addProductToBulkQueue(product);
        // Kosongkan input TANPA Alert (agar smooth)
        uiState.bulk_scan_input = '';
    } else {
        // Jika Bukan Produk, Cek apakah Resi
        let orderToFinalize = uiState.bulk_order_queue.find(o => o.id.startsWith('TEMP-'));
        
        if (orderToFinalize) {
            orderToFinalize.id = scannedValue;
            orderToFinalize.marketplaceOrderId = scannedValue;
            orderToFinalize.status = 'Mengantri';
            // Kosongkan input TANPA Alert
            uiState.bulk_scan_input = '';
        } else {
            // GAGAL
            // Kita kosongkan dulu inputnya SEBELUM alert muncul
            // Supaya jika user menutup alert, dia bisa scan ulang
            uiState.bulk_scan_input = ''; 
            alert(`Gagal: Kode "${scannedValue}" tidak ditemukan.`);
        }
    }
};



// --- LIFECYCLE & WATCHERS ---

watch(
    dashboardFilteredData,
    () => {
        if (
            activePage.value ===
                'dashboard' &&
            !dashboardDataLoading.value
        ) {
            nextTick(
                renderCharts
            );
        }
    }
);
watch(() => uiState.bulk_paste_input, () => {
    uiState.bulkPasteValidation = null;
});
watch(() => uiState.activeCartChannel, (newChannel) => { if (newChannel && !state.carts[newChannel]) state.carts[newChannel] = []; });
watch(() => uiState.promosiSelectedModel, (newModel) => {
  if (newModel) {
    if (!state.promotions.perModel[newModel]) {
      state.promotions.perModel[newModel] = {};
    }
    state.settings.marketplaces.forEach(channel => {
      if (!state.promotions.perModel[newModel][channel.id]) {
        state.promotions.perModel[newModel][channel.id] = { minBelanja: null, diskonRate: null, diskonBertingkat: [] };
      }
    });
  }
});

watch(() => uiState.bulk_scan_input, (newValue) => {
    // 1. Jika kosong, abaikan
    if (!newValue || newValue.trim() === '') return;

    // 2. Clear timer lama
    if (bulkScanTimer) clearTimeout(bulkScanTimer);

    // 3. Buat timer baru (Tunggu 500ms)
    bulkScanTimer = setTimeout(() => {
        const scannedValue = newValue.trim();

        // 4. [PENTING] Cek Panjang Karakter
        // Jangan proses jika cuma 1 atau 2 huruf (seperti 's' atau 'sl')
        // Ini mencegah error muncul saat scanner baru mulai mengetik
        if (scannedValue.length < 3) {
            return; 
        }

        // Jika panjang sudah oke (minimal 3 huruf), baru proses
        prosesBulkScanFinal(scannedValue);

    }, 500); 
});

// 2. Watcher untuk KASIR POS (Dengan Jeda Waktu)
watch(() => uiState.pos_scan_input, (newValue) => {
    if (posScanTimer) clearTimeout(posScanTimer);
    handlePosSearch(); // Tetap jalankan pencarian visual
    if (!newValue || newValue.trim() === '') return;

    posScanTimer = setTimeout(() => {
        const val = newValue.trim();
        if (val.length >= 3) {
             const product = getProductBySku(val);
             if (product) {
                 addProductToCart(product);
                 uiState.pos_scan_input = '';
                 uiState.posSearchRecommendations = [];
             }
        }
    }, 500);
});

watch(() => uiState.notesData.type, () => {
    uiState.notesData.voucherType = '';
});

watch(() => uiState.pengaturanTab, (newTab) => {
    // 1. Logika Lama (Untuk Tab Admin)
    if (newTab === 'admin' && isAdmin.value) {
        if (uiState.allUsers.length === 0) {
            fetchAllUsers();
        }
        fetchCommissionPayouts();
        fetchActivationCodes();
    }

    // 2. TAMBAHAN BARU (Untuk Tab Rekening Bank)
    // Ini akan memastikan data bank diambil saat Anda klik tab "Rekening Bank"
    if (newTab === 'rekening' && currentUser.value) {
        fetchInvestorsAndBanksData(currentUser.value.uid);
    }
});



let unsubscribe = () => {}; 

const applyCoreCachePayload =
    payload => {
        if (!payload) {
            return false;
        }

        Object.assign(
            state.settings,
            payload.settings || {}
        );

        // Cache lama tetap dapat dipakai, tetapi seluruh key PIN baru
        // harus selalu tersedia sebelum halaman Pengaturan ditampilkan.
        ensurePinProtectionDefaults();

        state.settings.categories =
            Array.isArray(payload.categories)
                ? payload.categories
                : [];

        state.promotions.perChannel =
            payload.promotions?.perChannel ||
            {};

        state.promotions.perModel =
            payload.promotions?.perModel ||
            {};

        state.commissions.perModel =
            payload.commissions?.perModel ||
            {};

        dataFetched.settings = true;

        return true;
    };

const createCoreCachePayload = () => ({
    settings: {
        ...state.settings,
        categories: undefined
    },
    categories:
        state.settings.categories || [],
    promotions: {
        perChannel:
            state.promotions.perChannel ||
            {},
        perModel:
            state.promotions.perModel ||
            {}
    },
    commissions: {
        perModel:
            state.commissions.perModel ||
            {}
    }
});

const setupListeners = async (
    userId,
    isUserPartner
) => {
    unsubscribe();

    // Komisi mitra tetap real-time.
    let commissionsListener = () => {};

    if (isUserPartner) {
        const commissionsQuery = query(
            collection(db, 'commissions'),
            where('partnerId', '==', userId)
        );

        commissionsListener = onSnapshot(
            commissionsQuery,
            (snapshot) => {
                commissions.value =
                    snapshot.docs.map(docSnap => ({
                        id: docSnap.id,
                        ...docSnap.data()
                    }));
            }
        );
    }

    unsubscribe = () => {
        commissionsListener();
    };
};

const fetchCoreData = async (
    userId,
    forceRefresh = false
) => {
    if (!userId) return;

    if (
        !forceRefresh &&
        dataFetched.settings
    ) {
        console.log(
            '[CACHE SESSION] Pengaturan, kategori, promosi, dan komisi produk sudah tersedia.'
        );

        return;
    }

    if (!forceRefresh) {
        const cachedCoreData =
            await readModuleCache(
                'settings',
                'core'
            );

        if (
            applyCoreCachePayload(
                cachedCoreData
            )
        ) {
            console.log(
                '[APP CACHE] Pengaturan dimuat tanpa membaca koleksi ulang.'
            );

            return;
        }
    }

    try {
        const readDocument =
            forceRefresh
                ? getDocFromServer
                : getDoc;

        const readDocuments =
            forceRefresh
                ? getDocsFromServer
                : getDocs;

        const categoriesQuery = query(
            collection(db, 'categories'),
            where('userId', '==', userId)
        );

        const [
            settingsSnap,
            promotionsSnap,
            commissionsSnap,
            categoriesSnap
        ] = await Promise.all([
            readDocument(
                doc(db, 'settings', userId)
            ),

            readDocument(
                doc(db, 'promotions', userId)
            ),

            readDocument(
                doc(
                    db,
                    'product_commissions',
                    userId
                )
            ),

            readDocuments(categoriesQuery)
        ]);

        const loadedCategories =
            categoriesSnap.docs.map(docSnap => ({
                id: docSnap.id,
                ...docSnap.data()
            }));

        const defaultPinSettings = {
            dashboard: false,
            incomeHistory: false,
            investmentPage: false,
            laporanTransaksi: false,
            laporanKeuangan: false,
            hargaHpp: false,
            statistikPenjualan: false,
            exportData: false,
            transactionDetail: false
        };

        if (settingsSnap.exists()) {
            const settingsData =
                settingsSnap.data();

            Object.assign(
                state.settings,
                settingsData
            );

            state.settings.pinProtection = {
                ...defaultPinSettings,
                ...(
                    settingsData.pinProtection ||
                    {}
                )
            };
        } else {
            state.settings.pinProtection =
                defaultPinSettings;
        }

        state.settings.categories =
            loadedCategories;

        if (
            userProfile.data?.inflowCategories
        ) {
            state.settings.inflowCategories =
                userProfile.data.inflowCategories;
        }

        if (promotionsSnap.exists()) {
            const promoData =
                promotionsSnap.data();

            state.promotions.perChannel =
                promoData.perChannel || {};

            state.promotions.perModel =
                promoData.perModel || {};
        } else {
            state.promotions.perChannel = {};
            state.promotions.perModel = {};
        }

        if (commissionsSnap.exists()) {
            const commsData =
                commissionsSnap.data();

            state.commissions.perModel =
                commsData.perModel || {};
        } else {
            state.commissions.perModel = {};
        }

        dataFetched.settings = true;

        await writeModuleCache(
            'settings',
            'core',
            createCoreCachePayload()
        );
    } catch (error) {
        dataFetched.settings = false;

        console.error(
            'Error fetching core data:',
            error
        );
    }
};

// Fungsi khusus untuk data produk, harga, dan alokasi

const mapInventoryProductDocument =
    docSnap => {
        const product =
            docSnap.data() || {};

        return {
            docId: docSnap.id,
            sku: product.sku || '',
            nama:
                product.product_name || '',
            model_id:
                product.model_id || '',
            warna: product.color || '',
            varian:
                product.variant || '',
            stokFisik:
                Number(
                    product.physical_stock
                ) || 0,
            hpp:
                Number(product.hpp) || 0,
            hargaJual: {},
            stokAlokasi: {},
            userId: product.userId
        };
    };

const resolveInventoryGroup =
    groupOrModelId => {
        if (
            groupOrModelId &&
            typeof groupOrModelId ===
                'object'
        ) {
            const modelIds =
                Array.isArray(
                    groupOrModelId.modelIds
                )
                    ? groupOrModelId.modelIds
                        .filter(
                            modelId =>
                                modelId !==
                                    undefined &&
                                modelId !== null &&
                                modelId !== ''
                        )
                    : [];

            return {
                groupKey:
                    groupOrModelId.groupKey ||
                    getInventoryModelGroupKey(
                        groupOrModelId.namaModel
                    ),
                modelIds
            };
        }

        return {
            groupKey:
                String(
                    groupOrModelId || ''
                ),
            modelIds:
                groupOrModelId
                    ? [groupOrModelId]
            : []
        };
    };

const applyInventoryGroupProducts =
    (
        groupKey,
        modelIds,
        modelProducts
    ) => {
        if (
            !groupKey ||
            !Array.isArray(modelProducts)
        ) {
            return false;
        }

        const loadedModelIdKeys =
            new Set(
                (modelIds || []).map(
                    modelId =>
                        String(modelId)
                )
            );

        state.inventoryPaginated =
            (
                state.inventoryPaginated ||
                []
            ).filter(
                product =>
                    !loadedModelIdKeys.has(
                        String(
                            product.model_id ||
                            ''
                        )
                    )
            );

        state.inventoryPaginated.push(
            ...modelProducts
        );

        if (
            !dataFetched.allProductsLoaded
        ) {
            state.produk =
                (
                    state.produk || []
                ).filter(
                    product =>
                        !loadedModelIdKeys.has(
                            String(
                                product.model_id ||
                                ''
                            )
                        )
                );

            state.produk.push(
                ...modelProducts
            );
        }

        inventoryModelLoaded[
            groupKey
        ] = true;

        dataFetched.products = true;

        return true;
    };

const loadInventoryModelProducts =
    async (
        userId,
        groupOrModelId,
        forceRefresh = false
    ) => {
        const {
            groupKey,
            modelIds
        } =
            resolveInventoryGroup(
                groupOrModelId
            );

        if (
            !userId ||
            !groupKey ||
            modelIds.length === 0
        ) {
            return;
        }

        if (
            inventoryModelLoading[
                groupKey
            ]
        ) {
            return;
        }

        if (
            inventoryModelLoaded[
                groupKey
            ] &&
            !forceRefresh
        ) {
            return;
        }

        inventoryModelLoading[
            groupKey
        ] = true;

        inventoryModelErrors[
            groupKey
        ] = '';

        try {
            const uniqueModelIds = [];

            modelIds.forEach(modelId => {
                const alreadyIncluded =
                    uniqueModelIds.some(
                        savedId =>
                            String(savedId) ===
                            String(modelId)
                    );

                if (!alreadyIncluded) {
                    uniqueModelIds.push(
                        modelId
                    );
                }
            });

            if (
                dataFetched
                    .allProductsLoaded
            ) {
                const modelIdKeys =
                    new Set(
                        uniqueModelIds.map(
                            modelId =>
                                String(modelId)
                        )
                    );

                const productsFromMemory =
                    (
                        state.produk || []
                    ).filter(
                        product =>
                            modelIdKeys.has(
                                String(
                                    product.model_id ||
                                    ''
                                )
                            )
                    );

                applyInventoryGroupProducts(
                    groupKey,
                    uniqueModelIds,
                    productsFromMemory
                );

                return;
            }

            if (!forceRefresh) {
                const cachedGroup =
                    await readModuleCache(
                        'products',
                        `inventory-${groupKey}`
                    );

                if (
                    cachedGroup &&
                    applyInventoryGroupProducts(
                        groupKey,
                        uniqueModelIds,
                        cachedGroup.products
                    )
                ) {
                    console.log(
                        `[APP CACHE] Grup Inventaris ${groupKey} dimuat tanpa membaca koleksi ulang.`
                    );

                    return;
                }
            }

            const modelProductsById =
                new Map();

            // Firestore membatasi query "in" maksimal 30 nilai.
            // Grup besar dibagi otomatis agar semua varian tetap terbaca.
            for (
                let index = 0;
                index <
                    uniqueModelIds.length;
                index +=
                    INVENTORY_MODEL_QUERY_CHUNK_SIZE
            ) {
                const modelIdBatch =
                    uniqueModelIds.slice(
                        index,
                        index +
                            INVENTORY_MODEL_QUERY_CHUNK_SIZE
                    );

                const modelConstraint =
                    modelIdBatch.length === 1
                        ? where(
                            'model_id',
                            '==',
                            modelIdBatch[0]
                        )
                        : where(
                            'model_id',
                            'in',
                            modelIdBatch
                        );

                const modelQuery =
                    query(
                        collection(
                            db,
                            'products'
                        ),
                        where(
                            'userId',
                            '==',
                            userId
                        ),
                        modelConstraint
                    );

                const modelSnapshot =
                    await getDocsFromServer(
                        modelQuery
                    );

                modelSnapshot.docs.forEach(
                    docSnap => {
                        const mappedProduct =
                            mapInventoryProductDocument(
                                docSnap
                            );

                        modelProductsById.set(
                            mappedProduct.docId,
                            mappedProduct
                        );
                    }
                );
            }

            const modelProducts =
                Array.from(
                    modelProductsById.values()
                );

            applyInventoryGroupProducts(
                groupKey,
                uniqueModelIds,
                modelProducts
            );

            await writeModuleCache(
                'products',
                `inventory-${groupKey}`,
                {
                    products:
                        modelProducts
                }
            );

            console.log(
                `[INVENTARIS] Grup ${groupKey}: ${modelProducts.length} varian dari ${uniqueModelIds.length} ID model dimuat.`
            );
        } catch (error) {
            console.error(
                '[INVENTARIS] Gagal memuat grup model:',
                error
            );

            inventoryModelErrors[
                groupKey
            ] =
                error?.message ||
                'Gagal memuat data model.';
        } finally {
            inventoryModelLoading[
                groupKey
            ] = false;
        }
    };

const toggleInventoryGroup =
    async group => {
        if (!group?.groupKey) {
            return;
        }

        if (
            uiState.activeAccordion ===
            group.groupKey
        ) {
            uiState.activeAccordion =
                null;

            return;
        }

        uiState.activeAccordion =
            group.groupKey;

        await loadInventoryModelProducts(
            currentUser.value?.uid,
            group
        );
    };

const openInventoryStock =
    async product => {
        if (!product?.docId) {
            alert('Produk ini belum memiliki ID database. Muat ulang halaman Inventaris lalu coba lagi.');
            return;
        }

        const initialAllocation = {};
        (state.settings.marketplaces || []).forEach(marketplace => {
            initialAllocation[marketplace.id] =
                Number(product.stokAlokasi?.[marketplace.id]) || 0;
        });

        const normalizedProduct = {
            ...product,
            stokFisik: Number(product.stokFisik ?? product.physical_stock) || 0,
            physical_stock: Number(product.physical_stock ?? product.stokFisik) || 0,
            stokAlokasi: initialAllocation
        };

        // Tampilkan modal segera. Membaca alokasi di server tidak boleh
        // membuat tombol Kelola Stok seolah tidak merespons.
        showModal('kelolaStok', {
            product: JSON.parse(JSON.stringify(normalizedProduct)),
            original: JSON.parse(JSON.stringify(normalizedProduct)),
            stockAllocationWarning: ''
        });

        try {
            const allocationSnapshot = await getDocFromServer(
                doc(db, 'stock_allocations', product.docId)
            );
            const allocation = allocationSnapshot.exists()
                ? allocationSnapshot.data()
                : {};
            const stokAlokasi = {};
            (state.settings.marketplaces || []).forEach(marketplace => {
                stokAlokasi[marketplace.id] =
                    Number(allocation[marketplace.id] ?? initialAllocation[marketplace.id]) || 0;
            });

            const enrichedProduct = { ...normalizedProduct, stokAlokasi };
            const inventoryIndex = state.inventoryPaginated.findIndex(
                item => item.docId === product.docId
            );
            if (inventoryIndex !== -1) state.inventoryPaginated[inventoryIndex] = enrichedProduct;

            if (
                uiState.modalType === 'kelolaStok' &&
                uiState.modalData?.original?.docId === product.docId
            ) {
                uiState.modalData.product.stokAlokasi = { ...stokAlokasi };
                uiState.modalData.original.stokAlokasi = { ...stokAlokasi };
                uiState.modalData.product.stokFisik = Number(
                    uiState.modalData.product.stokFisik ?? enrichedProduct.stokFisik
                ) || 0;
                uiState.modalData.product.physical_stock = uiState.modalData.product.stokFisik;
            }
        } catch (error) {
            console.warn('[INVENTARIS] Alokasi stok belum dapat dimuat; modal stok tetap bisa digunakan.', error);
            if (
                uiState.modalType === 'kelolaStok' &&
                uiState.modalData?.original?.docId === product.docId
            ) {
                uiState.modalData.stockAllocationWarning =
                    'Alokasi per channel belum bisa dimuat. Kamu tetap bisa mengubah stok fisik. Periksa koneksi/izin sebelum mengubah alokasi.';
            }
        }
    };

// Membuka halaman Inventaris tidak membaca
// semua produk, harga, dan alokasi.
const fetchProductData =
    async userId => {
        if (
            !dataFetched.settings
        ) {
            await fetchCoreData(
                userId
            );
        }

        uiState.productsLastVisible =
            null;

        uiState.productsHasMore =
            false;

        dataFetched.products = true;
    };

const applyLoadedSellingPricesToProducts =
    products => {
        const priceMap = new Map();

        (
            state.productPrices ||
            []
        ).forEach(price => {
            if (
                !isActiveExportRecord(price)
            ) {
                return;
            }

            const productId =
                price.product_id ??
                price.productId;

            const marketplaceId =
                price.marketplace_id ??
                price.marketplaceId;

            if (
                productId === undefined ||
                productId === null ||
                marketplaceId === undefined ||
                marketplaceId === null
            ) {
                return;
            }

            const rawPrice =
                price.price ??
                price.harga ??
                price.hargaJual;

            const numericPrice =
                Number(rawPrice);

            priceMap.set(
                `${String(productId)}__${String(marketplaceId)}`,
                Number.isFinite(numericPrice)
                    ? numericPrice
                    : 0
            );
        });

        (
            products ||
            state.produk ||
            []
        ).forEach(product => {
            if (
                !product.hargaJual ||
                typeof product.hargaJual !==
                    'object'
            ) {
                product.hargaJual = {};
            }

            (
                state.settings.marketplaces ||
                []
            ).forEach(marketplace => {
                const priceKey =
                    `${String(product.docId)}__${String(marketplace.id)}`;

                if (priceMap.has(priceKey)) {
                    product.hargaJual[
                        marketplace.id
                    ] =
                        priceMap.get(priceKey);
                } else if (
                    !Object.prototype.hasOwnProperty.call(
                        product.hargaJual,
                        marketplace.id
                    )
                ) {
                    product.hargaJual[
                        marketplace.id
                    ] = 0;
                }
            });
        });
    };

const applyLoadedStockAllocationsToProducts =
    products => {
        const allocationMap =
            new Map(
                (
                    state.stockAllocations ||
                    []
                ).map(allocation => [
                    String(
                        allocation.id ||
                        allocation.product_id ||
                        allocation.productId ||
                        ''
                    ),
                    allocation
                ])
            );

        (
            products ||
            state.produk ||
            []
        ).forEach(product => {
            const allocation =
                allocationMap.get(
                    String(
                        product.docId
                    )
                ) || {};

            if (
                !product.stokAlokasi ||
                typeof product.stokAlokasi !==
                    'object'
            ) {
                product.stokAlokasi = {};
            }

            (
                state.settings.marketplaces ||
                []
            ).forEach(marketplace => {
                product.stokAlokasi[
                    marketplace.id
                ] =
                    Number(
                        allocation[
                            marketplace.id
                        ]
                    ) || 0;
            });
        });
    };

const applyAllProductsCache =
    payload => {
        if (
            !payload ||
            !Array.isArray(payload.products) ||
            !Array.isArray(
                payload.productPrices
            ) ||
            !Array.isArray(
                payload.stockAllocations
            )
        ) {
            return false;
        }

        state.produk = payload.products;
        state.productPrices =
            payload.productPrices;
        state.stockAllocations =
            payload.stockAllocations;

        applyLoadedSellingPricesToProducts(
            state.produk
        );

        applyLoadedStockAllocationsToProducts(
            state.produk
        );

        const requestedVisibleCount =
            Number(payload.visibleCount) ||
            100;

        const visibleCount = Math.min(
            Math.max(
                requestedVisibleCount,
                100
            ),
            state.produk.length
        );

        state.inventoryPaginated =
            state.produk.slice(
                0,
                visibleCount
            );

        uiState.productsLastVisible =
            null;

        uiState.productsHasMore =
            visibleCount <
            state.produk.length;

        dataFetched.products = true;
        dataFetched.allProductsLoaded =
            true;
        dataFetched.pricesAndAllocations =
            true;

        return true;
    };

let productDataRequestV4 = null;

const runFetchAllProductData = async (userId) => {
    // State sesi tidak langsung dikembalikan. V4 tetap memeriksa satu
    // versi modul kecil di server agar perubahan dari tab/perangkat lain
    // dapat digabungkan tanpa membaca ulang seluruh koleksi.
    if (
    dataFetched.allProductsLoaded &&
    dataFetched.pricesAndAllocations
) {
        // Produk yang baru dimuat dari Inventaris memiliki hargaJual kosong.
        // Pasang kembali harga yang sudah ada sebelum memakai cache.
        applyLoadedSellingPricesToProducts(
            state.produk
        );

        console.log(
            '[INCREMENTAL V4] Produk sesi tersedia; memeriksa perubahan server.'
        );
    }

    let productBaselineVersionV4 = 0;

    try {
        const incrementalResult =
            await syncIncrementalModuleV4({
                firebaseFunctions:
                    functions,
                moduleName:
                    'products',
                cacheKey:
                    'all-products',
                validatePayload:
                    validateProductsPayloadV4,
                mergeChanges:
                    mergeProductChangesV4
            });

        if (
            incrementalResult.payload &&
            applyAllProductsCache(
                incrementalResult.payload
            )
        ) {
            const readMessage =
                incrementalResult.status ===
                    'incremental'
                    ? `${incrementalResult.documentReadCount} dokumen produk yang berubah`
                    : 'cache lokal';

            console.log(
                `[INCREMENTAL V4] ${state.produk.length} produk dimuat dari ${readMessage}.`
            );

            return;
        }

        productBaselineVersionV4 =
            Number(
                incrementalResult
                    .baselineVersion
            ) || 0;
    } catch (error) {
        console.warn(
            '[INCREMENTAL V4] Sinkronisasi produk gagal. Menjalankan fallback penuh yang aman.',
            error
        );
    }

    try {
        // Selalu kosongkan array produk, karena fungsi ini bertujuan memuat semuanya dari awal
        state.produk = []; 

        let lastVisible = null;
        let hasMoreData = true;

        // Ambil juga data harga dan alokasi sekali jalan
        const [pricesSnap, allocationsSnap] = await Promise.all([
            getDocsFromServer(query(collection(db, 'product_prices'), where("userId", "==", userId))),
            getDocsFromServer(query(collection(db, 'stock_allocations'), where("userId", "==", userId))),
        ]);
        const allPrices = pricesSnap.docs.map(doc => ({ id: doc.id, ...doc.data() }));
        const allAllocations = allocationsSnap.docs.map(doc => ({ id: doc.id, ...doc.data() }));
 // Simpan harga dan alokasi yang sudah berhasil diambil
state.productPrices = allPrices;
state.stockAllocations = allAllocations;

dataFetched.pricesAndAllocations = true;       
        while (hasMoreData) {
            let q = query(
                collection(db, "products"),
                where("userId", "==", userId),
                orderBy("product_name", "asc"),
                limit(500) // Ambil lebih banyak per batch untuk efisiensi
            );

            if (lastVisible) {
                q = query(q, startAfter(lastVisible));
            }

            const productSnap =
                await getDocsFromServer(q);

            if (!productSnap.empty) {
                lastVisible = productSnap.docs[productSnap.docs.length - 1];
                
                // Proses dan langsung tambahkan ke state.produk
                productSnap.forEach(docSnap => {
                    const p = { id: docSnap.id, ...docSnap.data() };
                    const hargaJual = {};
                    const stokAlokasi = {};
                    const productAllocation = allAllocations.find(alloc => alloc.id === p.id);
                    
                    (state.settings.marketplaces || []).forEach(mp => {
                        const priceInfo = allPrices.find(pr => pr.product_id === p.id && pr.marketplace_id === mp.id);
                        hargaJual[mp.id] = priceInfo ? priceInfo.price : 0;
                        stokAlokasi[mp.id] = productAllocation ? (productAllocation[mp.id] || 0) : 0;
                    });

                    state.produk.push({
                        docId: p.id,
                        sku: p.sku,
                        nama: p.product_name,
                        model_id: p.model_id,
                        warna: p.color,
                        varian: p.variant,
                        stokFisik: p.physical_stock,
                        hpp: p.hpp,
                        hargaJual,
                        stokAlokasi,
                        userId: p.userId
                    });
                });
            }

            if (productSnap.docs.length < 500) {
                hasMoreData = false;
            }
        }
        
        // ========================================================
// AMBIL JUGA HARGA LAMA BERDASARKAN PRODUCT_ID
// ========================================================
// Sebagian dokumen harga akun lama belum memiliki userId.
const legacyPrices = await getDocsByProductIds(
    "product_prices",
    state.produk.map(
        product => product.docId
    ),
    userId,
    true
);

// Gabungkan harga dengan userId dan harga format lama.
const mergedPrices = dedupeRowsByDocId([
    ...allPrices,
    ...legacyPrices
]);

state.productPrices = mergedPrices;

// Pastikan produk yang sudah berada di state langsung memperoleh harga.
applyLoadedSellingPricesToProducts(
    state.produk
);

// Map membuat pencarian harga jauh lebih cepat
// untuk akun yang produknya banyak.
const priceMap = new Map();

mergedPrices.forEach(price => {
    if (
        !price.product_id ||
        !price.marketplace_id
    ) {
        return;
    }

    priceMap.set(
        `${price.product_id}__${price.marketplace_id}`,
        price.price
    );
});

// Masukkan kembali harga ke masing-masing produk.
state.produk.forEach(product => {
    (
        state.settings.marketplaces ||
        []
    ).forEach(marketplace => {
        const priceKey =
            `${product.docId}__${marketplace.id}`;

        product.hargaJual[marketplace.id] =
            priceMap.has(priceKey)
                ? priceMap.get(priceKey)
                : 0;
    });
});

// Siapkan tampilan awal Inventaris.
// Kalau sebelumnya sudah membuka lebih dari 100,
// pertahankan jumlah yang terlihat.
const visibleCount = Math.min(
    Math.max(
        state.inventoryPaginated.length,
        100
    ),
    state.produk.length
);

state.inventoryPaginated =
    state.produk.slice(
        0,
        visibleCount
    );

uiState.productsLastVisible = null;

uiState.productsHasMore =
    visibleCount <
    state.produk.length;

// Tandai semua data produk berhasil dimuat.
dataFetched.products = true;
dataFetched.allProductsLoaded = true;
dataFetched.pricesAndAllocations = true;

console.log(
    `Successfully fetched ${state.produk.length} total products and ${mergedPrices.length} product prices.`
);

const fullProductPayload = {
        products:
            state.produk,
        productPrices:
            state.productPrices || [],
        stockAllocations:
            state.stockAllocations || [],
        visibleCount:
            state.inventoryPaginated.length
    };

const finalizedProducts =
    await finalizeFullReloadV4({
        firebaseFunctions:
            functions,
        moduleName:
            'products',
        cacheKey:
            'all-products',
        payload:
            fullProductPayload,
        baselineVersion:
            productBaselineVersionV4,
        validatePayload:
            validateProductsPayloadV4,
        mergeChanges:
            mergeProductChangesV4
    });

applyAllProductsCache(
    finalizedProducts.payload
);

    } catch (error) {
        console.error("Error fetching all products:", error);
    }
};

const fetchAllProductData =
    userId => {
        if (productDataRequestV4) {
            return productDataRequestV4;
        }

        productDataRequestV4 =
            runFetchAllProductData(
                userId
            ).finally(() => {
                productDataRequestV4 =
                    null;
            });

        return productDataRequestV4;
    };


const HISTORY_BATCH_SIZE = 200;

const transactionHistoryLoading =
    ref(false);

const returnHistoryLoading =
    ref(false);

const transactionHistoryLoadedCount =
    ref(0);

const returnHistoryLoadedCount =
    ref(0);

const transactionHistoryError =
    ref('');

const returnHistoryError =
    ref('');

const transactionHistoryMessage =
    ref('');

const returnHistoryMessage =
    ref('');

let transactionHistoryRequestId = 0;
let returnHistoryRequestId = 0;

let transactionHistoryReloadTimer =
    null;

let returnHistoryReloadTimer =
    null;

const createLocalDateFromInput =
    (
        value,
        endOfDay = false
    ) => {
        if (!value) {
            return null;
        }

        const parts =
            String(value)
                .split('-')
                .map(Number);

        if (
            parts.length !== 3 ||
            parts.some(
                part =>
                    !Number.isFinite(part)
            )
        ) {
            return null;
        }

        const [
            year,
            month,
            day
        ] = parts;

        return new Date(
            year,
            month - 1,
            day,
            endOfDay ? 23 : 0,
            endOfDay ? 59 : 0,
            endOfDay ? 59 : 0,
            endOfDay ? 999 : 0
        );
    };

const resolveHistoryDateRange =
    (
        filterType,
        {
            startDate = '',
            endDate = '',
            startMonth = null,
            endMonth = null,
            startYear = null,
            endYear = null
        } = {}
    ) => {
        const now =
            new Date();

        const todayStart =
            new Date(
                now.getFullYear(),
                now.getMonth(),
                now.getDate(),
                0,
                0,
                0,
                0
            );

        const todayEnd =
            new Date(
                now.getFullYear(),
                now.getMonth(),
                now.getDate(),
                23,
                59,
                59,
                999
            );

        switch (filterType) {
            case 'today':
                return {
                    ready: true,
                    allTime: false,
                    startDate:
                        todayStart,
                    endDate:
                        todayEnd
                };

            case 'last_7_days': {
                const start =
                    new Date(
                        todayStart
                    );

                // Hari ini + 6 hari sebelumnya
                // = tepat 7 hari kalender.
                start.setDate(
                    start.getDate() - 6
                );

                return {
                    ready: true,
                    allTime: false,
                    startDate: start,
                    endDate:
                        todayEnd
                };
            }

            case 'last_30_days': {
                const start =
                    new Date(
                        todayStart
                    );

                // Hari ini + 29 hari sebelumnya
                // = tepat 30 hari kalender.
                start.setDate(
                    start.getDate() - 29
                );

                return {
                    ready: true,
                    allTime: false,
                    startDate: start,
                    endDate:
                        todayEnd
                };
            }

            case 'this_year':
                return {
                    ready: true,
                    allTime: false,
                    startDate:
                        new Date(
                            now.getFullYear(),
                            0,
                            1,
                            0,
                            0,
                            0,
                            0
                        ),
                    endDate:
                        new Date(
                            now.getFullYear(),
                            11,
                            31,
                            23,
                            59,
                            59,
                            999
                        )
                };

            case 'by_date_range': {
                const start =
                    createLocalDateFromInput(
                        startDate,
                        false
                    );

                const end =
                    createLocalDateFromInput(
                        endDate,
                        true
                    );

                if (!start || !end) {
                    return {
                        ready: false,
                        message:
                            'Pilih tanggal awal dan tanggal akhir.'
                    };
                }

                if (start > end) {
                    return {
                        ready: false,
                        message:
                            'Tanggal awal tidak boleh melewati tanggal akhir.'
                    };
                }

                return {
                    ready: true,
                    allTime: false,
                    startDate: start,
                    endDate: end
                };
            }

            case 'by_month_range': {
                const startMonthNumber =
                    Number(startMonth);

                const endMonthNumber =
                    Number(endMonth);

                const startYearNumber =
                    Number(startYear);

                const endYearNumber =
                    Number(endYear);

                if (
                    !startMonthNumber ||
                    !endMonthNumber ||
                    !startYearNumber ||
                    !endYearNumber
                ) {
                    return {
                        ready: false,
                        message:
                            'Lengkapi bulan dan tahun awal serta akhir.'
                    };
                }

                const start =
                    new Date(
                        startYearNumber,
                        startMonthNumber - 1,
                        1,
                        0,
                        0,
                        0,
                        0
                    );

                const end =
                    new Date(
                        endYearNumber,
                        endMonthNumber,
                        0,
                        23,
                        59,
                        59,
                        999
                    );

                if (start > end) {
                    return {
                        ready: false,
                        message:
                            'Bulan awal tidak boleh melewati bulan akhir.'
                    };
                }

                return {
                    ready: true,
                    allTime: false,
                    startDate: start,
                    endDate: end
                };
            }

            case 'by_year_range': {
                const startYearNumber =
                    Number(startYear);

                const endYearNumber =
                    Number(endYear);

                if (
                    !startYearNumber ||
                    !endYearNumber
                ) {
                    return {
                        ready: false,
                        message:
                            'Lengkapi tahun awal dan tahun akhir.'
                    };
                }

                const start =
                    new Date(
                        startYearNumber,
                        0,
                        1,
                        0,
                        0,
                        0,
                        0
                    );

                const end =
                    new Date(
                        endYearNumber,
                        11,
                        31,
                        23,
                        59,
                        59,
                        999
                    );

                if (start > end) {
                    return {
                        ready: false,
                        message:
                            'Tahun awal tidak boleh melewati tahun akhir.'
                    };
                }

                return {
                    ready: true,
                    allTime: false,
                    startDate: start,
                    endDate: end
                };
            }

            case 'all_time':
            default:
                return {
                    ready: true,
                    allTime: true,
                    startDate: null,
                    endDate: null
                };
        }
    };

const createHistoryCacheKey =
    (prefix, range) => {
        if (range?.allTime) {
            return `${prefix}-all-time`;
        }

        const startValue =
            range?.startDate instanceof Date
                ? range.startDate.getTime()
                : 0;

        const endValue =
            range?.endDate instanceof Date
                ? range.endDate.getTime()
                : 0;

        return `${prefix}-${startValue}-${endValue}`;
    };

const fetchHistoryCollectionByPeriod =
    async ({
        collectionName,
        userId,
        range,
        mapDocument,
        appendDocuments,
        isRequestCurrent
    }) => {
        let lastVisible =
            null;

        let totalLoaded =
    0;

let hasMore =
    true;

while (hasMore) {
            const constraints = [
                where(
                    'userId',
                    '==',
                    userId
                )
            ];

            if (range.startDate) {
                constraints.push(
                    where(
                        'tanggal',
                        '>=',
                        range.startDate
                    )
                );
            }

            if (range.endDate) {
                constraints.push(
                    where(
                        'tanggal',
                        '<=',
                        range.endDate
                    )
                );
            }

            constraints.push(
                orderBy(
                    'tanggal',
                    'desc'
                )
            );

            if (lastVisible) {
                constraints.push(
                    startAfter(
                        lastVisible
                    )
                );
            }

            constraints.push(
                limit(
                    HISTORY_BATCH_SIZE
                )
            );

            const snapshot =
                await getDocsFromServer(
                    query(
                        collection(
                            db,
                            collectionName
                        ),
                        ...constraints
                    )
                );

            if (
                !isRequestCurrent()
            ) {
                return {
                    completed: false,
                    totalLoaded
                };
            }

            const mappedDocuments =
                snapshot.docs
                    .map(
                        mapDocument
                    )
                    .filter(Boolean);

            if (
                mappedDocuments.length > 0
            ) {
                appendDocuments(
                    mappedDocuments
                );

                totalLoaded +=
                    mappedDocuments.length;
            }

            if (
    snapshot.docs.length <
    HISTORY_BATCH_SIZE
) {
    hasMore = false;
    continue;
}

            lastVisible =
                snapshot.docs[
                    snapshot.docs.length - 1
                ];

            // Beri kesempatan Vue menampilkan batch
            // yang sudah selesai sebelum batch berikutnya.
            await nextTick();
        }

        return {
            completed: true,
            totalLoaded
        };
    };

const mapTransactionHistoryDocument =
    docSnap => {
        const data =
            docSnap.data() || {};

        const transaction = {
            id: docSnap.id,
            ...data,
            tanggal:
                data.tanggal?.toDate
                    ? data.tanggal.toDate()
                    : data.tanggal,
            tanggalPencairan:
                data.tanggalPencairan?.toDate
                    ? data.tanggalPencairan.toDate()
                    : data.tanggalPencairan
        };

        return isActiveExportRecord(
            transaction
        )
            ? transaction
            : null;
    };

const mapReturnHistoryDocument =
    docSnap => {
        const data =
            docSnap.data() || {};

        return {
            id: docSnap.id,
            ...data,
            tanggal:
                data.tanggal?.toDate
                    ? data.tanggal.toDate()
                    : data.tanggal
        };
    };

const loadTransactionHistoryByCurrentFilter =
    async userId => {
        if (!userId) {
            return;
        }

        const requestId =
            ++transactionHistoryRequestId;

        const range =
            resolveHistoryDateRange(
                uiState.posDateFilter,
                {
                    startDate:
                        uiState.posStartDate,
                    endDate:
                        uiState.posEndDate,
                    startMonth:
                        uiState.posStartMonth,
                    endMonth:
                        uiState.posEndMonth,
                    startYear:
                        uiState.posStartYear,
                    endYear:
                        uiState.posEndYear
                }
            );

        transactionHistoryError.value =
            '';

        transactionHistoryMessage.value =
            range.ready
                ? ''
                : range.message;

        state.transaksi = [];

        transactionHistoryLoadedCount.value =
            0;

        uiState.transaksiLastVisible =
            null;

        uiState.transaksiHasMore =
            false;

        dataFetched.allTransactionsLoaded =
            false;

        if (!range.ready) {
            transactionHistoryLoading.value =
                false;

            return;
        }

        // V4 memakai satu snapshot penjualan lengkap di IndexedDB.
        // Semua pilihan filter dihitung lokal dari snapshot akurat itu,
        // sehingga mengganti filter tidak membaca koleksi lagi.
        transactionHistoryLoading.value =
            true;

        try {
            await fetchTransactionAndReturnData(
                userId,
                false,
                null,
                null,
                true
            );

            if (
                requestId !==
                transactionHistoryRequestId
            ) {
                return;
            }

            if (
                dataFetched
                    .allTransactionsLoaded
            ) {
                state.transaksi =
                    filterRowsByRangeV4(
                        state.transaksi,
                        range
                    );

                transactionHistoryLoadedCount.value =
                    state.transaksi.length;

                dataFetched.transactions =
                    true;
                dataFetched
                    .allTransactionsLoaded =
                    range.allTime;

                transactionHistoryLoading.value =
                    false;

                console.log(
                    `[INCREMENTAL V4] Filter transaksi menampilkan ${state.transaksi.length} data dari cache lokal.`
                );

                return;
            }
        } catch (error) {
            console.warn(
                '[INCREMENTAL V4] Filter transaksi memakai loader periode sebagai fallback.',
                error
            );
        }

        const historyCacheKey =
            createHistoryCacheKey(
                'transaction-history',
                range
            );

        const cachedHistory =
            await readModuleCache(
                'sales',
                historyCacheKey
            );

        if (
            cachedHistory &&
            Array.isArray(
                cachedHistory.transactions
            )
        ) {
            state.transaksi =
                cachedHistory.transactions;

            transactionHistoryLoadedCount.value =
                state.transaksi.length;

            dataFetched.transactions =
                true;

            dataFetched.allTransactionsLoaded =
                range.allTime;

            transactionHistoryLoading.value =
                false;

            console.log(
                `[APP CACHE] ${state.transaksi.length} riwayat transaksi dimuat tanpa membaca koleksi ulang.`
            );

            return;
        }

        transactionHistoryLoading.value =
            true;

        try {
            const result =
                await fetchHistoryCollectionByPeriod(
                    {
                        collectionName:
                            'transactions',
                        userId,
                        range,
                        mapDocument:
                            mapTransactionHistoryDocument,
                        appendDocuments:
                            documents => {
                                state.transaksi.push(
                                    ...documents
                                );

                                transactionHistoryLoadedCount.value =
                                    state.transaksi.length;
                            },
                        isRequestCurrent:
                            () =>
                                requestId ===
                                    transactionHistoryRequestId &&
                                activePage.value ===
                                    'transaksi'
                    }
                );

            if (
                requestId !==
                transactionHistoryRequestId
            ) {
                return;
            }

            if (result.completed) {
                dataFetched.transactions =
                    true;

                dataFetched.allTransactionsLoaded =
                    range.allTime;

                await writeModuleCache(
                    'sales',
                    historyCacheKey,
                    {
                        transactions:
                            state.transaksi
                    }
                );
            }
        } catch (error) {
            if (
                requestId !==
                transactionHistoryRequestId
            ) {
                return;
            }

            console.error(
                '[RIWAYAT TRANSAKSI] Gagal memuat data:',
                error
            );

            transactionHistoryError.value =
                error?.message ||
                'Riwayat transaksi belum berhasil dimuat.';
        } finally {
            if (
                requestId ===
                transactionHistoryRequestId
            ) {
                transactionHistoryLoading.value =
                    false;
            }
        }
    };

const loadReturnHistoryByCurrentFilter =
    async userId => {
        if (!userId) {
            return;
        }

        const requestId =
            ++returnHistoryRequestId;

        const range =
            resolveHistoryDateRange(
                uiState.returPageDateFilter,
                {
                    startDate:
                        uiState.returPageStartDate,
                    endDate:
                        uiState.returPageEndDate,
                    startMonth:
                        uiState.returPageStartMonth,
                    endMonth:
                        uiState.returPageEndMonth,
                    startYear:
                        uiState.returPageStartYear,
                    endYear:
                        uiState.returPageEndYear
                }
            );

        returnHistoryError.value =
            '';

        returnHistoryMessage.value =
            range.ready
                ? ''
                : range.message;

        state.retur = [];

        returnHistoryLoadedCount.value =
            0;

        uiState.returLastVisible =
            null;

        uiState.returHasMore =
            false;

        dataFetched.allReturnsLoaded =
            false;

        if (!range.ready) {
            returnHistoryLoading.value =
                false;

            return;
        }

        returnHistoryLoading.value =
            true;

        try {
            await fetchTransactionAndReturnData(
                userId,
                false,
                null,
                null,
                true
            );

            if (
                requestId !==
                returnHistoryRequestId
            ) {
                return;
            }

            if (
                dataFetched
                    .allReturnsLoaded
            ) {
                state.retur =
                    filterRowsByRangeV4(
                        state.retur,
                        range
                    );

                returnHistoryLoadedCount.value =
                    state.retur.length;

                dataFetched.returns =
                    true;
                dataFetched
                    .allReturnsLoaded =
                    range.allTime;

                returnHistoryLoading.value =
                    false;

                console.log(
                    `[INCREMENTAL V4] Filter retur menampilkan ${state.retur.length} data dari cache lokal.`
                );

                return;
            }
        } catch (error) {
            console.warn(
                '[INCREMENTAL V4] Filter retur memakai loader periode sebagai fallback.',
                error
            );
        }

        const historyCacheKey =
            createHistoryCacheKey(
                'return-history',
                range
            );

        const cachedHistory =
            await readModuleCache(
                'sales',
                historyCacheKey
            );

        if (
            cachedHistory &&
            Array.isArray(
                cachedHistory.returns
            )
        ) {
            state.retur =
                cachedHistory.returns;

            returnHistoryLoadedCount.value =
                state.retur.length;

            dataFetched.returns =
                true;

            dataFetched.allReturnsLoaded =
                range.allTime;

            returnHistoryLoading.value =
                false;

            console.log(
                `[APP CACHE] ${state.retur.length} riwayat retur dimuat tanpa membaca koleksi ulang.`
            );

            return;
        }

        returnHistoryLoading.value =
            true;

        try {
            const result =
                await fetchHistoryCollectionByPeriod(
                    {
                        collectionName:
                            'returns',
                        userId,
                        range,
                        mapDocument:
                            mapReturnHistoryDocument,
                        appendDocuments:
                            documents => {
                                state.retur.push(
                                    ...documents
                                );

                                returnHistoryLoadedCount.value =
                                    state.retur.length;
                            },
                        isRequestCurrent:
                            () =>
                                requestId ===
                                    returnHistoryRequestId &&
                                activePage.value ===
                                    'retur'
                    }
                );

            if (
                requestId !==
                returnHistoryRequestId
            ) {
                return;
            }

            if (result.completed) {
                dataFetched.returns =
                    true;

                dataFetched.allReturnsLoaded =
                    range.allTime;

                await writeModuleCache(
                    'sales',
                    historyCacheKey,
                    {
                        returns:
                            state.retur
                    }
                );
            }
        } catch (error) {
            if (
                requestId !==
                returnHistoryRequestId
            ) {
                return;
            }

            console.error(
                '[MANAJEMEN RETUR] Gagal memuat data:',
                error
            );

            returnHistoryError.value =
                error?.message ||
                'Data retur belum berhasil dimuat.';
        } finally {
            if (
                requestId ===
                returnHistoryRequestId
            ) {
                returnHistoryLoading.value =
                    false;
            }
        }
    };

const scheduleTransactionHistoryReload =
    () => {
        clearTimeout(
            transactionHistoryReloadTimer
        );

        transactionHistoryReloadTimer =
            setTimeout(
                () => {
                    if (
                        activePage.value ===
                            'transaksi' &&
                        currentUser.value?.uid
                    ) {
                        loadTransactionHistoryByCurrentFilter(
                            currentUser.value.uid
                        );
                    }
                },
                350
            );
    };

const scheduleReturnHistoryReload =
    () => {
        clearTimeout(
            returnHistoryReloadTimer
        );

        returnHistoryReloadTimer =
            setTimeout(
                () => {
                    if (
                        activePage.value ===
                            'retur' &&
                        currentUser.value?.uid
                    ) {
                        loadReturnHistoryByCurrentFilter(
                            currentUser.value.uid
                        );
                    }
                },
                350
            );
    };

watch(
    () => [
        uiState.posDateFilter,
        uiState.posStartDate,
        uiState.posEndDate,
        uiState.posStartMonth,
        uiState.posEndMonth,
        uiState.posStartYear,
        uiState.posEndYear
    ],
    scheduleTransactionHistoryReload
);

watch(
    () => [
        uiState.returPageDateFilter,
        uiState.returPageStartDate,
        uiState.returPageEndDate,
        uiState.returPageStartMonth,
        uiState.returPageEndMonth,
        uiState.returPageStartYear,
        uiState.returPageEndYear
    ],
    scheduleReturnHistoryReload
);


const mapDashboardTransaction =
    docSnap => {
        const data =
            docSnap.data() || {};

        const transaction = {
            id: docSnap.id,
            ...data,
            tanggal:
                data.tanggal?.toDate
                    ? data.tanggal.toDate()
                    : data.tanggal,
            tanggalPencairan:
                data.tanggalPencairan?.toDate
                    ? data.tanggalPencairan.toDate()
                    : data.tanggalPencairan
        };

        return isActiveExportRecord(
            transaction
        )
            ? transaction
            : null;
    };

const mapDashboardReturn =
    docSnap => {
        const data =
            docSnap.data() || {};

        return {
            id: docSnap.id,
            ...data,
            tanggal:
                data.tanggal?.toDate
                    ? data.tanggal.toDate()
                    : data.tanggal
        };
    };

const mapDashboardFinance =
    docSnap => {
        const data =
            docSnap.data() || {};

        const finance = {
            id: docSnap.id,
            ...data,
            tanggal:
                data.tanggal?.toDate
                    ? data.tanggal.toDate()
                    : data.tanggal
        };

        return isActiveExportRecord(
            finance
        )
            ? finance
            : null;
    };

const fetchDashboardQueryBatches =
    async ({
        collectionName,
        userId,
        dateField,
        range,
        mapDocument,
        onBatch,
        isRequestCurrent
    }) => {
        let lastVisible =
            null;

        let hasMore =
            true;

        while (hasMore) {
            const constraints = [
                where(
                    'userId',
                    '==',
                    userId
                )
            ];

            if (range.startDate) {
                constraints.push(
                    where(
                        dateField,
                        '>=',
                        range.startDate
                    )
                );
            }

            if (range.endDate) {
                constraints.push(
                    where(
                        dateField,
                        '<=',
                        range.endDate
                    )
                );
            }

            constraints.push(
                orderBy(
                    dateField,
                    'desc'
                )
            );

            if (lastVisible) {
                constraints.push(
                    startAfter(
                        lastVisible
                    )
                );
            }

            constraints.push(
                limit(
                    DASHBOARD_BATCH_SIZE
                )
            );

            const snapshot =
                await getDocsFromServer(
                    query(
                        collection(
                            db,
                            collectionName
                        ),
                        ...constraints
                    )
                );

            if (
                !isRequestCurrent()
            ) {
                return false;
            }

            const documents =
                snapshot.docs
                    .map(
                        mapDocument
                    )
                    .filter(Boolean);

            if (
                documents.length > 0
            ) {
                onBatch(
                    documents
                );
            }

            if (
                snapshot.docs.length <
                DASHBOARD_BATCH_SIZE
            ) {
                hasMore = false;
                continue;
            }

            lastVisible =
                snapshot.docs[
                    snapshot.docs.length - 1
                ];

            await nextTick();
        }

        return true;
    };

const dashboardRangeContainsToday =
    range => {
        if (range.allTime) {
            return true;
        }

        if (
            !range.startDate ||
            !range.endDate
        ) {
            return false;
        }

        const now =
            new Date();

        const todayStart =
            new Date(
                now.getFullYear(),
                now.getMonth(),
                now.getDate(),
                0,
                0,
                0,
                0
            );

        const todayEnd =
            new Date(
                now.getFullYear(),
                now.getMonth(),
                now.getDate(),
                23,
                59,
                59,
                999
            );

        return (
            range.startDate <=
                todayStart &&
            range.endDate >=
                todayEnd
        );
    };

const isDateToday =
    value => {
        if (!value) {
            return false;
        }

        const date =
            value?.toDate
                ? value.toDate()
                : (
                    value?.seconds
                        ? new Date(
                            value.seconds *
                                1000
                        )
                        : new Date(
                            value
                        )
                );

        if (
            Number.isNaN(
                date.getTime()
            )
        ) {
            return false;
        }

        const today =
            new Date();

        return (
            date.getDate() ===
                today.getDate() &&
            date.getMonth() ===
                today.getMonth() &&
            date.getFullYear() ===
                today.getFullYear()
        );
    };

const loadDashboardReturnProducts =
    async (
        userId,
        returns,
        isRequestCurrent
    ) => {
        const skuList =
            Array.from(
                new Set(
                    (
                        returns || []
                    ).flatMap(
                        returnRecord =>
                            (
                                returnRecord.items ||
                                []
                            )
                                .map(
                                    item =>
                                        String(
                                            item.sku ||
                                                ''
                                        ).trim()
                                )
                                .filter(Boolean)
                    )
                )
            );

        if (
            skuList.length === 0
        ) {
            return;
        }

        const productMap =
            new Map(
                (
                    state.produk || []
                ).map(
                    product => [
                        String(
                            product.sku ||
                                ''
                        ).toLowerCase(),
                        product
                    ]
                )
            );

        // Ukuran 10 sengaja konservatif agar query "in"
        // tetap aman dan sederhana.
        for (
            let index = 0;
            index < skuList.length;
            index += 10
        ) {
            if (
                !isRequestCurrent()
            ) {
                return;
            }

            const skuChunk =
                skuList.slice(
                    index,
                    index + 10
                );

            const snapshot =
                await getDocsFromServer(
                    query(
                        collection(
                            db,
                            'products'
                        ),
                        where(
                            'userId',
                            '==',
                            userId
                        ),
                        where(
                            'sku',
                            'in',
                            skuChunk
                        )
                    )
                );

            snapshot.docs.forEach(
                docSnap => {
                    const data =
                        docSnap.data() ||
                        {};

                    productMap.set(
                        String(
                            data.sku ||
                                ''
                        ).toLowerCase(),
                        {
                            docId:
                                docSnap.id,
                            sku:
                                data.sku || '',
                            nama:
                                data.product_name ||
                                '',
                            model_id:
                                data.model_id ||
                                '',
                            warna:
                                data.color || '',
                            varian:
                                data.variant ||
                                '',
                            stokFisik:
                                Number(
                                    data.physical_stock
                                ) || 0,
                            hpp:
                                Number(
                                    data.hpp
                                ) || 0,
                            userId:
                                data.userId
                        }
                    );
                }
            );
        }

        if (
            isRequestCurrent()
        ) {
            state.produk =
                Array.from(
                    productMap.values()
                );
        }
    };

const loadDashboardReturnOrigins =
    async (
        userId,
        returns,
        isRequestCurrent
    ) => {
        const paidKeys =
            new Set();

        const unresolvedReturns =
            (returns || []).filter(
                returnRecord => {
                    const previousStatus =
                        returnRecord
                            .statusPencairanSebelumRetur;

                    if (
                        previousStatus ===
                        'Sudah Cair'
                    ) {
                        [
                            returnRecord.id,
                            returnRecord
                                .originalTransactionId,
                            returnRecord
                                .transactionId,
                            returnRecord
                                .marketplaceOrderId,
                            returnRecord.orderId,
                            returnRecord.idPesanan,
                            returnRecord.nomorPesanan
                        ]
                            .filter(Boolean)
                            .forEach(
                                key =>
                                    paidKeys.add(
                                        String(key)
                                            .toLowerCase()
                                    )
                            );

                        return false;
                    }

                    // Status Belum Cair berarti retur tidak pernah
                    // menjadi pemasukan kas. Tidak perlu membaca
                    // transaksi asal lagi.
                    if (previousStatus) {
                        return false;
                    }

                    // Retur lama yang belum menyimpan status asal
                    // tetap memakai fallback pembacaan transaksi.
                    return true;
                }
            );

        const transactionIds =
            Array.from(
                new Set(
                    unresolvedReturns
                        .flatMap(
                            returnRecord => [
                                returnRecord
                                    .originalTransactionId,
                                returnRecord
                                    .transactionId
                            ]
                        )
                        .filter(Boolean)
                        .map(String)
                )
            );

        for (
            const transactionId of
                transactionIds
        ) {
            if (
                !isRequestCurrent()
            ) {
                return;
            }

            try {
                const snapshot =
                    await getDocFromServer(
                        doc(
                            db,
                            'transactions',
                            transactionId
                        )
                    );

                if (
                    !snapshot.exists()
                ) {
                    continue;
                }

                const data =
                    snapshot.data() ||
                    {};

                if (
                    data.userId !==
                        userId ||
                    data.statusPencairan !==
                        'Sudah Cair'
                ) {
                    continue;
                }

                [
                    snapshot.id,
                    data.marketplaceOrderId,
                    data.orderId,
                    data.idPesanan,
                    data.nomorPesanan
                ]
                    .filter(Boolean)
                    .forEach(
                        key =>
                            paidKeys.add(
                                String(
                                    key
                                ).toLowerCase()
                            )
                    );
            } catch (error) {
                // Data uji lama dapat menunjuk transaksi yang tidak
                // boleh dibaca oleh akun aktif. Lewati permission-denied
                // tanpa memenuhi Console dengan pesan berulang.
                if (
                    error?.code !==
                    'permission-denied'
                ) {
                    console.warn(
                        '[DASHBOARD] Transaksi asal retur tidak dapat dibaca:',
                        transactionId,
                        error
                    );
                }
            }
        }

        if (
            isRequestCurrent()
        ) {
            dashboardPaidReturnOriginKeys.value =
                Array.from(
                    paidKeys
                );
        }
    };

const loadDashboardTodayFallback =
    async (
        userId,
        isRequestCurrent
    ) => {
        const todayRange =
            resolveHistoryDateRange(
                'today'
            );

        const todayTransactions =
            [];

        const todayFinance =
            [];

        await Promise.all([
            fetchDashboardQueryBatches(
                {
                    collectionName:
                        'transactions',
                    userId,
                    dateField:
                        'tanggal',
                    range:
                        todayRange,
                    mapDocument:
                        mapDashboardTransaction,
                    onBatch:
                        documents => {
                            todayTransactions.push(
                                ...documents
                            );
                        },
                    isRequestCurrent
                }
            ),
            fetchDashboardQueryBatches(
                {
                    collectionName:
                        'keuangan',
                    userId,
                    dateField:
                        'tanggal',
                    range:
                        todayRange,
                    mapDocument:
                        mapDashboardFinance,
                    onBatch:
                        documents => {
                            todayFinance.push(
                                ...documents
                            );
                        },
                    isRequestCurrent
                }
            )
        ]);

        if (
            isRequestCurrent()
        ) {
            dashboardTodayData.transactions =
                todayTransactions;

            dashboardTodayData.finance =
                todayFinance;
        }
    };

const loadDashboardDataByCurrentFilter =
    async userId => {
        if (!userId) {
            return;
        }

        const requestId =
            ++dashboardRequestId;

        const isRequestCurrent =
            () =>
                requestId ===
                    dashboardRequestId &&
                activePage.value ===
                    'dashboard';

        const range =
            resolveHistoryDateRange(
                uiState.dashboardDateFilter,
                {
                    startDate:
                        uiState.dashboardStartDate,
                    endDate:
                        uiState.dashboardEndDate,
                    startMonth:
                        uiState.dashboardStartMonth,
                    endMonth:
                        uiState.dashboardEndMonth,
                    startYear:
                        uiState.dashboardStartYear,
                    endYear:
                        uiState.dashboardEndYear
                }
            );

        dashboardDataError.value =
            '';

        dashboardDataMessage.value =
            range.ready
                ? ''
                : range.message;

        dashboardLoadedCounts.transactions =
            0;

        dashboardLoadedCounts.returns =
            0;

        dashboardLoadedCounts.finance =
            0;

        dashboardPeriodData.transactions =
            [];

        dashboardPeriodData.returns =
            [];

        dashboardPeriodData.finance =
            [];

        dashboardPaidReturnOriginKeys.value =
            [];

        if (!range.ready) {
            dashboardDataLoading.value =
                false;

            return;
        }

        dashboardDataLoading.value =
            true;

        const summaryLoaded =
            await loadDashboardPeriodSummaryV2(
                userId,
                range
            );

        if (
            !isRequestCurrent()
        ) {
            return;
        }

        if (summaryLoaded) {
            // Ringkasan V2 tidak membawa daftar pesanan dan rincian HPP.
            // Muat transaksi dan keuangan periode aktif agar KPI baru tidak membaca array kosong.
            const workflowTransactions = new Map();
            const workflowFinance = new Map();
            const transactionDateMap = new Map();
            const updateWorkflowTransactions = documents => {
                documents.forEach(transaction => workflowTransactions.set(transaction.id, transaction));
                dashboardPeriodData.transactions = Array.from(workflowTransactions.values());
                dashboardLoadedCounts.transactions = workflowTransactions.size;
            };
            const updateWorkflowFinance = documents => {
                documents.forEach(record => workflowFinance.set(record.id, record));
                dashboardPeriodData.finance = Array.from(workflowFinance.values());
                dashboardLoadedCounts.finance = workflowFinance.size;
            };

            try {
                await Promise.all([
                    fetchDashboardQueryBatches({
                        collectionName: 'transactions',
                        userId,
                        dateField: 'tanggal',
                        range,
                        mapDocument: mapDashboardTransaction,
                        onBatch: documents => {
                            documents.forEach(transaction => transactionDateMap.set(transaction.id, transaction));
                            updateWorkflowTransactions(documents);
                        },
                        isRequestCurrent
                    }),
                    range.allTime
                        ? Promise.resolve(true)
                        : fetchDashboardQueryBatches({
                            collectionName: 'transactions',
                            userId,
                            dateField: 'tanggalPencairan',
                            range,
                            mapDocument: mapDashboardTransaction,
                            onBatch: updateWorkflowTransactions,
                            isRequestCurrent
                        }),
                    fetchDashboardQueryBatches({
                        collectionName: 'keuangan',
                        userId,
                        dateField: 'tanggal',
                        range,
                        mapDocument: mapDashboardFinance,
                        onBatch: updateWorkflowFinance,
                        isRequestCurrent
                    })
                ]);

                if (!isRequestCurrent()) return;
                if (dashboardRangeContainsToday(range)) {
                    dashboardTodayData.transactions = Array.from(transactionDateMap.values())
                        .filter(transaction => isDateToday(transaction.tanggal));
                    dashboardTodayData.finance = Array.from(workflowFinance.values())
                        .filter(record => isDateToday(record.tanggal));
                } else {
                    await loadDashboardTodayFallback(userId, isRequestCurrent);
                }
                dashboardDataMessage.value =
                    'Mode hemat aktif • Ringkasan dan rincian pesanan periode terpilih sudah dimuat.';
                dashboardDataLoading.value = false;
                await nextTick();
                renderCharts();
            } catch (error) {
                if (!isRequestCurrent()) return;
                console.error('[DASHBOARD] Rincian pesanan marketplace gagal dimuat:', error);
                dashboardDataError.value =
                    error?.message || 'Rincian pesanan untuk Dashboard belum berhasil dimuat.';
                dashboardDataLoading.value = false;
            }
            return;
        }

        const cashBalancePromise =
            loadDashboardCashBalance(
                userId
            );

        const transactionMap =
            new Map();

        const transactionDateMap =
            new Map();

        const returns =
            [];

        const finance =
            [];

        const updateTransactions =
            documents => {
                documents.forEach(
                    transaction => {
                        transactionMap.set(
                            transaction.id,
                            transaction
                        );
                    }
                );

                dashboardPeriodData.transactions =
                    Array.from(
                        transactionMap.values()
                    );

                dashboardLoadedCounts.transactions =
                    transactionMap.size;
            };

        try {
            const transactionDatePromise =
                fetchDashboardQueryBatches(
                    {
                        collectionName:
                            'transactions',
                        userId,
                        dateField:
                            'tanggal',
                        range,
                        mapDocument:
                            mapDashboardTransaction,
                        onBatch:
                            documents => {
                                documents.forEach(
                                    transaction => {
                                        transactionDateMap.set(
                                            transaction.id,
                                            transaction
                                        );
                                    }
                                );

                                updateTransactions(
                                    documents
                                );
                            },
                        isRequestCurrent
                    }
                );

            const payoutDatePromise =
                range.allTime
                    ? Promise.resolve(
                        true
                    )
                    : fetchDashboardQueryBatches(
                        {
                            collectionName:
                                'transactions',
                            userId,
                            dateField:
                                'tanggalPencairan',
                            range,
                            mapDocument:
                                mapDashboardTransaction,
                            onBatch:
                                updateTransactions,
                            isRequestCurrent
                        }
                    );

            const returnsPromise =
                fetchDashboardQueryBatches(
                    {
                        collectionName:
                            'returns',
                        userId,
                        dateField:
                            'tanggal',
                        range,
                        mapDocument:
                            mapDashboardReturn,
                        onBatch:
                            documents => {
                                returns.push(
                                    ...documents
                                );

                                dashboardPeriodData.returns =
                                    [
                                        ...returns
                                    ];

                                dashboardLoadedCounts.returns =
                                    returns.length;
                            },
                        isRequestCurrent
                    }
                );

            const financePromise =
                fetchDashboardQueryBatches(
                    {
                        collectionName:
                            'keuangan',
                        userId,
                        dateField:
                            'tanggal',
                        range,
                        mapDocument:
                            mapDashboardFinance,
                        onBatch:
                            documents => {
                                finance.push(
                                    ...documents
                                );

                                dashboardPeriodData.finance =
                                    [
                                        ...finance
                                    ];

                                dashboardLoadedCounts.finance =
                                    finance.length;
                            },
                        isRequestCurrent
                    }
                );

            await Promise.all([
                transactionDatePromise,
                payoutDatePromise,
                returnsPromise,
                financePromise,
                cashBalancePromise
            ]);

            if (
                !isRequestCurrent()
            ) {
                return;
            }

            if (
                dashboardRangeContainsToday(
                    range
                )
            ) {
                dashboardTodayData.transactions =
                    Array.from(
                        transactionDateMap.values()
                    ).filter(
                        transaction =>
                            isDateToday(
                                transaction.tanggal
                            )
                    );

                dashboardTodayData.finance =
                    finance.filter(
                        record =>
                            isDateToday(
                                record.tanggal
                            )
                    );
            } else {
                await loadDashboardTodayFallback(
                    userId,
                    isRequestCurrent
                );
            }

            await Promise.all([
                loadDashboardReturnProducts(
                    userId,
                    returns,
                    isRequestCurrent
                ),
                loadDashboardReturnOrigins(
                    userId,
                    returns,
                    isRequestCurrent
                )
            ]);

            if (
                !isRequestCurrent()
            ) {
                return;
            }

            // State global tidak ditandai lengkap,
            // sebab Dashboard hanya membaca periode tertentu.
            dataFetched.transactions =
                false;

            dataFetched.returns =
                false;

            dataFetched.finance =
                false;

            dataFetched.allTransactionsLoaded =
                false;

            dataFetched.allReturnsLoaded =
                false;
        } catch (error) {
            if (
                !isRequestCurrent()
            ) {
                return;
            }

            console.error(
                '[DASHBOARD] Gagal memuat data periode:',
                error
            );

            dashboardDataError.value =
                error?.message ||
                'Data Dashboard belum berhasil dimuat.';
        } finally {
            if (
                requestId ===
                dashboardRequestId
            ) {
                dashboardDataLoading.value =
                    false;

                if (
                    activePage.value ===
                        'dashboard'
                ) {
                    await nextTick();
                    renderCharts();
                }
            }
        }
    };

const scheduleDashboardReload =
    () => {
        clearTimeout(
            dashboardReloadTimer
        );

        dashboardReloadTimer =
            setTimeout(
                () => {
                    if (
                        activePage.value ===
                            'dashboard' &&
                        currentUser.value?.uid
                    ) {
                        loadDashboardDataByCurrentFilter(
                            currentUser.value.uid
                        );
                    }
                },
                350
            );
    };

watch(
    () => [
        uiState.dashboardDateFilter,
        uiState.dashboardStartDate,
        uiState.dashboardEndDate,
        uiState.dashboardStartMonth,
        uiState.dashboardEndMonth,
        uiState.dashboardStartYear,
        uiState.dashboardEndYear
    ],
    scheduleDashboardReload
);

const salesDataRequestsV4 =
    new Map();

const runFetchTransactionAndReturnData = async (
    userId,
    loadMore = false,
    startDate = null,
    endDate = null,
    forceAll = false
) => {
    const ITEMS_PER_PAGE = 15;
    let salesBaselineVersionV4 = 0;

    // Seluruh transaksi dan retur sudah tersedia di state.
    // Jangan unduh ulang saat pindah halaman.
    const fullTransactionDataReady =
        dataFetched.allTransactionsLoaded === true &&
        dataFetched.allReturnsLoaded === true;

    if (
    !loadMore &&
    !startDate &&
    !endDate &&
    !forceAll &&
    fullTransactionDataReady
) {
    console.log(
        '[CACHE SESSION] Seluruh transaksi dan retur sudah tersedia.'
    );
    return;
}

    if (
        forceAll &&
        !loadMore &&
        !startDate &&
        !endDate
    ) {
        try {
            const incrementalResult =
                await syncIncrementalModuleV4({
                    firebaseFunctions:
                        functions,
                    moduleName:
                        'sales',
                    cacheKey:
                        'all-sales',
                    validatePayload:
                        validateSalesPayloadV4,
                    mergeChanges:
                        mergeSalesChangesV4
                });

            if (
                incrementalResult.payload
            ) {
                state.transaksi =
                    incrementalResult
                        .payload
                        .transactions;
                state.retur =
                    incrementalResult
                        .payload
                        .returns;

                uiState.transaksiHasMore =
                    false;
                uiState.returHasMore =
                    false;

                dataFetched.transactions =
                    true;
                dataFetched.returns =
                    true;
                dataFetched
                    .allTransactionsLoaded =
                    true;
                dataFetched
                    .allReturnsLoaded =
                    true;

                const source =
                    incrementalResult
                        .status ===
                        'incremental'
                        ? `${incrementalResult.documentReadCount} dokumen yang berubah`
                        : 'cache lokal';

                console.log(
                    `[INCREMENTAL V4] ${state.transaksi.length} transaksi dan ${state.retur.length} retur dimuat dari ${source}.`
                );

                return;
            }

            salesBaselineVersionV4 =
                Number(
                    incrementalResult
                        .baselineVersion
                ) || 0;
        } catch (error) {
            console.warn(
                '[INCREMENTAL V4] Sinkronisasi penjualan gagal. Menjalankan fallback penuh yang aman.',
                error
            );
        }
    }

    if (forceAll) {
        dataFetched
            .allTransactionsLoaded =
            false;
        dataFetched
            .allReturnsLoaded =
            false;
    }

    const isInitialSalesRequest =
        !forceAll &&
        !loadMore &&
        !startDate &&
        !endDate;

    if (isInitialSalesRequest) {
        const cachedInitialSales =
            await readModuleCache(
                'sales',
                'initial-sales'
            );

        if (
            cachedInitialSales &&
            Array.isArray(
                cachedInitialSales.transactions
            ) &&
            Array.isArray(
                cachedInitialSales.returns
            )
        ) {
            state.transaksi =
                cachedInitialSales
                    .transactions;

            state.retur =
                cachedInitialSales.returns;

            uiState.transaksiLastVisible =
                cachedInitialSales
                    .lastTransactionDate ||
                null;

            uiState.returLastVisible =
                cachedInitialSales
                    .lastReturnDate ||
                null;

            uiState.transaksiHasMore =
                cachedInitialSales
                    .transactionsHasMore ===
                true;

            uiState.returHasMore =
                cachedInitialSales
                    .returnsHasMore ===
                true;

            dataFetched.transactions =
                true;
            dataFetched.returns = true;

            console.log(
                '[APP CACHE] Data awal transaksi dan retur dimuat tanpa membaca koleksi ulang.'
            );

            return;
        }
    }

    // --- TRANSAKSI ---
    if (loadMore && !uiState.transaksiHasMore && !startDate && !forceAll) return;

    try {
        let q_trx;

        if (startDate && endDate && !forceAll) {
            q_trx = query(
                collection(db, "transactions"),
                where("userId", "==", userId),
                where("tanggal", ">=", startDate),
                where("tanggal", "<=", endDate),
                orderBy("tanggal", "desc")
            );

            state.transaksi = [];
        } else {
            if (forceAll) {
                q_trx = query(
                    collection(db, "transactions"),
                    where("userId", "==", userId),
                    orderBy("tanggal", "desc")
                );
            } else {
                q_trx = query(
                    collection(db, "transactions"),
                    where("userId", "==", userId),
                    orderBy("tanggal", "desc"),
                    limit(ITEMS_PER_PAGE)
                );

                if (loadMore && uiState.transaksiLastVisible) {
                    q_trx = query(q_trx, startAfter(uiState.transaksiLastVisible));
                }
            }

            if (!loadMore) {
                state.transaksi = [];
                uiState.transaksiHasMore = true;
            }
        }

        const transactionSnap = forceAll
    ? await getDocsFromServer(q_trx)
    : await getDocs(q_trx);

        if (!transactionSnap.empty) {
            uiState.transaksiLastVisible = transactionSnap.docs[transactionSnap.docs.length - 1];

            transactionSnap.forEach(docSnap => {
    const data = docSnap.data();

    const normalizedTransaction = {
        id: docSnap.id,
        ...data,
        tanggal: data.tanggal?.toDate ? data.tanggal.toDate() : data.tanggal,
        tanggalPencairan: data.tanggalPencairan?.toDate ? data.tanggalPencairan.toDate() : data.tanggalPencairan
    };

    // Jangan tampilkan transaksi yang sudah dihapus / diarsipkan.
    if (!isActiveExportRecord(normalizedTransaction)) return;

    state.transaksi.push(normalizedTransaction);
});
        }

        if (forceAll) {
    uiState.transaksiHasMore = false;

    // Seluruh transaksi user sudah dimuat.
    dataFetched.allTransactionsLoaded = true;
} else if (
    !startDate &&
    transactionSnap.docs.length < ITEMS_PER_PAGE
) {
    uiState.transaksiHasMore = false;
}

        dataFetched.transactions = true;
    } catch (error) {
        console.error("Error fetching transaction data:", error);
    }

    // --- RETUR ---
    if (loadMore && !uiState.returHasMore && !forceAll) return;

    try {
        let q_retur;

        if (forceAll) {
            q_retur = query(
                collection(db, "returns"),
                where("userId", "==", userId),
                orderBy("tanggal", "desc")
            );
        } else {
            q_retur = query(
                collection(db, "returns"),
                where("userId", "==", userId),
                orderBy("tanggal", "desc"),
                limit(ITEMS_PER_PAGE)
            );

            if (loadMore && uiState.returLastVisible) {
                q_retur = query(q_retur, startAfter(uiState.returLastVisible));
            }
        }

        if (!loadMore) {
            state.retur = [];
            uiState.returHasMore = true;
        }

        const returnSnap = forceAll
    ? await getDocsFromServer(q_retur)
    : await getDocs(q_retur);

        if (!returnSnap.empty) {
            uiState.returLastVisible = returnSnap.docs[returnSnap.docs.length - 1];

            returnSnap.forEach(docSnap => {
                const data = docSnap.data();

                state.retur.push({
                    id: docSnap.id,
                    ...data,
                    tanggal: data.tanggal?.toDate ? data.tanggal.toDate() : data.tanggal
                });
            });
        }

        if (forceAll) {
    uiState.returHasMore = false;

    // Seluruh data retur user sudah dimuat.
    dataFetched.allReturnsLoaded = true;
} else if (
    returnSnap.docs.length < ITEMS_PER_PAGE
) {
    uiState.returHasMore = false;
}

        dataFetched.returns = true;
    } catch (error) {
        console.error("Error fetching return data:", error);
    }

    if (
        forceAll &&
        dataFetched
            .allTransactionsLoaded &&
        dataFetched.allReturnsLoaded
    ) {
        const finalizedSales =
            await finalizeFullReloadV4({
                firebaseFunctions:
                    functions,
                moduleName:
                    'sales',
                cacheKey:
                    'all-sales',
                payload: {
                transactions:
                    state.transaksi,
                returns:
                    state.retur
                },
                baselineVersion:
                    salesBaselineVersionV4,
                validatePayload:
                    validateSalesPayloadV4,
                mergeChanges:
                    mergeSalesChangesV4
            });

        state.transaksi =
            finalizedSales
                .payload
                .transactions;
        state.retur =
            finalizedSales
                .payload
                .returns;
    }

    if (isInitialSalesRequest) {
        const lastTransaction =
            state.transaksi[
                state.transaksi.length - 1
            ];

        const lastReturn =
            state.retur[
                state.retur.length - 1
            ];

        await writeModuleCache(
            'sales',
            'initial-sales',
            {
                transactions:
                    state.transaksi,
                returns:
                    state.retur,
                transactionsHasMore:
                    uiState.transaksiHasMore,
                returnsHasMore:
                    uiState.returHasMore,
                lastTransactionDate:
                    lastTransaction?.tanggal ||
                    null,
                lastReturnDate:
                    lastReturn?.tanggal ||
                    null
            }
        );
    }
};

const fetchTransactionAndReturnData =
    (...args) => {
        const requestKey =
            args[4] === true
                ? 'all'
                : (
                    args[1] === true
                        ? 'more'
                        : 'initial'
                );

        if (
            salesDataRequestsV4.has(
                requestKey
            )
        ) {
            return salesDataRequestsV4.get(
                requestKey
            );
        }

        const request =
            runFetchTransactionAndReturnData(
                ...args
            ).finally(() => {
                salesDataRequestsV4.delete(
                    requestKey
                );
            });

        salesDataRequestsV4.set(
            requestKey,
            request
        );

        return request;
    };

// Fungsi khusus untuk data produksi
const fetchProductionData = async (userId, loadMore = false) => {
    const PRODUCTIONS_PER_PAGE = 9; // Muat 9 item (karena grid 3 kolom)

    if (
        !loadMore &&
        dataFetched.production &&
        dataFetched.fabric
    ) {
        console.log(
            '[CACHE SESSION] Produksi dan stok kain sudah tersedia.'
        );

        return;
    }

    if (!loadMore) {
        const cachedProduction =
            await readModuleCache(
                'production',
                'production-page'
            );

        if (
            cachedProduction &&
            Array.isArray(
                cachedProduction.production
            ) &&
            Array.isArray(
                cachedProduction.fabric
            )
        ) {
            state.produksi =
                cachedProduction.production;
            state.gudangKain =
                cachedProduction.fabric;

            uiState.produksiLastVisible =
                cachedProduction
                    .lastProductionDate ||
                null;

            uiState.produksiHasMore =
                cachedProduction.hasMore ===
                true;

            dataFetched.production = true;
            dataFetched.fabric = true;

            console.log(
                '[APP CACHE] Produksi dan stok kain dimuat tanpa membaca koleksi ulang.'
            );

            return;
        }
    }

    // Data stok kain tidak perlu paginasi
    if (!dataFetched.fabric) {
        console.log("Fetching fabric stock...");
        try {
            const fabricSnap = await getDocs(query(collection(db, "fabric_stock"), where("userId", "==", userId)));
            state.gudangKain = fabricSnap.docs.map(doc => ({ id: doc.id, ...doc.data(), tanggalBeli: doc.data().tanggalBeli?.toDate() }));
            dataFetched.fabric = true;
        } catch (error) {
            console.error("Error fetching fabric stock:", error);
        }
    }

    // Paginasi untuk data produksi
    if (loadMore && !uiState.produksiHasMore) return;

    try {
        let q = query(
            collection(db, "production_batches"),
            where("userId", "==", userId),
            orderBy("tanggal", "desc"),
            limit(PRODUCTIONS_PER_PAGE)
        );

        if (loadMore && uiState.produksiLastVisible) {
            q = query(q, startAfter(uiState.produksiLastVisible));
        } else {
            state.produksi = []; // Reset data untuk fetch awal
            uiState.produksiHasMore = true;
        }

        const productionSnap = await getDocs(q);

        if (!productionSnap.empty) {
            uiState.produksiLastVisible = productionSnap.docs[productionSnap.docs.length - 1];
            productionSnap.forEach(doc => {
                state.produksi.push({ id: doc.id, ...doc.data(), tanggal: doc.data().tanggal?.toDate() });
            });
        }
        
        if (productionSnap.docs.length < PRODUCTIONS_PER_PAGE) {
            uiState.produksiHasMore = false;
        }

        dataFetched.production = true;

        const lastProduction =
            state.produksi[
                state.produksi.length - 1
            ];

        await writeModuleCache(
            'production',
            'production-page',
            {
                production:
                    state.produksi,
                fabric:
                    state.gudangKain,
                hasMore:
                    uiState.produksiHasMore,
                lastProductionDate:
                    lastProduction?.tanggal ||
                    null
            }
        );
    } catch (error) {
        console.error("Error fetching production data:", error);
    }
};

// Fungsi khusus untuk data keuangan dan investor
const fetchInvestorsAndBanksData = async (
    userId,
    forceRefresh = false
) => {
    if (
        !forceRefresh &&
        dataFetched.investorsAndBanks
    ) {
        console.log(
            '[CACHE SESSION] Investor, pembayaran investor, dan rekening sudah tersedia.'
        );

        return;
    }

    if (!forceRefresh) {
        const cachedInvestment =
            await readModuleCache(
                'investment',
                'investors-and-banks'
            );

        if (
            cachedInvestment &&
            Array.isArray(
                cachedInvestment.investors
            ) &&
            Array.isArray(
                cachedInvestment.bankAccounts
            ) &&
            Array.isArray(
                cachedInvestment
                    .investorPayments
            )
        ) {
            state.investor =
                cachedInvestment.investors;
            state.bankAccounts =
                cachedInvestment.bankAccounts;
            state.investorPayments =
                cachedInvestment
                    .investorPayments;

            dataFetched.investorsAndBanks =
                true;

            console.log(
                '[APP CACHE] Data investasi dan rekening dimuat tanpa membaca koleksi ulang.'
            );

            return;
        }
    }

    try {
        const readDocuments =
            forceRefresh
                ? getDocsFromServer
                : getDocs;

        const [
            investorsSnap,
            bankAccountsSnap,
            investorPaymentsSnap
        ] = await Promise.all([
            readDocuments(
                query(
                    collection(db, 'investors'),
                    where(
                        'userId',
                        '==',
                        userId
                    )
                )
            ),

            readDocuments(
                query(
                    collection(
                        db,
                        'bank_accounts'
                    ),
                    where(
                        'userId',
                        '==',
                        userId
                    )
                )
            ),

            readDocuments(
                query(
                    collection(
                        db,
                        'investor_payments'
                    ),
                    where(
                        'userId',
                        '==',
                        userId
                    )
                )
            )
        ]);

        state.investor =
            investorsSnap.docs.map(docSnap => ({
                id: docSnap.id,
                ...docSnap.data(),
                startDate:
                    docSnap
                        .data()
                        .startDate
                        ?.toDate()
            }));

        state.bankAccounts =
            bankAccountsSnap.docs.map(docSnap => ({
                id: docSnap.id,
                ...docSnap.data()
            }));

        state.investorPayments =
            investorPaymentsSnap.docs.map(
                docSnap => ({
                    id: docSnap.id,
                    ...docSnap.data(),
                    paymentDate:
                        docSnap
                            .data()
                            .paymentDate
                            ?.toDate()
                })
            );

        dataFetched.investorsAndBanks = true;

        await writeModuleCache(
            'investment',
            'investors-and-banks',
            {
                investors:
                    state.investor,
                bankAccounts:
                    state.bankAccounts,
                investorPayments:
                    state.investorPayments ||
                    []
            }
        );
    } catch (error) {
        dataFetched.investorsAndBanks = false;

        console.error(
            'Error fetching investor/bank data:',
            error
        );
    }
};

// Fungsi baru yang canggih untuk data keuangan dengan filter & paginasi
let financeDataRequestV4 = null;

const runFetchKeuanganData = async (forceRefresh = false) => {
    if (!currentUser.value) return;

    // Walaupun state sesi sudah tersedia, V4 tetap memeriksa versi
    // incremental agar perubahan dari tab/perangkat lain ikut terlihat.
    if (!forceRefresh && dataFetched.finance) {
        console.log(
            '[INCREMENTAL V4] Data keuangan sesi tersedia; memeriksa perubahan server.'
        );
    }

    const userId = currentUser.value.uid;
    let financeBaselineVersionV4 = 0;

    try {
        const incrementalResult =
            await syncIncrementalModuleV4({
                firebaseFunctions:
                    functions,
                moduleName:
                    'finance',
                cacheKey:
                    'all-finance',
                validatePayload:
                    validateFinancePayloadV4,
                mergeChanges:
                    mergeFinanceChangesV4
            });

        if (
            incrementalResult.payload
        ) {
            state.keuangan =
                incrementalResult
                    .payload.rows;

            dataFetched.finance = true;

            const source =
                incrementalResult.status ===
                    'incremental'
                    ? `${incrementalResult.documentReadCount} dokumen yang berubah`
                    : 'cache lokal';

            console.log(
                `[INCREMENTAL V4] ${state.keuangan.length} data keuangan dimuat dari ${source}.`
            );

            return;
        }

        financeBaselineVersionV4 =
            Number(
                incrementalResult
                    .baselineVersion
            ) || 0;
    } catch (error) {
        console.warn(
            '[INCREMENTAL V4] Sinkronisasi keuangan gagal. Menjalankan fallback penuh yang aman.',
            error
        );
    }
    
    // Kueri Paling Stabil: Menggunakan 3 field untuk memastikan urutan Ascending yang sempurna.
    const q = query(
        collection(db, "keuangan"), 
        where("userId", "==", userId),
        orderBy("tanggal", "asc"),      // 1. Urutan Primer: Tanggal terlama di atas (Terbaru di bawah)
        orderBy(documentId(), "asc")    // 2. Urutan Sekunder: ID Dokumen terkecil di atas (Terbaru di bawah)
    );

    try {
        const keuanganSnap =
            await getDocsFromServer(q);
        
        const fetchedKeuangan = keuanganSnap.docs
    .map(doc => {
        const data = doc.data();
        const docId = doc.id;

        const dateObject = (data.tanggal && typeof data.tanggal.toDate === 'function') 
                           ? data.tanggal.toDate() 
                           : data.tanggal; 
        
        return { 
            id: docId, 
            ...data, 
            tanggal: dateObject
        };
    })
    .filter(isActiveExportRecord);
        
        // Update State dengan data yang sudah terurut stabil
        state.keuangan = fetchedKeuangan; 
        
        dataFetched.finance = true;
        console.log(`[Keuangan] Berhasil memuat ${state.keuangan.length} data.`);

        const finalizedFinance =
            await finalizeFullReloadV4({
                firebaseFunctions:
                    functions,
                moduleName:
                    'finance',
                cacheKey:
                    'all-finance',
                payload: {
                rows: state.keuangan
                },
                baselineVersion:
                    financeBaselineVersionV4,
                validatePayload:
                    validateFinancePayloadV4,
                mergeChanges:
                    mergeFinanceChangesV4
            });

        state.keuangan =
            finalizedFinance.payload.rows;

    } catch (error) {
        console.error("Error fetching Keuangan data:", error);
    }
};

const fetchKeuanganData =
    (...args) => {
        if (financeDataRequestV4) {
            return financeDataRequestV4;
        }

        financeDataRequestV4 =
            runFetchKeuanganData(
                ...args
            ).finally(() => {
                financeDataRequestV4 =
                    null;
            });

        return financeDataRequestV4;
    };
// Fungsi khusus untuk data supplier dan purchase order
const fetchSupplierData = async (
    userId,
    loadMore = false,
    forceRefresh = false
) => {
    const SUPPLIERS_PER_PAGE = 10;

    const supplierModuleReady =
        dataFetched.suppliers === true &&
        dataFetched.purchaseOrders === true;

    if (
        !loadMore &&
        !forceRefresh &&
        supplierModuleReady
    ) {
        console.log(
            '[CACHE SESSION] Supplier dan purchase order sudah tersedia.'
        );

        return;
    }

    if (
        !loadMore &&
        !forceRefresh
    ) {
        const cachedSuppliers =
            await readModuleCache(
                'suppliers',
                'supplier-page'
            );

        if (
            cachedSuppliers &&
            Array.isArray(
                cachedSuppliers.suppliers
            ) &&
            Array.isArray(
                cachedSuppliers.purchaseOrders
            )
        ) {
            state.suppliers =
                cachedSuppliers.suppliers;

            state.purchaseOrders =
                cachedSuppliers.purchaseOrders;

            uiState.purchaseOrdersLastVisible =
                cachedSuppliers
                    .lastPurchaseOrderDate ||
                null;

            uiState.purchaseOrdersHasMore =
                cachedSuppliers.hasMore ===
                true;

            dataFetched.suppliers = true;
            dataFetched.purchaseOrders =
                true;

            console.log(
                '[APP CACHE] Supplier dan purchase order dimuat tanpa membaca koleksi ulang.'
            );

            return;
        }
    }

    const readDocuments =
        forceRefresh
            ? getDocsFromServer
            : getDocs;

    if (forceRefresh) {
        dataFetched.suppliers = false;
        dataFetched.purchaseOrders = false;
    }

    // Daftar supplier
    if (!dataFetched.suppliers) {
        try {
            const suppliersSnap =
                await readDocuments(
                    query(
                        collection(
                            db,
                            'suppliers'
                        ),
                        where(
                            'userId',
                            '==',
                            userId
                        )
                    )
                );

            state.suppliers =
                suppliersSnap.docs.map(
                    docSnap => ({
                        id: docSnap.id,
                        ...docSnap.data()
                    })
                );

            dataFetched.suppliers = true;
        } catch (error) {
            dataFetched.suppliers = false;

            console.error(
                'Error fetching suppliers:',
                error
            );
        }
    }

    if (
        loadMore &&
        !uiState.purchaseOrdersHasMore
    ) {
        return;
    }

    try {
        let purchaseOrderQuery = query(
            collection(
                db,
                'purchase_orders'
            ),
            where(
                'userId',
                '==',
                userId
            ),
            orderBy('tanggal', 'desc'),
            limit(SUPPLIERS_PER_PAGE)
        );

        if (
            loadMore &&
            uiState.purchaseOrdersLastVisible
        ) {
            purchaseOrderQuery = query(
                purchaseOrderQuery,
                startAfter(
                    uiState
                        .purchaseOrdersLastVisible
                )
            );
        } else {
            state.purchaseOrders = [];

            uiState.purchaseOrdersLastVisible =
                null;

            uiState.purchaseOrdersHasMore =
                true;
        }

        const poSnapshot =
            await readDocuments(
                purchaseOrderQuery
            );

        if (!poSnapshot.empty) {
            uiState.purchaseOrdersLastVisible =
                poSnapshot.docs[
                    poSnapshot.docs.length - 1
                ];

            poSnapshot.forEach(docSnap => {
                state.purchaseOrders.push({
                    id: docSnap.id,
                    ...docSnap.data(),
                    tanggal:
                        docSnap
                            .data()
                            .tanggal
                            ?.toDate()
                });
            });
        }

        if (
            poSnapshot.docs.length <
            SUPPLIERS_PER_PAGE
        ) {
            uiState.purchaseOrdersHasMore =
                false;
        }

        dataFetched.purchaseOrders = true;

        const lastPurchaseOrder =
            state.purchaseOrders[
                state.purchaseOrders.length -
                    1
            ];

        await writeModuleCache(
            'suppliers',
            'supplier-page',
            {
                suppliers:
                    state.suppliers,
                purchaseOrders:
                    state.purchaseOrders,
                hasMore:
                    uiState
                        .purchaseOrdersHasMore,
                lastPurchaseOrderDate:
                    lastPurchaseOrder
                        ?.tanggal ||
                    null
            }
        );
    } catch (error) {
        dataFetched.purchaseOrders = false;

        console.error(
            'Error fetching purchase orders:',
            error
        );
    }
};

const bulkSettlementInput = ref(''); // State untuk menampung data paste dari Excel

// =====================================================
// DATA KHUSUS HALAMAN CEK PENCAIRAN DANA
// =====================================================

const isSettlementLoading = ref(false);
const pendingSettlementLoadError = ref('');
const settlementCurrentPage = ref(1);
const settlementItemsPerPage = ref(50);

// Mengubah berbagai format tanggal menjadi Date yang aman
function getSettlementDate(value) {
    if (!value) return new Date(0);

    if (value instanceof Date) {
        return isNaN(value.getTime()) ? new Date(0) : value;
    }

    if (value?.toDate && typeof value.toDate === 'function') {
        const date = value.toDate();
        return isNaN(date.getTime()) ? new Date(0) : date;
    }

    if (value?.seconds) {
        const date = new Date(value.seconds * 1000);
        return isNaN(date.getTime()) ? new Date(0) : date;
    }

    const date = new Date(value);
    return isNaN(date.getTime()) ? new Date(0) : date;
}


// Daftar transaksi yang benar-benar masih belum cair
const pendingSettlementTransactions = computed(() => {
    return (state.pendingSettlements || [])
        .filter(trx => {
            return (
                !trx.statusPencairan ||
                trx.statusPencairan === 'Belum Cair' ||
                trx.statusPencairan === 'Waiting'
            );
        })
        .sort((a, b) => {
            return (
                getSettlementDate(b.tanggal).getTime() -
                getSettlementDate(a.tanggal).getTime()
            );
        });
});


// Total halaman
const settlementTotalPages = computed(() => {
    return Math.max(
        1,
        Math.ceil(
            pendingSettlementTransactions.value.length /
            settlementItemsPerPage.value
        )
    );
});


// Data yang ditampilkan pada halaman aktif
const paginatedPendingSettlements = computed(() => {
    const start =
        (settlementCurrentPage.value - 1) *
        settlementItemsPerPage.value;

    const end = start + settlementItemsPerPage.value;

    return pendingSettlementTransactions.value.slice(start, end);
});


// Pastikan nomor halaman tidak melebihi total halaman
watch(pendingSettlementTransactions, () => {
    if (settlementCurrentPage.value > settlementTotalPages.value) {
        settlementCurrentPage.value = settlementTotalPages.value;
    }
});


// Mengambil seluruh transaksi yang masih belum cair
async function fetchPendingSettlementData(userId) {
    if (!userId) return;

    isSettlementLoading.value = true;
    pendingSettlementLoadError.value = '';

    const finalStatuses = new Set([
        'sudahcair',
        'retur',
        'returpengembalian',
        'dikembalikan',
        'pengembalian',
        'baranghilang',
        'hilang',
        'dibatalkan',
        'batal',
        'cancelled',
        'canceled'
    ]);

    const isPendingMarketplaceOrder = transaction => {
        if (!isActiveExportRecord(transaction)) return false;
        if (!String(transaction.marketplaceOrderId || '').trim()) return false;
        if (!String(transaction.channelId || transaction.channel || '').trim()) return false;

        const status = String(transaction.statusPencairan || '')
            .trim()
            .toLocaleLowerCase('id-ID')
            .replace(/[\s/_-]+/g, '');

        return !finalStatuses.has(status);
    };

    try {
        await fetchTransactionAndReturnData(
            userId,
            false,
            null,
            null,
            true
        );

        const transactionMap = new Map();

        if (dataFetched.allTransactionsLoaded) {
            (state.transaksi || []).forEach(transaction => {
                if (isPendingMarketplaceOrder(transaction)) {
                    transactionMap.set(transaction.id, transaction);
                }
            });
        }

        const belumCairQuery = query(
            collection(db, 'transactions'),
            where('userId', '==', userId),
            where('statusPencairan', '==', 'Belum Cair')
        );

        const waitingQuery = query(
            collection(db, 'transactions'),
            where('userId', '==', userId),
            where('statusPencairan', '==', 'Waiting')
        );

        const shippedExportQuery = query(
            collection(db, 'transactions'),
            where('userId', '==', userId),
            where('inputSource', '==', 'marketplace_shipped_export')
        );

        const [
            belumCairSnapshot,
            waitingSnapshot,
            shippedExportSnapshot
        ] = await Promise.all([
            getDocs(belumCairQuery),
            getDocs(waitingQuery),
            getDocs(shippedExportQuery)
        ]);

        const addSnapshotToMap = snapshot => {
            snapshot.forEach(docSnap => {
                const data = docSnap.data();
                const transaction = {
                    ...data,
                    id: docSnap.id,
                    tanggal: getSettlementDate(data.tanggal),
                    tanggalPencairan: data.tanggalPencairan
                        ? getSettlementDate(data.tanggalPencairan)
                        : null
                };

                if (isPendingMarketplaceOrder(transaction)) {
                    transactionMap.set(transaction.id, transaction);
                }
            });
        };

        addSnapshotToMap(belumCairSnapshot);
        addSnapshotToMap(waitingSnapshot);
        addSnapshotToMap(shippedExportSnapshot);

        state.pendingSettlements = Array.from(transactionMap.values());
        dataFetched.pendingSettlements = true;
        settlementCurrentPage.value = 1;

        try {
            await writeModuleCache('sales', 'pending-settlements', {
                transactions: state.pendingSettlements
            });
        } catch (cacheError) {
            console.warn('Cache pesanan tertunda tidak dapat diperbarui:', cacheError);
        }

        console.log(
            `Berhasil memuat ${state.pendingSettlements.length} pesanan belum selesai dari server.`
        );
    } catch (error) {
        console.error('Gagal mengambil transaksi belum selesai:', error);
        dataFetched.pendingSettlements = false;
        pendingSettlementLoadError.value =
            'Daftar pesanan belum berhasil dimuat. Periksa koneksi lalu muat ulang Dashboard.';
    } finally {
        isSettlementLoading.value = false;
    }
}
async function processBulkSettlement(targetStatus = 'Sudah Cair') {
    if (!bulkSettlementInput.value.trim()) {
        return alert("Tempelkan daftar ID Pesanan terlebih dahulu.");
    }
// Data produk diperlukan untuk mengembalikan stok.
// Hanya dimuat ketika tombol Retur/Pengembalian dipakai.
if (
    targetStatus === 'Retur/Pengembalian' &&
    !dataFetched.allProductsLoaded
) {
    await fetchAllProductData(
        currentUser.value.uid
    );
}
    const rawIds = bulkSettlementInput.value
        .split(/[\n,]+/)
        .map(id => id.trim())
        .filter(id => id !== "");

    const uniqueIds = [...new Set(rawIds)];

    let confirmMsg = '';

    if (targetStatus === 'Sudah Cair') {
        confirmMsg = `Sistem mendeteksi ${uniqueIds.length} ID. Tandai sebagai dana sudah cair?`;
    } else if (targetStatus === 'Retur/Pengembalian') {
        confirmMsg = `Sistem mendeteksi ${uniqueIds.length} ID. Masukkan pesanan ini ke Manajemen Retur?`;
    } else if (targetStatus === 'Batal') {
        confirmMsg = `Sistem mendeteksi ${uniqueIds.length} ID. Tandai pesanan ini sebagai batal dan hilangkan dari daftar gantung?`;
    } else {
        confirmMsg = `Sistem mendeteksi ${uniqueIds.length} ID. Lanjutkan proses?`;
    }

    if (!confirm(confirmMsg)) return;

    isSaving.value = true;

    let countSuccess = 0;
let countReturnCreated = 0;
const notFoundIds = [];
const newReturnDocs = [];

// Menyimpan perubahan transaksi.
// Baru diterapkan ke tampilan setelah batch Firebase berhasil.
const updatedTransactions = [];

// Gabungan stok dari seluruh ID pesanan yang diretur
const returnedStockMap = new Map();

    try {
        const batch = writeBatch(db);

        uniqueIds.forEach(orderId => {
            const foundTrx = state.pendingSettlements.find(t => {
    return (t.marketplaceOrderId || '')
        .toString()
        .trim()
        .toLowerCase() === orderId
        .trim()
        .toLowerCase();
});

            if (!foundTrx) {
                notFoundIds.push(orderId);
                return;
            }

            if (foundTrx.statusPencairan === targetStatus) {
    return;
}

// Simpan status sebelum diubah menjadi Retur/Pengembalian
const previousSettlementStatus =
    foundTrx.statusPencairan || 'Belum Cair';

const trxRef = doc(
    db,
    "transactions",
    foundTrx.id
);

            const updatePayload = {
    statusPencairan: targetStatus
};

if (targetStatus === 'Sudah Cair') {
    updatePayload.tanggalPencairan =
        new Date();
}

if (
    targetStatus ===
    'Retur/Pengembalian'
) {
    updatePayload
        .statusPencairanSebelumRetur =
        previousSettlementStatus;
}

batch.update(
    trxRef,
    updatePayload
);

// Simpan perubahan sementara.
// Jangan ubah tampilan sebelum batch berhasil.
updatedTransactions.push({
    id: foundTrx.id,
    updatePayload
});

countSuccess++;

            if (targetStatus === 'Retur/Pengembalian') {
    const returnRef = doc(
        collection(db, "returns")
    );

    // Seluruh item pesanan otomatis diretur.
    // Rumusnya sama dengan Manajemen Retur.
    const returnItems =
        buildReturnItemsFromTransaction(
            foundTrx,
            foundTrx.items || [],
            'Retur / Pengembalian dari Audit & Pencairan Dana'
        );

    if (returnItems.length === 0) {
        throw new Error(
            `Pesanan ${orderId} tidak mempunyai item retur yang valid.`
        );
    }

    const returnData = {
        tanggal: new Date(),
        channelId: foundTrx.channelId || '',
        originalTransactionId: foundTrx.id,
        marketplaceOrderId:
            foundTrx.marketplaceOrderId ||
            orderId,

        sumber: 'Audit & Pencairan Dana',
        statusRetur: 'Retur / Pengembalian',

        // Catatan agar riwayat status tetap jelas
        statusPencairanSebelumRetur:
            previousSettlementStatus,

        items: returnItems,
        userId: currentUser.value.uid,
        createdAt: new Date()
    };

    batch.set(
        returnRef,
        returnData
    );

    // Kumpulkan stok fisik seluruh item pesanan
    addReturnedItemsToStockMap(
        returnedStockMap,
        returnItems
    );

    newReturnDocs.push({
        id: returnRef.id,
        ...returnData
    });

    countReturnCreated++;
}
        });

        if (countSuccess === 0) {
    throw new Error(
        "Tidak ada ID yang cocok dengan daftar pesanan gantung. Periksa kembali ID Pesanan Anda."
    );
}

// Bila prosesnya adalah retur, kembalikan stok fisik.
// Bila Dana Cair atau Batal, Map kosong dan tidak mengubah stok.
queuePhysicalStockReturn(
    batch,
    returnedStockMap
);

await batch.commit();

// Batch Firebase sudah berhasil.
// Sekarang perbarui transaksi pada seluruh state lokal.
updatedTransactions.forEach(
    ({ id, updatePayload }) => {
        applyTransactionUpdateToLocalStores(
            id,
            updatePayload
        );
    }
);

if (newReturnDocs.length > 0) {
    newReturnDocs
        .slice()
        .reverse()
        .forEach(
            returnRecord =>
                addReturnToLocalStores(
                    returnRecord
                )
        );

    // Perbarui stok yang tampil tanpa harus refresh
    applyPhysicalStockReturnToLocal(
        returnedStockMap
    );
}

if (
    (
        targetStatus === 'Sudah Cair' ||
        targetStatus === 'Retur/Pengembalian'
    ) &&
    dashboardSummaryV2.globalReady !==
        true
) {
    await loadDashboardCashBalance(
        currentUser.value.uid
    );
}

        let message = `Berhasil! ${countSuccess} pesanan diperbarui menjadi: ${targetStatus}.`;

        if (countReturnCreated > 0) {
            message += `\n${countReturnCreated} data retur masuk ke Manajemen Retur.`;
        }

        if (notFoundIds.length > 0) {
            message += `\n\nID tidak ditemukan:\n${notFoundIds.slice(0, 10).join('\n')}`;
        }

        alert(message);
        bulkSettlementInput.value = '';

    } catch (error) {
        console.error("Error mass settlement:", error);
        alert(error.message);
    } finally {
        isSaving.value = false;
    }
}

// Fungsi khusus untuk catatan voucher
const fetchNotesData = async (
    userId,
    forceRefresh = false
) => {
    if (
        !forceRefresh &&
        dataFetched.notes
    ) {
        console.log(
            '[CACHE SESSION] Catatan voucher sudah tersedia.'
        );

        return;
    }

    if (!forceRefresh) {
        const cachedNotes =
            await readModuleCache(
                'notes',
                'voucher-notes'
            );

        if (
            cachedNotes &&
            Array.isArray(
                cachedNotes.rows
            )
        ) {
            state.voucherNotes =
                cachedNotes.rows;

            dataFetched.notes = true;

            console.log(
                `[APP CACHE] ${state.voucherNotes.length} catatan voucher dimuat tanpa membaca koleksi ulang.`
            );

            return;
        }
    }

    try {
        const readDocuments =
            forceRefresh
                ? getDocsFromServer
                : getDocs;

        const notesSnap =
            await readDocuments(
                query(
                    collection(
                        db,
                        'voucher_notes'
                    ),
                    where(
                        'userId',
                        '==',
                        userId
                    )
                )
            );

        state.voucherNotes =
            notesSnap.docs.map(docSnap => ({
                id: docSnap.id,
                ...docSnap.data(),
                endDate:
                    docSnap
                        .data()
                        .endDate
                        ?.toDate()
            }));

        dataFetched.notes = true;

        await writeModuleCache(
            'notes',
            'voucher-notes',
            {
                rows:
                    state.voucherNotes
            }
        );
    } catch (error) {
        dataFetched.notes = false;

        console.error(
            'Error fetching notes data:',
            error
        );
    }
};

function generateUniqueCode() {
    const numbers = Math.floor(10 + Math.random() * 90); // 2 angka acak
    const letters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
    let result = '';
    for (let i = 0; i < 3; i++) {
        result += letters.charAt(Math.floor(Math.random() * letters.length));
    }
    return `${numbers}${result}`;
}

onMounted(() => {
    // Memulai jam reaktif yang akan update setiap 1 menit
    setInterval(() => {
        currentTime.value = new Date();
    }, 60000); 

    onAuthStateChanged(auth, async (user) => {
    isLoading.value = true;
    hasLoadedInitialData.value = false;

    Object.keys(dataFetched).forEach(key => {
        dataFetched[key] = false;
    });

    if (!user) {
        currentUser.value = null;
        userProfile.data = null;
        clearReadCacheContext();
        activePage.value = 'login';

        if (unsubscribe) {
            unsubscribe();
        }

        isLoading.value = false;
        hasLoadedInitialData.value = true;

        return;
    }

    currentUser.value = user;

    try {
        // Saat login hanya baca profil dan pengaturan inti.
        const userDocSnap = await getDoc(
            doc(
                db,
                'users',
                user.uid
            )
        );

        userProfile.data =
            userDocSnap.exists()
                ? userDocSnap.data()
                : {};

        // Satu dokumen kecil menentukan modul cache mana
        // yang masih sama dengan data server.
        await preparePersistentReadCache(
            user.uid
        );

        await fetchCoreData(user.uid);

        await setupListeners(
            user.uid,
            userProfile.data.isPartner
        );

        // Tetap buka halaman terakhir pengguna.
        changePage(activePage.value);

        if (
            userProfile.data.onboardingDone !== true
        ) {
            uiState.onboardingVisible = true;
            uiState.onboardingStep = 0;
        }
    } catch (error) {
        console.error(
            '[STARTUP] Gagal memuat data inti:',
            error
        );
    } finally {
        // Aplikasi langsung ditampilkan setelah data inti.
        // Tidak menunggu ribuan produk dan transaksi.
        isLoading.value = false;
        hasLoadedInitialData.value = true;
    }

    // Data halaman aktif dimuat di belakang layar.
    // Jangan memakai await di sini karena akan
    // mengunci tampilan aplikasi.
    Promise.resolve()
        .then(() =>
            loadDataForPage(
                activePage.value
            )
        )
        .catch(error => {
            console.error(
                `[BACKGROUND LOAD] Gagal memuat halaman "${activePage.value}":`,
                error
            );
        });
    });
});

watch(activePage, (newPage, oldPage) => {
    localStorage.setItem('lastActivePage', newPage);
    loadDataForPage(newPage);

    // --- LOGIKA BARU UNTUK LISTENER REAL-TIME ---
    if (newPage === 'langganan' && currentUser.value) {
        // Mulai mendengarkan perubahan data pengguna saat masuk ke halaman langganan
        setupUserListener(currentUser.value.uid);
    } else if (oldPage === 'langganan' && userListener) {
        // Hentikan listener saat keluar dari halaman langganan untuk hemat resource
        console.log("Keluar dari halaman langganan, listener dihentikan.");
        userListener();
        userListener = null;
    }
});


// Helper lama dipertahankan agar data/fitur historis tetap kompatibel.
// Fitur yang sudah dikeluarkan dari tampilan tidak dipanggil pada alur baru.
void [
    addPromotionTier,
    removePromotionTier,
    kpiExplanations,
    dashboardSalesStats,
    tieredDiskonComputedUpdated,
    diskonRateComputedUpdated,
    tieredDiskonNominalComputed,
    diskonNominalComputed,
    dataHealthAudit,
    layananComputed,
    admComputed,
    removeProgram,
    saveModelPromotions,
    tieredMinComputed,
    diskonMinBelanjaComputed,
    showNotesModal
];
</script>

<template>
    <!-- ONBOARDING PENGGUNA BARU -->
<div
    v-if="currentUser && uiState.onboardingVisible"
    class="fixed inset-0 z-[9999] bg-slate-950/70 backdrop-blur-sm flex items-center justify-center p-4"
>
    <div class="bg-white rounded-3xl shadow-2xl w-full max-w-3xl overflow-hidden">
        
        <!-- Header -->
        <div class="bg-slate-950 text-white p-6">
            <div class="flex items-start justify-between gap-4">
                <div>
                    <p class="text-sm text-indigo-300 font-semibold">
                        Panduan Awal Fashion OS
                    </p>
                    <h2 class="text-2xl font-bold mt-1">
                        Selamat datang di Fashion OS
                    </h2>
                    <p class="text-sm text-slate-300 mt-2">
                        Ikuti langkah singkat ini agar aplikasi siap dipakai untuk operasional toko.
                    </p>
                </div>

                <button
                    @click="finishOnboarding(true)"
                    class="text-slate-300 hover:text-white text-2xl leading-none"
                    title="Lewati"
                >
                    ×
                </button>
            </div>
        </div>

        <!-- Body -->
        <div class="p-6">
            <div class="flex items-center justify-between mb-5">
                <div>
                    <p class="text-sm font-semibold text-indigo-600">
                        Langkah {{ uiState.onboardingStep + 1 }} dari {{ onboardingSteps.length }}
                    </p>
                    <h3 class="text-2xl font-bold text-slate-800 mt-1">
                        {{ onboardingSteps[uiState.onboardingStep].title }}
                    </h3>
                </div>

                <div class="hidden sm:flex items-center gap-1">
                    <span
                        v-for="(step, index) in onboardingSteps"
                        :key="step.title"
                        class="h-2.5 rounded-full transition-all"
                        :class="index === uiState.onboardingStep ? 'w-8 bg-indigo-600' : 'w-2.5 bg-slate-300'"
                    ></span>
                </div>
            </div>

            <div class="bg-slate-50 border border-slate-200 rounded-2xl p-5">
                <p class="text-lg font-semibold text-slate-800">
                    {{ onboardingSteps[uiState.onboardingStep].subtitle }}
                </p>

                <p class="text-sm text-slate-600 leading-relaxed mt-3">
                    {{ onboardingSteps[uiState.onboardingStep].description }}
                </p>

                <button
                    @click="openOnboardingRelatedPage(onboardingSteps[uiState.onboardingStep].pageName)"
                    class="mt-5 bg-indigo-100 text-indigo-700 font-bold px-4 py-2 rounded-xl hover:bg-indigo-200"
                >
                    {{ onboardingSteps[uiState.onboardingStep].pageLabel }}
                </button>
            </div>

            <div class="grid grid-cols-1 sm:grid-cols-5 gap-3 mt-6">
                <button
                    @click="finishOnboarding(true)"
                    class="sm:col-span-1 bg-slate-100 text-slate-700 font-bold py-3 rounded-xl hover:bg-slate-200"
                >
                    Skip Semua
                </button>

                <button
                    @click="prevOnboardingStep"
                    :disabled="uiState.onboardingStep === 0"
                    class="sm:col-span-1 bg-white border border-slate-300 text-slate-700 font-bold py-3 rounded-xl hover:bg-slate-50 disabled:opacity-40"
                >
                    Kembali
                </button>

                <button
                    @click="nextOnboardingStep"
                    class="sm:col-span-3 bg-indigo-600 text-white font-bold py-3 rounded-xl hover:bg-indigo-700"
                >
                    {{ uiState.onboardingStep === onboardingSteps.length - 1 ? 'Selesai & Masuk Dashboard' : 'Lanjutkan' }}
                </button>
            </div>
        </div>
    </div>
</div>
    <div v-if="!currentUser && !isLoading" class="relative min-h-screen flex items-center justify-center bg-slate-900 overflow-hidden">
    
    <video autoplay muted loop playsinline class="absolute inset-0 w-full h-full object-cover z-0 opacity-40">
        <source src="/wallpaper.mp4?v=2" type="video/mp4"> 
        Browser Anda tidak mendukung tag video.
    </video>

    <div class="relative z-10 p-8 sm:p-10 bg-white/80 backdrop-blur-md rounded-3xl shadow-2xl w-full max-w-md text-center animate-fade-in-up">
        <h2 class="text-3xl font-bold text-gray-800 mb-2">Selamat Datang di</h2>
        <p class="text-indigo-600 text-xl font-semibold mb-8">{{ state.settings.brandName }}</p>

        <button @click="signInWithGoogle" class="w-full flex items-center justify-center bg-white border border-gray-300 hover:bg-gray-50 text-gray-700 font-semibold py-3 px-4 rounded-xl shadow-sm transition-all duration-300 transform hover:scale-105 mb-6">
            <img src="https://www.vectorlogo.zone/logos/google/google-icon.svg" alt="Google logo" class="w-6 h-6 mr-3">
            Login dengan Google
        </button>

        <div class="flex items-center my-6">
            <hr class="flex-grow border-gray-300">
            <span class="px-4 text-gray-500 text-sm">Atau</span>
            <hr class="flex-grow border-gray-300">
        </div>

        <form @submit.prevent="activePage === 'login' ? handleLogin() : handleRegister()" class="space-y-5">
            <div>
                <label for="email" class="sr-only">Alamat Email</label>
                <input type="email" id="email" v-model="authForm.email" placeholder="Alamat Email" required
                       class="w-full p-3 border border-gray-300 rounded-xl focus:ring-indigo-500 focus:border-indigo-500 text-gray-800 shadow-sm transition-all duration-200">
            </div>
            <div>
                <label for="password" class="sr-only">Password</label>
                <input type="password" id="password" v-model="authForm.password" placeholder="Password" required
                       class="w-full p-3 border border-gray-300 rounded-xl focus:ring-indigo-500 focus:border-indigo-500 text-gray-800 shadow-sm transition-all duration-200">
            </div>
            
            <div v-if="activePage === 'register'">
                <label for="activation-code" class="sr-only">Kode Aktivasi (Opsional)</label>
                <input type="text" v-model="authForm.activationCode" id="activation-code" class="w-full p-3 border border-gray-300 rounded-xl" placeholder="Kode Aktivasi (Opsional)">
            </div>

            <p v-if="authForm.error" class="text-red-600 text-sm pt-1">{{ authForm.error }}</p>

            <button type="submit" class="w-full bg-indigo-600 text-white font-bold py-3 rounded-xl hover:bg-indigo-700 transition-colors duration-300 transform hover:scale-105 shadow-lg shadow-indigo-600/30">
                <span v-if="activePage === 'login'">Login</span>
                <span v-else>Daftar Akun Baru</span>
            </button>
        </form>

        <div class="mt-6 text-sm">
            <p class="mt-3 text-gray-600">
                <span v-if="activePage === 'login'">Belum Punya Akun?</span>
                <span v-else>Sudah Punya Akun?</span>
                <button @click.prevent="changePage(activePage === 'login' ? 'register' : 'login')" class="text-indigo-600 hover:text-indigo-800 font-semibold transition-colors duration-200">
                    <span v-if="activePage === 'login'">Daftar Sekarang</span>
                    <span v-else>Login</span>
                </button>
            </p>
        </div>
    </div>
</div>
        
  <div v-if="currentUser">
    <div
        class="flex h-screen bg-slate-100 fashion-app-shell"
        :class="{ 'fashion-dark': isDarkMode }"
    >
      <!-- Sidebar -->
      <aside class="w-64 bg-gray-900 text-gray-300 flex-shrink-0 hidden md:flex md:flex-col">
    <div class="h-16 flex items-center justify-center px-4 border-b border-gray-700/50">
        <h1 class="text-xl font-bold text-white tracking-wider">{{ state.settings.brandName }}</h1>
    </div>
    
    <div class="flex-1 flex flex-col overflow-y-auto">
        <nav class="flex-1 px-2 py-4 space-y-2 overflow-y-auto">

    <a href="#" @click.prevent="changePage('dashboard')" class="sidebar-link" :class="{ 'sidebar-link-active': activePage === 'dashboard' }">
    <span class="w-6 mr-3 text-center">🏠</span>
    Dashboard
</a>

<button type="button" @click="toggleSidebarGroup('penjualan')" class="w-full sidebar-link justify-between">
    <span class="flex items-center">
        <span class="w-6 mr-3 text-center">🛒</span>
        Penjualan
    </span>
    <span>{{ uiState.sidebarGroups.penjualan ? '▲' : '▼' }}</span>
</button>

<div v-show="uiState.sidebarGroups.penjualan" class="ml-4 space-y-1">
    <a href="#" @click.prevent="changePage('bulk_process')" class="sidebar-link" :class="{ 'sidebar-link-active': activePage === 'bulk_process' }">Impor Pesanan Terkirim</a>
    <a href="#" @click.prevent="changePage('transaksi')" class="sidebar-link" :class="{ 'sidebar-link-active': activePage === 'transaksi' }">Riwayat Transaksi</a>
    <a href="#" @click.prevent="changePage('retur')" class="sidebar-link" :class="{ 'sidebar-link-active': activePage === 'retur' }">Manajemen Retur</a>
    <a href="#" @click.prevent="changePage('statistik-penjualan')" class="sidebar-link" :class="{ 'sidebar-link-active': activePage === 'statistik-penjualan' }">Statistik Penjualan</a>
</div>

<button type="button" @click="toggleSidebarGroup('produk')" class="w-full sidebar-link justify-between">
    <span class="flex items-center">
        <span class="w-6 mr-3 text-center">📦</span>
        Produk
    </span>
    <span>{{ uiState.sidebarGroups.produk ? '▲' : '▼' }}</span>
</button>

<div v-show="uiState.sidebarGroups.produk" class="ml-4 space-y-1">
    <a href="#" @click.prevent="changePage('inventaris')" class="sidebar-link" :class="{ 'sidebar-link-active': activePage === 'inventaris' }">Inventaris</a>
    <a href="#" @click.prevent="changePage('harga-hpp')" class="sidebar-link" :class="{ 'sidebar-link-active': activePage === 'harga-hpp' }">Harga & HPP</a>
</div>

<button type="button" @click="toggleSidebarGroup('produksi')" class="w-full sidebar-link justify-between">
    <span class="flex items-center">
        <span class="w-6 mr-3 text-center">🏭</span>
        Produksi
    </span>
    <span>{{ uiState.sidebarGroups.produksi ? '▲' : '▼' }}</span>
</button>

<div v-show="uiState.sidebarGroups.produksi" class="ml-4 space-y-1">
    <a href="#" @click.prevent="changePage('produksi')" class="sidebar-link" :class="{ 'sidebar-link-active': activePage === 'produksi' }">Produksi</a>
    <a href="#" @click.prevent="changePage('supplier')" class="sidebar-link" :class="{ 'sidebar-link-active': activePage === 'supplier' }">Manajemen Supplier</a>
    <a href="#" @click.prevent="changePage('gudang-kain')" class="sidebar-link" :class="{ 'sidebar-link-active': activePage === 'gudang-kain' }">Stok Kain</a>
</div>

    <button type="button" @click="toggleSidebarGroup('keuangan')" class="w-full sidebar-link justify-between">
        <span class="flex items-center">
            <span class="w-6 mr-3 text-center">💰</span>
            Keuangan
        </span>
        <span>{{ uiState.sidebarGroups.keuangan ? '▲' : '▼' }}</span>
    </button>

    <div v-show="uiState.sidebarGroups.keuangan" class="ml-4 space-y-1">
        <a href="#" @click.prevent="changePage('keuangan')" class="sidebar-link" :class="{ 'sidebar-link-active': activePage === 'keuangan' }">Keuangan</a>
        <a href="#" @click.prevent="changePage('roas-dashboard')" class="sidebar-link" :class="{ 'sidebar-link-active': activePage === 'roas-dashboard' }">Dashboard ROAS</a>
        <a href="#" @click.prevent="changePage('roas-calculator')" class="sidebar-link" :class="{ 'sidebar-link-active': activePage === 'roas-calculator' }">Kalkulator ROAS</a>
        <a href="#" @click.prevent="changePage('investasi')" class="sidebar-link" :class="{ 'sidebar-link-active': activePage === 'investasi' }">Investasi</a>
        <a href="#" @click.prevent="changePage('laporan-transaksi')" class="sidebar-link" :class="{ 'sidebar-link-active': activePage === 'laporan-transaksi' }">Laporan Transaksi</a>
        <a href="#" @click.prevent="changePage('laporan-keuangan')" class="sidebar-link" :class="{ 'sidebar-link-active': activePage === 'laporan-keuangan' }">Laporan Keuangan</a>
    </div>

    <button type="button" @click="toggleSidebarGroup('sistem')" class="w-full sidebar-link justify-between">
        <span class="flex items-center">
            <span class="w-6 mr-3 text-center">⚙️</span>
            Sistem
        </span>
        <span>{{ uiState.sidebarGroups.sistem ? '▲' : '▼' }}</span>
    </button>

    <div v-show="uiState.sidebarGroups.sistem" class="ml-4 space-y-1">
        <a v-if="userProfile.data?.isPartner" href="#" @click.prevent="changePage('mitra')" class="sidebar-link" :class="{ 'sidebar-link-active': activePage === 'mitra' }">Dashboard Mitra</a>
        <a href="#" @click.prevent="changePage('pengaturan')" class="sidebar-link" :class="{ 'sidebar-link-active': activePage === 'pengaturan' }">Pengaturan</a>
    </div>

</nav>


<div class="theme-toggle-container">
    <button
        type="button"
        class="theme-toggle-card"
        :aria-pressed="isDarkMode"
        :aria-label="isDarkMode ? 'Nonaktifkan mode gelap' : 'Aktifkan mode gelap'"
        @click="toggleDarkMode"
    >
        <span class="theme-toggle-icon" aria-hidden="true">
            <svg
                v-if="isDarkMode"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                class="h-5 w-5"
            >
                <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    d="M21 12.79A9 9 0 1111.21 3 7 7 0 0021 12.79z"
                />
            </svg>

            <svg
                v-else
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                class="h-5 w-5"
            >
                <circle cx="12" cy="12" r="4" />
                <path
                    stroke-linecap="round"
                    d="M12 2v2M12 20v2M4.93 4.93l1.42 1.42M17.66 17.66l1.41 1.41M2 12h2M20 12h2M4.93 19.07l1.42-1.42M17.66 6.34l1.41-1.41"
                />
            </svg>
        </span>

        <span class="min-w-0 flex-1 text-left">
            <span class="block text-sm font-semibold text-white">
                Mode Gelap
            </span>
            <span class="block text-xs text-gray-400">
                {{ isDarkMode ? 'Aktif • nyaman untuk malam hari' : 'Nonaktif • tampilan terang' }}
            </span>
        </span>

        <span
            class="theme-toggle-switch"
            :class="{
                'theme-toggle-switch-active':
                    isDarkMode
            }"
            aria-hidden="true"
        >
            <span class="theme-toggle-switch-knob"></span>
        </span>
    </button>
</div>


<button
    type="button"
    @click="toggleSidebarGroup('bantuan')"
    class="w-full sidebar-link justify-between"
>
    <span class="flex items-center">
        <span class="w-6 mr-3 text-center">📖</span>
        Bantuan
    </span>

    <span>
        {{ uiState.sidebarGroups.bantuan ? '▲' : '▼' }}
    </span>
</button>

<div
    v-show="uiState.sidebarGroups.bantuan"
    class="ml-4 space-y-1"
>

    <a href="#"
        @click.prevent="changePage('langganan')"
        class="sidebar-link"
        :class="{ 'sidebar-link-active': activePage === 'langganan' }">
        Langganan
    </a>

    <a href="#"
        @click.prevent="changePage('panduan-baru')"
        class="sidebar-link"
        :class="{ 'sidebar-link-active': activePage === 'panduan-baru' }">
        Panduan Pengguna Baru
    </a>

    <a href="#"
        @click.prevent="changePage('barcode-generator')"
        class="sidebar-link"
        :class="{ 'sidebar-link-active': activePage === 'barcode-generator' }">
        Panduan Barcode
    </a>

    <a href="#"
        @click.prevent="changePage('panduan')"
        class="sidebar-link"
        :class="{ 'sidebar-link-active': activePage === 'panduan' }">
        Panduan Aplikasi
    </a>

    <a href="#"
        @click.prevent="changePage('tentang')"
        class="sidebar-link"
        :class="{ 'sidebar-link-active': activePage === 'tentang' }">
        Tentang Aplikasi
    </a>

    <button
        @click="handleLogout"
        class="w-full sidebar-link text-left hover:bg-red-500/20 hover:text-red-400"
    >
        Logout
    </button>

</div>
</div>
</aside>

      <!-- Main Content -->
      <main class="flex-1 overflow-y-auto p-4 sm:p-6 md:p-8">
    
    <div v-if="isLoading" class="flex items-center justify-center h-full">
        <div class="text-center">
            <svg class="animate-spin h-10 w-10 text-indigo-600 mx-auto" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
            </svg>
            <p class="mt-4 text-lg font-semibold text-slate-700">Memuat Data dari Database...</p>
        </div>
    </div>

    <div v-else>

<div v-if="activePage === 'dashboard'">
<div v-if="state.settings.dashboardPin && isDashboardLocked" class="flex min-h-[70vh] items-center justify-center">
    <div class="w-full max-w-sm rounded-2xl border bg-white p-8 text-center shadow-xl">
        <div class="mx-auto mb-5 flex h-16 w-16 items-center justify-center rounded-full bg-indigo-100 text-2xl text-indigo-700">🔒</div>
        <h2 class="text-xl font-bold text-slate-900">Dashboard Terkunci</h2>
        <p class="mb-4 mt-2 text-sm text-slate-500">Masukkan PIN keamanan untuk melihat ringkasan bisnis.</p>
        <form @submit.prevent="unlockDashboard">
            <input type="password" v-model="dashboardPinInput" placeholder="Masukkan PIN" class="w-full rounded-lg border p-3 text-center">
            <p v-if="dashboardPinError" class="mt-2 text-sm text-red-600">{{ dashboardPinError }}</p>
            <button type="submit" class="mt-3 w-full rounded-lg bg-indigo-600 p-3 font-bold text-white">Buka Dashboard</button>
        </form>
    </div>
</div>
<div v-else class="min-h-screen w-full bg-slate-50 p-4 sm:p-8">
<div class="max-w-7xl mx-auto space-y-6">
<header class="flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between"><div><p class="text-sm font-semibold uppercase tracking-[0.18em] text-indigo-600">Fashion OS · Business Overview</p><h1 class="mt-1 text-3xl font-bold text-slate-900">Dashboard Bisnis</h1><p class="mt-2 text-sm text-slate-500">Pantau pesanan, HPP, penghasilan marketplace yang sudah cocok, dan dana yang belum cair.</p></div><div class="flex flex-wrap items-center gap-2 rounded-xl border border-slate-200 bg-white p-3">
<label class="text-sm text-slate-600" for="dashboard-period-filter">Periode transaksi</label>
<select id="dashboard-period-filter" v-model="uiState.dashboardDateFilter" class="rounded-lg border-slate-300 text-sm">
<option value="today">Hari ini</option><option value="last_7_days">7 hari terakhir</option><option value="last_30_days">30 hari terakhir</option><option value="this_year">Tahun ini</option><option value="by_date_range">Rentang tanggal</option><option value="by_month_range">Rentang bulan</option><option value="by_year_range">Rentang tahun</option><option value="all_time">Semua</option>
</select>
<div v-if="uiState.dashboardDateFilter === 'by_date_range'" class="flex items-center gap-2"><input type="date" v-model="uiState.dashboardStartDate" class="rounded-lg border-slate-300 text-sm"><span class="text-slate-400">s/d</span><input type="date" v-model="uiState.dashboardEndDate" class="rounded-lg border-slate-300 text-sm"></div>
<div v-if="uiState.dashboardDateFilter === 'by_month_range'" class="flex flex-wrap items-center gap-2">
<select v-model.number="uiState.dashboardStartMonth" class="rounded-lg border-slate-300 text-sm"><option v-for="m in 12" :key="'start-' + m" :value="m">{{ new Date(0, m - 1).toLocaleString('id-ID', { month: 'long' }) }}</option></select>
<input type="number" v-model.number="uiState.dashboardStartYear" class="w-24 rounded-lg border-slate-300 text-sm" placeholder="Tahun"><span class="text-slate-400">s/d</span>
<select v-model.number="uiState.dashboardEndMonth" class="rounded-lg border-slate-300 text-sm"><option v-for="m in 12" :key="'end-' + m" :value="m">{{ new Date(0, m - 1).toLocaleString('id-ID', { month: 'long' }) }}</option></select>
<input type="number" v-model.number="uiState.dashboardEndYear" class="w-24 rounded-lg border-slate-300 text-sm" placeholder="Tahun"></div>
<div v-if="uiState.dashboardDateFilter === 'by_year_range'" class="flex items-center gap-2"><input type="number" v-model.number="uiState.dashboardStartYear" class="w-24 rounded-lg border-slate-300 text-sm" placeholder="Dari tahun"><span class="text-slate-400">s/d</span><input type="number" v-model.number="uiState.dashboardEndYear" class="w-24 rounded-lg border-slate-300 text-sm" placeholder="Sampai tahun"></div>
</div></header>
<section class="rounded-3xl bg-slate-900 p-6 text-white shadow-lg"><div><p class="text-sm font-semibold text-indigo-200">Aktivitas pesanan hari ini</p><h2 class="mt-1 text-xl font-bold">Pesanan yang tercatat di Fashion OS</h2><p class="mt-1 text-sm text-slate-300">Penghasilan dihitung setelah data marketplace dicocokkan.</p></div><div v-if="dashboardDataLoading" class="mt-3 text-sm text-slate-300">Memuat data…</div><div class="mt-6 grid grid-cols-2 gap-3 lg:grid-cols-4"><div class="rounded-2xl bg-white/10 p-4"><p class="text-sm text-slate-300">Pesanan tercatat</p><p class="mt-2 text-2xl font-bold">{{ formatNumber(dashboardPremiumData.orderHariIni) }}</p></div><div class="rounded-2xl bg-white/10 p-4"><p class="text-sm text-slate-300">Menunggu pencocokan</p><p class="mt-2 text-2xl font-bold">{{ formatNumber(dashboardPremiumData.orderMenungguCocok) }}</p></div><div class="rounded-2xl bg-white/10 p-4"><p class="text-sm text-slate-300">Sudah cocok</p><p class="mt-2 text-2xl font-bold">{{ formatNumber(dashboardPremiumData.orderCocok) }}</p></div><div class="rounded-2xl bg-white/10 p-4"><p class="text-sm text-slate-300">Penghasilan cocok hari ini</p><p class="mt-2 text-xl font-bold">{{ formatCurrency(dashboardPremiumData.penghasilanCocok) }}</p></div></div></section>
<section><div class="mb-3"><h2 class="text-lg font-bold text-slate-900">Ringkasan periode</h2><p class="text-sm text-slate-500">Penghasilan marketplace hanya berasal dari transaksi baru yang sudah cocok.</p></div><div class="grid grid-cols-1 gap-4 sm:grid-cols-2 xl:grid-cols-4">
<article class="rounded-2xl border border-emerald-100 bg-white p-5 shadow-sm"><p class="text-sm font-medium text-slate-500">Penghasilan Bersih Marketplace</p><p class="mt-2 text-2xl font-bold text-emerald-700">{{ dashboardWorkflowMetrics.incomeComplete ? formatCurrency(dashboardWorkflowMetrics.netIncome) : 'Lengkapi ringkasan pencairan' }}</p><p class="mt-2 text-xs text-slate-400">{{ dashboardWorkflowMetrics.incomeComplete ? 'Dari penghasilan per-pesanan atau total pencairan periode yang dicatat.' : 'Ada ID sukses tanpa ringkasan total pencairan periode.' }}</p></article>
<article class="rounded-2xl border border-indigo-100 bg-white p-5 shadow-sm"><p class="text-sm font-medium text-slate-500">HPP Barang Terjual</p><p class="mt-2 text-2xl font-bold text-indigo-700">{{ formatCurrency(dashboardWorkflowMetrics.totalHpp) }}</p><p class="mt-2 text-xs text-slate-400">Modal produk yang tercatat pada transaksi.</p></article>
<article class="rounded-2xl border border-blue-100 bg-white p-5 shadow-sm"><p class="text-sm font-medium text-slate-500">Laba Bersih Usaha</p><p class="mt-2 text-2xl font-bold" :class="dashboardWorkflowMetrics.netProfit >= 0 ? 'text-blue-700' : 'text-red-600'">{{ dashboardWorkflowMetrics.incomeComplete ? formatCurrency(dashboardWorkflowMetrics.netProfit) : 'Belum lengkap' }}</p><p class="mt-2 text-xs text-slate-400">{{ dashboardWorkflowMetrics.incomeComplete ? 'Penghasilan bersih dikurangi HPP pesanan berhasil dan biaya operasional.' : 'Catat total dana dilepas agar laba tidak tampil keliru.' }}</p></article>
<article class="rounded-2xl border border-amber-100 bg-white p-5 shadow-sm"><div class="flex items-center justify-between gap-2"><p class="text-sm font-medium text-slate-500">Pesanan Belum Selesai</p><button type="button" @click="togglePendingPrivacyMode" class="rounded-full px-2 py-1 text-xs font-semibold text-amber-700 hover:bg-amber-50">{{ isPendingPrivacyMode ? 'Tampilkan' : 'Sembunyikan' }}</button></div><p class="mt-2 text-2xl font-bold text-amber-700">{{ isPendingPrivacyMode ? '••••••••' : pendingSettlementLoadError ? 'Gagal dimuat' : isSettlementLoading ? 'Memuat…' : formatNumber(dashboardWorkflowMetrics.pendingOrders) + ' pesanan' }}</p><p class="mt-2 text-xs text-slate-500">{{ isPendingPrivacyMode ? '••' : pendingSettlementLoadError ? pendingSettlementLoadError : isSettlementLoading ? 'Mengambil daftar pesanan tertunda dari server…' : formatNumber(dashboardWorkflowMetrics.pendingQty) + ' pcs · HPP tertahan ' + formatCurrency(dashboardWorkflowMetrics.pendingHpp) }}</p><p class="mt-1 text-xs text-slate-400">Pesanan di kartu ini belum dikonfirmasi sukses cair, retur, atau hilang.</p></article>
<article class="rounded-2xl border border-slate-200 bg-white p-5 shadow-sm"><p class="text-sm font-medium text-slate-500">Biaya Operasional</p><p class="mt-2 text-2xl font-bold text-slate-800">{{ formatCurrency(dashboardWorkflowMetrics.operatingCosts) }}</p><p class="mt-2 text-xs text-slate-400">Pengeluaran usaha pada periode terpilih.</p></article>
<article class="rounded-2xl border border-slate-200 bg-white p-5 shadow-sm"><p class="text-sm font-medium text-slate-500">Saldo Kas Berjalan</p><p class="mt-2 text-2xl font-bold text-slate-800">{{ formatCurrency(dashboardKpis.saldoKas) }}</p><p class="mt-2 text-xs text-slate-400">Saldo kas yang tercatat di Fashion OS.</p></article>
<article class="rounded-2xl border border-slate-200 bg-white p-5 shadow-sm"><p class="text-sm font-medium text-slate-500">Unit Stok Tersedia</p><p class="mt-2 text-2xl font-bold text-slate-800">{{ formatNumber(dashboardKpis.totalUnitStok) }} pcs</p><p class="mt-2 text-xs text-slate-400">Jumlah stok produk yang tercatat.</p></article>
<article class="rounded-2xl border border-slate-200 bg-white p-5 shadow-sm"><p class="text-sm font-medium text-slate-500">Nilai Stok (HPP)</p><p class="mt-2 text-2xl font-bold text-slate-800">{{ formatCurrency(dashboardKpis.totalNilaiStokHPP) }}</p><p class="mt-2 text-xs text-slate-400">Modal yang tertanam pada stok.</p></article>
</div></section>
<section class="grid grid-cols-1 gap-4 lg:grid-cols-2"><div class="rounded-2xl border border-slate-200 bg-white p-5 shadow-sm"><div class="flex items-center justify-between gap-3"><div><h2 class="font-bold text-slate-900">Pesanan belum cocok</h2><p class="mt-1 text-sm text-slate-500">Belum masuk perhitungan penghasilan marketplace.</p></div><span class="rounded-full bg-amber-100 px-3 py-1 text-sm font-semibold text-amber-800">{{ formatNumber(dashboardPremiumData.orderMenungguCocok) }}</span></div><p class="mt-4 text-sm text-slate-600">Cocokkan transaksi dengan data pesanan terkirim sebelum menghitung laba.</p></div><div class="rounded-2xl border border-slate-200 bg-white p-5 shadow-sm"><h2 class="font-bold text-slate-900">Stok dan produksi</h2><p class="mt-1 text-sm text-slate-500">Pantau kesiapan barang untuk pesanan berikutnya.</p><div class="mt-4 flex flex-wrap gap-3 text-sm"><span class="rounded-full bg-rose-50 px-3 py-2 text-rose-700">Stok menipis: {{ formatNumber(dashboardPremiumData.produkHampirHabis.length) }}</span><span class="rounded-full bg-indigo-50 px-3 py-2 text-indigo-700">Produksi berjalan: {{ formatNumber(dashboardPremiumData.batchBelumSelesai) }}</span><span class="rounded-full bg-amber-50 px-3 py-2 text-amber-700">Maklun terlambat: {{ formatNumber(dashboardPremiumData.maklunTerlambat) }}</span></div></div></section>
</div></div></div>

<div v-if="activePage === 'transaksi'">
    <MarketplaceTransactionHistory :transactions="state.transaksi || []" :marketplaces="state.settings.marketplaces || []" />
</div>

<div v-if="activePage === 'bulk_process'">
    <div class="mx-auto max-w-7xl space-y-6 p-4 sm:p-8">
        <MarketplaceShipmentImport
            :products="state.produk || []"
            :marketplaces="state.settings.marketplaces || []"
            :user-id="currentUser?.uid || ''"
            :subscription-active="isSubscriptionActive"
            @completed="handleMarketplaceImportCompleted"
        />
        <MarketplaceIncomeImport
            :marketplaces="state.settings.marketplaces || []"
            :user-id="currentUser?.uid || ''"
            :subscription-active="isSubscriptionActive"
            @completed="handleMarketplaceImportCompleted"
        />
    </div>
</div>

<div v-if="activePage === 'bulk_process_legacy'">
    <div class="min-h-screen w-full bg-gradient-to-br from-slate-50 via-white to-indigo-100 p-4 sm:p-8">
        <div class="max-w-7xl mx-auto">

            <div class="flex flex-wrap justify-between items-center gap-4 mb-8 animate-fade-in-up">
                <div>
                    <h2 class="text-3xl font-bold text-slate-800">Smart Scan (Proses Super Cepat)</h2>
                    <p class="text-slate-500 mt-1">Proses pesanan bervolume tinggi dengan cepat dan akurat.</p>
                </div>
                <button @click="showModal('panduanBulkProcess')" class="bg-indigo-100 text-indigo-700 font-bold py-2 px-4 rounded-lg hover:bg-indigo-200 text-sm flex items-center gap-2">
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor"><path fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clip-rule="evenodd"></path></svg>
                    Panduan
                </button>
            </div>

            <div class="grid grid-cols-1 lg:grid-cols-3 gap-8 items-start">
                
                <div class="lg:col-span-1 bg-white/70 backdrop-blur-sm p-6 rounded-2xl shadow-xl border border-slate-200 lg:sticky lg:top-8 animate-fade-in-up" style="animation-delay: 100ms;">
                    <div class="space-y-6">
                        <div>
                            <label class="block text-sm font-semibold text-slate-700 mb-2">1. Pilih Channel Penjualan</label>
                            <select v-model="uiState.activeCartChannel" @change="uiState.bulk_order_queue = []" class="w-full p-2 border border-slate-300 rounded-md shadow-sm">
                                <option :value="null" disabled>-- Pilih Channel --</option>
                                <option v-for="mp in state.settings.marketplaces" :key="mp.id" :value="mp.id">{{ mp.name }}</option>
                            </select>
                        </div>

                        <div class="border-t pt-6">
                            <label class="block text-sm font-semibold text-slate-700 mb-2">2. Input Manual (Tanpa Scanner)</label>
                            <div class="relative">
                                <input type="text" v-model="uiState.bulk_manual_input" @input="handleBulkManualSearch" :disabled="!uiState.activeCartChannel" placeholder="Ketik SKU atau ID Pesanan..." class="w-full p-3 text-lg border-2 border-slate-300 rounded-lg" autocomplete="off">
                                <div v-if="uiState.bulk_recommendations.length > 0" class="absolute w-full mt-1 bg-white border rounded-lg shadow-lg z-10">
                                    <div v-for="p in uiState.bulk_recommendations" :key="p.sku" @click="selectBulkRecommendation(p)" class="p-3 hover:bg-slate-100 cursor-pointer border-b">
                                        <p class="font-semibold text-sm">{{ p.sku }}</p>
                                        <p class="text-xs text-slate-500 mt-1">{{ p.modelNama }} - {{ p.warna }} - {{ p.varian }}</p>
                                    </div>
                                </div>
                            </div>
                            <button @click="finalizeManualOrder" :disabled="!uiState.bulk_order_queue.find(o => o.id.startsWith('TEMP-')) || !uiState.bulk_manual_input || !isSubscriptionActive" class="mt-2 w-full bg-indigo-600 text-white font-bold py-2 rounded-lg hover:bg-indigo-700 disabled:bg-gray-400">
                                Jadikan ID Pesanan
                            </button>
                        </div>

                        <div class="border-t pt-6">
    <div class="flex items-center justify-between gap-3 mb-2">
    <label class="block text-sm font-semibold text-slate-700">
        3. Salin & Tempel Massal ID Pesanan
    </label>

    <button
        type="button"
        @click="showBulkPasteInfo"
        class="text-xs bg-blue-100 text-blue-700 font-bold px-3 py-1.5 rounded-lg hover:bg-blue-200"
    >
        ℹ️ Informasi
    </button>
</div>
<div
    v-if="uiState.bulkPasteInfoVisible"
    class="mb-4 bg-blue-50 border border-blue-200 rounded-xl p-4 text-sm text-slate-700 leading-relaxed"
>
    <p class="font-bold text-blue-800 mb-2">
        Alur kerja Salin & Tempel Massal ID Pesanan
    </p>

    <ol class="list-decimal ml-5 space-y-1">
        <li>Scan ID pesanan / resi terlebih dahulu.</li>
        <li>Setelah itu scan barcode SKU produk.</li>
        <li>Jika 1 pesanan berisi 2 baju, maka urutannya: 1 ID pesanan lalu 2 SKU produk di bawahnya.</li>
        <li>Ulangi pola yang sama untuk pesanan berikutnya.</li>
        <li>Semua hasil scan bisa dimasukkan dulu ke Excel.</li>
        <li>Setelah selesai, salin semua isi kolom Excel lalu tempel ke kolom ini.</li>
        <li>Klik tombol <strong>Masukkan ke Antrian Pesanan</strong>.</li>
    </ol>

    <div class="mt-4 bg-white border border-blue-100 rounded-lg p-3 font-mono text-xs text-slate-700 whitespace-pre-line">
250628ABC001
Baju-Hitam-M
Baju-Hitam-L
250628ABC002
Baju-Putih-S
250628ABC003
Baju-merah-XS
Baju-merah-M
    </div>

    <div class="mt-4 space-y-1 text-xs text-slate-600">
        <p><strong>Keterangan:</strong></p>
        <p>- Baris yang cocok dengan SKU produk akan dianggap sebagai produk.</p>
        <p>- Baris yang tidak cocok dengan SKU produk akan dianggap sebagai ID pesanan.</p>
        <p>- Pastikan SKU hasil scan barcode sama persis dengan SKU yang ada di aplikasi.</p>
    </div>
</div>
    <textarea
        v-model="uiState.bulk_paste_input"
        :disabled="!uiState.activeCartChannel"
        rows="8"
        placeholder="Tempel data dari Excel/SHEET di sini. Contoh:
IDPESANAN001
SKU-BAJU-HITAM-M
SKU-BAJU-HITAM-L
IDPESANAN002
SKU-BAJU-PUTIH-S"
        class="w-full p-3 text-sm border-2 border-dashed border-green-500 rounded-lg resize-y"
    ></textarea>

    <div class="grid grid-cols-1 md:grid-cols-2 gap-3 mt-3">
    <button
        type="button"
        @click="validateBulkPasteOrders"
        :disabled="!uiState.activeCartChannel || !uiState.bulk_paste_input || !isSubscriptionActive"
        class="w-full bg-blue-600 text-white font-bold py-2.5 rounded-lg hover:bg-blue-700 disabled:bg-gray-400"
    >
        Validasi Data
    </button>

    <button
        type="button"
        @click="processBulkPasteOrders"
        :disabled="!uiState.bulkPasteValidation || uiState.bulkPasteValidation.hasError || !isSubscriptionActive"
        class="w-full bg-green-600 text-white font-bold py-2.5 rounded-lg hover:bg-green-700 disabled:bg-gray-400"
    >
        Masukkan ke Antrian Pesanan
    </button>
</div>

<div
    v-if="uiState.bulkPasteValidation"
    class="mt-4 rounded-xl border p-4"
    :class="uiState.bulkPasteValidation.hasError ? 'bg-red-50 border-red-200' : 'bg-green-50 border-green-200'"
>
    <div class="flex items-start justify-between gap-3">
        <div>
            <p
                class="font-bold"
                :class="uiState.bulkPasteValidation.hasError ? 'text-red-700' : 'text-green-700'"
            >
                {{ uiState.bulkPasteValidation.hasError ? 'Data masih perlu diperbaiki' : 'Data aman untuk diproses' }}
            </p>

            <p class="text-sm text-slate-600 mt-1">
                ID Pesanan: {{ uiState.bulkPasteValidation.totalOrders }} |
                Produk: {{ uiState.bulkPasteValidation.totalProducts }} |
                Baris bermasalah: {{ uiState.bulkPasteValidation.errors.length }}
            </p>
        </div>
    </div>

    <div v-if="uiState.bulkPasteValidation.orders.length" class="mt-4">
        <p class="text-xs font-bold text-slate-600 mb-2">Preview Pesanan:</p>

        <div class="max-h-48 overflow-y-auto space-y-2">
            <div
                v-for="order in uiState.bulkPasteValidation.orders"
                :key="order.marketplaceOrderId"
                class="bg-white border rounded-lg p-3 text-xs"
            >
                <p class="font-bold text-slate-700">
                    {{ order.marketplaceOrderId }}
                </p>

                <p class="text-slate-500 mt-1">
                    {{ order.items.length }} produk
                </p>

                <ul class="mt-2 list-disc ml-5 text-slate-600">
                    <li v-for="item in order.items" :key="item.sku">
                        {{ item.sku }} x {{ item.qty }}
                    </li>
                </ul>
            </div>
        </div>
    </div>

    <div v-if="uiState.bulkPasteValidation.errors.length" class="mt-4">
        <p class="text-xs font-bold text-red-700 mb-2">Yang perlu dicek:</p>

        <ul class="text-xs text-red-700 list-disc ml-5 space-y-1">
            <li v-for="(err, index) in uiState.bulkPasteValidation.errors.slice(0, 20)" :key="index">
                {{ err }}
            </li>
        </ul>
    </div>
</div>

    <p class="text-xs text-slate-500 mt-2">
        Format: ID Pesanan lalu SKU produk. Jika 1 pesanan berisi 2 baju, tempel ID pesanan lalu 2 baris SKU di bawahnya.
    </p>
</div>
                    </div>
                </div>

                <div class="lg:col-span-2 bg-white/70 backdrop-blur-sm p-6 rounded-2xl shadow-xl border border-slate-200 animate-fade-in-up" style="animation-delay: 200ms;">
                    <div class="flex justify-between items-center mb-4 pb-4 border-b border-slate-200/80">
                        <h3 class="text-xl font-semibold text-slate-800">Antrian Pesanan untuk Diproses ({{ uiState.bulk_order_queue.length }})</h3>
                        <button @click="processBatchOrders" :disabled="uiState.bulk_order_queue.length === 0 || !isSubscriptionActive" class="bg-green-600 text-white font-bold py-2 px-5 rounded-lg hover:bg-green-700 disabled:bg-slate-400 disabled:shadow-none shadow">
                            Proses Semua Antrian
                        </button>
                    </div>
                    <div class="space-y-3 max-h-[70vh] overflow-y-auto p-2 -mr-2">
                        <p v-if="uiState.bulk_order_queue.length === 0" class="text-center py-16 text-slate-400">
                            Tidak ada pesanan di antrian.
                        </p>
                        <div v-for="(order, index) in uiState.bulk_order_queue" :key="order.id" class="p-4 border rounded-lg animate-fade-in" :class="order.status === 'Mengantri' ? 'bg-white shadow-sm' : 'bg-yellow-50/50 border-yellow-300'">
                            <div class="flex justify-between items-start">
                                <div>
                                    <p class="font-bold" :class="order.status === 'Mengantri' ? 'text-indigo-700' : 'text-yellow-700'">
                                        ID Pesanan: {{ order.marketplaceOrderId }}
                                    </p>
                                </div>
                                <div class="flex gap-2">
                                    <button @click="deleteQueuedOrder(index)" class="text-xs font-semibold text-red-600 hover:underline">Hapus</button>
                                </div>
                            </div>
                            
                            <div class="mt-2 border-t border-slate-200/80 pt-2 space-y-2">
                                <div v-for="item in order.items" :key="item.sku" class="flex justify-between items-center py-2 border-b border-slate-200/50 last:border-b-0">
                                    <div>
                                        <p class="font-semibold text-sm">{{ item.nama }} ({{ item.varian }})</p>
                                        <p class="text-xs text-slate-500">{{ item.sku }}</p>
                                        <p class="text-xs text-slate-500 mt-1">Model: {{ state.settings.modelProduk.find(m => m.id === item.model_id)?.namaModel || 'N/A' }}</p>
                                    </div>
                                    
                                    <div v-if="order.status === 'Sedang Diisi'" class="flex items-center gap-2">
                                        <button @click="updateBulkQueueItemQty(item.sku, -1)" class="w-6 h-6 rounded-full bg-red-100 text-red-700 font-bold flex items-center justify-center">-</button>
                                        <span class="font-bold w-6 text-center">{{ item.qty }}</span>
                                        <button @click="updateBulkQueueItemQty(item.sku, 1)" class="w-6 h-6 rounded-full bg-green-100 text-green-700 font-bold flex items-center justify-center">+</button>
                                        <button @click="removeBulkQueueItem(item.sku)" class="ml-2 text-slate-400 hover:text-red-600 font-bold text-xl">&times;</button>
                                    </div>
                                    
                                    <div v-else class="font-bold text-slate-700">
                                        {{ item.qty }}x
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                </div>
        </div>
    </div>
</div>

<div v-if="activePage === 'produksi'">
    <div class="min-h-screen w-full bg-gradient-to-br from-slate-50 via-white to-indigo-100 p-4 sm:p-8">
        <div class="max-w-7xl mx-auto">

            <div class="bg-white/70 backdrop-blur-sm p-6 sm:p-8 rounded-2xl shadow-xl border border-slate-200 animate-fade-in-up">
                
                <div class="flex flex-wrap justify-between items-center gap-4 mb-6 pb-6 border-b border-slate-200">
                    <div class="flex items-center gap-4">
    <div>
        <h2 class="text-3xl font-bold text-slate-800">Manajemen Produksi</h2>
        
        <p class="text-slate-500 mt-1">Lacak semua batch produksi, mulai dari bahan baku hingga produk jadi.</p>
    </div>
    <button @click="showModal('produksiInfo')" class="bg-indigo-100 text-indigo-700 font-bold py-2 px-4 rounded-lg hover:bg-indigo-200 text-sm flex items-center gap-2 flex-shrink-0">
        <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor"><path fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clip-rule="evenodd" /></svg>
        Informasi
    </button>
</div>
                    <button @click="showModal('addProduksi')" class="bg-indigo-600 text-white font-bold py-2.5 px-5 rounded-lg hover:bg-indigo-700 shadow transition-colors" :disabled="!isSubscriptionActive">
    + Buat Batch Produksi
</button>
                </div>

                <div class="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
                    <div class="bg-slate-50/50 p-4 rounded-xl border">
                        <label class="block text-sm font-semibold text-slate-700 mb-2">Laporan & Analisis</label>
                        <div class="flex flex-wrap gap-2">
                            <button @click="showModal('analisisModel')" class="flex-1 text-sm bg-white border border-slate-300 text-slate-700 font-bold py-2 px-3 rounded-lg hover:bg-slate-100">Analisis Model</button>
                            <button @click="showModal('ringkasanJadi')" class="flex-1 text-sm bg-white border border-slate-300 text-slate-700 font-bold py-2 px-3 rounded-lg hover:bg-slate-100">Ringkasan Jadi</button>
                            <button @click="showModal('laporanStatus')" class="flex-1 text-sm bg-white border border-slate-300 text-slate-700 font-bold py-2 px-3 rounded-lg hover:bg-slate-100">Laporan per Status</button>
                            <button @click="showModal('laporanSemuanya')" class="flex-1 text-sm bg-emerald-600 text-white font-bold py-2 px-3 rounded-lg hover:bg-emerald-700">Laporan Semuanya</button>
                        </div>
                    </div>
                    <div class="bg-slate-50/50 p-4 rounded-xl border">
                        <label class="block text-sm font-semibold text-slate-700 mb-2">Filter & Pencarian batch produksi / kode aktual</label>
                        <div class="grid grid-cols-1 sm:grid-cols-3 gap-2">
                            <input v-model="uiState.produksiSearch" type="text" placeholder="Cari..." class="w-full p-2 border border-slate-300 rounded-md shadow-sm">
                            <select v-model="uiState.produksiFilterType" class="w-full p-2 border border-slate-300 rounded-md shadow-sm">
                                <option value="all">Semua Jenis</option>
                                <option value="pemaklun">Pemaklun</option>
                                <option value="penjahit">Penjahit</option>
                            </select>
                            <select v-model="uiState.produksiFilterStatus" class="w-full p-2 border border-slate-300 rounded-md shadow-sm">
                                <option value="all">Semua Status</option>
                                <option value="Dalam Proses">Dalam Proses</option>
                                <option value="Selesai">Selesai</option>
                                <option value="Revisi">Revisi</option>
                                <option value="Ditunda">Ditunda</option>
                            </select>
                        </div>
                    </div>
                </div>

                <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                    <p v-if="filteredProduksiBatches.length === 0" class="md:col-span-2 lg:col-span-3 text-center py-16 text-slate-500">
                        Batch produksi tidak ditemukan.
                    </p>
                    <div v-for="(batch, index) in filteredProduksiBatches" :key="batch.id" 
                         class="bg-white/80 border border-slate-200 rounded-2xl shadow-lg flex flex-col transform hover:-translate-y-1 transition-all duration-300 animate-fade-in-up"
                         :style="{ animationDelay: `${index * 50}ms` }">
                        <div class="p-5 flex-grow">
                            <div class="flex justify-between items-start">
                                <div>
                                    <p class="font-bold text-lg text-slate-800">
                                        {{ batch.produksiType === 'penjahit' ? 'Penjahit' : 'Pemaklun' }}: {{ batch.namaStatus }}
                                    </p>
                                    <p class="text-sm font-mono text-slate-500">{{ batch.id }}</p>
                                </div>
                                <span class="text-xs font-semibold px-2.5 py-1 rounded-full"
                                      :class="{
                                        'bg-green-100 text-green-800': batch.statusProses === 'Selesai',
                                        'bg-blue-100 text-blue-800': batch.statusProses === 'Dalam Proses',
                                        'bg-yellow-100 text-yellow-800': batch.statusProses === 'Revisi',
                                        'bg-gray-100 text-gray-800': batch.statusProses === 'Ditunda',
                                      }">
                                    {{ batch.statusProses }}
                                </span>
                            </div>
                            <div class="mt-4 pt-4 border-t border-slate-200/80 space-y-2 text-sm">
                                <div class="flex justify-between">
                                    <span class="text-slate-500">Tgl. Produksi:</span>
                                    <span class="font-medium">{{ new Date(batch.tanggal).toLocaleDateString('id-ID') }}</span>
                                </div>
                                <div class="flex justify-between">
                                    <span class="text-slate-500">Total Kuantitas Jadi:</span>
                                    <span class="font-medium">{{ batch.totalQty || 0 }} pcs</span>
                                </div>
                                <div class="flex justify-between">
                                    <span class="text-slate-500">Total Biaya Material:</span>
                                    <span class="font-medium">{{ formatCurrency(batch.totalBiayaMaterial) }}</span>
                                </div>
                                <div class="flex justify-between">
                                    <span class="text-slate-500">Total Biaya Jasa:</span>
                                    <span class="font-medium text-indigo-600">{{ formatCurrency(
                                        (batch.kainBahan || []).reduce((sum, item) => sum + (item.aktualJadi || 0) * (batch.produksiType === 'penjahit' ? (item.hargaJahitPerPcs || 0) : (item.hargaMaklunPerPcs || 0)), 0)
                                    ) }}</span>
                                </div>
                            </div>
                        </div>
                        <div class="p-3 bg-slate-50/50 border-t border-slate-200/80 rounded-b-2xl flex gap-2">
                            <button @click="showModal('produksiDetail', batch)" class="flex-1 text-sm bg-white border border-slate-300 text-slate-700 font-bold py-2 px-3 rounded-lg hover:bg-slate-100">Detail</button>
                            <button @click="showModal('editProduksi', batch)" class="flex-1 text-sm bg-white border border-slate-300 text-slate-700 font-bold py-2 px-3 rounded-lg hover:bg-slate-100" :disabled="!isSubscriptionActive">Edit</button>
                            <button @click="deleteProduksiBatch(batch.id)" class="flex-1 text-sm bg-red-500 text-white font-bold py-2 px-3 rounded-lg hover:bg-red-600" :disabled="!isSubscriptionActive">Hapus</button>
                        </div>
                    </div>
                </div>
                <div v-if="uiState.produksiHasMore" class="mt-8 text-center">
    <button @click="fetchProductionData(currentUser.uid, true)" class="bg-white border border-slate-300 text-slate-700 font-bold py-2 px-5 rounded-lg hover:bg-slate-100 shadow-sm transition-colors">
        Muat Lebih Banyak
    </button>
</div>
            </div>
        </div>
    </div>
</div>
<div v-if="activePage === 'inventaris'">
    <div class="min-h-screen w-full bg-gradient-to-br from-slate-50 via-white to-indigo-100 p-4 sm:p-8">
        <div class="max-w-7xl mx-auto">
            <div class="bg-white/70 backdrop-blur-sm p-6 sm:p-8 rounded-2xl shadow-xl border border-slate-200 animate-fade-in-up">
                <div class="flex flex-wrap justify-between items-center gap-4 mb-6 pb-6 border-b border-slate-200">
                    <div class="flex items-center gap-4">
                        <div>
                            <h2 class="text-3xl font-bold text-slate-800">Manajemen Inventaris</h2>
                            <p class="text-slate-500 mt-1">Kelola semua produk, varian, dan stok Anda secara terpusat.</p>
                        </div>
                        <button @click="showModal('inventarisInfo')" class="bg-indigo-100 text-indigo-700 font-bold py-2 px-4 rounded-lg hover:bg-indigo-200 text-sm">
                            Informasi
                        </button>
                    </div>

                    <div class="flex flex-wrap items-center gap-3">
                        <button
                            @click="showModal('addStockIn', { sku: '', qty: null, tipe: 'penambahan', alasan: 'Penyesuaian Inventaris' })"
                            class="bg-yellow-500 text-white font-bold py-2 px-4 rounded-lg hover:bg-yellow-600"
                            :disabled="!isSubscriptionActive"
                        >
                            Penyesuaian Stok
                        </button>
                        <button
                            @click="showModal('addProduct', { sku: '', nama: '', warna: '', varian: '', hpp: null, hargaJualDefault: null })"
                            class="bg-indigo-600 text-white font-bold py-2 px-4 rounded-lg hover:bg-indigo-700"
                            :disabled="!isSubscriptionActive"
                        >
                            + Tambah Produk Baru
                        </button>
                    </div>
                </div>

                <div class="mb-6 p-4 bg-slate-50/50 rounded-xl border">
                    <div class="grid grid-cols-1 md:grid-cols-3 gap-4">
                        <div>
                            <label class="block text-sm font-medium text-slate-700 mb-1">Cari Nama Produk</label>
                            <input type="text" v-model="uiState.inventorySearch" placeholder="Ketik nama produk..." class="w-full p-2 border border-slate-300 rounded-md">
                        </div>
                        <div>
                            <label class="block text-sm font-medium text-slate-700 mb-1">Filter Status Stok</label>
                            <select v-model="uiState.inventoryFilterStock" class="w-full p-2 border border-slate-300 rounded-md">
                                <option value="all">Semua Status</option>
                                <option value="aman">Stok Aman</option>
                                <option value="menipis">Stok Menipis</option>
                                <option value="habis">Stok Habis</option>
                            </select>
                        </div>
                        <div>
                            <label class="block text-sm font-medium text-slate-700 mb-1">Urutkan Berdasarkan</label>
                            <select v-model="uiState.inventorySort" class="w-full p-2 border border-slate-300 rounded-md">
                                <option value="nama-asc">Nama Produk (A-Z)</option>
                                <option value="nama-desc">Nama Produk (Z-A)</option>
                                <option value="stok-desc">Stok Terbanyak</option>
                                <option value="stok-asc">Stok Terendah</option>
                            </select>
                        </div>
                    </div>
                </div>

                <div class="overflow-x-auto">
                    <table class="w-full text-sm text-left">
                        <thead class="text-xs text-slate-700 uppercase bg-slate-100/50">
                            <tr>
                                <th class="px-6 py-3">Nama Model</th>
                                <th class="px-6 py-3">SKU</th>
                                <th class="px-6 py-3">Warna</th>
                                <th class="px-6 py-3">Ukuran</th>
                                <th class="px-6 py-3 text-center">Stok</th>
                                <th class="px-6 py-3 text-right">Nilai Stok (HPP)</th>
                                <th class="px-6 py-3 text-center">Aksi</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-if="inventoryProductGroups.length === 0">
                                <td colspan="7" class="text-center py-12 text-slate-500">Produk tidak ditemukan.</td>
                            </tr>

                            <template v-for="group in inventoryProductGroups" :key="group.groupKey">
                                <tr
                                    :ref="el => { if (el) groupRefs[group.groupKey] = el }"
                                    class="bg-slate-50/50 border-b border-t cursor-pointer hover:bg-slate-100/70"
                                    @click="toggleInventoryGroup(group)"
                                >
                                    <td class="px-6 py-4 font-bold text-slate-800">
                                        <div class="flex items-center">
                                            <svg
    class="mr-2 h-4 w-4 shrink-0 text-slate-500 transition-transform"
    :class="{ 'rotate-90': uiState.activeAccordion === group.groupKey }"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="2"
    aria-hidden="true"
>
    <path stroke-linecap="round" stroke-linejoin="round" d="M9 5l7 7-7 7" />
</svg>
                                            <div>
                                                {{ group.namaModel }}
                                                <span v-if="group.isLoading" class="block text-xs font-normal text-indigo-500">Memuat varian...</span>
                                                <span v-else-if="group.isLoaded" class="block text-xs font-normal text-slate-500">{{ group.variants.length }} varian</span>
                                                <span v-else class="block text-xs font-normal text-slate-400">Klik untuk membuka</span>
                                            </div>
                                        </div>
                                    </td>
                                    <td colspan="3"></td>
                                    <td class="px-6 py-3 text-center">
                                        <span v-if="group.isLoaded">{{ formatNumber(group.totalStock) }} pcs</span>
                                        <span v-else>-</span>
                                    </td>
                                    <td class="px-6 py-3 text-right">
                                        <span v-if="group.isLoaded">{{ formatCurrency(group.totalNilaiStok) }}</span>
                                        <span v-else>-</span>
                                    </td>
                                    <td class="px-6 py-3 text-center">
                                        <button
                                            @click.stop="deleteGroup(group.variants)"
                                            class="p-2 text-red-500"
                                            title="Buka grup terlebih dahulu sebelum menghapus"
                                            :disabled="!isSubscriptionActive || !group.isLoaded"
                                        >
                                            Hapus
                                        </button>
                                    </td>
                                </tr>

                                <template v-if="uiState.activeAccordion === group.groupKey">
                                    <tr v-if="group.isLoading">
                                        <td colspan="7" class="px-6 py-8 text-center text-indigo-600">Memuat varian {{ group.namaModel }}...</td>
                                    </tr>
                                    <tr v-else-if="group.error">
                                        <td colspan="7" class="px-6 py-6 text-center text-red-600">
                                            {{ group.error }}
                                            <button @click.stop="loadInventoryModelProducts(currentUser.uid, group, true)" class="ml-2 underline font-semibold">
                                                Coba Lagi
                                            </button>
                                        </td>
                                    </tr>
                                    <tr v-for="product in group.variants" :key="product.docId" class="border-b hover:bg-slate-100/70">
                                        <td class="px-6 py-3 pl-12">{{ product.nama }}</td>
                                        <td class="px-6 py-3 font-mono text-xs">{{ product.sku }}</td>
                                        <td class="px-6 py-3">{{ product.warna }}</td>
                                        <td class="px-6 py-3">{{ product.varian }}</td>
                                        <td class="px-6 py-3 text-center">{{ formatNumber(product.stokFisik) }} pcs</td>
                                        <td class="px-6 py-3 text-right">{{ formatCurrency(product.stokFisik * (product.hpp || 0)) }}</td>
                                        <td class="px-6 py-3 text-center whitespace-nowrap">
                                            <button @click.stop="removeProductVariant(product.docId)" class="mr-2 text-red-500" :disabled="!isSubscriptionActive">Hapus</button>
                                            <button @click.stop="openInventoryStock(product)" class="mr-2 text-blue-600">Kelola Stok</button>
                                            <button @click.stop="goToAturHarga(product.nama)" class="text-green-600">Atur Harga</button>
                                        </td>
                                    </tr>
                                </template>
                            </template>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</div>
<div v-if="activePage === 'harga-hpp'" class="min-h-screen w-full bg-gradient-to-br from-slate-50 via-white to-indigo-100 p-4 sm:p-8">
    <div class="mx-auto max-w-7xl">
        <section class="rounded-2xl border border-slate-200 bg-white/70 p-6 shadow-xl backdrop-blur-sm sm:p-8">
            <div class="mb-6 border-b border-slate-200 pb-6">
                <h2 class="text-3xl font-bold text-slate-800">Harga & HPP Produk</h2>
                <p class="mt-1 text-slate-500">
                    Atur HPP untuk setiap produk, warna, dan ukuran.
                </p>
            </div>

            <div v-if="isHargaHppLocked" class="mx-auto max-w-sm rounded-2xl border bg-white p-6 text-center shadow">
                <h3 class="mb-2 text-xl font-bold text-slate-800">Halaman Terkunci</h3>
                <p class="mb-4 text-sm text-slate-600">Masukkan PIN untuk membuka halaman.</p>

                <form @submit.prevent="unlockHargaHpp">
                    <input
                        type="password"
                        v-model="uiState.hargaHppPinInput"
                        placeholder="Masukkan PIN"
                        class="mb-2 w-full rounded border p-2 text-center"
                    >

                    <p v-if="uiState.hargaHppPinError" class="mb-2 text-sm text-red-600">
                        {{ uiState.hargaHppPinError }}
                    </p>

                    <button type="submit" class="w-full rounded-lg bg-indigo-600 p-2 font-bold text-white">
                        Buka
                    </button>
                </form>
            </div>

            <div v-else>
                <div class="mb-4">
                    <h3 class="text-xl font-semibold text-slate-800">Daftar HPP per Varian</h3>
                    <p class="mt-1 text-sm text-slate-500">
                        Isi HPP setiap varian. Nilai ini menjadi modal barang pada transaksi.
                    </p>
                </div>

                <div class="overflow-x-auto rounded-xl border border-slate-200 bg-white">
                    <table class="w-full min-w-[760px] text-left text-sm">
                        <thead class="bg-slate-100 text-xs uppercase text-slate-700">
                            <tr>
                                <th class="p-3">Nama Produk</th>
                                <th class="p-3">SKU</th>
                                <th class="p-3">Warna</th>
                                <th class="p-3">Ukuran</th>
                                <th class="p-3">HPP</th>
                                <th class="p-3">Aksi</th>
                            </tr>
                        </thead>

                        <tbody>
                            <tr v-if="!state.produk || state.produk.length === 0">
                                <td colspan="6" class="p-8 text-center text-slate-500">
                                    Produk belum ditemukan. Periksa halaman Inventaris.
                                </td>
                            </tr>

                            <tr
                                v-for="product in state.produk"
                                :key="product.docId || product.sku || product.nama"
                                class="border-t border-slate-200"
                            >
                                <td class="p-3 font-medium text-slate-800">{{ product.nama || '-' }}</td>
                                <td class="p-3 font-mono">{{ product.sku || '-' }}</td>
                                <td class="p-3">{{ product.warna || '-' }}</td>
                                <td class="p-3">{{ product.varian || '-' }}</td>

                                <td class="p-3">
                                    <input
                                        :value="formatInputNumber(product.hpp)"
                                        @input="product.hpp = $event.target.value.trim() === '' ? null : parseInputNumber($event.target.value); markProductAsEdited(product.docId)"
                                        class="w-36 rounded-lg border border-slate-300 p-2 text-right"
                                        inputmode="numeric"
                                        placeholder="Masukkan HPP"
                                    >
                                </td>

                                <td class="p-3">
                                    <button
                                        @click="saveData()"
                                        :disabled="isSaving || !isSubscriptionActive"
                                        class="rounded-lg bg-green-600 px-4 py-2 font-bold text-white disabled:bg-slate-300"
                                    >
                                        {{ isSaving ? 'Menyimpan...' : 'Simpan HPP' }}
                                    </button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </section>
    </div>
</div>
<div v-if="activePage === 'gudang-kain'">
    <div class="min-h-screen w-full bg-gradient-to-br from-slate-50 via-white to-indigo-100 p-4 sm:p-8">
        <div class="max-w-7xl mx-auto">

            <div class="bg-white/70 backdrop-blur-sm p-6 sm:p-8 rounded-2xl shadow-xl border border-slate-200 animate-fade-in-up">
                
                <div class="flex flex-wrap justify-between items-center gap-4 mb-6 pb-6 border-b border-slate-200">
                    <div>
                        <h2 class="text-3xl font-bold text-slate-800">Manajemen Gudang Kain</h2>
                        <p class="text-slate-500 mt-1">Kelola semua aset bahan baku kain untuk produksi Anda.</p>
                    </div>
                    <button @click="showModal('addKain', { tanggalBeli: new Date().toISOString().split('T')[0] })" class="bg-indigo-600 text-white font-bold py-2.5 px-5 rounded-lg hover:bg-indigo-700 shadow transition-colors" :disabled="!isSubscriptionActive">
    + Tambah Stok Kain Baru
</button>
                </div>

                <div class="mb-6 grid grid-cols-1 md:grid-cols-2 gap-4">
                    <div>
                        <label class="block text-sm font-medium text-slate-700 mb-1">Cari (Nama Kain, Warna, Toko)</label>
                        <input type="text" v-model="uiState.gudangKainSearch" placeholder="Ketik untuk mencari..." class="w-full p-2 border border-slate-300 rounded-md shadow-sm">
                    </div>
                    <div>
                        <label class="block text-sm font-medium text-slate-700 mb-1">Urutkan Berdasarkan</label>
                        <select v-model="uiState.gudangKainSort" class="w-full p-2 border border-slate-300 rounded-md shadow-sm">
                            <option value="tanggal-desc">Tanggal Beli (Terbaru)</option>
                            <option value="tanggal-asc">Tanggal Beli (Terlama)</option>
                            <option value="nama-asc">Nama Kain (A-Z)</option>
                            <option value="nama-desc">Nama Kain (Z-A)</option>
                            <option value="stok-desc">Sisa Yard (Terbanyak)</option>
                            <option value="stok-asc">Sisa Yard (Tersedikit)</option>
                        </select>
                    </div>
                </div>

                <div class="overflow-x-auto">
                    <table class="w-full text-sm text-left text-slate-500">
                        <thead class="text-xs text-slate-700 uppercase bg-slate-100/50">
                            <tr>
                                <th class="px-6 py-3">Tanggal Beli</th>
                                <th class="px-6 py-3">Nama Kain</th>
                                <th class="px-6 py-3">Toko</th>
                                <th class="px-6 py-3 text-center">Sisa Stok</th>
                                <th class="px-6 py-3 text-right">Harga/Yard</th>
                                <th class="px-6 py-3 text-center">Aksi</th>
                            </tr>
                        </thead>
                        <tbody class="divide-y divide-slate-200/50">
                            <tr v-if="filteredGudangKain.length === 0">
                                <td colspan="6" class="p-10 text-center text-slate-500">Tidak ada data kain yang cocok dengan filter.</td>
                            </tr>
                            <tr v-for="kain in filteredGudangKain" :key="kain.id" class="hover:bg-slate-50/50">
                                <td class="px-6 py-4 whitespace-nowrap">{{ new Date(kain.tanggalBeli).toLocaleDateString('id-ID') }}</td>
                                <td class="px-6 py-4">
                                    <p class="font-semibold text-slate-800">{{ kain.namaKain }}</p>
                                    <p class="text-xs text-slate-500">{{ kain.warna }}</p>
                                </td>
                                <td class="px-6 py-4">{{ kain.toko || '-' }}</td>
                                <td class="px-6 py-4 text-center">
                                    <span class="text-xs font-bold px-3 py-1 rounded-full"
                                          :class="{
                                            'bg-green-100 text-green-800': kain.sisaYard >= 50,
                                            'bg-yellow-100 text-yellow-800': kain.sisaYard < 50 && kain.sisaYard > 10,
                                            'bg-red-100 text-red-800': kain.sisaYard <= 10
                                          }">
                                        {{ kain.sisaYard }} Yard
                                    </span>
                                </td>
                                <td class="px-6 py-4 text-right font-medium text-green-600">{{ formatCurrency(kain.hargaBeliPerYard) }}</td>
                                <td class="px-6 py-4 text-center space-x-3">
                                    <button @click="showModal('editKain', { ...kain, tanggalBeli: new Date(kain.tanggalBeli).toISOString().split('T')[0] })" class="text-xs bg-slate-100 font-bold py-1 px-2 rounded hover:bg-slate-200" :disabled="!isSubscriptionActive">Edit</button>
                                    <button @click="deleteKain(kain.id)" class="text-xs text-red-500 hover:underline" :disabled="!isSubscriptionActive">Hapus</button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</div>

<div v-if="activePage === 'keuangan'">
    <div class="min-h-screen w-full bg-gradient-to-br from-slate-50 via-white to-indigo-100 p-4 sm:p-8">
        <div class="max-w-7xl mx-auto">

            <div class="mb-8 animate-fade-in-up">
                <div class="flex items-center gap-4">
                    <h2 class="text-3xl font-bold text-slate-800">Manajemen Keuangan</h2>
                    <button @click="uiState.isKeuanganInfoVisible = true" class="bg-indigo-100 text-indigo-700 font-bold py-2 px-4 rounded-lg hover:bg-indigo-200 text-sm flex items-center gap-2">
                        <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor"><path fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clip-rule="evenodd"></path></svg>
                        Informasi
                    </button>
                </div>
                <p class="text-slate-500 mt-1">Catat dan lacak semua arus kas operasional bisnis Anda di luar transaksi penjualan.</p>
            </div>

            <div class="grid grid-cols-1 lg:grid-cols-2 gap-8 items-start">
                
                <div class="bg-white/70 backdrop-blur-sm p-6 rounded-2xl shadow-xl border border-slate-200 animate-fade-in-up" style="animation-delay: 100ms;">
                    <div class="flex justify-between items-center mb-4 pb-4 border-b border-slate-200/80">
                        <h3 class="text-xl font-semibold text-slate-800">Riwayat Pengeluaran</h3>
                        <button @click="showModal('addBiaya', { tanggal: new Date().toISOString().split('T')[0], kategori: '', jumlah: null, catatan: '', paymentMethod: 'transfer', selectedBankAccountId: null, adminFee: 0 })" class="bg-rose-500 text-white font-bold py-1.5 px-3 rounded-md hover:bg-rose-600 text-sm shadow" :disabled="!isSubscriptionActive">Tambah Baru</button>
                    </div>
                    <div class="p-4 border-b border-slate-200/80 mb-4">
                        <div class="flex items-start gap-2">
                            <div class="flex-grow">
                                <select v-model="uiState.keuanganPengeluaranFilter" class="w-full bg-white border border-slate-300 text-sm rounded-lg p-2.5 shadow-sm capitalize">
                                     <option value="today">hari ini</option>
                                    <option value="last_7_days">1 minggu terakhir</option>
                                    <option value="last_30_days">1 bulan terakhir</option>
                                    <option value="this_year">1 tahun terakhir</option>
                                    <option value="by_date_range">rentang tanggal</option>
                                    <option value="by_month_range">rentang bulan</option>
                                    <option value="by_year_range">rentang tahun</option>
                                    <option value="all_time">semua</option>
                                </select>
                                <div v-if="uiState.keuanganPengeluaranFilter === 'by_date_range'" class="mt-2 flex items-center gap-2">
                                    <input type="date" v-model="uiState.keuanganPengeluaranStartDate" class="w-full bg-white border-slate-300 text-sm rounded-lg p-2">
                                    <span class="text-slate-500">s/d</span>
                                    <input type="date" v-model="uiState.keuanganPengeluaranEndDate" class="w-full bg-white border-slate-300 text-sm rounded-lg p-2">
                                </div>
                                <div v-if="uiState.keuanganPengeluaranFilter === 'by_month_range'" class="mt-2 flex items-center gap-2">
                                    <select v-model.number="uiState.keuanganPengeluaranStartMonth" class="w-full bg-white border-slate-300 text-sm rounded-lg p-2"><option v-for="m in 12" :key="m" :value="m">{{ new Date(0, m - 1).toLocaleString('id-ID', { month: 'long' }) }}</option></select>
                                    <input type="number" v-model.number="uiState.keuanganPengeluaranStartYear" class="w-24 border-slate-300 text-sm rounded-lg p-2">
                                    <span class="mx-2">s/d</span>
                                    <select v-model.number="uiState.keuanganPengeluaranEndMonth" class="w-full bg-white border-slate-300 text-sm rounded-lg p-2"><option v-for="m in 12" :key="m" :value="m">{{ new Date(0, m - 1).toLocaleString('id-ID', { month: 'long' }) }}</option></select>
                                    <input type="number" v-model.number="uiState.keuanganPengeluaranEndYear" class="w-24 border-slate-300 text-sm rounded-lg p-2">
                                </div>
                                <div v-if="uiState.keuanganPengeluaranFilter === 'by_year_range'" class="mt-2 flex items-center gap-2">
                                    <input type="number" v-model.number="uiState.keuanganPengeluaranStartYear" placeholder="Dari Tahun" class="w-full border-slate-300 text-sm rounded-lg p-2">
                                    <span class="text-slate-500">s/d</span>
                                    <input type="number" v-model.number="uiState.keuanganPengeluaranEndYear" placeholder="Sampai Tahun" class="w-full border-slate-300 text-sm rounded-lg p-2">
                                </div>
                            </div>
                            <button @click="requestProtectedExport(() => exportKeuangan('pengeluaran'))" class="bg-white border text-slate-700 font-bold py-2.5 px-4 rounded-lg hover:bg-slate-100 text-sm h-[42px] shadow-sm">Export</button>
                        </div>
                    </div>
                    <div class="overflow-y-auto max-h-[60vh]">
                        <table class="w-full text-sm text-left text-slate-500">
                            <thead class="text-xs text-slate-700 uppercase bg-slate-100/50 sticky top-0">
                                <tr><th class="px-4 py-3">Detail</th><th class="px-4 py-3">Catatan</th><th class="px-4 py-3 text-right">Jumlah</th><th class="px-4 py-3 text-center">Aksi</th></tr>
                            </thead>
                            <tbody class="divide-y divide-slate-200/50">
                                <tr v-if="state.keuangan.filter(k => k.jenis === 'pengeluaran').length === 0"><td colspan="4" class="p-4 text-center text-slate-500">Tidak ada data.</td></tr>
                                <tr v-for="item in riwayatPengeluaran" :key="item.id" class="hover:bg-slate-50/50">
                                    <td class="px-4 py-3 align-top">
                                        <p class="font-semibold text-slate-800">{{ item.kategori }}</p>
                                        <p class="text-xs">{{ new Date(item.tanggal).toLocaleDateString('id-ID') }}</p>
                                    </td>
                                    <td class="px-4 py-3 text-xs align-top">{{ item.catatan || '-' }}</td>
                                    <td class="px-4 py-3 font-semibold text-red-600 text-right align-top">{{ formatCurrency(item.jumlah) }}</td>
                                    <td class="px-4 py-3 text-center align-top">
                                        <button @click="deleteBiaya(item.id)" class="text-xs text-red-500 hover:underline" :disabled="!isSubscriptionActive">Hapus</button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>

                <div class="bg-white/70 backdrop-blur-sm p-6 rounded-2xl shadow-xl border border-slate-200 animate-fade-in-up" style="animation-delay: 200ms;">
                    <div v-if="uiState.isPemasukanLocked" class="flex flex-col items-center justify-center min-h-[400px] animate-fade-in">
                        <div class="w-16 h-16 bg-indigo-100 text-indigo-600 rounded-full flex items-center justify-center mb-6 mx-auto">
                           <svg xmlns="http://www.w3.org/2000/svg" class="h-8 w-8" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2"><path stroke-linecap="round" stroke-linejoin="round" d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" /></svg>
                        </div>
                        <h3 class="text-xl font-bold text-slate-800 mb-2">Riwayat Pemasukan Terkunci</h3>
                        <p class="text-sm text-slate-600 mb-4">Masukkan PIN untuk melihat data.</p>
                        <form @submit.prevent="unlockPemasukan" class="max-w-xs w-full">
                            <input type="password" v-model="uiState.pemasukanPinInput" placeholder="••••" class="w-full p-2 border rounded-md text-center text-lg mb-2">
                            <p v-if="uiState.pemasukanPinError" class="text-red-500 text-xs mb-2">{{ uiState.pemasukanPinError }}</p>
                            <button type="submit" class="mt-2 w-full bg-indigo-600 text-white font-bold py-2.5 rounded-lg hover:bg-indigo-700">Buka</button>
                        </form>
                    </div>
                    
                    <div v-else class="animate-fade-in">
                        <div class="flex justify-between items-center mb-4 pb-4 border-b border-slate-200/80">
                            <h3 class="text-xl font-semibold text-slate-800">Riwayat Pemasukan</h3>
                            <div class="flex gap-2">
                                <button @click="showModal('addPemasukan', { tanggal: new Date().toISOString().split('T')[0], kategori: 'Modal Masuk', jumlah: null, catatan: '' })" class="bg-sky-500 text-white font-bold py-1.5 px-3 rounded-md hover:bg-sky-600 text-sm shadow" :disabled="!isSubscriptionActive">Tambah Baru</button>
                                <button @click="showNestedModal('manageInflowCategories')" class="bg-slate-100 p-1 text-slate-600 rounded-md hover:bg-slate-200" title="Kelola Kategori">
                                    <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.82 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.82 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.82-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.82-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z"></path>
                                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"></path>
                                    </svg>
                                </button>
                            </div>
                        </div>
                        <div class="p-4 border-b border-slate-200/80 mb-4">
                            <div class="flex items-start gap-2">
                                <div class="flex-grow">
                                    <select v-model="uiState.keuanganPemasukanFilter" class="w-full bg-white border border-slate-300 text-sm rounded-lg p-2.5 shadow-sm capitalize">
                                        <option value="today">hari ini</option>
                                        <option value="last_7_days">1 minggu terakhir</option>
                                        <option value="last_30_days">1 bulan terakhir</option>
                                        <option value="this_year">1 tahun terakhir</option>
                                        <option value="by_date_range">rentang tanggal</option>
                                        <option value="by_month_range">rentang bulan</option>
                                        <option value="by_year_range">rentang tahun</option>
                                        <option value="all_time">semua</option>
                                    </select>
                                    <div v-if="uiState.keuanganPemasukanFilter === 'by_date_range'" class="mt-2 flex items-center gap-2">
                                        <input type="date" v-model="uiState.keuanganPemasukanStartDate" class="w-full bg-white border-slate-300 text-sm rounded-lg p-2">
                                        <span class="text-slate-500">s/d</span>
                                        <input type="date" v-model="uiState.keuanganPemasukanEndDate" class="w-full bg-white border-slate-300 text-sm rounded-lg p-2">
                                    </div>
                                    <div v-if="uiState.keuanganPemasukanFilter === 'by_month_range'" class="mt-2 flex items-center gap-2">
                                        <select v-model.number="uiState.keuanganPemasukanStartMonth" class="w-full bg-white border-slate-300 text-sm rounded-lg p-2"><option v-for="m in 12" :key="m" :value="m">{{ new Date(0, m - 1).toLocaleString('id-ID', { month: 'long' }) }}</option></select>
                                        <input type="number" v-model.number="uiState.keuanganPemasukanStartYear" class="w-24 border-slate-300 text-sm rounded-lg p-2">
                                        <span class="mx-2">s/d</span>
                                        <select v-model.number="uiState.keuanganPemasukanEndMonth" class="w-full bg-white border-slate-300 text-sm rounded-lg p-2"><option v-for="m in 12" :key="m" :value="m">{{ new Date(0, m - 1).toLocaleString('id-ID', { month: 'long' }) }}</option></select>
                                        <input type="number" v-model.number="uiState.keuanganPemasukanEndYear" class="w-24 border-slate-300 text-sm rounded-lg p-2">
                                    </div>
                                    <div v-if="uiState.keuanganPemasukanFilter === 'by_year_range'" class="mt-2 flex items-center gap-2">
                                        <input type="number" v-model.number="uiState.keuanganPemasukanStartYear" placeholder="Dari Tahun" class="w-full border-slate-300 text-sm rounded-lg p-2">
                                        <span class="text-slate-500">s/d</span>
                                        <input type="number" v-model.number="uiState.keuanganPemasukanEndYear" placeholder="Sampai Tahun" class="w-full border-slate-300 text-sm rounded-lg p-2">
                                    </div>
                                </div>
                                <button @click="requestProtectedExport(() => exportKeuangan('pemasukan'))" class="bg-white border text-slate-700 font-bold py-2.5 px-4 rounded-lg hover:bg-slate-100 text-sm h-[42px] shadow-sm">Export</button>
                            </div>
                        </div>
                        <div class="overflow-y-auto max-h-[60vh]">
                            <table class="w-full text-sm text-left text-slate-500">
                                <thead class="text-xs text-slate-700 uppercase bg-slate-100/50 sticky top-0">
                                    <tr><th class="px-4 py-3">Detail</th><th class="px-4 py-3">Catatan</th><th class="px-4 py-3 text-right">Jumlah</th><th class="px-4 py-3 text-center">Aksi</th></tr>
                                </thead>
                                <tbody class="divide-y divide-slate-200/50">
                                    <tr v-if="state.keuangan.filter(k => k.jenis === 'pemasukan_lain').length === 0"><td colspan="4" class="p-4 text-center text-slate-500">Tidak ada data.</td></tr>
                                    <tr v-for="item in riwayatPemasukan" :key="item.id" class="hover:bg-slate-50/50">
                                        <td class="px-4 py-3 align-top">
                                            <p class="font-semibold text-slate-800">{{ item.kategori }}</p>
                                            <p class="text-xs">{{ new Date(item.tanggal).toLocaleDateString('id-ID') }}</p>
                                        </td>
                                        <td class="px-4 py-3 text-xs align-top">{{ item.catatan || '-' }}</td>
                                        <td class="px-4 py-3 font-semibold text-green-600 text-right align-top">{{ formatCurrency(item.jumlah) }}</td>
                                        <td class="px-4 py-3 text-center align-top">
                                            <button @click="deletePemasukan(item.id)" class="text-xs text-red-500 hover:underline" :disabled="!isSubscriptionActive">Hapus</button>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>

            <div v-if="uiState.isKeuanganInfoVisible" class="fixed inset-0 bg-black bg-opacity-60 z-50 flex items-center justify-center p-4 animate-fade-in">
                <div class="bg-white rounded-xl shadow-xl p-6 max-w-lg w-full animate-fade-in-up">
                    <div class="flex justify-between items-start pb-4 border-b">
                        <h3 class="text-xl font-bold text-slate-800 flex items-center gap-2">
                            <svg class="w-6 h-6 text-indigo-600" fill="currentColor" viewBox="0 0 20 20"><path fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clip-rule="evenodd"></path></svg>
                            Informasi & Logika
                        </h3>
                    </div>
                    <div class="space-y-4 text-slate-700 py-4">
                        <p class="text-sm text-slate-600">Halaman ini berfungsi sebagai buku kas digital Anda. Setiap data yang Anda masukkan di sini akan secara langsung memengaruhi metrik di Dashboard Analitik.</p>
                        <div class="space-y-4">
                            <div class="p-4 bg-slate-50 rounded-lg">
                                <p class="font-semibold text-slate-700">Pemasukan & Pengeluaran</p>
                                <p class="text-sm text-slate-500 mt-1">Data dari tabel ini akan diperhitungkan dalam kalkulasi **Saldo Kas** di dasbor.</p>
                            </div>
                            <div class="p-4 bg-slate-50 rounded-lg">
                                <p class="font-semibold text-slate-700">Kategori Pengeluaran</p>
                                <p class="text-sm text-slate-500 mt-1">Semua data di sini akan diklasifikasikan sebagai **Biaya Operasional**, yang digunakan untuk menghitung **Laba Bersih** di dasbor.</p>
                            </div>
                        </div>
                    </div>
                    <div class="flex justify-end gap-3 pt-4 border-t">
                        <button @click="hideKeuanganInfoModal" class="bg-slate-200 text-slate-800 font-bold py-2 px-4 rounded-lg hover:bg-slate-300">Tutup</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div v-if="activePage === 'investasi'">
    <div class="min-h-screen w-full bg-gradient-to-br from-slate-50 via-white to-indigo-100 p-4 sm:p-8">

        <div v-if="uiState.isInvestasiLocked" class="flex items-center justify-center h-full animate-fade-in">
            <div class="bg-white/70 backdrop-blur-sm p-8 rounded-2xl shadow-xl border text-center max-w-sm w-full">
                 <div class="w-16 h-16 bg-indigo-100 text-indigo-600 rounded-full flex items-center justify-center mb-6 mx-auto">
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-8 w-8" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2"><path stroke-linecap="round" stroke-linejoin="round" d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" /></svg>
                 </div>
                <h3 class="text-xl font-bold text-slate-800 mb-2">Halaman Terkunci</h3>
                <p class="text-sm text-slate-600 mb-4">Masukkan PIN keamanan Anda untuk mengakses data investor.</p>
                <form @submit.prevent="unlockInvestasi" class="w-full">
                    <input type="password" v-model="uiState.investasiPinInput" placeholder="••••" class="w-full p-2 border border-slate-300 rounded-md text-center text-lg mb-2">
                    <p v-if="uiState.investasiPinError" class="text-red-500 text-xs mb-2">{{ uiState.investasiPinError }}</p>
                    <button type="submit" class="mt-2 w-full bg-indigo-600 text-white font-bold py-2.5 rounded-lg hover:bg-indigo-700 transition-colors">Buka Halaman</button>
                </form>
            </div>
        </div>
        
        <div v-else class="max-w-7xl mx-auto">
            <div class="mb-8 animate-fade-in-up">
                <div class="flex items-center gap-4">
    <h2 class="text-3xl font-bold text-slate-800">Manajemen Investasi</h2>
    <button @click="showModal('investorInfo')" class="bg-indigo-100 text-indigo-700 font-bold py-2 px-4 rounded-lg hover:bg-indigo-200 text-sm flex items-center gap-2">
        <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor"><path fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clip-rule="evenodd" /></svg>
        Informasi
    </button>
</div>
                <p class="text-slate-500 mt-1">Kelola data investor, laporan bagi hasil, dan riwayat pembayaran.</p>
            </div>

            <div class="space-y-8">
                <div class="bg-white/70 backdrop-blur-sm p-6 sm:p-8 rounded-2xl shadow-xl border border-slate-200 animate-fade-in-up" style="animation-delay: 100ms;">
                    <div class="flex flex-wrap justify-between items-center gap-4 mb-4">
                        <h3 class="text-xl font-bold text-slate-800">Daftar Investor</h3>
                        <div class="flex items-center gap-4">
                             <select v-model="uiState.investorStatusFilter" class="p-2 border border-slate-300 rounded-md bg-white shadow-sm text-sm">
                                <option value="aktif">Hanya Aktif</option>
                                <option value="selesai">Hanya Selesai</option>
                                <option value="semua">Tampilkan Semua</option>
                            </select>
                            <button @click="showModal('addInvestor', { name: '', amount: null, profitShare: null, startDate: new Date().toISOString().split('T')[0], status: 'aktif' })" class="bg-indigo-600 text-white font-bold py-2 px-4 rounded-lg hover:bg-indigo-700 shadow transition-colors text-sm" :disabled="!isSubscriptionActive">
    + Tambah Investor
</button>
                        </div>
                    </div>
                    <div class="overflow-x-auto">
                        <table class="w-full text-sm text-left text-slate-500">
                            <thead class="text-xs text-slate-700 uppercase bg-slate-50/50">
                                <tr>
                                    <th class="px-6 py-3">Nama Investor</th>
                                    <th class="px-6 py-3 text-center">Status</th>
                                    <th class="px-6 py-3 text-right">Modal Masuk</th>
                                    <th class="px-6 py-3 text-right">Total Bagi Hasil</th>
                                    <th class="px-6 py-3 text-right">ROI</th>
                                    <th class="px-6 py-3 text-center">Aksi</th>
                                </tr>
                            </thead>
                            <tbody class="divide-y divide-slate-200/50">
                                <tr v-if="investorLedger.length === 0">
                                    <td colspan="6" class="p-10 text-center text-slate-500">Tidak ada data investor yang cocok dengan filter.</td>
                                </tr>
                                <tr v-for="inv in investorLedger" :key="inv.id" class="hover:bg-slate-50/50">
                                    <td class="px-6 py-4">
                                        <p class="font-semibold text-slate-800">{{ inv.name }}</p>
                                        <p class="text-xs text-slate-500">Bagi Hasil: {{ inv.profitShare }}% | Mulai: {{ new Date(inv.startDate).toLocaleDateString('id-ID') }}</p>
                                    </td>
                                    <td class="px-6 py-4 text-center">
                                        <span class="text-xs font-semibold px-2.5 py-1 rounded-full capitalize"
                                                :class="inv.status === 'aktif' ? 'bg-green-100 text-green-800' : 'bg-slate-100 text-slate-800'">
                                            {{ inv.status }}
                                        </span>
                                    </td>
                                    <td class="px-6 py-4 text-right font-medium text-slate-600">{{ formatCurrency(inv.amount) }}</td>
                                    <td class="px-6 py-4 text-right font-semibold text-green-600">{{ formatCurrency(inv.totalPayout) }}</td>
                                    <td class="px-6 py-4 text-right font-bold" :class="inv.roi >= 100 ? 'text-emerald-600' : 'text-amber-600'">
                                        {{ inv.roi.toFixed(1) }}%
                                    </td>
                                    <td class="px-6 py-4 text-center space-x-2 whitespace-nowrap">
                                        <button @click="toggleInvestorStatus(inv)" class="text-xs bg-slate-100 font-bold py-1 px-2 rounded hover:bg-slate-200">Ubah Status</button>
                                        <button @click="showModal('editInvestor', inv)" class="text-xs bg-slate-100 font-bold py-1 px-2 rounded hover:bg-slate-200" :disabled="!isSubscriptionActive">Edit</button>
                                        <button v-if="inv.status === 'selesai'" @click="deleteInvestor(inv.id)" class="text-xs bg-red-100 text-red-700 font-bold py-1 px-2 rounded hover:bg-red-200" :disabled="!isSubscriptionActive">
    Hapus
</button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>

                <div class="bg-white/70 backdrop-blur-sm p-6 sm:p-8 rounded-2xl shadow-xl border border-slate-200 animate-fade-in-up" style="animation-delay: 200ms;">
                    <h3 class="text-xl font-bold text-slate-800 mb-4">Laporan Bagi Hasil Investor</h3>
                    <div class="p-4 bg-slate-50/50 rounded-xl border shadow-sm mb-6">
                         <form @submit.prevent="generateBagiHasilReport" class="grid grid-cols-1 md:grid-cols-4 gap-4 items-end">
                            <div class="md:col-span-2">
                                <label class="block text-sm font-medium text-slate-700 mb-1">Pilih Investor</label>
                                <select v-model="uiState.laporanBagiHasil.selectedInvestorId" class="w-full p-2 border border-slate-300 rounded-md">
                                    <option :value="null" disabled>-- Pilih Investor --</option>
                                    <option v-for="inv in (state.investor || [])" :key="inv.id" :value="inv.id">{{ inv.name }}</option>
                                </select>
                            </div>
                            <div>
                                <label class="block text-sm font-medium text-slate-700 mb-1">Bulan</label>
                                <select v-model.number="uiState.laporanBagiHasil.month" class="w-full p-2 border border-slate-300 rounded-md">
                                    <option v-for="m in 12" :key="m" :value="m">{{ new Date(0, m - 1).toLocaleString('id-ID', { month: 'long' }) }}</option>
                                </select>
                            </div>
                            <div>
                                <label class="block text-sm font-medium text-slate-700 mb-1">Tahun</label>
                                <input type="number" v-model.number="uiState.laporanBagiHasil.year" class="w-full p-2 border border-slate-300 rounded-md">
                            </div>
                            <div class="md:col-span-4">
                                <button type="submit" class="w-full bg-indigo-600 text-white font-bold py-3 px-4 rounded-lg hover:bg-indigo-700 transition-colors">
                                    Buat Laporan
                                </button>
                            </div>
                        </form>
                    </div>
                    <div v-if="uiState.laporanBagiHasil.result" class="p-6 bg-white rounded-xl border-2 border-indigo-500 shadow-lg animate-fade-in">
                        <div class="border-b pb-4 mb-4">
                            <h3 class="text-xl font-bold text-slate-800">Laporan Bagi Hasil untuk {{ uiState.laporanBagiHasil.result.investorName }}</h3>
                            <p class="text-slate-600">Periode: <span class="font-semibold">{{ uiState.laporanBagiHasil.result.period }}</span></p>
                        </div>
                        <div class="grid grid-cols-1 md:grid-cols-2 gap-8 text-sm">
                            <div class="space-y-2 p-4 bg-indigo-50 rounded-lg">
                                <h4 class="font-bold text-base mb-2">Pembagian Hasil</h4>
                                <div v-if="uiState.laporanBagiHasil.result.labaBersih > 0">
                                    <div class="flex justify-between"><span>Bagian Investor ({{ uiState.laporanBagiHasil.result.profitSharePercentage }}%)</span><span class="font-bold text-xl text-green-700">{{ formatCurrency(uiState.laporanBagiHasil.result.investorShare) }}</span></div>
                                    <div class="flex justify-between mt-2"><span>Bagian Perusahaan</span><span class="font-medium">{{ formatCurrency(uiState.laporanBagiHasil.result.companyShare) }}</span></div>
                                    <div class="mt-6 pt-4 border-t space-y-3">
                                        <div><label class="block text-sm font-medium">Metode Pembayaran</label><select v-model="uiState.laporanBagiHasil.paymentMethod" class="mt-1 w-full p-2 border rounded-md"><option value="transfer">Transfer Bank</option><option value="cash">Tunai (Cash)</option></select></div>
                                        <div v-if="uiState.laporanBagiHasil.paymentMethod === 'transfer'"><label class="block text-sm font-medium">Rekening Tujuan</label><select v-model="uiState.laporanBagiHasil.selectedBankAccountId" class="mt-1 w-full p-2 border rounded-md" required><option :value="null" disabled>-- Pilih Rekening --</option><option v-for="acc in state.bankAccounts" :key="acc.id" :value="acc.id">{{ acc.bankName }} - {{ acc.accountNumber }} ({{ acc.accountName }})</option></select></div>
                                        <div v-if="uiState.laporanBagiHasil.paymentMethod === 'transfer'"><label class="block text-sm font-medium">Biaya Admin Transfer (jika ada)</label><input type="number" v-model.number="uiState.laporanBagiHasil.adminFee" class="mt-1 w-full p-2 border rounded-md" placeholder="Contoh: 6500"></div>
                                    </div>
                                    <div class="flex justify-end items-center gap-3 pt-4 border-t mt-4">
                                        <button type="button" @click="uiState.laporanBagiHasil.result = null" class="bg-slate-200 text-slate-800 font-bold py-2 px-4 rounded-lg hover:bg-slate-300">Tutup</button>
                                        <button type="button" @click="recordBagiHasilPayment" class="bg-green-600 text-white font-bold py-2 px-4 rounded-lg hover:bg-green-700" :disabled="!isSubscriptionActive">Catat Pembayaran Bagi Hasil</button>
                                    </div>
                                </div>
                                <div v-else class="text-center py-8"><p class="font-semibold text-slate-700">Tidak ada keuntungan pada periode ini.</p></div>
                            </div>
                            <div class="space-y-2 p-4 bg-slate-50 rounded-lg">
                                <h4 class="font-bold text-base mb-2">Perhitungan Laba Bersih</h4>
                                <div class="flex justify-between"><span>Omset Bersih Penjualan</span> <span class="font-medium text-green-600">{{ formatCurrency(uiState.laporanBagiHasil.result.omsetBersihPenjualan) }}</span></div>
                                <div class="flex justify-between"><span>(-) Omset Bersih dari Retur</span> <span class="font-medium text-red-600">-{{ formatCurrency(uiState.laporanBagiHasil.result.omsetBersihDariRetur) }}</span></div>
                                <div class="flex justify-between font-semibold border-t pt-1"><span>= Total Omset Bersih</span> <span>{{ formatCurrency(uiState.laporanBagiHasil.result.omsetBersihFinal) }}</span></div>
                                <div class="flex justify-between mt-3"><span>(-) HPP Terjual</span> <span class="font-medium text-red-600">-{{ formatCurrency(uiState.laporanBagiHasil.result.totalHppTerjual) }}</span></div>
                                <div class="flex justify-between"><span>(-) HPP dari Retur</span> <span class="font-medium text-red-600">-{{ formatCurrency(uiState.laporanBagiHasil.result.totalHppRetur) }}</span></div>
                                <div class="flex justify-between font-semibold border-t pt-1"><span>= Total HPP</span> <span class="text-red-600">-{{ formatCurrency(uiState.laporanBagiHasil.result.hppTerjualFinal) }}</span></div>
                                <div class="flex justify-between font-bold border-t-2 pt-2 mt-2"><span>LABA KOTOR</span> <span>{{ formatCurrency(uiState.laporanBagiHasil.result.labaKotor) }}</span></div>
                                <div class="flex justify-between mt-3"><span>(-) Biaya Marketplace (Penjualan)</span> <span class="font-medium text-red-600">-{{ formatCurrency(uiState.laporanBagiHasil.result.biayaMarketplacePenjualan) }}</span></div>
                                <div class="flex justify-between"><span>(-) Biaya Marketplace (dari Retur)</span> <span class="font-medium text-red-600">-{{ formatCurrency(uiState.laporanBagiHasil.result.biayaMarketplaceBatal) }}</span></div>
                                <div class="flex justify-between font-semibold border-t pt-1"><span>= Total Biaya Marketplace</span> <span class="text-red-600">-{{ formatCurrency(uiState.laporanBagiHasil.result.totalBiayaTransaksi) }}</span></div>
                                <div class="flex justify-between mt-2">
                                    <span class="flex items-center gap-2">(-) Biaya Operasional <button @click="showModal('biayaOperasionalHelp')" type="button" class="w-5 h-5 rounded-full flex items-center justify-center bg-slate-200 text-slate-600 font-bold text-sm hover:bg-slate-300">?</button></span> 
                                    <span class="font-medium text-red-600">-{{ formatCurrency(uiState.laporanBagiHasil.result.totalBiayaOperasional) }}</span>
                                </div>
                                <div class="flex justify-between font-bold text-lg text-indigo-700 border-t-2 pt-2 mt-2">
                                    <div class="flex items-center gap-2"><span>LABA BERSIH</span><button @click="showModal('labaBersihHelp')" type="button" class="w-5 h-5 rounded-full flex items-center justify-center bg-indigo-100 text-indigo-600 font-bold text-sm hover:bg-indigo-200">?</button></div>
                                    <span>{{ formatCurrency(uiState.laporanBagiHasil.result.labaBersih) }}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="bg-white/70 backdrop-blur-sm p-6 sm:p-8 rounded-2xl shadow-xl border border-slate-200 animate-fade-in-up" style="animation-delay: 300ms;">
                    <div class="flex justify-between items-center mb-4">
                        <h3 class="text-xl font-bold text-slate-800">Riwayat Pembayaran Investor</h3>
                        <button @click="requestProtectedExport(() => exportInvestorPayments())" class="bg-blue-600 text-white font-bold py-2 px-4 rounded-lg hover:bg-blue-700 text-sm">Export</button>
                    </div>
                    <div class="mb-6 p-4 bg-slate-50/50 rounded-xl border shadow-sm">
                        <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 items-end">
                            <div>
                                <label class="block text-sm font-medium mb-1">Filter Periode</label>
                                <select v-model="uiState.investorPaymentFilter" class="w-full bg-white border-slate-300 text-sm rounded-lg p-2.5 capitalize">
                                    <option value="all_time">Semua</option>
                                    <option value="by_month_range">Bulan & Tahun</option>
                                    <option value="by_year_range">Rentang Tahun</option>
                                </select>
                            </div>
                            <div v-if="uiState.investorPaymentFilter === 'by_month_range'" class="lg:col-span-2 grid grid-cols-2 gap-2 items-end">
                                <div>
                                    <label class="block text-xs font-medium mb-1">Dari Bulan</label>
                                    <select v-model.number="uiState.investorPaymentStartMonth" class="w-full p-2 border rounded-md bg-white shadow-sm">
                                        <option v-for="m in 12" :key="m" :value="m">{{ new Date(0, m - 1).toLocaleString('id-ID', { month: 'long' }) }}</option>
                                    </select>
                                </div>
                                <div>
                                    <label class="block text-xs font-medium mb-1">Tahun</label>
                                    <input type="number" v-model.number="uiState.investorPaymentStartYear" class="w-full p-2 border rounded-md bg-white shadow-sm">
                                </div>
                                <div>
                                    <label class="block text-xs font-medium mb-1">Sampai Bulan</label>
                                    <select v-model.number="uiState.investorPaymentEndMonth" class="w-full p-2 border rounded-md bg-white shadow-sm">
                                        <option v-for="m in 12" :key="m" :value="m">{{ new Date(0, m - 1).toLocaleString('id-ID', { month: 'long' }) }}</option>
                                    </select>
                                </div>
                                <div>
                                    <label class="block text-xs font-medium mb-1">Tahun</label>
                                    <input type="number" v-model.number="uiState.investorPaymentEndYear" class="w-full p-2 border rounded-md bg-white shadow-sm">
                                </div>
                            </div>
                            <div v-if="uiState.investorPaymentFilter === 'by_year_range'" class="lg:col-span-2 grid grid-cols-2 gap-2">
                                <div>
                                    <label class="block text-sm font-medium mb-1">Dari Tahun</label>
                                    <input type="number" v-model.number="uiState.investorPaymentStartYear" placeholder="Tahun" class="w-full p-2 border rounded-md bg-white shadow-sm">
                                </div>
                                <div>
                                    <label class="block text-sm font-medium mb-1">Sampai Tahun</label>
                                    <input type="number" v-model.number="uiState.investorPaymentEndYear" placeholder="Tahun" class="w-full p-2 border rounded-md bg-white shadow-sm">
                                </div>
                            </div>
                            <div>
                                <label class="block text-sm font-medium mb-1">Cari Investor</label>
                                <input type="text" v-model="uiState.investorPaymentSearch" placeholder="Cari nama investor..." class="w-full p-2 border rounded-md bg-white shadow-sm">
                            </div>
                        </div>
                    </div>
                    <div class="overflow-x-auto">
                        <table class="w-full text-sm text-left text-slate-500">
                            <thead class="text-xs text-slate-700 uppercase bg-slate-50/50">
                                <tr>
                                    <th class="px-6 py-3">Tanggal</th>
                                    <th class="px-6 py-3">Investor</th>
                                    <th class="px-6 py-3">Periode</th>
                                    <th class="px-6 py-3 text-right">Jumlah Dibayar</th>
                                    <th class="px-6 py-3">Metode</th>
                                    <th class="px-6 py-3 text-center">Aksi</th>
                                </tr>
                            </thead>
                            <tbody class="divide-y divide-slate-200/50">
                                <tr v-if="filteredInvestorPayments.length === 0">
                                    <td colspan="6" class="p-10 text-center text-slate-500">Belum ada riwayat pembayaran yang sesuai dengan filter.</td>
                                </tr>
                                <tr v-for="p in filteredInvestorPayments" :key="p.id" class="hover:bg-slate-50/50">
                                    <td class="px-6 py-4">{{ new Date(p.paymentDate).toLocaleDateString('id-ID') }}</td>
                                    <td class="px-6 py-4 font-semibold">{{ p.investorName }}</td>
                                    <td class="px-6 py-4">{{ p.period }}</td>
                                    <td class="px-6 py-4 text-right font-medium text-green-600">{{ formatCurrency(p.totalPayment) }}</td>
                                    <td class="px-6 py-4 capitalize">{{ p.paymentMethod }}</td>
                                    <td class="px-6 py-4 text-center space-x-3">
                                        <button @click="showInvestorPaymentDetail(p)" class="text-xs font-semibold text-indigo-600 hover:underline">Detail</button>
                                        <button @click="deleteInvestorPayment(p.id)" class="text-xs font-semibold text-red-500 hover:underline">Hapus</button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>

    </div>
</div>

<div v-if="activePage === 'barcode-generator'">
    <div class="min-h-screen w-full bg-gradient-to-br from-slate-50 via-white to-indigo-100 p-4 sm:p-8">
        <div class="max-w-4xl mx-auto">
            <div class="text-center mb-12 animate-fade-in-up">
                <h2 class="text-3xl md:text-4xl font-extrabold text-slate-800">
                    <span class="bg-gradient-to-r from-indigo-600 to-purple-600 bg-clip-text text-transparent">Panduan Mencetak Barcode</span>
                </h2>
                <p class="text-lg text-slate-600 mt-4 max-w-2xl mx-auto">
                    Ikuti panduan lengkap ini untuk mencetak label barcode produk Anda menggunakan aplikasi pihak ketiga.
                </p>
            </div>
            <div class="space-y-10">
                <div class="bg-white/70 backdrop-blur-sm p-6 sm:p-8 rounded-2xl shadow-xl border border-slate-200 animate-fade-in-up" style="animation-delay: 100ms;">
                    <h3 class="text-2xl font-bold text-indigo-700 mb-4">Bagian 1: Persiapan Awal Kertas & Kalibrasi Printer</h3>
                    <div class="space-y-6">
                        <div>
                            <h4 class="text-xl font-bold text-slate-800 mb-2">Langkah 1: Membeli Kertas Label</h4>
                            <p class="text-slate-700">
                                Sebelum memulai, pastikan Anda telah membeli kertas label khusus barcode. Anda bisa mencarinya di marketplace dengan kata kunci **"label thermal 33x15mm 2 line"**. Panduan ini menggunakan ukuran tersebut sebagai contoh, namun Anda bisa menyesuaikan pengaturan di aplikasi atau PC jika Anda menggunakan ukuran lain.
                            </p>
                        </div>
                        <div>
                            <h4 class="text-xl font-bold text-slate-800 mb-2">Langkah 2: Mengkalibrasi Printer</h4>
                            <p class="text-slate-700">
                                Kalibrasi penting untuk memastikan printer mengenali ukuran kertas dan mencetak dengan presisi.
                            </p>
                            <ul class="list-disc list-inside ml-4 space-y-2 text-slate-700 mt-2">
                                <li>
                                    <p class="font-bold">Untuk Printer Xprinter XP-D4601B:</p>
                                    <ol class="list-decimal list-inside ml-4">
                                        <li>Matikan printer (posisi **OFF**).</li>
                                        <li>Tekan dan tahan tombol bulat di atas printer, lalu hidupkan printer (posisi **ON**).</li>
                                        <li>Jangan lepas tombol sampai lampu indikator berkedip merah sebanyak **lima kali**. Setelah itu, lepaskan tombol.</li>
                                        <li>Printer akan menyesuaikan diri. Untuk menguji, tekan tombol bulat satu kali. Jika printer mengeluarkan satu baris dengan dua label kosong, kalibrasi berhasil.</li>
                                    </ol>
                                </li>
                                <li>
                                    <p class="font-bold">Untuk Printer Lain:</p>
                                    <p>Silakan cari panduan kalibrasi di Google atau YouTube sesuai merek dan model printer Anda.</p>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>

                <div class="bg-white/70 backdrop-blur-sm p-6 sm:p-8 rounded-2xl shadow-xl border border-slate-200 animate-fade-in-up" style="animation-delay: 200ms;">
                    <h3 class="text-2xl font-bold text-indigo-700 mb-4">Bagian 2: Pengaturan di Aplikasi "Print Label"</h3>
                    <div class="space-y-6">
                        <div>
                            <h4 class="text-xl font-bold text-slate-800 mb-2">Langkah 1: Menginstal Aplikasi</h4>
                            <ol class="list-decimal list-inside space-y-2 text-slate-700">
                                <li>Cari aplikasi **"Print Label"** di Google Play Store.</li>
                                <li>Jika tidak dapat diinstal, coba cari dan instal dari **GetApps**.</li>
                            </ol>
                        </div>
                        <div>
                            <h4 class="text-xl font-bold text-slate-800 mb-2">Langkah 2: Menghubungkan ke Printer</h4>
                            <ol class="list-decimal list-inside space-y-2 text-slate-700">
                                <li>Di layar utama, klik **ikon gambar printer** di pojok kanan atas.</li>
                                <li>Pada halaman **"Set bluetooth connection"**, klik tombol **"Search"**.</li>
                                <li>Setelah nama printer Anda muncul, klik nama tersebut untuk menghubungkannya.</li>
                            </ol>
                        </div>
                        <div>
                            <h4 class="text-xl font-bold text-slate-800 mb-2">Langkah 3: Mengatur Ukuran Label</h4>
                            <ol class="list-decimal list-inside space-y-2 text-slate-700">
                                <li>Kembali ke menu utama dan klik **"New Label"**.</li>
                                <li>Pilih **"Gap paper"** dan **"Rectangle"**. Atur **Width** menjadi **33** mm dan **Height** menjadi **15** mm (sesuaikan jika kertas Anda berbeda).</li>
                                <li>Klik tombol **"NEW LABEL"**.</li>
                            </ol>
                        </div>
                        <div>
                            <h4 class="text-xl font-bold text-slate-800 mb-2">Langkah 4: Menambahkan Barcode</h4>
                            <ol class="list-decimal list-inside space-y-2 text-slate-700">
                                <li>Di halaman editor, klik ikon **"BarCode"** di bagian bawah.</li>
                                <li>Edit konten teks di bawah barcode dengan **SKU** produk Anda.</li>
                            </ol>
                        </div>
                        <div>
                            <h4 class="text-xl font-bold text-slate-800 mb-2">Langkah 5: Meninjau dan Mencetak</h4>
                            <ol class="list-decimal list-inside space-y-2 text-slate-700">
                                <li>Klik **"Print"**, lalu atur **"Print direction"** (0 atau 180) dan **"Print density"** (misalnya, 5)jika kurang jelas barcodenya naikan angka densitynya dan atur sesuai keinginan.</li>
                                <li>Atur **"Number of prints"** sesuai jumlah salinan yang Anda inginkan, lalu klik **"OK"**.</li>
                            </ol>
                        </div>
                    </div>
                </div>

                <div class="bg-white/70 backdrop-blur-sm p-6 sm:p-8 rounded-2xl shadow-xl border border-slate-200 animate-fade-in-up" style="animation-delay: 700ms;">
                    <h3 class="text-2xl font-bold text-indigo-700 mb-4">Bagian 3: Jika Hasil Cetak Tidak Pas</h3>
                    <p class="text-slate-600 mb-4">
                        Jika hasil cetak masih kurang presisi, Anda perlu mengatur ulang konfigurasi printer langsung dari PC atau laptop Anda.
                    </p>
                    <ol class="list-decimal list-inside space-y-4 text-slate-700">
                        <li>
                            <p class="font-bold">Buka Pengaturan Printer:</p>
                            <ul class="list-disc list-inside ml-4">
                                <li>Pada PC atau laptop Anda, buka menu **Bluetooth & devices**.</li>
                                <li>Pilih perangkat printer Anda, lalu klik **Printer properties** atau **Printing preferences**.</li>
                            </ul>
                        </li>
                        <li>
                            <p class="font-bold">Atur Ukuran Kertas di Tab "Page Setup":</p>
                            <ul class="list-disc list-inside ml-4">
                                <li>Pilih tab **Page Setup**, lalu klik tombol **New**.</li>
                                <li>Beri nama **Label_33x15mm** di kolom **Stock Name**.</li>
                                <li>Di bagian **Label size**, atur **Width** menjadi **33.0 mm** dan **Height** menjadi **15.0 mm**.</li>
                                <li>Di bagian **Exposed liner width**, atur kolom **Left** dan **Right** menjadi **2.0 mm**.</li>
                                <li>Klik **OK**.</li>
                            </ul>
                        </li>
                        <li>
                            <p class="font-bold">Atur Tipe Kertas di Tab "Stock":</p>
                            <ul class="list-disc list-inside ml-4">
                                <li>Pilih tab **Stock**.</li>
                                <li>Di bagian **Media Settings**, atur **Method** menjadi **Direct Thermal** dan **Type** menjadi **Labels with gaps**.</li>
                                <li>Atur **Gap Height** menjadi **2.0 mm** dan **Gap Offset** menjadi **0.0 mm**.</li>
                                <li>Di bagian **Media Handling**, atur **Post-Print Action** ke **Tear Off** dan **Feed Offset** ke **0.0 mm**.</li>
                            </ul>
                        </li>
                        <li>
                            <p class="font-bold">Simpan Pengaturan:</p>
                            <ul class="list-disc list-inside ml-4">
                                <li>Di bagian bawah, pastikan kotak **"Use current printer settings"** sudah dicentang.</li>
                                <li>Klik **Apply**, lalu klik **OK**.</li>
                            </ul>
                        </li>
                    </ol>
                    <p class="text-sm font-semibold text-red-600 mt-6">
                        Catatan: Disarankan memiliki printer khusus untuk cetak barcode dan printer terpisah untuk mencetak resi pengiriman agar lebih efisien dan nyaman.
                    </p>
                </div>
            </div>
        </div>
    </div>
</div>

<div v-if="activePage === 'retur'">
    <div class="min-h-screen w-full bg-gradient-to-br from-slate-50 via-white to-indigo-100 p-4 sm:p-8">
        <div class="max-w-7xl mx-auto">
            
            <div class="bg-white/70 backdrop-blur-sm p-6 sm:p-8 rounded-2xl shadow-xl border border-slate-200 animate-fade-in-up">
                
                <div class="flex flex-wrap justify-between items-center gap-4 mb-6 pb-6 border-b border-slate-200">
                    <div>
                        <h2 class="text-3xl font-bold text-slate-800">Manajemen Retur</h2>
                        <p class="text-slate-500 mt-1">Lacak dan kelola semua pengembalian produk dari pelanggan.</p>
                    </div>
                    <div class="flex items-center gap-4">
                        <button @click="showModal('panduanRetur')" class="bg-indigo-100 text-indigo-700 font-bold py-2 px-4 rounded-lg hover:bg-indigo-200 text-sm flex items-center gap-2">
                            <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor"><path fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clip-rule="evenodd" /></svg>
                            Informasi
                        </button>
                        <button @click="showModal('addRetur', { tanggal: new Date().toISOString().split('T')[0], transactionIdSearch: '', foundTransaction: null, items: [] })" class="bg-orange-500 text-white font-bold py-2 px-5 rounded-lg hover:bg-orange-600 shadow transition-colors" :disabled="!isSubscriptionActive">
                            + Tambah Retur
                        </button>
                    </div>
                </div>

                <div class="mb-6 grid grid-cols-1 md:grid-cols-2 gap-4 items-end">
                    <div class="relative">
                        <label for="retur-search" class="block text-sm font-medium text-slate-700 mb-1">Cari (ID Retur, SKU, Nama, Alasan)</label>
                        <input 
                            v-model="uiState.returPageSearchQuery"
                            @input="handleReturPageSearch"
                            type="text" 
                            id="retur-search" 
                            placeholder="Ketik untuk mencari data retur..." 
                            class="w-full p-2 border border-slate-300 rounded-md shadow-sm"
                            autocomplete="off"
                        >
                        <div v-if="uiState.returPageSearchRecommendations.length > 0" class="absolute z-10 w-full mt-1 bg-white border border-gray-200 rounded-lg shadow-lg max-h-48 overflow-y-auto">
                            <div 
                                v-for="(rec, index) in uiState.returPageSearchRecommendations" 
                                :key="index" 
                                @click="selectReturPageRecommendation(rec)" 
                                class="p-2 px-3 hover:bg-slate-100 cursor-pointer text-sm"
                            >
                                {{ rec }}
                            </div>
                        </div>
                    </div>
                    <div>
                        <label for="retur-date-filter" class="block text-sm font-medium text-slate-700 mb-1">Filter Berdasarkan Tanggal</label>
                        <div class="flex items-center gap-2">
                            <select v-model="uiState.returPageDateFilter" id="retur-date-filter" class="w-full p-2 border border-slate-300 rounded-md shadow-sm capitalize">
                                <option value="today">hari ini</option>
                                <option value="last_7_days">1 minggu terakhir</option>
                                <option value="last_30_days">1 bulan terakhir</option>
                                <option value="this_year">1 tahun terakhir</option>
                                <option value="by_date_range">rentang tanggal</option>
                                <option value="by_month_range">rentang bulan</option>
                                <option value="by_year_range">rentang tahun</option>
                                <option value="all_time">semua</option>
                            </select>
                            <button @click="requestProtectedExport(() => exportReturToExcel())" id="export-retur-btn" class="bg-green-600 text-white font-bold py-2 px-4 rounded-lg hover:bg-green-700 h-10 flex-shrink-0">Export</button>
                        </div>
                        <div v-if="uiState.returPageDateFilter === 'by_date_range'" class="mt-2 flex items-center gap-2">
                            <input type="date" v-model="uiState.returPageStartDate" class="w-full bg-white border-slate-300 text-sm rounded-lg p-2">
                            <span>s/d</span>
                            <input type="date" v-model="uiState.returPageEndDate" class="w-full bg-white border-slate-300 text-sm rounded-lg p-2">
                        </div>
                        <div v-if="uiState.returPageDateFilter === 'by_month_range'" class="mt-2 flex items-center gap-2">
                            <select v-model.number="uiState.returPageStartMonth" class="w-full bg-white border-slate-300 text-sm rounded-lg p-2"><option v-for="m in 12" :key="m" :value="m">{{ new Date(0, m - 1).toLocaleString('id-ID', { month: 'long' }) }}</option></select>
                            <input type="number" v-model.number="uiState.returPageStartYear" class="w-24 border-slate-300 text-sm rounded-lg p-2">
                            <span class="mx-2">s/d</span>
                            <select v-model.number="uiState.returPageEndMonth" class="w-full bg-white border-slate-300 text-sm rounded-lg p-2"><option v-for="m in 12" :key="m" :value="m">{{ new Date(0, m - 1).toLocaleString('id-ID', { month: 'long' }) }}</option></select>
                            <input type="number" v-model.number="uiState.returPageEndYear" class="w-24 border-slate-300 text-sm rounded-lg p-2">
                        </div>
                        <div v-if="uiState.returPageDateFilter === 'by_year_range'" class="mt-2 flex items-center gap-2">
                            <input type="number" v-model.number="uiState.returPageStartYear" placeholder="Dari Tahun" class="w-full border-slate-300 text-sm rounded-lg p-2">
                            <span class="text-slate-500">s/d</span>
                            <input type="number" v-model.number="uiState.returPageEndYear" placeholder="Sampai Tahun" class="w-full border-slate-300 text-sm rounded-lg p-2">
                        </div>
                    </div>
                </div>

                <div
                    v-if="returnHistoryLoading"
                    class="mb-3 rounded-lg border border-indigo-200 bg-indigo-50 px-4 py-3 text-sm text-indigo-700"
                >
                    Menampilkan
                    <strong>{{ returnHistoryLoadedCount }}</strong>
                    data retur. Data berikutnya sedang dimuat otomatis...
                </div>

                <div
                    v-else-if="returnHistoryMessage"
                    class="mb-3 rounded-lg border border-slate-200 bg-slate-50 px-4 py-3 text-sm text-slate-600"
                >
                    {{ returnHistoryMessage }}
                </div>

                <div
                    v-else-if="returnHistoryError"
                    class="mb-3 rounded-lg border border-red-200 bg-red-50 px-4 py-3 text-sm text-red-700"
                >
                    {{ returnHistoryError }}

                    <button
                        @click="loadReturnHistoryByCurrentFilter(currentUser.uid)"
                        class="ml-2 font-bold underline"
                    >
                        Coba Lagi
                    </button>
                </div>

                <div class="overflow-x-auto">
                    <table class="w-full text-sm text-left text-slate-500">
                        <thead class="text-xs text-slate-700 uppercase bg-slate-100/50">
    <tr>
        <th class="px-6 py-3">Tanggal</th>
        
        <th class="px-6 py-3">ID Pesanan</th> 
        
        <th class="px-6 py-3">Asal Toko</th>
        <th class="px-6 py-3">Produk</th>
        <th class="px-6 py-3 text-center">Qty</th>
        <th class="px-6 py-3">Alasan</th>
        <th class="px-6 py-3 text-center">Aksi</th>
    </tr>
</thead>
                        <tbody class="divide-y divide-slate-200/50">
                            <tr v-if="!returnHistoryLoading && filteredRetur.length === 0">
                                <td colspan="6" class="p-10 text-center text-slate-500">Tidak ada data retur yang sesuai dengan filter.</td>
                            </tr>
                            <tr v-for="(item, index) in filteredRetur" :key="`${item.returnDocId}-${item.sku}-${index}`" class="hover:bg-slate-50/50">
    <td class="px-6 py-4 whitespace-nowrap">{{ new Date(item.tanggal).toLocaleDateString('id-ID') }}</td>
    
    <td class="px-6 py-4 font-mono text-xs font-bold text-indigo-600">
        {{ getTransactionDisplayId(item.originalTransactionId) }}
    </td>

    <td class="px-6 py-4">{{ getMarketplaceById(item.channelId)?.name || 'N/A' }}</td>
                                <td class="px-6 py-4">
                                    <p class="font-semibold text-slate-800">{{ getProductBySku(item.sku)?.nama || 'Produk tidak ditemukan' }}</p>
                                    <p class="font-mono text-xs text-slate-500">{{ item.sku }}</p>
                                </td>
                                <td class="px-6 py-4 font-medium text-center">{{ item.qty }}</td>
                                <td class="px-6 py-4">{{ item.alasan }}</td>
                                <td class="px-6 py-4 text-center space-x-2">
                                    <button @click="deleteReturnItem(item)" class="text-xs text-red-500 hover:underline" :disabled="!isSubscriptionActive">Hapus</button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>

            </div>
        </div>
    </div>
</div>

<div v-if="activePage === 'mitra'">
    <div class="min-h-screen w-full bg-gradient-to-br from-slate-50 via-white to-indigo-100 p-4 sm:p-8">
        
        <div v-if="currentUser && !userProfile.data?.isPartner" class="flex items-center justify-center h-full animate-fade-in">
            <div class="bg-white p-8 rounded-2xl shadow-xl border text-center max-w-md">
                <h3 class="text-2xl font-bold text-slate-800 mb-4">Jadilah Mitra & Dapatkan Penghasilan</h3>
                <p class="text-slate-600 mb-6">Dapatkan komisi dari setiap pelanggan yang Anda ajak. Jadilah bagian dari tim kami untuk mengembangkan Fashion OS bersama.</p>
                <button @click="showModal('registerPartner')" class="w-full bg-indigo-600 text-white font-bold py-3 rounded-lg hover:bg-indigo-700 transition-colors shadow-lg shadow-indigo-600/30">
                    Daftar Menjadi Mitra
                </button>
            </div>
        </div>
        
        <div v-else-if="userProfile.data?.isPartner" class="max-w-7xl mx-auto">
            <div class="flex justify-between items-center mb-8 animate-fade-in-up">
    <div>
        <h2 class="text-3xl font-bold text-slate-800">Dashboard Mitra</h2>
        <p class="text-slate-500 mt-1">Pantau kinerja dan penghasilan Anda di sini.</p>
    </div>
    <a :href="`https://wa.me/${nomorWhatsAppAdmin}`" target="_blank" class="bg-green-500 text-white font-bold py-2 px-4 rounded-lg hover:bg-green-600 transition-colors shadow-lg flex items-center gap-2">
        <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" viewBox="0 0 24 24" fill="currentColor"><path d="M.057 24l1.687-6.163c-1.041-1.804-1.588-3.849-1.587-5.946.003-6.556 5.338-11.891 11.893-11.891 3.181.001 6.167 1.24 8.413 3.488 2.245 2.248 3.487 5.235 3.487 8.413 0 6.557-5.338 11.892-11.894 11.892-1.99 0-3.903-.52-5.687-1.475L.057 24zm6.597-3.807c1.676.995 3.276 1.591 5.392 1.592 5.448 0 9.886-4.434 9.889-9.885.002-5.462-4.415-9.89-9.881-9.892-5.452 0-9.887 4.434-9.889 9.886-.001 2.267.655 4.398 1.905 6.344l-1.332 4.869 4.869-1.332z"/></svg>
        Hubungi Admin
    </a>
</div>
            
            <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-6 mb-8">
                <!-- Kolom Kode Rujukan -->
                <div class="bg-white/70 backdrop-blur-sm p-5 rounded-xl shadow-lg border border-slate-200 animate-fade-in-up flex flex-col justify-center" style="animation-delay: 100ms;">
                    <h4 class="text-sm font-medium text-slate-500">Kode Rujukan Anda</h4>
                    <p class="font-mono font-bold text-indigo-600 mt-2 break-all" :style="{ fontSize: 'clamp(1rem, 1.8vw, 1.5rem)' }">{{ userProfile.data.referralCode }}</p>
                </div>

                <!-- Kolom Total Pendapatan -->
                <div class="bg-white/70 backdrop-blur-sm p-5 rounded-xl shadow-lg border border-slate-200 flex items-start gap-4 animate-fade-in-up" style="animation-delay: 200ms;">
                    <div class="bg-indigo-100 text-indigo-600 p-3 rounded-lg flex-shrink-0">
                        <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2"><path stroke-linecap="round" stroke-linejoin="round" d="M11.049 2.927c.3-.921 1.603-.921 1.902 0l1.519 4.674a1 1 0 00.95.69h4.915c.969 0 1.371 1.24.588 1.81l-3.976 2.888a1 1 0 00-.363 1.118l1.518 4.674c.3.922-.755 1.688-1.538 1.118l-3.976-2.888a1 1 0 00-1.176 0l-3.976 2.888c-.783.57-1.838-.197-1.538-1.118l1.518-4.674a1 1 0 00-.363-1.118l-3.976-2.888c-.783-.57-.38-1.81.588-1.81h4.914a1 1 0 00.951-.69l1.519-4.674z" /></svg>
                    </div>
                    <div class="min-w-0">
                        <h4 class="text-sm font-medium text-slate-500">Total Pendapatan</h4>
                        <p class="font-bold text-slate-800 mt-1" :style="{ fontSize: 'clamp(1rem, 1.8vw, 1.5rem)' }">{{ formatCurrency(totalRevenue) }}</p>
                    </div>
                </div>

                <!-- Kolom Tersedia untuk Dicairkan -->
                <div class="bg-white/70 backdrop-blur-sm p-5 rounded-xl shadow-lg border border-slate-200 flex items-start gap-4 animate-fade-in-up" style="animation-delay: 300ms;">
                    <div class="bg-green-100 text-green-600 p-3 rounded-lg flex-shrink-0">
                        <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2"><path stroke-linecap="round" stroke-linejoin="round" d="M17 9V7a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2m2 4h10a2 2 0 002-2v-6a2 2 0 00-2-2H9a2 2 0 00-2 2v6a2 2 0 002 2zm7-5a2 2 0 11-4 0 2 2 0 014 0z" /></svg>
                    </div>
                    <div class="min-w-0">
                        <h4 class="text-sm font-medium text-slate-500">Tersedia Dicairkan</h4>
                        <p class="font-bold text-green-600 mt-1" :style="{ fontSize: 'clamp(1rem, 1.8vw, 1.5rem)' }">{{ formatCurrency(availableForWithdrawal) }}</p>
                    </div>
                </div>
                
                <!-- Kolom Sedang Diproses -->
                <div class="bg-white/70 backdrop-blur-sm p-5 rounded-xl shadow-lg border border-slate-200 flex items-start gap-4 animate-fade-in-up" style="animation-delay: 400ms;">
                    <div class="bg-yellow-100 text-yellow-600 p-3 rounded-lg flex-shrink-0">
                        <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2"><path stroke-linecap="round" stroke-linejoin="round" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" /></svg>
                    </div>
                    <div class="min-w-0">
                        <h4 class="text-sm font-medium text-slate-500">Sedang Diproses</h4>
                        <p class="font-bold text-yellow-600 mt-1" :style="{ fontSize: 'clamp(1rem, 1.8vw, 1.5rem)' }">{{ formatCurrency(totalProcessingCommission) }}</p>
                    </div>
                </div>

                <!-- Kolom Sudah Dicairkan -->
                <div class="bg-white/70 backdrop-blur-sm p-5 rounded-xl shadow-lg border border-slate-200 flex items-start gap-4 animate-fade-in-up" style="animation-delay: 500ms;">
                    <div class="bg-cyan-100 text-cyan-600 p-3 rounded-lg flex-shrink-0">
                        <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2"><path stroke-linecap="round" stroke-linejoin="round" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" /></svg>
                    </div>
                    <div class="min-w-0">
                        <h4 class="text-sm font-medium text-slate-500">Sudah Dicairkan</h4>
                        <p class="font-bold text-slate-800 mt-1" :style="{ fontSize: 'clamp(1rem, 1.8vw, 1.5rem)' }">{{ formatCurrency(totalWithdrawn) }}</p>
                    </div>
                </div>
            </div>
            
            <div class="bg-white/70 backdrop-blur-sm p-6 rounded-2xl shadow-xl border border-slate-200 animate-fade-in-up" style="animation-delay: 600ms;">
                 <div class="flex justify-between items-center mb-4">
                    <h3 class="text-lg font-semibold text-slate-800">Riwayat Komisi (Siap Dicairkan)</h3>
                    <button @click="handleCashoutRequest" :disabled="totalUnpaidCommission === 0 || isSaving" class="bg-green-600 text-white font-bold py-2 px-4 rounded-lg text-sm shadow-lg shadow-green-500/20 hover:bg-green-700 transition-colors disabled:bg-slate-400 disabled:shadow-none">
                        <span v-if="isSaving">Mengajukan...</span>
                        <span v-else>Cairkan Semua Komisi</span>
                    </button>
                </div>
                <div class="overflow-x-auto">
                    <table class="w-full text-sm text-left text-slate-500">
                         <thead class="text-xs text-slate-700 uppercase bg-slate-50/50">
                            <tr>
                                <th class="px-6 py-3">Tanggal</th>
                                <th class="px-6 py-3">Pelanggan Rujukan</th>
                                <th class="px-6 py-3 text-right">Jumlah Komisi</th>
                                <th class="px-6 py-3 text-center">Status</th>
                            </tr>
                        </thead>
                        <tbody class="divide-y divide-slate-200/50">
                            <tr v-if="unpaidCommissions.length === 0">
                                <td colspan="4" class="p-10 text-center text-slate-500">Tidak ada komisi yang siap dicairkan.</td>
                            </tr>
                            <tr v-for="com in unpaidCommissions" :key="com.id" class="hover:bg-slate-50/50">
                                <td class="px-6 py-4">{{ new Date(com.createdAt.seconds * 1000).toLocaleDateString('id-ID') }}</td>
                                <td class="px-6 py-4">{{ com.referredUserEmail }}</td>
                                <td class="px-6 py-4 text-right font-bold text-green-600">{{ formatCurrency(com.commissionAmount) }}</td>
                                <td class="px-6 py-4 text-center">
                                    <span class="text-xs font-semibold px-2 py-0.5 rounded-full bg-yellow-100 text-yellow-800 capitalize">{{ com.status }}</span>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>

            <div class="mt-8 bg-white/70 backdrop-blur-sm p-6 rounded-2xl shadow-xl border border-slate-200 animate-fade-in-up" style="animation-delay: 700ms;">
                 <h3 class="text-lg font-semibold text-slate-800 mb-4">Pencairan Sedang Diproses</h3>
                <div class="overflow-x-auto">
                    <table class="w-full text-sm text-left text-slate-500">
                        <thead class="text-xs text-slate-700 uppercase bg-slate-50/50">
    <tr>
        <th class="px-6 py-3">Tanggal Pengajuan</th>
        <th class="px-6 py-3">ID Pencairan</th> <th class="px-6 py-3">Pelanggan Rujukan</th>
        <th class="px-6 py-3 text-right">Jumlah Komisi</th>
        <th class="px-6 py-3 text-center">Status</th>
    </tr>
</thead>
                        <tbody class="divide-y divide-slate-200/50">
                            <tr v-if="processingCommissions.length === 0">
                                <td colspan="4" class="p-10 text-center text-slate-500">Tidak ada pencairan yang sedang diproses.</td>
                            </tr>
                            <tr v-for="com in processingCommissions" :key="com.id" class="hover:bg-slate-50/50">
    <td class="px-6 py-4">{{ new Date(com.createdAt.seconds * 1000).toLocaleDateString('id-ID') }}</td>
    <td class="px-6 py-4 font-mono text-xs">{{ com.withdrawalId }}</td> <td class="px-6 py-4">{{ com.referredUserEmail }}</td>
    <td class="px-6 py-4 text-right font-bold text-yellow-600">{{ formatCurrency(com.commissionAmount) }}</td>
    <td class="px-6 py-4 text-center">
        <span class="text-xs font-semibold px-2 py-0.5 rounded-full bg-yellow-100 text-yellow-800">Processing</span>
    </td>
</tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</div>

<div v-if="activePage === 'laporan-transaksi'" class="min-h-screen bg-gradient-to-br from-slate-50 via-white to-blue-100 p-4 sm:p-8">
<div v-if="isLaporanTransaksiLocked" class="mx-auto mt-16 max-w-sm rounded-2xl border bg-white p-8 text-center shadow-xl"><h3 class="text-xl font-bold">Halaman Terkunci</h3><p class="my-3 text-sm text-slate-600">Masukkan PIN keamanan Anda untuk membuka.</p><form @submit.prevent="unlockLaporanTransaksi"><input type="password" v-model="uiState.laporanTransaksiPinInput" placeholder="••••" class="w-full rounded-md border p-2 text-center text-lg"><p v-if="uiState.laporanTransaksiPinError" class="my-2 text-xs text-red-600">{{ uiState.laporanTransaksiPinError }}</p><button type="submit" class="mt-2 w-full rounded-lg bg-indigo-600 py-2.5 font-bold text-white">Buka</button></form></div>
<div v-else class="mx-auto max-w-7xl space-y-5"><header class="flex flex-wrap items-end justify-between gap-4"><div><p class="text-sm font-semibold uppercase tracking-wide text-indigo-600">Operasional</p><h2 class="text-3xl font-bold">Laporan Transaksi</h2><p class="mt-1 text-sm text-slate-600">Ringkasan pesanan berdasarkan tanggal terkirim. Total pencairan marketplace ada di Laporan Keuangan.</p></div><label class="text-sm font-medium">Tahun <input type="number" v-model.number="uiState.laporanTransaksiTahun" class="ml-2 w-28 rounded-md border p-2"></label></header>
<div class="overflow-x-auto rounded-2xl border bg-white shadow-sm"><table class="w-full min-w-[760px] text-left text-sm"><thead class="bg-slate-50 text-xs uppercase text-slate-500"><tr><th class="p-4">Bulan</th><th class="p-4 text-right">Pesanan diproses</th><th class="p-4 text-right">Qty tercatat</th><th class="p-4 text-right">HPP transaksi</th><th class="p-4 text-right">Dana dikonfirmasi</th><th class="p-4 text-right">Belum selesai</th></tr></thead><tbody class="divide-y"><tr v-for="month in laporanTransaksiData.months" :key="month.monthName"><td class="p-4 font-semibold capitalize">{{ month.monthName }}</td><td class="p-4 text-right">{{ formatNumber(month.totalOrders) }}</td><td class="p-4 text-right">{{ formatNumber(month.totalQty) }} pcs</td><td class="p-4 text-right">{{ formatCurrency(month.totalHpp) }}</td><td class="p-4 text-right text-emerald-700">{{ formatNumber(month.successfulOrders) }}</td><td class="p-4 text-right text-amber-700">{{ formatNumber(month.pendingOrders) }}</td></tr></tbody><tfoot class="border-t-2 bg-slate-50 font-bold"><tr><td class="p-4">TOTAL {{ uiState.laporanTransaksiTahun }}</td><td class="p-4 text-right">{{ formatNumber(laporanTransaksiData.yearlyTotals.totalOrders) }}</td><td class="p-4 text-right">{{ formatNumber(laporanTransaksiData.yearlyTotals.totalQty) }} pcs</td><td class="p-4 text-right">{{ formatCurrency(laporanTransaksiData.yearlyTotals.totalHpp) }}</td><td class="p-4 text-right">{{ formatNumber(laporanTransaksiData.yearlyTotals.successfulOrders) }}</td><td class="p-4 text-right">{{ formatNumber(laporanTransaksiData.yearlyTotals.pendingOrders) }}</td></tr></tfoot></table></div>
<p class="rounded-lg bg-indigo-50 p-3 text-xs text-indigo-900">Transaksi tetap tersimpan setelah antrean scan dibersihkan. Ringkasan ini menghitung data operasional dan HPP; total dana marketplace tidak dibagi ke setiap pesanan.</p></div></div>

<div v-if="activePage === 'roas-dashboard'" class="min-h-screen w-full bg-gradient-to-br from-slate-50 via-white to-blue-100 p-4 sm:p-8">
    <div class="max-w-7xl mx-auto animate-fade-in-up">

        <div class="mb-8">
            <h2 class="text-3xl font-bold text-slate-800">Dashboard ROAS Iklan</h2>
            <p class="text-slate-500 mt-1">
                Pantau performa iklan berdasarkan data POS, HPP produk, biaya marketplace, dan anggaran iklan.
            </p>
        </div>

        <div class="bg-white p-6 rounded-2xl shadow border border-slate-200 mb-6">
            <h3 class="text-lg font-bold text-slate-800 mb-4">Filter & Anggaran</h3>

            <div class="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-5 gap-4">
                <div>
                    <label class="block text-sm font-medium text-slate-700">Periode</label>
                    <select v-model="uiState.roasDashboard.dateFilter" class="mt-1 w-full p-2 border rounded-lg">
                        <option value="today">Hari Ini</option>
                        <option value="last_7_days">7 Hari Terakhir</option>
                        <option value="last_30_days">30 Hari Terakhir</option>
                        <option value="this_month">Bulan Ini</option>
                        <option value="all_time">Semua Data</option>
                    </select>
                </div>

<div>
    <label class="block text-sm font-medium text-slate-700">Channel Penjualan</label>
    <select v-model="uiState.roasDashboard.channelId" class="mt-1 w-full p-2 border rounded-lg">
        <option value="all">Semua Channel</option>
        <option
            v-for="channel in state.settings.marketplaces"
            :key="channel.id"
            :value="channel.id"
        >
            {{ channel.name }}
        </option>
    </select>
</div>

<div>
    <label class="block text-sm font-medium text-slate-700">Model Produk</label>
    <select v-model="uiState.roasDashboard.selectedModelId" class="mt-1 w-full p-2 border rounded-lg">
        <option value="all">Semua Model</option>
        <option
    v-for="model in uniqueRoasModels"
    :key="model.namaModel"
    :value="model.namaModel"
>
    {{ model.namaModel }}
</option>
    </select>
</div>

                <div>
                    <label class="block text-sm font-medium text-slate-700">Biaya Iklan</label>
                    <input type="number" v-model.number="uiState.roasDashboard.adSpend" class="mt-1 w-full p-2 border rounded-lg" placeholder="Contoh: 100000">
                </div>
                
                <div>
                    <label class="block text-sm font-medium text-slate-700">Pajak (%)</label>
                    <input type="number" v-model.number="uiState.roasDashboard.taxPercent" class="mt-1 w-full p-2 border rounded-lg" placeholder="Contoh: 0.5">
                </div>
            </div>
        </div>

        <div class="grid grid-cols-1 md:grid-cols-4 gap-5 mb-6">
            <div class="bg-white p-5 rounded-2xl shadow border">
                <p class="text-sm text-slate-500">Omset</p>
                <p class="text-2xl font-bold text-slate-800">{{ formatCurrency(roasDashboardData.omset) }}</p>
            </div>

            <div class="bg-white p-5 rounded-2xl shadow border">
                <p class="text-sm text-slate-500">ROAS</p>
                <p class="text-2xl font-bold text-blue-700">{{ roasDashboardData.roas.toFixed(2) }}x</p>
            </div>

            <div class="bg-white p-5 rounded-2xl shadow border">
                <p class="text-sm text-slate-500">Rugi ROAS (BEP)</p>
                <p class="text-2xl font-bold text-orange-600">{{ roasDashboardData.bepRoas.toFixed(2) }}x</p>
            </div>

            <div class="bg-white p-5 rounded-2xl shadow border">
                <p class="text-sm text-slate-500">Status</p>
                <p class="text-xl font-bold" :class="roasDashboardData.labaBersih >= 0 ? 'text-green-700' : 'text-red-700'">
                    {{ roasDashboardData.status }}
                </p>
            </div>
        </div>

        <div class="grid grid-cols-1 lg:grid-cols-2 gap-6">
            <div class="bg-white p-6 rounded-2xl shadow border">
                <h3 class="text-lg font-bold text-slate-800 mb-4">Ringkasan Penjualan</h3>

                <div class="space-y-3">
                    <div class="flex justify-between border-b pb-2">
                        <span>Total Order</span>
                        <strong>{{ roasDashboardData.totalOrder }}</strong>
                    </div>
                    <div class="flex justify-between border-b pb-2">
                        <span>Qty Terjual</span>
                        <strong>{{ formatNumber(roasDashboardData.qtyTerjual) }} pcs</strong>
                    </div>
                    <div class="flex justify-between border-b pb-2">
                        <span>Omset</span>
                        <strong>{{ formatCurrency(roasDashboardData.omset) }}</strong>
                    </div>
                    <div class="flex justify-between border-b pb-2">
                        <span>Laba Kotor</span>
                        <strong>{{ formatCurrency(roasDashboardData.labaKotor) }}</strong>
                    </div>
                    <div class="flex justify-between">
                        <span>Margin Bersih</span>
                        <strong>{{ roasDashboardData.marginBersih.toFixed(2) }}%</strong>
                    </div>
                </div>
            </div>

            <div class="bg-white p-6 rounded-2xl shadow border">
                <h3 class="text-lg font-bold text-slate-800 mb-4">Rincian Biaya</h3>

                <div class="space-y-3">
                    <div class="flex justify-between border-b pb-2">
                        <div class="flex justify-between border-b pb-2">
    <span>Diskon</span>

    <strong class="text-red-600">
        -{{ formatCurrency(roasDashboardData.discount) }}
    </strong>
</div>
                        <span>HPP Terjual</span>
                        <strong class="text-red-600">-{{ formatCurrency(roasDashboardData.totalHpp) }}</strong>
                    </div>
                
                    <div class="flex justify-between border-b pb-2">
                        <span>Biaya Marketplace</span>
                        <strong class="text-red-600">-{{ formatCurrency(roasDashboardData.biayaMarketplace) }}</strong>
                    </div>
                    <div class="flex justify-between border-b pb-2">
                        <span>Biaya Iklan</span>
                        <strong class="text-red-600">-{{ formatCurrency(roasDashboardData.biayaIklan) }}</strong>
                    </div>
                    <div class="flex justify-between border-b pb-2">
                        <span>Biaya Operasional</span>
                        <strong class="text-red-600">-{{ formatCurrency(roasDashboardData.biayaOperasional) }}</strong>
                    </div>
                    <div class="flex justify-between border-b pb-2">
                        <span>Estimasi Pajak</span>
                        <strong class="text-red-600">-{{ formatCurrency(roasDashboardData.pajak) }}</strong>
                    </div>
                    <div class="flex justify-between pt-2 text-lg">
                        <span class="font-bold">Laba Setelah Iklan</span>
                        <strong :class="roasDashboardData.labaBersih >= 0 ? 'text-green-700' : 'text-red-700'">
                            {{ formatCurrency(roasDashboardData.labaBersih) }}
                            <p class="text-xs text-slate-500 mt-1">
    Belum termasuk biaya operasional.
</p>
                        </strong>
                    </div>
                </div>
            </div>
        </div>

    </div>
</div>

<div v-if="activePage === 'roas-calculator'" class="min-h-screen w-full bg-gradient-to-br from-slate-50 via-white to-indigo-100 p-4 sm:p-8">
    <div class="max-w-7xl mx-auto animate-fade-in-up">
        <div class="mb-8">
            <h2 class="text-3xl font-bold text-slate-800">Kalkulator Target ROAS Iklan</h2>
            <p class="text-slate-500 mt-1">Tentukan target ROAS Anda agar iklan tidak merugi dan mencapai target profit.</p>
        </div>

        <div class="grid grid-cols-1 lg:grid-cols-3 gap-8 items-start">
            
            <div class="lg:col-span-1 bg-white/70 backdrop-blur-sm p-6 rounded-2xl shadow-xl border border-slate-200 space-y-4 lg:sticky lg:top-8">
                <div class="flex items-center justify-between border-b pb-3">
                    <h3 class="text-xl font-bold text-slate-800">1. Masukkan Data</h3>
                    <button @click="showModal('roasInputInfo')" class="bg-blue-100 text-blue-700 text-sm font-bold py-1 px-3 rounded-lg hover:bg-blue-200">Informasi</button>
                </div>
                
                <div>
                    <label class="block text-sm font-medium text-slate-700">Harga Jual / AOV</label>
                    <input type="number" v-model.number="uiState.roasCalculator.hargaJual" class="mt-1 w-full p-2 border rounded-md font-semibold">
                </div>
                <div>
                    <label class="block text-sm font-medium text-slate-700">Modal Produk (HPP)</label>
                    <input type="number" v-model.number="uiState.roasCalculator.modalProduk" class="mt-1 w-full p-2 border rounded-md">
                </div>
                <div>
                    <label class="block text-sm font-medium text-slate-700">Biaya Packing & Lainnya</label>
                    <input type="number" v-model.number="uiState.roasCalculator.biayaPacking" class="mt-1 w-full p-2 border rounded-md">
                </div>
                <div>
                    <label class="block text-sm font-medium text-slate-700">Biaya Admin Marketplace (Rp)</label>
                    <input type="number" v-model.number="uiState.roasCalculator.biayaAdminMarketplace" class="mt-1 w-full p-2 border rounded-md">
                </div>
            </div>

            <div class="lg:col-span-2 space-y-6">
                <div class="bg-white/70 backdrop-blur-sm p-6 rounded-2xl shadow-xl border border-slate-200">
                    <div class="flex items-center justify-between border-b pb-3 mb-4">
                        <h3 class="text-xl font-bold text-slate-800">2. Hasil Perhitungan</h3>
                        <button @click="showModal('roasResultInfo')" class="bg-blue-100 text-blue-700 text-sm font-bold py-1 px-3 rounded-lg hover:bg-blue-200">Informasi</button>
                    </div>
                    <div v-if="roasResults.error" class="p-4 bg-red-100 text-red-700 border border-red-200 rounded-lg">
                        {{ roasResults.error }}
                    </div>
                    <div v-else class="grid grid-cols-1 md:grid-cols-3 gap-4 text-center">
                        <div class="p-4 bg-slate-50 rounded-lg border">
                            <p class="text-sm font-medium text-slate-500">Profit Kotor / Penjualan</p>
                            <p class="text-2xl font-bold mt-1 text-indigo-600">{{ formatCurrency(roasResults.profitKotor) }}</p>
                        </div>
                        <div class="p-4 bg-yellow-100 rounded-lg border border-yellow-300">
                            <p class="text-sm font-medium text-yellow-800">ROAS Impas (BEP)</p>
                            <p class="text-2xl font-bold mt-1 text-yellow-900">{{ roasResults.breakEvenROAS.toFixed(2) }}</p>
                            <p class="text-xs text-yellow-700">ROAS minimum agar tidak rugi</p>
                        </div>
                        <div class="p-4 bg-slate-50 rounded-lg border">
                            <p class="text-sm font-medium text-slate-500">Margin Profit Kotor</p>
                            <p class="text-2xl font-bold mt-1 text-indigo-600">{{ roasResults.profitMargin.toFixed(1) }}%</p>
                        </div>
                    </div>
                </div>

                <div class="bg-white/70 backdrop-blur-sm p-6 rounded-2xl shadow-xl border border-slate-200">
                    <h3 class="text-xl font-bold text-slate-800 border-b pb-3 mb-4">3. Target ROAS (untuk Profit)</h3>
                    <p class="text-sm text-slate-600 mb-4">Untuk mendapatkan margin profit bersih dari penjualan, Anda harus mencapai target ROAS berikut:</p>
                    <div class="overflow-x-auto">
                        <table class="w-full text-sm">
                            <thead class="text-left bg-slate-100">
                                <tr>
                                    <th class="p-3 font-semibold text-slate-600">Target Profit Margin</th>
                                    <th class="p-3 font-semibold text-slate-600 text-center">Target ROAS yang Dibutuhkan</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="target in roasResults.targets" :key="target.margin" class="border-b">
                                    <td class="p-3">Target profit **{{ target.margin }}%** dari Harga Jual</td>
                                    <td class="p-3 text-center font-bold text-lg" :class="target.roas > roasResults.breakEvenROAS ? 'text-green-600' : 'text-slate-500'">
                                        <span v-if="isFinite(target.roas)">{{ target.roas.toFixed(2) }}</span>
                                        <span v-else>Tidak Mungkin</span>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                
                <div class="bg-white/70 backdrop-blur-sm p-6 rounded-2xl shadow-xl border border-slate-200">
                    <div class="flex items-center justify-between border-b pb-3 mb-4">
    <h3 class="text-xl font-bold text-slate-800">4. Simulasi Iklan dengan Budget</h3>
    <button @click="showModal('roasSimulationInfo')" class="bg-blue-100 text-blue-700 text-sm font-bold py-1 px-3 rounded-lg hover:bg-blue-200">Informasi</button>
</div>
                    <div class="max-w-md mb-6">
                        <label class="block text-sm font-medium text-slate-700">Masukkan Estimasi Budget Iklan (per bulan)</label>
                        <input type="number" v-model.number="uiState.roasCalculator.estimasiBiayaIklan" class="mt-1 w-full p-2 border rounded-md font-semibold">
                    </div>

                    <div v-if="roasResults.error">
                        <p class="text-slate-500 text-center py-4">Silakan lengkapi data produk di atas terlebih dahulu.</p>
                    </div>
                    <div v-else class="overflow-x-auto">
                        <table class="w-full text-sm">
                            <thead class="text-left bg-slate-100">
                                <tr>
                                    <th class="p-3 font-semibold text-slate-600">Skenario</th>
                                    <th class="p-3 font-semibold text-slate-600 text-center">Target ROAS</th>
                                    <th class="p-3 font-semibold text-slate-600 text-center">Estimasi Order</th>
                                    <th class="p-3 font-semibold text-slate-600 text-right">Estimasi Omset</th>
                                    <th class="p-3 font-semibold text-slate-600 text-right bg-indigo-100 text-indigo-800">Estimasi Laba Bersih<br><span class="font-normal text-xs">(Setelah Biaya Iklan)</span></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="sim in roasSimulationResults" :key="sim.scenario" class="border-b">
                                    <td class="p-3 font-semibold">{{ sim.scenario }}</td>
                                    <td class="p-3 text-center text-lg font-bold" :class="{'text-yellow-700': sim.scenario.includes('Impas'), 'text-green-700': sim.scenario.includes('Target')}">
                                        <div v-if="sim.scenario.includes('Kustom')" class="w-24 mx-auto">
                                            <input type="number" step="0.1" v-model.number="uiState.roasCalculator.customRoasTarget" class="w-full p-1 text-center border rounded-md">
                                        </div>
                                        <span v-else>{{ typeof sim.targetRoas === 'number' ? sim.targetRoas.toFixed(2) : sim.targetRoas }}</span>
                                    </td>
                                    <td class="p-3 text-center">{{ sim.estimasiOrder.toFixed(0) }} order</td>
                                    <td class="p-3 text-right">{{ formatCurrency(sim.estimasiOmset) }}</td>
                                    <td class="p-3 text-right text-lg font-bold" :class="sim.estimasiLabaBersih >= 0 ? 'text-green-600' : 'text-red-600'">
                                        {{ formatCurrency(sim.estimasiLabaBersih) }}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>

            </div>
        </div>
    </div>
</div>

<div v-if="activePage === 'laporan-keuangan'" class="min-h-screen bg-gradient-to-br from-slate-50 via-white to-indigo-100 p-4 sm:p-8">
<div v-if="isLaporanKeuanganLocked" class="mx-auto mt-16 max-w-sm rounded-2xl border bg-white p-8 text-center shadow-xl"><h3 class="text-xl font-bold">Halaman Terkunci</h3><p class="my-3 text-sm text-slate-600">Masukkan PIN keamanan Anda untuk membuka.</p><form @submit.prevent="unlockLaporanKeuangan"><input type="password" v-model="uiState.laporanKeuanganPinInput" placeholder="••••" class="w-full rounded-md border p-2 text-center text-lg"><p v-if="uiState.laporanKeuanganPinError" class="my-2 text-xs text-red-600">{{ uiState.laporanKeuanganPinError }}</p><button type="submit" class="mt-2 w-full rounded-lg bg-indigo-600 py-2.5 font-bold text-white">Buka</button></form></div>
<div v-else class="mx-auto max-w-7xl space-y-5"><header class="flex flex-wrap items-end justify-between gap-4"><div><p class="text-sm font-semibold uppercase tracking-wide text-indigo-600">Keuangan</p><h2 class="text-3xl font-bold">Laporan Keuangan</h2><p class="mt-1 text-sm text-slate-600">Pencairan marketplace dicatat satu kali per toko/periode; HPP dihitung dari pesanan yang berhasil dikonfirmasi.</p></div><label class="text-sm font-medium">Tahun <input type="number" v-model.number="uiState.laporanKeuanganTahun" class="ml-2 w-28 rounded-md border p-2"></label></header>
<section class="grid gap-4 md:grid-cols-3">
<article class="rounded-xl border bg-white p-4"><p class="text-xs font-semibold uppercase text-slate-500">Dana dilepas</p><p class="mt-1 text-xl font-bold">{{ formatCurrency(laporanKeuanganData.yearlyTotals.payoutAmount) }}</p></article>
<article class="rounded-xl border bg-white p-4"><p class="text-xs font-semibold uppercase text-slate-500">Laba/rugi setelah HPP dan biaya</p><p class="mt-1 text-xl font-bold" :class="laporanKeuanganData.yearlyTotals.netProfit===null?'text-amber-700':laporanKeuanganData.yearlyTotals.netProfit>=0?'text-emerald-700':'text-red-700'">{{ laporanKeuanganData.yearlyTotals.netProfit===null?'Lengkapi data':formatCurrency(laporanKeuanganData.yearlyTotals.netProfit) }}</p></article>
<article class="rounded-xl border bg-white p-4"><p class="text-xs font-semibold uppercase text-slate-500">Laba belum dibagikan</p><p class="mt-1 text-xl font-bold text-indigo-700">{{ laporanKeuanganData.yearlyTotals.undistributedProfit===null?'Lengkapi data':formatCurrency(laporanKeuanganData.yearlyTotals.undistributedProfit) }}</p></article>
</section>
<section class="rounded-2xl border bg-white p-5 shadow-sm">
<h3 class="font-bold text-slate-900">Catat pembagian laba</h3>
<p class="mt-1 text-sm text-slate-600">Masukkan jumlah yang benar-benar dibayarkan kepada teman pemodal sesuai kesepakatan kalian. Catatan ini mengurangi laba yang belum dibagikan, tetapi tidak mengubah laba usaha.</p>
<div class="mt-4 grid gap-3 sm:grid-cols-3">
<label class="block"><span class="mb-1 block text-xs font-medium">Bulan laba</span><select v-model.number="profitDistributionForm.month" class="w-full rounded-lg border p-2 text-sm"><option v-for="(month,index) in laporanKeuanganData.months" :key="month.monthName" :value="index+1">{{ month.monthName }}</option></select></label>
<label class="block"><span class="mb-1 block text-xs font-medium">Nama penerima</span><input v-model.trim="profitDistributionForm.recipient" class="w-full rounded-lg border p-2 text-sm" placeholder="Nama teman pemodal"></label>
<label class="block"><span class="mb-1 block text-xs font-medium">Jumlah dibayarkan (Rp)</span><input v-model.number="profitDistributionForm.amount" type="number" min="1" step="1" class="w-full rounded-lg border p-2 text-sm" placeholder="Nominal yang benar-benar dibayar"></label>
</div>
<button type="button" @click="saveProfitDistribution" :disabled="isSavingProfitDistribution || !profitDistributionForm.recipient || !profitDistributionForm.amount" class="mt-3 rounded-lg bg-indigo-700 px-4 py-2 text-sm font-semibold text-white disabled:bg-slate-300">{{ isSavingProfitDistribution?'Menyimpan…':'Simpan pembagian laba' }}</button>
<p v-if="profitDistributionForm.message" class="mt-3 rounded-lg bg-emerald-50 p-3 text-sm text-emerald-800">{{ profitDistributionForm.message }}</p>
<p v-if="profitDistributionForm.error" class="mt-3 rounded-lg bg-red-50 p-3 text-sm text-red-700">{{ profitDistributionForm.error }}</p>
</section>
<div class="overflow-x-auto rounded-2xl border bg-white shadow-sm"><table class="w-full min-w-[860px] text-left text-sm"><thead class="bg-slate-50 text-xs uppercase text-slate-500"><tr><th class="p-4">Bulan</th><th class="p-4 text-right">Total pencairan marketplace</th><th class="p-4 text-right">HPP pesanan berhasil</th><th class="p-4 text-right">Biaya transaksi terdata</th><th class="p-4 text-right">Biaya operasional</th><th class="p-4 text-right">Laba setelah HPP & biaya</th></tr></thead><tbody class="divide-y"><tr v-for="month in laporanKeuanganData.months" :key="month.monthName"><td class="p-4 font-semibold capitalize">{{ month.monthName }}</td><td class="p-4 text-right">{{ formatCurrency(month.payoutAmount) }}</td><td class="p-4 text-right">-{{ formatCurrency(month.soldHpp) }}</td><td class="p-4 text-right">-{{ formatCurrency(month.transactionFees) }}</td><td class="p-4 text-right">-{{ formatCurrency(month.operatingCosts) }}</td><td class="p-4 text-right font-bold" :class="month.netProfit===null?'text-amber-700':month.netProfit>=0?'text-emerald-700':'text-red-700'">{{ month.netProfit===null?'Lengkapi total pencairan':formatCurrency(month.netProfit) }}</td></tr></tbody><tfoot class="border-t-2 bg-slate-50 font-bold"><tr><td class="p-4">TOTAL {{ uiState.laporanKeuanganTahun }}</td><td class="p-4 text-right">{{ formatCurrency(laporanKeuanganData.yearlyTotals.payoutAmount) }}</td><td class="p-4 text-right">-{{ formatCurrency(laporanKeuanganData.yearlyTotals.soldHpp) }}</td><td class="p-4 text-right">-{{ formatCurrency(laporanKeuanganData.yearlyTotals.transactionFees) }}</td><td class="p-4 text-right">-{{ formatCurrency(laporanKeuanganData.yearlyTotals.operatingCosts) }}</td><td class="p-4 text-right">{{ laporanKeuanganData.yearlyTotals.netProfit===null?'Lengkapi total pencairan':formatCurrency(laporanKeuanganData.yearlyTotals.netProfit) }}</td></tr></tfoot></table></div>
<p class="rounded-lg bg-amber-50 p-3 text-xs text-amber-900">Masukkan total dana dilepas dari ringkasan marketplace di halaman Impor Pesanan Terkirim. Jika total pencairan belum dicatat, laba ditampilkan sebagai belum lengkap agar tidak keliru dianggap Rp0.</p></div></div>

<div v-if="activePage === 'statistik-penjualan'" class="min-h-screen w-full bg-gradient-to-br from-slate-50 via-white to-indigo-100 p-4 sm:p-8">

    <div v-if="isStatistikPenjualanLocked" class="flex items-center justify-center min-h-[70vh] animate-fade-in">
        <div class="bg-white/70 backdrop-blur-sm p-8 rounded-2xl shadow-xl border text-center max-w-sm w-full">
            <div class="w-16 h-16 bg-indigo-100 text-indigo-600 rounded-full flex items-center justify-center mb-6 mx-auto">
                <svg xmlns="http://www.w3.org/2000/svg" class="h-8 w-8" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
                </svg>
            </div>
            <h3 class="text-xl font-bold text-slate-800 mb-2">Statistik Penjualan Terkunci</h3>
            <p class="text-sm text-slate-600 mb-4">Masukkan PIN keamanan untuk melihat statistik penjualan.</p>
            <form @submit.prevent="unlockStatistikPenjualan" class="w-full">
                <input type="password" v-model="uiState.statistikPenjualanPinInput" placeholder="••••" class="w-full p-2 border border-slate-300 rounded-md text-center text-lg mb-2" autocomplete="current-password">
                <p v-if="uiState.statistikPenjualanPinError" class="text-red-500 text-xs mb-2">{{ uiState.statistikPenjualanPinError }}</p>
                <button type="submit" class="mt-2 w-full bg-indigo-600 text-white font-bold py-2.5 rounded-lg hover:bg-indigo-700 transition-colors">Buka Statistik Penjualan</button>
            </form>
        </div>
    </div>

    <div v-else class="max-w-7xl mx-auto space-y-6">

        <div class="bg-white/90 backdrop-blur-sm rounded-3xl border border-slate-200 shadow-xl p-6">
            <div class="flex flex-col lg:flex-row lg:items-start lg:justify-between gap-6">
                <div>
                    <p class="text-sm text-slate-500">Analisis performa produk</p>
                    <h2 class="text-3xl font-bold text-slate-800 mt-1">Statistik Penjualan</h2>
                    <p class="text-slate-500 mt-2 max-w-2xl">
                        Pantau produk, model, warna, ukuran, dan channel yang paling berkontribusi terhadap penjualan.
                    </p>
                </div>

                <div class="grid grid-cols-1 sm:grid-cols-3 gap-3 w-full lg:w-[720px]">
                    <div>
                        <label class="block text-xs font-semibold text-slate-500 mb-1">Periode</label>
                        <select v-model="uiState.salesStatsDateFilter" class="w-full p-3 border border-slate-200 rounded-xl text-sm bg-white">
                            <option value="all_time">Semua</option>
                            <option value="today">Hari Ini</option>
                            <option value="last_7_days">7 Hari Terakhir</option>
                            <option value="last_30_days">30 Hari Terakhir</option>
                            <option value="this_month">Bulan Ini</option>
                        </select>
                    </div>

                    <div>
                        <label class="block text-xs font-semibold text-slate-500 mb-1">Model</label>
                        <select v-model="uiState.salesStatsModelFilter" class="w-full p-3 border border-slate-200 rounded-xl text-sm bg-white">
                            <option value="all">Semua Model</option>
                            <option
                                v-for="model in uniqueRoasModels"
                                :key="model.namaModel"
                                :value="model.namaModel"
                            >
                                {{ model.namaModel }}
                            </option>
                        </select>
                    </div>

                    <div>
                        <label class="block text-xs font-semibold text-slate-500 mb-1">Channel</label>
                        <select v-model="uiState.salesStatsChannelFilter" class="w-full p-3 border border-slate-200 rounded-xl text-sm bg-white">
                            <option value="all">Semua Channel</option>
                            <option
                                v-for="channel in state.settings.marketplaces"
                                :key="channel.id"
                                :value="channel.name"
                            >
                                {{ channel.name }}
                            </option>
                        </select>
                    </div>
                </div>
            </div>
        </div>

        <div class="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-5">
            <div class="bg-white rounded-2xl border border-slate-200 shadow-lg p-6">
                <p class="text-sm text-slate-500">Total Order</p>
                <p class="text-3xl font-bold text-slate-800 mt-2">{{ formatNumber(salesPerformanceStats.totalOrder) }}</p>
                <p class="text-xs text-slate-400 mt-2">Jumlah transaksi sesuai filter.</p>
            </div>

            <div class="bg-white rounded-2xl border border-slate-200 shadow-lg p-6">
                <p class="text-sm text-slate-500">Total Produk Terjual</p>
                <p class="text-3xl font-bold text-cyan-600 mt-2">{{ formatNumber(salesPerformanceStats.totalQty) }} pcs</p>
                <p class="text-xs text-slate-400 mt-2">Total qty produk yang terjual.</p>
            </div>

            <div class="bg-white rounded-2xl border border-slate-200 shadow-lg p-6">
                <p class="text-sm text-slate-500">Total Omset</p>
                <p class="text-3xl font-bold text-blue-600 mt-2">{{ formatCurrency(salesPerformanceStats.totalOmset) }}</p>
                <p class="text-xs text-slate-400 mt-2">Perkiraan omset dari item terjual.</p>
            </div>

            <div class="bg-white rounded-2xl border border-slate-200 shadow-lg p-6">
                <p class="text-sm text-slate-500">Estimasi Laba Kotor</p>
                <p class="text-3xl font-bold mt-2" :class="salesPerformanceStats.grossProfit >= 0 ? 'text-green-600' : 'text-red-600'">
                    {{ formatCurrency(salesPerformanceStats.grossProfit) }}
                </p>
                <p class="text-xs text-slate-400 mt-2">Omset dikurangi HPP produk.</p>
            </div>
        </div>

        <div class="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-5">
            <div class="bg-white rounded-2xl border border-slate-200 shadow-lg p-6">
                <p class="text-sm text-slate-500">Model Terlaris</p>
                <p class="text-xl font-bold text-slate-800 mt-2">{{ salesPerformanceStats.topModels[0]?.name || 'Belum ada data' }}</p>
                <p class="text-sm text-slate-500 mt-2">
                    {{ salesPerformanceStats.topModels[0] ? formatNumber(salesPerformanceStats.topModels[0].qty) + ' pcs terjual' : '-' }}
                </p>
            </div>

            <div class="bg-white rounded-2xl border border-slate-200 shadow-lg p-6">
                <p class="text-sm text-slate-500">Warna Terlaris</p>
                <p class="text-xl font-bold text-slate-800 mt-2">{{ salesPerformanceStats.topColors[0]?.name || 'Belum ada data' }}</p>
                <p class="text-sm text-slate-500 mt-2">
                    {{ salesPerformanceStats.topColors[0] ? formatNumber(salesPerformanceStats.topColors[0].qty) + ' pcs terjual' : '-' }}
                </p>
            </div>

            <div class="bg-white rounded-2xl border border-slate-200 shadow-lg p-6">
                <p class="text-sm text-slate-500">Ukuran Terlaris</p>
                <p class="text-xl font-bold text-slate-800 mt-2">{{ salesPerformanceStats.topSizes[0]?.name || 'Belum ada data' }}</p>
                <p class="text-sm text-slate-500 mt-2">
                    {{ salesPerformanceStats.topSizes[0] ? formatNumber(salesPerformanceStats.topSizes[0].qty) + ' pcs terjual' : '-' }}
                </p>
            </div>

            <div class="bg-white rounded-2xl border border-slate-200 shadow-lg p-6">
                <p class="text-sm text-slate-500">Channel Terbaik</p>
                <p class="text-xl font-bold text-slate-800 mt-2">{{ salesPerformanceStats.topChannels[0]?.name || 'Belum ada data' }}</p>
                <p class="text-sm text-slate-500 mt-2">
                    {{ salesPerformanceStats.topChannels[0] ? formatCurrency(salesPerformanceStats.topChannels[0].omset) : '-' }}
                </p>
            </div>
        </div>

        <div class="bg-white rounded-3xl border border-slate-200 shadow-xl p-6">
            <div class="flex items-center justify-between gap-4 mb-5">
                <div>
                    <p class="text-sm text-slate-500">Ranking produk</p>
                    <h3 class="text-xl font-bold text-slate-800">Performa Produk per SKU</h3>
                </div>
                <p class="text-sm text-slate-400">Top 20 berdasarkan omset</p>
            </div>

            <div class="overflow-x-auto">
                <table class="w-full text-sm">
                    <thead class="bg-slate-50 text-slate-500 text-left">
                        <tr>
                            <th class="px-4 py-3 font-semibold">Produk</th>
                            <th class="px-4 py-3 font-semibold">SKU</th>
                            <th class="px-4 py-3 font-semibold">Model</th>
                            <th class="px-4 py-3 font-semibold">Warna</th>
                            <th class="px-4 py-3 font-semibold">Ukuran</th>
                            <th class="px-4 py-3 font-semibold text-right">Qty</th>
                            <th class="px-4 py-3 font-semibold text-right">Omset</th>
                            <th class="px-4 py-3 font-semibold text-right">HPP</th>
                            <th class="px-4 py-3 font-semibold text-right">Laba Kotor</th>
                        </tr>
                    </thead>

                    <tbody class="divide-y divide-slate-100">
                        <tr v-if="salesPerformanceStats.topProducts.length === 0">
                            <td colspan="9" class="px-4 py-6 text-center text-slate-500">
                                Belum ada data penjualan untuk filter ini.
                            </td>
                        </tr>

                        <tr v-for="item in salesPerformanceStats.topProducts" :key="item.sku" class="hover:bg-slate-50">
                            <td class="px-4 py-3 font-semibold text-slate-800">{{ item.name }}</td>
                            <td class="px-4 py-3 text-blue-600 font-mono">{{ item.sku }}</td>
                            <td class="px-4 py-3 text-slate-600">{{ item.model }}</td>
                            <td class="px-4 py-3 text-slate-600">{{ item.color }}</td>
                            <td class="px-4 py-3 text-slate-600">{{ item.size }}</td>
                            <td class="px-4 py-3 text-right font-bold">{{ formatNumber(item.qty) }}</td>
                            <td class="px-4 py-3 text-right font-bold text-blue-600">{{ formatCurrency(item.omset) }}</td>
                            <td class="px-4 py-3 text-right text-orange-600">{{ formatCurrency(item.hpp) }}</td>
                            <td class="px-4 py-3 text-right font-bold" :class="item.profit >= 0 ? 'text-green-600' : 'text-red-600'">
                                {{ formatCurrency(item.profit) }}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>

    </div>
</div>



<div v-if="activePage === 'pengaturan'" class="min-h-screen w-full bg-gradient-to-br from-slate-50 via-white to-indigo-100 p-4 sm:p-8">
    <div class="max-w-7xl mx-auto">
        
        <div class="mb-8 animate-fade-in-up">
            <h2 class="text-3xl font-bold text-slate-800">Pengaturan Aplikasi</h2>
            <p class="text-slate-500 mt-1">Kelola semua konfigurasi inti untuk bisnis Anda di sini.</p>
        </div>

        <div class="grid grid-cols-1 lg:grid-cols-4 gap-8 items-start">
            
            <div class="lg:col-span-1 bg-white/70 backdrop-blur-sm p-4 rounded-2xl shadow-lg border border-slate-200 lg:sticky lg:top-8 animate-fade-in-up" style="animation-delay: 100ms;">
                <h3 class="text-xl font-bold text-slate-800 mb-4 px-3">Pengaturan</h3>
                <ul class="space-y-1 text-base font-medium">
                    <li>
                        <button @click="uiState.pengaturanTab = 'umum'" class="w-full flex items-center gap-3 text-left p-3 rounded-lg transition-colors font-semibold" :class="{'bg-indigo-600 text-white shadow': uiState.pengaturanTab === 'umum', 'hover:bg-slate-100 text-slate-700': uiState.pengaturanTab !== 'umum'}">
                            <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor"><path d="M5 4a1 1 0 00-2 0v7.268a2 2 0 000 3.464V16a1 1 0 102 0v-1.268a2 2 0 000-3.464V4zM11 4a1 1 0 10-2 0v1.268a2 2 0 000 3.464V16a1 1 0 102 0V8.732a2 2 0 000-3.464V4zM16 3a1 1 0 011 1v7.268a2 2 0 010 3.464V16a1 1 0 11-2 0v-1.268a2 2 0 010-3.464V4a1 1 0 011-1z" /></svg>
                            Pengaturan Umum
                        </button>
                    </li>
                    <li>
                        <button @click="uiState.pengaturanTab = 'marketplace'" class="w-full flex items-center gap-3 text-left p-3 rounded-lg transition-colors font-semibold" :class="{'bg-indigo-600 text-white shadow': uiState.pengaturanTab === 'marketplace', 'hover:bg-slate-100 text-slate-700': uiState.pengaturanTab !== 'marketplace'}">
                            <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor"><path d="M3 1a1 1 0 000 2h1.22l.305 1.222a.997.997 0 00.01.042l1.358 5.43-.893.892C3.74 11.846 4.632 14 6.414 14H15a1 1 0 000-2H6.414l1-1H14a1 1 0 00.894-.553l3-6A1 1 0 0017 3H6.28l-.31-1.243A1 1 0 005 1H3zM16 16.5a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0zM6.5 18a1.5 1.5 0 100-3 1.5 1.5 0 000 3z" /></svg>
                            Marketplace
                        </button>
                    </li>
                    <li>
                        <button @click="uiState.pengaturanTab = 'modelproduk'" class="w-full flex items-center gap-3 text-left p-3 rounded-lg transition-colors font-semibold" :class="{'bg-indigo-600 text-white shadow': uiState.pengaturanTab === 'modelproduk', 'hover:bg-slate-100 text-slate-700': uiState.pengaturanTab !== 'modelproduk'}">
                           <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor"><path d="M5 4a2 2 0 012-2h6a2 2 0 012 2v14l-5-2.5L5 18V4z" /></svg>
                            Model Produk
                        </button>
                    </li>
                    <li>
                        <button @click="uiState.pengaturanTab = 'rekening'" class="w-full flex items-center gap-3 text-left p-3 rounded-lg transition-colors font-semibold" :class="{'bg-indigo-600 text-white shadow': uiState.pengaturanTab === 'rekening', 'hover:bg-slate-100 text-slate-700': uiState.pengaturanTab !== 'rekening'}">
                            <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor"><path d="M4 4a2 2 0 00-2 2v1h16V6a2 2 0 00-2-2H4z" /><path fill-rule="evenodd" d="M18 9H2v5a2 2 0 002 2h12a2 2 0 002-2V9zM4 13h1v2H4v-2z" clip-rule="evenodd" /></svg>
                            Rekening Bank
                        </button>
                    </li>
                    <li v-if="isAdmin">
                        <button @click="uiState.pengaturanTab = 'admin'" class="w-full flex items-center gap-3 text-left p-3 rounded-lg transition-colors font-semibold" :class="{'bg-indigo-600 text-white shadow': uiState.pengaturanTab === 'admin', 'hover:bg-slate-100 text-slate-700': uiState.pengaturanTab !== 'admin'}">
                            <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor"><path fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-6-3a2 2 0 11-4 0 2 2 0 014 0zm-2 4a5 5 0 00-4.545 2.917A5.996 5.996 0 0010 18a5.996 5.996 0 004.545-2.083A5 5 0 0012 11z" clip-rule="evenodd" /></svg>
                            Admin
                        </button>
                    </li>
                </ul>
            </div>

            <div class="lg:col-span-3">
                <div class="bg-white/70 backdrop-blur-sm p-6 sm:p-8 rounded-2xl shadow-lg border border-slate-200 animate-fade-in-up" style="animation-delay: 200ms;">
                    
                    <div v-if="uiState.pengaturanTab === 'umum'" class="animate-fade-in">
                        <h3 class="text-xl font-bold text-slate-800 mb-6">Informasi Dasar & Keamanan</h3>
                        <div class="space-y-4">
                            <div>
                                <label class="block text-sm font-medium text-slate-700 mb-1">Nama Brand Anda</label>
                                <input type="text" v-model="state.settings.brandName" class="w-full p-2 border border-slate-300 rounded-md">
                            </div>
                            <div>
                                <label class="block text-sm font-medium text-slate-700 mb-1">Batas Stok Minimum Peringatan</label>
                                <input type="number" v-model.number="state.settings.minStok" class="w-full p-2 border border-slate-300 rounded-md">
                            </div>
                        </div>
                        <div class="border-t pt-4 mt-6">
                            <h4 class="font-semibold text-slate-700 mb-2">Aktifkan Kunci PIN</h4>
                            <p class="text-xs text-slate-500 mb-4">Pilih bagian mana saja yang ingin Anda amankan menggunakan PIN.</p>
                            <div class="space-y-3">
                                <div class="flex justify-between items-center p-3 bg-slate-50 rounded-lg border">
                                    <span class="font-medium text-sm text-slate-800">Kunci Halaman Dashboard</span>
                                    <button @click="requestPinForToggle('dashboard')" class="w-14 h-7 rounded-full flex items-center transition-colors px-1" :class="state.settings.pinProtection?.dashboard ? 'bg-indigo-600' : 'bg-slate-300'">
                                        <span class="w-5 h-5 bg-white rounded-full shadow-md transition-transform" :class="{ 'transform translate-x-7': state.settings.pinProtection?.dashboard }"></span>
                                    </button>
                                </div>
                                <div class="flex justify-between items-center p-3 bg-slate-50 rounded-lg border">
                                    <span class="font-medium text-sm text-slate-800">Kunci Tabel Riwayat Pemasukan</span>
                                    <button @click="requestPinForToggle('incomeHistory')" class="w-14 h-7 rounded-full flex items-center transition-colors px-1" :class="state.settings.pinProtection?.incomeHistory ? 'bg-indigo-600' : 'bg-slate-300'">
                                        <span class="w-5 h-5 bg-white rounded-full shadow-md transition-transform" :class="{ 'transform translate-x-7': state.settings.pinProtection?.incomeHistory }"></span>
                                    </button>
                                </div>
                                <div class="flex justify-between items-center p-3 bg-slate-50 rounded-lg border">
                                    <span class="font-medium text-sm text-slate-800">Kunci Halaman Investasi</span>
                                    <button @click="requestPinForToggle('investmentPage')" class="w-14 h-7 rounded-full flex items-center transition-colors px-1" :class="state.settings.pinProtection?.investmentPage ? 'bg-indigo-600' : 'bg-slate-300'">
                                        <span class="w-5 h-5 bg-white rounded-full shadow-md transition-transform" :class="{ 'transform translate-x-7': state.settings.pinProtection?.investmentPage }"></span>
                                    </button>
                                </div>
                                <div class="flex justify-between items-center p-3 bg-slate-50 rounded-lg border">
    <span class="font-medium text-sm text-slate-800">Kunci Laporan Transaksi</span>
    <button @click="requestPinForToggle('laporanTransaksi')" class="w-14 h-7 rounded-full flex items-center transition-colors px-1" :class="state.settings.pinProtection?.laporanTransaksi ? 'bg-indigo-600' : 'bg-slate-300'">
        <span class="w-5 h-5 bg-white rounded-full shadow-md transition-transform" :class="{ 'transform translate-x-7': state.settings.pinProtection?.laporanTransaksi }"></span>
    </button>
</div>

<div class="flex justify-between items-center p-3 bg-slate-50 rounded-lg border">
    <span class="font-medium text-sm text-slate-800">Kunci Laporan Keuangan</span>
    <button @click="requestPinForToggle('laporanKeuangan')" class="w-14 h-7 rounded-full flex items-center transition-colors px-1" :class="state.settings.pinProtection?.laporanKeuangan ? 'bg-indigo-600' : 'bg-slate-300'">
        <span class="w-5 h-5 bg-white rounded-full shadow-md transition-transform" :class="{ 'transform translate-x-7': state.settings.pinProtection?.laporanKeuangan }"></span>
    </button>
</div>

<div class="flex justify-between items-center p-3 bg-slate-50 rounded-lg border">
    <span class="font-medium text-sm text-slate-800">Kunci Harga & HPP</span>
    <button @click="requestPinForToggle('hargaHpp')" class="w-14 h-7 rounded-full flex items-center transition-colors px-1" :class="state.settings.pinProtection?.hargaHpp ? 'bg-indigo-600' : 'bg-slate-300'">
        <span class="w-5 h-5 bg-white rounded-full shadow-md transition-transform" :class="{ 'transform translate-x-7': state.settings.pinProtection?.hargaHpp }"></span>
    </button>
</div>

<div class="flex justify-between items-center gap-4 p-3 bg-slate-50 rounded-lg border">
    <div>
        <span class="font-medium text-sm text-slate-800">Kunci Statistik Penjualan</span>
        <p class="text-xs text-slate-500 mt-1">PIN diminta saat membuka halaman Statistik Penjualan.</p>
    </div>
    <button @click="requestPinForToggle('statistikPenjualan')" class="w-14 h-7 rounded-full flex items-center transition-colors px-1 flex-shrink-0" :class="state.settings.pinProtection?.statistikPenjualan ? 'bg-indigo-600' : 'bg-slate-300'">
        <span class="w-5 h-5 bg-white rounded-full shadow-md transition-transform" :class="{ 'transform translate-x-7': state.settings.pinProtection?.statistikPenjualan }"></span>
    </button>
</div>

<div class="flex justify-between items-center gap-4 p-3 bg-slate-50 rounded-lg border">
    <div>
        <span class="font-medium text-sm text-slate-800">Kunci Semua Tombol Export</span>
        <p class="text-xs text-slate-500 mt-1">Setiap export data harus dikonfirmasi dengan PIN.</p>
    </div>
    <button @click="requestPinForToggle('exportData')" class="w-14 h-7 rounded-full flex items-center transition-colors px-1 flex-shrink-0" :class="state.settings.pinProtection?.exportData ? 'bg-indigo-600' : 'bg-slate-300'">
        <span class="w-5 h-5 bg-white rounded-full shadow-md transition-transform" :class="{ 'transform translate-x-7': state.settings.pinProtection?.exportData }"></span>
    </button>
</div>

<div class="flex justify-between items-center gap-4 p-3 bg-slate-50 rounded-lg border">
    <div>
        <span class="font-medium text-sm text-slate-800">Kunci Detail Riwayat Transaksi</span>
        <p class="text-xs text-slate-500 mt-1">PIN diminta setiap kali tombol Detail transaksi dibuka.</p>
    </div>
    <button @click="requestPinForToggle('transactionDetail')" class="w-14 h-7 rounded-full flex items-center transition-colors px-1 flex-shrink-0" :class="state.settings.pinProtection?.transactionDetail ? 'bg-indigo-600' : 'bg-slate-300'">
        <span class="w-5 h-5 bg-white rounded-full shadow-md transition-transform" :class="{ 'transform translate-x-7': state.settings.pinProtection?.transactionDetail }"></span>
    </button>
</div>
                            </div>
                        </div>
                        <div class="border-t pt-4 mt-6">
                            <h4 class="font-semibold text-slate-700 mb-2">
                                <span v-if="state.settings.dashboardPin">Ubah PIN Dasbor</span>
                                <span v-else>Buat PIN Dasbor Baru</span>
                            </h4>
                            <div class="space-y-2">
                                <div v-if="state.settings.dashboardPin">
                                    <label class="block text-sm font-medium text-slate-700">PIN Lama</label>
                                    <input type="password" v-model="uiState.oldPin" placeholder="Masukkan PIN lama" class="w-full p-2 border border-slate-300 rounded-md">
                                </div>
                                <div>
                                    <label class="block text-sm font-medium text-slate-700">PIN Baru</label>
                                    <input type="password" v-model="uiState.newPin" placeholder="Masukkan PIN baru" class="w-full p-2 border border-slate-300 rounded-md">
                                </div>
                                <div>
                                    <label class="block text-sm font-medium text-slate-700">Konfirmasi PIN Baru</label>
                                    <input type="password" v-model="uiState.confirmNewPin" placeholder="Ketik ulang PIN baru" class="w-full p-2 border border-slate-300 rounded-md">
                                </div>
                                <p v-if="uiState.pinError" class="text-sm text-red-500">{{ uiState.pinError }}</p>
                            </div>
                        </div>
                        <div class="flex justify-end pt-4 border-t mt-6">
                            <button @click="saveGeneralSettings" :disabled="isSavingSettings || !isSubscriptionActive" class="bg-indigo-600 text-white font-bold py-2.5 px-5 rounded-lg hover:bg-indigo-700 transition-colors disabled:bg-indigo-400">
    <span v-if="isSavingSettings">Menyimpan...</span>
    <span v-else>Simpan Perubahan</span>
</button>
                        </div>
                    </div>

                    <div v-if="uiState.pengaturanTab === 'marketplace'" class="animate-fade-in">
    <div class="flex justify-between items-center mb-4">
    <h3 class="text-xl font-bold text-slate-800">Daftar Marketplace</h3>

    <div class="flex gap-2">
        <button 
            @click="requestProtectedExport(() => exportMarketplaceYangTampil())" 
            class="bg-blue-600 text-white font-bold py-1 px-3 rounded-md hover:bg-blue-700 text-sm">
            Export
        </button>

        <button 
            @click="addMarketplace" 
            class="bg-green-500 text-white font-bold py-1 px-3 rounded-md hover:bg-green-600 text-sm" 
            :disabled="!isSubscriptionActive">
            Tambah
        </button>
    </div>
</div>
    <p class="mb-4 text-sm text-slate-500">Atur nama channel saja. Data potongan dan penghasilan bersih dicatat dari laporan marketplace yang dicocokkan dengan transaksi.</p>
    <div class="mb-4">
        <input type="text" v-model="uiState.pengaturanMarketplaceSearch" placeholder="Cari nama marketplace..." class="w-full p-2 border border-slate-300 rounded-md">
    </div>
    <div class="overflow-x-auto">
        <table class="w-full text-sm">
<thead class="text-left text-slate-500"><tr><th class="p-2 font-medium">NAMA MARKETPLACE</th><th class="p-2 font-medium text-right">AKSI</th></tr></thead>
<tbody class="divide-y divide-slate-200">
<tr v-if="filteredMarketplaces.length === 0"><td colspan="2" class="p-4 text-center text-slate-500">Belum ada channel marketplace. Tambahkan Shopee, TikTok Shop, atau channel lain yang digunakan.</td></tr>
<tr v-for="mp in (filteredMarketplaces || [])" :key="mp.id"><td class="p-3 font-semibold text-slate-700">{{ mp.name }}</td><td class="p-3 text-right space-x-4">
<button @click="showModal('editMarketplace', JSON.parse(JSON.stringify(mp)))" class="font-semibold text-blue-500 hover:underline" :disabled="!isSubscriptionActive">Edit</button>
<button @click="removeMarketplace(mp.id)" class="text-red-500 hover:text-red-700" :disabled="!isSubscriptionActive">Hapus</button>
</td></tr></tbody></table>
    </div>
    <div class="flex justify-end pt-4 border-t mt-6">
        <button @click="saveSettingsData" :disabled="isSaving || !isSubscriptionActive" class="bg-green-600 text-white font-bold py-2.5 px-5 rounded-lg hover:bg-green-700 transition-colors disabled:bg-green-400 disabled:shadow-none">
    <span v-if="isSaving">Menyimpan...</span>
    <span v-else>Simpan Perubahan</span>
</button>
    </div>
</div>
                    
                    <div v-if="uiState.pengaturanTab === 'modelproduk'" class="animate-fade-in">
    <div class="flex justify-between items-center mb-4">
        <div class="flex items-center gap-4">
    <h3 class="text-xl font-bold text-slate-800">Daftar Model Produk</h3>
    <button @click="showModal('modelProdukInfo')" class="bg-indigo-100 text-indigo-700 font-bold py-1 px-3 rounded-lg hover:bg-indigo-200 text-sm flex items-center gap-2">
        <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
            <path fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clip-rule="evenodd" />
        </svg>
        Informasi
    </button>
</div>
        <button @click="addModelProduk" class="bg-blue-600 text-white font-bold py-2 px-4 rounded-lg hover:bg-blue-700 text-sm" :disabled="!isSubscriptionActive">+ Tambah Model</button>
    </div>
    
    <div class="mb-4">
        <input type="text" v-model="uiState.pengaturanModelProdukSearch" placeholder="Cari nama model..." class="w-full p-2 border border-slate-300 rounded-md">
    </div>

    <div class="overflow-x-auto" style="max-height: 50vh;">
        <table class="w-full text-sm">
            <thead class="text-left text-slate-500">
                <tr>
                    <th class="p-2 font-medium">NAMA MODEL</th>
                    <th class="p-2 font-medium">WARNA</th>
                    <th class="p-2 font-medium">UKURAN</th>
                    <th class="p-2 font-medium">YARD</th>
                    <th class="p-2 font-medium">HARGA MAKLUN</th>
                    <th class="p-2 font-medium">HARGA JAHIT</th>
                    <th class="p-2 font-medium text-right">AKSI</th>
                </tr>
            </thead>
            <tbody class="divide-y divide-slate-200">
                <tr v-if="filteredModelProduk.length === 0">
                    <td colspan="5" class="p-4 text-center text-slate-500">Tidak ada model yang cocok.</td>
                </tr>
                <tr v-for="model in filteredModelProduk" :key="model.id">
                    <td class="p-3 font-semibold text-slate-700">{{ model.namaModel }}</td>
                    <td class="p-3">{{ model.warna }}</td>
                    <td class="p-3">{{ model.ukuran }}</td>
                    <td class="p-3">{{ model.yardPerModel || 0 }} y</td>
                    <td class="p-3">{{ formatCurrency(model.hargaMaklun || 0) }}</td>
                    <td class="p-3">{{ formatCurrency(model.hargaJahit || 0) }}</td>
                    <td class="p-3 text-right space-x-4">
                        <button @click="showModal('editModelProduk', JSON.parse(JSON.stringify(model)))" class="font-semibold text-blue-500 hover:underline" :disabled="!isSubscriptionActive">Edit</button>
                        <button @click="removeModelProduk(model.id)" class="text-red-500 hover:text-red-700" :disabled="!isSubscriptionActive">
    <svg class="w-5 h-5 inline-block" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"></path></svg>
</button>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
    <div class="flex justify-end pt-4 border-t mt-6">
        <button @click="saveSettingsData" :disabled="isSaving || !isSubscriptionActive" class="bg-green-600 text-white font-bold py-2.5 px-5 rounded-lg hover:bg-green-700 transition-colors disabled:bg-green-400 disabled:shadow-none">
    <span v-if="isSaving">Menyimpan...</span>
    <span v-else>Simpan Perubahan</span>
</button>
    </div>
</div>
                    
                    <div v-if="uiState.pengaturanTab === 'rekening'" class="animate-fade-in">
                        <div class="flex justify-between items-center mb-4">
                            <h3 class="text-xl font-bold text-slate-800">Daftar Rekening Bank</h3>
                            <button @click="showModal('addBankAccount', { bankName: '', accountNumber: '', accountName: '' })" class="bg-green-500 text-white font-bold py-1 px-3 rounded-md hover:bg-green-600 text-sm" :disabled="!isSubscriptionActive">Tambah</button>
                        </div>
                        <div class="overflow-x-auto">
                            <table class="w-full text-sm">
                                <thead class="text-left text-slate-500">
                                    <tr>
                                        <th class="p-2 font-medium">NAMA BANK</th>
                                        <th class="p-2 font-medium">NO. REKENING</th>
                                        <th class="p-2 font-medium">ATAS NAMA</th>
                                        <th class="p-2 font-medium text-right">AKSI</th>
                                    </tr>
                                </thead>
                                <tbody class="divide-y divide-slate-200">
                                    <tr v-if="state.bankAccounts.length === 0">
                                        <td colspan="4" class="p-4 text-center text-slate-500">Belum ada rekening tersimpan.</td>
                                    </tr>
                                    <tr v-for="acc in (state.bankAccounts || [])" :key="acc.id">
                                        <td class="p-3 font-semibold text-slate-700">{{ acc.bankName }}</td>
                                        <td class="p-3">{{ acc.accountNumber }}</td>
                                        <td class="p-3">{{ acc.accountName }}</td>
                                        <td class="p-3 text-right space-x-4">
                                            <button @click="showModal('editBankAccount', acc)" class="font-semibold text-blue-500 hover:underline" :disabled="!isSubscriptionActive">Edit</button>
                                            <button @click="deleteBankAccount(acc.id)" class="text-red-500 hover:text-red-700 font-semibold" :disabled="!isSubscriptionActive">Hapus</button>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>

                    <div v-if="uiState.pengaturanTab === 'admin' && isAdmin" class="animate-fade-in">
    <div class="space-y-6">
        <div class="bg-white p-6 rounded-xl border border-slate-200 shadow-sm">
            <h3 class="text-lg font-semibold text-slate-800 mb-4">Kelola Akun Mitra</h3>
            <p class="text-sm text-slate-500 mb-4">
                Pilih pengguna di bawah ini untuk menjadikannya mitra. Kode rujukan unik akan dibuat otomatis.
            </p>
            <div class="overflow-x-auto max-h-96">
    <table class="w-full text-sm">
        <thead class="text-left text-slate-500 bg-slate-100 sticky top-0">
            <tr>
                <th class="p-2 font-medium">Email Pengguna</th>
                <th class="p-2 font-medium text-center">Status Mitra</th>
                <th class="p-2 font-medium text-center">Kode Rujukan</th>
                <th class="p-2 font-medium text-right">Aksi</th>
            </tr>
        </thead>
        <tbody class="divide-y divide-slate-200">
            <tr v-if="uiState.allUsers.length === 0">
                <td colspan="4" class="p-4 text-center text-slate-500">Tidak ada pengguna terdaftar.</td>
            </tr>
            <tr v-for="user in uiState.allUsers" :key="user.uid" class="hover:bg-slate-50">
                <td class="p-3">{{ user.email }}</td>
                <td class="p-3 text-center">
                    <span v-if="user.isPartner" class="text-xs font-semibold px-2 py-0.5 rounded-full bg-green-100 text-green-800">Ya</span>
                    <span v-else class="text-xs font-semibold px-2 py-0.5 rounded-full bg-slate-100 text-slate-800">Tidak</span>
                </td>
                <td class="p-3 text-center font-mono text-sm">
                    {{ user.referralCode || '-' }}
                </td>
                <td class="p-3 text-right space-x-2">
                    <button v-if="!user.isPartner" @click="makeUserPartner(user.uid)" class="bg-indigo-600 text-white font-bold py-1 px-3 rounded-md hover:bg-indigo-700 text-xs">
                        Jadikan Mitra
                    </button>
                    <div v-else class="inline-flex items-center gap-2">
                        <button @click="showModal('editReferralCode', { user: user, newReferralCode: user.referralCode })" class="bg-blue-100 text-blue-800 font-bold py-1 px-3 rounded-md hover:bg-blue-200 text-xs">
                            Edit
                        </button>
                        <button @click="showModal('viewNote', { title: 'Kode Rujukan Mitra', content: user.referralCode })" class="bg-slate-200 text-slate-800 font-bold py-1 px-3 rounded-md hover:bg-slate-300 text-xs">
                            Lihat Kode
                        </button>
                    </div>
                </td>
            </tr>
        </tbody>
    </table>
</div>
        </div>

        <div class="bg-white p-6 rounded-xl border border-slate-200 shadow-sm">
            <h3 class="text-lg font-semibold text-slate-800 mb-4">Export Data Pelanggan</h3>
            <p class="text-sm text-slate-500 mb-4">Pilih pelanggan dan rentang waktu untuk mengunduh semua data mereka.</p>
            <div class="space-y-4">
                <div>
                    <label class="block text-sm font-medium text-slate-700">Pilih Pelanggan</label>
                    <select v-model="uiState.selectedUserForExport" class="mt-1 w-full p-2 border rounded-md">
                        <option :value="null" disabled>-- Daftar Pelanggan --</option>
                        <option v-for="user in uiState.allUsers" :key="user.uid" :value="user">
                            {{ user.email }}
                        </option>
                    </select>
                    <div v-if="uiState.selectedUserForExport" class="mt-3 p-3 rounded-xl bg-slate-50 border border-slate-200 text-xs text-slate-600 space-y-1">
    <p>
        <b>Email dipilih:</b>
        {{ getAdminExportUserEmail(uiState.selectedUserForExport) }}
    </p>

    <p>
        <b>User ID yang akan diexport:</b>
        {{ getAdminExportUserId(uiState.selectedUserForExport) }}
    </p>

    <p v-if="uiState.selectedUserForExport.oldUidField">
        <b>UID lama di field data:</b>
        {{ uiState.selectedUserForExport.oldUidField }}
    </p>
</div>
                </div>
                <div>
    <label class="block text-sm font-medium text-slate-700 mb-1">Filter Waktu</label>
    <select v-model="uiState.exportFilter" class="w-full p-2 border rounded-md capitalize bg-white shadow-sm">
        <option value="today">Hari Ini</option>
        <option value="last_7_days">7 Hari Terakhir</option>
        <option value="last_30_days">30 Hari Terakhir</option>
        <option value="this_year">Tahun Ini</option>
        <option value="by_date_range">Rentang Tanggal</option>
        <option value="by_month_range">Rentang Bulan</option>
        <option value="by_year_range">Rentang Tahun</option>
        <option value="all_time">Semua</option>
    </select>
</div>
<div v-if="uiState.exportFilter === 'by_date_range'" class="mt-2 grid grid-cols-2 gap-2 animate-fade-in">
    <div><label class="block text-xs font-medium mb-1">Dari Tanggal</label><input type="date" v-model="uiState.exportStartDate" class="w-full p-2 border rounded-md bg-white shadow-sm"></div>
    <div><label class="block text-xs font-medium mb-1">Sampai Tanggal</label><input type="date" v-model="uiState.exportEndDate" class="w-full p-2 border rounded-md bg-white shadow-sm"></div>
</div>
<div v-if="uiState.exportFilter === 'by_month_range'" class="mt-2 grid grid-cols-4 gap-2 animate-fade-in">
    <div><label class="block text-xs font-medium">Dari</label><select v-model.number="uiState.exportStartMonth" class="w-full p-2 border rounded-md bg-white shadow-sm"><option v-for="m in 12" :key="m" :value="m">{{ new Date(0, m - 1).toLocaleString('id-ID', { month: 'long' }) }}</option></select></div>
    <div><label class="block text-xs font-medium">Tahun</label><input type="number" v-model.number="uiState.exportStartYear" class="w-full p-2 border rounded-md bg-white shadow-sm"></div>
    <div><label class="block text-xs font-medium">Sampai</label><select v-model.number="uiState.exportEndMonth" class="w-full p-2 border rounded-md bg-white shadow-sm"><option v-for="m in 12" :key="m" :value="m">{{ new Date(0, m - 1).toLocaleString('id-ID', { month: 'long' }) }}</option></select></div>
    <div><label class="block text-xs font-medium">Tahun</label><input type="number" v-model.number="uiState.exportEndYear" class="w-full p-2 border rounded-md bg-white shadow-sm"></div>
</div>
<div v-if="uiState.exportFilter === 'by_year_range'" class="mt-2 grid grid-cols-2 gap-2 animate-fade-in">
    <div><label class="block text-xs font-medium mb-1">Dari Tahun</label><input type="number" v-model.number="uiState.exportStartYear" placeholder="Tahun" class="w-full p-2 border rounded-md bg-white shadow-sm"></div>
    <div><label class="block text-xs font-medium mb-1">Sampai Tahun</label><input type="number" v-model.number="uiState.exportEndYear" placeholder="Tahun" class="w-full p-2 border rounded-md bg-white shadow-sm"></div>
</div>
                <button @click="requestProtectedExport(() => exportAllDataForUser(
    uiState.selectedUserForExport?.uid || uiState.selectedUserForExport?.id,
    uiState.selectedUserForExport?.email,
    uiState.exportFilter,
    uiState.exportStartDate,
    uiState.exportEndDate,
    uiState.exportStartMonth,
    uiState.exportEndMonth,
    uiState.exportStartYear,
    uiState.exportEndYear
))"
 :disabled="!uiState.selectedUserForExport || uiState.isExportingUserData" class="w-full bg-blue-600 text-white font-bold py-2.5 px-5 rounded-lg hover:bg-blue-700 disabled:bg-blue-400 disabled:cursor-not-allowed">
                    <span v-if="uiState.isExportingUserData">Mengekspor Data...</span>
                    <span v-else>Export Data Pelanggan</span>
                </button>
            </div>
        </div>
        
        <div class="bg-white p-6 rounded-xl border border-slate-200 shadow-sm">
            <h3 class="text-lg font-semibold text-slate-800 mb-4">Riwayat Pengajuan Pencairan Komisi (Semua Mitra)</h3>
            <div class="overflow-x-auto max-h-96">
                <table class="w-full text-sm">
                    <thead class="text-left text-slate-500 bg-slate-100 sticky top-0">
                        <tr>
                            <th class="p-3 font-medium">TANGGAL</th>
                            <th class="p-3 font-medium">DETAIL PENCAIRAN</th>
                            <th class="p-3 font-medium text-right">JUMLAH</th>
                        </tr>
                    </thead>
                    <tbody class="divide-y divide-slate-200">
                        <tr v-if="commissionPayouts.length === 0">
                            <td colspan="3" class="p-4 text-center text-slate-500">Belum ada riwayat pencairan.</td>
                        </tr>
                        <tr v-for="payout in commissionPayouts" :key="payout.id">
                            <td class="p-3 whitespace-nowrap">{{ new Date(payout.tanggal.seconds * 1000).toLocaleDateString('id-ID') }}</td>
                            <td class="p-3">
                                <p class="font-semibold text-slate-700">{{ payout.catatan }}</p>
                            </td>
                            <td class="p-3 text-right font-bold text-green-600">
                                {{ formatCurrency(payout.jumlah) }}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>

        <div class="bg-white p-6 rounded-xl border border-slate-200 shadow-sm">
            <h3 class="text-lg font-semibold text-slate-800 mb-4">Kelola Kode Aktivasi</h3>
            <p class="text-sm text-slate-500 mb-4">
                Buat kode sekali pakai untuk pengguna yang membeli di luar aplikasi (misalnya Shopee).
            </p>
            <div class="flex gap-2 mb-6">
                <input type="text" v-model="newActivationCode" placeholder="Ketik kode kustom (opsional)" class="w-full p-2 border border-slate-300 rounded-md shadow-sm">
                <button @click="createActivationCode" :disabled="isSaving" class="bg-indigo-600 text-white font-bold py-2 px-5 rounded-lg hover:bg-indigo-700 disabled:bg-indigo-400">
                    <span v-if="isSaving">...</span>
                    <span v-else>Buat Kode</span>
                </button>
            </div>
            <div class="overflow-x-auto max-h-96">
    <table class="w-full text-sm">
        <thead class="text-left text-slate-500 bg-slate-100 sticky top-0">
            <tr>
                <th class="p-3 font-medium">KODE AKTIVASI</th>
                <th class="p-3 font-medium text-center">STATUS</th>
                <th class="p-3 font-medium">DIGUNAKAN OLEH</th>
                <th class="p-3 font-medium text-right">AKSI</th>
            </tr>
        </thead>
        <tbody class="divide-y divide-slate-200">
            <tr v-if="activationCodes.length === 0">
                <td colspan="4" class="p-4 text-center text-slate-500">Belum ada kode aktivasi yang dibuat.</td>
            </tr>
            <tr v-for="code in activationCodes" :key="code.id">
                <td class="p-3 font-mono text-indigo-600">{{ code.id }}</td>
                <td class="p-3 text-center">
                    <span class="text-xs font-semibold px-2.5 py-1 rounded-full capitalize"
                          :class="code.status === 'unused' ? 'bg-green-100 text-green-800' : 'bg-slate-100 text-slate-800'">
                        {{ code.status }}
                    </span>
                </td>
                <td class="p-3 text-slate-500">{{ code.usedByEmail || '-' }}</td>
                <td class="p-3 text-right">
                    <button @click="deleteActivationCode(code.id)" class="text-red-500 hover:text-red-700">
                        <svg class="w-5 h-5 inline-block" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"></path></svg>
                    </button>
                </td>
            </tr>
        </tbody>
    </table>
</div>
        </div>

        <!-- 👇👇 BLOK VERIFIKASI YANG SUDAH DIPERBAIKI 👇👇 -->
        <div class="bg-white p-6 rounded-xl border border-slate-200 shadow-sm mt-6">
            <h3 class="text-lg font-semibold text-slate-800 mb-4">Verifikasi Pencairan Komisi Mitra</h3>
            <p class="text-sm text-slate-500 mb-4">
                Masukkan ID Pencairan dari email untuk memverifikasi jumlah yang benar.
            </p>
            <form @submit.prevent="verifyCashoutRequest" class="flex gap-2">
                <input 
                    type="text" 
                    v-model="uiState.adminVerificationIdInput" 
                    placeholder="Contoh: WDRW-17..." 
                    class="w-full p-2 border border-slate-300 rounded-md shadow-sm font-mono"
                >
                <button 
                    type="submit" 
                    :disabled="uiState.isVerifying" 
                    class="bg-indigo-600 text-white font-bold py-2 px-5 rounded-lg hover:bg-indigo-700 disabled:bg-indigo-400"
                >
                    <span v-if="uiState.isVerifying">...</span>
                    <span v-else>Verifikasi</span>
                </button>
            </form>

            <div v-if="uiState.adminVerificationResult" class="mt-4 p-4 bg-green-50 border-l-4 border-green-500 text-green-800 animate-fade-in">
                <p class="font-bold text-lg">✅ Verifikasi Berhasil</p>
                <div class="mt-2 space-y-1 text-sm">
                    <p><strong>Jumlah Asli:</strong> <span class="text-2xl font-bold">{{ formatCurrency(uiState.adminVerificationResult.jumlah) }}</span></p>
                    <p><strong>Tanggal Pengajuan:</strong> {{ uiState.adminVerificationResult.tanggal }}</p>
                    <p><strong>Detail:</strong> {{ uiState.adminVerificationResult.catatan }}</p>
                </div>
                <button @click="confirmCashoutPayment(uiState.adminVerificationIdInput)" class="mt-4 w-full bg-green-600 text-white font-bold py-2 rounded-lg hover:bg-green-700">
                    Konfirmasi Pembayaran Selesai
                </button>
            </div>
            <div v-if="uiState.adminVerificationError" class="mt-4 p-4 bg-red-50 border-l-4 border-red-500 text-red-800 animate-fade-in">
                <p class="font-bold text-lg">❌ Gagal Verifikasi</p>
                <p class="text-sm mt-1">{{ uiState.adminVerificationError }}</p>
            </div>
        </div>
        
    </div>
</div>

                    </div>
                </div>
            </div>
        </div>
    </div>


<div v-if="activePage === 'panduan'" class="min-h-screen w-full bg-gradient-to-br from-slate-950 via-slate-900 to-indigo-950 p-4 sm:p-8">
    <div class="max-w-7xl mx-auto space-y-8">

        <!-- HERO -->
        <div class="relative overflow-hidden rounded-3xl border border-white/10 bg-white/10 backdrop-blur-xl shadow-2xl">
            <div class="absolute inset-0 bg-gradient-to-r from-indigo-500/20 via-purple-500/10 to-cyan-500/10"></div>

            <div class="relative p-6 sm:p-10 lg:p-12">
                <div class="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-8">
                    <div>
                        <div class="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-white/10 border border-white/10 text-indigo-100 text-sm font-bold mb-5">
                            <span>📖</span>
                            <span>Pusat Panduan Fashion OS</span>
                        </div>

                        <h2 class="text-4xl md:text-6xl font-black text-white leading-tight">
                            Panduan Lengkap<br>
                            <span class="bg-gradient-to-r from-indigo-300 via-white to-cyan-200 bg-clip-text text-transparent">
                                Semua Fitur Aplikasi
                            </span>
                        </h2>

                        <p class="text-slate-300 text-lg mt-5 max-w-3xl leading-relaxed">
                            Pelajari fungsi setiap halaman Fashion OS dengan alur yang rapi. Mulai dari pengaturan,
                            produk, stok, produksi, penjualan, retur, keuangan, laporan, sampai analisis ROAS.
                        </p>

                        <div class="flex flex-wrap gap-3 mt-7">
                            <button @click="panduanAccordion = 'pengaturan'" class="bg-white text-slate-900 font-bold py-3 px-5 rounded-xl hover:bg-slate-100 transition shadow-lg">
                                Mulai dari Pengaturan
                            </button>

                            <button @click="panduanAccordion = 'penjualan'" class="bg-indigo-600 text-white font-bold py-3 px-5 rounded-xl hover:bg-indigo-700 transition shadow-lg">
                                Lihat Alur Penjualan
                            </button>

                            <a :href="'https://wa.me/' + nomorWhatsAppAdmin" target="_blank" class="bg-green-500 text-white font-bold py-3 px-5 rounded-xl hover:bg-green-600 transition shadow-lg">
                                Chat Admin
                            </a>
                        </div>
                    </div>

                    <div class="grid grid-cols-2 gap-4 min-w-full lg:min-w-[380px]">
                        <div class="rounded-2xl bg-white/10 border border-white/10 p-5">
                            <p class="text-3xl font-black text-white">01</p>
                            <p class="text-sm text-slate-300 mt-1">Pengaturan</p>
                        </div>
                        <div class="rounded-2xl bg-white/10 border border-white/10 p-5">
                            <p class="text-3xl font-black text-white">02</p>
                            <p class="text-sm text-slate-300 mt-1">Produk & Stok</p>
                        </div>
                        <div class="rounded-2xl bg-white/10 border border-white/10 p-5">
                            <p class="text-3xl font-black text-white">03</p>
                            <p class="text-sm text-slate-300 mt-1">Penjualan</p>
                        </div>
                        <div class="rounded-2xl bg-white/10 border border-white/10 p-5">
                            <p class="text-3xl font-black text-white">04</p>
                            <p class="text-sm text-slate-300 mt-1">Laporan & ROAS</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- QUICK FLOW -->
        <div class="bg-white rounded-3xl shadow-xl border border-slate-200 p-6 sm:p-8">
            <div class="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-5 mb-6">
                <div>
                    <p class="text-sm font-black text-indigo-600 uppercase tracking-wide">Alur Kerja Harian</p>
                    <h3 class="text-2xl sm:text-3xl font-black text-slate-900 mt-1">
                        Urutan paling aman saat memakai Fashion OS
                    </h3>
                    <p class="text-slate-600 mt-2">
                        Jangan loncat langsung ke transaksi. Pastikan data dasar sudah rapi supaya laporan tidak salah hitung.
                    </p>
                </div>
            </div>

            <div class="grid grid-cols-1 md:grid-cols-5 gap-4">
                <div class="rounded-2xl bg-indigo-50 border border-indigo-100 p-4">
                    <div class="text-2xl mb-2">⚙️</div>
                    <h4 class="font-black text-slate-900">Pengaturan</h4>
                    <p class="text-sm text-slate-600 mt-1">Marketplace, model produk, kategori, rekening, PIN.</p>
                </div>

                <div class="rounded-2xl bg-slate-50 border border-slate-200 p-4">
                    <div class="text-2xl mb-2">📦</div>
                    <h4 class="font-black text-slate-900">Produk</h4>
                    <p class="text-sm text-slate-600 mt-1">SKU, warna, ukuran, stok, harga, HPP.</p>
                </div>

                <div class="rounded-2xl bg-slate-50 border border-slate-200 p-4">
                    <div class="text-2xl mb-2">🏭</div>
                    <h4 class="font-black text-slate-900">Produksi</h4>
                    <p class="text-sm text-slate-600 mt-1">Kain, maklun, supplier, aktual jadi.</p>
                </div>

                <div class="rounded-2xl bg-slate-50 border border-slate-200 p-4">
                    <div class="text-2xl mb-2">🛒</div>
                    <h4 class="font-black text-slate-900">Penjualan</h4>
                    <p class="text-sm text-slate-600 mt-1">POS, proses massal, retur, audit data.</p>
                </div>

                <div class="rounded-2xl bg-green-50 border border-green-100 p-4">
                    <div class="text-2xl mb-2">📊</div>
                    <h4 class="font-black text-slate-900">Laporan</h4>
                    <p class="text-sm text-slate-600 mt-1">Profit, keuangan, ROAS, statistik.</p>
                </div>
            </div>
        </div>

        <!-- GUIDE ACCORDION -->
        <div class="grid grid-cols-1 lg:grid-cols-3 gap-6">

            <!-- LEFT HELP BOX -->
            <div class="space-y-6">
                <div class="bg-white rounded-3xl shadow-xl border border-slate-200 p-6">
                    <h3 class="text-xl font-black text-slate-900">Cara baca panduan</h3>
                    <p class="text-slate-600 text-sm mt-2 leading-relaxed">
                        Klik salah satu modul, baca fungsi utamanya, lalu gunakan tombol di bawahnya untuk langsung masuk ke halaman terkait.
                    </p>

                    <div class="mt-5 space-y-3 text-sm">
                        <div class="flex gap-3">
                            <span class="text-green-600 font-black">✓</span>
                            <span class="text-slate-700">Cocok untuk pengguna baru.</span>
                        </div>
                        <div class="flex gap-3">
                            <span class="text-green-600 font-black">✓</span>
                            <span class="text-slate-700">Menjelaskan kapan fitur dipakai.</span>
                        </div>
                        <div class="flex gap-3">
                            <span class="text-green-600 font-black">✓</span>
                            <span class="text-slate-700">Tombol langsung menuju halaman.</span>
                        </div>
                    </div>
                </div>

                <div class="bg-gradient-to-br from-indigo-600 to-slate-900 rounded-3xl shadow-xl p-6 text-white">
                    <p class="text-sm font-bold text-indigo-200 uppercase tracking-wide">Catatan Penting</p>
                    <h3 class="text-xl font-black mt-2">Akurasi laporan bergantung dari data awal.</h3>
                    <p class="text-indigo-100 mt-3 text-sm leading-relaxed">
                        Marketplace, model produk, HPP, harga jual, dan stok harus rapi dulu sebelum transaksi mulai dicatat.
                    </p>
                </div>

                <div class="bg-white rounded-3xl shadow-xl border border-slate-200 p-6">
                    <h3 class="text-xl font-black text-slate-900">Bantuan cepat</h3>
                    <p class="text-slate-600 text-sm mt-2">
                        Hubungi admin kalau ada bagian yang masih membingungkan.
                    </p>
                    <a :href="'https://wa.me/' + nomorWhatsAppAdmin" target="_blank" class="mt-5 inline-flex w-full justify-center bg-green-500 text-white font-bold py-3 px-5 rounded-xl hover:bg-green-600 transition">
                        Chat Admin WhatsApp
                    </a>
                </div>
            </div>

            <!-- RIGHT ACCORDION -->
            <div class="lg:col-span-2 space-y-4">
                <div 
                    v-for="panduan in panduanData" 
                    :key="panduan.id"
                    class="bg-white rounded-3xl border border-slate-200 shadow-xl overflow-hidden transition hover:shadow-2xl"
                >
                    <button 
                        type="button"
                        @click="panduanAccordion = panduanAccordion === panduan.id ? null : panduan.id"
                        class="w-full flex items-start gap-4 p-5 sm:p-6 text-left hover:bg-slate-50 transition"
                    >
                        <div class="w-12 h-12 rounded-2xl bg-indigo-100 text-indigo-700 flex items-center justify-center text-2xl flex-shrink-0">
                            {{ panduan.icon }}
                        </div>

                        <div class="flex-1">
                            <div class="flex flex-wrap items-center gap-2">
                                <h3 class="text-lg sm:text-xl font-black text-slate-900">
                                    {{ panduan.title }}
                                </h3>
                                <span class="px-3 py-1 rounded-full bg-slate-100 text-slate-600 text-xs font-black">
                                    {{ panduan.badge }}
                                </span>
                            </div>
                            <p class="text-sm text-slate-600 mt-1">
                                {{ panduan.subtitle }}
                            </p>
                        </div>

                        <span class="text-slate-400 text-2xl transition" :class="{ 'rotate-180': panduanAccordion === panduan.id }">
                           ⌄
                        </span>
                    </button>

                    <div v-show="panduanAccordion === panduan.id" class="px-5 sm:px-6 pb-6">
                        <div class="border-t border-slate-100 pt-5">
                            <p class="text-slate-700 leading-relaxed">
                                {{ panduan.description }}
                            </p>

                            <div class="grid grid-cols-1 md:grid-cols-2 gap-5 mt-5">
                                <div class="rounded-2xl bg-slate-50 border border-slate-200 p-4">
                                    <h4 class="font-black text-slate-900 mb-3">Yang dilakukan di halaman ini:</h4>
                                    <ul class="space-y-2 text-sm text-slate-700">
                                        <li v-for="step in panduan.steps" :key="step" class="flex gap-2">
                                            <span class="text-indigo-600 font-black">•</span>
                                            <span>{{ step }}</span>
                                        </li>
                                    </ul>
                                </div>

                                <div class="rounded-2xl bg-amber-50 border border-amber-200 p-4">
                                    <h4 class="font-black text-amber-900 mb-3">Tips pemakaian:</h4>
                                    <ul class="space-y-2 text-sm text-amber-800">
                                        <li v-for="tip in panduan.tips" :key="tip" class="flex gap-2">
                                            <span class="font-black">✓</span>
                                            <span>{{ tip }}</span>
                                        </li>
                                    </ul>
                                </div>
                            </div>

                            <div class="flex flex-wrap gap-3 mt-5">
                                <button
                                    v-for="link in panduan.links"
                                    :key="link.label"
                                    @click="openPanduanLink(link)"
                                    class="font-bold py-2.5 px-4 rounded-xl transition"
                                    :class="link.primary 
                                        ? 'bg-indigo-600 text-white hover:bg-indigo-700 shadow-lg' 
                                        : 'bg-white border border-slate-300 text-slate-700 hover:bg-slate-50'"
                                >
                                    {{ link.label }} →
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>

        <!-- FINAL CTA -->
        <div class="bg-white rounded-3xl shadow-xl border border-slate-200 p-6 sm:p-8">
            <div class="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-5">
                <div>
                    <p class="text-sm font-black text-green-600 uppercase tracking-wide">Panduan selesai</p>
                    <h3 class="text-2xl sm:text-3xl font-black text-slate-900 mt-1">
                        Gunakan Fashion OS dari data dasar sampai laporan profit.
                    </h3>
                    <p class="text-slate-600 mt-2">
                        Mulai dari pengaturan, lanjut produk, stok, penjualan, lalu cek laporan dan ROAS.
                    </p>
                </div>

                <div class="flex flex-wrap gap-3">
                    <button @click="changePage('panduan-baru')" class="bg-indigo-600 text-white font-bold py-3 px-5 rounded-xl hover:bg-indigo-700">
                        Panduan Pengguna Baru
                    </button>
                    <button @click="changePage('dashboard')" class="bg-slate-900 text-white font-bold py-3 px-5 rounded-xl hover:bg-slate-800">
                        Buka Dashboard
                    </button>
                </div>
            </div>
        </div>

    </div>
</div>

<div v-if="activePage === 'panduan-baru'" class="min-h-screen w-full bg-gradient-to-br from-slate-950 via-slate-900 to-indigo-950 p-4 sm:p-8">
    <div class="max-w-7xl mx-auto">

        <!-- HERO -->
        <div class="relative overflow-hidden rounded-3xl border border-white/10 bg-white/10 backdrop-blur-xl shadow-2xl mb-8">
            <div class="absolute inset-0 bg-gradient-to-r from-indigo-500/20 via-purple-500/10 to-cyan-500/10"></div>

            <div class="relative p-6 sm:p-10 lg:p-12">
                <div class="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-8">
                    <div>
                        <div class="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-white/10 border border-white/10 text-indigo-100 text-sm font-semibold mb-5">
                            <span>🚀</span>
                            <span>Panduan Setup Awal Fashion OS</span>
                        </div>

                        <h2 class="text-4xl md:text-6xl font-black text-white leading-tight">
                            Mulai dari Nol,<br>
                            <span class="bg-gradient-to-r from-indigo-300 via-white to-cyan-200 bg-clip-text text-transparent">
                                Sampai Siap Dipakai
                            </span>
                        </h2>

                        <p class="text-slate-300 text-lg mt-5 max-w-3xl leading-relaxed">
                            Ikuti alur ini agar data produk, stok, harga, penjualan, produksi, keuangan, dan ROAS
                            tersusun rapi sejak awal. Panduan ini dibuat untuk pengguna baru supaya tidak bingung harus mulai dari mana.
                        </p>

                        <div class="flex flex-wrap gap-3 mt-7">
                            <button @click="changePage('pengaturan')" class="bg-white text-slate-900 font-bold py-3 px-5 rounded-xl hover:bg-slate-100 transition shadow-lg">
                                Mulai dari Pengaturan
                            </button>

                            <button @click="changePage('inventaris')" class="bg-indigo-600 text-white font-bold py-3 px-5 rounded-xl hover:bg-indigo-700 transition shadow-lg">
                                Lanjut ke Produk
                            </button>

                            <a :href="'https://wa.me/' + nomorWhatsAppAdmin" target="_blank" class="bg-green-500 text-white font-bold py-3 px-5 rounded-xl hover:bg-green-600 transition shadow-lg">
                                Hubungi Admin
                            </a>
                        </div>
                    </div>

                    <div class="grid grid-cols-2 gap-4 min-w-full lg:min-w-[360px]">
                        <div class="rounded-2xl bg-white/10 border border-white/10 p-5">
                            <p class="text-3xl font-black text-white">01</p>
                            <p class="text-sm text-slate-300 mt-1">Data dasar</p>
                        </div>
                        <div class="rounded-2xl bg-white/10 border border-white/10 p-5">
                            <p class="text-3xl font-black text-white">02</p>
                            <p class="text-sm text-slate-300 mt-1">Produk & stok</p>
                        </div>
                        <div class="rounded-2xl bg-white/10 border border-white/10 p-5">
                            <p class="text-3xl font-black text-white">03</p>
                            <p class="text-sm text-slate-300 mt-1">Penjualan</p>
                        </div>
                        <div class="rounded-2xl bg-white/10 border border-white/10 p-5">
                            <p class="text-3xl font-black text-white">04</p>
                            <p class="text-sm text-slate-300 mt-1">Laporan & ROAS</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- QUICK START -->
        <div class="grid grid-cols-1 lg:grid-cols-3 gap-6 mb-8">
            <div class="lg:col-span-2 bg-white rounded-3xl border border-slate-200 shadow-xl p-6 sm:p-8">
                <div class="flex items-center justify-between gap-4 mb-6">
                    <div>
                        <p class="text-sm font-bold text-indigo-600 uppercase tracking-wide">Alur Paling Aman</p>
                        <h3 class="text-2xl sm:text-3xl font-black text-slate-900 mt-1">Ikuti urutan ini dulu</h3>
                    </div>
                    <div class="hidden sm:flex w-14 h-14 rounded-2xl bg-indigo-100 text-indigo-700 items-center justify-center text-2xl">
                        ✅
                    </div>
                </div>

                <div class="space-y-4">

                    <!-- STEP 1 -->
<div class="group rounded-2xl border-2 border-indigo-200 bg-indigo-50/60 p-5 hover:border-indigo-400 hover:shadow-lg transition">
    <div class="flex gap-4">
        <div class="w-11 h-11 rounded-xl bg-indigo-600 text-white flex items-center justify-center font-black flex-shrink-0">1</div>

        <div class="flex-1">
            <div class="flex flex-wrap items-center gap-2 mb-2">
                <h4 class="font-black text-slate-900 text-lg">Wajib Isi Pengaturan Awal</h4>
                <span class="px-3 py-1 rounded-full bg-red-100 text-red-700 text-xs font-black">
                    WAJIB PERTAMA
                </span>
            </div>

            <p class="text-slate-700 mt-1 leading-relaxed">
                Sebelum menambahkan produk, transaksi, produksi, atau laporan, pengguna baru wajib mengisi
                <strong>Marketplace</strong> dan <strong>Model Produk</strong> terlebih dahulu.
                Dua bagian ini adalah fondasi utama agar harga, HPP, stok, laporan, dan ROAS bisa terbaca dengan benar.
            </p>

            <div class="grid grid-cols-1 md:grid-cols-2 gap-4 mt-5">

                <!-- MARKETPLACE -->
                <div class="rounded-2xl bg-white border border-indigo-200 p-4 shadow-sm">
                    <div class="flex items-start gap-3">
                        <div class="w-10 h-10 rounded-xl bg-indigo-100 text-indigo-700 flex items-center justify-center text-xl flex-shrink-0">
                            🛒
                        </div>
                        <div>
                            <h5 class="font-black text-slate-900">A. Isi Marketplace</h5>
                            <p class="text-sm text-slate-600 mt-1">
                                Tambahkan semua channel jualan seperti Shopee, TikTok Shop, Offline, Website, atau marketplace lain.
                            </p>

                            <div class="mt-3 bg-slate-50 border border-slate-200 rounded-xl p-3">
                                <p class="text-xs font-bold text-slate-500 uppercase mb-1">Yang perlu diisi:</p>
                                <ul class="text-sm text-slate-700 space-y-1">
                                    <li>• Nama channel penjualan</li>
                                    <li>• Biaya admin marketplace</li>
                                    <li>• Biaya layanan / program tambahan</li>
                                    <li>• Biaya per pesanan jika ada</li>
                                </ul>
                            </div>

                            <button 
                                @click="uiState.pengaturanTab = 'marketplace'; changePage('pengaturan')" 
                                class="mt-4 w-full bg-indigo-600 text-white font-bold py-2.5 px-4 rounded-xl hover:bg-indigo-700 transition">
                                Buka Marketplace →
                            </button>
                        </div>
                    </div>
                </div>

                <!-- MODEL PRODUK -->
                <div class="rounded-2xl bg-white border border-indigo-200 p-4 shadow-sm">
                    <div class="flex items-start gap-3">
                        <div class="w-10 h-10 rounded-xl bg-purple-100 text-purple-700 flex items-center justify-center text-xl flex-shrink-0">
                            👗
                        </div>
                        <div>
                            <h5 class="font-black text-slate-900">B. Isi Model Produk</h5>
                            <p class="text-sm text-slate-600 mt-1">
                                Tambahkan nama model produk utama, misalnya Aurelia, Amara, Elara, atau model lain yang kamu jual.
                            </p>

                            <div class="mt-3 bg-slate-50 border border-slate-200 rounded-xl p-3">
                                <p class="text-xs font-bold text-slate-500 uppercase mb-1">Kenapa wajib?</p>
                                <ul class="text-sm text-slate-700 space-y-1">
                                    <li>• Produk akan mengambil data dari model</li>
                                    <li>• Laporan bisa dibaca per model</li>
                                    <li>• Produksi dan stok lebih rapi</li>
                                    <li>• ROAS bisa dianalisis per model</li>
                                </ul>
                            </div>

                            <button 
                                @click="uiState.pengaturanTab = 'modelproduk'; changePage('pengaturan')" 
                                class="mt-4 w-full bg-purple-600 text-white font-bold py-2.5 px-4 rounded-xl hover:bg-purple-700 transition">
                                Buka Model Produk →
                            </button>
                        </div>
                    </div>
                </div>

            </div>

            <div class="mt-5 rounded-2xl bg-amber-50 border border-amber-200 p-4">
                <p class="font-black text-amber-800 mb-1">Urutan yang benar:</p>
                <p class="text-sm text-amber-800 leading-relaxed">
                    1. Isi <strong>Marketplace</strong> → 
                    2. Isi <strong>Model Produk</strong> → 
                    3. Baru masuk ke <strong>Inventaris</strong> untuk tambah produk/SKU.
                </p>
            </div>
        </div>
    </div>
</div>

                    <!-- STEP 2 -->
                    <div class="group rounded-2xl border border-slate-200 p-5 hover:border-indigo-300 hover:shadow-lg transition">
                        <div class="flex gap-4">
                            <div class="w-11 h-11 rounded-xl bg-indigo-600 text-white flex items-center justify-center font-black flex-shrink-0">2</div>
                            <div class="flex-1">
                                <h4 class="font-black text-slate-900 text-lg">Masukkan Produk, SKU, Warna, Ukuran, dan Stok</h4>
                                <p class="text-slate-600 mt-1">
                                    Buat produk per varian agar stok, barcode, retur, penjualan, dan laporan bisa terbaca rapi.
                                </p>
                                <div class="bg-amber-50 border border-amber-200 text-amber-800 rounded-xl p-3 mt-4 text-sm">
                                    Contoh SKU yang rapi: <strong>ARL-HTM-M</strong> untuk Aurelia Hitam ukuran M.
                                </div>
                                <button @click="changePage('inventaris')" class="mt-4 text-indigo-700 font-bold hover:text-indigo-900">
                                    Buka Inventaris →
                                </button>
                            </div>
                        </div>
                    </div>

                    <!-- STEP 3 -->
                    <div class="group rounded-2xl border border-slate-200 p-5 hover:border-indigo-300 hover:shadow-lg transition">
                        <div class="flex gap-4">
                            <div class="w-11 h-11 rounded-xl bg-indigo-600 text-white flex items-center justify-center font-black flex-shrink-0">3</div>
                            <div class="flex-1">
                                <h4 class="font-black text-slate-900 text-lg">Isi Harga Jual dan HPP</h4>
                                <p class="text-slate-600 mt-1">
                                    Lengkapi modal produk dan harga jual per channel supaya laba, margin, laporan, dan ROAS tidak salah hitung.
                                </p>
                                <button @click="changePage('harga-hpp')" class="mt-4 text-indigo-700 font-bold hover:text-indigo-900">
                                    Buka Harga & HPP →
                                </button>
                            </div>
                        </div>
                    </div>

                    <!-- STEP 4 -->
                    <div class="group rounded-2xl border border-slate-200 p-5 hover:border-indigo-300 hover:shadow-lg transition">
                        <div class="flex gap-4">
                            <div class="w-11 h-11 rounded-xl bg-indigo-600 text-white flex items-center justify-center font-black flex-shrink-0">4</div>
                            <div class="flex-1">
                                <h4 class="font-black text-slate-900 text-lg">Mulai Proses Penjualan</h4>
                                <p class="text-slate-600 mt-1">
                                    Gunakan Kasir POS untuk penjualan langsung. Untuk marketplace, cocokkan scan paket dengan ekspor terkirim lalu impor hasilnya.
                                </p>
                                <div class="flex flex-wrap gap-3 mt-4">
                                    <button @click="changePage('transaksi')" class="bg-slate-900 text-white font-bold py-2 px-4 rounded-lg hover:bg-slate-800">
                                        Kasir POS
                                    </button>
                                    <button @click="changePage('bulk_process')" class="bg-indigo-600 text-white font-bold py-2 px-4 rounded-lg hover:bg-indigo-700">
                                        Impor Pesanan Terkirim
                                    </button>
                                    <button @click="changePage('retur')" class="bg-white border border-slate-300 text-slate-700 font-bold py-2 px-4 rounded-lg hover:bg-slate-50">
                                        Retur
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- STEP 5 -->
                    <div class="group rounded-2xl border border-slate-200 p-5 hover:border-green-300 hover:shadow-lg transition">
                        <div class="flex gap-4">
                            <div class="w-11 h-11 rounded-xl bg-green-600 text-white flex items-center justify-center font-black flex-shrink-0">5</div>
                            <div class="flex-1">
                                <h4 class="font-black text-slate-900 text-lg">Pantau Laporan, Profit, dan ROAS</h4>
                                <p class="text-slate-600 mt-1">
                                    Setelah transaksi masuk, cek Dashboard, Laporan Keuangan, Laporan Transaksi, Dashboard ROAS, dan Kalkulator ROAS.
                                </p>
                                <div class="flex flex-wrap gap-3 mt-4">
                                    <button @click="changePage('dashboard')" class="bg-green-600 text-white font-bold py-2 px-4 rounded-lg hover:bg-green-700">
                                        Dashboard
                                    </button>
                                    <button @click="changePage('roas-dashboard')" class="bg-white border border-slate-300 text-slate-700 font-bold py-2 px-4 rounded-lg hover:bg-slate-50">
                                        Dashboard ROAS
                                    </button>
                                    <button @click="changePage('laporan-keuangan')" class="bg-white border border-slate-300 text-slate-700 font-bold py-2 px-4 rounded-lg hover:bg-slate-50">
                                        Laporan Keuangan
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>

            <!-- SIDE PANEL -->
            <div class="space-y-6">
                <div class="bg-white rounded-3xl border border-slate-200 shadow-xl p-6">
                    <h3 class="text-xl font-black text-slate-900">Checklist Sebelum Jualan</h3>
                    <div class="space-y-3 mt-5 text-sm text-slate-700">
                        <div class="flex gap-3">
                            <span class="text-green-600 font-black">✓</span>
                            <span>Channel penjualan sudah dibuat.</span>
                        </div>
                        <div class="flex gap-3">
                            <span class="text-green-600 font-black">✓</span>
                            <span>Model produk sudah diisi.</span>
                        </div>
                        <div class="flex gap-3">
                            <span class="text-green-600 font-black">✓</span>
                            <span>Produk dan SKU sudah rapi.</span>
                        </div>
                        <div class="flex gap-3">
                            <span class="text-green-600 font-black">✓</span>
                            <span>Stok awal sudah masuk.</span>
                        </div>
                        <div class="flex gap-3">
                            <span class="text-green-600 font-black">✓</span>
                            <span>HPP dan harga jual sudah lengkap.</span>
                        </div>
                    </div>
                </div>

                <div class="bg-gradient-to-br from-indigo-600 to-slate-900 rounded-3xl shadow-xl p-6 text-white">
                    <p class="text-sm font-bold text-indigo-200 uppercase tracking-wide">Tips Penting</p>
                    <h3 class="text-xl font-black mt-2">Jangan langsung input penjualan kalau data dasar belum rapi.</h3>
                    <p class="text-indigo-100 mt-3 text-sm leading-relaxed">
                        Kalau SKU, HPP, channel, atau stok belum lengkap, laporan profit dan ROAS bisa tidak akurat.
                    </p>
                </div>

                <div class="bg-white rounded-3xl border border-slate-200 shadow-xl p-6">
                    <h3 class="text-xl font-black text-slate-900">Butuh bantuan?</h3>
                    <p class="text-slate-600 text-sm mt-2">
                        Hubungi admin kalau bingung saat setup awal.
                    </p>
                    <a :href="'https://wa.me/' + nomorWhatsAppAdmin" target="_blank" class="mt-5 inline-flex w-full justify-center bg-green-500 text-white font-bold py-3 px-5 rounded-xl hover:bg-green-600 transition">
                        Chat Admin WhatsApp
                    </a>
                </div>
            </div>
        </div>

        <!-- FEATURE GUIDE -->
        <div class="mt-8">
            <div class="text-center mb-8">
                <p class="text-indigo-200 font-bold uppercase tracking-wide text-sm">Setelah Data Dasar Siap</p>
                <h3 class="text-3xl sm:text-4xl font-black text-white mt-2">Kenali Modul Utama Fashion OS</h3>
                <p class="text-slate-300 mt-3 max-w-3xl mx-auto">
                    Bagian ini membantu pengguna baru memahami fungsi setiap halaman tanpa harus menebak-nebak.
                </p>
            </div>

            <div class="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-5">

                <div class="bg-white rounded-3xl p-6 shadow-xl border border-slate-200">
                    <div class="text-3xl mb-4">📦</div>
                    <h4 class="font-black text-slate-900 text-lg">Inventaris</h4>
                    <p class="text-slate-600 text-sm mt-2">Tempat mengatur produk, SKU, warna, ukuran, stok fisik, dan alokasi stok.</p>
                    <button @click="changePage('inventaris')" class="mt-4 text-indigo-700 font-bold text-sm">Buka halaman →</button>
                </div>

                <div class="bg-white rounded-3xl p-6 shadow-xl border border-slate-200">
                    <div class="text-3xl mb-4">🏷️</div>
                    <h4 class="font-black text-slate-900 text-lg">Harga & HPP</h4>
                    <p class="text-slate-600 text-sm mt-2">Tempat mengisi modal produk dan harga jual per channel penjualan.</p>
                    <button @click="changePage('harga-hpp')" class="mt-4 text-indigo-700 font-bold text-sm">Buka halaman →</button>
                </div>

                <div class="bg-white rounded-3xl p-6 shadow-xl border border-slate-200">
                    <div class="text-3xl mb-4">🏭</div>
                    <h4 class="font-black text-slate-900 text-lg">Produksi</h4>
                    <p class="text-slate-600 text-sm mt-2">Catat proses produksi, kain, maklun, aktual jadi, dan status pembayaran.</p>
                    <button @click="changePage('produksi')" class="mt-4 text-indigo-700 font-bold text-sm">Buka halaman →</button>
                </div>

                <div class="bg-white rounded-3xl p-6 shadow-xl border border-slate-200">
                    <div class="text-3xl mb-4">🧵</div>
                    <h4 class="font-black text-slate-900 text-lg">Gudang Kain</h4>
                    <p class="text-slate-600 text-sm mt-2">Pantau kain yang dipakai untuk produksi dan sisa kebutuhan bahan.</p>
                    <button @click="changePage('gudang-kain')" class="mt-4 text-indigo-700 font-bold text-sm">Buka halaman →</button>
                </div>

                <div class="bg-white rounded-3xl p-6 shadow-xl border border-slate-200">
                    <div class="text-3xl mb-4">🛒</div>
                    <h4 class="font-black text-slate-900 text-lg">Kasir POS</h4>
                    <p class="text-slate-600 text-sm mt-2">Input penjualan manual, offline, marketplace, atau toko sendiri.</p>
                    <button @click="changePage('transaksi')" class="mt-4 text-indigo-700 font-bold text-sm">Buka halaman →</button>
                </div>

                <div class="bg-white rounded-3xl p-6 shadow-xl border border-slate-200">
                    <div class="text-3xl mb-4">⚡</div>
                    <h4 class="font-black text-slate-900 text-lg">Impor Pesanan Terkirim</h4>
                    <p class="text-slate-600 text-sm mt-2">Impor paket yang sudah cocok dengan data pesanan terkirim dari marketplace.</p>
                    <button @click="changePage('bulk_process')" class="mt-4 text-indigo-700 font-bold text-sm">Buka halaman →</button>
                </div>

                <div class="bg-white rounded-3xl p-6 shadow-xl border border-slate-200">
                    <div class="text-3xl mb-4">↩️</div>
                    <h4 class="font-black text-slate-900 text-lg">Retur</h4>
                    <p class="text-slate-600 text-sm mt-2">Catat produk kembali, alasan retur, dan dampaknya ke stok serta laporan.</p>
                    <button @click="changePage('retur')" class="mt-4 text-indigo-700 font-bold text-sm">Buka halaman →</button>
                </div>

                <div class="bg-white rounded-3xl p-6 shadow-xl border border-slate-200">
                    <div class="text-3xl mb-4">📊</div>
                    <h4 class="font-black text-slate-900 text-lg">ROAS</h4>
                    <p class="text-slate-600 text-sm mt-2">Pantau omset, HPP, diskon, biaya iklan, profit, dan target ROAS per model.</p>
                    <button @click="changePage('roas-dashboard')" class="mt-4 text-indigo-700 font-bold text-sm">Buka halaman →</button>
                </div>

            </div>
        </div>

        <!-- FINAL CTA -->
        <div class="mt-8 bg-white rounded-3xl shadow-xl border border-slate-200 p-6 sm:p-8">
            <div class="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-5">
                <div>
                    <p class="text-sm font-bold text-green-600 uppercase tracking-wide">Siap digunakan</p>
                    <h3 class="text-2xl sm:text-3xl font-black text-slate-900 mt-1">
                        Setelah semua langkah selesai, aplikasi sudah siap dipakai harian.
                    </h3>
                    <p class="text-slate-600 mt-2">
                        Mulai dari input penjualan, pantau stok, produksi, retur, keuangan, sampai analisis ROAS.
                    </p>
                </div>

                <div class="flex flex-wrap gap-3">
                    <button @click="changePage('dashboard')" class="bg-slate-900 text-white font-bold py-3 px-5 rounded-xl hover:bg-slate-800">
                        Buka Dashboard
                    </button>
                    <button @click="changePage('panduan')" class="bg-white border border-slate-300 text-slate-800 font-bold py-3 px-5 rounded-xl hover:bg-slate-50">
                        Panduan Lengkap
                    </button>
                </div>
            </div>
        </div>

    </div>
</div>

<div v-if="activePage === 'tentang'">
    <div class="min-h-screen w-full bg-gradient-to-br from-slate-50 via-white to-indigo-100 p-4 sm:p-8">
        <div class="max-w-4xl mx-auto">
            
            <div class="text-center mb-12 animate-fade-in-up">
                <h2 class="text-4xl md:text-5xl font-extrabold text-slate-800">
                    <span class="bg-gradient-to-r from-indigo-600 to-purple-600 bg-clip-text text-transparent">Tentang Fashion OS</span>
                </h2>
                <p class="text-lg text-slate-600 mt-4 max-w-2xl mx-auto">
                    Dibangun dengan privasi, keamanan, dan pertumbuhan bisnis Anda sebagai prioritas utama.
                </p>
            </div>

            <div class="bg-white/70 backdrop-blur-sm p-8 rounded-2xl shadow-xl border border-slate-200 mb-8 animate-fade-in-up" style="animation-delay: 200ms;">
                <h3 class="text-2xl font-bold text-slate-800 mb-6 text-center">Privasi & Keamanan Data Anda</h3>
                <ul class="space-y-6">
                    <li class="flex items-start gap-4">
                        <div class="flex-shrink-0 w-12 h-12 rounded-lg bg-indigo-100 text-indigo-600 flex items-center justify-center">
                             <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2"><path stroke-linecap="round" stroke-linejoin="round" d="M8 9l4-4 4 4m0 6l-4 4-4-4" /></svg>
                        </div>
                        <div>
                            <h4 class="font-semibold text-slate-800">Arsitektur Data Langsung</h4>
                            <p class="text-sm text-slate-600 mt-1">
                                Aplikasi ini dirancang agar data operasional Anda (penjualan, produk, keuangan) dikirim **langsung dari browser Anda ke database**.Untuk Pihak Pengembang aplikasi tidak memiliki server perantara yang menyimpan atau melihat data sensitif Anda.
                            </p>
                        </div>
                    </li>
                    <li class="flex items-start gap-4">
                        <div class="flex-shrink-0 w-12 h-12 rounded-lg bg-indigo-100 text-indigo-600 flex items-center justify-center">
                            <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2"><path stroke-linecap="round" stroke-linejoin="round" d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" /></svg>
                        </div>
                        <div>
                            <h4 class="font-semibold text-slate-800">Kontrol Penuh di Tangan Anda</h4>
                            <p class="text-sm text-slate-600 mt-1">
                                Akun Anda terhubung ke database terpusat yang dikelola oleh kami, namun setiap data **selalu ditandai dengan ID unik milik Anda**. Sistem keamanan kami memastikan bahwa Anda hanya bisa mengakses data Anda sendiri, dan kami sebagai pengembang **tidak memiliki akses untuk melihat isi data pribadi setiap pengguna.**
                            </p>
                        </div>
                    </li>
                    <li class="flex items-start gap-4">
                        <div class="flex-shrink-0 w-12 h-12 rounded-lg bg-indigo-100 text-indigo-600 flex items-center justify-center">
                            <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2"><path stroke-linecap="round" stroke-linejoin="round" d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" /></svg>
                        </div>
                        <div>
                            <h4 class="font-semibold text-slate-800">Standar Keamanan Tinggi</h4>
                            <p class="text-sm text-slate-600 mt-1">
                                Setiap transmisi data dilindungi oleh enkripsi HTTPS/TLS, protokol keamanan canggih yang sama seperti yang digunakan oleh lembaga perbankan global.
                            </p>
                        </div>
                    </li>
                </ul>
            </div>
            <div class="bg-white/70 backdrop-blur-sm p-8 rounded-2xl shadow-xl border border-slate-200 animate-fade-in-up" style="animation-delay: 300ms;">
                 <h3 class="text-2xl font-bold text-slate-800 mb-6 text-center">Informasi Aplikasi</h3>
                 <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 text-sm">
                    <div class="bg-slate-50 p-4 rounded-lg border border-slate-200">
                        <p class="font-semibold text-slate-600">Dikembangkan oleh</p>
                        <p class="text-slate-800">Arrasyid</p>
                    </div>
                    <div class="bg-slate-50 p-4 rounded-lg border border-slate-200">
                        <p class="font-semibold text-slate-600">Informasi Kontak</p>
                        <p><a href="mailto:fashion234oss@gmail.com" class="text-blue-600 hover:underline">fashion234oss@gmail.com</a></p>
                    </div>
                    <div class="bg-slate-50 p-4 rounded-lg border border-slate-200">
                        <p class="font-semibold text-slate-600">Versi Aplikasi</p>
                        <p class="text-slate-800">1.0.0 (Build 20251004)</p>
                    </div>
                </div>
            </div>

        </div>
    </div>
</div>

<div v-if="activePage === 'supplier'">
    <div class="min-h-screen w-full bg-gradient-to-br from-slate-50 via-white to-indigo-100 p-4 sm:p-8">
        <div class="max-w-7xl mx-auto">

            <div v-show="uiState.activeSupplierView !== 'form'" class="animate-fade-in-up">
                
                <div class="flex flex-wrap justify-between items-center gap-4 mb-8">
                    <div>
                        <h2 class="text-3xl font-bold text-slate-800">Manajemen Supplier</h2>
                        <p class="text-slate-500 mt-1">Kelola data supplier dan riwayat pesanan pembelian Anda.</p>
                    </div>
                    <div class="flex items-center gap-3">
                        <button 
                            v-if="uiState.activeSupplierView === 'produkList'" 
                            @click="uiState.activeSupplierView = 'list'" 
                            class="bg-white border border-slate-300 text-slate-700 font-bold py-2.5 px-5 rounded-lg hover:bg-slate-100 shadow-sm transition-colors"
                        >
                            &laquo; Kembali ke Daftar Supplier
                        </button>
                        <button 
                            v-if="uiState.activeSupplierView === 'list'" 
                            @click="uiState.activeSupplierView = 'produkList'" 
                            class="bg-white border border-slate-300 text-slate-700 font-bold py-2.5 px-5 rounded-lg hover:bg-slate-100 shadow-sm transition-colors"
                        >
                            Lihat Produk Supplier
                        </button>
                        <button 
    @click="showModal('masterHargaSupplier')" 
    class="bg-indigo-600 text-white px-4 py-2 rounded-lg font-bold hover:bg-indigo-700 flex items-center gap-2 shadow-lg"
>
    <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
    </svg>
    Update Master Harga Supplier
</button>
                        <button 
                            @click="showModal('addSupplier', { name: '', contact: '' })" 
                            class="bg-indigo-600 text-white font-bold py-2.5 px-5 rounded-lg hover:bg-indigo-700 shadow transition-colors" 
                            :disabled="!isSubscriptionActive"
                        >
                            + Tambah Supplier Baru
                        </button>
                    </div>
                </div>

                <div 
                    v-show="uiState.activeSupplierView === 'list'" 
                    class="bg-white/70 backdrop-blur-sm p-6 sm:p-8 rounded-2xl shadow-xl border border-slate-200 mb-8"
                >
                    <h3 class="text-xl font-bold text-slate-800 mb-4 pb-4 border-b">Daftar Supplier</h3>
                    <div class="overflow-x-auto">
                        <table class="w-full text-sm text-left text-slate-500">
                            <thead class="text-xs text-slate-700 uppercase bg-slate-100/50">
                                <tr>
                                    <th class="px-6 py-3">Nama Supplier</th>
                                    <th class="px-6 py-3">Kontak</th>
                                    <th class="px-6 py-3 text-right" style="width: 250px;">Aksi</th>
                                </tr>
                            </thead>
                            <tbody class="divide-y divide-slate-200/50">
                                <tr v-if="state.suppliers.length === 0">
                                    <td colspan="3" class="p-10 text-center text-slate-500">Tidak ada data supplier.</td>
                                </tr>
                                <tr v-for="supplier in state.suppliers" :key="supplier.id" class="hover:bg-slate-50/50">
                                    <td class="px-6 py-4 font-semibold text-slate-800">{{ supplier.name }}</td>
                                    <td class="px-6 py-4">{{ supplier.contact || '-' }}</td>
                                    <td class="px-6 py-4 text-right space-x-3 whitespace-nowrap" style="width: 250px;">
                                        <button @click="showPenerimaanBarangForm(supplier)" class="font-semibold text-green-500 hover:underline" :disabled="!isSubscriptionActive">Buat Pesanan</button>
                                        <button @click="showModal('editSupplier', JSON.parse(JSON.stringify(supplier)))" class="font-semibold text-blue-500 hover:underline" :disabled="!isSubscriptionActive">Edit</button>
                                        <button @click="deleteSupplier(supplier.id)" class="text-red-500 hover:text-red-700" :disabled="!isSubscriptionActive">
                                            <svg class="w-5 h-5 inline-block" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"></path></svg>
                                        </button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                
                <div 
                    v-show="uiState.activeSupplierView === 'list'" 
                    class="bg-white/70 backdrop-blur-sm p-6 sm:p-8 rounded-2xl shadow-xl border border-slate-200"
                >
                    <h3 class="text-xl font-bold text-slate-800 mb-4 pb-4 border-b">Riwayat Penerimaan Barang</h3>
                    <div class="p-4 bg-slate-50/50 rounded-xl border shadow-sm mb-6">
                        <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 items-end">
                            <div>
                                <label class="block text-sm font-medium mb-1">Cari Supplier / SKU</label>
                                <input type="text" v-model="uiState.purchaseOrderSearch" placeholder="Ketik nama supplier atau SKU..." class="w-full p-2 border rounded-md bg-white shadow-sm">
                            </div>
                            <div>
                                <label class="block text-sm font-medium mb-1">Filter Status Proses</label>
                                <select v-model="uiState.purchaseOrderStatusProsesFilter" class="w-full p-2 border rounded-md bg-white shadow-sm">
                                    <option value="all">Semua Status</option>
                                    <option value="Dalam Proses">Dalam Proses</option>
                                    <option value="Selesai">Selesai</option>
                                    <option value="Revisi">Revisi</option>
                                </select>
                            </div>
                            <div>
                                <label class="block text-sm font-medium mb-1">Filter Status Bayar</label>
                                <select v-model="uiState.purchaseOrderStatusBayarFilter" class="w-full p-2 border rounded-md bg-white shadow-sm">
                                    <option value="all">Semua Status</option>
                                    <option value="Belum Dibayar">Belum Dibayar</option>
                                    <option value="Proses Pembayaran">Proses Pembayaran</option>
                                    <option value="Sudah Dibayar">Sudah Dibayar</option>
                                </select>
                            </div>
                            <div>
                                <label class="block text-sm font-medium mb-1">Urutkan</label>
                                <select v-model="uiState.purchaseOrderSort" class="w-full p-2 border rounded-md bg-white shadow-sm">
                                    <option value="tanggal-desc">Tanggal (Terbaru)</option>
                                    <option value="tanggal-asc">Tanggal (Terlama)</option>
                                    <option value="total-desc">Total Nilai (Tertinggi)</option>
                                    <option value="total-asc">Total Nilai (Terendah)</option>
                                </select>
                            </div>
                            <div class="lg:col-span-4">
                                <label class="block text-sm font-medium mb-1">Filter Waktu</label>
                                <div class="flex flex-wrap items-center gap-2">
                                    <select v-model="uiState.purchaseOrderDateFilter" class="flex-grow bg-white border-slate-300 text-sm rounded-lg p-2.5 shadow-sm capitalize">
                                        <option value="all_time">Semua Waktu</option>
                                        <option value="today">Hari Ini</option>
                                        <option value="last_7_days">7 Hari Terakhir</option>
                                        <option value="last_30_days">30 Hari Terakhir</option>
                                        <option value="this_year">Tahun Ini</option>
                                        <option value="by_month_range">Rentang Bulan</option>
                                        <option value="by_year_range">Rentang Tahun</option>
                                    </select>
                                    <div v-if="uiState.purchaseOrderDateFilter === 'by_month_range'" class="flex flex-wrap items-center gap-2">
                                        <select v-model.number="uiState.purchaseOrderStartMonth" class="border-slate-300 text-sm rounded-lg p-2"><option v-for="m in 12" :key="m" :value="m">{{ new Date(0, m - 1).toLocaleString('id-ID', { month: 'long' }) }}</option></select>
                                        <input type="number" v-model.number="uiState.purchaseOrderStartYear" class="w-24 border-slate-300 text-sm rounded-lg p-2" placeholder="Tahun">
                                        <span class="mx-2">s/d</span>
                                        <select v-model.number="uiState.purchaseOrderEndMonth" class="border-slate-300 text-sm rounded-lg p-2"><option v-for="m in 12" :key="m" :value="m">{{ new Date(0, m - 1).toLocaleString('id-ID', { month: 'long' }) }}</option></select>
                                        <input type="number" v-model.number="uiState.purchaseOrderEndYear" class="w-24 border-slate-300 text-sm rounded-lg p-2" placeholder="Tahun">
                                    </div>
                                    <div v-if="uiState.purchaseOrderDateFilter === 'by_year_range'" class="flex items-center gap-2">
                                        <input type="number" v-model.number="uiState.purchaseOrderStartYear" placeholder="Dari Tahun" class="w-full border-slate-300 text-sm rounded-lg p-2">
                                        <span>s/d</span>
                                        <input type="number" v-model.number="uiState.purchaseOrderEndYear" placeholder="Sampai Tahun" class="w-full border-slate-300 text-sm rounded-lg p-2">
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="lg:col-span-4 flex justify-end">
                            <button @click="requestProtectedExport(() => exportPurchaseOrdersToExcel())" class="bg-green-600 text-white font-bold py-2.5 px-4 rounded-lg hover:bg-green-700 text-sm h-[42px] flex-shrink-0" :disabled="!isSubscriptionActive">
                                Export ke Excel
                            </button>
                        </div>
                    </div>
                    <div class="overflow-x-auto">
                        <table class="w-full text-sm text-left text-slate-500">
                            <thead class="text-xs text-slate-700 uppercase bg-slate-100/50">
                                <tr>
                                    <th class="px-4 py-3">Tanggal</th>
                                    <th class="px-4 py-3">Supplier</th>
                                    <th class="px-4 py-3">Produk</th>
                                    <th class="px-4 py-3 text-right">Harga</th>
                                    <th class="px-4 py-3 text-center">Jumlah Barang</th>
                                    <th class="px-4 py-3 text-right">Total Nilai Barang</th>
                                    <th class="px-4 py-3">Status Proses</th>
                                    <th class="px-4 py-3">Status Bayar</th>
                                    <th class="px-4 py-3">Retur</th>
                                    <th class="px-4 py-3 text-right">Aksi</th>
                                </tr>
                            </thead>
                            <tbody class="divide-y divide-slate-200/50">
                                <tr v-if="itemizedPurchaseHistory.length === 0">
                                    <td colspan="10" class="p-10 text-center text-slate-500">Belum ada riwayat penerimaan barang.</td>
                                </tr>
                                <tr v-for="(item, index) in itemizedPurchaseHistory" :key="`${item.orderId}-${index}`" class="hover:bg-slate-50/50">
    <td class="px-4 py-3">{{ new Date(item.tanggal).toLocaleDateString('id-ID') }}</td>
    <td class="px-4 py-3 font-semibold text-slate-800">{{ item.supplierName }}</td>
    <td class="px-4 py-3">
        <p class="font-semibold">{{ item.modelName }}</p>
        <p class="text-xs">{{ item.sku }} ({{ item.color }} / {{ item.size }})</p>
    </td>
    <td class="px-4 py-3 text-right">{{ formatCurrency(item.hargaJual) }}</td>
    <td class="px-4 py-3 text-center font-medium">{{ item.qty }}</td>
    <td class="px-4 py-3 text-right font-bold text-green-600">{{ formatCurrency(item.hargaJual * item.qty) }}</td>
    <td class="px-4 py-3">{{ item.statusProses }}</td>
    <td class="px-4 py-3 text-center">
    <span class="text-xs font-semibold px-2.5 py-1 rounded-full capitalize whitespace-nowrap" :class="{
            'bg-green-100 text-green-800': item.orderStatusPembayaran === 'Lunas' || item.orderStatusPembayaran === 'Sudah Dibayar',
            'bg-yellow-100 text-yellow-800': item.orderStatusPembayaran === 'Cicilan' || item.orderStatusPembayaran === 'Proses Pembayaran',
            'bg-red-100 text-red-800': item.orderStatusPembayaran === 'Belum Dibayar',
          }">
        {{ item.orderStatusPembayaran }}
    </span>
</td>
    <td class="px-4 py-3">{{ item.returReason || 'Tidak Retur' }}</td>

    <td class="px-4 py-3 text-right space-x-3 whitespace-nowrap">
    <button
        v-if="item.orderStatusPembayaran !== 'Lunas'"
        @click="showModal('supplierPayment', filteredPurchaseOrders.find(o => o.id === item.orderId))"
        class="font-semibold text-green-500 hover:underline"
        :disabled="!isSubscriptionActive"
    >
        Bayar/Cicil
    </button>
    
    <button 
        @click="showModal('viewPurchaseOrder', filteredPurchaseOrders.find(o => o.id === item.orderId))" 
        class="font-semibold text-indigo-500 hover:underline"
    >
        Detail
    </button>

    <button @click="showEditPenerimaanBarangForm(filteredPurchaseOrders.find(o => o.id === item.orderId))" class="font-semibold text-blue-500 hover:underline">Edit</button>
    <button @click="deletePurchaseOrder(item.orderId)" class="text-red-500 hover:text-red-700">
        <svg class="w-5 h-5 inline-block" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"></path></svg>
    </button>
</td>
    </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
<div v-if="uiState.purchaseOrdersHasMore" class="mt-4 text-center">
    <button @click="fetchSupplierData(currentUser.uid, true)" class="bg-white border border-slate-300 text-slate-700 font-bold py-2 px-5 rounded-lg hover:bg-slate-100 shadow-sm transition-colors">
        Muat Lebih Banyak
    </button>
</div>
                <div v-show="uiState.activeSupplierView === 'produkList'" class="bg-white/70 backdrop-blur-sm p-6 sm:p-8 rounded-2xl shadow-xl border border-slate-200">
    <h3 class="text-xl font-bold text-slate-800 mb-4 pb-4 border-b">Riwayat Produk dari Supplier</h3>
    
    <div class="mb-4">
        <label for="inventory-status-filter" class="block text-sm font-medium text-slate-700 mb-1">Filter Status Inventaris</label>
        <select v-model="uiState.purchaseOrderItemStatusFilter" id="inventory-status-filter" class="w-full md:w-1/3 p-2 border border-slate-300 rounded-md bg-white shadow-sm">
            <option value="all">Semua Status</option>
            <option value="belumMasuk">Belum Masuk Inventaris</option>
            <option value="sudahMasuk">Sudah Masuk</option>
        </select>
    </div>
    <div class="overflow-x-auto">
        <table class="w-full text-sm text-left text-slate-500">
            <thead class="text-xs text-slate-700 uppercase bg-slate-100/50">
                <tr>
                    <th class="px-4 py-3">Tanggal</th>
                    <th class="px-4 py-3">Supplier</th>
                    <th class="px-4 py-3">Produk</th>
                    <th class="px-4 py-3 text-right">Harga Beli</th>
                    <th class="px-4 py-3 text-center">Qty</th>
                    <th class="px-4 py-3 text-center">Status Inventaris</th>
                </tr>
            </thead>
            <tbody class="divide-y divide-slate-200/50">
                <tr v-if="itemizedPurchaseHistory.length === 0">
                    <td colspan="6" class="p-10 text-center text-slate-500">Tidak ada produk yang cocok dengan filter.</td>
                </tr>
                <tr v-for="(item, index) in itemizedPurchaseHistory" :key="`${item.orderId}-${index}`" class="hover:bg-slate-50/50">
                    <td class="px-4 py-3">{{ new Date(item.tanggal).toLocaleDateString('id-ID') }}</td>
                    <td class="px-4 py-3 font-semibold text-slate-800">{{ item.supplierName }}</td>
                    <td class="px-4 py-3">
                        <p class="font-semibold">{{ item.modelName }}</p>
                        <p class="text-xs">{{ item.sku }} ({{ item.color }} / {{ item.size }})</p>
                    </td>
                    <td class="px-4 py-3 text-right">{{ formatCurrency(item.hargaJual) }}</td>
                    <td class="px-4 py-3 text-center font-medium">{{ item.qty }}</td>
                    <td class="px-4 py-3 text-center">
                        <span v-if="item.isInventoried" class="text-green-600 font-bold flex items-center justify-center text-xs">
                            <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4 mr-1" viewBox="0 0 20 20" fill="currentColor"><path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd" /></svg>
                            Sudah Masuk
                        </span>
                        <button 
                            v-else 
                            @click="addPurchaseOrderItemToInventory(item)" 
                            class="bg-blue-600 text-white font-bold text-xs py-1 px-3 rounded-md hover:bg-blue-700" 
                            :disabled="!isSubscriptionActive"
                        >
                            Masukkan ke Inventaris
                        </button>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</div>
</div>
            <div v-if="uiState.activeSupplierView === 'form'" class="animate-fade-in-up">
                <div class="flex justify-between items-center mb-8">
                    <div>
                        <h2 class="text-3xl font-bold text-slate-800">Penerimaan Barang</h2>
                        <p class="text-slate-500 mt-1">Buat pesanan baru dari supplier: <span class="font-semibold">{{ uiState.penerimaanBarangForm.supplierName }}</span></p>
                    </div>
                </div>

                <div class="bg-white/70 backdrop-blur-sm p-6 sm:p-8 rounded-2xl shadow-xl border border-slate-200">
                    <form @submit.prevent="submitPenerimaanBarang" class="space-y-4">
                        <div class="grid grid-cols-1 md:grid-cols-3 gap-4">
                            <div>
                                <label class="block text-sm font-medium">Tanggal</label>
                                <input type="date" v-model="uiState.penerimaanBarangForm.tanggal" class="mt-1 w-full p-2 border rounded-md" required>
                            </div>
                            <div>
                                <label class="block text-sm font-medium">Catatan</label>
                                <input type="text" v-model="uiState.penerimaanBarangForm.catatan" class="mt-1 w-full p-2 border rounded-md">
                            </div>
                            <div class="relative">
                                <label class="block text-sm font-medium">Pilih Produk</label>
                                <div class="flex gap-2">
                                    <select v-model="uiState.selectedProductForPurchase" class="mt-1 w-full p-2 border rounded-md" :class="{'text-slate-400': !uiState.selectedProductForPurchase}" required>
                                        <option :value="null" disabled>-- Pilih Produk Inventaris --</option>
                                        <option v-for="product in state.produk" :key="product.sku" :value="product">{{ product.nama }} ({{ product.sku }})</option>
                                    </select>
                                    <button @click.prevent="addProductFromSelection" type="button" class="bg-indigo-600 text-white font-bold px-4 rounded-lg flex-shrink-0" :disabled="!uiState.selectedProductForPurchase">+ Tambah</button>
                                </div>
                            </div>
                        </div>

                        <div class="mt-8">
                            <h4 class="text-lg font-bold mb-2">Daftar Produk Pesanan</h4>
                            <div class="overflow-x-auto max-h-96">
                                <table class="w-full text-sm text-left text-slate-500">
                                    <thead class="text-xs text-slate-700 uppercase bg-slate-100/50 sticky top-0">
                                        <tr>
                                            <th class="px-4 py-3">Produk</th>
                                            <th class="px-4 py-3 text-right">Harga Jual</th>
                                            <th class="px-4 py-3 text-center">Qty</th>
                                            <th class="px-4 py-3 text-right">Total</th>
                                            <th class="px-4 py-3">Status Proses</th>
                                            <th class="px-4 py-3">Status Bayar</th>
                                            <th class="px-4 py-3">Retur</th>
                                            <th class="px-4 py-3">Aksi</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-if="uiState.penerimaanBarangForm.produk.length === 0">
                                            <td colspan="8" class="p-4 text-center text-slate-500">Daftar pesanan kosong.</td>
                                        </tr>
                                        <tr v-for="(p, index) in uiState.penerimaanBarangForm.produk" :key="p.sku">
                                            <td class="px-4 py-3">
                                                <p class="font-semibold text-slate-800">{{ p.nama }}</p>
                                                <p class="text-xs">{{ p.sku }} ({{ p.warna }} / {{ p.varian }})</p>
                                            </td>
                                            <td class="px-4 py-3">
                                                <input type="number" v-model.number="p.hargaJual" class="w-full p-1 border rounded-md text-sm text-right">
                                            </td>
                                            <td class="px-4 py-3">
                                                <input type="number" v-model.number="p.qty" class="w-20 p-1 border rounded-md text-sm text-center">
                                            </td>
                                            <td class="px-4 py-3 text-right font-bold text-indigo-600">
                                                {{ formatCurrency(p.hargaJual * p.qty) }}
                                            </td>
                                            <td class="px-4 py-3">
                                                <select v-model="p.statusProses" class="w-full p-1 border rounded-md text-xs">
                                                    <option>Dalam Proses</option>
                                                    <option>Selesai</option>
                                                    <option>Revisi</option>
                                                </select>
                                            </td>
                                            <td class="px-4 py-3">
                                                <select v-model="p.statusPembayaran" class="w-full p-1 border rounded-md text-xs">
                                                    <option>Belum Dibayar</option>
                                                    <option>Proses Pembayaran</option>
                                                    <option>Sudah Dibayar</option>
                                                </select>
                                            </td>
                                            <td class="px-4 py-3">
                                                <select v-model="p.returReason" class="w-full p-1 border rounded-md text-xs">
                                                    <option :value="null">Tidak Retur</option>
                                                    <option>Cacat</option>
                                                    <option>Salah Warna</option>
                                                    <option>Salah Ukuran</option>
                                                </select>
                                            </td>
                                            <td class="px-4 py-3">
                                                <button @click.prevent="removeProductFromPenerimaanBarang(index)" type="button" class="text-red-500 hover:underline text-xs">Hapus</button>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        

                        <div class="flex justify-end gap-3 mt-8 pt-4 border-t">
                            <button @click.prevent="hidePenerimaanBarangForm" type="button" class="bg-slate-200 py-2 px-4 rounded-lg">Batal</button>
                            <button type="submit" class="bg-indigo-600 text-white py-2 px-4 rounded-lg">Simpan Penerimaan</button>
                        </div>
                    </form>
                </div>
            </div>
            
        </div>
    </div>
</div>

<div v-if="activePage === 'langganan'">
    <div class="min-h-screen w-full bg-gradient-to-br from-slate-50 via-white to-indigo-100 p-4 sm:p-8 flex items-center justify-center">

        <div v-if="isSubscriptionActive && userProfile.data?.subscriptionStatus === 'active'" class="w-full max-w-4xl animate-fade-in">
            <div class="bg-white p-8 sm:p-12 rounded-2xl shadow-2xl border border-green-200 flex flex-col items-center">
                <div class="w-16 h-16 bg-green-100 text-green-600 rounded-full flex items-center justify-center mb-6">
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-8 w-8" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2"><path stroke-linecap="round" stroke-linejoin="round" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" /></svg>
                </div>
                <h2 class="text-3xl font-bold text-slate-800 mb-2">Langganan Anda Aktif! 🎉</h2>
                <p class="text-slate-600 mb-6 max-w-xl text-center">
                    Selamat, Anda memiliki akses penuh ke semua fitur premium kami.
                </p>
                <div class="bg-green-50 text-green-800 px-6 py-4 rounded-lg w-full text-center border border-green-200">
                    <p class="text-lg font-semibold">Status Langganan: Aktif</p>
                    <p v-if="userProfile.data?.subscriptionEndDate" class="text-sm mt-1">
                        Berakhir pada: {{ new Date(userProfile.data.subscriptionEndDate.seconds ? userProfile.data.subscriptionEndDate.seconds * 1000 : userProfile.data.subscriptionEndDate).toLocaleString('id-ID', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric', hour: '2-digit', minute: '2-digit' }) }}
                    </p>
                </div>
            </div>
        </div>

        <div v-else-if="isSubscriptionActive && userProfile.data?.subscriptionStatus === 'trial'" class="w-full max-w-4xl animate-fade-in">
            <div class="bg-white p-8 sm:p-12 rounded-2xl shadow-2xl border border-blue-200 flex flex-col items-center">
                <div class="w-16 h-16 bg-blue-100 text-blue-600 rounded-full flex items-center justify-center mb-6">
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-8 w-8" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                        <path stroke-linecap="round" stroke-linejoin="round" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                    </svg>
                </div>
                <h2 class="text-3xl font-bold text-slate-800 mb-2">Masa Uji Coba Gratis Anda Aktif!</h2>
                <p class="text-slate-600 mb-6 max-w-xl text-center">
                    Nikmati semua fitur premium selama masa uji coba. Untuk melanjutkan setelahnya, silakan pilih paket langganan.
                </p>
                <div class="bg-blue-50 text-blue-800 px-6 py-4 rounded-lg w-full text-center border border-blue-200">
                    <p class="text-lg font-semibold">Status: Uji Coba (Trial)</p>
                    <p v-if="userProfile.data?.trialEndDate" class="text-sm mt-1">
                        Berakhir pada: {{ new Date(userProfile.data.trialEndDate.seconds * 1000).toLocaleString('id-ID', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric', hour: '2-digit', minute: '2-digit' }) }}
                    </p>
                </div>
            </div>
        </div>

        <div v-else class="max-w-5xl mx-auto text-center">
            <h2 class="text-4xl md:text-5xl font-extrabold text-slate-800 animate-fade-in-up">
                <span class="bg-gradient-to-r from-indigo-600 to-purple-600 bg-clip-text text-transparent">Mulai Langganan Anda</span>
            </h2>
            <p class="text-lg text-slate-600 mt-4 mb-10 max-w-2xl mx-auto animate-fade-in-up" style="animation-delay: 100ms;">
                Pilih paket di bawah ini atau masukkan kode aktivasi jika Anda sudah melakukan pembayaran di luar aplikasi.
            </p>

            <div class="max-w-xl mx-auto mb-8 p-6 rounded-xl border-2 border-dashed border-green-400 bg-white/70 backdrop-blur-sm text-left animate-fade-in-up" style="animation-delay: 200ms;">
                <h3 class="text-lg font-semibold text-green-700">Punya Kode Aktivasi? (Dari Shopee, dll.)</h3>
                <p class="text-sm text-slate-600 mb-2">
                    Jika Anda sudah membayar, masukkan kode aktivasi yang Anda terima di sini untuk mengaktifkan langganan Anda.
                </p>
                <div class="flex gap-2">
                    <input type="text" v-model="activationCodeInput" class="w-full p-2 border bg-white/50 border-slate-300 rounded-md text-slate-800 placeholder-slate-400" placeholder="Masukkan Kode Aktivasi...">
                    <button @click.prevent="handleActivation" :disabled="isSaving" class="bg-green-600 text-white font-bold py-2 px-4 rounded-lg hover:bg-green-700 transition-colors disabled:bg-green-400">
                        <span v-if="isSaving && activationCodeMessage">...</span>
                        <span v-else>Aktifkan</span>
                    </button>
                </div>
                <p v-if="activationCodeMessage" class="mt-2 text-xs font-medium text-red-600">
                    {{ activationCodeMessage }}
                </p>
            </div>

            <div class="max-w-xl mx-auto mb-12 p-6 rounded-xl border border-dashed border-indigo-300 bg-white/70 backdrop-blur-sm text-left animate-fade-in-up" style="animation-delay: 300ms;">
                <h3 class="text-lg font-semibold text-indigo-700">Punya Kode Rujukan? (Untuk Diskon)</h3>
                <p v-if="!userProfile.data?.referredBy" class="text-sm text-slate-600 mb-2">
                    Silahkan masukan kodenya.
                </p>
                <div v-if="!userProfile.data?.referredBy" class="flex gap-2">
                    <input type="text" v-model="uiState.referralCodeInput" class="w-full p-2 border bg-white/50 border-slate-300 rounded-md text-slate-800 placeholder-slate-400">
                    <button @click.prevent="applyReferralCode" class="bg-indigo-600 text-white font-bold py-2 px-4 rounded-lg hover:bg-indigo-700 transition-colors">Terapkan</button>
                </div>
                <p v-if="uiState.referralCodeMessage" class="mt-2 text-xs font-medium" :class="uiState.referralCodeApplied ? 'text-green-600' : 'text-red-500'">
                    {{ uiState.referralCodeMessage }}
                </p>
                <p v-if="userProfile.data?.referredBy" class="text-sm text-green-600 font-medium">
                    Selamat! Diskon rujukan sudah berlaku selamanya untuk akun Anda.
                </p>
            </div>

            <div class="flex flex-col md:flex-row items-center justify-center gap-8">
                <div class="bg-white p-8 rounded-2xl shadow-lg border w-full md:w-96 transform hover:-translate-y-2 hover:shadow-2xl transition-all duration-300 animate-fade-in-up" style="animation-delay: 400ms;">
                    <h3 class="text-xl font-semibold text-slate-800">Paket Bulanan</h3>
                    <div v-if="uiState.referralCodeApplied || userProfile.data?.referredBy" class="my-4">
                        <p class="text-2xl font-bold line-through text-slate-400">{{ formatCurrency(monthlyPrice) }}</p>
                        <p class="text-4xl font-bold text-green-600">{{ formatCurrency(discountedMonthlyPrice) }} <span class="text-base font-normal text-slate-500">/bulan</span></p>
                    </div>
                    <p v-else class="text-4xl font-bold my-4 text-slate-900">
                        {{ formatCurrency(monthlyPrice) }} <span class="text-base font-normal text-slate-500">/bulan</span>
                    </p>
                    <ul class="text-left space-y-3 text-slate-600 mt-6">
                        <li class="flex items-center gap-3"><svg class="w-5 h-5 text-indigo-500" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" /></svg>Akses semua fitur</li>
                        <li class="flex items-center gap-3"><svg class="w-5 h-5 text-indigo-500" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" /></svg>Dukungan prioritas</li>
                        <li class="flex items-center gap-3"><svg class="w-5 h-5 text-indigo-500" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" /></svg>Update berkala</li>
                    </ul>
                    <button @click="handleSubscriptionMayar('bulanan')" :disabled="isSubscribingMonthly" class="mt-8 w-full border border-indigo-600 text-indigo-600 font-bold py-3 px-8 rounded-lg hover:bg-indigo-50 transition-colors disabled:bg-slate-200 disabled:text-slate-500 disabled:border-slate-200">
                        <span v-if="isSubscribingMonthly">Memproses...</span>
                        <span v-else>Pilih Paket Bulanan</span>
                    </button>
                </div>
                <div class="relative bg-white p-8 rounded-2xl shadow-2xl border-2 border-indigo-500 w-full md:w-96 transform hover:-translate-y-2 hover:shadow-indigo-200 transition-all duration-300 animate-fade-in-up" style="animation-delay: 500ms;">
                    <div class="absolute top-0 right-6 -mt-3 bg-indigo-600 text-white text-xs font-bold px-3 py-1 rounded-full uppercase tracking-wider">Paling Hemat</div>
                    <h3 class="text-xl font-semibold text-slate-800">Paket Tahunan</h3>
                    <div v-if="uiState.referralCodeApplied || userProfile.data?.referredBy" class="my-4">
                        <p class="text-2xl font-bold line-through text-slate-400">{{ formatCurrency(yearlyPrice) }}</p>
                        <p class="text-4xl font-bold text-green-600">{{ formatCurrency(discountedYearlyPrice) }} <span class="text-base font-normal text-slate-500">/tahun</span></p>
                    </div>
                    <p v-else class="text-4xl font-bold my-4 text-slate-900">
                        {{ formatCurrency(yearlyPrice) }} <span class="text-base font-normal text-slate-500">/tahun</span>
                    </p>
                    <ul class="text-left space-y-3 text-slate-600 mt-6">
                        <li class="flex items-center gap-3"><svg class="w-5 h-5 text-indigo-500" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" /></svg>Akses semua fitur</li>
                        <li class="flex items-center gap-3"><svg class="w-5 h-5 text-indigo-500" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" /></svg>Dukungan prioritas</li>
                        <li class="flex items-center gap-3"><svg class="w-5 h-5 text-indigo-500" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" /></svg>Update berkala</li>
                        <li class="flex items-center gap-3 font-semibold text-green-600"><svg class="w-5 h-5 text-green-500" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" /></svg>Diskon setara 2 bulan!</li>
                    </ul>
                    <button @click="handleSubscriptionMayar('tahunan')" :disabled="isSubscribingYearly" class="mt-8 w-full bg-indigo-600 text-white font-bold py-3 px-8 rounded-lg hover:bg-indigo-700 transition-colors shadow-lg shadow-indigo-600/30 disabled:bg-slate-400 disabled:shadow-none">
                        <span v-if="isSubscribingYearly">Memproses...</span>
                        <span v-else>Pilih Paket Tahunan</span>
                    </button>
                </div>
            </div>
        </div>

    </div>
</div>

</div>
</main>
    </div>

    <!-- Modal System -->
     
    <div v-if="uiState.isModalVisible" class="fixed inset-0 bg-black bg-opacity-50 z-40 flex items-start justify-center p-20">
        
        <div v-if="uiState.modalType === 'aturHargaMassal'" class="bg-white rounded-lg shadow-xl p-6 max-w-5xl w-full h-full md:max-h-[100vh] flex flex-col">
    <div class="flex-shrink-0 pb-4 border-b">
        <h3 class="text-2xl font-bold text-slate-800">Atur Harga Massal</h3>
        <p class="text-slate-500 mt-1">Untuk Model: <span class="font-semibold">{{ uiState.modalData.groupName }}</span></p>
    </div>
    
    <div class="flex-1 overflow-y-auto py-4 pr-2 grid grid-cols-1 md:grid-cols-2 gap-8">
        <div class="space-y-6">
            <div>
                <h4 class="font-semibold text-slate-700 mb-2">1. Filter Varian (Opsional)</h4>
                <div class="p-4 bg-slate-50 rounded-lg border space-y-3">
                    <div>
                        <label class="block text-sm font-medium">Filter berdasarkan Ukuran</label>
                        <input type="text" v-model="uiState.massPriceFilterUkuran" placeholder="masukan ukuran" class="mt-1 w-full p-2 border rounded-md">
                    </div>
                    <div>
                        <label class="block text-sm font-medium">Filter berdasarkan Warna</label>
                        <input type="text" v-model="uiState.massPriceFilterWarna" placeholder="masukan warna" class="mt-1 w-full p-2 border rounded-md">
                    </div>
                </div>
            </div>

            <div>
                <h4 class="font-semibold text-slate-700 mb-2">2. Masukkan HPP Baru (Opsional)</h4>
                <div class="p-4 bg-slate-50 rounded-lg border">
                    <label class="block text-sm font-medium">Harga Pokok Produksi (HPP)</label>
                    <input type="number" v-model.number="uiState.massPriceHppInput" placeholder="Kosongkan jika tidak ingin diubah" class="mt-1 w-full p-2 border rounded-md">
                </div>
            </div>
            <div>
                <h4 class="font-semibold text-slate-700 mb-2">3. Masukkan Harga Jual Baru (Opsional)</h4>
                <div class="p-4 bg-slate-50 rounded-lg border space-y-3">
                    <div v-for="mp in state.settings.marketplaces" :key="mp.id">
                        <label class="block text-sm font-medium">Harga {{ mp.name }}</label>
                        <input type="number" v-model.number="uiState.massPriceInputs[mp.id]" :placeholder="`Kosongkan jika tidak diubah`" class="mt-1 w-full p-2 border rounded-md">
                    </div>
                </div>
            </div>
        </div>
        
        <div>
            <h4 class="font-semibold text-slate-700 mb-2">Pratinjau ({{ filteredMassPriceVariants.length }} Varian Terpilih)</h4>
            <div class="max-h-[55vh] overflow-y-auto border rounded-lg bg-white p-2">
                <p v-if="filteredMassPriceVariants.length === 0" class="text-center text-slate-500 p-4">Tidak ada produk yang cocok dengan filter.</p>
                <ul v-else class="divide-y divide-slate-200">
                    <li v-for="variant in filteredMassPriceVariants" :key="variant.docId" class="py-2 px-3 text-sm">
                        <p class="font-semibold text-slate-800">{{ variant.nama }}</p>
                        <p class="text-xs text-slate-500">{{ variant.sku }} | Warna: {{ variant.warna }} | Ukuran: {{ variant.varian }}</p>
                    </li>
                </ul>
            </div>
        </div>
    </div>

    <div class="flex-shrink-0 flex justify-end gap-3 mt-4 pt-4 border-t">
        <button @click="hideModal" class="bg-slate-200 text-slate-800 font-bold py-2 px-4 rounded-lg hover:bg-slate-300">Batal</button>
        <button @click="applyAndSaveChanges" :disabled="isSaving || filteredMassPriceVariants.length === 0" class="bg-green-600 text-white font-bold py-2 px-4 rounded-lg hover:bg-green-700 disabled:bg-green-300">
             <span v-if="isSaving">Menyimpan...</span>
             <span v-else>Terapkan & Simpan Harga</span>
        </button>
    </div>
</div>

<div v-if="uiState.modalType === 'supplierPayment'" class="bg-white rounded-lg shadow-xl p-6 w-full max-w-md max-h-[90vh] overflow-y-auto transform scale-100 opacity-100 animate-fade-in-up" @click.stop>
    <h3 class="text-2xl font-bold mb-4 text-slate-800">Pembayaran Pesanan #{{ uiState.modalData.id.slice(-6) }}</h3>
    <form @submit.prevent="addSupplierPayment" class="space-y-4">
        <div class="bg-slate-50 p-4 rounded-lg border border-slate-200">
            <div class="flex justify-between items-center text-sm">
                <span>Total Tagihan:</span>
                <span class="font-bold text-lg text-indigo-600">{{ formatCurrency(uiState.modalData.totalQtyValue) }}</span>
            </div>
            <div class="flex justify-between items-center text-sm">
                <span>Sudah Dibayar:</span>
                <span class="font-medium text-green-600">{{ formatCurrency(uiState.modalData.dibayarkan) }}</span>
            </div>
            <div class="flex justify-between items-center text-sm font-bold border-t pt-2 mt-2">
                <span>Sisa Tagihan:</span>
                <span class="text-red-600">{{ formatCurrency(uiState.modalData.totalQtyValue - uiState.modalData.dibayarkan) }}</span>
            </div>
        </div>
        <div class="space-y-4 mt-4">
            <div>
                <label class="block text-sm font-medium text-slate-700">Jumlah Pembayaran</label>
                <input type="number" v-model.number="uiState.newPaymentData.amount" :max="uiState.modalData.totalQtyValue - uiState.modalData.dibayarkan" class="mt-1 w-full p-2 border rounded-md" required placeholder="Masukkan jumlah pembayaran">
            </div>
            <div>
                <label class="block text-sm font-medium text-slate-700">Tanggal Bayar</label>
                <input type="date" v-model="uiState.newPaymentData.date" class="mt-1 w-full p-2 border rounded-md" required>
            </div>
            <div>
                <label class="block text-sm font-medium text-slate-700">Metode Pembayaran</label>
                <select v-model="uiState.newPaymentData.method" class="mt-1 w-full p-2 border rounded-md">
                    <option>Transfer</option>
                    <option>Tunai</option>
                    <option>Lainnya</option>
                </select>
            </div>
            <div>
                <label class="block text-sm font-medium text-slate-700">Catatan (Opsional)</label>
                <textarea v-model="uiState.newPaymentData.notes" rows="2" class="mt-1 w-full p-2 border rounded-md"></textarea>
            </div>
        </div>
        <div class="flex justify-end gap-3 mt-6 pt-4 border-t">
            <button type="button" @click="hideModal" class="bg-slate-200 text-slate-800 font-bold py-2 px-4 rounded-lg hover:bg-slate-300">Batal</button>
            <button type="submit" :disabled="isSaving || !isSubscriptionActive" class="bg-green-600 text-white font-bold py-2 px-4 rounded-lg hover:bg-green-700 disabled:bg-green-400">
                <span v-if="isSaving">Menyimpan...</span>
                <span v-else>Catat Pembayaran</span>
            </button>
        </div>
    </form>
</div>

<div v-if="uiState.modalType === 'viewPurchaseOrder'" class="bg-white rounded-lg shadow-2xl p-0 max-w-5xl w-full h-full md:max-h-[90vh] flex flex-col overflow-hidden animate-fade-in-up" @click.stop>
    <div class="bg-slate-900 p-6 text-white flex justify-between items-center">
        <div>
            <h1 class="text-2xl font-black tracking-tighter">{{ state.settings.brandName }}</h1>
            <p class="text-slate-400 text-xs uppercase tracking-widest">Bukti Pembelian Barang</p>
        </div>
        <div class="text-right">
            <h2 class="text-xl font-bold">NOTA PEMBELIAN</h2>
            <p class="font-mono text-sm">#{{ uiState.modalData.id.slice(-6).toUpperCase() }}</p>
        </div>
    </div>

    <div class="flex-1 overflow-y-auto p-8">
        <div class="grid grid-cols-1 md:grid-cols-2 gap-12 mb-8">
            <div>
                <h4 class="text-xs font-bold text-slate-400 uppercase mb-2">Supplier / Gudang:</h4>
                <p class="text-lg font-bold text-slate-800">{{ uiState.modalData.supplierName }}</p>
                <p class="text-sm text-slate-500">Rincian pembelian dan pengambilan barang.</p>
                <p class="text-sm mt-4 text-slate-500">Tanggal Ambil: <span class="text-slate-800 font-semibold">{{ new Date(uiState.modalData.tanggal).toLocaleDateString('id-ID', { day: 'numeric', month: 'long', year: 'numeric' }) }}</span></p>
            </div>

            <div class="bg-slate-50 p-6 rounded-2xl border border-slate-100">
                <h4 class="text-xs font-bold text-slate-400 uppercase mb-4">Ringkasan Pembayaran</h4>
                <div class="space-y-3">
                    <div class="flex justify-between text-sm">
                        <span class="text-slate-500">Total Tagihan</span>
                        <span class="font-bold text-slate-800">{{ formatCurrency(uiState.modalData.totalQtyValue) }}</span>
                    </div>
                    <div class="flex justify-between text-sm">
                        <span class="text-slate-500">Sudah Dibayar</span>
                        <span class="font-bold text-green-600">{{ formatCurrency(uiState.modalData.dibayarkan) }}</span>
                    </div>
                    <div class="flex justify-between text-lg pt-3 border-t-2 border-dashed border-slate-200 mt-3">
                        <span class="font-bold text-slate-800">Sisa Tagihan</span>
                        <span class="font-black text-red-600">{{ formatCurrency(uiState.modalData.totalQtyValue - uiState.modalData.dibayarkan) }}</span>
                    </div>
                </div>
            </div>
        </div>

        <h4 class="text-xs font-bold text-slate-400 uppercase mb-4">Rincian Item Produk</h4>
        <div class="border rounded-xl overflow-hidden mb-8">
            <table class="w-full text-sm text-left">
                <thead class="bg-slate-50 text-slate-600 font-bold uppercase text-[10px]">
                    <tr>
                        <th class="p-4">Deskripsi Produk</th>
                        <th class="p-4 text-right">Harga Beli</th>
                        <th class="p-4 text-center">Qty</th>
                        <th class="p-4 text-right">Subtotal</th>
                    </tr>
                </thead>
                <tbody class="divide-y">
                    <tr v-for="p in uiState.modalData.produk" :key="p.sku" class="hover:bg-slate-50/50">
                        <td class="p-4">
                            <p class="font-bold text-slate-800">{{ p.modelName }}</p>
                            <p class="text-[10px] font-mono text-slate-500">{{ p.sku }} ({{ p.color }} / {{ p.size }})</p>
                        </td>
                        <td class="p-4 text-right">{{ formatCurrency(p.hargaJual) }}</td>
                        <td class="p-4 text-center font-medium">{{ p.qty }}</td>
                        <td class="p-4 text-right font-bold text-slate-800">{{ formatCurrency(p.hargaJual * p.qty) }}</td>
                    </tr>
                </tbody>
            </table>
        </div>

        <div v-if="uiState.modalData.paymentHistory?.length > 0">
            <h4 class="text-xs font-bold text-slate-400 uppercase mb-4">Log Cicilan / Pembayaran</h4>
            <div class="grid grid-cols-1 sm:grid-cols-2 gap-4">
                <div v-for="(pay, idx) in uiState.modalData.paymentHistory" :key="idx" class="p-3 bg-white border rounded-xl flex justify-between items-center shadow-sm">
                    <div>
                        <p class="text-xs text-slate-400">{{ new Date(pay.date.seconds ? pay.date.seconds * 1000 : pay.date).toLocaleDateString() }}</p>
                        <p class="text-sm font-bold text-slate-700">{{ pay.method }}</p>
                    </div>
                    <p class="font-bold text-indigo-600">{{ formatCurrency(pay.amount) }}</p>
                </div>
            </div>
        </div>
    </div>

    <div class="bg-slate-50 p-6 border-t flex flex-wrap justify-between gap-4">
        <div class="flex gap-2">
            <button @click="printPurchaseInvoice(uiState.modalData)" class="bg-white border border-slate-300 text-slate-700 font-bold py-2 px-4 rounded-lg hover:bg-slate-100 flex items-center gap-2 shadow-sm">
                <svg class="w-4 h-4 text-indigo-600" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 17h2a2 2 0 002-2v-4a2 2 0 00-2-2H5a2 2 0 00-2 2v4a2 2 0 002 2h2m2 4h10a2 2 0 002-2v-4a2 2 0 00-2-2H9a2 2 0 00-2 2v4a2 2 0 002 2zm8-12V5a2 2 0 00-2-2H9a2 2 0 00-2 2v4h10z"/></svg>
                Cetak Nota Pembelian
            </button>

            <button @click="requestProtectedExport(() => exportInvoiceToExcel(uiState.modalData))" class="bg-white border border-slate-300 text-slate-700 font-bold py-2 px-4 rounded-lg hover:bg-slate-100 flex items-center gap-2 shadow-sm">
                <svg class="w-4 h-4 text-green-600" fill="currentColor" viewBox="0 0 20 20"><path d="M14.78 3.653a3.936 3.936 0 115.567 5.567l-3.627 3.627a3.936 3.936 0 01-5.567 0 3.936 3.936 0 010-5.567l3.627-3.627zm-3.045 4.385a2.146 2.146 0 100 4.292 2.146 2.146 0 000-4.292z"/></svg>
                Export Excel
            </button>
        </div>
        
        <button @click="hideModal" class="bg-slate-900 text-white font-bold py-2 px-8 rounded-lg hover:bg-slate-800 shadow-lg shadow-slate-900/20">Tutup</button>
    </div>
</div>



<div v-if="uiState.modalType === 'voucherUmum'" class="bg-white rounded-lg shadow-xl p-6 max-w-4xl w-full h-full md:max-h-[70vh] flex flex-col animate-fade-in-up">
    <div class="flex-shrink-0 pb-4 border-b">
        <h3 class="text-2xl font-bold text-slate-800">Pengaturan Voucher Umum (Per Channel)</h3>
        <p class="text-slate-500 mt-1">Pengaturan ini berlaku untuk semua produk di setiap channel penjualan.</p>
    </div>
    
    <div class="flex-1 overflow-y-auto py-4 pr-2 space-y-4">
        <div v-for="channel in state.settings.marketplaces" :key="channel.id" class="p-4 border border-slate-200 rounded-lg bg-slate-50 shadow-sm">
            <p class="font-semibold text-slate-700 mb-4 text-lg">{{ channel.name }}</p>
            
            <div class="mt-3">
                <label class="block text-sm font-medium text-slate-600">Voucher Ikuti Toko</label>
                <div class="mt-2 grid grid-cols-3 gap-2 text-xs text-slate-500 font-semibold">
                    <span class="pl-1">Min. Belanja (Rp)</span>
                    <span class="pl-1">Diskon (%)</span>
                    <span class="pl-1">Diskon (Rp)</span>
                </div>
                <div class="grid grid-cols-3 gap-2">
                    <input type="text" v-model="voucherTokoMinBelanjaComputed(channel).value" class="w-full p-1.5 text-sm border border-slate-300 rounded-md">
                    <input type="text" v-model="voucherTokoDiskonRateComputedUpdated(channel).value" class="w-full p-1.5 text-sm border border-slate-300 rounded-md">
                    <input type="text" v-model="voucherTokoDiskonNominalComputed(channel).value" class="w-full p-1.5 text-sm border border-slate-300 rounded-md">
                </div>
            </div>

            <div class="mt-4">
                <label class="block text-sm font-medium text-slate-600">Voucher Semua Produk</label>
                <div class="mt-2 grid grid-cols-3 gap-2 text-xs text-slate-500 font-semibold">
                    <span class="pl-1">Min. Belanja (Rp)</span>
                    <span class="pl-1">Diskon (%)</span>
                    <span class="pl-1">Diskon (Rp)</span>
                </div>
                <div class="grid grid-cols-3 gap-2">
                    <input type="text" v-model="voucherSemuaProdukMinBelanjaComputed(channel).value" class="w-full p-1.5 text-sm border border-slate-300 rounded-md">
                    <input type="text" v-model="voucherSemuaProdukDiskonRateComputedUpdated(channel).value" class="w-full p-1.5 text-sm border border-slate-300 rounded-md">
                    <input type="text" v-model="voucherSemuaProdukDiskonNominalComputed(channel).value" class="w-full p-1.5 text-sm border border-slate-300 rounded-md">
                </div>
            </div>

            <div class="flex justify-end mt-4 pt-3 border-t">
                <button @click="saveChannelPromotions(channel.id)" :disabled="isSaving" class="bg-green-600 text-white font-bold text-xs py-1 px-3 rounded-md hover:bg-green-700 disabled:bg-green-300">
                    <span v-if="isSaving">Menyimpan Perubahan {{ channel.name }}...</span>
                    <span v-else>Simpan Perubahan {{channel.name}}</span>
                </button>
            </div>
        </div>
    

    <div class="flex-shrink-0 flex justify-end gap-3 mt-4 pt-4 border-t">
        <button @click="hideModal" class="bg-slate-200 text-slate-800 font-bold py-2 px-4 rounded-lg hover:bg-slate-300">Tutup</button>
    </div>
  </div>
</div>
<div v-if="uiState.modalType === 'notesModal'" class="bg-white rounded-lg shadow-xl p-6 max-w-5xl w-full h-full md:max-h-[90vh] flex flex-col">
        <div class="flex-shrink-0 pb-4 border-b">
            <h3 class="text-2xl font-bold text-slate-800">Catatan Masa Berakhir Voucher</h3>
            <p class="text-slate-500 mt-1">Lacak masa berlaku voucher agar promosi tidak terlewat.</p>
        </div>
        <div class="flex-1 overflow-y-auto py-4 pr-2 space-y-6">
            <div class="p-4 bg-slate-50 rounded-lg border">
                <form @submit.prevent="submitVoucherNote" class="grid grid-cols-1 md:grid-cols-2 gap-4">
                    <h4 class="col-span-full font-semibold text-lg text-indigo-700">Tambah Catatan Baru</h4>
                    <div>
                        <label class="block text-sm font-medium">Tipe Voucher</label>
                        <select v-model="uiState.notesData.type" class="mt-1 w-full p-2 border rounded-md">
                            <option value="model">Per Model Produk</option>
                            <option value="channel">Per Akun Penjualan</option>
                        </select>
                    </div>
                    <div>
                        <label class="block text-sm font-medium">Jenis Voucher</label>
                        <select v-model="uiState.notesData.voucherType" class="mt-1 w-full p-2 border rounded-md" required>
    <option value="" disabled>-- Pilih Jenis Voucher --</option>
    <option v-for="type in filteredVoucherTypes" :key="type" :value="type">
        {{ type }}
    </option>
</select>
                    </div>
                    <template v-if="uiState.notesData.voucherType">
                        <div v-if="uiState.notesData.type === 'model'">
                            <label class="block text-sm font-medium">Pilih Model Produk</label>
                            <select v-model="uiState.notesData.modelName" class="mt-1 w-full p-2 border rounded-md" required>
                                <option value="">-- Pilih Model --</option>
                                <option v-for="model in promosiProductModels" :key="model" :value="model">{{ model }}</option>
                            </select>
                        </div>
                        <div>
                            <label class="block text-sm font-medium">Pilih Akun Penjualan</label>
                            <select v-model="uiState.notesData.channelId" class="mt-1 w-full p-2 border rounded-md" required>
                                <option value="">-- Pilih Channel --</option>
                                <option v-for="channel in state.settings.marketplaces" :key="channel.id" :value="channel.id">{{ channel.name }}</option>
                            </select>
                        </div>
                    </template>
                    <div>
                        <label class="block text-sm font-medium">Nama Voucher</label>
                        <input type="text" v-model="uiState.notesData.title" class="mt-1 w-full p-2 border rounded-md" required>
                    </div>
                    <div class="grid grid-cols-3 gap-2">
                        <div>
                            <label class="block text-sm font-medium">Tgl Berakhir</label>
                            <input type="date" v-model="uiState.notesData.endDate" class="mt-1 w-full p-2 border rounded-md" required>
                        </div>
                        <div>
                            <label class="block text-sm font-medium">Jam</label>
                            <input type="number" v-model.number="uiState.notesData.endHour" min="0" max="23" class="mt-1 w-full p-2 border rounded-md" required>
                        </div>
                        <div>
                            <label class="block text-sm font-medium">Menit</label>
                            <input type="number" v-model.number="uiState.notesData.endMinute" min="0" max="59" class="mt-1 w-full p-2 border rounded-md" required>
                        </div>
                    </div>
                    <div class="col-span-full flex justify-end">
                        <button type="submit" class="bg-indigo-600 text-white font-bold py-2 px-4 rounded-lg hover:bg-indigo-700">Simpan Catatan</button>
                    </div>
                </form>
            </div>
            <div class="p-4 bg-white rounded-lg border">
                <h4 class="font-semibold text-lg text-slate-800 mb-4">Daftar Catatan Voucher</h4>
                <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mb-4">
                    <div>
                        <label class="block text-sm font-medium">Cari</label>
                        <input type="text" v-model="uiState.notesSearch" placeholder="Cari model/channel..." class="mt-1 w-full p-2 border rounded-md">
                    </div>
                    <div>
                        <label class="block text-sm font-medium">Filter Tipe</label>
                        <select v-model="uiState.notesFilterType" class="mt-1 w-full p-2 border rounded-md">
                            <option value="all">Semua Tipe</option>
                            <option value="model">Per Model</option>
                            <option value="channel">Per Akun</option>
                        </select>
                    </div>
                    <div>
                        <label class="block text-sm font-medium">Filter Model</label>
                        <select v-model="uiState.notesFilterModel" class="mt-1 w-full p-2 border rounded-md">
                            <option value="">Semua Model</option>
                            <option v-for="model in promosiProductModels" :key="model" :value="model">{{ model }}</option>
                        </select>
                    </div>
                    <div>
                        <label class="block text-sm font-medium">Filter Akun</label>
                        <select v-model="uiState.notesFilterChannel" class="mt-1 w-full p-2 border rounded-md">
                            <option value="">Semua Akun</option>
                            <option v-for="channel in state.settings.marketplaces" :key="channel.id" :value="channel.id">{{ channel.name }}</option>
                        </select>
                    </div>
                </div>
                <div class="overflow-x-auto max-h-[40vh]">
                    <table class="min-w-full text-sm text-left text-slate-500">
                        <thead class="text-xs text-slate-700 uppercase bg-slate-100/50 sticky top-0">
                            <tr>
                                <th class="px-4 py-3">Voucher</th>
                                <th class="px-4 py-3">Berakhir pada</th>
                                <th class="px-4 py-3">Tipe</th>
                                <th class="px-4 py-3">Detail</th>
                                <th class="px-4 py-3 text-center">Aksi</th>
                            </tr>
                        </thead>
                        <tbody class="divide-y divide-slate-200/50">
                            <tr v-if="filteredVoucherNotes.length === 0">
                                <td colspan="5" class="p-4 text-center text-slate-500">Tidak ada catatan voucher.</td>
                            </tr>
                            <tr v-for="note in filteredVoucherNotes" :key="note.id" class="hover:bg-slate-50/50">
                                <td class="px-4 py-3 font-semibold text-slate-800">{{ note.title }}</td>
                                <td class="px-4 py-3 whitespace-nowrap">{{ new Date(note.endDate).toLocaleString('id-ID') }}</td>
                                <td class="px-4 py-3 capitalize">{{ note.type }}</td>
                                <td class="px-4 py-3">{{ note.modelName || note.channelName }}</td>
                                <td class="px-4 py-3 text-center">
                                    <button @click="deleteVoucherNote(note.id)" class="text-red-500 hover:underline text-xs font-bold">Hapus</button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
        <div class="flex-shrink-0 flex justify-end gap-3 mt-4 pt-4 border-t">
            <button @click="hideModal" class="bg-slate-200 text-slate-800 font-bold py-2 px-4 rounded-lg hover:bg-slate-300">Tutup</button>
        </div>
    </div>
    
    

<div v-if="uiState.nestedModalType === 'hppCalculationInfo'" class="fixed inset-0 bg-black bg-opacity-70 z-50 flex items-center justify-center p-4">
    <div class="bg-white rounded-lg shadow-xl p-6 max-w-lg w-full">
        <div v-if="uiState.nestedModalData.topic === 'ideal'">
            <h3 class="text-lg font-bold text-slate-800 mb-2">Apa itu HPP Ideal/Pcs?</h3>
            <p class="text-sm text-slate-600">Ini adalah biaya modal per produk jika hasil produksi **sesuai dengan target** (tidak ada selisih).</p>
            <p class="font-mono text-xs mt-2 bg-slate-100 p-2 rounded">Rumus: Total Biaya Produksi / Target Qty</p>
        </div>
        <div v-if="uiState.nestedModalData.topic === 'loss'">
            <h3 class="text-lg font-bold text-slate-800 mb-2">Apa itu Kerugian/Pcs?</h3>
            <p class="text-sm text-slate-600">Ini adalah **tambahan biaya modal** yang dibebankan ke setiap produk jadi karena adanya selisih (hasil produksi lebih sedikit dari target). Biaya dari produk yang gagal dibuat "ditanggung" oleh produk yang berhasil dibuat.</p>
            <p class="font-mono text-xs mt-2 bg-slate-100 p-2 rounded">Rumus: HPP Final - HPP Ideal</p>
        </div>
        <div v-if="uiState.nestedModalData.topic === 'final'">
            <h3 class="text-lg font-bold text-slate-800 mb-2">Apa itu HPP Final/Pcs?</h3>
            <p class="text-sm text-slate-600">Ini adalah **biaya modal riil** untuk setiap produk yang berhasil dibuat, sudah termasuk menanggung biaya kerugian dari produk yang gagal diproduksi.</p>
            <p class="font-mono text-xs mt-2 bg-slate-100 p-2 rounded">Rumus: Total Biaya Produksi / Aktual Jadi</p>
        </div>
        <div class="flex justify-end mt-4 pt-4 border-t">
            <button @click="hideNestedModal" class="bg-slate-200 text-slate-800 font-bold py-2 px-4 rounded-lg hover:bg-slate-300">Mengerti</button>
        </div>
    </div>
</div>

<div v-if="uiState.modalType === 'addSupplier' || uiState.modalType === 'editSupplier'" class="fixed inset-0 bg-black bg-opacity-50 z-40 flex items-start justify-center p-20">
    <div class="bg-white rounded-lg shadow-xl p-6 max-w-2xl w-full h-full md:max-h-[50vh] flex flex-col">
        <h3 class="text-xl font-bold mb-4">{{ uiState.modalType === 'addSupplier' ? 'Tambah Supplier Baru' : 'Edit Supplier' }}</h3>
        <form @submit.prevent="uiState.modalType === 'addSupplier' ? addSupplier() : updateSupplier()" class="space-y-4">
            <div>
                <label class="block text-sm font-medium">Nama Supplier</label>
                <input type="text" v-model="uiState.modalData.name" class="mt-1 w-full p-2 border rounded-md" required>
            </div>
            <div>
                <label class="block text-sm font-medium">Kontak (Opsional)</label>
                <input type="text" v-model="uiState.modalData.contact" class="mt-1 w-full p-2 border rounded-md" placeholder="Contoh: 0812xxxxxx">
            </div>
            <div class="flex justify-end gap-3 pt-4 border-t mt-4">
                <button type="button" @click="hideModal" class="bg-slate-200 py-2 px-4 rounded-lg">Batal</button>
                <button type="submit" class="bg-indigo-600 text-white py-2 px-4 rounded-lg" :disabled="!isSubscriptionActive">Simpan</button>
            </div>
        </form>
    </div>
</div>



<div v-if="uiState.modalType === 'inventarisInfo'" class="bg-white rounded-lg shadow-xl p-6 max-w-5xl w-full h-full md:max-h-[90vh] flex flex-col">
    <div class="flex-shrink-0 pb-4 border-b">
        <h3 class="text-2xl font-bold text-slate-800">Panduan Manajemen Inventaris</h3>
        <p class="text-slate-500 mt-1">Pusat kendali untuk semua data produk dan stok Anda.</p>
    </div>
    
    <div class="flex-1 overflow-y-auto py-4 pr-2">
        <div class="space-y-6 text-slate-700 leading-relaxed">
            
            <div class="p-4 bg-slate-50 rounded-lg border border-slate-200">
                <h4 class="font-semibold text-lg text-indigo-700">Konsep Kunci: Stok Fisik vs. Alokasi Stok</h4>
                <p class="mt-1 text-sm">
                    Untuk mencegah *overselling* (menjual barang yang stoknya habis), sistem ini membedakan dua jenis stok:
                </p>
                <ul class="list-disc list-inside ml-4 mt-2 space-y-3 text-sm">
                    <li>
                        <strong>Stok Fisik:</strong> Ini adalah **sumber kebenaran utama**. Angka ini menunjukkan jumlah total produk yang secara nyata ada di gudang Anda. Stok ini hanya berubah saat ada penjualan, retur, atau penyesuaian manual.
                        <br>
                        <em>Analogi: Total air di dalam sebuah tandon utama.</em>
                    </li>
                    <li>
                        <strong>Alokasi Stok:</strong> Ini adalah "jatah" stok yang Anda putuskan untuk **ditampilkan** di setiap marketplace. Anda bisa mengalokasikan stok secara berbeda untuk setiap toko.
                        <br>
                        <em>Analogi: Jumlah air yang Anda tuang dari tandon utama ke dalam botol-botol terpisah (Botol Shopee, Botol Tokopedia, dll). Total air di semua botol tidak bisa melebihi air di tandon.</em>
                    </li>
                </ul>
            </div>

            <div class="p-4 bg-slate-50 rounded-lg border border-slate-200">
                <h4 class="font-semibold text-lg text-indigo-700">Fungsi Tombol Utama</h4>
                 <ul class="list-disc list-inside ml-4 mt-2 space-y-2 text-sm">
                    <li><strong>+ Tambah Produk Baru:</strong> Gunakan tombol ini untuk mendaftarkan produk atau varian baru ke dalam sistem untuk **pertama kalinya**. Produk yang baru dibuat akan memiliki stok awal 0.</li>
                    <li><strong>Penyesuaian Stok:</strong> Gunakan tombol ini untuk mengubah jumlah stok secara manual di luar transaksi normal. Ini penting untuk:
                        <ul>
                            <li>- Mencatat stok awal saat pertama kali input produk.</li>
                            <li>- Menyesuaikan stok setelah melakukan stok opname.</li>
                            <li>- Mencatat barang hilang atau rusak (pengurangan stok).</li>
                        </ul>
                    </li>
                </ul>
            </div>
             <div class="p-4 bg-slate-50 rounded-lg border border-slate-200">
                <h4 class="font-semibold text-lg text-indigo-700">Filter & Pencarian</h4>
                <p class="mt-1 text-sm">
                    Gunakan panel filter untuk menemukan produk dengan cepat berdasarkan **Nama Produk** atau **Status Stok** (Aman, Menipis, Habis) yang batasnya Anda atur sendiri di halaman Pengaturan.
                </p>
            </div>
        </div>
    </div>

    <div class="flex-shrink-0 flex justify-end gap-3 mt-4 pt-4 border-t">
        <button @click="hideModal" class="bg-slate-200 text-slate-800 font-bold py-2 px-4 rounded-lg hover:bg-slate-300">Mengerti</button>
    </div>
</div>

<div v-if="uiState.modalType === 'produksiInfo'" class="bg-white rounded-lg shadow-xl p-6 max-w-5xl w-full h-full md:max-h-[90vh] flex flex-col">
    <div class="flex-shrink-0 pb-4 border-b">
        <h3 class="text-2xl font-bold text-slate-800">Panduan Halaman Manajemen Produksi</h3>
        <p class="text-slate-500 mt-1">Pusat kendali untuk melacak, menganalisis, dan mengelola seluruh alur kerja produksi Anda.</p>
    </div>
    
    <div class="flex-1 overflow-y-auto py-4 pr-2">
        <div class="space-y-6 text-slate-700 leading-relaxed">
            
            <div class="p-4 bg-slate-50 rounded-lg border border-slate-200">
                <h4 class="font-semibold text-lg text-indigo-700">Laporan & Analisis</h4>
                <p class="mt-1 text-sm">
                    Ini adalah pusat intelijen bisnis untuk operasional produksi Anda. Setiap tombol di sini menyajikan data dari sudut pandang yang berbeda untuk membantu Anda mengambil keputusan yang lebih baik.
                </p>
                <ul class="list-disc list-inside ml-4 mt-2 space-y-3 text-sm">
                    <li><strong>Analisis Model:</strong> Alat paling kuat untuk mengukur efisiensi. Fitur ini membandingkan **Target Kuantitas** (berdasarkan standar yard) dengan **Aktual Jadi** untuk setiap item produksi, lalu menyorot mana yang paling untung (selisih positif) dan mana yang paling rugi (selisih negatif). Gunakan ini untuk mengevaluasi kinerja pemaklun atau penjahit.</li>
                    <li><strong>Ringkasan Jadi:</strong> Menampilkan rekapitulasi total kuantitas produk yang sudah jadi, dikelompokkan berdasarkan model, kain, warna, dan ukuran. Cocok untuk melihat ringkasan cepat hasil produksi.</li>
                    <li><strong>Laporan per Status:</strong> Memungkinkan Anda memfilter dan melihat semua batch produksi berdasarkan statusnya (misal, tampilkan semua yang "Selesai" untuk proses pembayaran, atau semua yang "Dalam Proses" untuk pemantauan).</li>
                    <li><strong>Laporan Semuanya:</strong> Tampilan master yang menggabungkan semua detail dari setiap item di semua batch produksi ke dalam satu tabel besar. Ini adalah sumber data utama untuk ekspor ke Excel dan analisis mendalam.</li>
                </ul>
            </div>

            <div class="p-4 bg-slate-50 rounded-lg border border-slate-200">
                <h4 class="font-semibold text-lg text-indigo-700">Filter & Pencarian</h4>
                <p class="mt-1 text-sm">
                    Gunakan panel ini untuk menemukan batch produksi spesifik dengan cepat.
                </p>
                 <ul class="list-disc list-inside ml-4 mt-2 space-y-1 text-sm">
                    <li><strong>Kolom Cari:</strong> Masukkan ID Batch, kode unik item (misal: 12ABC), nama pemaklun/penjahit, atau nama bahan untuk menemukan data yang relevan.</li>
                    <li><strong>Filter Jenis & Status:</strong> Persempit pencarian Anda berdasarkan jenis jasa (Pemaklun/Penjahit) dan status proses produksi saat ini.</li>
                </ul>
            </div>
            
        </div>
    </div>

    <div class="flex-shrink-0 flex justify-end gap-3 mt-4 pt-4 border-t">
        <button @click="hideModal" class="bg-slate-200 text-slate-800 font-bold py-2 px-4 rounded-lg hover:bg-slate-300">Mengerti</button>
    </div>
</div>        

<div v-if="uiState.modalType === 'modelProdukInfo'" class="bg-white rounded-lg shadow-xl p-6 max-w-5xl w-full h-full md:max-h-[90vh] flex flex-col">
    <div class="flex-shrink-0 pb-4 border-b">
        <h3 class="text-2xl font-bold text-slate-800">Panduan Pengisian Data Model Produk</h3>
    </div>
    
    <div class="flex-1 overflow-y-auto py-4 pr-2">
        <div class="space-y-6 text-slate-700 leading-relaxed">
            
            <div class="p-4 bg-slate-50 rounded-lg border border-slate-200">
                <h4 class="font-semibold text-lg text-indigo-700">Aturan Pengisian Nama Model</h4>
                <p class="mt-1">
                    Silakan klik **"+ Tambah Model"**, lalu edit. Pastikan untuk mengisi **Nama Model** dengan format yang konsisten.
                </p>
                <p class="mt-2 text-sm font-semibold">
                    Mengisi data ini dengan benar akan sangat mempermudah Anda saat menambahkan produk baru di halaman **Inventaris**, karena Anda hanya perlu memilih model yang sudah ada dan beberapa kolom akan terisi otomatis.
                </p>
                
                <div class="mt-3 p-3 bg-indigo-100 border border-indigo-200 rounded-md">
                    <p class="font-semibold">Contoh Pengisian: Format Size (Huruf)</p>
                    <ul class="list-disc list-inside mt-1 text-sm">
                        <li><strong>Nama Model:</strong> <code>MADINA HITAM M</code></li>
                        <li><strong>Kolom Warna:</strong> <code>HITAM</code></li>
                        <li><strong>Kolom Ukuran:</strong> <code>M</code></li>
                    </ul>
                </div>
                <div class="mt-2 p-3 bg-indigo-100 border border-indigo-200 rounded-md">
                    <p class="font-semibold">Contoh Pengisian: Format No. (Angka)</p>
                    <ul class="list-disc list-inside mt-1 text-sm">
                        <li><strong>Nama Model:</strong> <code>MADINA HITAM NO.6</code></li>
                        <li><strong>Kolom Warna:</strong> <code>HITAM</code></li>
                        <li><strong>Kolom Ukuran:</strong> <code>NO.6</code></li>
                    </ul>
                </div>
            </div>

            <div class="p-4 bg-yellow-50 border border-yellow-300 rounded-lg">
                <h4 class="font-semibold text-lg text-yellow-800">Perhatian untuk Kebutuhan Kain (Yard/Model)</h4>
                <p class="mt-1">
                    Pastikan Anda memasukkan data yard dengan benar, karena angka ini akan sangat memengaruhi perhitungan di Halaman Produksi.
                </p>
                <p class="mt-2 text-sm">
                    Kalkulasi **Target Qty** di dalam form "Buat Batch Produksi" dihitung secara otomatis berdasarkan rumus:
                </p>
                <div class="mt-2 p-2 bg-white text-center font-mono text-slate-800 rounded">
                    Target Qty = Total Yard Kain / Yard per Model
                </div>
            </div>

            <div class="p-4 bg-cyan-50 border border-cyan-200 rounded-lg">
                <h4 class="font-semibold text-lg text-cyan-800">Aturan Pengisian Harga Jasa</h4>
                <ul class="list-disc list-inside mt-2 space-y-2 text-sm">
                    <li><strong>Harga Maklun:</strong> Silakan isi dengan harga jasa maklun. Harga ini akan otomatis terisi saat Anda membuat batch produksi baru dengan jenis jasa "Pemaklun".</li>
                    <li><strong>Harga Jahit:</strong> Silakan isi dengan harga jahit yang sudah disepakati langsung dengan penjahit. Harga ini akan otomatis terisi saat Anda memilih jenis jasa "Penjahit" di form batch produksi.</li>
                </ul>
            </div>

        </div>
    </div>

    <div class="flex-shrink-0 flex justify-end gap-3 mt-4 pt-4 border-t">
        <button @click="hideModal" class="bg-slate-200 text-slate-800 font-bold py-2 px-4 rounded-lg hover:bg-slate-300">Mengerti</button>
    </div>
</div>        

<div v-if="uiState.modalType === 'panduanPromosi'" class="bg-white rounded-lg shadow-xl p-6 max-w-4xl w-full h-full md:max-h-[90vh] flex flex-col">
    <div class="flex-shrink-0 pb-4 border-b">
        <h3 class="text-2xl font-bold text-slate-800">Panduan Manajemen Promosi & Voucher</h3>
        <p class="text-slate-500 mt-1">Pahami struktur promosi berlapis untuk mengoptimalkan profitabilitas.</p>
    </div>
    
    <div class="flex-1 overflow-y-auto py-4 pr-2">
        <div class="space-y-6 text-slate-700 leading-relaxed prose">
            <p>Sistem promosi dirancang untuk memberikan fleksibilitas maksimum dalam strategi harga Anda. Ada dua tingkatan promosi utama yang bisa Anda atur, dan keduanya akan dibandingkan secara otomatis untuk menemukan diskon terbaik saat transaksi terjadi.</p>
            
            <h4 class="text-lg font-semibold mt-4 mb-2">1. Promosi Per Akun Penjualan (Berlaku Global)</h4>
            <div class="p-4 bg-indigo-50 rounded-lg border border-indigo-200 text-sm">
                <p>Ini adalah promosi yang berlaku untuk **semua produk** yang dijual di satu channel marketplace. Cocok untuk strategi diskon umum.</p>
                <ul class="list-disc list-inside ml-4 mt-2 space-y-1">
                    <li>**Voucher Ikuti Toko**: Diskon persentase yang diberikan kepada pelanggan baru yang mengikuti toko Anda.</li>
                    <li>**Voucher Semua Produk**: Diskon persentase yang berlaku untuk semua item di keranjang belanja.</li>
                </ul>
            </div>
            
            <h4 class="text-lg font-semibold mt-4 mb-2">2. Promosi Spesifik Per Model Produk (Berlaku Terbatas)</h4>
            <div class="p-4 bg-green-50 rounded-lg border border-green-200 text-sm">
                <p>Ini adalah promosi yang hanya berlaku untuk **varian produk dari model tertentu**. Strategi ini sangat efektif untuk promosi produk unggulan atau produk baru.</p>
                <ul class="list-disc list-inside ml-4 mt-2 space-y-1">
                    <li>**Voucher Produk Tertentu**: Diskon persentase khusus untuk model produk yang Anda pilih.</li>
                    <li>**Diskon Bertingkat**: Memberikan diskon yang berbeda berdasarkan jumlah minimal belanja.</li>
                </ul>
            </div>

            <h4 class="text-lg font-semibold mt-6 mb-2 text-red-700">Catatan Penting: Prioritas Voucher dan Batasan Penggunaan</h4>
            <div class="p-4 bg-red-50 rounded-lg border border-red-200 text-sm">
                <p>Sistem promosi di aplikasi ini dirancang untuk secara otomatis memilih dan menerapkan **voucher dengan nilai diskon terbaik** untuk setiap transaksi. Namun, untuk memastikan data Anda selalu sinkron dengan laporan dari marketplace (seperti Shopee atau TikTok), ada satu detail penting yang perlu Anda perhatikan:</p>
                
                <p class="mt-2">Beberapa jenis voucher, seperti **"Voucher Ikuti Toko"**, hanya dapat digunakan **satu kali per pelanggan** di platform marketplace.</p>
                
                <p class="mt-2">Untuk mencegah ketidakcocokan data, Anda memiliki dua opsi saat mengatur voucher ini:</p>
                <ol class="list-decimal list-inside ml-4 mt-2 space-y-1">
                    <li>**Berikan Nilai Diskon Paling Rendah**: Masukkan nilai diskon yang lebih kecil pada kolom **"Voucher Ikuti Toko"** dibandingkan dengan voucher lainnya. Dengan cara ini, aplikasi akan memprioritaskan voucher lain yang nilainya lebih besar.</li>
                    <li>**Kosongkan Nilai Diskon**: Jika Anda tidak ingin menggunakan "Voucher Ikuti Toko" dalam kalkulasi otomatis sama sekali, Anda bisa mengosongkan nilai diskonnya.</li>
                </ol>
            </div>
            </div>
    </div>
    
    <div class="flex-shrink-0 flex justify-end gap-3 mt-4 pt-4 border-t">
        <button @click="hideModal" class="bg-slate-200 text-slate-800 font-bold py-2 px-4 rounded-lg hover:bg-slate-300">Tutup</button>
    </div>
</div>

<div v-if="uiState.modalType === 'editReferralCode'" class="bg-white rounded-lg shadow-xl p-6 max-w-lg w-full">
    <h3 class="text-xl font-bold mb-2">Edit Kode Rujukan</h3>
    <p v-if="uiState.modalData.user" class="text-sm text-slate-500 mb-4">Mengubah kode untuk: <span class="font-semibold">{{ uiState.modalData.user.email }}</span></p>
    
    <form @submit.prevent="updateReferralCode">
        <div>
            <label class="block text-sm font-medium text-slate-700">Kode Rujukan Baru</label>
            <input 
                type="text" 
                v-model="uiState.modalData.newReferralCode" 
                class="mt-1 w-full p-2 border rounded-md font-mono text-lg" 
                required
            >
            <p class="text-xs text-slate-500 mt-1">Gunakan huruf besar dan angka. Minimal 5 karakter.</p>
        </div>
        
        <div class="flex justify-end gap-3 pt-6 border-t mt-4">
            <button type="button" @click="hideModal" class="bg-slate-200 py-2 px-4 rounded-lg">Batal</button>
            <button type="submit" :disabled="isSaving" class="bg-indigo-600 text-white font-bold py-2 px-4 rounded-lg disabled:bg-indigo-400">
                <span v-if="isSaving">Menyimpan...</span>
                <span v-else>Simpan Perubahan</span>
            </button>
        </div>
    </form>
</div>

<div v-if="uiState.modalType === 'registerPartner'" class="bg-white rounded-lg shadow-xl p-6 max-w-lg w-full">
    <h3 class="text-xl font-bold mb-4">Daftar Menjadi Mitra</h3>
    <div class="space-y-4">
        <p class="text-sm text-slate-600">Untuk menjadi mitra, Anda akan dikenakan biaya pendaftaran satu kali sebesar Rp 50.000. Biaya ini akan kami gunakan untuk mendukung program dan operasional kami.</p>
        <p class="text-sm font-semibold text-slate-800">Manfaat menjadi mitra:</p>
        <ul class="list-disc list-inside ml-4 text-sm text-slate-600">
            <li>Dapatkan komisi berkelanjutan dari setiap pelanggan yang Anda ajak.</li>
            <li>Akses ke dashboard khusus untuk melacak komisi Anda secara real-time.</li>
            <li>Mendukung pengembangan aplikasi yang lebih baik.</li>
        </ul>
        <p class="mt-4 text-xs font-semibold text-red-600">Setelah pembayaran, Anda akan menerima kode rujukan unik.</p>
    </div>
    <div class="flex justify-end gap-3 pt-6 border-t mt-4">
        <button type="button" @click="hideModal" class="bg-slate-200 py-2 px-4 rounded-lg">Batal</button>
        <button @click="proceedToPartnerPayment" class="bg-green-600 text-white font-bold py-2 px-4 rounded-lg">Lanjut ke Pembayaran</button>
    </div>
</div>

        <div v-if="uiState.modalType === 'dashboardKpiInfo'" class="bg-white rounded-lg shadow-xl p-6 max-w-4xl w-full h-full md:max-h-[90vh] flex flex-col">
    <div class="flex-shrink-0 pb-4 border-b">
        <h3 class="text-2xl font-bold text-slate-800">Memahami Dampak Retur pada Laporan Keuangan</h3>
        <p class="text-slate-500 mt-1">Penjelasan singkat tentang bagaimana setiap data retur memengaruhi metrik di dashboard.</p>
    </div>
    <div class="flex-1 overflow-y-auto py-4 pr-2 space-y-6 text-slate-700 leading-relaxed">
        <p>
            Ketika Anda menambahkan data retur di halaman **Manajemen Retur**, sistem secara otomatis menganggap pesanan tersebut sebagai **gagal** atau **dibatalkan**. Hal ini memicu penyesuaian otomatis pada semua metrik keuangan di dashboard analitik Anda untuk memastikan data yang ditampilkan selalu akurat.
        </p>
        
        <div class="p-4 bg-slate-50 rounded-lg">
            <h4 class="font-bold text-lg text-indigo-700">Dampak Langsung pada Metrik Utama</h4>
            <ul class="list-disc list-inside ml-4 mt-2 space-y-2 text-sm">
                <li>
                    <strong>Omset Kotor & Omset Bersih:</strong> Nilai harga jual dari produk yang diretur akan **dikurangi** dari total omset Anda.
                </li>
                <li>
                    <strong>Diskon:</strong> Jumlah diskon atau voucher yang sebelumnya teralokasi pada produk yang diretur juga akan **dibatalkan** dan dikurangi dari total diskon.
                </li>
                <li>
                    <strong>Biaya Transaksi Marketplace:</strong> Biaya yang dibebankan oleh platform e-commerce (seperti biaya admin, komisi) untuk produk yang diretur akan **dihilangkan** dan dikurangi dari total biaya.
                </li>
                <li>
                    <strong>Laba Kotor & Laba Bersih:</strong> Karena Omset Kotor dan Omset Bersih berkurang, maka nilai **Laba Kotor** dan **Laba Bersih** juga akan **terpengaruh dan ikut berkurang** secara proporsional.
                </li>
            </ul>
        </div>
        
        <p>
            Dengan alur kerja ini, Anda tidak perlu lagi melakukan koreksi manual pada laporan keuangan. Cukup catat data retur, dan sistem akan mengurus sisanya, sehingga data di dashboard Anda selalu mencerminkan kondisi bisnis yang sebenarnya.
        </p>

    </div>
    <div class="flex-shrink-0 flex justify-end gap-3 mt-4 pt-4 border-t">
        <button @click="hideModal" class="bg-slate-200 text-slate-800 font-bold py-2 px-4 rounded-lg hover:bg-slate-300">Tutup</button>
    </div>
</div>

        <div v-if="uiState.modalType === 'kpiHelp'" class="bg-white rounded-lg shadow-xl p-6 max-w-xl w-full">
    <div class="flex justify-between items-center pb-4 border-b mb-4">
        <h3 class="text-xl font-bold text-slate-800">{{ uiState.modalData?.title || 'Informasi' }}</h3>
    </div>
    <div class="space-y-4 text-slate-700">
        <div v-if="uiState.modalData?.description">
            <p class="text-sm italic">{{ uiState.modalData.description }}</p>
        </div>
        <div v-if="uiState.modalData?.formula">
            <p class="text-xs font-medium text-slate-700">Rumus:</p>
            <p class="font-mono text-sm mt-1 bg-slate-200 p-2 rounded-md">{{ uiState.modalData.formula }}</p>
        </div>
    </div>
    <div class="flex justify-end mt-6 pt-4 border-t">
        <button @click="hideModal" class="bg-slate-300 py-2 px-4 rounded-lg">Tutup</button>
    </div>
</div>

<div v-if="uiState.modalType === 'panduanStockAdjustment'" class="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 bg-white rounded-lg shadow-xl p-6 max-w-4xl w-full max-h-[90vh] flex flex-col">
    <div class="flex-shrink-0 pb-4 border-b">
        <h3 class="text-2xl font-bold text-slate-800">Panduan Fitur Penyesuaian Stok</h3>
        <p class="text-slate-500">Memahami alur kerja untuk menjaga akurasi data inventaris dan keuangan.</p>
    </div>
    
    <div class="flex-1 overflow-y-auto py-4 pr-2">
        <div class="space-y-6 text-slate-700 leading-relaxed prose">
            
            <div class="p-4 bg-slate-50 rounded-lg">
                <h4 class="text-lg font-semibold text-indigo-700">Tujuan Fitur Ini</h4>
                <p class="mt-1 text-sm">
                    Fitur <strong>Penyesuaian Stok</strong> adalah alat vital untuk memastikan data stok di dalam sistem selalu 100% sama dengan jumlah stok fisik di gudang Anda. Fitur ini digunakan untuk mencatat semua perubahan stok yang terjadi di luar alur penjualan normal.
                </p>
            </div>

            <div class="p-4 bg-slate-50 rounded-lg">
                <h4 class="text-lg font-semibold text-indigo-700">1. Penambahan Stok (+)</h4>
                <p class="mt-1 text-sm">Pilih tipe ini untuk <strong>menambah</strong> jumlah stok fisik. Gunakan untuk kasus seperti:</p>
                <ul class="list-disc list-inside space-y-1 mt-2 text-sm">
                    <li><strong>Stok Awal:</strong> Saat pertama kali memasukkan data produk ke dalam sistem.</li>
                    <li><strong>Hasil Produksi:</strong> Jika Anda tidak menggunakan tombol "+ Masukkan ke Inventaris" di halaman laporan produksi.</li>
                    <li><strong>Penyesuaian Inventaris:</strong> Ketika hasil stok opname menemukan jumlah fisik lebih banyak daripada yang tercatat di sistem.</li>
                </ul>
                <p class="mt-3 text-xs text-slate-500"><strong>Catatan:</strong> Untuk retur dari pelanggan, sangat direkomendasikan menggunakan halaman <strong>Manajemen Retur</strong> agar kalkulasi keuangan di dasbor lebih akurat.</p>
            </div>

            <div class="p-4 bg-yellow-50 border border-yellow-300 rounded-lg">
                <h4 class="text-lg font-semibold text-yellow-800">2. Pengurangan Stok (-)</h4>
                 <p class="mt-1 text-sm text-yellow-900">Pilih tipe ini untuk <strong>mengurangi</strong> jumlah stok fisik. Ini adalah fitur krusial untuk mencatat kerugian.</p>
                <ul class="list-disc list-inside space-y-1 mt-2 text-sm">
                    <li><strong>Barang Hilang atau Rusak:</strong> Ketika produk hilang dari gudang atau rusak sehingga tidak bisa dijual.</li>
                    <li><strong>Digunakan untuk Sampel:</strong> Ketika produk diambil untuk keperluan promosi, foto, atau sampel.</li>
                    <li><strong>Penyesuaian Inventaris:</strong> Ketika hasil stok opname menemukan jumlah fisik lebih sedikit daripada yang tercatat.</li>
                </ul>
                <div class="mt-4 p-3 bg-red-100 text-red-800 border-l-4 border-red-500">
                    <p class="font-bold">PENTING: Dampak Finansial Otomatis</p>
                    <p class="mt-2 text-sm">Setiap kali Anda melakukan <strong>Pengurangan Stok</strong>, sistem akan secara otomatis membuat catatan <strong>pengeluaran</strong> baru di halaman <strong>Manajemen Keuangan</strong> dengan kategori "Kerugian Stok". Nilai kerugian yang dicatat adalah <strong>Jumlah Stok Hilang dikalikan dengan HPP (Harga Pokok)</strong> produk tersebut. Ini memastikan laporan laba rugi Anda tetap akurat.</p>
                </div>
            </div>
        </div>
    </div>

    <div class="flex-shrink-0 flex justify-end gap-3 mt-4 pt-4 border-t">
        <button @click="hideModal" class="bg-slate-200 text-slate-800 font-bold py-2 px-4 rounded-lg hover:bg-slate-300">Mengerti</button>
    </div>
</div>

<div v-if="uiState.modalType === 'investorInfo'" class="bg-white rounded-lg shadow-xl p-6 max-w-6xl w-full h-full md:max-h-[90vh] flex flex-col">
    <div class="flex-shrink-0 pb-4 border-b">
        <h3 class="text-2xl font-bold text-slate-800">Informasi Halaman Manajemen Investor</h3>
        <p class="text-slate-500">Panduan untuk mengelola modal, melacak profitabilitas, dan memahami metrik kunci.</p>
    </div>
    
    <div class="flex-1 overflow-y-auto py-4 pr-2">
        <div class="space-y-6 text-slate-700 leading-relaxed prose">
            
            <div class="p-4 bg-slate-50 rounded-lg">
                <h4 class="text-lg font-semibold text-indigo-700">Tujuan Halaman Ini</h4>
                <p class="mt-1 text-sm">
                    Halaman Manajemen Investor adalah pusat kendali Anda untuk semua aktivitas yang berkaitan dengan permodalan eksternal. Tujuannya adalah memberikan transparansi penuh atas kinerja setiap investasi, memastikan akuntabilitas, dan memfasilitasi pembagian hasil yang adil dan akurat.
                </p>
                <ul class="list-disc list-inside space-y-1 mt-2 text-sm">
                    <li><strong>Pencatatan Terpusat:</strong> Mencatat setiap investor, jumlah modal yang ditanamkan, dan persentase bagi hasil yang disepakati.</li>
                    <li><strong>Pelacakan Kinerja:</strong> Memantau total bagi hasil yang telah dibayarkan kepada setiap investor.</li>
                    <li><strong>Kalkulasi Otomatis:</strong> Menghitung dan menyajikan laporan bagi hasil secara otomatis berdasarkan kinerja bisnis pada periode tertentu.</li>
                </ul>
            </div>

            <div class="p-4 bg-slate-50 rounded-lg">
                <h4 class="text-lg font-semibold text-indigo-700">Memahami ROI (Return on Investment)</h4>
                <p class="mt-1 text-sm">
                    <strong>ROI</strong> adalah metrik kinerja fundamental yang digunakan untuk mengevaluasi efisiensi atau profitabilitas sebuah investasi. Sederhananya, ROI menjawab pertanyaan: <strong>"Dari setiap rupiah yang diinvestasikan, berapa rupiah yang telah kembali sebagai bagi hasil?"</strong>
                </p>
                <p class="mt-2 text-sm">
                    Ini adalah indikator utama kesehatan sebuah investasi. Semakin tinggi persentase ROI, semakin efisien modal tersebut menghasilkan pengembalian.
                </p>
                <div class="mt-3 p-3 bg-indigo-100 text-indigo-800 border-l-4 border-indigo-500 text-sm">
                    <p class="font-bold">Formula di Aplikasi Ini:</p>
                    <p class="mt-2 font-mono text-center">
                        ROI = (Total Bagi Hasil Diterima / Modal Awal) x 100%
                    </p>
                </div>
                <p class="mt-3 text-sm">
                    <strong>Contoh Mudah:</strong> Bayangkan seorang investor menanamkan modal <strong>Rp 10.000.000</strong>. Setelah beberapa periode, ia telah menerima total bagi hasil sebesar <strong>Rp 2.500.000</strong>. Maka, ROI-nya saat ini adalah (Rp 2.500.000 / Rp 10.000.000) x 100% = <strong>25%</strong>. Ini berarti investasi tersebut telah mengembalikan 25% dari modal awalnya dalam bentuk keuntungan.
                </p>
            </div>
        </div>
    </div>

    <div class="flex-shrink-0 flex justify-end gap-3 mt-4 pt-4 border-t">
        <button @click="hideModal" class="bg-slate-200 text-slate-800 font-bold py-2 px-4 rounded-lg hover:bg-slate-300">Tutup</button>
    </div>
</div>

<div v-if="uiState.modalType === 'roasInputInfo'" class="bg-white rounded-lg shadow-xl p-6 max-w-2xl w-full">
    <h3 class="text-xl font-bold text-slate-800 mb-4">Panduan Pengisian Data</h3>
    <div class="space-y-4 text-sm text-slate-600">
        <div>
            <p class="font-semibold text-slate-800">Harga Jual / AOV</p>
            <p>Masukkan harga jual akhir produk Anda ke pelanggan (setelah diskon jika ada). AOV (Average Order Value) adalah nilai rata-rata pesanan.</p>
        </div>
        <div>
            <p class="font-semibold text-slate-800">Modal Produk (HPP)</p>
            <p>Biaya modal murni untuk membuat atau membeli satu unit produk.</p>
        </div>
        <div>
            <p class="font-semibold text-slate-800">Biaya Packing & Lainnya</p>
            <p>Estimasi biaya untuk mengemas satu pesanan, seperti bubble wrap, kardus, lakban, stiker, atau kartu ucapan.</p>
        </div>
        <div>
    <p class="font-semibold text-slate-800">Biaya Admin Marketplace (Rp)</p>
    <p>Masukkan total biaya tetap dalam Rupiah yang diambil oleh marketplace untuk satu pesanan. Contoh: jika ada biaya admin Rp 2.000 dan biaya layanan program Rp 1.500, masukkan **3500**.</p>
</div>
    </div>
    <div class="flex justify-end mt-6 pt-4 border-t">
        <button @click="hideModal" class="bg-slate-200 text-slate-800 font-bold py-2 px-4 rounded-lg hover:bg-slate-300">Mengerti</button>
    </div>
</div>

<div v-if="uiState.modalType === 'roasResultInfo'" class="bg-white rounded-lg shadow-xl p-6 max-w-2xl w-full">
    <h3 class="text-xl font-bold text-slate-800 mb-4">Memahami Hasil Perhitungan</h3>
    <div class="space-y-4 text-sm text-slate-600">
        <div>
            <p class="font-semibold text-slate-800">Profit Kotor / Penjualan</p>
            <p>Ini adalah keuntungan bersih yang Anda dapatkan dari **satu penjualan**, sebelum dikurangi biaya iklan. Rumusnya: `Harga Jual - (Semua Biaya)`.</p>
        </div>
        <div>
            <p class="font-semibold text-slate-800">ROAS Impas (BEP - Break Even Point)</p>
            <p>Ini adalah angka ROAS **paling minimum** yang harus Anda capai agar tidak rugi (modal kembali, tapi belum untung). Jika ROAS iklan Anda di bawah angka ini, berarti Anda rugi.</p>
        </div>
        <div>
            <p class="font-semibold text-slate-800">Target ROAS (untuk Profit)</p>
            <p>Ini adalah angka ROAS yang harus Anda targetkan di platform iklan (Shopee Ads, TikTok Ads) untuk mendapatkan margin keuntungan bersih sesuai yang Anda inginkan setelah dikurangi biaya iklan.</p>
            <p class="mt-2 p-2 bg-yellow-50 rounded-md border-l-4 border-yellow-400"><strong>Kapan "Tidak Mungkin"?</strong> Muncul jika target profit Anda lebih besar dari profit kotor yang tersedia. Artinya, tidak ada sisa profit untuk membayar biaya iklan.</p>
        </div>
    </div>
    <div class="flex justify-end mt-6 pt-4 border-t">
        <button @click="hideModal" class="bg-slate-200 text-slate-800 font-bold py-2 px-4 rounded-lg hover:bg-slate-300">Mengerti</button>
    </div>
</div>

<div v-if="uiState.modalType === 'roasSimulationInfo'" class="bg-white rounded-lg shadow-xl p-6 max-w-3xl w-full">
    <h3 class="text-xl font-bold text-slate-800 mb-4">Panduan Membaca Tabel Simulasi</h3>
    <div class="space-y-4 text-sm text-slate-600">
        <p>Tabel ini membantu Anda memproyeksikan hasil akhir dari kampanye iklan Anda berdasarkan budget dan target ROAS yang berbeda.</p>
        
        <div>
            <p class="font-semibold text-slate-800">Penjelasan Kolom:</p>
            <ul class="list-disc list-inside ml-4 mt-1 space-y-1">
                <li><strong>Estimasi Order:</strong> Perkiraan jumlah penjualan yang akan Anda dapatkan. Dihitung dari `(Budget Iklan * Target ROAS) / Harga Jual`.</li>
                <li><strong>Estimasi Omset:</strong> Perkiraan total pendapatan kotor dari iklan. Dihitung dari `Budget Iklan * Target ROAS`.</li>
                <li><strong>Estimasi Laba Bersih:</strong> Ini adalah metrik paling penting. Ini adalah perkiraan **keuntungan bersih** Anda setelah **dikurangi budget iklan**. Dihitung dari `(Total Profit Kotor dari semua order) - Budget Iklan`.</li>
            </ul>
        </div>

        <div>
            <p class="font-semibold text-slate-800">Penjelasan Skenario:</p>
             <ul class="list-disc list-inside ml-4 mt-1 space-y-1">
                <li><strong>Skenario Impas (BEP):</strong> Menunjukkan hasil jika ROAS iklan Anda sama persis dengan angka ROAS Impas. Laba Bersih di skenario ini akan selalu **Rp 0**.</li>
                <li><strong>Skenario Target Profit 20%:</strong> Menunjukkan hasil jika Anda berhasil mencapai target ROAS untuk mendapatkan profit 20% dari harga jual.</li>
                <li><strong>Skenario Kustom:</strong> Baris interaktif di mana Anda bisa memasukkan angka ROAS apa pun untuk melihat langsung potensi profit atau kerugiannya.</li>
            </ul>
        </div>
    </div>
    <div class="flex justify-end mt-6 pt-4 border-t">
        <button @click="hideModal" class="bg-slate-200 text-slate-800 font-bold py-2 px-4 rounded-lg hover:bg-slate-300">Mengerti</button>
    </div>
</div>

<div v-if="uiState.modalType === 'biayaOperasionalHelp'" class="bg-white rounded-lg shadow-xl p-6 max-w-lg w-full">
    <div class="flex justify-between items-center pb-3 border-b mb-4">
        <h3 class="text-xl font-bold text-slate-800 flex items-center gap-2">
            <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 text-indigo-500" viewBox="0 0 20 20" fill="currentColor"><path fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clip-rule="evenodd" /></svg>
            Informasi Perhitungan Biaya Operasional
        </h3>
    </div>
    <div class="space-y-4 text-slate-700">
        <p class="text-sm">
            Angka <strong>Biaya Operasional</strong> yang ditampilkan di sini adalah total dari semua pengeluaran yang tercatat di halaman <strong>Manajemen Keuangan</strong> selama periode laporan yang dipilih.
        </p>
        <div class="p-3 bg-yellow-50 text-yellow-800 border-l-4 border-yellow-400 text-sm">
            <p class="font-semibold">Penting:</p>
            <p class="mt-1">
                Untuk menjaga akurasi perhitungan bagi hasil, setiap transaksi pengeluaran yang catatannya berisi frasa <strong>"Bagi hasil"</strong> secara otomatis <strong>dikecualikan</strong> dan tidak akan dihitung ke dalam total Biaya Operasional pada laporan ini.
            </p>
        </div>
        <p class="text-sm">
            Ini memastikan bahwa pembayaran bagi hasil dari periode sebelumnya tidak membebani perhitungan laba bersih untuk periode saat ini.
        </p>
    </div>
    <div class="flex justify-end mt-6 pt-4 border-t">
        <button @click="hideModal" class="bg-slate-200 text-slate-800 font-bold py-2 px-4 rounded-lg hover:bg-slate-300">Mengerti</button>
    </div>
</div>

<div v-if="uiState.modalType === 'addBankAccount' || uiState.modalType === 'editBankAccount'" class="bg-white rounded-lg shadow-xl p-6 max-w-2xl w-full">
    <h3 class="text-xl font-bold mb-4">{{ uiState.modalType === 'addBankAccount' ? 'Tambah Rekening' : 'Edit Rekening' }}</h3>
    <form @submit.prevent="submitBankAccount" class="space-y-4">
        <div>
            <label class="block text-sm font-medium">Nama Bank</label>
            <input type="text" v-model="uiState.modalData.bankName" class="mt-1 w-full p-2 border rounded-md" required placeholder="Contoh: BCA">
        </div>
        <div>
            <label class="block text-sm font-medium">Nomor Rekening</label>
            <input type="text" v-model="uiState.modalData.accountNumber" class="mt-1 w-full p-2 border rounded-md" required placeholder="Contoh: 1234567890">
        </div>
        <div>
            <label class="block text-sm font-medium">Atas Nama</label>
            <input type="text" v-model="uiState.modalData.accountName" class="mt-1 w-full p-2 border rounded-md" required placeholder="Contoh: John Doe">
        </div>
        <div class="flex justify-end gap-3 pt-4 border-t mt-4">
            <button type="button" @click="hideModal" class="bg-slate-200 py-2 px-4 rounded-lg">Batal</button>
            <button type="submit" class="bg-indigo-600 text-white py-2 px-4 rounded-lg">Simpan</button>
        </div>
    </form>
</div>

<div v-if="uiState.modalType === 'laporanBagiHasilDetail'" class="bg-white rounded-lg shadow-xl p-6 max-w-4xl w-full max-h-[90vh] flex flex-col">
    <div id="print-area-investor" class="print-content">
        <div class="flex-shrink-0 pb-4 border-b">
            <h3 class="text-xl font-bold text-slate-800">Detail Laporan Bagi Hasil</h3>
            <p class="text-slate-600">Investor: <span class="font-semibold">{{ uiState.modalData.investorName }}</span></p>
            <p class="text-slate-600">Periode: <span class="font-semibold">{{ uiState.modalData.period }}</span></p>
        </div>
        <div class="flex-1 overflow-y-auto py-4 pr-2">
            <div class="grid grid-cols-1 md:grid-cols-2 gap-8 text-sm">
                
                <div class="space-y-2 p-4 bg-indigo-50 rounded-lg">
                    <h4 class="font-bold text-base mb-2">Pembagian Hasil</h4>
                    <div v-if="uiState.modalData.labaBersih > 0">
                        <div class="flex justify-between"><span>Bagian Investor ({{ uiState.modalData.profitSharePercentage }}%)</span><span class="font-bold text-xl text-green-700">{{ formatCurrency(uiState.modalData.investorShare) }}</span></div>
                        <div class="flex justify-between mt-2"><span>Bagian Perusahaan</span><span class="font-medium">{{ formatCurrency(uiState.modalData.companyShare) }}</span></div>
                        <div class="mt-6 pt-4 border-t space-y-3">
                            <div><label class="block text-sm font-medium">Metode Pembayaran</label><p class="mt-1 font-semibold capitalize">{{ uiState.modalData.paymentMethod }}</p></div>
                            <div v-if="uiState.modalData.paymentMethod === 'transfer'">
                                <p class="text-xs text-slate-500 mt-1">Detail Bank:</p>
                                <p class="text-sm font-medium">Nama Bank: {{ uiState.modalData.bankDetails?.bankName }}</p>
                                <p class="text-sm font-medium">No. Rek: {{ uiState.modalData.bankDetails?.accountNumber }}</p>
                                <p class="text-sm font-medium">Atas Nama: {{ uiState.modalData.bankDetails?.accountName }}</p>
                                <p v-if="uiState.modalData.adminFee > 0" class="text-xs text-red-500 mt-2">Biaya Admin: {{ formatCurrency(uiState.modalData.adminFee) }}</p>
                            </div>
                        </div>
                    </div>
                    <div v-else class="text-center py-8"><p class="font-semibold text-slate-700">Tidak ada keuntungan pada periode ini.</p></div>
                </div>

                <div class="space-y-2 p-4 bg-slate-50 rounded-lg">
    <h4 class="font-bold text-base mb-2">Perhitungan Laba Bersih</h4>
    
    <div class="flex justify-between"><span>Omset Bersih Penjualan</span> <span class="font-medium text-green-600">{{ formatCurrency(uiState.modalData.omsetBersihPenjualan) }}</span></div>
    <div class="flex justify-between"><span>(-) Omset Bersih dari Retur</span> <span class="font-medium text-red-600">{{ formatCurrency(uiState.modalData.omsetBersihDariRetur) }}</span></div>
    <div class="flex justify-between font-semibold border-t pt-1"><span>= Total Omset Bersih</span> <span>{{ formatCurrency(uiState.modalData.omsetBersihFinal) }}</span></div>
    
    <div class="flex justify-between mt-3"><span>(-) HPP Terjual</span> <span class="font-medium text-red-600">{{ formatCurrency(uiState.modalData.totalHppTerjual) }}</span></div>
    <div class="flex justify-between"><span>(-) HPP dari Retur</span> <span class="font-medium text-red-600">{{ formatCurrency(uiState.modalData.totalHppRetur) }}</span></div>
    <div class="flex justify-between font-semibold border-t pt-1"><span>= Total HPP</span> <span class="text-red-600">{{ formatCurrency(uiState.modalData.hppTerjualFinal) }}</span></div>

    <div class="flex justify-between font-bold border-t-2 pt-2 mt-2"><span>LABA KOTOR</span> <span>{{ formatCurrency(uiState.modalData.labaKotor) }}</span></div>
    
    <div class="flex justify-between mt-3"><span>(-) Biaya Marketplace (Penjualan)</span> <span class="font-medium text-red-600">{{ formatCurrency(uiState.modalData.biayaMarketplacePenjualan) }}</span></div>
    <div class="flex justify-between"><span>(-) Biaya Marketplace (dari Retur)</span> <span class="font-medium text-red-600">{{ formatCurrency(uiState.modalData.biayaMarketplaceBatal) }}</span></div>
    <div class="flex justify-between font-semibold border-t pt-1"><span>= Total Biaya Marketplace</span> <span class="text-red-600">{{ formatCurrency(uiState.modalData.totalBiayaTransaksi) }}</span></div>
    
    <div class="flex justify-between mt-2">
        <span class="flex items-center gap-2">
            (-) Biaya Operasional
            <button @click="showModal('biayaOperasionalHelp')" type="button" class="w-5 h-5 rounded-full flex items-center justify-center bg-slate-200 text-slate-600 font-bold text-sm hover:bg-slate-300">?</button>
        </span> 
        <span class="font-medium text-red-600">{{ formatCurrency(uiState.modalData.totalBiayaOperasional) }}</span>
    </div>
    
    <div class="flex justify-between font-bold text-lg text-indigo-700 border-t-2 pt-2 mt-2">
        <div class="flex items-center gap-2">
            <span>LABA BERSIH</span>
            <button @click="showModal('labaBersihHelp')" type="button" class="w-5 h-5 rounded-full flex items-center justify-center bg-indigo-100 text-indigo-600 font-bold text-sm hover:bg-indigo-200">?</button>
        </div>
        <span>{{ formatCurrency(uiState.modalData.labaBersih) }}</span>
    </div>
</div>

            </div>
        </div>
    </div>
    <div class="flex-shrink-0 flex justify-end gap-3 mt-4 pt-4 border-t no-print">
        <button type="button" @click="printInvestorPaymentDetailed(uiState.modalData)" class="bg-blue-600 text-white font-bold py-2 px-4 rounded-lg hover:bg-blue-700">Cetak Struk</button>
        <button type="button" @click="hideModal" class="bg-slate-200 py-2 px-4 rounded-lg hover:bg-slate-300">Tutup</button>
    </div>
</div>

        <div v-if="uiState.modalType === 'confirmTransaction'" class="bg-white rounded-lg shadow-xl p-6 max-w-2xl w-full h-full md:max-h-[40vh] flex flex-col">
    <h3 class="text-2xl font-bold mb-4">Konfirmasi Transaksi</h3>
    <p class="text-slate-600 mb-4">Anda akan menyelesaikan transaksi untuk channel <span class="font-semibold text-slate-800">{{ uiState.modalData.channelName }}</span>.</p>
    <div class="bg-slate-50 p-4 rounded-lg space-y-2 text-sm">
        <div class="flex justify-between font-bold text-lg">
            <span>Total HPP Barang:</span>
            <span>{{ formatCurrency(activeCart.reduce((total, item) => total + ((Number(item.hpp) || 0) * (Number(item.qty) || 0)), 0)) }}</span>
        </div>
        <div class="flex justify-between text-slate-500">
            <span>Jumlah Barang:</span><span>{{ cartSummary.itemCount }}</span>
        </div>
    </div>
    <p class="mt-4 text-sm text-slate-600">Apakah Anda yakin ingin melanjutkan?</p>
    <div class="flex justify-end gap-3 mt-6">
        <button @click="hideModal" class="bg-slate-200 text-slate-800 font-bold py-2 px-4 rounded-lg hover:bg-slate-300">Batal</button>
        <button @click="executeCompleteTransaction" class="bg-indigo-600 text-white font-bold py-2 px-4 rounded-lg hover:bg-indigo-700">Ya, Selesaikan</button>
    </div>
</div>
<div v-if="uiState.modalType === 'addProduct'" class="bg-white rounded-lg shadow-xl p-6 max-w-3xl w-full h-full md:max-h-[120vh] flex flex-col">
    <h3 class="text-xl font-bold mb-2">Tambah Produk Baru</h3>
    <p class="text-sm text-slate-500 mb-4">Isi HPP/modal produk pada formulir ini agar Fashion OS bisa mencocokkan transaksi dengan biaya modal. Harga jual tiap channel dapat diatur di halaman Harga & HPP.</p>
    <form @submit.prevent="submitAddProduct" class="space-y-4 overflow-y-auto max-h-[75vh] p-2">
        <div>
            <label for="product-sku" class="block text-sm font-medium text-slate-700">SKU (Stock Keeping Unit)</label>
            <input type="text" v-model="uiState.modalData.sku" id="product-sku" class="mt-1 block w-full p-2 border border-slate-300 rounded-md shadow-sm" placeholder="Contoh: TSH-BL-M001" required>
        </div>
        
        <div>
            <label for="product-model" class="block text-sm font-medium text-slate-700">Model Produk</label>
            <div v-if="state.settings.modelProduk.length === 0" class="mt-1 p-3 bg-red-100 text-red-800 border-l-4 border-red-500 rounded-lg shadow-sm">
                <p class="font-semibold mb-1">Peringatan:</p>
                <p class="text-sm">Anda belum memiliki data model Produk. Silakan tambahkan di halaman **Pengaturan** terlebih dahulu.</p>
                <a href="#" @click.prevent="changePage('pengaturan'); hideModal();" class="mt-2 inline-block text-red-700 font-bold hover:underline">
                    Buka Halaman Pengaturan &raquo;
                </a>
            </div>
            <select v-else v-model="uiState.modalData.modelId" @change="handleModelProdukChange()" id="product-model" class="mt-1 block w-full p-2 border border-slate-300 rounded-md shadow-sm" required>
    <option value="">-- Pilih Model --</option>
    <option v-for="model in state.settings.modelProduk" :key="model.id" :value="model.id">{{ model.namaModel }}</option>
</select>
        </div>
        
        <div>
            <label for="product-name" class="block text-sm font-medium text-slate-700">Nama Produk</label>
            <input type="text" v-model="uiState.modalData.nama" id="product-name" class="mt-1 block w-full p-2 border border-slate-300 rounded-md shadow-sm" placeholder="Contoh: Kaos Polos" required>
        </div>
        <div>
            <label for="product-color" class="block text-sm font-medium text-slate-700">Warna</label>
            <input type="text" v-model="uiState.modalData.warna" id="product-color" class="mt-1 block w-full p-2 border border-slate-300 rounded-md shadow-sm" placeholder="Contoh: Hitam" required>
        </div>
        <div>
            <label for="product-variant" class="block text-sm font-medium text-slate-700">Varian (Ukuran/Model)</label>
            <input type="text" v-model="uiState.modalData.varian" id="product-variant" class="mt-1 block w-full p-2 border border-slate-300 rounded-md shadow-sm" placeholder="Contoh: M, L, XL" required>
        </div>

        <div>
            <label for="product-hpp" class="block text-sm font-medium text-slate-700">HPP / Modal per Produk (Rp)</label>
            <input type="number" v-model.number="uiState.modalData.hpp" id="product-hpp" min="1" step="1" inputmode="numeric" class="mt-1 block w-full p-2 border border-slate-300 rounded-md shadow-sm" placeholder="Contoh: 65000" required>
            <p class="mt-1 text-xs text-slate-500">Masukkan modal untuk satu pcs produk, tanpa tanda titik atau koma.</p>
        </div>
        
        <div class="flex justify-end gap-3 mt-15">
            <button type="button" @click="hideModal" class="bg-slate-300 text-slate-800 font-bold py-2 px-4 rounded-lg hover:bg-slate-400">Batal</button>
            <button type="submit" class="bg-indigo-600 text-white font-bold py-2 px-4 rounded-lg hover:bg-indigo-700">Tambah Produk</button>
        </div>
    </form>
</div>

<div v-if="uiState.modalType === 'addInvestor' || uiState.modalType === 'editInvestor'" class="bg-white rounded-lg shadow-xl p-6 max-w-2xl w-full">
    <h3 class="text-xl font-bold mb-4">{{ uiState.modalType === 'addInvestor' ? 'Tambah Investor Baru' : 'Edit Data Investor' }}</h3>
    <form @submit.prevent="submitInvestorForm(uiState.modalType === 'editInvestor')" class="space-y-4">
        <div>
            <label class="block text-sm font-medium">Nama Investor</label>
            <input type="text" v-model="uiState.modalData.name" class="mt-1 w-full p-2 border rounded-md" required>
        </div>
        <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
                <label class="block text-sm font-medium">Jumlah Investasi (Rp)</label>
                <input type="number" v-model.number="uiState.modalData.amount" class="mt-1 w-full p-2 border rounded-md" required>
            </div>
            <div>
                <label class="block text-sm font-medium">Persentase Bagi Hasil (%)</label>
                <input type="number" v-model.number="uiState.modalData.profitShare" class="mt-1 w-full p-2 border rounded-md" required>
            </div>
        </div>
        <div>
            <label class="block text-sm font-medium">Tanggal Mulai Investasi</label>
            <input type="date" v-model="uiState.modalData.startDate" class="mt-1 w-full p-2 border rounded-md" required>
        </div>

        <div>
            <label class="block text-sm font-medium">Status Investor</label>
            <select v-model="uiState.modalData.status" class="mt-1 w-full p-2 border rounded-md">
                <option value="aktif">Aktif</option>
                <option value="selesai">Selesai</option>
            </select>
        </div>

        <div class="flex justify-end gap-3 pt-4 border-t mt-4">
            <button type="button" @click="hideModal" class="bg-slate-200 py-2 px-4 rounded-lg">Batal</button>
            <button type="submit" class="bg-indigo-600 text-white py-2 px-4 rounded-lg">Simpan</button>
        </div>
    </form>
</div>

<div v-if="uiState.modalType === 'labaBersihHelp'" class="bg-white rounded-lg shadow-xl p-6 max-w-lg w-full">
    <div class="flex justify-between items-center pb-3 border-b mb-4">
        <h3 class="text-xl font-bold text-slate-800">Definisi & Rumus Laba Bersih</h3>
    </div>
    <div class="space-y-4 text-slate-700">
        <p class="text-sm">
            <strong>Laba Bersih</strong> adalah keuntungan final yang didapat setelah mengurangi semua biaya dari pendapatan. Angka ini adalah indikator paling penting dari profitabilitas bisnis Anda pada periode yang dipilih.
        </p>
        <div>
            <p class="text-xs font-medium text-slate-600">Rumus yang Digunakan:</p>
            <p class="font-mono text-sm mt-1 bg-slate-100 p-3 rounded-md border text-center">
                Laba Kotor - (Total Biaya Marketplace + Total Biaya Operasional)
            </p>
        </div>
        <div class="text-sm space-y-2 pt-2 border-t">
             <div class="flex justify-between">
                <span class="text-slate-500">Laba Kotor</span>
                <span class="font-semibold text-green-600">{{ formatCurrency(uiState.laporanBagiHasil.result.labaKotor) }}</span>
            </div>
             <div class="flex justify-between">
                <span class="text-slate-500">(-) Biaya Marketplace</span>
                <span class="font-semibold text-red-600">{{ formatCurrency(uiState.laporanBagiHasil.result.totalBiayaTransaksi) }}</span>
            </div>
             <div class="flex justify-between">
                <span class="text-slate-500">(-) Biaya Operasional</span>
                <span class="font-semibold text-red-600">{{ formatCurrency(uiState.laporanBagiHasil.result.totalBiayaOperasional) }}</span>
            </div>
        </div>
    </div>
    <div class="flex justify-end mt-6 pt-4 border-t">
        <button @click="hideModal" class="bg-slate-200 text-slate-800 font-bold py-2 px-4 rounded-lg hover:bg-slate-300">Mengerti</button>
    </div>
</div>

<div
    v-if="uiState.modalType === 'panduanBulkProcess'"
    class="bg-white rounded-2xl shadow-2xl w-[95vw] max-w-5xl max-h-[92vh] flex flex-col overflow-hidden"
>
    <!-- HEADER -->
    <div class="flex-shrink-0 px-5 sm:px-6 py-4 border-b bg-white">
        <div class="flex items-start justify-between gap-4">
            <div>
                <h3 class="text-xl sm:text-2xl font-bold text-slate-800">
                    Panduan Fitur Proses Massal
                </h3>
                <p class="text-sm text-slate-500 mt-1">
                    Panduan untuk memproses banyak pesanan dengan lebih cepat, rapi, dan minim kesalahan.
                </p>
            </div>

            <button
                @click="hideModal"
                class="text-slate-400 hover:text-slate-700 text-2xl leading-none"
                title="Tutup"
            >
                ×
            </button>
        </div>
    </div>

    <!-- BODY -->
    <div class="flex-1 min-h-0 overflow-y-auto px-5 sm:px-6 py-5">
        <div class="space-y-5 text-slate-700 leading-relaxed">

            <div class="p-4 rounded-xl bg-slate-50 border border-slate-200">
                <p class="text-sm">
                    Halaman <strong>Proses Massal</strong> digunakan untuk memasukkan ID pesanan dan produk yang terjual dalam jumlah banyak.
                    Fitur ini cocok dipakai ketika pesanan sedang ramai dan Anda ingin mempercepat proses input transaksi.
                </p>

                <p class="text-sm mt-2 font-semibold text-slate-800">
                    Sebelum mulai, pastikan Anda sudah memilih Channel Penjualan terlebih dahulu.
                </p>
            </div>

            <!-- ALUR 1 -->
            <div class="p-4 sm:p-5 border rounded-xl bg-blue-50 border-blue-200">
                <div class="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-2">
                    <h4 class="text-lg font-bold text-blue-800">
                        Alur Kerja #1: Salin & Tempel Massal ID Pesanan
                    </h4>

                    <span class="w-fit text-xs bg-blue-100 text-blue-700 font-bold px-3 py-1 rounded-full">
                        Cocok untuk banyak pesanan
                    </span>
                </div>

                <p class="mt-2 text-sm text-slate-600">
                    Gunakan alur ini jika hasil scan ID pesanan dan SKU produk sudah dikumpulkan terlebih dahulu di Excel.
                    Setelah itu, Anda cukup salin semua data dari Excel lalu tempel ke kolom
                    <strong>Salin & Tempel Massal ID Pesanan</strong>.
                </p>

                <ol class="list-decimal ml-5 space-y-1 mt-3 text-sm">
                    <li>Scan ID pesanan atau resi terlebih dahulu.</li>
                    <li>Setelah itu scan barcode SKU produk.</li>
                    <li>Jika 1 pesanan berisi lebih dari 1 produk, masukkan semua SKU produk di bawah ID pesanan tersebut.</li>
                    <li>Ulangi pola yang sama untuk pesanan berikutnya.</li>
                    <li>Semua hasil scan bisa dimasukkan dulu ke Excel dalam 1 kolom.</li>
                    <li>Salin semua isi kolom Excel lalu tempel ke kolom salin-tempel massal.</li>
                    <li>Klik <strong>Validasi Data</strong> untuk mengecek apakah ID pesanan dan SKU sudah terbaca dengan benar.</li>
                    <li>Jika data sudah aman, klik <strong>Masukkan ke Antrian Pesanan</strong>.</li>
                    <li>Pesanan akan masuk ke bagian <strong>Antrian Pesanan untuk Diproses</strong>.</li>
                </ol>

                <div class="mt-4">
                    <p class="text-xs font-bold text-slate-600 mb-2">
                        Contoh format:
                    </p>

                    <pre class="bg-white border border-blue-100 rounded-lg p-3 text-xs text-slate-700 overflow-x-auto">SPX2345
BAJU-HTM-L
BAJU-HTM-M
BAJU-HTM-L
SPX5678
BAJU-PUTIH-M</pre>
                </div>

                <div class="mt-4 text-xs text-slate-600 space-y-1">
                    <p><strong>Keterangan:</strong></p>
                    <p>- <strong>SPX2345</strong> dianggap sebagai ID pesanan.</p>
                    <p>- <strong>BAJU-HTM-L</strong> dianggap sebagai SKU produk.</p>
                    <p>- Jika SKU yang sama muncul 3 kali, maka qty produk menjadi 3.</p>
                    <p>- Baris yang cocok dengan SKU di aplikasi akan dianggap sebagai produk.</p>
                    <p>- Baris yang tidak cocok dengan SKU akan dianggap sebagai ID pesanan.</p>
                    <p>- Format ID pesanan bebas, bisa angka, huruf, campuran, spasi, strip, atau underscore.</p>
                    <p>- Pastikan SKU hasil scan barcode sama persis dengan SKU produk yang ada di aplikasi.</p>
                </div>
            </div>

            <!-- ALUR 2 -->
            <div class="p-4 sm:p-5 border rounded-xl bg-slate-50 border-slate-200">
                <div class="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-2">
                    <h4 class="text-lg font-bold text-slate-800">
                        Alur Kerja #2: Input Manual Tanpa Scanner
                    </h4>

                    <span class="w-fit text-xs bg-slate-200 text-slate-700 font-bold px-3 py-1 rounded-full">
                        Cocok untuk sedikit pesanan
                    </span>
                </div>

                <p class="mt-2 text-sm text-slate-600">
                    Gunakan alur ini jika Anda ingin memasukkan pesanan satu per satu secara manual.
                    Alur ini cocok dipakai saat jumlah pesanan sedikit atau saat Anda ingin mengecek produk dengan lebih teliti.
                </p>

                <ol class="list-decimal ml-5 space-y-1 mt-3 text-sm">
                    <li>Ketik SKU atau nama produk di kolom <strong>Input Manual</strong>.</li>
                    <li>Pilih produk dari daftar rekomendasi yang muncul.</li>
                    <li>Jika pesanan berisi lebih dari 1 produk, tambahkan semua produknya terlebih dahulu.</li>
                    <li>Setelah produk lengkap, masukkan ID pesanan atau resi.</li>
                    <li>Klik <strong>Proses Pesanan Ini</strong>.</li>
                    <li>Pesanan akan masuk ke antrian atau riwayat proses sesuai alur yang tersedia di sistem.</li>
                </ol>
            </div>

            <!-- PENUTUP -->
            <div class="p-4 bg-green-50 text-green-800 border-l-4 border-green-500 rounded-r-xl text-sm">
                <p class="font-bold">
                    Pilih Alur Kerja yang Sesuai
                </p>

                <p class="mt-2">
                    Gunakan <strong>Salin & Tempel Massal</strong> jika Anda menangani banyak pesanan sekaligus.
                    Gunakan <strong>Input Manual</strong> jika Anda hanya memproses sedikit pesanan atau ingin memasukkan pesanan satu per satu dengan kontrol penuh.
                </p>
            </div>

        </div>
    </div>

    <!-- FOOTER -->
    <div class="flex-shrink-0 flex justify-end gap-3 px-5 sm:px-6 py-4 border-t bg-white">
        <button
            @click="hideModal"
            class="bg-slate-200 text-slate-800 font-bold py-2 px-5 rounded-lg hover:bg-slate-300"
        >
            Tutup
        </button>
    </div>
</div>

<div v-if="uiState.modalType === 'addStockIn'" class="bg-white rounded-lg shadow-xl p-6 max-w-3xl w-full max-h-[90vh] flex flex-col">
    <div class="flex items-center gap-4 mb-4">
        <h3 class="text-xl font-bold">Buat Penyesuaian Stok</h3>
        <button @click="showModal('panduanStockAdjustment')" class="bg-indigo-100 text-indigo-700 font-bold py-2 px-4 rounded-lg hover:bg-indigo-200 text-sm flex items-center gap-2">
            <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor"><path fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clip-rule="evenodd"></path></svg>
            Informasi
        </button>
    </div>
    
    <form @submit.prevent="submitStockAdjustment" class="flex flex-col h-full space-y-4">
        <div>
            <label class="block text-sm font-medium text-slate-700">Tipe Penyesuaian</label>
            <select v-model="uiState.modalData.tipe" class="mt-1 block w-full p-2 border border-slate-300 rounded-md shadow-sm" required>
                <option value="penambahan">Penambahan Stok (+)</option>
                <option value="pengurangan">Pengurangan Stok (-)</option>
            </select>
        </div>

        <div class="relative">
    <label for="stock-in-sku" class="block text-sm font-medium text-slate-700">Cari SKU Produk</label>
    <input 
        type="text" 
        v-model="uiState.modalData.sku" 
        @input="handleStockInSearch"  id="stock-in-sku" 
        class="mt-1 block w-full p-2 border border-slate-300 rounded-md shadow-sm" 
        placeholder="Ketik SKU atau Nama Produk..." 
        required 
        autocomplete="off"
    >
    <div v-if="uiState.stockInSearchRecommendations.length > 0" class="absolute z-10 w-full mt-1 bg-white border border-gray-200 rounded-lg shadow-lg max-h-48 overflow-y-auto">
        <div 
            v-for="p in uiState.stockInSearchRecommendations" 
            :key="p.sku" 
            @click="selectStockInRecommendation(p)" 
            class="p-3 hover:bg-slate-100 cursor-pointer border-b last:border-b-0"
        >
            <p class="font-semibold text-slate-800">{{ p.nama }}</p>
            <p class="text-sm text-slate-500">{{ p.sku }} - {{ p.warna }} - {{ p.varian }} | <span class="font-medium">Stok: {{ p.stokFisik }}</span></p>
        </div>
    </div>
</div>

        <div>
            <label for="stock-in-qty" class="block text-sm font-medium text-slate-700">Jumlah (Pcs)</label>
            <input type="number" v-model.number="uiState.modalData.qty" id="stock-in-qty" class="mt-1 block w-full p-2 border border-slate-300 rounded-md shadow-sm" placeholder="Contoh: 50" required>
        </div>

        <div>
            <label for="stock-in-reason" class="block text-sm font-medium text-slate-700">Alasan Penyesuaian</label>
            <select v-model="uiState.modalData.alasan" id="stock-in-reason" class="mt-1 block w-full p-2 border border-slate-300 rounded-md shadow-sm" required>
                <option value="" disabled>-- Pilih Alasan --</option>
                <template v-if="uiState.modalData.tipe === 'penambahan'">
                    <option value="Stok Awal">Stok Awal</option>
                    <option value="Hasil Produksi">Hasil Produksi</option>
                    <option value="Retur dari Pelanggan">Retur dari Pelanggan</option>
                    <option value="Penyesuaian Inventaris">Penyesuaian Inventaris (+)</option>
                </template>
                <template v-else>
                    <option value="Barang Hilang">Barang Hilang</option>
                    <option value="Barang Rusak">Barang Rusak</option>
                    <option value="Digunakan untuk Sampel">Digunakan untuk Sampel</option>
                    <option value="Penyesuaian Inventaris">Penyesuaian Inventaris (-)</option>
                </template>
                <option value="Lain-lain">Lain-lain</option>
            </select>
        </div>
        
        <div class="flex justify-end gap-3 mt-auto pt-4 border-t">
            <button type="button" @click="hideModal" class="bg-slate-200 text-slate-800 font-bold py-2 px-4 rounded-lg hover:bg-slate-300">Batal</button>
            <button type="submit" class="bg-green-600 text-white font-bold py-2 px-4 rounded-lg hover:bg-green-700">Simpan Penyesuaian</button>
        </div>
    </form>
</div>

<div v-if="uiState.nestedModalType === 'panduanStockIn'" class="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4">
    <div class="bg-white rounded-lg shadow-xl p-6 max-w-3xl w-4/5 max-h-[90vh] flex flex-col">
        <div class="flex-shrink-0 pb-4 border-b">
            <h3 class="text-2xl font-bold text-slate-800">Panduan Penambahan Stok Inventaris</h3>
            <p class="text-slate-500">Memahami alur yang tepat untuk menjaga keakuratan data stok.</p>
        </div>

        <div class="flex-1 overflow-y-auto py-4 pr-2">
            <div class="space-y-6 text-slate-700 leading-relaxed">
                <div>
                    <h4 class="text-xl font-semibold">1. Penambahan Stok dari Produksi</h4>
                    <p class="mt-2">Ketika produk baru selesai diproduksi, penambahan stok harus dilakukan melalui halaman **Laporan Detail Gabungan**. Caranya:</p>
                    <ul class="list-disc list-inside space-y-1 mt-2">
                        <li>Kunjungi halaman **Produksi** dan klik **Laporan Detail Gabungan**.</li>
                        <li>Temukan item yang sudah selesai dan klik tombol **"+ Masukkan ke Inventaris"**.</li>
                        <li>**Penting:** Proses ini akan secara otomatis menambahkan stok ke inventaris master Anda.</li>
                    </ul>
                </div>

                <div>
                    <h4 class="text-xl font-semibold">2. Penambahan Stok Manual</h4>
                    <p class="mt-2">Halaman **Tambah Stok Masuk** ini digunakan untuk penambahan stok manual di luar proses produksi. Ini termasuk: </p>
                    <ul class="list-disc list-inside space-y-1 mt-2">
                        <li>Penyesuaian inventaris karena kesalahan pencatatan.</li>
                        <li>Penambahan stok dari sumber lain yang tidak melalui proses produksi di aplikasi ini.</li>
                    </ul>
                    <p class="mt-4 p-3 bg-red-100 text-red-800 border-l-4 border-red-500">
                        <strong>Perhatian:</strong> Pastikan Anda tidak menggunakan fitur ini untuk mencatat hasil produksi. Penggunaan yang tidak tepat dapat menyebabkan data stok menjadi tidak akurat.
                    </p>
                </div>
            </div>
        </div>

        <div class="flex-shrink-0 flex justify-end gap-3 mt-4 pt-4 border-t">
            <button @click="hideNestedModal" class="bg-slate-200 text-slate-800 font-bold py-2 px-4 rounded-lg hover:bg-slate-300">Tutup</button>
        </div>
    </div>
</div>

<div v-if="uiState.modalType === 'transactionDetail' && transactionDetails" class="bg-white rounded-lg shadow-xl p-6 max-w-5xl w-full h-full md:max-h-[85vh] flex flex-col">
    <div class="flex justify-between items-start pb-4 border-b">
        <div>
            <h3 class="text-2xl font-bold text-slate-800">Detail Transaksi</h3>
            <p class="text-sm text-slate-500 font-mono">{{ transactionDetails.id }}</p>
        </div>
        <div class="text-right">
            <p class="text-sm font-semibold text-slate-700">{{ new Date(transactionDetails.tanggal).toLocaleDateString('id-ID', { weekday: 'long', day: 'numeric', month: 'long', year: 'numeric' }) }}</p>
            <p class="text-base font-bold text-indigo-600">{{ transactionDetails.channel }}</p>
        </div>
    </div>

    <div class="flex-1 overflow-y-auto pt-6 -mx-6 px-6">
        <div class="grid grid-cols-1 lg:grid-cols-2 gap-8 items-start">
            <div class="space-y-4">
                <div class="bg-slate-50 p-4 rounded-xl border">
                    <h4 class="font-semibold text-slate-700 mb-2 flex items-center">
                        <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 mr-2 text-indigo-500" viewBox="0 0 20 20" fill="currentColor"><path d="M4 4a2 2 0 00-2 2v1h16V6a2 2 0 00-2-2H4z" /><path fill-rule="evenodd" d="M18 9H2v5a2 2 0 002 2h12a2 2 0 002-2V9zM4 13h6v2H4v-2z" clip-rule="evenodd" /></svg>
                        Produk Terjual
                    </h4>
                    <ul class="divide-y divide-slate-200">
                        <li v-for="item in transactionDetails.items" :key="item.sku" class="py-3 flex justify-between items-center text-sm">
                            <div class="font-medium text-slate-800">
                                {{ item.qty }}x {{ getProductBySku(item.sku)?.nama || item.sku }}
                            </div>
                            <span class="font-semibold text-right">
                            {{
                                formatCurrency(
                                    transactionDetails.isNewFormat
                                        ? ((Number(item.hpp) || 0) * (Number(item.qty) || 0))
                                        : ((Number(item.hargaJual) || 0) * (Number(item.qty) || 0))
                                )
                            }}
                        </span>
                        </li>
                    </ul>
                </div>
                
                <div v-if="uiState.isProfitLocked" class="p-6 rounded-xl border-2 border-dashed border-slate-400 bg-slate-50 text-center flex flex-col justify-center h-full">
                    <h4 class="font-semibold text-slate-700">Estimasi Laba Bersih Terkunci</h4>
                    <p class="text-sm text-slate-500 mt-1 mb-4">Masukkan PIN untuk melihat profitabilitas transaksi ini.</p>
                    <form @submit.prevent="unlockProfitDetail" class="max-w-xs mx-auto w-full">
                        <input 
                            type="password" 
                            v-model="uiState.profitPinInput" 
                            placeholder="••••" 
                            class="w-full p-2 border rounded-md text-center text-lg mb-2"
                        >
                        <p v-if="uiState.profitPinError" class="text-red-500 text-xs mb-2">{{ uiState.profitPinError }}</p>
                        <button type="submit" class="w-full bg-indigo-600 text-white font-bold py-2 rounded-lg hover:bg-indigo-700">
                            Buka
                        </button>
                    </form>
                </div>
                
                <div class="p-6 rounded-xl border-2 border-indigo-400 bg-indigo-50 text-center shadow-md">
    <p class="text-sm font-medium text-indigo-800">Estimasi Laba Bersih Transaksi Ini:</p>
    <p
        v-if="transactionDetails.labaBersih !== null"
        class="text-3xl font-extrabold text-indigo-700 my-1"
    >
        {{ formatCurrency(transactionDetails.labaBersih) }}
    </p>
    <p v-else class="text-sm text-amber-700 my-2">
        Laba menunggu pencocokan data marketplace.
    </p>
    <p class="text-xs text-indigo-600 font-medium">
        {{
            transactionDetails.isNewFormat
                ? 'Penghasilan Bersih Marketplace - HPP'
                : '(Omset Bersih - HPP Terjual - Total Biaya Marketplace)'
        }}
    </p>
</div>
            </div>

            <div class="space-y-4">
                <div
                    v-if="transactionDetails.isNewFormat"
                    class="bg-slate-50 p-4 rounded-xl border"
                >
                    <h4 class="font-semibold text-slate-700 mb-2">
                        Ringkasan Transaksi Marketplace
                    </h4>
                    <p
                        v-if="!transactionDetails.isMatched"
                        class="rounded-lg bg-amber-50 p-3 text-sm text-amber-800"
                    >
                        Data marketplace belum dicocokkan. Penghasilan dan laba belum tersedia.
                    </p>
                    <ul v-else class="space-y-2 text-sm">
                        <li class="flex justify-between font-semibold">
                            <span>Penghasilan Bersih Marketplace</span>
                            <span>{{ formatCurrency(transactionDetails.totalPenghasilan) }}</span>
                        </li>
                        <li class="flex justify-between">
                            <span class="text-slate-600">HPP Barang</span>
                            <span class="text-red-600">-{{ formatCurrency(transactionDetails.totalHPP) }}</span>
                        </li>
                        <li class="flex justify-between font-bold border-t pt-2">
                            <span>Laba sebelum biaya operasional</span>
                            <span>{{ formatCurrency(transactionDetails.totalPenghasilan - transactionDetails.totalHPP) }}</span>
                        </li>
                    </ul>
                </div>

                <div v-else class="bg-slate-50 p-4 rounded-xl border">
                    <h4 class="font-semibold text-slate-700 mb-2 flex items-center">
                        <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 mr-2 text-green-500" viewBox="0 0 20 20" fill="currentColor"><path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-11a1 1 0 10-2 0v2H7a1 1 0 100 2h2v2a1 1 0 102 0v-2h2a1 1 0 100-2h-2V7z" clip-rule="evenodd" /></svg>
                        Ringkasan Laba Rugi
                    </h4>
                    <ul class="space-y-1 text-sm">
                        <li class="flex justify-between">
                            <span class="text-slate-600">Omset Kotor</span>
                            <span class="font-semibold">{{ formatCurrency(transactionDetails.subtotal) }}</span>
                        </li>
                        <li v-if="transactionDetails.diskon && transactionDetails.diskon.totalDiscount > 0" class="flex justify-between text-green-600">
                            <span class="text-sm">Diskon ({{ transactionDetails.diskon.description || 'N/A' }})</span>
                            <span class="font-semibold">-{{ formatCurrency(transactionDetails.diskon.totalDiscount) }}</span>
                        </li>
                        <li class="flex justify-between font-bold border-t pt-2 mt-2">
                            <span>Omset Bersih</span>
                            <span>{{ formatCurrency(transactionDetails.total) }}</span>
                        </li>
                        <li class="flex justify-between pt-2">
                            <span class="text-slate-600">HPP Terjual</span>
                            <span class="text-red-600 font-semibold">-{{ formatCurrency(transactionDetails.totalHPP) }}</span>
                        </li>
                        <li class="flex justify-between font-bold border-t pt-2 mt-2">
                            <span>Laba Kotor</span>
                            <span>{{ formatCurrency(transactionDetails.total - transactionDetails.totalHPP) }}</span>
                        </li>
                    </ul>
                </div>

                <div class="bg-slate-50 p-4 rounded-xl border">
                    <h4 class="font-semibold text-slate-700 mb-2 flex items-center">
                        <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 mr-2 text-red-500" viewBox="0 0 20 20" fill="currentColor"><path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clip-rule="evenodd" /></svg>
                        Biaya Marketplace
                    </h4>
                    <ul v-if="transactionDetails.biaya && transactionDetails.biaya.rincian" class="space-y-1 text-sm">
                        <li class="flex justify-between font-bold text-red-600">
                            <span>Total Biaya</span>
                            <span>-{{ formatCurrency(transactionDetails.biaya.total) }}</span>
                        </li>
                        <template v-for="(item, index) in transactionDetails.biaya.rincian" :key="index">
                            <li class="flex justify-between text-xs text-slate-600">
                                <span>- {{ item.name }}</span>
                                <span>{{ formatCurrency(item.value) }}</span>
                            </li>
                        </template>
                    </ul>
                    <p v-else class="text-xs text-slate-500 italic text-center py-4">Tidak ada rincian biaya marketplace.</p>
                </div>
            </div>
        </div>
    </div>

    <div class="flex-shrink-0 flex justify-end gap-3 mt-6 pt-4 border-t">
        <button @click="hideModal" class="bg-slate-200 text-slate-800 font-bold py-2 px-4 rounded-lg hover:bg-slate-300">
            Tutup
        </button>
    </div>
</div>
<div v-if="uiState.modalType === 'addKain' || uiState.modalType === 'editKain'" class="bg-white rounded-lg shadow-xl p-6 max-w-5xl w-full h-full md:max-h-[50vh] flex flex-col">
    <h3 class="text-xl font-bold mb-4">{{ uiState.modalType === 'addKain' ? 'Tambah Stok Kain Baru' : 'Edit Data Kain' }}</h3>
    <form @submit.prevent="submitKain(uiState.modalType === 'editKain')" class="space-y-4">
        <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
                <label class="block text-sm font-medium">Tanggal Beli</label>
                <input type="date" v-model="uiState.modalData.tanggalBeli" class="mt-1 w-full p-2 border rounded-md" required>
            </div>
            <div>
                <label class="block text-sm font-medium">Nama Kain</label>
                <input type="text" v-model="uiState.modalData.namaKain" placeholder="Contoh: Cotton Combed 30s" class="mt-1 w-full p-2 border rounded-md" required>
            </div>
        </div>
        <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
                <label class="block text-sm font-medium">Warna Kain</label>
                <input type="text" v-model="uiState.modalData.warna" placeholder="Contoh: Hitam Pekat" class="mt-1 w-full p-2 border rounded-md" required>
            </div>
            <div>
                <label class="block text-sm font-medium">Toko Pembelian</label>
                <input type="text" v-model="uiState.modalData.toko" placeholder="Contoh: Toko Kain Abadi" class="mt-1 w-full p-2 border rounded-md">
            </div>
        </div>
        <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
                <label class="block text-sm font-medium">Jumlah Beli (Yard)</label>
                <input type="number" step="0.1" v-model.number="uiState.modalData.sisaYard" placeholder="Contoh: 150.5" class="mt-1 w-full p-2 border rounded-md" required>
            </div>
            <div>
                <label class="block text-sm font-medium">Harga Beli per Yard (Rp)</label>
                <input type="number" v-model.number="uiState.modalData.hargaBeliPerYard" placeholder="Contoh: 25500" class="mt-1 w-full p-2 border rounded-md" required>
            </div>
        </div>
        <div class="flex justify-end gap-3 pt-14 border-t">
            <button type="button" @click="hideModal" class="bg-slate-200 py-2 px-4 rounded-lg">Batal</button>
            <button type="submit" class="bg-indigo-600 text-white py-2 px-4 rounded-lg">Simpan</button>
        </div>
    </form>
</div>
        <div v-if="uiState.modalType === 'scannerHelp'" class="bg-white rounded-lg shadow-xl p-6 max-w-6xl w-full h-full md:max-h-[90vh] flex flex-col">
    <h3 class="text-2xl font-bold text-slate-800 mb-2">Panduan Alur Kerja Pemindaian Barcode</h3>
    <p class="text-slate-500 mb-6">Optimalkan kecepatan dan akurasi transaksi Anda dengan alur kerja pemindaian barcode yang efisien.</p>

    <div class="space-y-6 text-slate-700 p-2 overflow-y-auto max-h-[70vh]">
        <div class="p-5 bg-slate-50 rounded-lg border border-slate-200">
            <h4 class="font-semibold text-lg text-indigo-700">Metode 1: Pemindai Barcode Fisik (Direkomendasikan)</h4>
            <p class="mt-2 text-sm leading-relaxed">
                Ini adalah standar industri untuk kecepatan dan keandalan. Alur kerjanya dirancang untuk menjadi secepat kilat:
            </p>
            <ol class="list-decimal list-inside mt-3 space-y-2 text-sm">
                <li><strong>Aktivasi Kolom Pencarian:</strong> Cukup klik satu kali pada kolom pencarian utama untuk mengaktifkannya.</li>
                <li><strong>Pindai Barcode Produk:</strong> Arahkan pemindai ke barcode pada label produk.</li>
                <li><strong>Proses Otomatis:</strong> Sistem akan secara instan membaca SKU, menemukan produk yang cocok, dan secara otomatis menambahkannya ke dalam keranjang. Tidak ada pengetikan manual, tidak ada kesalahan.</li>
            </ol>
        </div>

        <div class="p-5 bg-slate-50 rounded-lg border border-slate-200">
            <h4 class="font-semibold text-lg text-indigo-700">Metode 2: Ponsel sebagai Pemindai Nirkabel</h4>
            <p class="mt-2 text-sm leading-relaxed">
                Untuk fleksibilitas atau sebagai solusi cadangan, Anda dapat mengubah ponsel cerdas Anda menjadi pemindai barcode yang terhubung ke komputer.
            </p>
            <ol class="list-decimal list-inside mt-3 space-y-2 text-sm">
                <li><strong>Instalasi Aplikasi:</strong> Unduh aplikasi pihak ketiga yang berfungsi sebagai jembatan, seperti <strong>"Barcode to PC"</strong> atau <strong>"Scanner Keyboard"</strong> di ponsel dan komputer Anda.</li>
                <li><strong>Hubungkan Perangkat:</strong> Pastikan ponsel dan komputer terhubung ke jaringan Wi-Fi yang sama, lalu ikuti instruksi aplikasi untuk menyinkronkannya.</li>
                <li><strong>Pindai dengan Kamera:</strong> Setelah terhubung, buka aplikasi di ponsel Anda dan gunakan kamera untuk memindai barcode. SKU akan dikirim secara nirkabel ke kolom pencarian di aplikasi kasir ini.</li>
            </ol>
        </div>
    </div>

    <div class="flex justify-end mt-6 pt-12 border-t">
        <button type="button" @click="hideModal" class="bg-slate-200 text-slate-800 font-bold py-2 px-4 rounded-lg hover:bg-slate-300">Mengerti</button>
    </div>
</div>

<div v-if="uiState.modalType === 'specialPrice'" class="bg-white rounded-lg shadow-xl p-6 max-w-5xl w-full h-full md:max-h-[60vh] flex flex-col">
    <h3 class="text-2xl font-bold text-slate-800 mb-4">Atur Harga Spesial (Flash Sale)</h3>
    <div class="space-y-4">
        <div>
            <label class="block text-sm font-medium text-slate-700 mb-1">Pilih Channel Penjualan</label>
            <select v-model="uiState.specialPriceChannel" class="w-full p-2 border border-slate-300 rounded-md bg-white shadow-sm">
                <option v-for="channel in state.settings.marketplaces" :key="channel.id" :value="channel.id">
                    {{ channel.name }}
                </option>
            </select>
        </div>
        <div class="relative">
            <label class="block text-sm font-medium text-slate-700 mb-1">Cari Produk (SKU, Nama, Warna, Ukuran)</label>
            <input 
                type="text" 
                v-model="uiState.specialPriceSearch"
                @input="handleSpecialPriceSearch"
                placeholder="Ketik untuk mencari..."
                class="w-full p-2 border border-slate-300 rounded-md"
                autocomplete="off"
            >
            <div v-if="uiState.specialPriceRecommendations.length > 0" class="absolute z-20 w-full mt-1 bg-white border rounded-lg shadow-lg max-h-48 overflow-y-auto">
                <div v-for="p in uiState.specialPriceRecommendations" :key="p.sku" @click="selectProductForSpecialPrice(p)" class="p-3 hover:bg-slate-100 cursor-pointer border-b last:border-b-0">
    <p class="font-semibold text-slate-800">{{ p.nama }}</p>
    <p class="text-xs text-slate-500">{{ p.sku }} - {{ p.warna }} - {{ p.varian }}</p>
</div>
            </div>
        </div>

        <div v-if="uiState.selectedProductForSpecialPrice" class="pt-4 border-t space-y-3">
            <div class="p-3 bg-indigo-50 rounded-lg">
                <p class="text-sm font-medium text-indigo-800">Produk Terpilih:</p>
                <p class="font-bold text-slate-800">{{ uiState.selectedProductForSpecialPrice.nama }} - {{ uiState.selectedProductForSpecialPrice.varian }}</p>
                <p class="text-xs text-slate-500">Harga Jual Normal: {{ formatCurrency(uiState.selectedProductForSpecialPrice.hargaJual[uiState.specialPriceChannel] || 0) }}</p>
            </div>
            <div>
                <label class="block text-sm font-medium text-slate-700 mb-1">Masukkan Harga Spesial (Rp)</label>
                <input 
                    type="number" 
                    v-model.number="uiState.specialPriceInput"
                    placeholder="Contoh: 99000" 
                    class="w-full p-2 border border-indigo-300 rounded-md text-lg font-bold"
                >
            </div>
        </div>
    </div>
    <div class="flex justify-between items-center mt-6 pt-6 border-t">
        <button @click="showModal('manageSpecialPrices')" class="text-sm text-blue-600 hover:underline">Lihat & Hapus Harga Spesial</button>
        <div class="flex gap-3">
            <button @click="hideModal" class="bg-slate-200 text-slate-800 font-bold py-2 px-4 rounded-lg hover:bg-slate-300">Tutup</button>
            <button @click="saveSpecialPrice" :disabled="!uiState.selectedProductForSpecialPrice || !uiState.specialPriceInput" class="bg-amber-500 text-white font-bold py-2 px-4 rounded-lg hover:bg-amber-600 disabled:bg-amber-300 disabled:cursor-not-allowed">Simpan Harga</button>
        </div>
    </div>
</div>

<div v-if="uiState.modalType === 'manageSpecialPrices'" class="bg-white rounded-lg shadow-xl p-6 max-w-7xl w-full h-full md:max-h-[90vh] flex flex-col">
    <h3 class="text-2xl font-bold text-slate-800 mb-4">Kelola Harga Spesial Aktif</h3>
    <p class="mb-4 text-sm text-slate-600">Channel: <span class="font-semibold">{{ state.settings.marketplaces.find(mp => mp.id === uiState.specialPriceChannel)?.name }}</span></p>

    <div class="max-h-[60vh] overflow-y-auto space-y-2 p-2 bg-slate-50 border rounded-md">
        <p v-if="!state.specialPrices[uiState.specialPriceChannel] || Object.keys(state.specialPrices[uiState.specialPriceChannel]).length === 0" class="text-center text-slate-500 p-4">
            Tidak ada harga spesial yang aktif untuk channel ini.
        </p>
        <div v-else v-for="(price, sku) in state.specialPrices[uiState.specialPriceChannel]" :key="sku" class="flex justify-between items-center p-3 bg-white border rounded-md shadow-sm">
    <div>
        <p class="font-semibold text-slate-800">{{ getProductBySku(sku)?.nama }} ({{ sku }})</p>
        <p class="text-sm text-slate-600 mt-1">
            Normal: <span class="line-through">{{ formatCurrency(getProductBySku(sku)?.hargaJual[uiState.specialPriceChannel] || 0) }}</span> -> <span class="font-bold text-green-600">Spesial: {{ formatCurrency(price) }}</span>
        </p>
    </div>
    <button @click="deleteSpecialPrice(uiState.specialPriceChannel, sku)" class="bg-red-100 text-red-700 font-semibold py-1 px-3 rounded-md hover:bg-red-200 text-sm">Hapus</button>
</div>
    </div>

    <div class="flex justify-end mt-6 pt-4 border-t">
        <button @click="showModal('specialPrice')" class="bg-slate-200 text-slate-800 font-bold py-2 px-4 rounded-lg hover:bg-slate-300">Kembali</button>
    </div>
</div>

<div v-if="uiState.modalType === 'produksiDetail'" class="bg-white rounded-lg shadow-xl p-6 max-w-6xl w-full h-full md:max-h-[90vh] flex flex-col">
    <h3 class="text-xl font-bold mb-4">Detail Batch Produksi: {{ uiState.modalData.id }}</h3>
    <div class="space-y-4 text-slate-700 max-h-[70vh] overflow-y-auto p-2 text-sm">
        
        <div class="grid grid-cols-1 md:grid-cols-2 gap-x-6 gap-y-2 p-4 bg-slate-50 rounded-lg">
            <div>
                <p><strong>Tanggal Produksi:</strong> {{ new Date(uiState.modalData.tanggal).toLocaleDateString('id-ID') }}</p>
                <p><strong>{{ uiState.modalData.produksiType === 'penjahit' ? 'Penjahit' : 'Pemaklun' }}:</strong> {{ uiState.modalData.namaStatus }}</p>
                <p><strong>Kuantitas Jadi (Total):</strong> {{ produksiDetailComputed.totalAktualJadi }} pcs</p>
                <p><strong>Kuantitas Perbaikan (Total):</strong> {{ uiState.modalData.kuantitasPerbaikan || 0 }} pcs</p>
            </div>
            <div class="text-left md:text-right">
                <p><strong>Total Harga Jasa {{ uiState.modalData.produksiType === 'penjahit' ? 'Jahit' : 'Maklun' }}:</strong> {{ formatCurrency(uiState.modalData.totalHargaJasaMaklun) }}</p>
                <p><strong>Rata-rata Harga Jasa {{ uiState.modalData?.produksiType === 'penjahit' ? 'Jahit' : 'Maklun' }}/Pcs:</strong> {{ formatCurrency(uiState.modalData?.totalHargaJasaMaklun / (produksiDetailComputed?.totalAktualJadi || 1)) }}</p>
                <p><strong>Total Biaya Material:</strong> {{ formatCurrency(uiState.modalData.totalBiayaMaterial) }}</p>
                <p><strong>Status Proses:</strong> <span class="font-semibold text-green-600">{{ uiState.modalData.statusProses }}</span></p>
                <p><strong>Admin:</strong> {{ uiState.modalData.admin }}</p>
            </div>
        </div>

        <div class="border-t pt-3 mt-3">
            <h4 class="text-lg font-semibold mb-2">Informasi Pembayaran</h4>
            <p><strong>Status Pembayaran:</strong> {{ uiState.modalData.statusPembayaran }}</p>
            <div v-if="uiState.modalData.statusPembayaran === 'Sudah Dibayar'">
                <p><strong>Jumlah Pembayaran:</strong> {{ formatCurrency(uiState.modalData.jumlahPembayaran) }}</p>
                <p><strong>Tanggal Pembayaran:</strong> {{ new Date(uiState.modalData.tanggalPembayaran).toLocaleDateString('id-ID') }}</p>
            </div>
        </div>

        <div class="border-t pt-3 mt-3">
            <h4 class="text-lg font-semibold mb-2">Detail Kain & Bahan</h4>
            <div v-if="!uiState.modalData.kainBahan || uiState.modalData.kainBahan.length === 0" class="text-slate-500">Tidak ada data kain.</div>
            <div v-for="(kb, index) in uiState.modalData.kainBahan" :key="index" class="mb-3 p-4 bg-slate-50 rounded-lg border">
                <p class="font-bold text-base text-slate-800">{{ kb.namaKain }}</p>
                <ul class="list-disc list-inside ml-4 text-slate-600 space-y-1 mt-2">
                    <li><strong>Model Produk:</strong> {{ state.settings.modelProduk.find(m => m.id === kb.modelProdukId)?.namaModel || 'N/A' }}</li>
                    <li><strong>Warna Kain:</strong> {{ kb.warnaKain || '-' }}</li>
                    <li><strong>Ukuran:</strong> {{ kb.ukuran || '-' }}</li>
                    <li><strong>Toko Kain:</strong> {{ kb.tokoKain || '-' }}</li>
                    <li><strong>Total Yard:</strong> {{ kb.totalYard || 0 }} yard @ {{ formatCurrency(kb.hargaKainPerYard || 0) }}/yard</li>
                    <li><strong>Yard/Model:</strong> {{ kb.yardPerModel || 0 }} yard/Model</li>
                    <li><strong>Target Qty:</strong> {{ Math.floor((kb.totalYard || 0) / (kb.yardPerModel || 1)) }} pcs</li>
                    <li class="font-semibold text-slate-800"><strong>Aktual Jadi:</strong> {{ kb.aktualJadi || 0 }} pcs, Harga {{ uiState.modalData.produksiType === 'penjahit' ? 'Jahit' : 'Maklun' }}/Pcs: {{ formatCurrency(uiState.modalData.produksiType === 'penjahit' ? (kb.hargaJahitPerPcs || 0) : (kb.hargaMaklunPerPcs || 0)) }}</li>
                    <li v-if="kb.aktualJadiKombinasi > 0"><strong>Aktual Jadi Kombinasi:</strong> {{ kb.aktualJadiKombinasi }} pcs</li>
                </ul>
            </div>
        </div>
        
        <div class="border-t pt-3 mt-3">
            <h4 class="text-lg font-semibold mb-2">Catatan</h4>
            <p>{{ uiState.modalData.catatan || '-' }}</p>
        </div>
    </div>
    <div class="flex justify-end gap-3 mt-6 border-t pt-4">
      <button @click="printProduksiDetail(uiState.modalData)" class="bg-blue-600 text-white font-bold py-2 px-4 rounded-lg hover:bg-blue-700">Cetak</button>
      <button @click="requestProtectedExport(() => exportProduksiDetailToExcel(uiState.modalData))" class="bg-green-600 text-white font-bold py-2 px-4 rounded-lg hover:bg-green-700">Export laporan</button>
      <button @click="hideModal" class="bg-slate-300 py-2 px-4 rounded-lg hover:bg-slate-400">Tutup</button>
    </div>
</div>

<div v-if="uiState.modalType === 'addBiaya' || uiState.modalType === 'editBiaya'" class="bg-white rounded-lg shadow-xl p-6 max-w-3xl w-full">
    <h3 class="text-xl font-bold mb-4">{{ uiState.modalType === 'addBiaya' ? 'Tambah Pengeluaran Baru' : 'Edit Pengeluaran' }}</h3>
    <form @submit.prevent="submitBiaya" class="space-y-4">
        <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
                <label class="block text-sm font-medium">Tanggal</label>
                <input type="date" v-model="uiState.modalData.tanggal" class="mt-1 w-full p-2 border rounded-md" required>
            </div>
            <div>
                <label class="block text-sm font-medium">Kategori</label>
                <div class="flex items-center gap-2 mt-1">
                    <select v-model="uiState.modalData.kategori" class="w-full p-2 border rounded-md" required>
                        <option value="" disabled>-- Pilih Kategori --</option>
                        <option v-for="cat in state.settings.categories" :key="cat.id" :value="cat.name">
    {{ cat.name }} - {{ (cat.type || 'operasional') === 'produksi' ? 'Produksi' : 'Operasional' }}
</option>
                    </select>
                    <button type="button" @click="showNestedModal('manageCategories')" class="bg-slate-100 p-2 text-slate-600 rounded-md hover:bg-slate-200" title="Kelola Kategori">
                        <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.82 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.82 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.82-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.82-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z"></path>
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"></path>
                        </svg>
                    </button>
                </div>
            </div>
        </div>
        <div>
            <label class="block text-sm font-medium">Jumlah Pokok Pengeluaran (Rp)</label>
            <input type="number" v-model.number="uiState.modalData.jumlah" placeholder="Contoh: 500000" class="mt-1 w-full p-2 border rounded-md" required>
        </div>
        
        <div class="pt-4 border-t space-y-4">
             <div>
                <label class="block text-sm font-medium">Metode Pembayaran</label>
                <select v-model="uiState.modalData.paymentMethod" class="mt-1 w-full p-2 border rounded-md">
                    <option value="transfer">Transfer Bank</option>
                    <option value="cash">Tunai (Cash)</option>
                </select>
            </div>
            <div v-if="uiState.modalData.paymentMethod === 'transfer'" class="grid grid-cols-1 md:grid-cols-2 gap-4 animate-fade-in">
                <div>
                    <label class="block text-sm font-medium">Rekening Tujuan</label>
                    <select v-model="uiState.modalData.selectedBankAccountId" class="mt-1 w-full p-2 border rounded-md" required>
                        <option :value="null" disabled>-- Pilih Rekening --</option>
                        <option v-for="acc in state.bankAccounts" :key="acc.id" :value="acc.id">{{ acc.bankName }} - {{ acc.accountNumber }}</option>
                    </select>
                </div>
                <div>
                    <label class="block text-sm font-medium">Biaya Admin Transfer (jika ada)</label>
                    <input type="number" v-model.number="uiState.modalData.adminFee" class="mt-1 w-full p-2 border rounded-md" placeholder="Contoh: 6500">
                </div>
            </div>
        </div>

        <div>
            <label class="block text-sm font-medium">Catatan (Opsional)</label>
            <textarea v-model="uiState.modalData.catatan" rows="2" class="mt-1 w-full p-2 border rounded-md"></textarea>
        </div>
        
        <div class="p-3 bg-slate-100 rounded-md flex justify-between items-center text-lg font-bold">
            <span>Total Pengeluaran Akan Dicatat:</span>
            <span class="text-indigo-600">{{ formatCurrency((uiState.modalData.jumlah || 0) + (uiState.modalData.paymentMethod === 'transfer' ? (uiState.modalData.adminFee || 0) : 0)) }}</span>
        </div>

        <div class="flex justify-end gap-3 pt-4 border-t">
            <button type="button" @click="hideModal" class="bg-slate-200 py-2 px-4 rounded-lg">Batal</button>
            <button type="submit" class="bg-indigo-600 text-white py-2 px-4 rounded-lg">Simpan</button>
        </div>
    </form>
</div>

<div v-if="uiState.modalType === 'addPemasukan' || uiState.modalType === 'editPemasukan'">
    <div class="fixed inset-0 bg-black bg-opacity-50 z-40 flex items-center justify-center p-4">
        <div class="bg-white rounded-lg shadow-xl p-6 max-w-3xl w-full max-h-[90vh] flex flex-col">
            <h3 class="text-xl font-bold mb-4">{{ uiState.modalType === 'addPemasukan' ? 'Tambah Pemasukan Baru' : 'Edit Pemasukan' }}</h3>
            <form @submit.prevent="submitPemasukan" class="space-y-4">
                <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
                    <div>
                        <label class="block text-sm font-medium">Tanggal</label>
                        <input type="date" v-model="uiState.modalData.tanggal" class="mt-1 w-full p-2 border rounded-md" required>
                    </div>
                    <div>
                        <label class="block text-sm font-medium">Kategori Pemasukan</label>
                        <div class="flex items-center gap-2 mt-1">
                            <select v-model="uiState.modalData.kategori" class="w-full p-2 border rounded-md" required>
                                <option value="" disabled>-- Pilih Kategori --</option>
                                <option v-for="cat in state.settings.inflowCategories" :key="cat.id" :value="cat.name">{{ cat.name }}</option>
                            </select>
                            <button type="button" @click="showNestedModal('manageInflowCategories')" class="bg-slate-100 p-2 text-slate-600 rounded-md hover:bg-slate-200" title="Kelola Kategori">
                                <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.82 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.82 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924-1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.82-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.82-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z"></path>
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"></path>
                                </svg>
                            </button>
                        </div>
                    </div>
                </div>
                <div>
                    <label class="block text-sm font-medium">Jumlah (Rp)</label>
                    <input type="number" v-model.number="uiState.modalData.jumlah" placeholder="Contoh: 10000000" class="mt-1 w-full p-2 border rounded-md" required>
                </div>
                <div>
                    <label class="block text-sm font-medium">Catatan (Opsional)</label>
                    <textarea v-model="uiState.modalData.catatan" rows="3" class="mt-1 w-full p-2 border rounded-md"></textarea>
                </div>
                <div class="flex justify-end gap-3 pt-4 border-t">
                    <button type="button" @click="hideModal" class="bg-slate-200 py-2 px-4 rounded-lg">Batal</button>
                    <button type="submit" class="bg-indigo-600 text-white py-2 px-4 rounded-lg">Simpan</button>
                </div>
            </form>
        </div>
    </div>
</div>

<div v-if="uiState.nestedModalType === 'manageInflowCategories'" class="fixed inset-0 bg-black bg-opacity-50 z-40 flex items-center justify-center p-4">
    <div class="bg-white rounded-lg shadow-xl p-6 max-w-xl w-full max-h-[90vh] flex flex-col">
        <div class="flex justify-between items-center pb-4 border-b">
            <h3 class="text-xl font-bold">Kelola Kategori Pemasukan</h3>
            <button @click="showNestedModal('addInflowCategory', { name: '', description: '' })" class="bg-indigo-600 text-white font-bold py-2 px-4 rounded-lg hover:bg-indigo-700 text-sm">
                + Tambah Kategori
            </button>
        </div>
        <div class="flex-1 overflow-y-auto py-4">
            <table class="w-full text-sm text-left text-slate-500">
                <thead class="text-xs text-slate-700 uppercase bg-slate-50 sticky top-0">
                    <tr>
                        <th class="px-4 py-3">Nama Kategori</th>
                        <th class="px-4 py-3">Deskripsi</th>
                        <th class="px-4 py-3 text-center">Aksi</th>
                    </tr>
                </thead>
                <tbody class="divide-y divide-slate-100">
                    <tr v-if="state.settings.inflowCategories.length === 0">
                        <td colspan="3" class="p-4 text-center text-slate-500">Tidak ada kategori pemasukan.</td>
                    </tr>
                    <tr v-for="cat in state.settings.inflowCategories" :key="cat.id" class="hover:bg-slate-50">
                        <td class="px-4 py-3 font-semibold text-slate-800">{{ cat.name }}</td>
                        <td class="px-4 py-3">{{ cat.description || '-' }}</td>
                        <td class="px-4 py-3 text-center space-x-3">
                            <button @click="showNestedModal('editInflowCategory', JSON.parse(JSON.stringify(cat)))" class="text-xs bg-slate-100 font-bold py-1 px-2 rounded hover:bg-slate-200">Edit</button>
                            <button @click="deleteInflowCategory(cat.id)" class="text-xs text-red-500 hover:underline">Hapus</button>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="flex-shrink-0 flex justify-end gap-3 pt-4 border-t">
            <button @click="hideNestedModal" class="bg-slate-200 text-slate-800 font-bold py-2 px-4 rounded-lg hover:bg-slate-300">Selesai</button>
        </div>
    </div>
</div>

<div v-if="uiState.modalType === 'masterHargaSupplier'" class="bg-white rounded-lg shadow-xl p-6 max-w-4xl w-full h-full md:max-h-[90vh] flex flex-col">
            <div class="flex justify-between items-center mb-6">
                <h3 class="text-xl font-bold text-slate-800">Katalog Harga Beli (Supplier)</h3>
                <button @click="hideModal" class="text-slate-400 hover:text-slate-600">✕</button>
            </div>

            <div class="mb-4">
                <input 
                    v-model="searchCatalogQuery" 
                    type="text" 
                    placeholder="Cari SKU atau Nama..." 
                    class="w-full p-3 border rounded-xl bg-slate-50 outline-none focus:ring-2 focus:ring-indigo-500"
                />
            </div>

            <div class="overflow-y-auto max-h-[400px] border rounded-xl">
                <table class="w-full text-sm text-left">
                    <thead class="bg-slate-100 sticky top-0">
                        <tr>
                            <th class="p-3 font-bold text-slate-600">Produk / SKU</th>
                            <th class="p-3 font-bold text-slate-600 w-40 text-right">Harga Beli</th>
                        </tr>
                    </thead>
                    <tbody class="divide-y divide-slate-100">
                        <tr v-for="p in filteredCatalog" :key="p.id || p.docId" class="hover:bg-slate-50">
                            <td class="p-3 text-slate-700">
                                <p class="font-bold">{{ p.namaModel || 'Tanpa Nama' }}</p>
                                <p class="text-xs font-mono text-slate-400">{{ p.sku }}</p>
                            </td>
                            <td class="p-3">
                                <input 
                                    type="number" 
                                    v-model.number="p.hargaBeli" 
                                    class="w-full p-2 border rounded text-right font-bold text-indigo-600 outline-none focus:bg-indigo-50"
                                    placeholder="0"
                                />
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <div class="mt-6 flex justify-end gap-3 border-t pt-4">
                <button @click="hideModal" class="px-6 py-2 border rounded-lg hover:bg-slate-50">Batal</button>
                <button @click="saveMasterHargaSupplier" :disabled="isSaving" class="px-6 py-2 bg-indigo-600 text-white rounded-lg font-bold hover:bg-indigo-700">
                    {{ isSaving ? 'Menyimpan...' : 'Simpan Semua Harga' }}
                </button>
            </div>
        </div>



<div v-if="uiState.nestedModalType === 'addInflowCategory' || uiState.nestedModalType === 'editInflowCategory'" class="fixed inset-0 bg-black bg-opacity-70 z-50 flex items-center justify-center p-4">
    <div class="bg-white rounded-lg shadow-xl p-6 max-w-md w-full">
        <h3 class="text-xl font-bold mb-4">{{ uiState.nestedModalType === 'addInflowCategory' ? 'Tambah Kategori Baru' : 'Edit Kategori' }}</h3>
        <form @submit.prevent="uiState.nestedModalType === 'addInflowCategory' ? addInflowCategory() : updateInflowCategory()">
            <div class="space-y-4">
                <div>
                    <label class="block text-sm font-medium">Nama Kategori</label>
                    <input type="text" v-model="uiState.nestedModalData.name" class="mt-1 w-full p-2 border rounded-md" required>
                </div>
                <div>
                    <label class="block text-sm font-medium">Deskripsi</label>
                    <textarea v-model="uiState.nestedModalData.description" rows="2" class="mt-1 w-full p-2 border rounded-md"></textarea>
                </div>
            </div>
            <div class="flex justify-end gap-3 mt-6 border-t pt-4">
                <button type="button" @click="hideNestedModal" class="bg-slate-200 py-2 px-4 rounded-lg">Batal</button>
                <button type="submit" class="bg-indigo-600 text-white py-2 px-4 rounded-lg">Simpan</button>
            </div>
        </form>
    </div>
</div>

<div v-if="uiState.isModalVisible && uiState.nestedModalType === 'manageCategories'" class="fixed inset-0 bg-black bg-opacity-50 z-40 flex items-start justify-center p-20">
    <div class="bg-white rounded-lg shadow-xl p-6 max-w-xl w-full h-full md:max-h-[60vh] flex flex-col">
        <div class="flex justify-between items-center pb-4 border-b">
            <h3 class="text-xl font-bold">Kelola Kategori Pengeluaran</h3>
            <button @click="showNestedModal('addCategory', { name: '', description: '', type: 'operasional' })" class="bg-indigo-600 text-white font-bold py-2 px-4 rounded-lg hover:bg-indigo-700 text-sm">
                + Tambah Kategori
            </button>
        </div>
        <div class="flex-1 overflow-y-auto py-4">
            <table class="w-full text-sm text-left text-slate-500">
                <thead class="text-xs text-slate-700 uppercase bg-slate-50 sticky top-0">
                    <tr>
                        <th class="px-4 py-3">Nama Kategori</th>
                        <th class="px-4 py-3">Deskripsi</th>
                        <th class="px-4 py-3 text-center">Aksi</th>
                    </tr>
                </thead>
                <tbody class="divide-y divide-slate-100">
                    <tr v-if="state.settings.categories.length === 0">
                        <td colspan="3" class="p-4 text-center text-slate-500">Tidak ada kategori.</td>
                    </tr>
                    <tr v-for="cat in state.settings.categories" :key="cat.id" class="hover:bg-slate-50">
                        <td class="px-4 py-3 font-semibold text-slate-800">{{ cat.name }}</td>
                        <td class="px-4 py-3">{{ cat.description || '-' }}</td>
                        <td class="px-4 py-3 text-center space-x-3">
                            <button @click="showNestedModal('editCategory', JSON.parse(JSON.stringify(cat)))" class="text-xs bg-slate-100 font-bold py-1 px-2 rounded hover:bg-slate-200">Edit</button>
                            <button @click="deleteCategory(cat.id)" class="text-xs text-red-500 hover:underline">Hapus</button>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="flex-shrink-0 flex justify-end gap-3 pt-4 border-t">
            <button @click="hideNestedModal" class="bg-slate-200 text-slate-800 font-bold py-2 px-4 rounded-lg hover:bg-slate-300">Selesai</button>
        </div>
    </div>
</div>
<div v-if="uiState.isModalVisible && (uiState.nestedModalType === 'addCategory' || uiState.nestedModalType === 'editCategory')" class="fixed inset-0 bg-black bg-opacity-70 z-50 flex items-center justify-center p-4">
    <div class="bg-white rounded-lg shadow-xl p-6 max-w-md w-full">
        <h3 class="text-xl font-bold mb-4">
            {{ uiState.nestedModalType === 'addCategory' ? 'Tambah Kategori Baru' : 'Edit Kategori' }}
        </h3>

        <form @submit.prevent="uiState.nestedModalType === 'addCategory' ? addCategory() : updateCategory()">
            <div class="space-y-4">
                <div>
                    <label class="block text-sm font-medium">Nama Kategori</label>
                    <input
                        type="text"
                        v-model="uiState.nestedModalData.name"
                        class="mt-1 w-full p-2 border rounded-md"
                        required
                    >
                </div>

                <div>
                    <label class="block text-sm font-medium">Tipe Biaya</label>
                    <select
                        v-model="uiState.nestedModalData.type"
                        class="mt-1 w-full p-2 border rounded-md bg-white"
                        required
                    >
                        <option value="operasional">Operasional</option>
                        <option value="produksi">Produksi</option>
                    </select>
                </div>

                <div>
                    <label class="block text-sm font-medium">Deskripsi</label>
                    <textarea
                        v-model="uiState.nestedModalData.description"
                        rows="2"
                        class="mt-1 w-full p-2 border rounded-md"
                        placeholder="Opsional"
                    ></textarea>
                </div>
            </div>

            <div class="flex justify-end gap-3 mt-6 border-t pt-4">
                <button type="button" @click="hideNestedModal" class="bg-slate-200 py-2 px-4 rounded-lg">
                    Batal
                </button>
                <button type="submit" class="bg-indigo-600 text-white py-2 px-4 rounded-lg">
                    Simpan
                </button>
            </div>
        </form>
    </div>
</div>

<div v-if="uiState.modalType === 'viewNote'" class="bg-white rounded-lg shadow-xl p-6 max-w-7xl w-full h-full md:max-h-[30vh] flex flex-col">
    <h3 class="text-xl font-bold mb-4">{{ uiState.modalData.title }}</h3>
    <div class="max-h-[60vh] overflow-y-auto p-4 bg-slate-50 rounded-lg border">
        <p class="text-slate-700 whitespace-pre-wrap">{{ uiState.modalData.content }}</p>
    </div>
    <div class="flex justify-end mt-6 border-t pt-4">
        <button @click="hideModal" class="bg-slate-300 text-slate-800 font-bold py-2 px-4 rounded-lg hover:bg-slate-400">Tutup</button>
    </div>
</div>
<div v-if="uiState.modalType === 'ringkasanJadi'" class="bg-white rounded-lg shadow-xl p-6 max-w-6xl w-full h-full md:max-h-[90vh] flex flex-col">
    <h3 class="text-xl font-bold mb-4">Ringkasan Total Aktual Jadi Kuantitas</h3>
    <div class="mb-4 flex gap-4">
        <div>
            <label for="ringkasan-status-filter" class="block text-sm font-medium text-slate-700 mb-1">Pilih Status Produksi</label>
            <select v-model="uiState.ringkasanStatusSelected" id="ringkasan-status-filter" class="mt-1 block w-full p-2 border border-slate-300 rounded-md shadow-sm">
                <option value="all">Semua Status</option>
                <option value="Selesai">Selesai</option>
                <option value="Dalam Proses">Dalam Proses</option>
                <option value="Revisi">Revisi</option>
                <option value="Ditunda">Ditunda</option>
            </select>
        </div>
        <!-- Filter jenis Status baru -->
        <div>
            <label for="ringkasan-Status-filter" class="block text-sm font-medium text-slate-700 mb-1">Pilih Jenis Status</label>
            <select v-model="uiState.produksiFilterType" id="ringkasan-Status-filter" class="mt-1 block w-full p-2 border rounded-md bg-white shadow-sm">
                <option value="all">Semua Jenis Status</option>
                <option value="pemaklun">Pemaklun</option>
                <option value="penjahit">Penjahit</option>
            </select>
        </div>
    </div>
    <div class="bg-white rounded-xl border border-slate-200 shadow-sm overflow-x-auto max-h-[70vh]">
        <table class="w-full text-sm text-left text-slate-500">
            <thead class="text-xs text-slate-700 uppercase bg-slate-100 sticky top-0">
                <tr>
                    <th class="px-6 py-3">Tanggal</th>
                    <th class="px-6 py-3">Model Produk</th>
                    <th class="px-6 py-3">Nama Kain</th>
                    <th class="px-6 py-3">Warna</th>
                    <th class="px-6 py-3">Ukuran</th>
                    <th class="px-6 py-3 text-right">Total Aktual Jadi</th>
                </tr>
            </thead>
            <tbody class="divide-y divide-slate-100">
                <tr v-if="ringkasanJadiData.length === 0">
                    <td colspan="6" class="px-6 py-10 text-center text-slate-500">Tidak ada data untuk status ini.</td>
                </tr>
                <tr v-for="(item, index) in ringkasanJadiData" :key="index">
                    <td class="px-6 py-4 font-semibold text-slate-800">{{ new Date(item.tanggal).toLocaleDateString('id-ID') }}</td>
                    <td class="px-6 py-4 font-semibold text-slate-800">{{ item.model }}</td>
                    <td class="px-6 py-4 font-semibold text-slate-800">{{ item.kain }}</td>
                    <td class="px-6 py-4 font-semibold text-slate-800">{{ item.warna }}</td>
                    <td class="px-6 py-4 font-semibold text-slate-800">{{ item.ukuran }}</td>
                    <td class="px-6 py-4 text-right font-bold text-indigo-700">{{ item.total }} pcs</td>
                </tr>
            </tbody>
        </table>
    </div>
    <div class="flex justify-end mt-6 pt-4 border-t">
        <button @click="hideModal" class="bg-slate-300 text-slate-800 font-bold py-2 px-4 rounded-lg hover:bg-slate-400">Tutup</button>
    </div>
</div>

<div v-if="uiState.modalType === 'addRetur'" class="bg-white rounded-lg shadow-xl p-6 max-w-4xl w-full h-full md:max-h-[90vh] flex flex-col">
    <h3 class="text-xl font-bold mb-4">Tambah Data Retur dari Transaksi</h3>
    
    <div class="p-4 bg-slate-50 rounded-lg border flex flex-col md:flex-row gap-2 items-start">
        <div class="flex-grow w-full relative">
            <label class="block text-sm font-medium">1. Scan Resi atau Masukkan ID Pesanan Marketplace</label>
            <input 
                type="text" 
                v-model="uiState.modalData.transactionIdSearch" 
                @input="handleReturSearch"
                placeholder="Ketik ID Pesanan Marketplace atau ID internal..." 
                class="mt-1 w-full p-2 border rounded-md"
                autocomplete="off"
            >
            <div v-if="uiState.returSearchRecommendations.length > 0" class="absolute z-10 w-full mt-1 bg-white border border-gray-200 rounded-lg shadow-lg max-h-48 overflow-y-auto">
                <div 
                    v-for="trx in uiState.returSearchRecommendations" 
                    :key="trx.id" 
                    @click="selectReturRecommendation(trx)" 
                    class="p-3 hover:bg-slate-100 cursor-pointer border-b last:border-b-0"
                >
                    <p class="font-semibold text-slate-800">{{ trx.marketplaceOrderId || trx.id }}</p>
                    <p class="text-xs text-slate-500">{{ new Date(trx.tanggal).toLocaleDateString('id-ID') }} - {{ trx.channel }} - {{ formatCurrency(trx.total) }}</p>
                </div>
            </div>
        </div>
        <div class="flex-shrink-0 w-full md:w-auto">
            <label class="block text-sm font-medium opacity-0 hidden md:block">Aksi</label> <button @click="findTransactionForReturn" type="button" class="bg-indigo-600 text-white font-bold py-2 px-4 rounded-lg hover:bg-indigo-700 w-full mt-1">
                Cari Transaksi
            </button>
        </div>
    </div>
    <div v-if="uiState.modalData.foundTransaction" class="flex-1 overflow-y-auto mt-4 pt-4 border-t">
        <div class="mb-4 p-3 bg-green-50 text-green-800 rounded-md border border-green-200">
            <p><strong>Transaksi Ditemukan:</strong> {{ uiState.modalData.foundTransaction.marketplaceOrderId }}</p>
            <p class="text-sm"><strong>Tanggal:</strong> {{ new Date(uiState.modalData.foundTransaction.tanggal).toLocaleDateString('id-ID') }} | <strong>Channel:</strong> {{ uiState.modalData.foundTransaction.channel }}</p>
        </div>

        <h4 class="font-semibold mb-2">2. Pilih Produk yang Diretur:</h4>
        <div class="space-y-3 max-h-[40vh] overflow-y-auto p-2">
            <div v-for="(item, index) in uiState.modalData.items" :key="index" class="p-3 border rounded-lg bg-white shadow-sm">
                <div class="flex items-start gap-4">
                    <input type="checkbox" v-model="item.selected" class="mt-1 h-5 w-5">
                    <div class="flex-grow">
                        <p class="font-semibold">{{ getProductBySku(item.sku)?.nama || item.sku }}</p>
                        <p class="text-xs text-slate-500">SKU: {{ item.sku }} | Harga Jual Asli: {{ formatCurrency(item.hargaJual) }}</p>
                        
                        <div v-if="item.selected" class="mt-3 grid grid-cols-1 md:grid-cols-2 gap-2 animate-fade-in">
    <div>
        <label class="block text-xs font-medium">Qty Retur</label>
        <input type="number" v-model.number="item.returnQty" class="mt-1 w-full p-1.5 text-xs border rounded-md" :max="item.qty" min="1">
    </div>
    <div>
        <label class="block text-xs font-medium">Alasan / Tindak Lanjut</label>
        <input type="text" v-model="item.alasan" placeholder="Contoh: Refund, Ganti Baru, dll." class="mt-1 w-full p-1.5 text-xs border rounded-md">
    </div>
</div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="flex justify-end gap-3 pt-4 border-t mt-auto">
        <button type="button" @click="hideModal" class="bg-slate-200 py-2 px-4 rounded-lg">Batal</button>
        <button type="button" @click="submitReturForm" class="bg-indigo-600 text-white py-2 px-4 rounded-lg" :disabled="!isSubscriptionActive">Simpan Data Retur</button>
    </div>
</div>

<div v-if="uiState.modalType === 'kelolaStok'" class="bg-white rounded-lg shadow-xl p-6 max-w-5xl w-full h-full md:max-h-[60vh] flex flex-col">
    <h3 class="text-xl font-bold text-slate-800 mb-1">Kelola Stok & Alokasi</h3>
    <p class="text-sm text-slate-500 mb-6" v-if="uiState.modalData.original">
        {{ uiState.modalData.original.nama }} ({{ uiState.modalData.original.sku }})
    </p>
    <p v-if="uiState.modalData.stockAllocationWarning" class="mb-4 rounded-lg bg-amber-50 p-3 text-sm text-amber-800">{{ uiState.modalData.stockAllocationWarning }}</p>
    <div class="grid grid-cols-1 md:grid-cols-2 gap-8">
        <div class="space-y-2">
            <h4 class="font-semibold text-slate-700">Stok Master</h4>
            <div>
                <label class="block text-sm font-medium text-slate-600">Total Stok Fisik di Gudang</label>
                <input type="number" v-model.number="uiState.modalData.product.stokFisik" class="mt-1 w-full p-2 border border-slate-300 rounded-md font-bold text-lg">
            </div>
        </div>
        
        <div class="space-y-2">
            <h4 class="font-semibold text-slate-700">Alokasi Stok per Channel</h4>
            
            <div v-if="state.settings.marketplaces.length === 0" class="p-4 bg-yellow-100 text-yellow-800 border border-yellow-300 rounded-md">
                <p class="font-semibold mb-2">Peringatan:</p>
                <p class="text-sm">Anda belum memiliki marketplace untuk mengalokasikan stok. Silakan tambahkan data marketplace di halaman <a href="#" @click.prevent="changePage('pengaturan')" class="underline font-bold">Pengaturan</a> terlebih dahulu.</p>
            </div>

            <div v-else class="space-y-2 max-h-60 overflow-y-auto pr-2">
                <div v-for="mp in state.settings.marketplaces" :key="mp.id" class="flex justify-between items-center">
                    <label class="text-sm text-slate-600">{{ mp.name }}</label>
                    <input type="number" v-model.number="uiState.modalData.product.stokAlokasi[mp.id]" class="w-28 p-1.5 border border-slate-300 rounded-md text-right">
                </div>
            </div>
            <div class="mt-4 pt-4 border-t text-sm space-y-2">
                <div class="flex justify-between items-center">
                    <span class="text-slate-500">Teralokasi:</span>
                    <span class="font-semibold text-slate-800 text-base">{{ modalStockSummary.teralokasi }}</span>
                </div>
                <div class="flex justify-between items-center" :class="modalStockSummary.belumTeralokasi < 0 ? 'text-red-500' : 'text-slate-800'">
                    <span class="text-slate-500">Belum Teralokasi:</span>
                    <span class="font-bold text-base">{{ modalStockSummary.belumTeralokasi }}</span>
                </div>
            </div>
        </div>
    </div>
    <div class="flex justify-end gap-3 mt-8 pt-4 border-t">
        <button type="button" @click="hideModal" class="bg-slate-200 text-slate-800 font-bold py-2 px-4 rounded-lg hover:bg-slate-300">Batal</button>
        <button type="button" @click="saveStockAllocation" :disabled="isSaving" class="bg-indigo-600 text-white font-bold py-2 px-4 rounded-lg hover:bg-indigo-700 disabled:opacity-50">{{ isSaving ? 'Menyimpan…' : 'Simpan Perubahan' }}</button>
    </div>
</div>

<div v-if="uiState.modalType === 'editModelProduk' || uiState.modalType === 'addModelProduk'" class="fixed inset-0 bg-black bg-opacity-50 z-40 flex items-start justify-center p-20">
    <div class="bg-white rounded-lg shadow-xl p-6 max-w-2xl w-full h-full md:max-h-[85vh] flex flex-col">
        <h3 class="text-xl font-bold mb-4">{{ uiState.modalType === 'addModelProduk' ? 'Tambah Model Produk Baru' : 'Edit Model Produk' }}</h3>
        <form @submit.prevent="uiState.modalType === 'addModelProduk' ? addModelProduk() : saveModelProdukEdit()" class="space-y-4 overflow-y-auto pr-2">
            <div>
                <label class="block text-sm font-medium text-slate-700">Nama Model</label>
                <input type="text" v-model="uiState.modalData.namaModel" class="mt-1 w-full p-2 border rounded-md">
            </div>
            <div>
                <label class="block text-sm font-medium text-slate-700">Warna</label>
                <input type="text" v-model="uiState.modalData.warna" class="mt-1 w-full p-2 border rounded-md">
            </div>
            <div>
                <label class="block text-sm font-medium text-slate-700">Ukuran</label>
                <input type="text" v-model="uiState.modalData.ukuran" class="mt-1 w-full p-2 border rounded-md">
            </div>
            <div>
                <label class="block text-sm font-medium text-slate-700">Kebutuhan Kain (Yard/Model)</label>
                <input type="number" step="0.1" v-model.number="uiState.modalData.yardPerModel" class="mt-1 w-full p-2 border rounded-md">
            </div>
            <div>
                <label class="block text-sm font-medium text-slate-700">Harga Jasa Maklun (Rp)</label>
                <input type="number" v-model.number="uiState.modalData.hargaMaklun" class="mt-1 w-full p-2 border rounded-md">
            </div>
            <div>
                <label class="block text-sm font-medium text-slate-700">Harga Jasa Jahit (Rp)</label>
                <input type="number" v-model.number="uiState.modalData.hargaJahit" class="mt-1 w-full p-2 border rounded-md">
            </div>
            <div class="flex justify-end gap-3 pt-6 border-t mt-6">
                <button type="button" @click="hideModal" class="bg-slate-200 py-2 px-4 rounded-lg">Batal</button>
                <button type="submit" class="bg-indigo-600 text-white font-bold py-2 px-4 rounded-lg" :disabled="!isSubscriptionActive">Simpan Perubahan</button>
            </div>
        </form>
    </div>
</div>


<div v-if="uiState.modalType === 'editMarketplace'" class="bg-white rounded-lg shadow-xl p-6 max-w-xl w-full">
    <h3 class="text-xl font-bold text-slate-800">Edit Marketplace</h3>
    <p class="mt-2 text-sm text-slate-500">Masukkan nama channel saja. Potongan dan penghasilan bersih mengikuti data marketplace yang dicocokkan dengan transaksi.</p>
    <form @submit.prevent="saveMarketplaceEdit" class="mt-5 space-y-4">
        <div><label class="block text-sm font-medium text-slate-700">Nama Marketplace</label><input type="text" v-model.trim="uiState.modalData.name" required class="mt-1 w-full rounded-md border p-2"></div>
        <div class="flex justify-end gap-3 border-t pt-4"><button type="button" @click="hideModal" class="rounded-lg bg-slate-200 px-4 py-2">Batal</button><button type="submit" class="rounded-lg bg-indigo-600 px-4 py-2 font-bold text-white" :disabled="!isSubscriptionActive">Simpan</button></div>
    </form>
</div>

<div v-if="uiState.modalType === 'addProduksi'" class="bg-white rounded-lg shadow-xl p-6 max-w-6xl w-full h-full md:max-h-[100vh] flex flex-col">
    <div class="flex items-center gap-4 mb-4">
        <h3 class="text-xl font-bold">Buat Batch Produksi Baru</h3>
        <button @click.stop="showNestedModal('panduanProduksi')" type="button" class="bg-indigo-100 text-indigo-700 font-bold py-2 px-4 rounded-lg hover:bg-indigo-200 text-sm flex items-center gap-2">
            <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor"><path fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clip-rule="evenodd" /></svg>
            Informasi
        </button>
    </div>
    <form @submit.prevent="submitNewProduksiBatch" class="space-y-4 overflow-y-auto max-h-[80vh] p-2">
        <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
                <label class="block text-sm font-medium text-slate-700">Tanggal Produksi</label>
                <input type="date" v-model="uiState.newProduksiBatch.tanggal" class="mt-1 block w-full p-2 border rounded-md" required>
            </div>
            <div>
                <label class="block text-sm font-medium text-slate-700">Jenis Jasa</label>
                <select v-model="uiState.newProduksiBatch.produksiType" class="mt-1 block w-full p-2 border rounded-md" required>
                    <option value="pemaklun">Pemaklun</option>
                    <option value="penjahit">Penjahit</option>
                </select>
            </div>
        </div>
        <div>
            <label class="block text-sm font-medium text-slate-700">{{ uiState.newProduksiBatch.produksiType === 'penjahit' ? 'Nama Penjahit' : 'Nama Pemaklun' }}</label>
            <input type="text" v-model="uiState.newProduksiBatch.namaStatus" class="mt-1 block w-full p-2 border rounded-md" :placeholder="uiState.newProduksiBatch.produksiType === 'penjahit' ? 'Contoh: Ibu Ranti' : 'Contoh: Jahit Cepat Abadi'" required>
        </div>
        
        <div class="border-t pt-4">
            <h4 class="text-lg font-semibold mb-2">Detail Bahan Produksi</h4>
            <div class="space-y-4">
                <div v-for="(item, index) in uiState.newProduksiBatch.kainBahan" :key="index" class="p-4 border rounded-lg bg-slate-50 relative">
                    <div class="grid grid-cols-1 lg:grid-cols-2 gap-x-8">
                        <div class="space-y-3">
                            <div class="grid grid-cols-2 gap-3">
                                <div>
                                    <label class="block text-xs font-medium">Model Produk</label>
                                    <select v-model="item.modelProdukId" @change="handleModelProdukChange(item)" class="mt-1 w-full p-2 text-sm border rounded-md bg-white">
                                        <option value="">Pilih Model</option>
                                        <option v-for="model in state.settings.modelProduk" :key="model.id" :value="model.id">{{ model.namaModel }}</option>
                                    </select>
                                </div>
                                
                                <div v-if="item.modelProdukId">
                                    <label class="block text-xs font-medium">SKU Produk (Untuk Aktual Jadi)</label>
                                    <select v-if="state.produk.filter(p => p.model_id === item.modelProdukId).length > 0" v-model="item.sku" @change="handleProductSkuChange(item)" class="mt-1 w-full p-2 text-sm border rounded-md bg-white">
                                        <option value="">-- Pilih SKU Terdaftar --</option>
                                        <option v-for="product in state.produk.filter(p => p.model_id === item.modelProdukId)" :key="product.sku" :value="product.sku">
                                            {{ product.sku }} - {{ product.varian }}
                                        </option>
                                    </select>
                                     <div v-else class="mt-1 p-2 text-sm text-red-700 bg-red-100 border border-red-300 rounded-md">
                                        <p class="mb-2">Tidak ada produk.</p>
                                        <a href="#" @click.prevent="activePage = 'inventaris'" class="font-semibold underline">Tambah Produk</a>
                                    </div>
                                </div>

                                <div class="col-span-2">
                                    <label class="block text-xs font-medium">SKU Kombinasi (Tulis Manual)</label>
                                    <input type="text" v-model="item.skuKombinasi" placeholder="Misal: Lengan Merah" class="mt-1 w-full p-2 text-sm border rounded-md">
                                </div>

                                <div><label class="block text-xs font-medium">Nama Kain</label><input list="namaKainHistory" v-model="item.namaKain" type="text" class="mt-1 w-full p-2 text-sm border rounded-md"></div>
                                <datalist id="namaKainHistory"><option v-for="name in namaKainHistory" :key="name" :value="name"></option></datalist>
                                <div><label class="block text-xs font-medium">Toko Kain</label><input list="tokoKainHistory" v-model="item.tokoKain" type="text" class="mt-1 w-full p-2 text-sm border rounded-md"></div>
                                <datalist id="tokoKainHistory"><option v-for="toko in tokoKainHistory" :key="toko" :value="toko"></option></datalist>
                                <div><label class="block text-xs font-medium">Warna Kain</label><input v-model="item.warnaKain" type="text" class="mt-1 w-full p-2 text-sm border rounded-md"></div>
                                <div><label class="block text-xs font-medium">Ukuran</label><input v-model="item.ukuran" type="text" class="mt-1 w-full p-2 text-sm border rounded-md"></div>
                                <div><label class="block text-xs font-medium">Total Yard</label><input list="totalYardHistory" v-model.number="item.totalYard" type="number" class="mt-1 w-full p-2 text-sm border rounded-md"></div>
                                <datalist id="totalYardHistory"><option v-for="yard in totalYardHistory" :key="yard" :value="yard"></option></datalist>
                                <div><label class="block text-xs font-medium">Harga/Yard</label><input list="hargaKainPerYardHistory" v-model.number="item.hargaKainPerYard" type="number" class="mt-1 w-full p-2 text-sm border rounded-md"></div>
                                <datalist id="hargaKainPerYardHistory"><option v-for="harga in hargaKainPerYardHistory" :key="harga" :value="harga"></option></datalist>
                                <div v-if="uiState.newProduksiBatch.produksiType === 'penjahit'">
                                    <label class="block text-xs font-medium">Harga Jahit/Pcs</label>
                                    <input v-model.number="item.hargaJahitPerPcs" type="number" class="mt-1 w-full p-2 text-sm border rounded-md">
                                </div>
                                <div v-else>
                                    <label class="block text-xs font-medium">Harga Maklun/Pcs</label>
                                    <input v-model.number="item.hargaMaklunPerPcs" type="number" class="mt-1 w-full p-2 text-sm border rounded-md">
                                </div>
                                <div class="col-span-2"><label class="block text-xs font-medium">Biaya Alat-Alat (Rp)</label><input v-model.number="item.biayaAlat" type="number" placeholder="Plastik, kancing, dll." class="mt-1 w-full p-2 text-sm border rounded-md"></div>
                                <div class="col-span-2 space-y-2">
                                    <div>
                                        <label class="block text-xs font-medium">Aktual Jadi</label>
                                        <div class="flex items-center gap-2">
                                            <span class="bg-indigo-100 text-indigo-800 font-bold px-2 py-1 rounded-md text-xs">{{ item.idUnik }}</span>
                                            <input v-model.number="item.aktualJadi" type="number" class="w-full p-2 text-sm border rounded-md" placeholder="Jumlah jadi utama">
                                        </div>
                                    </div>
                                    <div>
                                        <label class="block text-xs font-medium">Aktual Jadi Kombinasi (pcs)</label>
                                        <div class="flex items-center gap-2">
                                            <span class="bg-purple-100 text-purple-800 font-bold px-2 py-1 rounded-md text-xs">{{ item.idUnik }}</span>
                                            <input v-model.number="item.aktualJadiKombinasi" type="number" class="w-full p-2 text-sm border rounded-md" placeholder="Jumlah komponen pelengkap">
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div>
                            <div class="p-4 bg-white rounded-lg space-y-2 text-sm h-full border sticky top-0">
    <h5 class="font-semibold mb-2 text-center">Ringkasan Biaya Baris Ini</h5>
    <div class="flex justify-between mt-2">
        <span class="text-slate-600">Target Qty:</span>
        <span class="font-medium">{{ calculateRowSummary(item, 'new')?.targetQty || 0 }} pcs</span>
    </div>
    <div class="flex justify-between font-bold" :class="calculateRowSummary(item, 'new')?.selisih < 0 ? 'text-red-500' : 'text-emerald-600'">
        <span>Selisih (Aktual - Target):</span>
        <span>{{ (calculateRowSummary(item, 'new')?.selisih >= 0 ? '+' : '') + (calculateRowSummary(item, 'new')?.selisih || 0) }} pcs</span>
    </div>
    <hr class="my-2">
    <div class="flex justify-between">
        <span class="text-slate-600">Total Biaya Kain:</span>
        <span class="font-medium">{{ formatCurrency(calculateRowSummary(item, 'new')?.totalBiayaKain || 0) }}</span>
    </div>
    <div class="flex justify-between">
        <span class="text-slate-600">Total Biaya {{ uiState.newProduksiBatch.produksiType === 'penjahit' ? 'Jahit' : 'Maklun' }}:</span>
        <span class="font-medium">{{ formatCurrency(calculateRowSummary(item, 'new')?.totalBiayaJasa || 0) }}</span>
    </div>
    <div class="flex justify-between">
        <span class="text-slate-600">Total Biaya Alat:</span>
        <span class="font-medium">{{ formatCurrency(calculateRowSummary(item, 'new')?.totalBiayaAlat || 0) }}</span>
    </div>
    <div class="flex justify-between font-bold text-slate-800 border-t pt-1 mt-1">
        <span>Total Biaya Produksi:</span>
        <span>{{ formatCurrency(calculateRowSummary(item, 'new')?.totalBiayaProduksi || 0) }}</span>
    </div>
    <div class="border-t pt-2 mt-2 space-y-1">
        <div class="flex justify-between text-sm">
            <span class="flex items-center gap-1 text-slate-600">
                HPP Ideal/Pcs
                <button @click.stop="showNestedModal('hppCalculationInfo', { topic: 'ideal' })" type="button" class="help-icon-button-sm">?</button>
            </span>
            <span class="font-medium">{{ formatCurrency(calculateRowSummary(item, 'new')?.hppIdeal || 0) }}</span>
        </div>
        <div class="flex justify-between text-sm" v-if="calculateRowSummary(item, 'new')?.selisih < 0">
            <span class="flex items-center gap-1 text-slate-600">
                Kerugian/Pcs
                <button @click.stop="showNestedModal('hppCalculationInfo', { topic: 'loss' })" type="button" class="help-icon-button-sm">?</button>
            </span>
            <span class="font-medium text-red-500">+ {{ formatCurrency(calculateRowSummary(item, 'new')?.kerugianPerPcs || 0) }}</span>
        </div>
        <div class="flex justify-between font-bold text-base text-red-600 border-t pt-1 mt-1">
            <span class="flex items-center gap-1">
                HPP Final/Pcs
                <button @click.stop="showNestedModal('hppCalculationInfo', { topic: 'final' })" type="button" class="help-icon-button-sm">?</button>
            </span>
            <span>{{ formatCurrency(calculateRowSummary(item, 'new')?.hpp || 0) }}</span>
        </div>
    </div>
</div>
                        </div>
                    </div>
                    <button v-if="uiState.newProduksiBatch.kainBahan && uiState.newProduksiBatch.kainBahan.length > 1" @click="removeKainBahanItem(uiState.newProduksiBatch, index)" type="button" class="absolute top-2 right-2 bg-red-500 text-white rounded-full h-5 w-5 text-xs flex items-center justify-center font-bold">×</button>
                </div>
            </div>
            <button @click="addKainBahanItem(uiState.newProduksiBatch)" type="button" class="mt-3 text-sm text-blue-600 hover:underline">+ Tambah Kain & Bahan Lain</button>
        </div>

        <div class="grid grid-cols-1 md:grid-cols-3 gap-4 border-t pt-4 mt-4">
            <div><label class="block text-sm font-medium text-slate-700">Status Pembayaran</label><select v-model="uiState.newProduksiBatch.statusPembayaran" class="w-full p-2 border rounded-md mt-1"><option>Belum Dibayar</option><option>Sudah Dibayar</option></select></div>
            <div v-if="uiState.newProduksiBatch.statusPembayaran === 'Sudah Dibayar'"><label class="block text-sm font-medium text-slate-700">Jumlah Pembayaran</label><input v-model.number="uiState.newProduksiBatch.jumlahPembayaran" type="number" class="w-full p-2 border rounded-md mt-1"></div>
            <div v-if="uiState.newProduksiBatch.statusPembayaran === 'Sudah Dibayar'"><label class="block text-sm font-medium text-slate-700">Tanggal Pembayaran</label><input v-model="uiState.newProduksiBatch.tanggalPembayaran" type="date" class="w-full p-2 border rounded-md mt-1"></div>
        </div>
        <div><label class="block text-sm font-medium text-slate-700">Catatan</label><textarea v-model="uiState.newProduksiBatch.catatan" rows="2" class="mt-1 block w-full p-2 border rounded-md"></textarea></div>
        <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div><label class="block text-sm font-medium text-slate-700">Status Proses</label><select v-model="uiState.newProduksiBatch.statusProses" class="w-full p-2 border rounded-md mt-1"><option>Dalam Proses</option><option>Selesai</option><option>Revisi</option><option>Ditunda</option></select></div>
            <div><label class="block text-sm font-medium text-slate-700">Admin (Opsional)</label><input v-model="uiState.newProduksiBatch.orangMemproses" type="text" class="mt-1 block w-full p-2 border rounded-md"></div>
        </div>
        <div class="flex justify-end gap-3 mt-6 border-t pt-7">
            <button type="button" @click="hideModal" class="bg-slate-200 py-2 px-4 rounded-lg">Batal</button>
            <button type="submit" class="bg-indigo-600 text-white py-2 px-4 rounded-lg">Simpan Batch Produksi</button>
        </div>
    </form>
</div>

<div v-if="uiState.modalType === 'editProduksi'" class="bg-white rounded-lg shadow-xl p-6 max-w-6xl w-full h-full md:max-h-[90vh] flex flex-col">
    <h3 class="text-xl font-bold mb-4">Edit Batch Produksi: {{ uiState.editProduksiBatch?.id }}</h3>
    <form @submit.prevent="submitEditProduksiBatch" class="space-y-4 overflow-y-auto max-h-[90vh] p-2">
        <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
                <label class="block text-sm font-medium text-slate-700">Tanggal Produksi</label>
                <input type="date" v-model="uiState.editProduksiBatch.tanggal" class="mt-1 block w-full p-2 border rounded-md" required>
            </div>
            <div>
                <label class="block text-sm font-medium text-slate-700">Jenis Jasa</label>
                <select v-model="uiState.editProduksiBatch.produksiType" class="mt-1 block w-full p-2 border rounded-md" required>
                    <option value="pemaklun">Pemaklun</option>
                    <option value="penjahit">Penjahit</option>
                </select>
            </div>
        </div>
        <div>
            <label class="block text-sm font-medium text-slate-700">{{ uiState.editProduksiBatch.produksiType === 'penjahit' ? 'Nama Penjahit' : 'Nama Pemaklun' }}</label>
            <input type="text" v-model="uiState.editProduksiBatch.namaStatus" class="mt-1 block w-full p-2 border rounded-md" required>
        </div>
        
        <div class="border-t pt-4">
            <h4 class="text-lg font-semibold mb-2">Detail Bahan Produksi</h4>
            <div class="space-y-4">
                <div v-for="(item, index) in uiState.editProduksiBatch?.kainBahan" :key="index" class="p-4 border rounded-lg bg-slate-50 relative">
                    <div class="grid grid-cols-1 lg:grid-cols-2 gap-x-8">
                        <div class="space-y-3">
                            <div class="grid grid-cols-2 gap-3">
                                <div>
                                    <label class="block text-xs font-medium">Model Produk</label>
                                    <select v-model="item.modelProdukId" @change="handleModelProdukChange(item)" class="mt-1 w-full p-2 text-sm border rounded-md bg-white">
                                        <option value="">Pilih Model</option>
                                        <option v-for="model in state.settings.modelProduk" :key="model.id" :value="model.id">{{ model.namaModel }}</option>
                                    </select>
                                </div>
                                
                                <div v-if="item.modelProdukId">
                                    <label class="block text-xs font-medium">SKU Produk (Untuk Aktual Jadi)</label>
                                    <select v-model="item.sku" @change="handleProductSkuChange(item)" class="mt-1 w-full p-2 text-sm border rounded-md bg-white">
                                        <option value="">-- Pilih SKU Terdaftar --</option>
                                        <option v-for="product in state.produk.filter(p => p.model_id === item.modelProdukId)" :key="product.sku" :value="product.sku">
                                            {{ product.sku }} - {{ product.varian }}
                                        </option>
                                    </select>
                                </div>
                                <div class="col-span-2">
                                    <label class="block text-xs font-medium">SKU Kombinasi (Tulis Manual)</label>
                                    <input type="text" v-model="item.skuKombinasi" placeholder="Misal: Lengan Merah" class="mt-1 w-full p-2 text-sm border rounded-md">
                                </div>
                                <div><label class="block text-xs font-medium">Nama Kain</label><input list="namaKainHistory" v-model="item.namaKain" type="text" class="mt-1 w-full p-2 text-sm border rounded-md"></div>
                                <datalist id="namaKainHistory"><option v-for="name in namaKainHistory" :key="name" :value="name"></option></datalist>
                                <div><label class="block text-xs font-medium">Toko Kain</label><input list="tokoKainHistory" v-model="item.tokoKain" type="text" class="mt-1 w-full p-2 text-sm border rounded-md"></div>
                                <datalist id="tokoKainHistory"><option v-for="toko in tokoKainHistory" :key="toko" :value="toko"></option></datalist>
                                <div><label class="block text-xs font-medium">Warna Kain</label><input v-model="item.warnaKain" type="text" class="mt-1 w-full p-2 text-sm border rounded-md"></div>
                                <div><label class="block text-xs font-medium">Ukuran</label><input v-model="item.ukuran" type="text" class="mt-1 w-full p-2 text-sm border rounded-md"></div>
                                <div><label class="block text-xs font-medium">Total Yard</label><input list="totalYardHistory" v-model.number="item.totalYard" type="number" class="mt-1 w-full p-2 text-sm border rounded-md"></div>
                                <datalist id="totalYardHistory"><option v-for="yard in totalYardHistory" :key="yard" :value="yard"></option></datalist>
                                <div><label class="block text-xs font-medium">Harga/Yard</label><input list="hargaKainPerYardHistory" v-model.number="item.hargaKainPerYard" type="number" class="mt-1 w-full p-2 text-sm border rounded-md"></div>
                                <datalist id="hargaKainPerYardHistory"><option v-for="harga in hargaKainPerYardHistory" :key="harga" :value="harga"></option></datalist>
                                <div v-if="uiState.editProduksiBatch.produksiType === 'penjahit'">
                                    <label class="block text-xs font-medium">Harga Jahit/Pcs</label>
                                    <input v-model.number="item.hargaJahitPerPcs" type="number" class="mt-1 w-full p-2 text-sm border rounded-md">
                                </div>
                                <div v-else>
                                    <label class="block text-xs font-medium">Harga Maklun/Pcs</label>
                                    <input v-model.number="item.hargaMaklunPerPcs" type="number" class="mt-1 w-full p-2 text-sm border rounded-md">
                                </div>
                                <div class="col-span-2"><label class="block text-xs font-medium">Biaya Alat-Alat (Rp)</label><input v-model.number="item.biayaAlat" type="number" placeholder="Plastik, kancing, dll." class="mt-1 w-full p-2 text-sm border rounded-md"></div>
                                <div class="col-span-2 space-y-2">
                                    <div>
                                        <label class="block text-xs font-medium">Aktual Jadi</label>
                                        <div class="flex items-center gap-2">
                                            <span class="bg-indigo-100 text-indigo-800 font-bold px-2 py-1 rounded-md text-xs">{{ item.idUnik }}</span>
                                            <input v-model.number="item.aktualJadi" type="number" class="w-full p-2 text-sm border rounded-md" placeholder="Jumlah jadi utama">
                                        </div>
                                    </div>
                                    <div>
                                        <label class="block text-xs font-medium">Aktual Jadi Kombinasi (pcs)</label>
                                        <div class="flex items-center gap-2">
                                            <span class="bg-purple-100 text-purple-800 font-bold px-2 py-1 rounded-md text-xs">{{ item.idUnik }}</span>
                                            <input v-model.number="item.aktualJadiKombinasi" type="number" class="w-full p-2 text-sm border rounded-md" placeholder="Jumlah komponen pelengkap">
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div>
                           <div class="p-4 bg-white rounded-lg space-y-2 text-sm h-full border sticky top-0">
    <h5 class="font-semibold mb-2 text-center">Ringkasan Biaya Baris Ini</h5>
    <div class="flex justify-between mt-2">
        <span class="text-slate-600">Target Qty:</span>
        <span class="font-medium">{{ calculateRowSummary(item, 'edit')?.targetQty || 0 }} pcs</span>
    </div>
    <div class="flex justify-between font-bold" :class="calculateRowSummary(item, 'edit')?.selisih < 0 ? 'text-red-500' : 'text-emerald-600'">
        <span>Selisih (Aktual - Target):</span>
        <span>{{ (calculateRowSummary(item, 'edit')?.selisih >= 0 ? '+' : '') + (calculateRowSummary(item, 'edit')?.selisih || 0) }} pcs</span>
    </div>
    <hr class="my-2">
    <div class="flex justify-between">
        <span class="text-slate-600">Total Biaya Kain:</span>
        <span class="font-medium">{{ formatCurrency(calculateRowSummary(item, 'edit')?.totalBiayaKain || 0) }}</span>
    </div>
    <div class="flex justify-between">
        <span class="text-slate-600">Total Biaya {{ uiState.editProduksiBatch.produksiType === 'penjahit' ? 'Jahit' : 'Maklun' }}:</span>
        <span class="font-medium">{{ formatCurrency(calculateRowSummary(item, 'edit')?.totalBiayaJasa || 0) }}</span>
    </div>
    <div class="flex justify-between">
        <span class="text-slate-600">Total Biaya Alat:</span>
        <span class="font-medium">{{ formatCurrency(calculateRowSummary(item, 'edit')?.totalBiayaAlat || 0) }}</span>
    </div>
    <div class="flex justify-between font-bold text-slate-800 border-t pt-1 mt-1">
        <span>Total Biaya Produksi:</span>
        <span>{{ formatCurrency(calculateRowSummary(item, 'edit')?.totalBiayaProduksi || 0) }}</span>
    </div>
    <div class="border-t pt-2 mt-2 space-y-1">
        <div class="flex justify-between text-sm">
            <span class="flex items-center gap-1 text-slate-600">
                HPP Ideal/Pcs
                <button @click.stop="showNestedModal('hppCalculationInfo', { topic: 'ideal' })" type="button" class="help-icon-button-sm">?</button>
            </span>
            <span class="font-medium">{{ formatCurrency(calculateRowSummary(item, 'edit')?.hppIdeal || 0) }}</span>
        </div>
        <div class="flex justify-between text-sm" v-if="calculateRowSummary(item, 'edit')?.selisih < 0">
            <span class="flex items-center gap-1 text-slate-600">
                Kerugian/Pcs
                <button @click.stop="showNestedModal('hppCalculationInfo', { topic: 'loss' })" type="button" class="help-icon-button-sm">?</button>
            </span>
            <span class="font-medium text-red-500">+ {{ formatCurrency(calculateRowSummary(item, 'edit')?.kerugianPerPcs || 0) }}</span>
        </div>
        <div class="flex justify-between font-bold text-base text-red-600 border-t pt-1 mt-1">
            <span class="flex items-center gap-1">
                HPP Final/Pcs
                <button @click.stop="showNestedModal('hppCalculationInfo', { topic: 'final' })" type="button" class="help-icon-button-sm">?</button>
            </span>
            <span>{{ formatCurrency(calculateRowSummary(item, 'edit')?.hpp || 0) }}</span>
        </div>
    </div>
</div>
                        </div>
                    </div>
                    <button v-if="uiState.editProduksiBatch.kainBahan.length > 1" @click="removeKainBahanItem(uiState.editProduksiBatch, index)" type="button" class="absolute top-2 right-2 bg-red-500 text-white rounded-full h-5 w-5 text-xs flex items-center justify-center font-bold">×</button>
                </div>
            </div>
            <button @click="addKainBahanItem(uiState.editProduksiBatch)" type="button" class="mt-3 text-sm text-blue-600 hover:underline">+ Tambah Kain & Bahan Lain</button>
        </div>
        <div class="grid grid-cols-1 md:grid-cols-3 gap-4 border-t pt-4 mt-4">
            <div><label class="block text-sm font-medium text-slate-700">Status Pembayaran</label><select v-model="uiState.editProduksiBatch.statusPembayaran" class="w-full p-2 border rounded-md mt-1"><option>Belum Dibayar</option><option>Sudah Dibayar</option></select></div>
            <div v-if="uiState.editProduksiBatch.statusPembayaran === 'Sudah Dibayar'"><label class="block text-sm font-medium text-slate-700">Jumlah Pembayaran</label><input v-model.number="uiState.editProduksiBatch.jumlahPembayaran" type="number" class="w-full p-2 border rounded-md mt-1"></div>
            <div v-if="uiState.editProduksiBatch.statusPembayaran === 'Sudah Dibayar'"><label class="block text-sm font-medium text-slate-700">Tanggal Pembayaran</label><input v-model="uiState.editProduksiBatch.tanggalPembayaran" type="date" class="w-full p-2 border rounded-md mt-1"></div>
        </div>
        <div><label class="block text-sm font-medium text-slate-700">Catatan</label><textarea v-model="uiState.editProduksiBatch.catatan" rows="2" class="mt-1 block w-full p-2 border rounded-md"></textarea></div>
        <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
             <div><label class="block text-sm font-medium text-slate-700">Status Proses</label><select v-model="uiState.editProduksiBatch.statusProses" class="w-full p-2 border rounded-md mt-1"><option>Dalam Proses</option><option>Selesai</option><option>Revisi</option><option>Ditunda</option></select></div>
             <div><label class="block text-sm font-medium text-slate-700">Admin (Opsional)</label><input v-model="uiState.editProduksiBatch.orangMemproses" type="text" class="mt-1 block w-full p-2 border rounded-md"></div>
        </div>
        <div class="flex justify-end gap-3 mt-6 border-t pt-4">
            <button type="button" @click="hideModal" class="bg-slate-200 py-2 px-4 rounded-lg">Batal</button>
            <button type="submit" class="bg-indigo-600 text-white py-2 px-4 rounded-lg">Simpan Perubahan</button>
        </div>
    </form>
</div>

<div v-if="uiState.nestedModalType === 'panduanProduksi'" class="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4">
    <div class="bg-white rounded-lg shadow-xl p-6 max-w-3xl w-4/5 max-h-[90vh] flex flex-col">
        <div class="flex-shrink-0 pb-4 border-b">
            <h3 class="text-2xl font-bold text-slate-800">Panduan Form Produksi</h3>
            <p class="text-slate-500">Penjelasan fungsional untuk memastikan pencatatan biaya dan kuantitas yang akurat.</p>
        </div>

        <div class="flex-1 overflow-y-auto py-4 pr-2">
            <div class="space-y-6 text-slate-700 leading-relaxed prose max-w-none">
                
                <div>
                    <h4 class="text-xl font-semibold">Memahami Kolom SKU</h4>
                    <p class="mt-2">Form ini memiliki dua jenis kolom SKU untuk menangani produk utama dan produk kombinasi secara terpisah.</p>
                    <ul class="list-disc list-inside space-y-2 mt-2 text-sm">
                        <li>
                            <strong>SKU Produk (Untuk Aktual Jadi):</strong> Gunakan dropdown ini untuk memilih SKU produk akhir yang <strong>sudah terdaftar di Manajemen Inventaris</strong>. Stok dari SKU inilah yang akan bertambah ketika Anda menekan tombol "+ Masukkan ke Inventaris". Wajib diisi untuk bahan utama.
                        </li>
                        <li>
                            <strong>SKU Kombinasi (Tulis Manual):</strong> Gunakan kolom teks ini untuk memberi nama pada bahan komponen atau kombinasi (contoh untuk bagian tangan: nama model bajunya madina lalu warnanya putih lalu SIzenya M / no angka alhasil tulis dikolom SKU Kombinasi (Tulis Manual) tulisnya MDN htm M di singkat agar cepat"). Data ini <strong>tidak terhubung ke inventaris</strong> dan hanya berfungsi untuk pencatatan biaya bahan tambahan pada produk akhir.
                        </li>
                    </ul>
                </div>

                <div>
                    <h4 class="text-xl font-semibold">Aktual Jadi vs. Aktual Jadi Kombinasi</h4>
                    <p class="mt-2">Gunakan kolom <strong>"Aktual Jadi"</strong> ketika satu produk (contoh: 1 ModelProduk) dibuat sepenuhnya dari satu jenis bahan kain utama. Kolom ini berfungsi sebagai sumber data utama untuk perhitungan final. Semua biaya krusial (jasa, alat) dan jumlah total produk jadi akan dihitung berdasarkan input di sini.</p>
                    <ul class="list-disc list-inside mt-2 space-y-1 text-sm">
                        <li><strong>Kapan digunakan:</strong> Produksi standar, seperti kaos yang seluruh bagiannya terbuat dari bahan dan warna yang sama.</li>
                        <li><strong>Peran:</strong> Menentukan jumlah akhir produk jadi dan menjadi dasar kalkulasi semua biaya produksi.</li>
                    </ul>
                    <p class="mt-3">Gunakan kolom <strong>"Aktual Jadi Kombinasi"</strong> untuk mencatat penggunaan bahan kain sekunder atau tambahan dalam pembuatan satu produk yang sama.</p>
                    <ul class="list-disc list-inside mt-2 space-y-1 text-sm">
                        <li><strong>Bahan Utama/Dominan:</strong> Data untuk bahan yang paling banyak digunakan (misalnya, kain untuk bagian badan) harus dimasukkan ke dalam kolom "Aktual Jadi".</li>
                        <li><strong>Bahan Sekunder:</strong> Data untuk bahan campuran (misalnya, kain untuk bagian lengan) dimasukkan ke dalam kolom "Aktual Jadi Kombinasi".</li>
                        <li><strong>Kapan digunakan:</strong> Produksi produk dengan variasi bahan, seperti kemeja dengan badan katun dan lengan rayon.</li>
                        <li><strong>Peran:</strong> Mencatat biaya material tambahan tanpa memengaruhi perhitungan utama untuk biaya jasa dan peralatan.</li>
                    </ul>
                </div>

                <div>
                    <h4 class="text-xl font-semibold">Peringatan Penting</h4>
                    <ul class="list-none space-y-2 mt-2">
                        <li class="p-3 bg-red-100 text-red-800 border-l-4 border-red-500">
                            <strong>❌ Jangan menggunakan kedua kolom ("Aktual Jadi" dan "Aktual Jadi Kombinasi") sekaligus dalam satu baris bahan!</strong><br>
                            Pilih salah satu. Jika Anda butuh mencatat keduanya untuk satu produk, klik "+ Tambah Kain & Bahan Lain" untuk membuat baris baru.
                        </li>
                        <li class="p-3 bg-yellow-100 text-yellow-800 border-l-4 border-yellow-500">
                            <strong>ℹ️ Catatan Penting untuk Sisa Kain:</strong><br>
                            Jika ada sisa kain yang belum terpotong, catat kode unik kain tersebut. Jika nanti sisa kain itu dipotong dan menjadi produk jadi, cari batch produksi ini di halaman utama dan klik "Edit" untuk memperbarui jumlah hasil jadinya. Namun, jika sisa kain diarahkan untuk model lain, jangan jadikan kode uniknya sebagai acuan analisis selisih tertinggi, karena data tersebut tidak relevan untuk analisis batch awal.
                        </li>
                    </ul>
                </div>
            </div>
        </div>

        <div class="flex-shrink-0 flex justify-end gap-3 mt-4 pt-4 border-t">
            <button @click="hideNestedModal" class="bg-slate-200 text-slate-800 font-bold py-2 px-4 rounded-lg hover:bg-slate-300">Tutup</button>
        </div>
    </div>
</div>



<div v-if="uiState.modalType === 'analisisModel'" class="bg-white rounded-lg shadow-xl p-6 max-w-6xl w-full h-full md:max-h-[90vh] flex flex-col">
    <div class="flex-shrink-0 pb-4 border-b">
        <h3 class="text-2xl font-bold text-slate-800">🔍 Analisis Model Produksi</h3>
        <p class="text-slate-500">Analisis efisiensi dan HPP rill untuk setiap hasil produksi.</p>
    </div>

    <div class="flex-1 overflow-y-auto py-4 pr-2">
        <div class="mb-6 p-4 bg-slate-50 rounded-lg border">
            <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 items-end">
                <div>
                    <label class="block text-sm font-medium text-slate-700 mb-1">Opsi Analisis</label>
                    <select v-model="uiState.analisisModelFilter" class="w-full p-2 border rounded-md bg-white shadow-sm">
                        <option value="none" disabled>-- Pilih Opsi Analisis --</option>
                        <option value="all">Tampilkan Semua Data</option>
                        <option value="model">Analisis per Model</option>
                    </select>
                </div>
                <div>
                    <label class="block text-sm font-medium text-slate-700 mb-1">Jenis Status</label>
                    <select v-model="uiState.produksiFilterType" class="w-full p-2 border rounded-md bg-white shadow-sm">
                        <option value="all">Semua Jenis Status</option>
                        <option value="pemaklun">Pemaklun</option>
                        <option value="penjahit">Penjahit</option>
                    </select>
                </div>
                <div v-if="uiState.analisisModelFilter === 'model'">
                    <label class="block text-sm font-medium text-slate-700 mb-1">Pilih Model Produk</label>
                    <select v-model="uiState.analisisModelSelectedModel" class="w-full p-2 border rounded-md bg-white shadow-sm">
    <option value="" disabled>-- Pilih Model Produk --</option>
    <option v-for="model in state.settings.modelProduk" :key="model.id" :value="model.id">{{ model.namaModel }}</option>
</select>
                </div>
                <div v-if="uiState.analisisModelFilter === 'model' && uiState.analisisModelSelectedModel">
                    <label class="block text-sm font-medium text-slate-700 mb-1">Tipe Aktual Jadi</label>
                    <select v-model="uiState.analisisModelSelectedType" class="w-full p-2 border rounded-md bg-white shadow-sm">
                        <option value="aktualJadi">Aktual Jadi</option>
                        <option value="aktualJadiKombinasi">Aktual Jadi Kombinasi</option>
                    </select>
                </div>
                <div>
                    <label class="block text-sm font-medium text-slate-700 mb-1">Tampilkan Top</label>
                    <div class="relative">
                        <input type="number" v-model.number="uiState.analisisModelLimit" placeholder="Jumlah data" class="w-full p-2 border rounded-md bg-white shadow-sm">
                        <span class="absolute top-1/2 right-3 -translate-y-1/2 text-slate-500 text-xs">baris</span>
                    </div>
                </div>
            </div>
        </div>
        
        <div class="bg-white rounded-lg border shadow-sm flex-1 overflow-y-auto">
            <table class="w-full text-sm text-left text-slate-500">
                <thead class="text-xs text-slate-700 uppercase bg-slate-100 sticky top-0">
                    <tr>
                        <th class="px-4 py-3">Info Produksi</th>
                        <th class="px-4 py-3">Toko Kain</th>
                        <th class="px-4 py-3">Nama Kain</th>
                        <th class="px-4 py-3">Warna</th>
                        <th class="px-4 py-3">Ukuran</th>
                        <th class="px-4 py-3 text-center">Target</th>
                        <th class="px-4 py-3 text-center" :class="{ 'text-green-600': uiState.analisisModelSelectedType === 'aktualJadi', 'text-purple-600': uiState.analisisModelSelectedType === 'aktualJadiKombinasi' }">
                            Aktual
                        </th>
                        <th class="px-4 py-3 text-center bg-yellow-100 text-yellow-800">Selisih</th>
                        <th class="px-4 py-3 text-right bg-red-100 text-red-800">HPP/Pcs</th>
                    </tr>
                </thead>
                <tbody class="divide-y divide-slate-100">
                    <tr v-if="analisisModelData.length === 0">
                        <td colspan="9" class="p-10 text-center text-slate-500">Tidak ada data produksi yang cocok.</td>
                    </tr>
                    <tr v-for="(item, index) in analisisModelData" :key="index" class="hover:bg-slate-50">
                        <td class="px-4 py-3">
                            <p class="font-semibold text-slate-800">{{ item.modelNama }}</p>
                            <p class="text-xs">{{ new Date(item.tanggal).toLocaleDateString('id-ID') }}</p>
                            <p class="text-xs text-indigo-600">
                                {{ item.produksiType === 'penjahit' ? 'Penjahit' : 'Pemaklun' }}: {{ item.namaStatus }}
                            </p>
                        </td>
                        <td class="px-4 py-3">{{ item.tokoKain }}</td>
                        <td class="px-4 py-3 font-medium">{{ item.namaKain }}</td>
                        <td class="px-4 py-3">{{ item.warnaKain }}</td>
                        <td class="px-4 py-3">{{ item.ukuran }}</td>
                        <td class="px-4 py-3 text-center font-medium text-slate-700">{{ item.targetQty }} pcs</td>
                        <td class="px-4 py-3 text-center font-semibold" :class="{ 'text-green-700': uiState.analisisModelSelectedType === 'aktualJadi', 'text-purple-700': uiState.analisisModelSelectedType === 'aktualJadiKombinasi' }">
                            {{ item.aktualFinal || 0 }} pcs
                        </td>
                        <td class="px-4 py-3 text-center font-bold text-lg" :class="item.selisih < 0 ? 'text-red-500' : 'text-emerald-600'">
                            {{ item.selisih >= 0 ? '+' : '' }}{{ item.selisih }}
                        </td>
                        <td class="px-4 py-3 text-right font-bold text-red-600">{{ formatCurrency(item.hpp) }}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
    
    <div class="flex-shrink-0 flex justify-end gap-3 mt-6 pt-4 border-t">
        <button @click="hideModal" class="bg-slate-300 text-slate-800 font-bold py-2 px-4 rounded-lg hover:bg-slate-400">Tutup</button>
    </div>
</div>

<div v-if="uiState.modalType === 'laporanStatus'" class="bg-white rounded-lg shadow-xl p-6 max-w-2xl w-full h-full md:max-h-[30vh] flex flex-col">
    <h3 class="text-xl font-bold mb-4">Buat Laporan Detail Berdasarkan Status</h3>
    <div class="space-y-4">
        <div>
            <label for="report-status-select" class="block text-sm font-medium text-slate-700 mb-1">Pilih Status Produksi</label>
            <select v-model="uiState.laporanStatusSelected" id="report-status-select" class="mt-1 block w-full p-3 border border-slate-300 rounded-md shadow-sm">
                <option value="all">Semua Status</option>
                <option value="Dalam Proses">Dalam Proses</option>
                <option value="Selesai">Selesai</option>
                <option value="Revisi">Revisi</option>
                <option value="Ditunda">Ditunda</option>
            </select>
        </div>
    </div>
    <div class="flex justify-end gap-3 mt-12">
        <button type="button" @click="hideModal" class="bg-slate-200 text-slate-800 font-bold py-2 px-4 rounded-lg hover:bg-slate-300">Batal</button>
        <button type="button" @click="generateLaporanByStatus(uiState.laporanStatusSelected)" class="bg-cyan-600 text-white font-bold py-2 px-4 rounded-lg hover:bg-cyan-700">Lihat Laporan</button>
    </div>
</div>

<div v-if="uiState.modalType === 'laporanStatusDetail'" class="bg-white rounded-lg shadow-xl p-6 max-w-6xl w-full h-full md:max-h-[90vh] flex flex-col">
    <div class="flex-shrink-0 pb-4 border-b">
        <h3 class="text-2xl font-bold text-slate-800">Laporan Detail Gabungan - Status: {{ uiState.laporanData.statusTerpilih }}</h3>
    </div>
    
    <div class="flex-1 overflow-y-auto py-4 pr-2">
        <div class="mb-4">
            <label for="laporan-Status-filter" class="block text-sm font-medium text-slate-700 mb-1">Pilih Jenis Jasa</label>
            <select v-model="uiState.produksiFilterType" id="laporan-Status-filter" class="w-full p-2 border rounded-md bg-white shadow-sm">
                <option value="all">Semua Jenis Jasa</option>
                <option value="pemaklun">Pemaklun</option>
                <option value="penjahit">Penjahit</option>
            </select>
        </div>

        <div class="p-4 mb-4 bg-blue-100 border border-blue-300 rounded-lg text-center">
            <p class="text-sm font-medium text-blue-800">Total Keseluruhan Biaya {{ uiState.produksiFilterType === 'all' ? 'Jasa Produksi' : uiState.produksiFilterType === 'penjahit' ? 'Jahit' : 'Maklun' }} (Status: {{ uiState.laporanData.statusTerpilih }})</p>
            <p class="text-3xl font-bold text-blue-900">{{ formatCurrency(laporanTotalBiayaJasa) }}</p>
        </div>

        <div class="space-y-4">
            <p v-if="uiState.laporanData.laporanPerStatus.length === 0" class="text-center py-8 text-slate-500">Tidak ada data untuk status ini.</p>
            
            <div v-for="batch in uiState.laporanData.laporanPerStatus.filter(b => uiState.produksiFilterType === 'all' || b.produksiType === uiState.produksiFilterType)" :key="batch.id" class="p-4 border rounded-lg bg-white shadow-sm">
                <div class="flex justify-between items-start">
                    <div>
                        <p class="font-bold text-indigo-700">ID Batch: {{ batch.id }} ({{ batch.produksiType === 'penjahit' ? 'Penjahit' : 'Pemaklun' }}: {{ batch.namaStatus }})</p>
                        <span class="text-xs font-semibold px-2 py-0.5 rounded-full mt-1 inline-block"
                              :class="{
                                'bg-green-100 text-green-800': batch.statusProses === 'Selesai',
                                'bg-blue-100 text-blue-800': batch.statusProses === 'Dalam Proses',
                                'bg-yellow-100 text-yellow-800': batch.statusProses === 'Revisi',
                                'bg-gray-100 text-gray-800': batch.statusProses === 'Ditunda',
                              }">
                            {{ batch.statusProses }}
                        </span>
                    </div>
                    <div class="text-right">
                        <p class="text-sm text-slate-500">Subtotal Biaya {{ batch.produksiType === 'penjahit' ? 'Jahit' : 'Maklun' }}</p>
                        <p class="font-bold text-lg text-green-600">{{ formatCurrency(
                            (batch.kainBahan || []).reduce((subtotal, item) => subtotal + (item.aktualJadi || 0) * (batch.produksiType === 'penjahit' ? (item.hargaJahitPerPcs || 0) : (item.hargaMaklunPerPcs || 0)), 0)
                        ) }}</p>
                    </div>
                </div>
                
                <div class="border-t mt-3 pt-3">
                    <h5 class="font-semibold text-sm mb-2">Detail Produksi:</h5>
                    <div class="space-y-2">
                        <div v-for="(kb, index) in batch.kainBahan" :key="index" class="text-xs p-3 bg-slate-50 rounded-md border flex items-center justify-between">
                            <div>
                                <p class="font-semibold">{{ kb.namaKain }}</p>
                                <ul class="list-disc list-inside ml-4 text-slate-600 space-y-1 mt-1">
                                    <li>Model Produk: {{ state.settings.modelProduk.find(m => m.id === kb.modelProdukId)?.namaModel || 'N/A' }}</li>
                                    <li>Warna Kain: {{ kb.warnaKain || '-' }}</li>
                                    <li>Ukuran: {{ kb.ukuran || '-' }}</li>
                                    <li>Qty Jadi: {{ kb.aktualJadi || 0 }} pcs</li>
                                </ul>
                            </div>
                            <div class="flex-shrink-0 text-right">
                                <span v-if="kb.isInventoried" class="text-green-600 font-bold flex items-center text-xs">
                                    <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4 mr-1" viewBox="0 0 20 20" fill="currentColor"><path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd" /></svg>
                                    Sudah Masuk Inventaris
                                </span>
                                <button v-if="!kb.isInventoried && kb.aktualJadi > 0" @click="updateProductionInventoryStatus(batch.id, index)" class="bg-indigo-600 text-white font-bold py-1 px-3 rounded-lg hover:bg-indigo-700 text-sm" :disabled="!isSubscriptionActive">
    + Masukkan ke Inventaris
</button>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="border-t mt-3 pt-3">
                    <h5 class="font-semibold text-sm mb-1">Catatan</h5>
                    <p class="text-sm text-slate-600">{{ batch.catatan || '-' }}</p>
                </div>
            </div>
        </div>
    </div>
    
    <div class="flex-shrink-0 flex justify-end gap-3 mt-4 pt-4 border-t">
        <button @click="requestProtectedExport(() => exportGroupedProduksiToExcel())" class="bg-green-600 text-white font-bold py-2 px-4 rounded-lg">Export Laporan</button>
        <button @click="hideModal" class="bg-slate-300 text-slate-800 font-bold py-2 px-4 rounded-lg hover:bg-slate-400">Tutup</button>
    </div>
</div>


<div v-if="uiState.modalType === 'panduanProduksi'" class="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4">
    <div class="bg-white rounded-lg shadow-xl p-6 max-w-3xl w-4/5 max-h-[90vh] flex flex-col">
        <div class="flex-shrink-0 pb-4 border-b">
            <h3 class="text-2xl font-bold text-slate-800">Panduan Penggunaan: Aktual Jadi vs. Aktual Jadi Kombinasi</h3>
            <p class="text-slate-500">Dokumen ini menjelaskan perbedaan fungsional untuk memastikan pencatatan biaya dan kuantitas yang akurat.</p>
        </div>

        <div class="flex-1 overflow-y-auto py-4 pr-2">
            <div class="space-y-6 text-slate-700 leading-relaxed">
                <div>
                    <h4 class="text-xl font-semibold">1. Aktual Jadi</h4>
                    <p class="mt-2">Gunakan kolom <strong>"Aktual Jadi"</strong> ketika satu produk (contoh: 1 ModelProduk) dibuat sepenuhnya dari satu jenis bahan kain utama.</p>
                    <p>Kolom ini berfungsi sebagai sumber data utama untuk perhitungan final. Semua biaya krusial dan jumlah total produk jadi akan dihitung berdasarkan input di sini.</p>
                    <ul class="list-disc list-inside space-y-1 mt-2">
                        <li><strong>Kapan digunakan:</strong> Produksi standar, seperti kaos yang seluruh bagiannya terbuat dari bahan yang sama dan warna yang sama.</li>
                        <li><strong>Peran:</strong> Menentukan jumlah akhir produk jadi dan menjadi dasar kalkulasi semua biaya produksi.</li>
                    </ul>
                </div>

                <div>
                    <h4 class="text-xl font-semibold">2. Aktual Jadi Kombinasi</h4>
                    <p class="mt-2">Gunakan kolom <strong>"Aktual Jadi Kombinasi"</strong> untuk mencatat penggunaan bahan kain sekunder atau tambahan dalam pembuatan satu produk yang sama.</p>
                    <p><strong>Aturan Penggunaan:</strong></p>
                    <ul class="list-disc list-inside space-y-1 mt-2">
                        <li><strong>Bahan Utama/Dominan:</strong> Data untuk bahan yang paling banyak digunakan (misalnya, kain untuk bagian badan Model Produk) harus dimasukkan ke dalam kolom "Aktual Jadi".</li>
                        <li><strong>Bahan Sekunder:</strong> Data untuk bahan campuran / bahan yang sama tapi berbeda warna (misalnya, kain untuk bagian lengan) dimasukkan ke dalam kolom "Aktual Jadi Kombinasi".</li>
                    </ul>
                    <ul class="list-disc list-inside space-y-1 mt-2">
                        <li><strong>Kapan digunakan:</strong> Produksi produk dengan variasi bahan, seperti dikategori fashion dengan badan katun dan lengan rayon / bagian badan bahan katun dan tangan bahan bahan katun tapi warna yang membedakanya.</li>
                        <li><strong>Peran:</strong> Mencatat biaya material tambahan tanpa memengaruhi perhitungan utama untuk biaya jasa dan peralatan.</li>
                    </ul>
                </div>

                <div>
                    <h4 class="text-xl font-semibold">Peringatan Penting</h4>
                    <ul class="list-none space-y-2 mt-2">
                        <li class="p-3 bg-red-100 text-red-800 border-l-4 border-red-500">
                            <strong>❌ Jangan menggunakan kedua kolom sekaligus!</strong><br>
                            Pilih salah satu input ("Aktual Jadi" atau "Aktual Jadi Kombinasi") untuk setiap baris bahan. Jika Anda ingin menambah data retur dengan SKU yang sama, klik <strong>"+ Tambah Kain & Bahan Lain"</strong>.
                        </li>
                        <li class="p-3 bg-yellow-100 text-yellow-800 border-l-4 border-yellow-500">
                            <strong>ℹ️ Catatan Penting untuk Sisa Kain:</strong><br>
                            Jika ada sisa kain yang belum terpotong, catat kode unik kain tersebut. Jika nanti sisa kain itu dipotong dan menjadi produk jadi, cari kode uniknya di halaman <strong>Edit Batch Produksi</strong> untuk menambahkan total hasil jadinya. Namun, jika sisa kain diarahkan untuk model lain, jangan jadikan kode uniknya sebagai acuan analisis selisih tertinggi, karena data tersebut tidak relevan untuk analisis batch awal.
                        </li>
                    </ul>
                </div>
            </div>
        </div>

        <div class="flex-shrink-0 flex justify-end gap-3 mt-4 pt-4 border-t">
            <button @click="hideNestedModal" class="bg-slate-200 text-slate-800 font-bold py-2 px-4 rounded-lg hover:bg-slate-300">Tutup</button>
        </div>
    </div>
</div>
<div v-if="uiState.modalType === 'panduanPOS'" class="bg-white rounded-lg shadow-xl p-6 max-w-4xl w-full h-full md:max-h-[90vh] flex flex-col">
    <div class="flex-shrink-0 pb-4 border-b">
        <h3 class="text-2xl font-bold text-slate-800">Panduan Fitur Kasir (Point of Sale)</h3>
        <p class="text-slate-500">Alur Kerja untuk Transaksi Tunggal yang Akurat dan Fleksibel.</p>
    </div>
    
    <div class="flex-1 overflow-y-auto py-4 pr-2">
        <div class="space-y-6 text-slate-700 leading-relaxed prose">
            <p>Halaman Kasir dirancang untuk memproses <strong>satu pesanan per satu waktu</strong> dengan tingkat akurasi dan kontrol tertinggi. Alur ini ideal untuk memverifikasi setiap detail pesanan sebelum finalisasi.</p>
            
            <h4 class="text-lg font-semibold mt-4 mb-2">Alur Kerja Hybrid (Manual & Scanner)</h4>
            <p>Sistem input tunggal kami dirancang untuk melayani semua jenis pengguna secara efisien:</p>
            <ol class="list-decimal list-inside space-y-2 mt-2">
                <li><strong>Mulai Scan/Ketik Produk:</strong> Produk yang di-scan atau dipilih dari rekomendasi akan langsung masuk ke keranjang.</li>
                <li><strong>Scan/Ketik ID Pesanan:</strong> Setelah semua produk masuk keranjang, scan resi atau ketik ID Pesanan lalu tekan <strong>Enter</strong> atau klik tombol <strong>"Jadikan ID Pesanan"</strong>. ID akan tercatat dan keranjang akan terkunci.</li>
                <li><strong>Verifikasi Akhir:</strong> Periksa kembali isi keranjang, total harga, dan ID Pesanan yang sudah tercatat.</li>
                <li><strong>Selesaikan Transaksi:</strong> Klik tombol finalisasi untuk menyimpan transaksi. Setelah berhasil, halaman akan siap untuk pesanan berikutnya.</li>
            </ol>

            <div class="mt-4 p-3 bg-indigo-50 text-indigo-800 border-l-4 border-indigo-500 text-sm">
                <p class="font-bold">Prinsip Utama Halaman Ini</p>
                <p class="mt-2">Halaman ini memegang teguh prinsip <strong>"Satu Resi = Satu Keranjang"</strong>. Mengunci keranjang setelah ID Pesanan dimasukkan adalah fitur keamanan untuk memastikan tidak ada produk yang salah masuk ke pesanan yang salah.</p>
            </div>
        </div>
    </div>

    <div class="flex-shrink-0 flex justify-end gap-3 mt-4 pt-4 border-t">
        <button @click="hideModal" class="bg-slate-200 text-slate-800 font-bold py-2 px-4 rounded-lg hover:bg-slate-300">Tutup</button>
    </div>
</div>

<div v-if="uiState.modalType === 'panduanRetur'" class="bg-white rounded-xl shadow-xl p-6 max-w-4xl w-full h-full md:max-h-[70vh] flex flex-col">
    <div class="flex-shrink-0 pb-4 mb-4 border-b">
        <h3 class="text-2xl font-bold text-slate-800">Panduan Manajemen Retur</h3>
        <p class="text-slate-500 mt-1">Pahami alur kerja dan logika stok untuk proses retur yang akurat.</p>
    </div>
    
    <div class="flex-1 overflow-y-auto pr-2 text-slate-700">
        <p class="mb-4">Modul ini dirancang untuk membantu Anda mencatat pengembalian produk dari pelanggan dan secara otomatis menyesuaikan stok di inventaris Anda.</p>
        
        <div class="mt-2 p-4 bg-indigo-50 rounded-lg">
            <h4 class="font-bold text-lg text-indigo-700 flex items-center">
                <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 mr-2 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2"><path stroke-linecap="round" stroke-linejoin="round" d="M16 15v-1a4 4 0 00-4-4H8m0 0l-3 3m3-3l3 3m0 0v-2a4 4 0 014-4h2" /></svg>
                Alur Kerja Otomatis
            </h4>
            <ul class="list-disc list-inside ml-4 mt-2 space-y-1 text-sm">
                <li>Ketika Anda mencatat retur, sistem akan mengembalikan stok ke **Inventaris Fisik Global** dan **alokasi stok di toko asalnya**.</li>
                <li>Ini memastikan produk yang dikembalikan siap dijual kembali di platform yang sama.</li>
            </ul>
        </div>
        
        <div class="mt-4 p-4 bg-yellow-50 rounded-lg">
            <h4 class="font-bold text-lg text-yellow-800 flex items-center">
                <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 mr-2 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2"><path stroke-linecap="round" stroke-linejoin="round" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" /></svg>
                Peringatan Penting
            </h4>
            <ul class="list-disc list-inside ml-4 mt-2 space-y-1 text-sm">
                <li>**Pembatalan Data:** Data retur yang sudah disimpan tidak dapat diubah (diedit). Hapus data yang salah dan catat ulang jika diperlukan.</li>
                <li>**Penghapusan & Dampak Stok:** Menghapus data retur akan secara otomatis **mengurangi stok fisik dan alokasi stok** yang sebelumnya ditambahkan.</li>
            </ul>
        </div>
    </div>
    
    <div class="flex-shrink-0 flex justify-end gap-3 mt-4 pt-4 border-t">
        <button @click="hideModal" class="bg-slate-200 text-slate-800 font-bold py-2 px-4 rounded-lg hover:bg-slate-300">Tutup</button>
    </div>
</div>

<div v-if="uiState.modalType === 'priceCalculator'" class="bg-white rounded-lg shadow-xl p-6 max-w-4xl w-full h-full md:max-h-[85vh] flex flex-col">
    <h3 class="text-2xl font-bold text-slate-800 mb-4 border-b pb-4">Kalkulator Harga Jual</h3>
    
    <div class="grid grid-cols-1 md:grid-cols-2 gap-8 flex-1 overflow-hidden">
        
        <div class="flex flex-col space-y-4">
            <h4 class="text-lg font-semibold text-slate-700">1. Masukkan Data</h4>
            <form @submit.prevent="calculateSellingPrice" class="space-y-4">
                <div>
                    <label class="block text-sm font-medium">Harga Pokok Penjualan (HPP)</label>
                    <input type="number" v-model.number="uiState.priceCalculator.hpp" class="mt-1 w-full p-2 border rounded-md" required placeholder="Contoh: 50000">
                </div>
                <div>
                    <label class="block text-sm font-medium">Pilih Marketplace</label>
                    <select v-model="uiState.priceCalculator.selectedMarketplace" class="w-full p-2 border rounded-md" required>
                        <option value="" disabled>-- Pilih Marketplace --</option>
                        <option v-for="mp in state.settings.marketplaces" :key="mp.id" :value="mp.id">{{ mp.name }}</option>
                    </select>
                </div>
                <div>
                    <label class="block text-sm font-medium">Pilih Model Produk (untuk diskon)</label>
                    <select v-model="uiState.priceCalculator.selectedModelName" class="w-full p-2 border rounded-md" required>
                        <option value="" disabled>-- Pilih Model --</option>
                        <option v-for="modelName in promosiProductModels" :key="modelName" :value="modelName">{{ modelName }}</option>
                    </select>
                </div>
                <div>
                    <label class="block text-sm font-medium">Target Keuntungan (%)</label>
                    <input type="text" v-model="targetMarginComputed" class="mt-1 w-full p-2 border rounded-md" placeholder="Contoh: 30%">
                </div>
                
                <div class="pt-4">
                    <button type="submit" class="w-full bg-indigo-600 text-white font-bold py-3 px-4 rounded-lg hover:bg-indigo-700 transition-colors shadow-md">
                        Hitung Harga
                    </button>
                </div>
            </form>
        </div>

        <div class="flex flex-col overflow-y-auto pr-2">
            <h4 class="text-lg font-semibold text-slate-700">2. Hasil Perhitungan</h4>
            <div v-if="!uiState.priceCalculator.result" class="flex-1 flex items-center justify-center bg-slate-50 rounded-lg mt-4">
                <p class="text-slate-500">Hasil akan muncul di sini...</p>
            </div>
            <div v-else class="mt-4 space-y-6">
                <div class="grid grid-cols-2 gap-4 text-sm">
                    <div class="p-4 bg-green-50 rounded-lg border border-green-200">
                        <p class="text-slate-600">Harga Jual Ideal</p>
                        <p class="text-2xl font-bold text-green-700">{{ formatCurrency(uiState.priceCalculator.result.calculatedPrice) }}</p>
                    </div>
                    <div class="p-4 bg-blue-50 rounded-lg border border-blue-200">
                        <p class="text-slate-600">Estimasi Laba Bersih</p>
                        <p class="text-2xl font-bold text-blue-700">{{ formatCurrency(uiState.priceCalculator.result.netProfit) }}</p>
                    </div>
                </div>

                <div class="space-y-4">
                    <div class="p-4 bg-slate-50 rounded-lg">
                        <p class="font-semibold text-slate-700">Pendapatan & Modal</p>
                        <ul class="mt-2 text-sm text-slate-600 space-y-1">
                            <li class="flex justify-between"><span>Harga Jual</span><span class="font-medium text-green-600">{{ formatCurrency(uiState.priceCalculator.result.calculatedPrice) }}</span></li>
                             <li class="flex justify-between">
                                <span>Diskon Otomatis ({{ uiState.priceCalculator.result.bestDiscountRatePercentage }}%)</span>
                                <span class="text-red-600">-{{ formatCurrency(uiState.priceCalculator.result.bestDiscount) }}</span>
                            </li>
                            <li class="flex justify-between"><span>HPP (Modal)</span><span class="text-red-600">-{{ formatCurrency(uiState.priceCalculator.result.breakdown.hpp) }}</span></li>
                            <li class="flex justify-between font-bold border-t pt-1 mt-1"><span>Laba Kotor</span><span>{{ formatCurrency(uiState.priceCalculator.result.labaKotor) }}</span></li>
                        </ul>
                    </div>

                    <div class="p-4 bg-slate-50 rounded-lg">
                        <p class="font-semibold text-slate-700">Rincian Biaya Marketplace</p>
                        <ul class="mt-2 text-sm text-slate-600 space-y-1">
                            <li class="flex justify-between"><span>Biaya Admin ({{ uiState.priceCalculator.result.breakdown.admRate }}%)</span><span>-{{ formatCurrency(uiState.priceCalculator.result.breakdown.adminFee) }}</span></li>
                            <li class="flex justify-between"><span>Biaya Komisi ({{ uiState.priceCalculator.result.breakdown.komisiRate }}%)</span><span>-{{ formatCurrency(uiState.priceCalculator.result.breakdown.commission) }}</span></li>
                            <li class="flex justify-between"><span>Biaya Layanan G XTRA ({{ uiState.priceCalculator.result.breakdown.layananRate }}%)</span><span>-{{ formatCurrency(uiState.priceCalculator.result.breakdown.serviceFee) }}</span></li>
                             <li v-for="program in uiState.priceCalculator.result.breakdown.programFee" :key="program.name" class="flex justify-between">
                                <span>- {{ program.name }} ({{ program.rate }}%)</span>
                                <span>-{{ formatCurrency(program.fee) }}</span>
                            </li>
                            <li class="flex justify-between"><span>Biaya Per Pesanan</span><span>-{{ formatCurrency(uiState.priceCalculator.result.breakdown.perOrderFee) }}</span></li>
                            <li class="flex justify-between font-bold text-red-600 border-t pt-1 mt-1">
                                <span>Total Biaya Marketplace</span>
                                <span>-{{ formatCurrency(uiState.priceCalculator.result.totalFees) }}</span>
                            </li>
                        </ul>
                    </div>
                     <div class="p-3 bg-blue-100 rounded-lg text-center">
                         <p class="text-xs text-blue-700">Estimasi Laba Bersih = Laba Kotor - Total Biaya Marketplace</p>
                         <p class="text-lg font-bold text-blue-800">{{formatCurrency(uiState.priceCalculator.result.labaKotor)}} - {{formatCurrency(uiState.priceCalculator.result.totalFees)}} = {{formatCurrency(uiState.priceCalculator.result.netProfit)}}</p>
                     </div>
                </div>
            </div>
        </div>
    </div>
     <div class="flex-shrink-0 flex justify-end gap-3 mt-4 pt-4 border-t">
        <button @click="hideModal" class="bg-slate-200 text-slate-800 font-bold py-2 px-4 rounded-lg hover:bg-slate-300">Tutup</button>
    </div>
</div>

<div v-if="uiState.modalType === 'laporanSemuanya'" class="bg-white rounded-lg shadow-xl p-6 max-w-7xl w-full h-full md:max-h-[90vh] flex flex-col">
    <div class="flex-shrink-0 pb-4 border-b">
        <h3 class="text-2xl font-bold text-slate-800">Laporan Produksi Menyeluruh</h3>
        <p class="text-slate-500">Analisis semua data produksi dengan filter tanggal.</p>

        <div class="mb-4 p-4 bg-slate-50 rounded-lg border mt-4">
            <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 items-end">
                <div class="lg:col-span-2">
                    <label class="block text-sm font-medium text-slate-700 mb-1">Filter Waktu</label>
                    <select v-model="uiState.laporanSemuaFilter" class="w-full p-2 border rounded-md capitalize bg-white shadow-sm">
                        <option value="today">Hari Ini</option>
                        <option value="last_7_days">1 Minggu Terakhir</option>
                        <option value="last_30_days">1 Bulan Terakhir</option>
                        <option value="this_year">1 Tahun Terakhir</option>
                        <option value="by_date_range">Rentang Tanggal</option>
                        <option value="by_month_range">Rentang Bulan</option>
                        <option value="by_year_range">Rentang Tahun</option>
                        <option value="all_time">Semua</option>
                    </select>
                </div>
                <div v-if="uiState.laporanSemuaFilter === 'by_date_range'" class="lg:col-span-2 grid grid-cols-2 gap-2">
                    <div><label class="block text-sm font-medium mb-1">Dari Tanggal</label><input type="date" v-model="uiState.laporanSemuaStartDate" class="w-full p-2 border rounded-md bg-white shadow-sm"></div>
                    <div><label class="block text-sm font-medium mb-1">Sampai Tanggal</label><input type="date" v-model="uiState.laporanSemuaEndDate" class="w-full p-2 border rounded-md bg-white shadow-sm"></div>
                </div>
                <div v-if="uiState.laporanSemuaFilter === 'by_month_range'" class="lg:col-span-4 grid grid-cols-1 sm:grid-cols-4 gap-2 items-end">
                        <div>
                            <label class="block text-xs font-medium">Dari Bulan</label>
                            <select v-model.number="uiState.laporanSemuaStartMonth" class="w-full p-2 border rounded-md bg-white shadow-sm"><option v-for="m in 12" :key="m" :value="m">{{ new Date(0, m - 1).toLocaleString('id-ID', { month: 'long' }) }}</option></select>
                        </div>
                        <div>
                            <label class="block text-xs font-medium">Tahun</label>
                            <input type="number" v-model.number="uiState.laporanSemuaStartYear" class="w-full p-2 border rounded-md bg-white shadow-sm">
                        </div>
                        <div>
                            <label class="block text-xs font-medium">Sampai Bulan</label>
                            <select v-model.number="uiState.laporanSemuaEndMonth" class="w-full p-2 border rounded-md bg-white shadow-sm"><option v-for="m in 12" :key="m" :value="m">{{ new Date(0, m - 1).toLocaleString('id-ID', { month: 'long' }) }}</option></select>
                        </div>
                        <div>
                            <label class="block text-xs font-medium">Tahun</label>
                            <input type="number" v-model.number="uiState.laporanSemuaEndYear" class="w-full p-2 border rounded-md bg-white shadow-sm">
                        </div>
                    </div>
                <div v-if="uiState.laporanSemuaFilter === 'by_year_range'" class="lg:col-span-2 grid grid-cols-2 gap-2">
                    <div>
                        <label class="block text-sm font-medium mb-1">Dari Tahun</label>
                        <input type="number" v-model.number="uiState.laporanSemuaStartYear" placeholder="Tahun" class="w-full p-2 border rounded-md bg-white shadow-sm">
                    </div>
                    <div>
                        <label class="block text-sm font-medium mb-1">Sampai Tahun</label>
                        <input type="number" v-model.number="uiState.laporanSemuaEndYear" placeholder="Tahun" class="w-full p-2 border rounded-md bg-white shadow-sm">
                    </div>
                </div>
                
                <div class="lg:col-span-2">
                    <label class="block text-sm font-medium text-slate-700 mb-1">Pilih Jenis Status</label>
                    <select v-model="uiState.produksiFilterType" class="w-full p-2 border rounded-md bg-white shadow-sm">
                        <option value="all">Semua Jenis Status</option>
                        <option value="pemaklun">Pemaklun</option>
                        <option value="penjahit">Penjahit</option>
                    </select>
                </div>
            </div>
        </div>
        
        <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 mb-4">
            <div class="p-4 bg-white rounded-lg border"><h4 class="text-sm font-medium text-slate-500">Total Produk Selesai</h4><p class="text-2xl font-bold mt-1 text-indigo-600">{{ formatNumber(laporanSemuaKpis.totalModelSelesai) }} pcs</p></div>
            <div class="p-4 bg-white rounded-lg border"><h4 class="text-sm font-medium text-slate-500">Total Biaya Produksi</h4><p class="text-2xl font-bold mt-1 text-red-600">{{ formatCurrency(laporanSemuaKpis.totalBiaya) }}</p></div>
            <div class="p-4 bg-white rounded-lg border"><h4 class="text-sm font-medium text-slate-500">Rata-rata HPP/Pcs</h4><p class="text-2xl font-bold mt-1 text-emerald-600">{{ formatCurrency(laporanSemuaKpis.avgHpp) }}</p></div>
            <div class="p-4 bg-white rounded-lg border"><h4 class="text-sm font-medium text-slate-500">Total Batch Produksi</h4><p class="text-2xl font-bold mt-1 text-sky-600">{{ formatNumber(laporanSemuaKpis.totalBatch) }}</p></div>
        </div>
    </div>

    <div class="bg-white rounded-lg border shadow-sm flex-1 overflow-y-auto">
        <table class="w-full text-sm text-left text-slate-500">
            <thead class="text-xs text-slate-700 uppercase bg-slate-100 sticky top-0">
                <tr>
                    <th class="px-6 py-3">Tanggal</th>
                    <th class="px-6 py-3">Batch ID</th>
                    <th class="px-6 py-3">Jenis Status (Nama)</th>
                    <th class="px-6 py-3">Status</th>
                    <th class="px-6 py-3">Kain</th>
                    <th class="px-6 py-3 text-right">Qty Jadi</th>
                    <th class="px-6 py-3 text-right">Biaya Total</th>
                </tr>
            </thead>
            <tbody class="divide-y divide-slate-100">
                <tr v-if="laporanSemuanyaData.tableData.length === 0">
                    <td colspan="7" class="p-10 text-center text-slate-500">Tidak ada data produksi yang cocok dengan filter Anda.</td>
                </tr>
                <tr v-for="(item, index) in laporanSemuanyaData.tableData" :key="index" class="hover:bg-slate-50">
                    <td class="px-6 py-4 whitespace-nowrap">{{ new Date(item.tanggal).toLocaleDateString('id-ID') }}</td>
                    <td class="px-6 py-4 font-mono text-xs">{{ item.batchId }}</td>
                    <td class="px-6 py-4 font-medium capitalize">{{ item.produksiType }} ({{ item.namaStatus }})</td>
                    <td class="px-6 py-4">
                        <span class="text-xs font-semibold px-2 py-0.5 rounded-full"
                                :class="{
                                    'bg-green-100 text-green-800': item.statusProses === 'Selesai',
                                    'bg-blue-100 text-blue-800': item.statusProses === 'Dalam Proses',
                                    'bg-yellow-100 text-yellow-800': item.statusProses === 'Revisi',
                                    'bg-gray-100 text-gray-800': item.statusProses === 'Ditunda',
                                }">
                            {{ item.statusProses }}
                        </span>
                    </td>
                    <td class="px-6 py-4">
                        <p class="font-semibold text-slate-800">{{ item.namaKain }}</p>
                        <p class="text-xs text-slate-500">{{ item.warnaKain || '-' }} ({{ item.ukuran || '-' }})</p>
                    </td>
                    <td class="px-6 py-4 text-right font-medium">{{ item.aktualJadi || 0 }} pcs</td>
                    <td class="px-6 py-4 text-right font-bold">{{ formatCurrency(item.totalBiayaProduksi) }}</td>
                </tr>
            </tbody>
        </table>
    </div>

    <div class="flex-shrink-0 flex justify-end gap-3 mt-4 pt-4 border-t">
        <button @click="requestProtectedExport(() => exportLaporanSemuaToExcel())" class="bg-green-600 text-white font-bold py-2 px-4 rounded-lg hover:bg-green-700">
            📄 Export ke Excel
        </button>
        <button @click="hideModal" class="bg-slate-200 text-slate-800 font-bold py-2 px-4 rounded-lg hover:bg-slate-300">
            Tutup
        </button>
    </div>
</div>


      </div>
    
      
  
    <div v-if="uiState.nestedModalType === 'manageInflowCategories'" class="fixed inset-0 bg-black bg-opacity-50 z-40 flex items-center justify-center p-4">
    <div class="bg-white rounded-lg shadow-xl p-6 max-w-xl w-full max-h-[90vh] flex flex-col">
        <div class="flex justify-between items-center pb-4 border-b">
            <h3 class="text-xl font-bold">Kelola Kategori Pemasukan</h3>
            <button @click="showNestedModal('addInflowCategory', { name: '', description: '' })" class="bg-indigo-600 text-white font-bold py-2 px-4 rounded-lg hover:bg-indigo-700 text-sm">
                + Tambah Kategori
            </button>
        </div>
        <div class="flex-1 overflow-y-auto py-4">
            <table class="w-full text-sm text-left text-slate-500">
                <thead class="text-xs text-slate-700 uppercase bg-slate-50 sticky top-0">
                    <tr>
                        <th class="px-4 py-3">Nama Kategori</th>
                        <th class="px-4 py-3">Deskripsi</th>
                        <th class="px-4 py-3 text-center">Aksi</th>
                    </tr>
                </thead>
                <tbody class="divide-y divide-slate-100">
                    <tr v-if="state.settings.inflowCategories.length === 0">
                        <td colspan="3" class="p-4 text-center text-slate-500">Tidak ada kategori pemasukan.</td>
                    </tr>
                    <tr v-for="cat in state.settings.inflowCategories" :key="cat.id" class="hover:bg-slate-50">
                        <td class="px-4 py-3 font-semibold text-slate-800">{{ cat.name }}</td>
                        <td class="px-4 py-3">{{ cat.description || '-' }}</td>
                        <td class="px-4 py-3 text-center space-x-3">
                            <button @click="showNestedModal('editInflowCategory', JSON.parse(JSON.stringify(cat)))" class="text-xs bg-slate-100 font-bold py-1 px-2 rounded hover:bg-slate-200">Edit</button>
                            <button @click="deleteInflowCategory(cat.id)" class="text-xs text-red-500 hover:underline">Hapus</button>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="flex-shrink-0 flex justify-end gap-3 pt-4 border-t">
            <button @click="hideNestedModal" class="bg-slate-200 text-slate-800 font-bold py-2 px-4 rounded-lg hover:bg-slate-300">Selesai</button>
        </div>
    </div>
</div>

<div v-if="uiState.nestedModalType === 'addInflowCategory' || uiState.nestedModalType === 'editInflowCategory'" class="fixed inset-0 bg-black bg-opacity-70 z-50 flex items-center justify-center p-4">
    <div class="bg-white rounded-lg shadow-xl p-6 max-w-md w-full">
        <h3 class="text-xl font-bold mb-4">{{ uiState.nestedModalType === 'addInflowCategory' ? 'Tambah Kategori Baru' : 'Edit Kategori' }}</h3>
        <form @submit.prevent="uiState.nestedModalType === 'addInflowCategory' ? addInflowCategory() : updateInflowCategory()">
            <div class="space-y-4">
                <div>
                    <label class="block text-sm font-medium">Nama Kategori</label>
                    <input type="text" v-model="uiState.nestedModalData.name" class="mt-1 w-full p-2 border rounded-md" required>
                </div>
                <div>
                    <label class="block text-sm font-medium">Deskripsi</label>
                    <textarea v-model="uiState.nestedModalData.description" rows="2" class="mt-1 w-full p-2 border rounded-md"></textarea>
                </div>
            </div>
            <div class="flex justify-end gap-3 mt-6 border-t pt-4">
                <button type="button" @click="hideNestedModal" class="bg-slate-200 py-2 px-4 rounded-lg">Batal</button>
                <button type="submit" class="bg-indigo-600 text-white py-2 px-4 rounded-lg">Simpan</button>
            </div>
        </form>
    </div>
</div>
  
<div v-if="uiState.modalType === 'rekonsiliasiInfo'" class="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4 animate-fade-in">
        <div class="bg-white rounded-2xl shadow-xl p-6 max-w-2xl w-full max-h-[90vh] flex flex-col animate-fade-in-up">
            <div class="flex-shrink-0 pb-4 border-b flex justify-between items-center">
                <h3 class="text-2xl font-bold text-slate-800">Logika Pencairan & Dashboard</h3>
                <button @click="hideModal" class="text-slate-400 hover:text-slate-600 text-2xl">×</button>
            </div>
            
            <div class="flex-1 overflow-y-auto py-6 space-y-6">
                <div class="p-4 bg-blue-50 rounded-xl border border-blue-200">
                    <h4 class="font-bold text-blue-800 mb-2">1. Apa Fungsi Halaman Ini?</h4>
                    <p class="text-sm text-slate-600 leading-relaxed">
                        Halaman ini digunakan untuk <strong>Audit Massal</strong>. Marketplace biasanya mencairkan dana beberapa hari setelah pesanan selesai. Anda cukup tempel ID Pesanan dari Excel pencairan marketplace ke sini untuk menandai uang sudah masuk ke rekening.
                    </p>
                </div>

                <div class="p-4 bg-indigo-50 rounded-xl border border-indigo-200">
                    <h4 class="font-bold text-indigo-800 mb-2">2. Hubungan dengan Dashboard (PENTING)</h4>
                    <p class="text-sm text-slate-600 leading-relaxed">
                        Agar laporan keuangan Anda akurat, sistem memisahkan dua status:
                    </p>
                    <ul class="list-disc list-inside mt-3 space-y-2 text-sm text-slate-700">
                        <li><strong>Belum Cair:</strong> Masuk ke kolom <strong>"Dana Gantung"</strong> di Dashboard (Belum dianggap laba karena uang belum Anda pegang).</li>
                        <li><strong>Sudah Cair:</strong> Setelah Anda proses di halaman ini, transaksi tersebut baru akan dihitung sebagai <strong>Omset Bersih & Laba Bersih</strong> di Dashboard.</li>
                    </ul>
                </div>

                <div class="p-4 bg-amber-50 rounded-xl border border-amber-200 text-sm text-amber-800 italic">
                    "Gunakan fitur ini setiap kali Anda menerima email/laporan pencairan dana dari marketplace agar angka Laba di Dashboard Anda selalu nyata."
                </div>
            </div>

            <div class="flex-shrink-0 flex justify-end pt-4 border-t">
                <button @click="hideModal" class="w-full bg-slate-900 text-white font-bold py-3 rounded-xl hover:bg-slate-800 transition-all active:scale-95">Saya Mengerti</button>
            </div>
        </div>
    </div>
    
<div v-if="uiState.isPinConfirmModalVisible" class="fixed inset-0 bg-black bg-opacity-60 z-50 flex items-center justify-center p-4">
    <div class="bg-white rounded-xl shadow-xl p-6 max-w-sm w-full">
        <h3 class="text-lg font-bold text-slate-800 mb-2">
            {{ uiState.pinConfirmationMode === 'action' ? 'Konfirmasi PIN' : 'Konfirmasi Perubahan Kunci' }}
        </h3>
        <p class="text-sm text-slate-600 mb-4">
            <span v-if="uiState.pinConfirmationMode === 'action'">Masukkan PIN keamanan untuk {{ uiState.pinActionLabel }}.</span>
            <span v-else>Masukkan PIN keamanan untuk mengubah pengaturan kunci.</span>
        </p>
        <form @submit.prevent="confirmPinAndToggle">
            <input 
                type="password" 
                v-model="uiState.pinConfirmInput"
                data-pin-confirm-input="true"
                placeholder="Masukkan PIN"
                autocomplete="current-password"
                class="w-full p-2 border rounded-md text-center text-lg mb-2"
            >
            <p v-if="uiState.pinConfirmError" class="text-red-500 text-xs mb-2">{{ uiState.pinConfirmError }}</p>
            <div class="flex justify-end gap-3 mt-6 pt-4 border-t">
                <button type="button" @click="cancelPinConfirmation" class="bg-slate-200 py-2 px-4 rounded-lg">Batal</button>
                <button type="submit" class="bg-indigo-600 text-white font-bold py-2 px-4 rounded-lg">Konfirmasi</button>
            </div>
        </form>
    </div>
</div>




</div>
</template>

<style scoped>
.help-icon-button {
    position: absolute;
    top: 0.5rem;
    right: 0.5rem;
    width: 1.25rem;
    height: 1.25rem;
    border-radius: 9999px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #f1f5f9;
    color: #64748b;
    font-weight: bold;
    font-size: 0.875rem;
    cursor: pointer;
    transition: all 0.2s ease-in-out;
}
.help-icon-button:hover {
    background-color: #6366f1;
    color: white;
    transform: scale(1.1);
}
.sidebar-link {
    display: flex;
    align-items: center;
    padding: 0.75rem 1rem;
    border-radius: 0.5rem;
    font-weight: 500;
    color: #9ca3af;
    transition: background-color 0.2s ease-in-out, color 0.2s ease-in-out;
}
.sidebar-link:hover {
    background-color: #374151;
    color: #ffffff;
}
.sidebar-link-active {
    background-image: linear-gradient(to right, #4f46e5, #6d28d9);
    color: #ffffff;
    font-weight: 600;
    box-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
}
.chart-container {
    position: relative;
    width: 100%;
    height: 320px;
}
.kpi-card {
    transition: transform 0.2s, box-shadow 0.2s;
    border-color: #e2e8f0;
}
.kpi-card:hover {
    transform: translateY(-4px);
    box-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
}
.stock-badge {
    display: inline-block;
    padding: 0.2rem 0.6rem;
    border-radius: 9999px;
    font-weight: 600;
    font-size: 0.8rem;
    line-height: 1;
}
.stock-safe {
    background-color: #dcfce7;
    color: #166534;
}
.stock-low {
    background-color: #fef3c7;
    color: #92400e;
}
.stock-empty {
    background-color: #fee2e2;
    color: #991b1b;
}
.accordion-content {
    max-height: 0;
    overflow: hidden;
    transition: max-height 0.5s ease-in-out;
}
.accordion-content.open {
    max-height: 1000px;
}
.panduan-content ul {
    list-style-position: outside;
    padding-left: 1.5rem;
}
.panduan-content li {
    margin-bottom: 0.5rem;
}
.barcode-page-grid {
    display: grid;
    grid-template-columns: 400px 1fr;
    gap: 2rem;
    height: calc(100vh - 120px);
}
.barcode-settings-panel {
    background: #f8fafc;
    padding: 1.5rem;
    border-radius: 0.75rem;
    border: 1px solid #e2e8f0;
    overflow-y: auto;
    height: 100%;
}
.barcode-preview-area {
    background: #f1f5f9;
    padding: 1.5rem;
    border-radius: 0.75rem;
    overflow: auto;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: flex-start;
}
.preview-sheet {
    background: white;
    display: grid;
    padding: 1mm;
    box-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
    justify-content: center;
}
.label-box {
    background: white;
    padding: 1.5mm;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: stretch;
    overflow: hidden;
    border: 1px dashed #e2e8f0;
}
.label-box p {
    margin: 0;
    line-height: 1.2;
    flex-shrink: 0;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
.label-box .barcode-svg {
    flex-grow: 1;
    width: 100%;
    min-height: 10px;
}
@keyframes fade-in-up {
    from {
        opacity: 0;
        transform: translateY(20px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
}
.animate-fade-in-up {
    animation: fade-in-up 0.6s ease-out forwards;
    opacity: 0;
}
@keyframes fade-in {
    from { opacity: 0; }
    to { opacity: 1; }
}
.animate-fade-in {
    animation: fade-in 0.5s ease-in-out;
}
@keyframes fade-in-scale {
    from {
        opacity: 0;
        transform: scale(0.9);
    }
    to {
        opacity: 1;
        transform: scale(1);
    }
}
.animate-fade-in-scale {
    animation: fade-in-scale 0.7s ease-out forwards;
    opacity: 0;
}

/* --- Kode Cetak yang Diperbaiki --- */
.help-icon-button-sm {
    width: 1rem;
    height: 1rem;
    border-radius: 9999px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #e2e8f0;
    color: #475569;
    font-weight: bold;
    font-size: 0.65rem;
    line-height: 1;
    cursor: pointer;
    transition: all 0.2s ease-in-out;
    flex-shrink: 0;
}
.help-icon-button-sm:hover {
    background-color: #4f46e5;
    color: white;
}

/* FASHION_OS_DARK_MODE_V1 */

/* ============================================================
   MODE GELAP FASHION OS
   ============================================================ */
:global(html.fashion-os-dark-page),
:global(html.fashion-os-dark-page body) {
    background-color: #0b1120;
    color-scheme: dark;
}

.fashion-app-shell {
    transition:
        background-color 0.2s ease,
        color 0.2s ease;
}

.fashion-dark {
    background-color: #0b1120 !important;
    color: #e2e8f0;
    color-scheme: dark;
}

.fashion-dark > main {
    background-color: #0b1120;
}

.fashion-dark :deep(.min-h-screen[class*="bg-gradient-to-br"]) {
    background-image:
        linear-gradient(
            135deg,
            #0f172a 0%,
            #111827 55%,
            #172033 100%
        ) !important;
}

.fashion-dark :deep(.bg-white),
.fashion-dark :deep([class~="bg-white/70"]),
.fashion-dark :deep([class~="bg-white/80"]),
.fashion-dark :deep([class~="bg-white/90"]),
.fashion-dark :deep([class~="bg-white/95"]) {
    background-color:
        rgba(30, 41, 59, 0.96) !important;
}

.fashion-dark :deep(.bg-slate-50),
.fashion-dark :deep(.bg-gray-50) {
    background-color: #0f172a !important;
}

.fashion-dark :deep(.bg-slate-100),
.fashion-dark :deep(.bg-gray-100) {
    background-color: #111827 !important;
}

.fashion-dark :deep(.bg-slate-200),
.fashion-dark :deep(.bg-gray-200) {
    background-color: #273449 !important;
}

.fashion-dark :deep(.bg-slate-300),
.fashion-dark :deep(.bg-gray-300) {
    background-color: #3b4a61 !important;
}

.fashion-dark :deep(.bg-indigo-50),
.fashion-dark :deep(.bg-indigo-100) {
    background-color:
        rgba(49, 46, 129, 0.34) !important;
}

.fashion-dark :deep(.bg-blue-50),
.fashion-dark :deep(.bg-blue-100) {
    background-color:
        rgba(30, 64, 175, 0.28) !important;
}

.fashion-dark :deep(.bg-cyan-50),
.fashion-dark :deep(.bg-cyan-100) {
    background-color:
        rgba(14, 116, 144, 0.26) !important;
}

.fashion-dark :deep(.bg-purple-50),
.fashion-dark :deep(.bg-purple-100) {
    background-color:
        rgba(107, 33, 168, 0.28) !important;
}

.fashion-dark :deep(.bg-green-50),
.fashion-dark :deep(.bg-green-100),
.fashion-dark :deep(.bg-emerald-50),
.fashion-dark :deep(.bg-emerald-100) {
    background-color:
        rgba(6, 95, 70, 0.30) !important;
}

.fashion-dark :deep(.bg-yellow-50),
.fashion-dark :deep(.bg-yellow-100),
.fashion-dark :deep(.bg-amber-50),
.fashion-dark :deep(.bg-amber-100),
.fashion-dark :deep(.bg-orange-50),
.fashion-dark :deep(.bg-orange-100) {
    background-color:
        rgba(146, 64, 14, 0.28) !important;
}

.fashion-dark :deep(.bg-red-50),
.fashion-dark :deep(.bg-red-100) {
    background-color:
        rgba(153, 27, 27, 0.28) !important;
}

.fashion-dark :deep(.text-black),
.fashion-dark :deep(.text-slate-950),
.fashion-dark :deep(.text-slate-900),
.fashion-dark :deep(.text-slate-800),
.fashion-dark :deep(.text-slate-700),
.fashion-dark :deep(.text-gray-900),
.fashion-dark :deep(.text-gray-800),
.fashion-dark :deep(.text-gray-700) {
    color: #f1f5f9 !important;
}

.fashion-dark :deep(.text-slate-600),
.fashion-dark :deep(.text-gray-600) {
    color: #cbd5e1 !important;
}

.fashion-dark :deep(.text-slate-500),
.fashion-dark :deep(.text-gray-500) {
    color: #94a3b8 !important;
}

.fashion-dark :deep(.text-indigo-900),
.fashion-dark :deep(.text-indigo-800),
.fashion-dark :deep(.text-indigo-700),
.fashion-dark :deep(.text-indigo-600) {
    color: #a5b4fc !important;
}

.fashion-dark :deep(.text-blue-900),
.fashion-dark :deep(.text-blue-800),
.fashion-dark :deep(.text-blue-700),
.fashion-dark :deep(.text-blue-600) {
    color: #93c5fd !important;
}

.fashion-dark :deep(.text-cyan-900),
.fashion-dark :deep(.text-cyan-800),
.fashion-dark :deep(.text-cyan-700),
.fashion-dark :deep(.text-cyan-600) {
    color: #67e8f9 !important;
}

.fashion-dark :deep(.text-purple-900),
.fashion-dark :deep(.text-purple-800),
.fashion-dark :deep(.text-purple-700),
.fashion-dark :deep(.text-purple-600) {
    color: #d8b4fe !important;
}

.fashion-dark :deep(.text-green-900),
.fashion-dark :deep(.text-green-800),
.fashion-dark :deep(.text-green-700),
.fashion-dark :deep(.text-green-600),
.fashion-dark :deep(.text-emerald-900),
.fashion-dark :deep(.text-emerald-800),
.fashion-dark :deep(.text-emerald-700),
.fashion-dark :deep(.text-emerald-600) {
    color: #6ee7b7 !important;
}

.fashion-dark :deep(.text-yellow-900),
.fashion-dark :deep(.text-yellow-800),
.fashion-dark :deep(.text-yellow-700),
.fashion-dark :deep(.text-amber-900),
.fashion-dark :deep(.text-amber-800),
.fashion-dark :deep(.text-amber-700),
.fashion-dark :deep(.text-orange-900),
.fashion-dark :deep(.text-orange-800),
.fashion-dark :deep(.text-orange-700) {
    color: #fcd34d !important;
}

.fashion-dark :deep(.text-red-900),
.fashion-dark :deep(.text-red-800),
.fashion-dark :deep(.text-red-700),
.fashion-dark :deep(.text-red-600) {
    color: #fca5a5 !important;
}

.fashion-dark :deep(.border-slate-100),
.fashion-dark :deep(.border-slate-200),
.fashion-dark :deep(.border-slate-300),
.fashion-dark :deep(.border-gray-100),
.fashion-dark :deep(.border-gray-200),
.fashion-dark :deep(.border-gray-300) {
    border-color: #334155 !important;
}

.fashion-dark :deep([class*="divide-slate"]) > :not([hidden]) ~ :not([hidden]),
.fashion-dark :deep([class*="divide-gray"]) > :not([hidden]) ~ :not([hidden]) {
    border-color: #334155 !important;
}

.fashion-dark :deep(hr) {
    border-color: #334155 !important;
}

.fashion-dark :deep(input:not([type="checkbox"]):not([type="radio"])),
.fashion-dark :deep(select),
.fashion-dark :deep(textarea) {
    background-color: #0f172a !important;
    border-color: #475569 !important;
    color: #f8fafc !important;
    box-shadow: none;
}

.fashion-dark :deep(input::placeholder),
.fashion-dark :deep(textarea::placeholder) {
    color: #64748b !important;
    opacity: 1;
}

.fashion-dark :deep(input:disabled),
.fashion-dark :deep(select:disabled),
.fashion-dark :deep(textarea:disabled) {
    background-color: #1e293b !important;
    color: #94a3b8 !important;
}

.fashion-dark :deep(select option) {
    background-color: #0f172a;
    color: #f8fafc;
}

.fashion-dark :deep(input[type="date"]),
.fashion-dark :deep(input[type="datetime-local"]),
.fashion-dark :deep(input[type="month"]) {
    color-scheme: dark;
}

.fashion-dark :deep(table) {
    color: #e2e8f0;
}

.fashion-dark :deep(thead) {
    background-color: #1e293b !important;
    color: #f8fafc;
}

.fashion-dark :deep(tbody tr) {
    border-color: #334155;
}

.fashion-dark :deep(tbody tr:hover) {
    background-color:
        rgba(51, 65, 85, 0.72) !important;
}

.fashion-dark :deep(.prose) {
    color: #cbd5e1;
}

.fashion-dark :deep(.prose strong),
.fashion-dark :deep(.prose h1),
.fashion-dark :deep(.prose h2),
.fashion-dark :deep(.prose h3),
.fashion-dark :deep(.prose h4) {
    color: #f8fafc;
}

.fashion-dark :deep(.help-icon-button),
.fashion-dark :deep(.help-icon-button-sm) {
    background-color: #334155;
    color: #cbd5e1;
}

.fashion-dark :deep(.barcode-settings-panel) {
    background-color: #1e293b;
    border-color: #334155;
}

.fashion-dark :deep(.barcode-preview-area) {
    background-color: #0f172a;
}

.fashion-dark :deep(.preview-sheet),
.fashion-dark :deep(.label-box) {
    background-color: #ffffff !important;
    color: #111827 !important;
}

.fashion-dark :deep(.preview-sheet *),
.fashion-dark :deep(.label-box *) {
    color: #111827 !important;
}

.fashion-dark :deep(*) {
    scrollbar-color: #475569 #0f172a;
}

.fashion-dark :deep(*::-webkit-scrollbar) {
    width: 10px;
    height: 10px;
}

.fashion-dark :deep(*::-webkit-scrollbar-track) {
    background: #0f172a;
}

.fashion-dark :deep(*::-webkit-scrollbar-thumb) {
    background: #475569;
    border: 2px solid #0f172a;
    border-radius: 9999px;
}

.theme-toggle-container {
    padding: 0 0.75rem 0.75rem;
}

.theme-toggle-card {
    width: 100%;
    display: flex;
    align-items: center;
    gap: 0.75rem;
    padding: 0.75rem;
    border: 1px solid rgba(148, 163, 184, 0.18);
    border-radius: 0.75rem;
    background: rgba(255, 255, 255, 0.055);
    color: #e5e7eb;
    transition:
        background-color 0.2s ease,
        border-color 0.2s ease,
        transform 0.2s ease;
}

.theme-toggle-card:hover {
    background: rgba(255, 255, 255, 0.10);
    border-color: rgba(129, 140, 248, 0.50);
}

.theme-toggle-card:active {
    transform: scale(0.985);
}

.theme-toggle-card:focus-visible {
    outline: 2px solid #818cf8;
    outline-offset: 2px;
}

.theme-toggle-icon {
    width: 2rem;
    height: 2rem;
    flex-shrink: 0;
    border-radius: 0.625rem;
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(99, 102, 241, 0.18);
    color: #c7d2fe;
}

.theme-toggle-switch {
    position: relative;
    width: 2.75rem;
    height: 1.5rem;
    flex-shrink: 0;
    border-radius: 9999px;
    background-color: #475569;
    transition: background-color 0.2s ease;
}

.theme-toggle-switch-knob {
    position: absolute;
    top: 0.1875rem;
    left: 0.1875rem;
    width: 1.125rem;
    height: 1.125rem;
    border-radius: 9999px;
    background-color: #ffffff;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.30);
    transition: transform 0.2s ease;
}

.theme-toggle-switch-active {
    background-color: #6366f1;
}

.theme-toggle-switch-active .theme-toggle-switch-knob {
    transform: translateX(1.25rem);
}

@media print {
    .theme-toggle-container {
        display: none !important;
    }

    .fashion-dark :deep(.preview-sheet),
    .fashion-dark :deep(.label-box),
    .fashion-dark :deep(.preview-sheet *),
    .fashion-dark :deep(.label-box *) {
        background-color: #ffffff !important;
        color: #111827 !important;
    }
}


/* FASHION_OS_FOCUS_PENDING_PRIVACY_V1 */

/* ============================================================
   MODE FOKUS + PRIVASI DANA GANTUNG
   ============================================================ */
.view-mode-controls {
    display: grid;
    gap: 0.5rem;
    padding: 0 0.75rem 0.75rem;
}

.view-mode-card {
    width: 100%;
    display: flex;
    align-items: center;
    gap: 0.7rem;
    padding: 0.7rem;
    border: 1px solid rgba(148, 163, 184, 0.16);
    border-radius: 0.75rem;
    background-color: rgba(255, 255, 255, 0.045);
    color: #e5e7eb;
    transition:
        background-color 0.2s ease,
        border-color 0.2s ease,
        transform 0.2s ease;
}

.view-mode-card:hover {
    background-color: rgba(255, 255, 255, 0.09);
    border-color: rgba(129, 140, 248, 0.50);
}

.view-mode-card:active {
    transform: scale(0.985);
}

.view-mode-card:focus-visible {
    outline: 2px solid #818cf8;
    outline-offset: 2px;
}

.view-mode-card-active {
    background-color: rgba(79, 70, 229, 0.14);
    border-color: rgba(129, 140, 248, 0.55);
}

.view-mode-icon {
    width: 2rem;
    height: 2rem;
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 0.625rem;
    background-color: rgba(99, 102, 241, 0.18);
    color: #c7d2fe;
}

.view-mode-action {
    flex-shrink: 0;
    padding: 0.25rem 0.45rem;
    border-radius: 0.45rem;
    background-color: rgba(99, 102, 241, 0.18);
    color: #c7d2fe;
    font-size: 0.68rem;
    font-weight: 800;
}

.view-mode-switch {
    position: relative;
    width: 2.6rem;
    height: 1.4rem;
    flex-shrink: 0;
    border-radius: 9999px;
    background-color: #475569;
    transition:
        background-color 0.2s ease;
}

.view-mode-switch-knob {
    position: absolute;
    top: 0.175rem;
    left: 0.175rem;
    width: 1.05rem;
    height: 1.05rem;
    border-radius: 9999px;
    background-color: #ffffff;
    box-shadow:
        0 2px 5px
        rgba(0, 0, 0, 0.30);
    transition:
        transform 0.2s ease;
}

.view-mode-switch-active {
    background-color: #6366f1;
}

.view-mode-switch-active
.view-mode-switch-knob {
    transform: translateX(1.2rem);
}

.pending-private-value {
    letter-spacing: 0.06em;
    user-select: none;
}

@media (min-width: 768px) {
    }

@media print {
    .view-mode-controls {
        display: none !important;
    }
}


/* FASHION_OS_COMPACT_SIDEBAR_MODES_V1 */

/* ============================================================
   MODE SIDEBAR COMPACT
   ============================================================ */

/* Jarak keseluruhan antar-kontrol dipadatkan */
.theme-toggle-container,
.view-mode-controls {
    padding-left: 0.5rem !important;
    padding-right: 0.5rem !important;
    padding-bottom: 0.45rem !important;
}

.view-mode-controls {
    gap: 0.35rem !important;
}

/* Tinggi kartu diperkecil */
.theme-toggle-card,
.view-mode-card {
    min-height: 3.25rem;
    gap: 0.5rem !important;
    padding: 0.5rem 0.55rem !important;
    border-radius: 0.65rem !important;
}

/* Ikon lebih kecil */
.theme-toggle-icon,
.view-mode-icon {
    width: 1.65rem !important;
    height: 1.65rem !important;
    border-radius: 0.5rem !important;
}

.theme-toggle-icon svg,
.view-mode-icon svg {
    width: 1rem !important;
    height: 1rem !important;
}

/* Judul dan keterangan lebih ringkas */
.theme-toggle-card .text-sm,
.view-mode-card .text-sm {
    font-size: 0.78rem !important;
    line-height: 1rem !important;
}

.theme-toggle-card .text-xs,
.view-mode-card .text-xs {
    margin-top: 0.05rem;
    font-size: 0.66rem !important;
    line-height: 0.9rem !important;
}

/* Tombol kecil "Buka" */
.view-mode-action {
    padding: 0.18rem 0.38rem !important;
    border-radius: 0.4rem !important;
    font-size: 0.6rem !important;
}

/* Sakelar dibuat lebih kecil tetapi tetap nyaman diklik */
.theme-toggle-switch,
.view-mode-switch {
    width: 2.15rem !important;
    height: 1.2rem !important;
}

.theme-toggle-switch-knob,
.view-mode-switch-knob {
    top: 0.15rem !important;
    left: 0.15rem !important;
    width: 0.9rem !important;
    height: 0.9rem !important;
}

.theme-toggle-switch-active .theme-toggle-switch-knob,
.view-mode-switch-active .view-mode-switch-knob {
    transform: translateX(0.95rem) !important;
}

/* Bantuan tidak terlalu jauh dari kontrol mode */
.view-mode-controls + button.sidebar-link {
    margin-top: 0.15rem;
}


/* FASHION_OS_REMOVE_FOCUS_ULTRA_COMPACT_V1 */

/* ============================================================
   SIDEBAR MODE ULTRA COMPACT
   ============================================================ */

/* Hanya Mode Gelap dan Privasi Dana */
.theme-toggle-container,
.view-mode-controls {
    padding: 0 0.4rem 0.35rem !important;
}

.view-mode-controls {
    gap: 0.25rem !important;
}

/* Kartu sangat ringkas */
.theme-toggle-card,
.view-mode-card {
    min-height: 2.55rem !important;
    gap: 0.4rem !important;
    padding: 0.35rem 0.45rem !important;
    border-radius: 0.55rem !important;
}

/* Ikon kecil */
.theme-toggle-icon,
.view-mode-icon {
    width: 1.35rem !important;
    height: 1.35rem !important;
    border-radius: 0.4rem !important;
}

.theme-toggle-icon svg,
.view-mode-icon svg {
    width: 0.82rem !important;
    height: 0.82rem !important;
}

/* Teks dibuat lebih pendek dan rapat */
.theme-toggle-card .text-sm,
.view-mode-card .text-sm {
    font-size: 0.7rem !important;
    line-height: 0.82rem !important;
}

.theme-toggle-card .text-xs,
.view-mode-card .text-xs {
    margin-top: 0 !important;
    font-size: 0.57rem !important;
    line-height: 0.72rem !important;
}

/* Sakelar lebih kecil */
.theme-toggle-switch,
.view-mode-switch {
    width: 1.75rem !important;
    height: 1rem !important;
}

.theme-toggle-switch-knob,
.view-mode-switch-knob {
    top: 0.125rem !important;
    left: 0.125rem !important;
    width: 0.75rem !important;
    height: 0.75rem !important;
}

.theme-toggle-switch-active .theme-toggle-switch-knob,
.view-mode-switch-active .view-mode-switch-knob {
    transform: translateX(0.75rem) !important;
}

/* Bantuan tetap dekat */
.view-mode-controls + button.sidebar-link {
    margin-top: 0.05rem !important;
}


/* FASHION_OS_MOVE_PENDING_PRIVACY_TO_SETTINGS_V1 */

/* FASHION_OS_ADVANCED_PIN_PROTECTION_V1 */

/* FASHION_OS_PIN_NEW_KEYS_CACHE_HOTFIX_V1 */

/* FASHION_OS_PENDING_PRIVACY_EYE_DASHBOARD_V1 */
</style>
